webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var CommonService = function () {
  function CommonService(http) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CommonService);

    this._resource = http;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CommonService, [{
    key: "bufferToBase64",
    value: function bufferToBase64(buf) {
      var binstr = Array.prototype.map.call(buf, function (ch) {
        return String.fromCharCode(ch);
      }).join("");
      return btoa(binstr);
    }
  }, {
    key: "enviarEmail",
    value: function enviarEmail(id_nota, email, envXml, envDanfe, component, empr) {
      var url = "";

      switch (component) {
        case "NFSE":
          url = "nfses/email/" + id_nota + "/empr/" + empr + "?_emailTo=" + email;
          break;
        case "CTE":
          url = "ctes/email/" + id_nota + "/empr/" + empr + "?_emailTo=" + email;
          break;
        default:
          url = "nfes/danfe/email/" + id_nota + "/empr/" + empr + "?_emailTo=" + email;
          break;
      }

      if (envXml && envDanfe) {
        url += "&_xml=" + envXml + "&_pdf=" + envDanfe;
      } else if (envXml) {
        url += "&_xml=" + envXml;
      } else if (envDanfe) {
        url += "&_pdf=" + envDanfe;
      }
      return this._resource.get(url).then(function (success) {
        return success;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "getQntdNotasEmp",
    value: function getQntdNotasEmp(idEmp, component) {
      var url = "";

      switch (component) {
        case "CTE":
          url += "ctes/qnts/" + idEmp;
          break;
        case "NFeRecebidas":
          url += "nfes/qnts/" + idEmp;
          break;
        case "NFSE":
          url += "nfses/qnts/" + idEmp;
          break;
        default:
          throw new Error("Não foi possísvel setar url para buscar qntd de notas");
      }
      return this._resource.get(url).then(function (success) {
        return success;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "zipEmailNotas",
    value: function zipEmailNotas(id_nota, email, envXml, envDanfe, component, empr) {
      var url = "";

      switch (component) {
        case "CTE":
          url += "ctes/email/multi/empr/" + empr;
          break;
        case "NFeRecebidas":
          url += "nfes/email/multi/empr/" + empr;
          break;
        case "NFSE":
          url += "nfses/email/multi/empr/" + empr;
          break;
        default:
          throw new Error("Não foi possísvel setar url para enivar multi arq email");
      }
      url += "?_emailTo=" + email + "&_zip=true";
      var acao = "";
      if (envXml) {
        acao += "xml";
      }
      if (envDanfe) {
        acao += "-pdf";
      }
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ notas: id_nota, acao: acao });
      //debugger;
      return this._resource.post(url, body).then(function (success) {
        return success;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "getBase64File",
    value: function getBase64File(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {};
      reader.onerror = function (error) {};

      return reader.result;
    }
  }, {
    key: "saveCustomColumn",
    value: function saveCustomColumn(id_nota, arrayColuna, component) {
      var url = "";
      switch (component) {
        case "CTE":
          url = "ctes/custom/" + id_nota;
          break;
        case "NFeRecebidas":
          url = "nfes/custom/" + id_nota;
          break;
        case "fornecedores":
          url = "fornecedores/custom/" + id_nota;
          break;
        case "clientes":
          url = "clientes/custom/" + id_nota;
          break;
        case "produtos":
          url = "produtos/custom/" + id_nota;
          break;
        case "NFSE":
          url = "nfses/custom/" + id_nota;
          break;
        default:
          return;
      }
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arrayColuna);

      return this._resource.put(url, body).then(function (success) {
        return success.body;
      }, function (failed) {});
    }
  }, {
    key: "getLogConsulta",
    value: function getLogConsulta(id_empresa, component, tipo) {
      var url = "";
      switch (component) {
        case "CTE":
          url = "ctes/logconsulta/" + id_empresa;
          break;
        case "NFeRecebidas":
          url = "nfes/logconsulta/" + id_empresa;
          break;
        case "NFSE":
          url = "nfses/logconsulta/" + id_empresa + "?_tipo=" + tipo;
          break;
        default:
          return;
      }
      return this._resource.get(url).then(function (success) {
        success.body.log = new Date(success.body.log);
        return success.body;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "saveHeadersByEmp",
    value: function saveHeadersByEmp(id_empresa, headers, component, tipo) {
      var url = "";
      switch (component) {
        case "CTE":
          url = "empresas/colunacte/" + id_empresa + "?tipo=" + tipo;
          break;
        case "NFeRecebidas":
          url = "empresas/colunanfe/" + id_empresa + "?tipo=" + tipo;
          break;
        case "fornecedores":
          url = "empresas/colunafornec/" + id_empresa;
          break;
        case "clientes":
          url = "empresas/colunacliente/" + id_empresa;
          break;
        case "produtos":
          url = "empresas/colunaproduto/" + id_empresa + "?tipo=" + tipo;
          break;
        case "NFSE":
          url = "empresas/colunanfse/" + id_empresa + "?tipo=" + tipo;
          break;
        default:
          return;
      }
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(headers);

      return this._resource.put(url, body).then(function (success) {
        return success;
      }, function (failed) {
        return failed;
      });
    }
  }]);

  return CommonService;
}();

/* harmony default export */ __webpack_exports__["a"] = (CommonService);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);








var NfeService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(NfeService, _CommonService);

    function NfeService() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NfeService);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NfeService.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(NfeService)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(NfeService, [{
        key: "getNfeRecebidas",
        value: function getNfeRecebidas(page, qntdNfe, id_empresa, range, urlFiltros) {
            var url = "nfes/empresa/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range;

            urlFiltros != undefined ? url += urlFiltros : '';
            // https://app.motorfiscal.com.br/teste/nfes/empresa/5b4cc42de471d50362ddce00?_page=1&_pagesize=2&_range=semana
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "getNfeTransportados",
        value: function getNfeTransportados(page, qntdNfe, id_empresa, range, urlFiltros) {
            var url = "nfes/empresa/transportadora/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range;
            urlFiltros != undefined ? url += urlFiltros : '';
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "getNfeEmitidas",
        value: function getNfeEmitidas(page, qntdNfe, id_empresa, range, urlFiltros) {
            var url = "nfes/empresa/emitidas/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range;
            urlFiltros != undefined ? url += urlFiltros : '';
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "sendXml",
        value: function sendXml(id_empresa, file) {

            var data = new FormData();
            data.append("file", file);

            var url = "nfes/uploadxml/" + id_empresa;

            return this._resource.post(url, data).then(function (success) {

                return success;
            }, function (failed) {

                return failed;
            });
        }
    }, {
        key: "consultaAvulsaNota",
        value: function consultaAvulsaNota(id_empresa) {
            return this._resource.get("nfes/busca/" + id_empresa).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "getDanfe",
        value: function getDanfe(id_nota) {
            var _this2 = this;

            return this._resource.get("nfes/danfe/" + id_nota).then(function (success) {
                var data = new Uint8Array(success.body.danfe.data);
                return _this2.bufferToBase64(data);
            }, function (failed) {
                console.log(failed);
            });
        }
    }, {
        key: "getDacce",
        value: function getDacce(id_nota, indice) {
            var _this3 = this;

            return this._resource.get("nfes/cce/" + id_nota + "?_indice=" + indice).then(function (success) {
                var data = new Uint8Array(success.body.pdf.data);
                return _this3.bufferToBase64(data);
            }, function (failed) {
                console.log(failed);
            });
        }
    }, {
        key: "getXml",
        value: function getXml(id_nota) {
            return this._resource.get("nfes/xml/" + id_nota).then(function (success) {
                return success.body.xml;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "manifestar",
        value: function manifestar(chave, tpEvento, id_empresa, just) {
            var obj = {
                chave: chave,
                // tpEvento: "210210"
                tpEvento: tpEvento,
                just: just
            };
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
            return this._resource.post("nfes/manifestacao/" + id_empresa, body).then(function (success) {}, function (failed) {
                var message = failed.body.message.replace(/Rejeicao: /gi, "");
                return message;
            });
        }
    }, {
        key: "getCTeByIdNFe",
        value: function getCTeByIdNFe(id_nota) {
            return this._resource.get("nfes/ctes/" + id_nota).then(function (success) {

                return success.body.items;
            }, function (failed) {
                console.log(failed);
            });
        }
    }]);

    return NfeService;
}(__WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NfeService);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);






var Table = function () {
    function Table(component) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Table);

        this.headers = this.getHeaders();
        this.component = component;
        this.resetTable();
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Table, [{
        key: 'resetTable',
        value: function resetTable() {
            var empresa = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            this.filtro = this.resetFiltro();
            this.sendAtt = false;
            this.firstAcess = true;
            this.buscarNotas = false;
            this.posExbPrimNota = 0;
            this.posExbUltmaNota = 0;
            this.notasPorPage = 0;
            this.qnt_total_notas = 10;
            this.pagina_atual = 1;
            this.qnt_total_paginas = 1;
            this.pagina_seguinte = 2;
            this.valor_total_notas = 0;
            this.valor_total_conta_empr = 0;
            this.valor_total_conta_nfe = 0;
            this.valor_total_conta_nfse = 0;
            this.valor_total_conta_cte = 0;
            this.valor_total_conta_colab = 0;
            this.arraySearch = [];
            this.arrayNotas = [];
            this.array_todas_notas = [];
            this.loading = false;
            this.nfePorPage = 0;
            this.rows_per_page_items = [10, 30, 60];
            this.pagination;
            this.arraySearch;
            this.dadosFiltrados;
            this.showSnackAtt = false;
            this.addedCustomColumn = false;
            this.selected = [];
            this.primeiro_limpo = false;
            this.busca = false;
            this.urlFiltros = '';
            this.auxHeaders = [];
            this.auxNotas = [];
            this.range = "semana";
            this.snack = { show: false, text: '', time: 5000, color: "grey darken-4", btnFColor: "red", multiple: false };
            this.rangeButtons = [{
                text: "7 Dias",
                value: "semana",
                width: "500px",
                noDataText: "nos últimos 7 Dias",
                selected: true,
                show: true
            }, {
                text: "Mês Atual",
                value: "mesAtual",
                selected: false,
                noDataText: "neste Mês",
                show: true,
                width: "500px"
            }, {
                text: "Mês anterior",
                selected: false,
                noDataText: "no Mês passado",
                value: "mesAnterior",
                show: true
            }, {
                text: "Filtrar",
                selected: false,
                noDataText: "",
                value: "tudo",
                show: true
            }];
            var nfseTomadosBH = empresa && empresa.servicos && empresa.servicos.robotizacao.find(function (item) {
                return item.nomeServico === 'NFSE_TOMADOS';
            });
            if (nfseTomadosBH && component.name == "NFSE" && component.tipo === 'emitida') {
                this.rangeButtons.splice(3, 0, {
                    text: "Falhas",
                    value: "falhas",
                    width: "500px",
                    noDataText: "falhas",
                    selected: true,
                    show: true
                });
            }
        }
    }, {
        key: 'resetFiltro',
        value: function resetFiltro() {
            this.urlFiltros = '';
            return this.filtros = {
                fechar: false,
                items: [{ type: 'S', text: "Status", item_id: 'status', valor: null, options: ['Autorizada', 'Cancelada', 'Não Autorizada', 'Inutilizadas'], multiple: true, icon: 'local_offer' }, { type: 'S', text: "Presença de CCe", item_id: 'cce', valor: null, options: ['Sim', 'Não'], multiple: false, icon: 'edit' }, { type: 'S', text: "Manifestação", item_id: 'manifestacao', valor: null, options: ['Ciente', 'Confirmada', 'Não Realizada', 'Desconhecida'], multiple: true, icon: 'near_me' }, { type: 'S', text: "Protocolada", item_id: 'protocolada', valor: null, options: ['Sim', 'Não'], multiple: false, icon: 'description' }, { type: 'T', text: "Valor a partir", item_id: 'vlrInicial', valor: null }, { type: 'T', text: "Valor até", item_id: 'vlrFinal', valor: null },
                // { type: 'D', text: "Data de emissão inicial", item_id: 'emissaoIni', valor: null, },
                { type: 'D', text: "Data de emissão inicial", item_id: 'emissaoIni', valor: null, data: null, index: this.menu0 }, { type: 'D', text: "Data de emissão final", item_id: 'emissaoFim', valor: null, data: null, index: this.menu1 }, { type: 'D', text: "Data de importação inicial", item_id: 'importacaoIni', valor: null, data: null, index: this.menu2 }, { type: 'D', text: "Data de importação final", item_id: 'importacaoFim', valor: null, data: null, index: this.menu3 }, { type: 'D', text: "Data de Vencimento Inicial", item_id: 'vencimentoIni', valor: null, data: null, index: this.menu4 }, { type: 'D', text: "Data de Vencimento Final", item_id: 'vencimentoFim', valor: null, data: null, index: this.menu5 }, { type: 'S', text: "Tipo de vencimento", item_id: 'tipoVencimento', valor: null, options: ['Parcela única', 'Parcelado', 'Não informado'], multiple: false, icon: 'date_range' }, { type: 'L', text: "Status da Des", item_id: 'statusDes', valor: null, options: ['validado', 'pendente', 'inconsistente'], multiple: true, icon: 'local_offer' }]
            };
        }
    }, {
        key: 'resetAlert',
        value: function resetAlert() {
            this.snack = { show: false, text: '', time: 3000, color: "grey darken-4", btnFColor: "red", multiple: false };
            return this.snack;
        }
    }, {
        key: 'snackSuccess',
        value: function snackSuccess() {
            this.snack.color = "green darken-3";
            this.snack.btnFColor = "white";
        }
    }, {
        key: 'snackDanger',
        value: function snackDanger() {
            this.snack.color = "red darken-4";
            this.snack.btnFColor = "white";
        }
    }, {
        key: 'snackAlert',
        value: function snackAlert() {
            this.snack.color = "yellow darken-2";
            this.snack.btnFColor = "black";
        }
    }, {
        key: 'snackDefault',
        value: function snackDefault() {
            this.snack.color = "grey darken-4";
            this.snack.btnFColor = "red";
        }
    }, {
        key: 'snackInfo',
        value: function snackInfo() {
            this.snack.color = "cyan darken-3";
            this.snack.btnFColor = "white";
        }
    }, {
        key: 'formatData',
        value: function formatData(v) {
            if (!v) return null;

            var _v$split = v.split("-"),
                _v$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_v$split, 3),
                year = _v$split2[0],
                month = _v$split2[1],
                day = _v$split2[2];

            return day + '/' + month + '/' + year;
        }
    }, {
        key: 'selecionarTodosItens',
        value: function selecionarTodosItens(tipo) {
            var _this = this;

            switch (tipo) {
                case 'all':
                    this.tradeNotaArray(this.qnt_total_notas, this.arrayNotas.length);
                    if (this.selected.length == this.qnt_total_notas) {
                        this.selected = [];
                    } else if (this.dadosFiltrados) {
                        this.selected = this.arraySearch.slice();
                    } else {
                        this.selected = this.arrayNotas.slice();
                    }
                    break;
                case 'parse':
                    // PEGA AS NOTAS QUE ESTÃO NA TELA
                    var prmPos = this.posExbPrimNota;
                    var ultPos = this.posExbUltmaNota - 1;
                    ultPos = prmPos + this.pagination.rowsPerPage - 1;

                    var notasEmTela = [];
                    var posEncontrados = [];
                    if (this.dadosFiltrados) {
                        //CASO SEJA NOTAS QUE FORAM USADAS O CAMPO DE BUSCA
                        notasEmTela = this.arraySearch.slice(prmPos, ultPos + 1);
                    } else {
                        notasEmTela = this.arrayNotas.slice(prmPos, ultPos + 1);
                    }
                    var qntdEncontrada = 0;
                    var tam = this.selected.length;
                    if (tam > 0) {
                        //VERIFICA SE ESSAS NOTAS JÁ CONSTAM NO ARRAY DE SELECIONADAS, CASO NÃO ADICIONAR..
                        notasEmTela.forEach(function (item) {
                            var itemEncontrado = false;
                            _this.selected.find(function (ele, pos) {
                                if (ele.chave == item.chave) {
                                    itemEncontrado = true;
                                    posEncontrados.push(pos);
                                }
                            });
                            if (itemEncontrado) {
                                qntdEncontrada++;
                            } else {
                                _this.selected.push(item);
                            }
                        });
                        if (qntdEncontrada == notasEmTela.length) {
                            notasEmTela.forEach(function (item) {
                                _this.selected.splice(_this.selected.indexOf(item), 1);
                            });
                        }
                    } else {
                        this.selected = notasEmTela.slice();
                    }
                    break;
                case 'importador_xml':
                    // PEGA AS NOTAS QUE ESTÃO NA TELA

                    this.selected = [];
                    this.primeiro_limpo = true;
                    break;

                case 'clear':
                    // PEGA AS NOTAS QUE ESTÃO NA TELA
                    prmPos = this.posExbPrimNota;
                    ultPos = this.posExbUltmaNota - 1;
                    ultPos = prmPos + this.pagination.rowsPerPage - 1;

                    notasEmTela = [];
                    posEncontrados = [];
                    if (this.dadosFiltrados) {
                        //CASO SEJA NOTAS QUE FORAM USADAS O CAMPO DE BUSCA
                        notasEmTela = this.arraySearch.slice(prmPos, ultPos + 1);
                    } else {
                        notasEmTela = this.arrayNotas.slice(prmPos, ultPos + 1);
                    }
                    qntdEncontrada = 0;
                    tam = this.selected.length;
                    if (tam == 0) {
                        this.selected = [];
                    }
                    break;
                case 'primeiro_check':
                    if (this.selected.length == 0) {
                        this.selected = [];
                    }
                    this.primeiro_limpo = true;
                    break;
            }
            //RETORNAR O ARRAY COM AS NOTAS SELECIONADAS
            return this.selected;
        }
    }, {
        key: 'tradeNotaArray',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(qntdade_notas, ultPos) {
                var i;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(this.arrayNotas.length == this.array_todas_notas.length)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                if (this.arrayNotas.length < this.qnt_total_notas) {
                                    if (qntdade_notas > this.qnt_total_notas) {
                                        qntdade_notas = this.qnt_total_notas;
                                    }
                                    for (i = ultPos; i < qntdade_notas; i++) {
                                        this.arrayNotas.push(this.array_todas_notas[i]);
                                    }
                                }
                                // this.arrayNotas.sort(function (a, b) {
                                //     return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
                                // });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function tradeNotaArray(_x3, _x4) {
                return _ref.apply(this, arguments);
            }

            return tradeNotaArray;
        }()
    }, {
        key: 'setQntPorPage',
        value: function setQntPorPage(qntNotasExibidas) {
            if (qntNotasExibidas) {
                if (this.arrayNotas.length == 0 && this.qnt_total_notas == 999) {
                    this.nfePorPage = qntNotasExibidas;
                }
                if (qntNotasExibidas > this.arrayNotas.length && qntNotasExibidas < this.qnt_total_notas) {
                    this.nfePorPage = qntNotasExibidas;
                }
                if (qntNotasExibidas == -1) {
                    this.nfePorPage = this.qnt_total_notas - this.arrayNotas.length;
                }
                if (qntNotasExibidas > this.qnt_total_notas) {
                    this.nfePorPage = this.qnt_total_notas;
                }
                this.nfePorPage = qntNotasExibidas;
            } else {
                this.nfePorPage = this.rows_per_page_items[0];
            }
            return this.nfePorPage;
        }
    }, {
        key: 'setPages',
        value: function setPages(total_de_notas, qntNotasExibidas) {
            this.qnt_total_paginas = total_de_notas / qntNotasExibidas;

            if (total_de_notas % qntNotasExibidas > 0) {
                //arredondar as páginas para não ficar um valor quebrado
                this.qnt_total_paginas += 1;
                this.qnt_total_paginas = Math.floor(this.qnt_total_paginas);
            }
            return this.qnt_total_paginas;
        }
    }, {
        key: 'getPosNFeExibidas',
        value: function getPosNFeExibidas(start, stop) {
            this.posExbPrimNota = start - 1;
            this.posExbUltmaNota = stop;
        }
    }, {
        key: 'bufferToBase64',
        value: function bufferToBase64(buf) {
            var binstr = Array.prototype.map.call(buf, function (ch) {
                return String.fromCharCode(ch);
            }).join("");
            return btoa(binstr);
        }
    }]);

    return Table;
}();

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);










var EmpresaService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(EmpresaService, _CommonService);

    function EmpresaService(http) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, EmpresaService);

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EmpresaService.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(EmpresaService)).call(this, http));
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(EmpresaService, [{
        key: "getEmpresasNotAdmin",
        value: function getEmpresasNotAdmin(idConta, page, qntd, range) {

            var url = "contas/emprs/noAdmin/" + idConta + "?_page=" + page + "&_pagesize=" + qntd;
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "getEmpresasConta",
        value: function getEmpresasConta(idConta, page, qntd, range) {
            var _this2 = this;

            var url = "contas/info/" + idConta + "?_page=" + page + "&_pagesize=" + qntd;

            return this._resource.get(url).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(success) {
                    var notAdmin;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.getEmpresasNotAdmin(idConta);

                                case 2:
                                    notAdmin = _context.sent;

                                    success.body['emprs_not_admin'] = notAdmin;
                                    return _context.abrupt("return", success.body);

                                case 5:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }(), function (failed) {
                return failed;
            });
        }
    }, {
        key: "getEmpresasColaborador",
        value: function getEmpresasColaborador(idColaborador, page, qntd, range) {

            var url = "contas/colaborador/" + idColaborador + "?_page=" + page + "&_pagesize=" + qntd;

            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "getEmpresasCnpj",
        value: function getEmpresasCnpj(cnpj) {
            var url = "empresas?cnpj=" + cnpj;
            // this.resource = this.$resource("empresas?cnpj=" + this.empresa.cnpj);
            return this._resource.get(url).then(function (success) {
                //trocar para algo melhor
                //trocar até aqui
                return success;
            }, function (failed) {
                if (failed.status == 404) {
                    return failed;
                }
            });
        }
    }, {
        key: "getEmpresasID",
        value: function getEmpresasID(id) {
            var url = "empresas/" + id;
            return this._resource.get(url).then(function (success) {
                //trocar para algo melhor
                //trocar até aqui
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "getAPIReceita",
        value: function getAPIReceita(cnpj) {
            var url = "\"https://www.receitaws.com.br/v1/cnpj/" + cnpj;
            return this._resource.jsonp("https://www.receitaws.com.br/v1/cnpj/" + cnpj).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "cadastrar",
        value: function cadastrar(empresa, idConta) {

            var url = "contas/empresa/" + idConta;

            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(empresa);
            return this._resource.post(url, body).then(function (success) {
                success['infoMessage'] = { msg: 'Empresa cadastrada com sucesso.', ok: true };
                return success;
            }, function (failed) {

                failed['infoMessage'] = { msg: 'Não conseguimos cadastrar a empresa.', ok: false };
                return failed;
            });
        }
    }, {
        key: "faturamento",
        value: function faturamento(idConta, idEmpresa) {
            var url = "contas/empresa/faturamento/" + idConta;
            var body = {};
            body['faturamento'] = idEmpresa;
            body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body);
            return this._resource.post(url, body).then(function (success) {
                return true;
            }, function (failed) {
                return false;
            });
        }
    }, {
        key: "editar",
        value: function editar(empresa, idEmpresa) {
            var url = "empresas/" + idEmpresa;

            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(empresa);

            return this._resource.patch(url, body).then(function (success) {

                success['infoMessage'] = { msg: 'As informações da empresa foram editadas.', ok: true };
                return success;
            }, function (failed) {

                failed['infoMessage'] = { msg: 'Não conseguimos editar as informações da empresa.', ok: false };
                return failed;
            });
        }
    }, {
        key: "fechamentoMensal",
        value: function fechamentoMensal(body) {
            var url = "empresas/fechamentoMensal";

            var bodyEnvio = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body);
            return this._resource.post(url, bodyEnvio).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }]);

    return EmpresaService;
}(__WEBPACK_IMPORTED_MODULE_8__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EmpresaService);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);








var CteService = function (_CommonService) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CteService, _CommonService);

  function CteService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CteService);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CteService.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CteService)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CteService, [{
    key: "getCte",
    value: function getCte(page, qntdNfe, empresa, range, urlFiltros) {
      var url = "ctes/empresa/" + empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range;

      urlFiltros != undefined ? url += urlFiltros : "";
      return this._resource.get(url).then(function (success) {
        return success.body;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "sendXml",
    value: function sendXml(id_empresa, file) {

      var data = new FormData();
      data.append("file", file);

      var url = "ctes/uploadxml/" + id_empresa;

      return this._resource.post(url, data).then(function (success) {

        return success;
      }, function (failed) {

        return failed;
      });
    }
  }, {
    key: "getCteTomados",
    value: function getCteTomados(page, qntdNfe, empresa, range, urlFiltros) {
      var url = "ctes/empresa/" + empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range + "&_tomadas=true";

      urlFiltros != undefined ? url += urlFiltros : "";
      return this._resource.get(url).then(function (success) {
        return success.body;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "getXml",
    value: function getXml(id_nota) {
      return this._resource.get("ctes/xml/" + id_nota).then(function (success) {
        return success.body.xml;
      }, function (failed) {
        console.log(failed);
      });
    }
  }, {
    key: "consultaAvulsaNota",
    value: function consultaAvulsaNota(id_empresa) {
      return this._resource.get("ctes/busca/" + id_empresa).then(function (success) {
        return success;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "getNfeByChave",
    value: function getNfeByChave(chave) {
      var _this2 = this;

      return this._resource.get("nfes/chave/" + chave).then(function (success) {
        return _this2.getDanfe(success.body.idNF);
      }, function (failed) {
        console.log(failed);
      });
    }
  }, {
    key: "getDanfe",
    value: function getDanfe(id_nota) {
      var _this3 = this;

      return this._resource.get("nfes/danfe/" + id_nota).then(function (success) {
        var data = new Uint8Array(success.body.danfe.data);
        return _this3.bufferToBase64(data);
      }, function (failed) {
        console.log(failed);
      });
    }
  }, {
    key: "getDacte",
    value: function getDacte(id_nota) {
      var _this4 = this;

      return this._resource.get("ctes/pdf/" + id_nota).then(function (success) {
        var data = new Uint8Array(success.body.danfe.data);
        return _this4.bufferToBase64(data);
      }, function (failed) {
        console.log(failed);
      });
    }
  }, {
    key: "desacordo",
    value: function desacordo(chave, id_empresa, just) {
      var obj = {
        chave: chave,
        obs: just
      };
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
      console.log("ctes/manifestacao/" + id_empresa, body);

      return this._resource.post("ctes/manifestacao/" + id_empresa, body).then(function (success) {}, function (failed) {
        var message = failed.body.message.replace(/Desacordo: /gi, "");
        return message;
      });
    }
  }]);

  return CteService;
}(__WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CteService);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);










var NfseService = function (_CommonService) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(NfseService, _CommonService);

  function NfseService() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, NfseService);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NfseService.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(NfseService)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(NfseService, [{
    key: "getNfse",
    value: function getNfse(page, qntdNfe, empresa, range, urlFiltros, tipo) {
      // console.log("NFSE-e", urlFiltros);
      var url = "nfses/empresa/" + empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range + "&tipo=" + tipo;
      urlFiltros != undefined ? url += urlFiltros : "";
      return this._resource.get(url).then(function (success) {
        // console.log(success.body);
        return success.body;
      }, function (failed) {
        console.log(failed);
      });
    }
  }, {
    key: "getXml",
    value: function getXml(id_nota) {
      return this._resource.get("nfses/xml/" + id_nota).then(function (success) {
        console.log("xml");
        console.log(success.body);
        return success.body.xml;
      }, function (failed) {
        console.log(failed);
      });
    }
  }, {
    key: "getPdf",
    value: function getPdf(pathPdf) {
      var _this2 = this;

      return this._resource.get("nfses/pdf/" + pathPdf).then(function (success) {
        var data = new Uint8Array(success.body.pdf.data);
        return _this2.bufferToBase64(data);
      }, function (failed) {
        console.log(failed);
      });
    }
  }, {
    key: "sendPdfRobo",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id_empresa, file, name, codMun) {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = new FormData();

                data.append("file", file);
                data.append("codMun", codMun);
                data.append("name", name);

                // let url = `https://api.motorfiscal.com.br/upload/${id_empresa}`;

                return _context.abrupt("return", this._resource.post("upload/" + id_empresa, data).then(function (success) {
                  return success;
                }, function (failed) {
                  return failed;
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendPdfRobo(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return sendPdfRobo;
    }()
  }, {
    key: "getPdfById",
    value: function getPdfById(id) {
      var _this3 = this;

      var motor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (motor) {
        return this._resource.get("nfses/pdf/" + id).then(function (success) {
          var data = new Uint8Array(success.body.pdf.data);
          return _this3.bufferToBase64(data);
        }, function (failed) {
          console.log(failed);
        });
      } else {
        return this._resource.get("nfses/pdfMotor/" + id).then(function (success) {
          var data = new Uint8Array(success.body.pdf.data);
          return _this3.bufferToBase64(data);
        }, function (failed) {
          console.log(failed);
        });
      }
    }
  }, {
    key: "consultaAvulsaNota",
    value: function consultaAvulsaNota(id_empresa, tipo) {
      // ?_dtInicio=2018-05-01&_dtFim=2018-05-30&_emitida=true
      var today = new Date().toLocaleDateString().split("/").reverse().join("-");
      var yersterday = new Date(Date.now() - 864e5).toLocaleDateString().split("/").reverse().join("-");
      var tipoUrl = "";
      if (tipo == "emitida") {
        tipoUrl = "_emitida=" + true;
      } else {
        tipoUrl = "_recebida=" + true;
      }
      return this._resource.get("nfses/busca/" + id_empresa + "?_dtInicio=" + yersterday + "&_dtFim=" + today + "&" + tipoUrl).then(function (success) {
        console.log("Consulta Avulsa");
        console.log(success);
        return success;
      }, function (failed) {
        return failed;
        console.log(failed);
      });
    }
  }, {
    key: "enviarPlanilha",
    value: function enviarPlanilha(file, idEmpresa) {
      return this._resource.post("nfses/emissaobh/importaPlanilha/" + idEmpresa, file).then(function (success) {
        return success;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "enviarPlanilhaEscrituracao",
    value: function enviarPlanilhaEscrituracao(file, idEmpresa) {
      return this._resource.post("nfses/escrituracao/importaPlanilha/" + idEmpresa, file).then(function (success) {
        return success;
      }, function (failed) {
        return failed;
      });
    }
  }, {
    key: "getNfseEmitidas",
    value: function getNfseEmitidas(page, qntdNfe, empresa, range, urlFiltros, tipo) {
      var url = '';
      if (range !== 'falhas') {
        url = "nfses/empresa/" + empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range + "&tipo=" + tipo + "&_nfsebh=true";
        urlFiltros != undefined ? url += urlFiltros : "";
      } else {
        url = "nfses/emissaobh/falha/" + empresa + "?_page=" + page + "&_pagesize=" + qntdNfe;
      }
      return this._resource.get(url).then(function (success) {

        return success.body;
      }, function (failed) {
        return failed.body;
      });
    }
  }, {
    key: "inserirNovaNota",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(nfse, idEmpresa) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._resource.post("nfses/emissaobh/" + idEmpresa, nfse).then(function (success) {
                  return success.body;
                }, function (failed) {
                  return failed.body;
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function inserirNovaNota(_x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return inserirNovaNota;
    }()
  }, {
    key: "atualizarNota",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(nfse, notaId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this._resource.put("nfses/emissaobh/" + notaId, nfse).then(function (success) {
                  return success.body;
                }, function (failed) {
                  return failed.body;
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function atualizarNota(_x8, _x9) {
        return _ref3.apply(this, arguments);
      }

      return atualizarNota;
    }()
  }, {
    key: "uploadDes",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(file, idEmpresa) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this._resource.post("nfses/validaDes/" + idEmpresa, file).then(function (success) {
                  return success;
                }, function (failed) {
                  return failed;
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function uploadDes(_x10, _x11) {
        return _ref4.apply(this, arguments);
      }

      return uploadDes;
    }()
  }]);

  return NfseService;
}(__WEBPACK_IMPORTED_MODULE_7__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NfseService);

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);








var UsuarioService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(UsuarioService, _CommonService);

    function UsuarioService(http) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, UsuarioService);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UsuarioService.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UsuarioService)).call(this, http));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(UsuarioService, [{
        key: 'getAll',
        value: function getAll(page, qntd, range) {

            var url = 'usuarios?_page=' + page + '&_pagesize=' + qntd + '&_range=' + range;
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: 'getUsuarioByToken',
        value: function getUsuarioByToken(token) {
            var url = 'usuarios?token=' + token;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: 'cadastrarUsuario',
        value: function cadastrarUsuario(usuario) {
            var url = 'usuarios';
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(usuario);
            return this._resource.post(url, body).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: 'cadastrar',
        value: function cadastrar(usuario, idConta, reenvio) {
            var url = 'contas/colaborador/' + idConta;
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(usuario);

            if (!reenvio) {
                return this._resource.post(url, body).then(function (success) {

                    success['infoMessage'] = { msg: 'Colaborador cadastrado com sucesso.', ok: true };

                    return success;
                }, function (failed) {
                    failed['infoMessage'] = { msg: 'Não conseguimos cadastrar o colaborador.', ok: false };
                    return failed;
                });
            } else {
                return this._resource.post(url, body).then(function (success) {

                    success['infoMessage'] = { msg: 'Email enviado com sucesso.', ok: true };

                    return success;
                }, function (failed) {
                    failed['infoMessage'] = { msg: 'Não conseguimos reenviar o Email.', ok: false };
                    return failed;
                });
            }
        }
    }, {
        key: 'getUsuarioId',
        value: function getUsuarioId(idUsuario) {
            var url = 'usuarios/' + idUsuario;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: 'removerDaConta',
        value: function removerDaConta(idConta, idColab, idEmp) {
            var url = 'contas/colaborador/' + idConta;
            var obj = {};
            obj['colaborador'] = idColab;
            obj['empresa'] = idEmp;
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
            return this._resource.delete(url, {
                body: { colaborador: idColab, empresa: idEmp }
            }).then(function (success) {
                success['infoMessage'] = { msg: 'Colaborador desativado.', ok: true };
                return success;
            }, function (failed) {

                failed['infoMessage'] = { msg: 'Não conseguimos desativar o Colaborador.', ok: false };
                return failed;
            });
        }
    }, {
        key: 'relatorio',
        value: function relatorio(page, qntdNfe, id_empresa, range, urlFiltros, tipo, idUsuario) {
            // /usuarios/relatorio/5c9e6ffcb073f519943342f1
            var url = 'usuarios/relatorio/' + idUsuario + '?_page=' + page + '&_pagesize=' + qntdNfe + '&_range=' + range;
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: 'editar',
        value: function editar(usuario, idUsuario) {

            var url = 'usuarios/' + idUsuario;

            // let body = JSON.stringify(usuario);
            return this._resource.patch(url, usuario).then(function (success) {

                success['infoMessage'] = { msg: 'As informações foram editadas.', ok: true };
                return success;
            }, function (failed) {

                failed['infoMessage'] = { msg: 'Não conseguimos editar as informações.', ok: false };
                return failed;
            });
        }
    }]);

    return UsuarioService;
}(__WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (UsuarioService);

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RenderTableNFe_vue__ = __webpack_require__(155);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a247480_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RenderTableNFe_vue__ = __webpack_require__(770);
function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a247480"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RenderTableNFe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a247480_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RenderTableNFe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);










var CertificadoService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(CertificadoService, _CommonService);

    function CertificadoService(http) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, CertificadoService);

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CertificadoService.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(CertificadoService)).call(this, http));
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(CertificadoService, [{
        key: "getCertificadosConta",
        value: function getCertificadosConta(idConta, page, qntd, range) {
            var _this2 = this;

            var url = "certificados/conta/" + idConta + "?_page=" + page + "&_pagesize=" + qntd + "&_range=" + range;
            return this._resource.get(url).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(success) {
                    var certs;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.getCertificadosContaAdmin(idConta, page, qntd, range);

                                case 2:
                                    certs = _context.sent;

                                    success.body['certs_not_owner'] = certs && certs.items ? certs : [];
                                    // debugger;
                                    return _context.abrupt("return", success.body);

                                case 5:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }(), function (failed) {
                return failed;
            });
        }
    }, {
        key: "getCertificadosContaAdmin",
        value: function getCertificadosContaAdmin(idConta, page, qntd, range) {
            var url = "certificados/admin/conta/" + idConta + "?_page=" + page + "&_pagesize=" + qntd + "&_range=" + range;
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "cadastrar",
        value: function cadastrar(certificado, idConta) {
            var data = new FormData();
            // data.append("file", this.file_cert);

            // certificado.empresa.push("2222");
            if (certificado.file.length >= 1) {
                data.append("file", certificado.file[0]);
            } else {
                data.append("file", certificado.file);
            }
            data.append("password", certificado.password);
            data.append("empresas", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(certificado.empresa));

            var url = "certificados/" + idConta;

            return this._resource.post(url, data).then(function (success) {
                success['infoMessage'] = { msg: 'Certificado cadastrado.', ok: true };
                return success;
            }, function (failed) {
                failed['infoMessage'] = { msg: 'Ocorreu algum erro no cadastrado do certificado.', ok: false };
                return failed;
            });
        }
    }, {
        key: "vincularEmpresa",
        value: function vincularEmpresa(idCert, idEmpresas) {

            var url = "certificados/vinculaempresa/" + idCert;
            var body = {};

            body['empresas'] = idEmpresas;

            return this._resource.post(url, body).then(function (success) {
                success['infoMessage'] = { msg: 'Certificado vinculado.', ok: true };
                return success;
            }, function (failed) {
                failed['infoMessage'] = { msg: 'Ocorreu algum erro ao vincular o certificado.', ok: false };
                return failed;
            });
        }
    }, {
        key: "removerDaConta",
        value: function removerDaConta(idCertificado) {
            var url = "certificados/" + idCertificado;

            return this._resource.delete(url).then(function (success) {
                success['infoMessage'] = { msg: 'Certificado desativado.', ok: true };
                return success;
            }, function (failed) {
                failed['infoMessage'] = { msg: 'Não conseguimos desativar o Certificado.', ok: false };
                return failed;
            });
        }
    }, {
        key: "getQntdVencendo",
        value: function getQntdVencendo(idUsuario) {
            var url = "certificados/relatorio/qntdVencendo/" + idUsuario;

            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "relatorio",
        value: function relatorio(idUsuario) {
            var url = "certificados/relatorio/" + idUsuario;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "envMail",
        value: function envMail(idCert, email) {
            var url = "certificados/envMail";
            var obj = { idCert: idCert, email: email };
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
            return this._resource.post(url, body).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }]);

    return CertificadoService;
}(__WEBPACK_IMPORTED_MODULE_8__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CertificadoService);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var ContaService = function () {
    function ContaService(http) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ContaService);

        this._resource = http;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContaService, [{
        key: "recoverPassword",
        value: function recoverPassword(email) {
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(email);
            return this._resource.patch("usuarios/recoverPassword", body).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "getConta",
        value: function getConta(id_conta) {
            var url = "contas/" + id_conta;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "attPrimAcesso",
        value: function attPrimAcesso(id_conta) {
            var url = "contas/primAcesso/" + id_conta;
            return this._resource.patch(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "relatorio",
        value: function relatorio(page, qntdNfe, id_empresa, range, urlFiltros, tipo, idUsuario) {
            var url = "contas/relatorio/" + idUsuario + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range;
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "relatorioDetalhado",
        value: function relatorioDetalhado(idUsuario, conta) {
            var url = "contas/relatorio/" + idUsuario + "/conta/" + conta;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "relatorioContasNotas",
        value: function relatorioContasNotas(idUsuario, conta, mes) {
            var url = "contas/relatorio/" + idUsuario + "/individual/" + conta + "/" + mes;

            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }]);

    return ContaService;
}();

/* harmony default export */ __webpack_exports__["a"] = (ContaService);

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);









var IptuService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(IptuService, _CommonService);

    function IptuService() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, IptuService);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IptuService.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(IptuService)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(IptuService, [{
        key: "getImoveis",
        value: function getImoveis(page, qntd, id_empresa) {
            var url = "iptu/empresa/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntd;
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "getPdfById",
        value: function getPdfById(id, path) {
            var _this2 = this;

            return this._resource.get("iptu/" + id + "/pdf/" + path).then(function (success) {
                var data = new Uint8Array(success.body.pdf.data);
                return _this2.bufferToBase64(data);
            }, function (failed) {
                console.log(failed);
            });
        }
    }, {
        key: "setImovel",
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(imovel) {
                var url;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log(imovel);
                                url = "imoveis";
                                return _context.abrupt("return", this._resource.post(url, imovel).then(function (success) {
                                    return success.body;
                                }, function (failed) {
                                    return failed;
                                }));

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function setImovel(_x) {
                return _ref.apply(this, arguments);
            }

            return setImovel;
        }()
    }, {
        key: "updateImovel",
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(imovel, idImovel) {
                var url;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                url = "iptu/" + idImovel;
                                return _context2.abrupt("return", this._resource.patch(url, imovel).then(function (success) {
                                    return success.body;
                                }, function (failed) {
                                    return failed;
                                }));

                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function updateImovel(_x2, _x3) {
                return _ref2.apply(this, arguments);
            }

            return updateImovel;
        }()
    }]);

    return IptuService;
}(__WEBPACK_IMPORTED_MODULE_7__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (IptuService);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tributacao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return simples; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findTributacao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findSimples; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formataAliquota; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var tributacao = [{ tipo: "T", desc: "Tributado em São Paulo." }, { tipo: "F", desc: "Tributado Fora de São Paulo." }, { tipo: "A", desc: "Tributado em São Paulo, porém Isento." }, { tipo: "B", desc: "Tributado Fora de São Paulo, porém Isento." }, { tipo: "D", desc: "Tributado em São Paulo com isenção parcia." }, {
  tipo: "M",
  desc: "Tributado em São Paulo, porém com indicação de imunidade subjetiva."
}, {
  tipo: "N",
  desc: "Tributado Fora de São Paulo, porém com indicação de imunidade subjetiva."
}, {
  tipo: "R",
  desc: "Tributado em São Paulo, porém com indicação de imunidade objetiva."
}, {
  tipo: "S",
  desc: "Tributado fora de São Paulo, porém com indicação de imunidade objetiva."
}, {
  tipo: "X",
  desc: "Tributado em São Paulo, porém Exigibilidade Suspensa."
}, {
  tipo: "V",
  desc: "Tributado Fora de São Paulo, porém Exigibilidade Suspensa."
}, { tipo: "P", desc: "Exportação de Serviços." }, { tipo: "U0", desc: "Upload, sem informação de tributação." }];

var simples = [{ tipo: "0", desc: "Não optante pelo Simples Federal nem Municipal" }, { tipo: "1", desc: "Optante pelo Simples Federal (Alíquota de 1,0%)" }, { tipo: "2", desc: "Optante pelo Simples Federal (Alíquota de 0,5%)" }, { tipo: "3", desc: "Optante pelo Simples Municipal." }, { tipo: "4", desc: "Optante pelo Simples Nacional." }, { tipo: "5", desc: "Não Contratado" }];

var findTributacao = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(obj) {
    var trib;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            trib = null;

            tributacao.forEach(function (item) {
              if (item.tipo == obj) {
                trib = item;
              }
            });
            return _context.abrupt("return", trib);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function findTributacao(_x) {
    return _ref.apply(this, arguments);
  };
}();
var findSimples = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(obj) {
    var simp;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            simp = null;

            simples.forEach(function (item) {
              if (item.tipo == obj) {
                simp = item;
              }
            });
            return _context2.abrupt("return", simp);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function findSimples(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var DEFAULT_VALUE_RETURN = '0,00';

var LIMIT_VALUE_TO_FORMAT = 10;

var validaValorMaximoAliquota = function validaValorMaximoAliquota(aliquota) {
  return Number(aliquota) < LIMIT_VALUE_TO_FORMAT;
};

var formataAliquota = function formataAliquota(aliqServico) {
  var aliquota = 0;

  if (String(aliqServico).includes('0.')) {
    aliquota = String(aliqServico).replace('0.0', '');
    if (validaValorMaximoAliquota(aliquota)) return String(Number(aliquota));
    return String(Number(aliquota[0] + "." + aliquota[1] + (aliquota[2] ? aliquota[2] : 0)));
  } else {
    if (!String(aliqServico).includes('0.')) {
      aliquota = String(aliqServico).replace('0.', '');
      if (validaValorMaximoAliquota(aliquota)) return String(Number(aliquota));
      return String(Number(aliquota[0] + "." + aliquota[1] + (aliquota[2] ? aliquota[2] : 0)));
    }
  }

  return DEFAULT_VALUE_RETURN;
};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputFile_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4cc1b7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputFile_vue__ = __webpack_require__(651);
function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f4cc1b7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4cc1b7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var GravatarService = function () {
  function GravatarService(http) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GravatarService);

    this._resource = http;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GravatarService, [{
    key: "getGravatar",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(email) {
        var hashMD5;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.MD5(email);

              case 2:
                hashMD5 = _context.sent;
                return _context.abrupt("return", this._resource.get("https://pt.gravatar.com/" + hashMD5 + ".json").then(function (success) {
                  return JSON.parse(success.bodyText).entry[0];
                }, function (failed) {
                  return failed;
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getGravatar(_x) {
        return _ref.apply(this, arguments);
      }

      return getGravatar;
    }()
  }, {
    key: "MD5",
    value: function MD5(d) {
      var result = this.M(this.V(this.Y(this.X(d), 8 * d.length)));
      return result.toLowerCase();
    }
  }, {
    key: "M",
    value: function M(d) {
      for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++) {
        _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
      }return f;
    }
  }, {
    key: "X",
    value: function X(d) {
      for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) {
        _[m] = 0;
      }for (m = 0; m < 8 * d.length; m += 8) {
        _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
      }return _;
    }
  }, {
    key: "V",
    value: function V(d) {
      for (var _ = "", m = 0; m < 32 * d.length; m += 8) {
        _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
      }return _;
    }
  }, {
    key: "Y",
    value: function Y(d, _) {
      d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;
      for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
        var h = m,
            t = f,
            g = r,
            e = i;
        f = this.md5_ii(f = this.md5_ii(f = this.md5_ii(f = this.md5_ii(f = this.md5_hh(f = this.md5_hh(f = this.md5_hh(f = this.md5_hh(f = this.md5_gg(f = this.md5_gg(f = this.md5_gg(f = this.md5_gg(f = this.md5_ff(f = this.md5_ff(f = this.md5_ff(f = this.md5_ff(f, r = this.md5_ff(r, i = this.md5_ff(i, m = this.md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = this.md5_ff(r, i = this.md5_ff(i, m = this.md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = this.md5_ff(r, i = this.md5_ff(i, m = this.md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = this.md5_ff(r, i = this.md5_ff(i, m = this.md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = this.md5_gg(r, i = this.md5_gg(i, m = this.md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = this.md5_gg(r, i = this.md5_gg(i, m = this.md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = this.md5_gg(r, i = this.md5_gg(i, m = this.md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = this.md5_gg(r, i = this.md5_gg(i, m = this.md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = this.md5_hh(r, i = this.md5_hh(i, m = this.md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = this.md5_hh(r, i = this.md5_hh(i, m = this.md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = this.md5_hh(r, i = this.md5_hh(i, m = this.md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = this.md5_hh(r, i = this.md5_hh(i, m = this.md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = this.md5_ii(r, i = this.md5_ii(i, m = this.md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = this.md5_ii(r, i = this.md5_ii(i, m = this.md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = this.md5_ii(r, i = this.md5_ii(i, m = this.md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = this.md5_ii(r, i = this.md5_ii(i, m = this.md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = this.safe_add(m, h), f = this.safe_add(f, t), r = this.safe_add(r, g), i = this.safe_add(i, e);
      }
      return Array(m, f, r, i);
    }
  }, {
    key: "md5_cmn",
    value: function md5_cmn(d, _, m, f, r, i) {
      return this.safe_add(this.bit_rol(this.safe_add(this.safe_add(_, d), this.safe_add(f, i)), r), m);
    }
  }, {
    key: "md5_ff",
    value: function md5_ff(d, _, m, f, r, i, n) {
      return this.md5_cmn(_ & m | ~_ & f, d, _, r, i, n);
    }
  }, {
    key: "md5_gg",
    value: function md5_gg(d, _, m, f, r, i, n) {
      return this.md5_cmn(_ & f | m & ~f, d, _, r, i, n);
    }
  }, {
    key: "md5_hh",
    value: function md5_hh(d, _, m, f, r, i, n) {
      return this.md5_cmn(_ ^ m ^ f, d, _, r, i, n);
    }
  }, {
    key: "md5_ii",
    value: function md5_ii(d, _, m, f, r, i, n) {
      return this.md5_cmn(m ^ (_ | ~f), d, _, r, i, n);
    }
  }, {
    key: "safe_add",
    value: function safe_add(d, _) {
      var m = (65535 & d) + (65535 & _);
      return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m;
    }
  }, {
    key: "bit_rol",
    value: function bit_rol(d, _) {
      return d << _ | d >>> 32 - _;
    }
  }]);

  return GravatarService;
}();

/* harmony default export */ __webpack_exports__["a"] = (GravatarService);

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Certificado = function Certificado(nome, validade, _id) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Certificado);

    this.nome = nome;
    var bvenc = false;
    if (new Date() > new Date(validade)) {
        bvenc = true;
    }
    this.validade = new Date(validade).toLocaleDateString();
    this.bvenc = bvenc;
    this._id = _id;
};

/* harmony default export */ __webpack_exports__["a"] = (Certificado);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Usuario = function Usuario(nome, sobrenome, email, telefone, dtNascimento, estado, cidade, statusIn, preCadastro, _id, password) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Usuario);

    this.nome = nome;
    this.sobrenome = sobrenome;
    this.email = email;
    this.telefone = telefone != undefined && telefone.length == 8 ? telefone.replace(/^(\d{4})(\d)/, "$1-$2") : telefone != undefined && telefone.length == 11 ? telefone.replace(/^(\d{2})(\d{5})(\d)/, "($1) $2-$3") : telefone;
    this.dtNascimento = dtNascimento != undefined ? dtNascimento.replace(/^(\d{2})(\d{2})(\d)/, "$1/$2/$3") : dtNascimento;
    this.estado = estado;
    this.plano;
    this.cidade = cidade;
    this.statusIn = statusIn;
    this.preCadastro = preCadastro;
    this._id = _id;
};

/* harmony default export */ __webpack_exports__["a"] = (Usuario);

/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormUsuario_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b231da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormUsuario_vue__ = __webpack_require__(594);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23b231da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormUsuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b231da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormUsuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b32e129_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(508);
function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b32e129"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b32e129_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logotipo_5.036a2c9.png";

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = converter;
function converter(data_erp) {
  if (!data_erp) {
    return '';
  }

  var input = data_erp;

  var date = input.substring(0, 10);
  var hour = input.substring(11, 19);
  var aux = date.split('-').reverse().join('/');
  var formater = aux + ' ' + hour;

  return formater;
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__certificado_Certificado__ = __webpack_require__(72);



var Empresa = function Empresa() {
  var cnpj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var razao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var grupo = arguments[2];
  var apelido = arguments[3];
  var ie = arguments[4];
  var ccm = arguments[5];
  var endereco = arguments[6];
  var bairro = arguments[7];
  var complemento = arguments[8];
  var cep = arguments[9];
  var municipio = arguments[10];
  var uf = arguments[11];
  var codMun = arguments[12];
  var faturamento = arguments[13];
  var colaboradores = arguments[14];
  var certificado = arguments[15];
  var nfeTask = arguments[16];
  var cteTask = arguments[17];
  var enviaEmails = arguments[18];
  var _id = arguments[19];
  var tknIntegracao = arguments[20];
  var dtReg = arguments[21];
  var bloqueada = arguments[22];

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Empresa);

  this.cnpj = cnpj;
  this.razao = razao;
  this.grupo = grupo;
  this.apelido = apelido;
  this.endereco = endereco;
  this.bairro = bairro;
  this.complemento = complemento;
  this.ccm = ccm;
  this.ie = ie;
  this.cep = cep;
  this.municipio = municipio;
  this.uf = uf;
  this.codMun = codMun;
  this.colaboradores = colaboradores;
  this.faturamento = faturamento;
  this.certificado = certificado;

  this.dtReg = dtReg ? new Date(dtReg) : new Date();
  this.bloqueada = bloqueada;

  var bvenc = false;
  if (certificado != undefined) {
    if (certificado.validade == undefined || new Date() > new Date(certificado.validade)) {
      bvenc = true;
    }
    this.certificado["validade"] = {
      data: certificado.validade != undefined ? new Date(certificado.validade) : undefined,
      venc: bvenc
    };
  } else {
    this.certificado = certificado;
  }
  this.nfeTask = nfeTask;
  this.cteTask = cteTask;
  this.enviaEmails = enviaEmails;
  this._id = _id;
  this.tknIntegracao = tknIntegracao;
};

/* harmony default export */ __webpack_exports__["a"] = (Empresa);

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnExpExcell_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_753d8f5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnExpExcell_vue__ = __webpack_require__(644);
function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-753d8f5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnExpExcell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_753d8f5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnExpExcell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertMessage_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c8d8e4e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertMessage_vue__ = __webpack_require__(809);
function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c8d8e4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c8d8e4e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var AlertMessage = function () {
    function AlertMessage() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AlertMessage);

        this.snack = this.resetAlert();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AlertMessage, [{
        key: "resetAlert",
        value: function resetAlert() {
            this.snack = { show: false, text: '', time: 4000, color: "grey darken-4", btnFColor: "red", multiple: false };
            return this.snack;
        }
    }, {
        key: "snackSuccess",
        value: function snackSuccess() {
            this.snack.color = "green darken-3";
            this.snack.btnFColor = "white";
        }
    }, {
        key: "snackDanger",
        value: function snackDanger() {
            this.snack.color = "red darken-4";
            this.snack.btnFColor = "white";
        }
    }, {
        key: "snackAlert",
        value: function snackAlert() {
            this.snack.color = "amber accent-4";
            this.snack.btnFColor = "black";
        }
    }, {
        key: "snackDefault",
        value: function snackDefault() {
            this.snack.color = "grey darken-4";
            this.snack.btnFColor = "red";
        }
    }]);

    return AlertMessage;
}();

/* harmony default export */ __webpack_exports__["a"] = (AlertMessage);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    progressBar: function progressBar() {
      return this.$store.getters.progressBar;
    }
  },
  components: {}
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu_Menu_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_loggedArea_consultaNotas_ConsultaNotas_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_loggedArea_dashBoard_DashBoard_vue__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_loggedArea_editarPerfil_EditarPerfil_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_loggedArea_configuracoes_Configuracoes_vue__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_loggedArea_configuracoes_configuracoesAutomacao_ConfiguracoesAutomacao_vue__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_conta_usuario_Usuario_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_conta_Conta_js__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__domain_conta_ContaService_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_alertMessage_AlertMessage_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__domain_alertMessage_AlertMessage_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__domain_notificacoes_NotificacoesService_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_loggedArea_firstAccess_FirstAccess_vue__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_loggedArea_relatorio_Relatorio_vue__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_loggedArea_fechamentoMes_FechamentoMes_vue__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_loggedArea_docsFederal_DocsFederal__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_loggedArea_loja_Loja_vue__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_loggedArea_validaOcr_ValidaOcr_vue__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__domain_ibge_estados_js__ = __webpack_require__(285);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    mainMenu: __WEBPACK_IMPORTED_MODULE_2__components_menu_Menu_vue__["a" /* default */],
    ConsultaNotas: __WEBPACK_IMPORTED_MODULE_4__pages_loggedArea_consultaNotas_ConsultaNotas_vue__["a" /* default */],
    DashBoard: __WEBPACK_IMPORTED_MODULE_5__pages_loggedArea_dashBoard_DashBoard_vue__["a" /* default */],
    editarPerfil: __WEBPACK_IMPORTED_MODULE_6__pages_loggedArea_editarPerfil_EditarPerfil_vue__["a" /* default */],
    configuracoes: __WEBPACK_IMPORTED_MODULE_7__pages_loggedArea_configuracoes_Configuracoes_vue__["a" /* default */],
    AlertComponent: __WEBPACK_IMPORTED_MODULE_12__components_shared_alertMessage_AlertMessage_vue__["a" /* default */],
    PrimeiroAcesso: __WEBPACK_IMPORTED_MODULE_16__pages_loggedArea_firstAccess_FirstAccess_vue__["a" /* default */],
    Relatorio: __WEBPACK_IMPORTED_MODULE_17__pages_loggedArea_relatorio_Relatorio_vue__["a" /* default */],
    FechamentoMes: __WEBPACK_IMPORTED_MODULE_18__pages_loggedArea_fechamentoMes_FechamentoMes_vue__["a" /* default */],
    Loja: __WEBPACK_IMPORTED_MODULE_20__pages_loggedArea_loja_Loja_vue__["a" /* default */],
    configuracoesAutomacao: __WEBPACK_IMPORTED_MODULE_8__pages_loggedArea_configuracoes_configuracoesAutomacao_ConfiguracoesAutomacao_vue__["a" /* default */],
    ValidaOcr: __WEBPACK_IMPORTED_MODULE_21__pages_loggedArea_validaOcr_ValidaOcr_vue__["a" /* default */]
  },
  data: function data() {
    return {
      // vezes: 0,
      // oldId: '',
      empresa: [],
      error: undefined,
      alert: new __WEBPACK_IMPORTED_MODULE_13__domain_alertMessage_AlertMessage_js__["a" /* default */](),
      component: { name: "" },
      route: this.$router.history.current.path,
      conta: new __WEBPACK_IMPORTED_MODULE_10__domain_conta_Conta_js__["a" /* default */](),
      notifiService: new __WEBPACK_IMPORTED_MODULE_15__domain_notificacoes_NotificacoesService_js__["a" /* default */](this.$http),
      attEmpresas: false,
      IBGE: { estados: [], cidades: { att: false, uf: undefined, items: [] } },
      notificacoes: { data: null },
      firstAccess: { nfeQtd: 0, cteQtd: 0, nfseQtd: 0, buscando: true },
      tabs: [{
        title: "Recebidas"
      }, {
        title: "Enviadas"
      }]
    };
  },

  created: function created() {
    if (this.$session.exists()) {
      var auxConta = this.$session.get("jwt");
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common["Authorization"] = "Bearer " + auxConta.accessToken;
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common["sessionId"] = this.$session.id();
      this.service = new __WEBPACK_IMPORTED_MODULE_11__domain_conta_ContaService_js__["a" /* default */](this.$http);
      this.conta.admin = auxConta.admin;
      this.conta.conta = auxConta.conta;
      this.conta.email = auxConta.email;
      auxConta.hasOwnProperty("emprs_not_admin") ? this.conta["emprs_not_admin"] = auxConta.emprs_not_admin : "";
      this.conta.favEmails = auxConta.favEmails;
      this.conta.gravatarProfile = auxConta.gravatarProfile;
      this.conta.id_usuario = auxConta.id_usuario;
      this.conta.nome = auxConta.nome;
      this.conta.colaborador = auxConta.colaborador;
      this.conta.primAcesso = auxConta.primAcesso;
      this.conta.imagem = auxConta.img;

      // this.conta["newFeatures"] = true;

      this.getEstados;
    } else {
      // debugger;
      this.error = {};
      this.error["show"] = true;
      this.error["msg"] = "Logue no sistema.";
      this.$router.afterHooks.push(this.error);
      this.$router.push("/login");
    }
  },
  mounted: function mounted() {
    // this.openJivoChat();
    this.$nextTick(function () {
      if (!this.error) {
        if (this.conta.primAcesso) {
          this.$router.push("/primeiroAcesso");
        }
        if (this.$router.history.current.path == "/consultaCTe" || this.$router.history.current.path == "/consultaNFe" || this.$router.history.current.path == "/consultaNFSe") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/ePerfil") {
          this.component.name = "editarPerfil";
        } else if (this.$router.history.current.path == "/verPerfil") {
          this.component.name = "verPerfil";
        } else if (this.$router.history.current.path == "/configuracoes") {
          this.component.name = "configuracoes";
        } else if (this.$router.history.current.path == "/configuracoesAutomacao") {
          this.component.name = "configuracoesAutomacao";
        } else if (this.$router.history.current.path == "/fornecedores") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/clientes") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/produtos") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/consultaIptu") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/relatorio" && this.$canAccessRelatorio.includes(this.conta.email)) {
          this.component.name = "Relatorio";
        } else if (this.$router.history.current.path == "/validaOcr" && this.$canAccessRelatorio.includes(this.conta.email)) {
          this.component.name = "ValidaOcr";
        } else if (this.$router.history.current.path == "/primeiroAcesso" && this.conta.primAcesso) {
          this.component.name = "PrimeiroAcesso";
        } else if (this.$router.history.current.path == "/fechamento") {
          this.component.name = "FechamentoMes";
        } else if (this.$router.history.current.path == "/docsFederal") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/docsMunicipal") {
          this.component.name = "ConsultaNotas";
          // } else if (this.$router.history.current.path == "/loja") {
          //   this.component.name = "Loja";
        } else {
          this.$router.push("/DashBoard");
          this.component.name = "DashBoard";
        }
      }
    });
  },
  watch: {
    "conta.getNotificacoes": function contaGetNotificacoes(newV, oldV) {
      if (newV) {
        this.getNotificacoes();
        this.conta.getNotificacoes = false;
      }
    },
    "IBGE.cidades.att": function IBGECidadesAtt(newV, oldV) {
      if (newV) {
        if (this.IBGE.cidades.uf) {
          this.getCidades(this.IBGE.cidades.uf);
          this.IBGE.cidades.att = false;
        }
      }
    },
    empresa: function empresa() {
      // if(this.vezes === 0){
      //   this.oldId = this.empresa._id;
      //   this.getNotificacoes();
      //   this.currentProperties;
      // }
      // this.vezes++;
      // return;
    },
    $route: function $route() {
      if (!this.error) {
        if (this.conta.primAcesso) {
          this.$router.push("/primeiroAcesso");
        }
        this.getNotificacoes();
        if (this.$router.history.current.path == "/consultaCTe" || this.$router.history.current.path == "/consultaNFe" || this.$router.history.current.path == "/consultaNFSe") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/ePerfil") {
          this.component.name = "editarPerfil";
        } else if (this.$router.history.current.path == "/verPerfil") {
          this.component.name = "verPerfil";
        } else if (this.$router.history.current.path == "/configuracoes") {
          this.component.name = "configuracoes";
        } else if (this.$router.history.current.path == "/configuracoesAutomacao") {
          this.component.name = "configuracoesAutomacao";
        } else if (this.$router.history.current.path == "/fornecedores") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/clientes") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/produtos") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/consultaIptu") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/relatorio" && this.$canAccessRelatorio.includes(this.conta.email)) {
          this.component.name = "Relatorio";
        } else if (this.$router.history.current.path == "/validaOcr" && this.$canAccessRelatorio.includes(this.conta.email)) {
          this.component.name = "ValidaOcr";
        } else if (this.$router.history.current.path == "/primeiroAcesso" && this.conta.primAcesso) {
          this.component.name = "PrimeiroAcesso";
        } else if (this.$router.history.current.path == "/fechamento") {
          this.component.name = "FechamentoMes";
        } else if (this.$router.history.current.path == "/docsFederal") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/docsMunicipal") {
          this.component.name = "ConsultaNotas";
          // } else if (this.$router.history.current.path == "/loja") {
          //   this.component.name = "Loja";
        } else {
          this.$router.push("/DashBoard");
          this.component.name = "DashBoard";
        }
      }
    }
  },
  computed: {
    getSelect: function getSelect() {},
    currentProperties: function currentProperties() {
      var obj = {};
      obj["empresa"] = this.empresa;
      return obj;
    },
    getEstados: function getEstados() {
      var _this = this;

      var auxAut = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common["Authorization"];
      delete __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common["Authorization"];
      this.resource = this.$resource("https://servicodados.ibge.gov.br/api/v1/localidades/estados");
      this.resource.query().then(function (success) {
        _this.$store.commit('addUfArray', success.body);
        _this.IBGE.estados = success.body;
        _this.IBGE.cidades.uf = 35;
        _this.IBGE.cidades.att = true;
        return success.body;
      }, function (failed) {
        _this.IBGE.estados = __WEBPACK_IMPORTED_MODULE_22__domain_ibge_estados_js__["a" /* estados */];
        _this.IBGE.cidades.uf = 35;
        _this.IBGE.cidades.att = true;
        return __WEBPACK_IMPORTED_MODULE_22__domain_ibge_estados_js__["a" /* estados */];
      });
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common["Authorization"] = auxAut;
    }
  },
  methods: {
    openJivoChat: function openJivoChat() {
      var jivoChat = document.querySelector('jdiv');

      // Verifica se o jivochat já foi criado
      if (jivoChat) {
        jivoChat.style.display = "block";
        return;
      } else {
        // Cria o jivochat
        if (this.$router.currentRoute.path !== '/login') {
          var load = function load() {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = '//code.jivosite.com/script/widget/' + widget_id;
            var ss = document.getElementsByTagName('script')[0];
            ss.parentNode.insertBefore(s, ss);
          };

          var widget_id = 'JiAtwaHBNP';
          var d = document;
          var w = window;


          if (d.readyState == 'complete') {
            load();
          } else {
            if (w.attachEvent) {
              w.attachEvent('onload', load);
            } else {
              w.addEventListener('load', load, false);
            }
          }
        } else {
          return;
        }
      }
    },

    getCidades: function getCidades(uf) {
      var _this2 = this;

      if (uf) {
        var auxAut = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common["Authorization"];
        delete __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common["Authorization"];
        var uf = uf;
        this.resource = this.$resource("https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + uf + "/municipios");
        this.resource.query().then(function (success) {
          _this2.IBGE.cidades.items = success.body;

          return success.body;
        }, function (failed) {
          return [];
        });
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common["Authorization"] = auxAut;
      }
    },
    getNotificacoes: function getNotificacoes() {
      var _this3 = this;

      if (this.conta && this.empresa) {
        // if(this.oldId === this.empresa._id) {
        //   return;
        // }
        // this.oldId = this.empresa._id;
        this.notifiService.getNotificacoesGeral(this.conta.id_usuario, this.empresa._id).then(function (resp) {
          if (resp.status != 0) {
            if (resp.ok) {
              _this3.conta.notificacoes = resp.body;
            } else if (resp.status == 400) {
              _this3.conta.notificacoes = "Notificações desativadas para esta empresa";
            } else {
              _this3.conta.notificacoes = undefined;
            }
          }
        });
      }
    },
    getNewEmp: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee($event) {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!$event) {
                  _context.next = 4;
                  break;
                }

                this.resource = this.$resource("empresas?cnpj=" + $event.cnpj);
                _context.next = 4;
                return this.resource.query().then(function (success) {
                  _this4.empresa = success.body.items[0];
                  return false;
                }, function (failed) {
                  if (failed.status == 404) {
                    return true;
                  }
                });

              case 4:
                this.attEmpresas = false;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getNewEmp(_x) {
        return _ref.apply(this, arguments);
      }

      return getNewEmp;
    }(),
    emitAttEmpresas: function emitAttEmpresas($event) {
      this.attEmpresas = $event;
    }
  }
});

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_menu_persistInfo_PersistInfo_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_menu_notificacoes_Notificacoes_vue__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_notas_cte_CteService__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_notas_nfse_NfseService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assert__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assert__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PersistInfo: __WEBPACK_IMPORTED_MODULE_5__components_menu_persistInfo_PersistInfo_vue__["a" /* default */], Notificacoes: __WEBPACK_IMPORTED_MODULE_6__components_menu_notificacoes_Notificacoes_vue__["a" /* default */] },
  props: ["conta", "attEmpresas", "logado", "alert", "firstAccess"],
  data: function data() {
    return {
      liberarInput: 0,
      //seta a nav como 100% o width
      clipped: true,
      //seta o menu como show no loading
      drawer: true,
      avatarProfile: "",
      usuario: { nome: "Aaron Chavez", email: "aaron.cha@themeon.net" },
      menuConfig: false,
      x: 0,
      y: 0,
      seeConfig: false,
      empresas: [],
      select: "",
      fixed: true,
      //deixa o menu menor:
      miniVariant: false,
      title: "Motor Fiscal",
      route: this.$router.history.current.path,
      changeLogo: false,
      emprSelect: "",
      oldEmprSelect: "",
      items: [
      // {
      //   icon: "mdi-store",
      //   title: "Loja Automação",
      //   rota: "/loja",
      //   id: "login"
      // },
      {
        icon: "mdi-view-dashboard-outline",
        title: "DashBoard",
        rota: "/DashBoard",
        id: "login"
      }, {
        icon: "mdi-cloud-search-outline",
        title: "Consulta NF-e",
        rota: "/consultaNFe",
        id: "login"
      }, {
        icon: "mdi-truck",
        title: "Consulta CT-e",
        rota: "/consultaCTe",
        id: "login"
      }, {
        icon: "mdi-toolbox-outline",
        title: "Consulta NFs-e",
        rota: "/consultaNFSe",
        id: "login"
      }, {
        icon: "mdi-diamond-stone",
        title: "Clientes",
        rota: "/clientes",
        id: "login"
      }, {
        icon: "mdi-cash",
        title: "Fornecedores",
        rota: "/fornecedores",
        id: "login"
      }, {
        icon: "mdi-package-variant",
        title: "Produtos",
        rota: "/produtos",
        id: "login"
      }, {
        icon: "mdi-calendar-check",
        title: "Fechamento de Mês",
        rota: "/fechamento",
        id: "login"
      }, {
        icon: "mdi-cog-outline",
        title: "Configurações",
        rota: "/configuracoes",
        id: "login"
      }, {
        icon: "mdi-text-box-outline",
        title: "Relátorio",
        rota: "/relatorio",
        id: "login"
      }, {
        icon: "mdi-file-outline",
        title: "Valida OCR",
        rota: "/validaOcr",
        id: "login"
      }]
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      if (this.conta != undefined && this.conta.conta != undefined) {
        this.seeConfig = true;
      }
      if (this.conta.imagem) {
        var dataImg = "data:image/jpg;base64," + this.bufferToBase64(this.conta.imagem.data);
        this.avatarProfile = "" + dataImg;
      } else if (this.conta != undefined && this.conta.gravatarProfile != undefined && !this.conta.gravatarProfile.hasOwnProperty('body')) {
        this.avatarProfile = this.conta.gravatarProfile.thumbnailUrl + "?s=200";
      }
      setTimeout(function () {
        _this.setActive(_this.$router.currentRoute.path);
      }, 200);
    });
  },
  computed: {
    homolog: function homolog() {
      if (window.location.href.indexOf("app.motorfiscal") == -1) {
        return true;
      } else {
        return false;
      }
    }
  },

  watch: {
    emprSelect: function emprSelect(newV, oldV) {
      var _this2 = this;

      this.firstAccess.buscando = false;
      if (newV && newV.hasOwnProperty('_id')) {
        if (newV.primBusca && newV.hasOwnProperty('certificado')) {
          var msg = '';
          if (this.conta.primAcesso) {
            msg = "Motor fiscal est\xE1 preparando o ambiente para voc\xEA!";
            this.drawer = false;
          } else {
            msg = "Motor fiscal est\xE1 preparando o ambiente para " + newV.razao + "!";
          }
          var primBuscaEmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newV.primBusca));
          var busca = 0;
          var qntBusca = 3;
          var temBusca = false;
          // let this.firstAccess = {nfeQtd: 0, cteQtd: 0, nfseQtd: 0}
          new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      setTimeout(function () {
                        resolve();
                      }, 40000);
                      _this2.activeGlobalLoader(msg);
                      _this2.alert.snackDefault();
                      _this2.alert.snack.time = 6000;
                      _this2.firstAccess.buscando = true;
                      _this2.firstAccess.nfeQtd = 0;
                      _this2.firstAccess.cteQtd = 0;
                      _this2.firstAccess.nfseQtd = 0;
                      while (busca < qntBusca) {
                        // if(primBuscaEmp.nfe){
                        //   temBusca = true;
                        //   await this.buscarSefaz(newV, 'NFe', this.firstAccess)
                        // }
                        // if(primBuscaEmp.cte){
                        //   temBusca = true;
                        //   await this.buscarSefaz(newV, 'CTE', this.firstAccess)
                        // }
                        // if(primBuscaEmp.nfse){
                        //   temBusca = true;
                        //   await this.buscarSefaz(newV, 'NFSE', this.firstAccess)
                        // }
                        busca++;
                        if (busca == qntBusca) {

                          resolve();
                        }
                        if (!temBusca) {
                          busca = qntBusca;
                          resolve();
                        }
                      }

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, _this2);
            }));

            return function (_x, _x2) {
              return _ref.apply(this, arguments);
            };
          }()).then(function () {
            if (_this2.firstAccess.buscando) {
              _this2.firstAccess.buscando = false;
              _this2.desactiveGlobalLoader();
              if (temBusca) {
                if (!_this2.conta.primAcesso) {
                  _this2.alert.snack.multiple = true;
                  _this2.alert.snack.text = "Notas baixadas para " + newV.razao + ":\n                    NF-e: " + _this2.firstAccess.nfeQtd + " \n                    CT-e: " + _this2.firstAccess.cteQtd + " \n                    NFS-e: " + _this2.firstAccess.nfseQtd + "\n                    ";
                  _this2.alert.snack.time = 8000;
                  _this2.alert.snack.show = true;
                }
                primBuscaEmp.nfe = false;
                primBuscaEmp.cte = false;
                primBuscaEmp.nfse = false;
                _this2.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_EmpresaService_js__["a" /* default */](_this2.$http);
                _this2.service.editar(newV, newV._id).then(function (resp) {});
              }
            }
          });
        }
      }
    },
    "conta.primAcesso": function contaPrimAcesso(newV, oldV) {
      if (newV && newV == true || this.$router.history.current.path == '/primeiroAcesso') {
        this.drawer = false;
      } else {
        this.drawer = true;
      }
    },
    attEmpresas: function attEmpresas(newV, oldV) {
      if (newV) {
        this.empresas = [];
        this.getEmpresas();
      }
    },
    "conta.getEmpresas": function contaGetEmpresas(newV, olV) {
      if (newV) {
        this.empresas = [];
        this.conta.getEmpresas = false;
        this.getEmpresas();
      }
    },
    miniVariant: function miniVariant(newV, oldV) {
      var sideBar = document.querySelector('#sideBar');
      if (newV && sideBar.classList.contains('v-navigation-drawer--is-mobile')) {
        this.drawer = newV;
      }
    },
    drawer: function drawer(newV, oldV) {
      var sideBar = document.querySelector('#sideBar');
      if (newV && sideBar.classList.contains('v-navigation-drawer--is-mobile')) {
        this.miniVariant = true;
      } else if (!newV && sideBar.classList.contains('v-navigation-drawer--is-mobile')) {
        this.miniVariant = false;
      }
    },
    $route: {
      deep: true,
      handler: function handler(refreshPage) {
        var rota = this.$router.history.current.path;
        if (rota == '/primeiroAcesso') {
          this.drawer = false;
        } else {
          this.drawer = true;
        }

        document.querySelectorAll(".navItem").forEach(function (element) {
          element.classList.remove("active");
        });
        var navItem = void 0;
        navItem = document.getElementById(rota);
        if (navItem != null) {
          navItem.parentElement.classList.add("active");
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.$nextTick(function () {
      this.getEmpresas();
    });
  },
  methods: {
    itemText: function itemText(item) {
      return item.razao + ' — ' + item.cnpj + ' — ' + item.apelido;
    },
    show: function show(e) {
      var _this3 = this;

      e.preventDefault();
      this.menuConfig = false;
      this.x = e.clientX;
      this.y = e.clientY + 10;
      this.$nextTick(function () {
        _this3.menuConfig = true;
      });
    },

    activeGlobalLoader: function activeGlobalLoader(msg) {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      var h4Msg = document.querySelector('.c_custom-msg');
      if (msg) {
        h4Msg.textContent = msg;
        h4Msg.classList.add("loading_global");
      } else {
        h4Msg.textContent = '';
      }
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      var h4Msg = document.querySelector('.c_custom-msg');

      h4Msg.classList.remove("loading_global");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    buscarSefaz: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(empr, component, firstAccess) {
        var tipo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tipo = 'recebida';

                if (component.indexOf("NFe") != -1) {
                  this.service = new __WEBPACK_IMPORTED_MODULE_7__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                } else if (component == "CTE") {
                  this.service = new __WEBPACK_IMPORTED_MODULE_8__domain_notas_cte_CteService__["a" /* default */](this.$http);
                } else if (component == "NFSE") {
                  this.service = new __WEBPACK_IMPORTED_MODULE_9__domain_notas_nfse_NfseService__["a" /* default */](this.$http);
                }
                _context2.next = 4;
                return this.service.consultaAvulsaNota(empr._id, tipo).then(function (resp) {
                  if (resp.status == 200) {
                    if (resp.body) {
                      if (resp.body.baixadas) {
                        firstAccess[component.toLowerCase() + "Qtd"] += parseInt(resp.body.baixadas);
                      }
                    }
                  }
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function buscarSefaz(_x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return buscarSefaz;
    }(),

    deslogar: function deslogar() {
      this.$session.destroy();
      this.$router.push("/login");
    },
    verificarCampo: function verificarCampo() {
      if (!this.emprSelect) {
        this.emprSelect = this.oldEmprSelect;
      }
    },
    handleFocus: function handleFocus() {
      document.activeElement.blur();
    },
    handleMenu: function handleMenu() {
      var enableMenuIptu = this.emprSelect.servicos ? this.emprSelect.servicos.robotizacao.find(function (item) {
        return item.nomeServico == "IPTU";
      }) : null;
      if (enableMenuIptu) {
        if (this.items[4].title == 'Consulta IPTU') {
          return;
        }

        this.items.splice(4, 0, {
          icon: "mdi-home-search-outline",
          title: "Consulta IPTU",
          rota: "/consultaIptu",
          id: "login"
        });
      } else {
        if (this.items[4].title == 'Consulta IPTU') {
          this.items.splice(4, 1);
        }
      }
    },
    handleChange: function handleChange() {
      if (this.oldEmprSelect.cnpj !== this.emprSelect.cnpj) {
        this.handleMenu();
        this.getEmpresas();
      } else {
        return;
      }
    },

    getEmpresas: function getEmpresas() {
      var _this4 = this;

      if (this.emprSelect) {
        this.oldEmprSelect = this.emprSelect;
        this.$store.commit('ressetAllStates');
      }
      this.resource = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
      var lengthEmpr = 0;

      new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this4.$store.commit('addOpenStore', false);
                  if (_this4.conta.conta != undefined && _this4.empresas.length == 0) {
                    _this4.resource.getEmpresasConta(_this4.conta.conta).then(function (success) {
                      //  if(!success.emprs_not_admin.length){
                      //    console.log('LENGTH');
                      //    return;
                      //  }
                      _this4.$store.commit('addEmpresasMenu', success);
                      for (var j = 0; j < success.emprs_not_admin.length; j++) {
                        try {
                          success.emprs_not_admin[j].empresa['not_admin'] = true;
                        } catch (error) {
                          continue;
                        }
                        _this4.empresas.push(success.emprs_not_admin[j].empresa);
                      }
                      for (var i = 0; i < success.empresas.length; i++) {
                        if (success.empresas[i] && success.empresas[i].empresa && success.empresas[i].empresa._id == success.faturamento) {
                          success.empresas[i].empresa['faturamento'] = true;
                        }
                        if (success.empresas[i] && success.empresas[i].empresa && success.empresas[i].empresa._id == success.faturamento && (_this4.emprSelect == '' || _this4.emprSelect == undefined)) {
                          _this4.emprSelect = success.empresas[i].empresa;
                          _this4.handleMenu();
                          _this4.oldEmprSelect = _this4.emprSelect;
                          _this4.$emit("getNewEmp", _this4.emprSelect);
                        }
                        if (success.empresas[i].empresa) {

                          _this4.empresas.push(success.empresas[i].empresa);
                        }
                      }
                      _this4.conta.admin = _this4.empresas.slice();
                      lengthEmpr = _this4.empresas.length;
                      _this4.empresas = _this4.empresas.sort(function (a, b) {
                        return a.cnpj > b.cnpj ? 1 : a.cnpj < b.cnpj ? -1 : 0;
                      }).slice();
                      resolve();
                    });
                  } else {
                    resolve();
                  }

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, _this4);
        }));

        return function (_x6, _x7) {
          return _ref3.apply(this, arguments);
        };
      }()).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.conta.colaborador != undefined && _this4.empresas.length == lengthEmpr)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return _this4.resource.getEmpresasColaborador(_this4.conta.id_usuario).then(function (success) {
                  for (var i = 0; i < success.empresas.length; i++) {
                    if (success.empresas[i] != null) {

                      if (_this4.emprSelect == '' || _this4.emprSelect == undefined) {
                        _this4.emprSelect = success.empresas[i];
                        _this4.$emit("getNewEmp", _this4.emprSelect);
                      }
                      _this4.empresas.push(success.empresas[i]);
                    }
                  }
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))).then(function () {
        if (_this4.emprSelect != undefined && _this4.emprSelect != "") {

          _this4.resource.getEmpresasID(_this4.emprSelect._id).then(function (emp) {
            _this4.select = emp;
            _this4.$emit("getNewEmp", emp);
            return emp;
          });
        }
      }).then(function () {
        _this4.conta['list_empresas'] = _this4.empresas.slice();
        if (_this4.liberarInput < 2) {
          _this4.liberarInput++;
        }
        if (_this4.$router.history.current.path !== '/loja') {
          _this4.$store.commit('addOpenStore', true);
        }
      });
    },

    setActive: function setActive(rota) {
      document.querySelectorAll(".navItem").forEach(function (element) {
        element.classList.remove("active");
      });
      var navItem = document.getElementById(rota);
      if (navItem != undefined) {
        navItem.parentElement.classList.add("active");
      }
      if (rota == "/consultaCTe" || rota == "/consultaNFe" || rota == "/consultaNFSe") {
        this.getEmpresas();
      }
    },

    currentProperties: function currentProperties() {
      var obj = {};
      obj["empresa"] = this.select;
      return obj;
    },
    authenticateRoute: function authenticateRoute() {
      //   "===================FUNÇÃO authenticateRoute================="
      // );
      var rota = this.$router.history.current.path;

      if (rota.substring(0, rota.indexOf("/", 2)) == "/DashBoard") {
        return true;
      } else if (rota == "/consultaNFe" || rota == "/consultaCTe") return true;else return false;
    },
    bufferToBase64: function bufferToBase64(buf) {
      var binstr = Array.prototype.map.call(buf, function (ch) {
        return String.fromCharCode(ch);
      }).join("");
      return btoa(binstr);
    },

    toggleSideMenu: function toggleSideMenu() {
      // Logotipo_5.png
      this.animeHamburguer();
      this.miniVariant = !this.miniVariant;
      this.changeLogo = !this.changeLogo;

      document.querySelector("#userInfoMenu").classList.add("d-none");
      // if (
      //   document.querySelector("#userInfo #arrowIcon") != null &&
      //   document
      //     .querySelector("#userInfo #arrowIcon")
      //     .classList.contains("rotateArrow")
      // ) {
      //   document
      //     .querySelector("#userInfo #arrowIcon")
      //     .classList.remove("rotateArrow");
      // }
    },
    animeHamburguer: function animeHamburguer() {
      var lines = document.querySelectorAll(".custom_line");
      document.querySelector(".custom_hamb").classList.toggle("custom_toggled");
      lines.forEach(function (item) {
        item.classList.toggle("custom_toggled");
      });
    },
    toggleUserInfo: function toggleUserInfo() {
      // let arrowIcon = document.querySelector("#userInfo #arrowIcon");
      // arrowIcon.classList.toggle("rotateArrow");
      var userNavInfo = document.querySelector("#userInfoMenu");
      userNavInfo.classList.toggle("d-none");
    }
  },
  name: "App"
});

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CertDigitalElement_vue__ = __webpack_require__(483);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["empresa", "conta"],
  components: { CertDigitalElement: __WEBPACK_IMPORTED_MODULE_0__CertDigitalElement_vue__["a" /* default */] },
  data: function data() {
    return {
      config: {
        show: false,
        msg: "",
        color: "",
        icon: "",
        link: { has: false, url: "", msg: "" }
      },
      mostrarNewFeatures: false,
      sefazLentidao: false,
      prefSpLentidao: false,
      InformacaoSefaz: false,
      dialog: false
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  watch: {
    empresa: function empresa(newV, oldV) {
      this.reset();
      this.hasCCM();
      this.verifyCert;
    },
    "conta.notificacoes": function contaNotificacoes() {
      if (this.conta && this.conta.hasOwnProperty('notificacoes')) {
        try {
          this.sefazLentidao = this.conta.notificacoes.sefazLenta;
          this.prefSpLentidao = this.conta.notificacoes.prefSPLenta;
        } catch (e) {
          console.log(e);
        }
      }
    },
    $route: {
      deep: true,
      handler: function handler(refreshPage) {
        if (this.empresa) {
          this.reset();
          this.hasCCM();
          this.verifyCert;
        }
      }
    }
  },
  computed: {
    dialogWidthRC: function dialogWidthRC() {
      return this.$store.getters.dialogWidthRC;
    },
    buscaCTE: function buscaCTE() {
      return this.$store.state.buscaCTE;
    },

    verifyCert: function verifyCert() {
      var today = new Date();
      var certDate = this.empresa.certificado == undefined ? undefined : new Date(this.empresa.certificado.validade);

      // let certDate = new Date("2019-02-26");
      // let dateVenc = new Date("2018-01-12T14:38:54.000Z");
      if (this.empresa.hasOwnProperty("_id")) {
        /* if(this.certificadoError() == true){
          this.configMsg(
            "Estamos com lentidão em nosso sistema! A equipe técnica já está atuando e informaremos a todos assim que estabilizar. Desculpe pelo transtorno!",
            { has: true},
            "danger",
            true
          );
        } */
        if (certDate == undefined) {
          this.configMsg("Empresa não possui certificado vinculado, impossibilitando baixa de documentos fiscais!", { has: true, url: "/configuracoes", msg: "Cadastrar agora ?" }, "danger", true);
        } else if (this.certVencido(certDate, today)) {
          this.configMsg("Certificado expirado, impossibilitando consultas.", { has: true, url: "/configuracoes", msg: "Atualizar agora ?" }, "danger", true);
        } else if (this.diffDays(certDate, today) <= 30) {
          var diasRestantes = this.diffDays(certDate, today);
          this.configMsg("Certificado est\xE1 pr\xF3ximo do vencimento(" + certDate.toLocaleDateString() + "),  " + diasRestantes + " dias restantes.", { has: true, url: "/configuracoes", msg: "Atualizar agora ?" }, "" + (diasRestantes <= 7 ? "danger" : "warning"), true);
        } else if (this.empresa["certNaoPertence"]) {
          this.configMsg("Identificamos que certificado digital n\xE3o pertence a est\xE1 empresa, impossibilitando baixa de documentos fiscais!", { has: true, url: "/configuracoes", msg: "Atualizar agora ?" }, "danger", true);
        }
      }
    }
  },
  methods: {
    handleRedirectAgendaOnline: function handleRedirectAgendaOnline() {
      this.dialog = true;
    },
    desativarNewFeature: function desativarNewFeature() {
      this.conta.newFeatures = false;
      this.mostrarNewFeatures = false;
    },
    desativarNewFeatureInfoSefaz: function desativarNewFeatureInfoSefaz() {
      this.conta.newFeatures = false;
      this.InformacaoSefaz = false;
    },
    hasCCM: function hasCCM() {
      if (!this.empresa.hasOwnProperty("ccm") && this.$router.currentRoute.path.indexOf("NFSe") != -1) {
        this.configMsg("Para consultar NFS-e - Emitida \xE9 necess\xE1rio cadastrar a Inscri\xE7\xE3o Municipal.", { has: true, url: "/configuracoes", msg: "Cadastrar agora ?" }, "warning", true);
      }
    },
    begin: function begin() {},
    reset: function reset() {
      this.config.show = false;
      this.config.msg = "";
      this.config.color = "";
      this.config.icon = "";
      this.config.link = { has: false, url: "", msg: "" };
    },
    diffDays: function diffDays(certDate, today) {
      var timeDiff = Math.abs(certDate.getTime() - today.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays;
    },
    certVencido: function certVencido(certDate, today) {
      if (certDate.getTime() > today.getTime()) {
        return false;
      }
      return true;
    },
    /* certificadoError: function(){
      return true;
    }, */
    configMsg: function configMsg(msg, link, color, show) {
      this.config.msg = msg;
      if (this.ownerEmp()) {
        this.config.link.has = link.has;
        this.config.link.url = link.url;
        this.config.link.msg = link.msg;
      }
      this.config.color = color;
      this.config.show = show;
    },
    ownerEmp: function ownerEmp() {
      var hasEmp = false;
      var empresa = this.empresa;
      if (this.conta.admin) {
        this.conta.admin.find(function (item) {
          for (var prop in item) {
            if (item[prop] == empresa._id) {
              hasEmp = true;
            }
          }
          return hasEmp;
        });
      }

      return hasEmp;
    }
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   data: function data() {
      return {
         showInfoCertificado: false
      };
   },
   props: ["dialog"],
   beforeMount: function beforeMount() {
      this.$root.$el.parentNode.appendChild(this.$root.$el);
   },

   watch: {
      dialog: function dialog(newV, oldV) {
         var _this = this;

         if (newV) {
            this.$mount();
         } else {
            setTimeout(function () {
               _this.showInfoCertificado = false;
               _this.$store.commit('addDialogWidthRC', 1000);
            }, 400);
         }
      }
   },
   methods: {
      handleShowRenovarCertificado: function handleShowRenovarCertificado() {
         this.$store.commit('addDialogWidthRC', 935);
         this.showInfoCertificado = true;
      }
   }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_notificacoes_NotificacoesService_js__ = __webpack_require__(143);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "empresa"],
  data: function data() {
    return {
      naoVistos: [],
      vistos: [],
      msg: "Selecione alguma empresa.",
      page: 2,
      loading: false
    };
  },

  watch: {
    "conta.notificacoes": function contaNotificacoes() {
      this.loading = false;
      if (this.conta) {
        this.msg = [];
        this.page = 2;
        if (this.conta.notificacoes) {
          if (this.conta.notificacoes.naoVistas) {
            this.naoVistos = this.conta.notificacoes.naoVistas;
          }
          if (this.conta.notificacoes.vistas) {
            this.vistos = this.conta.notificacoes.vistas;
          }
          if (this.conta.notificacoes == "Notificações desativadas para esta empresa") {
            this.msg = this.conta.notificacoes;
            this.naoVistos = [];
            this.vistos = [];
          }
        } else {
          this.naoVistos = [];
          this.vistos = [];
        }
      }
    },
    empresa: function empresa() {
      this.loading = false;
    }
  },
  methods: {
    gerarLinkZIP: function gerarLinkZIP(desc) {
      try {
        return ("/download/fechamentoMensal?_link=" + (desc ? desc.split(':')[1] : '')).replace(/\s/g, '');
      } catch (er) {
        console.log(er);
        return "";
      }
    },

    getNotificacoes: function getNotificacoes() {
      var _this = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_0__domain_notificacoes_NotificacoesService_js__["a" /* default */](this.$http);
      this.loading = true;
      this.service.getNotificacoesGeral(this.conta.id_usuario, this.empresa._id, this.page, 10).then(function (res) {
        if (res.ok) {
          _this.naoVistos = _this.naoVistos.concat(res.body.naoVistas);
          _this.vistos = _this.vistos.concat(res.body.vistas);
          if (res.body.naoVistas.length > 0 || res.body.vistas.length > 0) {
            _this.page++;
          } else {
            _this.msg = "Não há mais notificações no Motor Fiscal para esta empresa.";
          }
        }
      }).then(function () {
        _this.loading = false;
      });
    },
    setArray: function setArray(array) {
      if (array && array.length) {
        array.forEach(function (item, i) {
          if (item.tipo == "ultConsulta") {
            item.tipo = "Última consulta";
            item["icon"] = "check";
            item["iconClass"] = "green lighten-1 white--text";
          } else if (item.tipo == "notaCancelada") {
            item.tipo = "Nota cancelada";
            item["icon"] = "warning";
            item["iconClass"] = "warning lighten-1 white--text";
          } else if (item.tipo = "zipFechamento") {
            item["icon"] = "archive";
            item["iconClass"] = "green lighten-1 white--text";
          }
        });
        return array;
      }
    },
    marcarVisto: function marcarVisto(item, acao) {
      var _this2 = this;

      if (item) {
        var notifIds = [];
        if (acao == "parse") {
          notifIds.push(item._id);
        } else if (acao == "all") {
          item.forEach(function (notifi) {
            notifIds.push(notifi._id);
          });
        }

        this.loading = true;

        if (this.conta.id_usuario) {
          this.service = new __WEBPACK_IMPORTED_MODULE_0__domain_notificacoes_NotificacoesService_js__["a" /* default */](this.$http);
          this.service.attVisto(notifIds, this.conta.id_usuario).then(function (resp) {
            //mandar att as notificações
            if (resp.ok) {
              _this2.conta.getNotificacoes = true;
            }
          });
        }
      }
    }
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_util__);









var NotificacoesServices = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(NotificacoesServices, _CommonService);

    function NotificacoesServices(http) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NotificacoesServices);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotificacoesServices.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(NotificacoesServices)).call(this, http));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(NotificacoesServices, [{
        key: "getNotificacoesGeral",
        value: function getNotificacoesGeral(id_user, id_empr, page, size) {
            // ?_page=1&_pagesize=10
            var pagina = page || 1;
            var qntidade = size || 10;
            var url = "notificacoes/geral/user/" + id_user + "/emp/" + id_empr + "?_page=" + pagina + "&_pagesize=" + qntidade;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "attVisto",
        value: function attVisto(idNotificacao, idUsuario) {
            var url = "notificacoes/geral";
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ usuario: idUsuario, notificacoes: idNotificacao });

            return this._resource.post(url, body).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }]);

    return NotificacoesServices;
}(__WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NotificacoesServices);

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ico2.a05573c.png";

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAC+lBMVEUZdtLy17xdNgswNTgVGh6rq6vevp7///8jNUNBXnUWGx8adM4vNDflyKonLC8kKS0YHSHw1rupqakaHyNgOA0bcskfb77v07gtMjYcISW1vMEqZ6I1XIBLRz9ORDYqLzJTPyf8/Pwcd9IfeNAeccQbbsHbvZ4yNzoiJytYOxrj5efX19cmfNFclMvDw8Pk0b7s1b3rz7TpzrIma64naKcsZZwsYpfKq4w4Wno3WHZnaWs5SFYgJSkeIydVPiJvSSBnQBZkPhP4+Pjy8vIxgdBvncmsuMO8v8Eda7i0tbUkbLTnzLAoaarhxagfZKjiw6SgoqPfwKKen5+bm5vUt5qWmJmRlJYwYI7Epoa+n3+3l3U9VGmrimhCUVyZdlJGSk1JSUWMaUM5PkE1PEGAXDUsMTRPQzNsRh1aORTu7/Dn5+fe4OHS09RLjc0bdMsac8vBxsp3oMmKqMcdcsbOx8DYzL/o0r26u7uVn6alpaXgwqQgYaGLlJvQtZkiXpfQspPNr5CJi42ZkoyHiYydlIslWIqDhohveYBlc31GYXayknA+UmOlhGAqRV4zRVdTVFRJTVCUckyHYz1MRjyDXzdRQS1ZOhdiPBHY2tzMz9ErftA4hM9CiM5VkcxnmcrJycmCpcigssTIw78jb7uss7hbh7KxsbGwsLAeZ7C3ppQxZJMjW5OOj5CzoY/LrY6imI25o4yBh4w4Y4vGqIhzf4h/g4UzXIR6fH0lUn1jbnZQYm87Vm08VWs5UmlMW2ZcX2FAUWB6bF1DTlY/S1UpOkgwNzsbKDN9WDB2USj09PTs7Ow/h85Rj8xjl8ovfcmUrcaZr8U2eLl+mrbrz7Jrj7Kiqa80ca3myaudpauaoql3kaldhKmjpqiHmKjKspk3aZnFrZW8p5QnXpSZlpOAi5PAqZF7ho5pe4kXUIgtWoaDg4NQaX0cTX1YaHUzVXQxUnCKe2tfY2VVWFovQ1ZOUlUtP0ySb0kuPEg+QkYWKj0tLCp0TyYkIh8NERQ7fFbyAAAG2UlEQVR42uzWvUtbYRQG8PM868UhkBioSbi0QQh0iZqoS0ygLkYHQciHGiNIkqVC261QdFah+L0XunRwEVx0KC76F3Xp0psQaxLzcW/uidP9TXc7z3vueXmPeDwej8fj8XhcS9xXYqxUyuu/xuXVGMszIUsyKkaYz1JzhryC5btTPgmX2cackBGbOUyxn9qMKJswWr7vUhwkFhVdt5HctMjucm5uK0Y77rV7TssFHdC+DGU6NC+6oiadCYuy8TAdiYm6RLlGBwIyAuu075wXlZAhqkJ0KrIreoxNOhdWnMIIh5HQOv5cjUM51Sl/Y3JY4+57n9yMcXg3Li+eSZcOxRUjTEf0hyAQoTumuBTYYtNwUWriWs6kxUweso9MqbCW32YXomA6lFsSifQpf5RF3ezJX3b6Ilpi7OXsK/7z7R/7RxMgyh78Gz60mXwcSYAlvrRAsvoNneKtw2DoLaad/MU0+biCl3wtCURLgh0u99bIsyy6maqy6UK0THSe/woF/gmiu2s2pUTLdEf9PFAsoaedp9VMtATYZgNAIYiervV3ovOW0ecJLHH05quyYUt9J86sLpDpLAY5YsNv0Z7CDRyTRQw0y4Z57QCXWRxwB4PFL1mXFDVLbP78PK9gwwProiK6j8EBsL8DO0q0RERRipZ9YG8WdhzQciuKvtMyBkzCljwtP0XN2zcFkn4AQdiyRvIBi6LlI4JpMg3bVkgW8UO0fAKOyCpsmyIzcfjeiZLPwJifC7AtTpYAvFcMgGMnAUD/KoAPomQRwEomDfu4Dc0O/CvGPkKjCKM4gL/hfbPf7hrddde2eliSoBE7ij25GDVGJLHFkyIkeLAX7BW7HiwHD/beCxYUC9iwgL333ntXLCj4zZuZzbrO6Ex2Rn+HQEjg/+Z9b9637AlJ6FrOTgHjxI+64JjByiU754r1IaSF2RocM5DerZHWC6CFuQgcU2uoZAvtq8Fp4JxBkn21wUG16kp25YCjBko21W0JjkqvI9mzGBw2P0eyoXVtcN5SyboF4IKWZa0PQBq4obJk1TJwRW3Jqr7girQhkjWVwSWtJEvKLgSXpA/5jxNAFksWDG0J7jkj/V0rcFFazt+XILhq/t/GYHAtcNfCen/egQvAbaekP6jXF9y39A/5teFfOPuf8yGttUn+IvhH0pcbLqCT8M+cv2BwA9xoUKE8uK3figYN12/zbfaUTvyqouLIaT5hW5W2pcA9q0a/8CnWeTwJJdTv4NnhI0+Gp4Nb0m/KoanTRcgYD8nPL03y8zuI3yb5hD0FsnwR3HJdFgpe+aZ7jKzz+aZPDYn/CJ0Gd5wLyWTKNI+Rzr7dHWVyy51hfJq1UVaNmFTNoIC7yp/JzqNVwXkv/SzSSdZ02pQYX21CSNYURNhXx3uQd9jPGCvTXtZNoEGM2UTdV0UZY0fzwEmjZmKQKQpDsm7EZk/M7Qdysf1MEfgwtpRj8c0RMZOR2XKxTve07k+isjQFfqbogVg0uZRT8UIlPyP75TgTPMIj6r4uFGWKCCpmroVktVHiSRZT7ZSLPW8sCjgox2vGSBlUTYbktCtCXQ+minSJSzsoDuC7HCc3zBRB1L2GZNzJwGIRpsIRsXZ3/7Zly9sfE+WYmrMYCWDM3iQG4TLl66JM8z42hV5yWNas6TWMEX8lLNYUSmpFIf4izDT6I2/1qrTtMCz7mHZOmRivEZRM/0P4qzJME66zmhJ3e1XqVNRJ5VOYKorxikq4mJtgoiDTzM4eRh2IL6Am573DWoFIkjyENhmYKMB07VOXiMwl3Sh/j3L8NTjnzZj+Dv4qo0QteIO/SYkGMsN+mvKevKZ46MpUQOVcOTdb5PdRHj4rEK2EiZ6BfVUz0EQZ5STGc95rdQ2+T+QfSq0jjp8akJWChpqDfZPN4iNql1twnt2CDxAFXOPHuaKGKCwYMC6hBGcw0/zpSS4nooCVXLWDCSYlbLB/AibPz3TvKLSFKGA0V6HBEtLtBbs2oLEI04R7cqGnKGAaJzWZqjoaKAK7ZqCxHv7Ym0jnLgroxsl4rQHGQ9AG7Cl/BE1kxpYRF+Z6hVSu+GjWADIW7MlDM/TBhPQWqfO8Qm+ahmDCBCS3DHehqepM00XEDqBFxIUc/RpyZhPMQFMpegu+iFhahcO5MNG0ASSjP9hyBC20YC7nK73Cdi7MYoosNLPW3kWEaKEFYh1f8gr7RH5qRLuHzdwHO8YiWmhBIefDvcInuogUYTTVxOYMWmpBHz7aqxBXcUftHjZ1IIkZNP1cMIU/pAIGaB8FgiloqhDs+IyWWoB8OxVwlfMUbQmZqwDW9Ue01oJ5U6mAx7yX/g6aywNDPwEv3FGOdVlCjQAAAABJRU5ErkJggg=="

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu_Menu_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dataTable_RenderTableNFe_vue__ = __webpack_require__(46);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    mainMenu: __WEBPACK_IMPORTED_MODULE_0__components_menu_Menu_vue__["a" /* default */],
    RenderTableNFe: __WEBPACK_IMPORTED_MODULE_1__components_dataTable_RenderTableNFe_vue__["default"]
  },
  props: ["conta", "empresa", "alert", 'IBGE'],
  data: function data() {
    return {
      select: "",
      route: this.$router.history.current.path,
      tabs: [{
        title: "Recebidas"
      }, {
        title: "Enviadas"
      }]
    };
  },

  updated: function updated() {
    this.$nextTick(function () {});
  },

  computed: {
    getSelect: function getSelect() {}
  },
  methods: {
    getNewEmp: function getNewEmp($event) {
      this.$emit("getNewEmp", $event);
    }
  },

  beforeMount: function beforeMount() {
    this.$nextTick(function () {});
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commonTable_CommonTable_vue__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_cte_CteService__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_notas_nfse_NfseService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_dataTable_component_Component_js__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_loggedArea_docsFederal_DocsFederal__ = __webpack_require__(252);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["empresa", "table", "sendAttTable", "conta", "alert", "arrayItems", "attTableEmp", "IBGE"],
  components: {
    CommonTable: __WEBPACK_IMPORTED_MODULE_0__commonTable_CommonTable_vue__["a" /* default */],
    DocsFederal: __WEBPACK_IMPORTED_MODULE_6__pages_loggedArea_docsFederal_DocsFederal__["a" /* default */]
  },
  data: function data() {
    return {
      component: { name: "", noDataText: "" },
      logConsulta: "",
      logQtd: 1,
      route: this.$router.history.current.path,
      currentItem: 0,
      currentItemProduto: 0,
      currentItemIptu: 0,
      currentItemNFSE: 0,
      currentItemCTE: 0,
      currentItemDF: 0,
      currentItemDM: 0,
      select: {},
      attTable: false,
      attTableCert: false,
      tabs: [{
        title: "Recebidas"
      }, {
        title: "Emitidas"
      }, {
        title: "Transportadas"
      }],
      tabsProduto: [{
        title: "Entrada"
      }, {
        title: "Saída"
      }],
      tabsIptu: [{
        title: "Iptu"
      }],
      tabsNFSE: [{
        title: "Recebidas"
      }, {
        title: "Emitidas"
      }],
      tabsCTE: [{
        title: "Tomados"
      }, {
        title: "Todos"
      }],
      tabsDocsFederal: [{
        title: "Situação Fiscal"
      }, {
        title: "Extrato DCTF"
      }, {
        title: "Relação de Darfs Pagos"
      }, {
        title: "E-mails Caixa Postal"
      }, {
        title: "Processos"
      }, {
        title: "CND"
      }],
      tabsDocsMunicipal: [
        // {
        //   title: "Relação de NFs"
        // },
        // {
        //   title: "Guias"
        // },
        // {
        //   title: "CND"
        // },
        // {
        //   title: "IPTU"
        // },
      ]
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.setComponent();
    });
  },
  attTableEmp: function attTableEmp(value) {
    if (this.component.name == "certificado") {
      this.attTable = value.ok;
    } else {
      this.$emit("attTableEmp", value);
    }
  },

  watch: {
    "conta.getLog": function contaGetLog(newV, oldV) {
      if (this.conta.getLog) {
        this.logConsulta = "";
        this.logQtd = 1;
        var auxThis = this;
        setTimeout(auxThis.consultaLog(), 2000);
        this.conta.getLog = false;
      }
    },
    sendAttTable: function sendAttTable(newV, oldV) {
      this.attTable = newV;
    },
    $route: function $route() {
      this.currentItem = 0;
      this.currentItemNFSE = 0;
      this.currentItemCTE = 0;
      this.currentItemProduto = 0;
      this.currentItemIptu = 0;
      this.setComponent();
    },
    currentItem: function currentItem() {
      if (this.component.name == "NFeRecebidas") {
        var posTabActive = this.currentItem;
        switch (posTabActive) {
          case 0:
            this.component["tipo"] = "recebida";
            this.component.text = "Nota Fiscal Eletrônica - Recebidas";
            this.component.enable.consultaSefaz = true;
            this.consultaLog();
            break;
          case 1:
            this.component["tipo"] = "emitida";
            this.component.text = "Nota Fiscal Eletrônica - Emitidas";
            this.component.enable.consultaSefaz = false;
            break;
          case 2:
            this.component["tipo"] = "transportados";
            this.component.text = "Nota Fiscal Eletrônica - Transportadas";
            this.component.enable.consultaSefaz = false;
            break;
        }
      }
    },
    currentItemProduto: function currentItemProduto() {
      if (this.component.name == "currentItemProduto") {
        var posTabActive = this.currentItemProduto;
        switch (posTabActive) {
          case 0:
            this.component.text = "Produto - Entrada";
            this.component["tipo"] = "recebida";
            break;
          case 1:
            this.component.text = "Produto - Saída";
            this.component["tipo"] = "emitida";

            break;
        }
      }
    },
    currentItemIptu: function currentItemIptu() {
      if (this.component.name == "currentItemIptu") {
        var posTabActive = this.currentItemIptu;
        switch (posTabActive) {
          case 0:
            this.component.text = "Iptu";
            this.component["tipo"] = "recebida";
            break;
          case 1:
            this.component.text = "Iptu - Saída";
            this.component["tipo"] = "emitida";

            break;
        }
      }
    },
    currentItemNFSE: function currentItemNFSE() {
      if (this.component.name == "NFSE") {
        var posTabActive = this.currentItemNFSE;
        switch (posTabActive) {
          case 0:
            this.component.text = "Nota Fiscal de Serviço Eletrônica - Recebidas";
            this.component["tipo"] = "recebida";
            this.consultaLog();
            break;
          case 1:
            this.component.text = "Nota Fiscal de Serviço Eletrônica - Emitidas";
            this.component["tipo"] = "emitida";
            this.consultaLog();
            break;
        }
      }
    },

    currentItemCTE: function currentItemCTE() {
      if (this.component.name === "CTE") {
        var posTabActive = this.currentItemCTE;
        switch (posTabActive) {
          case 0:
            this.component.text = "Conhecimento de Transporte Eletrônico - Tomados";
            this.component["tipo"] = "tomados";
            this.consultaLog();
            break;
          case 1:
            this.component.text = "Conhecimento de Transporte Eletrônico - Todos";
            this.component["tipo"] = "todos";
            this.consultaLog();
            break;
        }
      }
    },
    currentItemDF: function currentItemDF() {
      if (this.component.name === "docsFederal") {
        var posTabActive = this.currentItemDF;
        switch (posTabActive) {
          case 0:
            this.component.text = "Situação Fiscal";
            this.component["tipo"] = "situacao_fiscal";
            break;
          case 1:
            this.component.text = "Extrato DCTF";
            this.component["tipo"] = "extrato_dctf";
            break;
          case 2:
            this.component.text = "Relação de Darfs Pagos";
            this.component["tipo"] = "relação_de_darfs_pagos";
            break;
          case 3:
            this.component.text = "E-mails Caixa Postal";
            this.component["tipo"] = "emails_caixa_postal";
            break;
          case 4:
            this.component.text = "Processos";
            this.component["tipo"] = "processos";
            break;
          case 5:
            this.component.text = "CND";
            this.component["tipo"] = "cnd";
            break;
        }
      }
    },
    currentItemDM: function currentItemDM() {
      if (this.component.name === "docsMunicipal") {
        var posTabActive = this.currentItemDM;
        switch (posTabActive) {
          case 0:
            this.component.text = "Relação de NFs";
            this.component["tipo"] = "relação_de_nfs";
            break;
          case 1:
            this.component.text = "Guias";
            this.component["tipo"] = "guias";
            break;
          case 2:
            this.component.text = "CND";
            this.component["tipo"] = "cnd";
            break;
          case 3:
            this.component.text = "IPTU";
            this.component["tipo"] = "iptu";
            break;
        }
      }
    },
    empresa: function empresa(newV, oldV) {
      //verifica se a empresa mudou para buscar um novo log
      if (newV.cnpj != oldV.cnpj) {
        this.conta.getLog = true;
      }
      this.currentProperties;
    }
  },
  computed: {
    getSelect: function getSelect() {},
    currentProperties: function currentProperties() {
      var obj = {};
      obj["empresa"] = this.empresa;
      return obj;
    }
  },
  methods: {
    consultaLog: function consultaLog() {
      var _this = this;

      if (this.empresa) {
        this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_dataTable_commonService_CommonService_js__["a" /* default */](this.$http);
        try {
          this.service.getLogConsulta(this.empresa._id, this.component.name, this.component.tipo).then(function (res) {
            if (res) {
              _this.logConsulta = res.log;
              _this.logQtd = res.qtd;
            } else {
              _this.logConsulta = "";
              _this.logQtd = undefined;
            }
          });
        } catch (e) {
          console.log("NÃO FOI POSSIVEL BUSCAR log");
          console.log(e);
        }
      }
    },

    emitAttTable: function emitAttTable(value) {
      this.attTable = value;
      this.$emit("attSendTable", value);
    },
    setComponent: function setComponent() {
      var name = "",
          text = "",
          abrev = "",
          enable = {
        filtrar: true,
        rangeDate: true,
        selectAll: true,
        consultaSefaz: true,
        colunas: true,
        expExcel: true,
        search: true,
        arrowMovTable: true,
        acoes: true,
        verPdf: true,
        downPdf: false,
        downXML: true,
        envEmail: true,
        download: false
      },
          textPlural = "",
          tipo = void 0;
      if (this.$router.history.current.path == "/consultaCTe") {
        if (!this.currentItemCTE || this.currentItemCTE === 0) {
          name = "CTE";
          text = "Conhecimento de Transporte Eletrônico - Tomados";
          tipo = "tomados";
        } else {
          name = "CTE";
          text = "Conhecimento de Transporte Eletrônico - Todos";
          tipo = "todos";
        }
        this.getNewEmp(this.empresa);
        abrev = "CT-e";
        textPlural = "CT-e";
        enable.download = true;
        enable.downPdf = true;
      } else if (this.$router.history.current.path == "/consultaNFe") {
        if (this.currentItem == 0) {
          name = "NFeRecebidas";
          tipo = "recebida";
          text = "Nota Fiscal Eletrônica - Recebidas";
        } else if (this.currentItem == 1) {
          name = "NFeRecebidas";
          tipo = "emitida";
          text = "Nota Fiscal Eletrônica - Emitidas";
          enable.consultaSefaz = false;
        } else {
          name = "NFeRecebidas";
          tipo = "transportados";
          text = "Nota Fiscal Eletrônica - Transportadas";
          enable.consultaSefaz = false;
        }
        this.getNewEmp(this.empresa);
        enable.download = true;
        enable.downPdf = true;
        abrev = "NF-e";
        textPlural = "NF-e";
      } else if (this.$router.history.current.path == "/consultaNFSe") {
        if (this.currentItemNFSE == 0) {
          name = "NFSE";
          tipo = "recebida";
          text = "Nota Fiscal de Serviço Eletrônica - Recebidas";
        } else {
          name = "NFSE";
          tipo = "emitida";
          text = "Nota Fiscal de Serviço Eletrônica - Emitidas";
        }
        this.getNewEmp(this.empresa);
        enable.filtrar = true;
        enable.download = true;
        abrev = "NFS-e";
        enable.selectAll = true;
        enable.verPdf = true;
        enable.downPdf = true;
        textPlural = "NFS-e";
      } else if (this.$router.history.current.path == "/fornecedores") {
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "fornecedores";
        text = "Fornecedor";
        abrev = text;
        textPlural = "Fornecedores";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
      } else if (this.$router.history.current.path == "/clientes") {
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "clientes";
        text = "Cliente";
        abrev = text;
        textPlural = "Clientes";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
      } else if (this.$router.history.current.path == "/produtos") {
        if (this.currentItemProduto && this.currentItemProduto == 1) {
          tipo = "emitida";
          text = "Produto - Saída";
        } else {
          tipo = "recebida";
          text = "Produto - Entrada";
        }
        this.getNewEmp(this.empresa);
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "produtos";
        abrev = text;
        textPlural = "Produtos";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.acoes = false;
      } else if (this.$router.history.current.path == "/consultaIptu") {

        tipo = "Iptu";
        text = "Iptu";

        this.getNewEmp(this.empresa);
        enable.selectAll = false;
        enable.download = false;
        enable.downIptu = true;
        enable.verPdf = true;
        enable.downXML = false;
        enable.envEmail = false;
        name = "Iptu";
        abrev = text;
        textPlural = "Iptu's";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.acoes = true;
      } else if (this.$router.history.current.path == "/configuracoes" && this.table == "empresa") {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "empresa";
        text = "Empresa";
        abrev = text;
        textPlural = "Empresas";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = false;
      } else if (this.$router.history.current.path == "/configuracoes" && this.table == "usuario") {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "usuario";
        text = "Colaborador";
        abrev = text;
        textPlural = "Colaboradores";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = false;
      } else if (this.$router.history.current.path == "/configuracoes" && this.table == "certificado") {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "certificado";
        text = "Certificado";
        abrev = text;
        textPlural = "Certificados";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = false;
        enable.acoes = true;
      } else if (this.$router.history.current.path == "/configuracoesAutomacao") {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "automacaoFiscal";
        text = "Imóveis";
        abrev = text;
        textPlural = "Imóveis";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = false;
        enable.acoes = true;
      } else if (this.$router.history.current.path == "/relatorio" && this.table == "conta") {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "conta";
        text = "Conta";
        abrev = text;
        textPlural = "Contas";
        enable.filtrar = true;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = true;
        enable.acoes = false;
      } else if (this.$router.history.current.path == "/relatorio" && this.table == "rela_usuario") {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "rela_usuario";
        text = "Usuário";
        abrev = text;
        textPlural = "Usuários";
        enable.filtrar = true;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = true;
        enable.acoes = false;
      } else if (this.$router.history.current.path == "/docsFederal") {
        name = 'docsFederal';
        if (this.currentItemDF == 0) {
          tipo = "situacao_fiscal";
          text = "Situação Fiscal";
        } else if (this.currentItemDF == 1) {
          tipo = "gnd";
          text = "GND";
        } else {
          tipo = "dctf";
          text = "DCTF";
        }
        this.getNewEmp(this.empresa);
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        abrev = text;
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.acoes = false;
      } else if (this.$router.history.current.path == "/docsMunicipal") {
        name = 'docsMunicipal';
        if (this.currentItemDM == 0) {
          tipo = "iptu";
          text = "IPTU";
        } else if (this.currentItemDF == 1) {
          tipo = "gnd";
          text = "GND";
        } else {
          tipo = "dctf";
          text = "DCTF";
        }
        this.getNewEmp(this.empresa);
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        abrev = text;
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.acoes = false;
      }
      this.getNewEmp(this.empresa);
      this.component = new __WEBPACK_IMPORTED_MODULE_5__domain_dataTable_component_Component_js__["a" /* default */](name, text, abrev, enable, textPlural, tipo);
      if (this.component.enable.consultaSefaz) {
        this.conta.getLog = true;
      }
    },
    attLogConsulta: function attLogConsulta($event) {
      this.logConsulta = $event;
    },

    getNewEmp: function getNewEmp($event) {
      //onde event é a empresa atual
      this.$emit("getNewEmp", $event);
    },
    emitEditEmp: function emitEditEmp($event) {
      this.$emit("emitEditEmp", $event);
    }
  },

  beforeMount: function beforeMount() {
    this.$nextTick(function () {});
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_notas_nfe_Nfe_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_notas_cte_CteService__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_notas_nfse_NfseService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_clientes_ClientesService__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_conta_empresa_EmpresaService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__domain_conta_empresa_certificado_CertificadoService__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__domain_produtos_ProdutosService__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__domain_fornecedores_FornecedoresService__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__domain_conta_ContaService_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__domain_automacaoFiscal_iptu_IptuService__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__domain_dataTable_Table__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__domain_dataTable_TableNfe__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__domain_dataTable_TableNfseEmitida__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__domain_dataTable_TableNfse__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__domain_dataTable_TableCte__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__domain_dataTable_TableClientes__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__domain_dataTable_TableFornecedores__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__domain_dataTable_TableProdutos__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__domain_dataTable_TableProdutosEmitida__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__domain_dataTable_TableCertificados__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__domain_dataTable_TableEmpresas__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__domain_dataTable_TableUsuarios__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__domain_dataTable_TableContas_js__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__domain_dataTable_TableRelaUsuarios__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__domain_dataTable_TableIptu__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_dataTable_commonTable_coluna_listEmprConta_Coluna_listEmprConta_vue__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_dataTable_commonTable_coluna_logins_Coluna_Logins_vue__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__coluna_actions_ColumnActions_vue__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__actionsHeader_ActionsHeader__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__actionsHeader_btnDias_BtnDias_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__actionsHeader_btnFiltrar_BtnFiltrar_vue__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__actionsHeader_btnFiltrar_panelFiltro_PanelFiltro_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__coluna_vinculo_Coluna_Vinculo_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__coluna_manifesto_btn_ColunaManifestoBtn_vue__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__coluna_vencimento_Coluna_vencimento_vue__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__coluna_produtos_Coluna_produtos_vue__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__coluna_lote_Coluna_lote_vue__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__coluna_simples_Coluna_simples_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__coluna_tributacao_Coluna_tributacao_vue__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__coluna_lei116_Coluna_lei_vue__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__coluna_infAd_Coluna_infAd_vue__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__actionsHeader_btnMoverTable_BtnMoverTable_vue__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__domain_planos_planos_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__snackBar_SnackBar_vue__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_timers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_timers__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















































/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    columnActions: __WEBPACK_IMPORTED_MODULE_34__coluna_actions_ColumnActions_vue__["a" /* default */],
    actionsHeader: __WEBPACK_IMPORTED_MODULE_35__actionsHeader_ActionsHeader__["a" /* default */],
    colunaVinculo: __WEBPACK_IMPORTED_MODULE_39__coluna_vinculo_Coluna_Vinculo_vue__["a" /* default */],
    colunaVencimento: __WEBPACK_IMPORTED_MODULE_41__coluna_vencimento_Coluna_vencimento_vue__["a" /* default */],
    colunaLogins: __WEBPACK_IMPORTED_MODULE_33__components_dataTable_commonTable_coluna_logins_Coluna_Logins_vue__["a" /* default */],
    colunaLote: __WEBPACK_IMPORTED_MODULE_43__coluna_lote_Coluna_lote_vue__["a" /* default */],
    colunaSimples: __WEBPACK_IMPORTED_MODULE_44__coluna_simples_Coluna_simples_vue__["a" /* default */],
    colunatributacao: __WEBPACK_IMPORTED_MODULE_45__coluna_tributacao_Coluna_tributacao_vue__["a" /* default */],
    colunalei: __WEBPACK_IMPORTED_MODULE_46__coluna_lei116_Coluna_lei_vue__["a" /* default */],
    colunaInfAd: __WEBPACK_IMPORTED_MODULE_47__coluna_infAd_Coluna_infAd_vue__["a" /* default */],
    btnDias: __WEBPACK_IMPORTED_MODULE_36__actionsHeader_btnDias_BtnDias_vue__["a" /* default */],
    btnFiltrar: __WEBPACK_IMPORTED_MODULE_37__actionsHeader_btnFiltrar_BtnFiltrar_vue__["a" /* default */],
    panelFiltro: __WEBPACK_IMPORTED_MODULE_38__actionsHeader_btnFiltrar_panelFiltro_PanelFiltro_vue__["a" /* default */],
    btnMoverTable: __WEBPACK_IMPORTED_MODULE_48__actionsHeader_btnMoverTable_BtnMoverTable_vue__["a" /* default */],
    SnackComp: __WEBPACK_IMPORTED_MODULE_51__snackBar_SnackBar_vue__["a" /* default */],
    colunaListEmprConta: __WEBPACK_IMPORTED_MODULE_32__components_dataTable_commonTable_coluna_listEmprConta_Coluna_listEmprConta_vue__["a" /* default */],
    colunaManifestoBtn: __WEBPACK_IMPORTED_MODULE_40__coluna_manifesto_btn_ColunaManifestoBtn_vue__["a" /* default */],
    colunaProdutos: __WEBPACK_IMPORTED_MODULE_42__coluna_produtos_Coluna_produtos_vue__["a" /* default */]
  },
  props: ["conta", "empresa", "alert", "component", "logConsulta", "attTable", "arrayItems", "logQtd", "IBGE"],
  data: function data() {
    return {
      failureDialog: false,
      infoDialog: false,
      errors: "",
      infos: "",
      nextPage: "",
      table: new __WEBPACK_IMPORTED_MODULE_18__domain_dataTable_TableNfe__["a" /* default */](),
      filtro: false,
      headersAtualizado: false,
      filtroForSearch: { text: "Tudo", value: "tudo" },
      snack: false,
      snackColor: "",
      snackText: "",
      aux_pages: 1,
      search: "",
      dialog: false,
      range: "mesAtual",
      remove_headers: false,
      nomeUF: "",
      pagination: {},
      selected: [],
      arrayUF: []
    };
  },

  updated: function updated() {
    this.$nextTick(function () {
      //organiza o texto do botão remover
      var btn = document.querySelector("#btn_clsFiltros");
      if (btn != undefined) {
        btn.firstElementChild.style.width = "unset";
      }
      this.setValorTotal;
      this.setTotalizaValoresConta;

      if (!this.headersAtualizado) {
        this.getEmpresa;
      }
    });
  },
  created: function created() {},
  mounted: function mounted() {
    this.$nextTick(function () {
      this.handleService();
    });
  },
  watch: {
    updateTable: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(newV, oldV) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (newV) {
                  this.handleService();
                  // this.service = new NfseService(this.$http);
                  // this.getItems("getNfseEmitidas", 2);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateTable(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return updateTable;
    }(),
    search: function search() {
      this.table.selected = [];
      this.selected = [];
    },
    attTable: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(newV, oldV) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!newV) {
                  _context2.next = 6;
                  break;
                }

                this.table.resetTable(this.empresa, this.component);
                this.table.pagination.page = 1;
                _context2.next = 5;
                return this.getDadosApi();

              case 5:
                this.$emit("emitAttTable", false);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function attTable(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return attTable;
    }(),
    empresa: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(newVal, oldVal) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (newVal._id != oldVal._id) {
                  this.filtro = false;
                  this.range = "mesAtual";
                  this.table.resetTable(this.empresa, this.component);
                  this.table.pagination.page = 1;
                  this.getDadosApi();
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function empresa(_x5, _x6) {
        return _ref3.apply(this, arguments);
      }

      return empresa;
    }(),
    "table.sendAtt": function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(newV, oldV) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!newV) {
                  _context4.next = 6;
                  break;
                }

                // this.table.resetTable();
                this.table.pagination.page = 1;
                console.log("table send");
                _context4.next = 5;
                return this.getDadosApi();

              case 5:
                this.table.sendAtt = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function tableSendAtt(_x7, _x8) {
        return _ref4.apply(this, arguments);
      }

      return tableSendAtt;
    }(),
    "pagination.rowsPerPage": function paginationRowsPerPage(newVal, oldVal) {
      if (newVal) {
        this.loading = true;
        this.table.pagination = this.pagination;
        // this.table.pagination.rowsPerPage = newVal;
        if (this.table.arrayNotas.length > 0) {
          if (this.table.pagination.rowsPerPage == "Todas") {
            this.table.pagination.rowsPerPage = this.table.array_todas_notas.length;
          }
          this.table.tradeNotaArray(this.table.pagination.rowsPerPage, this.table.arrayNotas.length);

          this.table.setPages(this.table.array_todas_notas.length, this.table.pagination.rowsPerPage);

          if (newVal > oldVal) {
            //necessario pois sempre que muda a quantidade de itens exibidos na tabela os headers voltam a aparecer
            this.remove_headers = true;
            this.removeHeaders;
          }
        }
        this.loading = false;
      }
    },
    "pagination.page": function paginationPage(newVal, oldVal) {
      this.table.pagina_atual = newVal;
      if (this.table.pagina_atual != 1 && this.table.arrayNotas.length < this.table.qnt_total_notas) {
        var qntdade_notas = this.table.pagination.rowsPerPage * this.table.pagina_atual;
        this.table.tradeNotaArray(qntdade_notas, this.table.arrayNotas.length);
      }
    },
    range: function range() {
      this.resetState();
      this.table.selected = [];
      this.selected = [];
      // this.table.qnt_total_paginas = 1;

      var component = this.component.name;

      this.table.rangeButtons.forEach(function (item) {
        var aux_btn = document.querySelector(".btn_" + item.value + "_" + component);
        aux_btn.classList.add("v-btn--outline");
        aux_btn.classList.add("teal--text");
        if (item && item.value == "tudo") {
          var iconFiltrar = document.querySelector(".btn_" + item.value + "_" + component + " .iconFiltrarRangedButtons");
          if (iconFiltrar) {
            iconFiltrar.classList.remove("white--text");
            iconFiltrar.classList.add("teal--text");
          }
        }
        aux_btn.classList.remove("teal");
        aux_btn.classList.remove("white--text");
      });

      if (this.range == "tudo") {
        var iconFiltrar = document.querySelector(".btn_" + this.range + "_" + component + " .iconFiltrarRangedButtons");
        if (iconFiltrar) {
          iconFiltrar.classList.remove("teal--text");
          iconFiltrar.classList.add("white--text");
        }
      }

      var btn = document.querySelector(".btn_" + this.range + "_" + component);
      btn.classList.remove("v-btn--outline");
      btn.classList.remove("bg_white");
      btn.classList.remove("teal--text");
      btn.classList.add("teal");
      btn.classList.add("white--text");

      if (this.range == "tudo" && !this.table.urlFiltros) {
        return;
      } else if (this.range != "tudo" && this.table.urlFiltros) {
        this.table.resetFiltro();
        this.table.filtros.fechar = true;
        this.getFiltro();
      }

      this.getDadosApi();
    }
  },
  computed: {
    updateTable: function updateTable() {
      return this.$store.getters.updateTable;
    },
    tableNfeRecebidas: function tableNfeRecebidas() {
      return this.$store.getters.tableNfeRecebidas;
    },
    tableNfeEmitidas: function tableNfeEmitidas() {
      return this.$store.getters.tableNfeEmitidas;
    },
    tableNfeTransportados: function tableNfeTransportados() {
      return this.$store.getters.tableNfeTransportados;
    },
    tableCteTodos: function tableCteTodos() {
      return this.$store.getters.tableCteTodos;
    },
    tableCteTomados: function tableCteTomados() {
      return this.$store.getters.tableCteTomados;
    },
    tableNfseRecebidas: function tableNfseRecebidas() {
      return this.$store.getters.tableNfseRecebidas;
    },
    tableNfseEmitidas: function tableNfseEmitidas() {
      return this.$store.getters.tableNfseEmitidas;
    },
    tableClientes: function tableClientes() {
      return this.$store.getters.tableClientes;
    },
    tableFornecedores: function tableFornecedores() {
      return this.$store.getters.tableFornecedores;
    },
    tableProdutos: function tableProdutos() {
      return this.$store.getters.tableProdutos;
    },
    tableProdutosEmitidas: function tableProdutosEmitidas() {
      return this.$store.getters.tableProdutosEmitidas;
    },
    tableEmpresas: function tableEmpresas() {
      return this.$store.getters.tableEmpresas;
    },
    tableCertificados: function tableCertificados() {
      return this.$store.getters.tableCertificados;
    },
    getEmpresa: function getEmpresa() {
      this.headersAtualizado = true;
    },

    setAttrFirstLine: function setAttrFirstLine() {
      //ao gerar a tabela o  não cria um atributo na 1º linha da tabela, impedindo assim o funcionamento correto das informações
      var table = document.querySelector(".table_" + this.component.name);
      var tableAttr = table.getAttributeNames();
      var pos = null;

      tableAttr.forEach(function (item, i) {
        item.indexOf("data") != -1 ? pos = i : "";
      });
      if (pos != null) {
        var getAttr = tableAttr[pos];
        var frstLineTable = document.querySelector(".table_" + this.component.name + " tbody").firstElementChild;
        frstLineTable.setAttribute(getAttr, "");
        frstLineTable.firstElementChild.setAttribute(getAttr, "");
      }
    },
    setValorTotal: function setValorTotal() {
      var vlrTotal = 0;
      var propSomar = "valor";
      if (this.component.name == "NFSE") {
        propSomar = "vlrServico";
      }
      if (this.table.dadosFiltrados && this.table.arraySearch.length > 0) {
        for (var i = this.table.posExbPrimNota; i < this.table.posExbUltmaNota; i++) {
          vlrTotal += this.table.arraySearch[i][propSomar];
        }
      } else if (this.table.arrayNotas.length > 0) {
        for (var i = this.table.posExbPrimNota; i < this.table.posExbUltmaNota; i++) {
          vlrTotal += this.table.arrayNotas[i][propSomar];
        }
      }
      this.table.valor_total_notas = vlrTotal;
    },
    setTotalizaValoresConta: function setTotalizaValoresConta() {
      if (this.component.name == "conta") {
        var total_empr = 0;
        // var total_nfe = 0;
        // var total_nfse = 0;
        // var total_cte = 0;
        var total_colabs = 0;
        var propEmpr = "rela_totalEmp";
        // let propNfe = "rela_totalNfe";
        // let propNfse = "rela_totalNfse";
        // let propCte = "rela_totalCte";
        var propColab = "rela_totalColab";
        if (this.table.dadosFiltrados && this.table.arraySearch.length > 0) {
          for (var i = this.table.posExbPrimNota; i < this.table.posExbUltmaNota; i++) {
            total_empr += this.table.arraySearch[i][propEmpr];
            // total_nfe += this.table.arraySearch[i][propNfe];
            // total_nfse += this.table.arraySearch[i][propNfse];
            // total_cte += this.table.arraySearch[i][propCte];
            total_colabs += this.table.arraySearch[i][propColab];
          }
        } else if (this.table.arrayNotas.length > 0) {
          for (var i = this.table.posExbPrimNota; i < this.table.posExbUltmaNota; i++) {
            total_empr += this.table.arrayNotas[i][propEmpr];
            // total_nfe += this.table.arrayNotas[i][propNfe];
            // total_nfse += this.table.arrayNotas[i][propNfse];
            // total_cte += this.table.arrayNotas[i][propCte];
            total_colabs += this.table.arrayNotas[i][propColab];
          }
        }
        this.table.valor_total_conta_empr = total_empr;
        // this.table.valor_total_conta_nfe = total_nfe;
        // this.table.valor_total_conta_nfse = total_nfse;
        // this.table.valor_total_conta_cte = total_cte;
        this.table.valor_total_conta_colab = total_colabs;
      }
    },
    removeHeaders: function removeHeaders() {
      if (this.table.posExbUltmaNota - this.table.posExbPrimNota != this.table.pagination.rowsPerPage) {
        this.remove_headers = true;
      }
      if (this.remove_headers && (this.table.posExbUltmaNota - this.table.posExbPrimNota == this.table.pagination.rowsPerPage || this.table.pagination.rowsPerPage >= this.table.qnt_total_notas)) {
        this.table.headers.forEach(function (item) {
          if (item.value != "acoes") {
            if (!item.show) {
              var id = "#" + item.value;
              document.querySelectorAll(id).forEach(function (item) {
                return item.style.display = "none";
              });
            }
          }
        });
        this.remove_headers = false;
      }
    },
    setTextRange: function setTextRange() {
      var range = this.range;
      this.table.rangeButtons.forEach(function (i) {
        if (i.value == range) {
          range = i.noDataText;
        }
      });
      return range;
    }
  },
  methods: {
    handleInfo: function handleInfo(props, tipo) {
      if (props.log_statusErp && tipo === 'STATUSERP') {
        this.infos = props.log_statusErp;
        this.infoDialog = true;
      } else if (props.log_statusErpDois && tipo === 'STATUSERPDOIS') {
        this.infos = props.log_statusErpDois;
        this.infoDialog = true;
      } else {
        return;
      }
    },
    handleFailure: function handleFailure(props, tipo) {
      if (props.erroEmissao && tipo == 'EMISSAO') {
        this.errors = props.erroEmissao;
        this.failureDialog = true;
      } else if (props.log_escrituracao && tipo === 'ESCRITURACAO') {
        this.errors = props.log_escrituracao;
        this.failureDialog = true;
      } else if (props.log_integracao && tipo === 'INTEGRACAO') {
        this.errors = props.log_integracao;
        this.failureDialog = true;
      } else if (props.log_ocr && tipo === 'OCR') {
        this.errors = props.log_ocr;
        this.failureDialog = true;
      } else if (props.logErroFtpXml && tipo === 'XML') {
        this.errors = props.logErroFtpXml;
        this.failureDialog = true;
      } else if (props.logErroFtpPdf && tipo === 'PDF') {
        this.errors = props.logErroFtpPdf;
        this.failureDialog = true;
      } else if (props.log_statusErp && tipo === 'STATUSERP') {
        this.errors = props.log_statusErp;
        this.failureDialog = true;
      } else if (props.log_statusErpDois && tipo === 'STATUSERPDOIS') {
        this.errors = props.log_statusErpDois;
        this.failureDialog = true;
      } else {
        return;
      }
    },
    handleService: function handleService() {
      if (this.component.name.indexOf("NFe") != -1) {
        this.table = new __WEBPACK_IMPORTED_MODULE_18__domain_dataTable_TableNfe__["a" /* default */](this.component);
      } else if (this.component.name.indexOf("CTE") != -1) {
        this.table = new __WEBPACK_IMPORTED_MODULE_21__domain_dataTable_TableCte__["a" /* default */]();
      } else if (this.component.name == "NFSE") {
        if (this.component.tipo == "recebida") {
          this.table = new __WEBPACK_IMPORTED_MODULE_20__domain_dataTable_TableNfse__["a" /* default */]();
        } else if (this.component.tipo == "emitida") {
          this.table = new __WEBPACK_IMPORTED_MODULE_19__domain_dataTable_TableNfseEmitida__["a" /* default */]();
        }
      } else if (this.component.name == "fornecedores") {
        this.table = new __WEBPACK_IMPORTED_MODULE_23__domain_dataTable_TableFornecedores__["a" /* default */]();
      } else if (this.component.name == "clientes") {
        this.table = new __WEBPACK_IMPORTED_MODULE_22__domain_dataTable_TableClientes__["a" /* default */]();
      } else if (this.component.name == "produtos") {
        if (this.component.tipo == "recebida") {
          this.table = new __WEBPACK_IMPORTED_MODULE_24__domain_dataTable_TableProdutos__["a" /* default */]();
        } else if (this.component.tipo == "emitida") {
          this.table = new __WEBPACK_IMPORTED_MODULE_25__domain_dataTable_TableProdutosEmitida__["a" /* default */]();
        }
      } else if (this.component.name == "empresa") {
        this.table = new __WEBPACK_IMPORTED_MODULE_27__domain_dataTable_TableEmpresas__["a" /* default */]();
      } else if (this.component.name == "Iptu") {
        this.table = new __WEBPACK_IMPORTED_MODULE_31__domain_dataTable_TableIptu__["a" /* default */]();
      } else if (this.component.name == "certificado") {
        this.table = new __WEBPACK_IMPORTED_MODULE_26__domain_dataTable_TableCertificados__["a" /* default */]();
      } else if (this.component.name == "usuario") {
        this.table = new __WEBPACK_IMPORTED_MODULE_28__domain_dataTable_TableUsuarios__["a" /* default */]();
      } else if (this.component.name == "conta") {
        this.table = new __WEBPACK_IMPORTED_MODULE_29__domain_dataTable_TableContas_js__["a" /* default */]();
      } else if (this.component.name == "rela_usuario") {
        this.table = new __WEBPACK_IMPORTED_MODULE_30__domain_dataTable_TableRelaUsuarios__["a" /* default */]();
      } else {
        throw new Error("Tabela: '" + component.name + "' n\xE3o codificada");
      }
      this.getUFs_IBGE;
      this.setAttrFirstLine;
      this.table.pagination = this.pagination;
      if (this.empresa == undefined && this.table.arrayNotas == 0 || this.empresa.razao && this.table.arrayNotas == 0) {
        this.table.resetTable(this.empresa, this.component);
        this.getDadosApi();
      }
      this.$store.commit("addUpdateTable", false);
    },
    resetState: function resetState() {
      this.$store.commit("ressetAllStates");
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    ordenaCustomColumns: function ordenaCustomColumns(column) {
      if (column.indexOf("custom_") != -1 && this.pagination.descending == false) {
        //ordem crescente
        this.table.arrayNotas.sort(function (a, b) {
          if (a[column].value != "" && b[column].value == "") {
            return -1;
          }
          if (a[column].value == "" && b[column].value != "") {
            return 1;
          }
          return a[column].value > b[column].value ? 1 : a[column].value < b[column].value ? -1 : 0;
        });
      } else if (column.indexOf("custom_") != -1 && this.pagination.descending == true) {
        //order decrescente
        this.table.arrayNotas.sort(function (a, b) {
          if (a[column].value != "" && b[column].value == "") {
            return -1;
          }
          if (a[column].value == "" && b[column].value != "") {
            return 1;
          }
          return a[column].value < b[column].value ? 1 : a[column].value > b[column].value ? -1 : 0;
        });
      }
    },
    ordenaColumnsVinculo: function ordenaColumnsVinculo(column) {
      if (column == "vinculo") {
        if (this.pagination.descending == true) {
          this.table.arrayNotas.sort(function (a, b) {
            return a.cte.length < b.cte.length ? 1 : a.cte.length > b.cte.length ? -1 : a.xmlCce.length < b.xmlCce.length ? 1 : a.xmlCce.length > b.xmlCce.length ? -1 : 0;
          });
        } else {
          this.table.arrayNotas.sort(function (a, b) {
            return a.cte.length < b.cte.length ? -1 : a.cte.length > b.cte.length ? 1 : a.xmlCce.length < b.xmlCce.length ? -1 : a.xmlCce.length > b.xmlCce.length ? 1 : 0;
          });
        }
      }
    },
    getUfById: function getUfById(id) {
      this.arrayUF = this.IBGE.estados;
      var uf = "";
      this.arrayUF.forEach(function (item) {
        if (item.id == id) {
          uf = item;
        }
      });
      return uf.nome;
    },
    rmvThisFilter: function rmvThisFilter(item, txt, $event) {
      if ($event.target.nodeName != "I") {
        return;
      }

      if (txt != undefined) {
        var pos = null;
        item.valor.forEach(function (v, index) {
          if (v == txt) {
            pos = index;
          }
        });
        if (pos != null) {
          item.valor.splice(pos, 1);
        }
      } else {
        item.valor = null;
      }
      this.getFiltro();
    },

    getDataBusca: function getDataBusca($event) {
      if ($event === "semana" || $event === "mesAtual" || $event === "mesAnterior") {
        this.filtro = false;
      }
      this.range = $event;
      this.$emit("getNewEmp", this.empresa);
    },
    attTableEmp: function attTableEmp(value) {
      if (this.component.name == "certificado") {
        this.$emit("emitAttTable", value);
      } else {
        this.$emit("attTableEmp", value);
      }
    },
    changeSort: function changeSort(column) {
      if (this.table.array_todas_notas.length > 0) {
        this.table.tradeNotaArray(
        //pega todas as notas para ordenar no customSort.
        this.table.qnt_total_notas, this.table.arrayNotas.length);
        if (this.pagination.sortBy == column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
        //ordenando custom coluns
        this.ordenaCustomColumns(column);
        this.ordenaColumnsVinculo(column);
      }
    },
    getFiltro: function getFiltro() {
      this.resetState();
      this.filtro = !this.table.filtros.fechar;
      var url = "";
      // console.log('oioioioioii',this.table);
      this.table.filtros.items.forEach(function (item) {
        if (item.item_id == "cce") {
          if (item.valor == "Não") {
            url += "&_cce=" + false;
          }
          if (item.valor == "Sim") {
            url += "&_cce=" + true;
          }
        }
        if (item.item_id == "tipoVencimento") {
          if (item.valor == "Parcela única") {
            url += "&_tipoVencimento=0";
          }
          if (item.valor == "Parcelado") {
            url += "&_tipoVencimento=1";
          }
          if (item.valor == "Não informado") {
            url += "&_tipoVencimento=2";
          }
        }

        if (item.item_id == "protocolada") {
          if (item.valor != null) {
            url += "&_protocolada=" + item.valor;
          }
        }

        if (item.item_id == "status") {
          if (item.valor != null) {
            if (item.valor.length > 0) {
              url += "&_status=";
            }
            for (var i = 0; i < item.valor.length; i++) {
              if (i > 0) {
                url += ",";
              }
              url += item.valor[i];
            }
          }
        }

        if (item.item_id == 'statusDes') {
          if (item.valor != null) {
            if (item.valor.length > 0) {
              url += "&_statusDes=";
            }
            for (var _i = 0; _i < item.valor.length; _i++) {
              if (_i > 0) {
                url += ",";
              }
              url += item.valor[_i];
            }
          }
        }

        if (item.item_id == "manifestacao") {
          if (item.valor != null) {
            if (item.valor.length > 0) {
              url += "&_manifestacao=";
            }
            for (var _i2 = 0; _i2 < item.valor.length; _i2++) {
              if (_i2 > 0) {
                url += ",";
              }
              url += item.valor[_i2];
            }
          }
        }
        if (item.item_id == "emissaoIni") {
          if (item.valor != null) {
            url += "&_emissaoIni=" + item.valor;
          }
        }
        if (item.item_id == "emissaoFim") {
          if (item.valor != null) {
            url += "&_emissaoFim=" + item.valor;
          }
        }
        if (item.item_id == "importacaoIni") {
          if (item.valor != null) {
            url += "&_importacaoIni=" + item.valor;
          }
        }
        if (item.item_id == "importacaoFim") {
          if (item.valor != null) {
            url += "&_importacaoFim=" + item.valor;
          }
        }
        if (item.item_id == "vencimentoIni") {
          if (item.valor != null) {
            url += "&_vencimentoIni=" + item.valor;
          }
        }
        if (item.item_id == "vencimentoFim") {
          if (item.valor != null) {
            url += "&_vencimentoFim=" + item.valor;
          }
        }
        if (item.item_id == "vlrInicial") {
          if (item.valor != null) {
            var aux = item.valor;
            aux = aux.replace(/\D/g, ""); //Remode tudo o que não é dígito
            aux = aux.replace(/(\d+)(\d{2})/, "$1.$2");
            url += "&_valorIni=" + aux;
          }
        }
        if (item.item_id == "vlrFinal") {
          if (item.valor != null) {
            var _aux = item.valor;
            _aux = _aux.replace(/\D/g, ""); //Remode tudo o que não é dígito
            _aux = _aux.replace(/(\d+)(\d{2})/, "$1.$2");
            url += "&_valorFim=" + _aux;
          }
        }
      });
      this.table.urlFiltros = url;
      this.range = "tudo";
      this.getDadosApi();
    },
    updatedSelected: function updatedSelected($event) {
      if ($event) {
        this.selected = $event.slice();
      }
    },
    customFilter: function customFilter(items, search, filter) {
      var auxTable = this.table;
      Object(__WEBPACK_IMPORTED_MODULE_52_timers__["setTimeout"])(function () {
        auxTable.headers.forEach(function (item) {
          if (item.value != "acoes") {
            if (!item.show) {
              var id = "#" + item.value;
              document.querySelectorAll(id).forEach(function (item) {
                return item.style.display = "none";
              });
            }
          }
        });
      }, 300);

      this.table.headers.forEach(function (item) {
        if (item.value != "acoes") {
          if (!item.show) {
            var id = "#" + item.value;
            document.querySelectorAll(id).forEach(function (item) {
              return item.style.display = "none";
            });
          }
        }
      });
      if (!search) {
        if (this.table.dadosFiltrados) {
          this.table.qnt_total_notas = this.table.array_todas_notas.length;
          this.table.setPages(this.table.array_todas_notas.length, this.table.pagination.rowsPerPage);
        }

        this.table.dadosFiltrados = false;
        this.table.arraySearch = [];

        Object(__WEBPACK_IMPORTED_MODULE_52_timers__["setTimeout"])(function () {
          auxTable.headers.forEach(function (item) {
            if (item.value != "acoes") {
              if (!item.show) {
                var id = "#" + item.value;
                document.querySelectorAll(id).forEach(function (item) {
                  return item.style.display = "none";
                });
              }
            }
          });
        }, 10);

        return this.table.arrayNotas;
      }
      this.table.headers.forEach(function (item) {
        if (item.value != "acoes") {
          if (!item.show) {
            var id = "#" + item.value;
            document.querySelectorAll(id).forEach(function (item) {
              return item.style.display = "none";
            });
          }
        }
      });

      this.table.dadosFiltrados = true;
      var notas = [];
      if (this.filtroForSearch.value != "tudo") {
        var searchLngth = search.replace(/[^0-9a-zA-Z]+/g, "").length;
        for (var i = 0; i < this.table.array_todas_notas.length; i++) {
          if (this.filtroForSearch.value.indexOf("custom") == -1) {
            if (this.table.array_todas_notas[i][this.filtroForSearch.value].toString().toLowerCase().replace(/[^0-9a-zA-Z]+/g, "").substr(0, searchLngth) == search.toString().toLowerCase().replace(/[^0-9a-zA-Z]+/g, "")) {
              notas.push(this.table.array_todas_notas[i]);
            }
          } else {
            if (this.table.array_todas_notas[i][this.filtroForSearch.value].value.toString().toLowerCase().replace(/[^0-9a-zA-Z]+/g, "").substr(0, searchLngth) == search.toString().toLowerCase().replace(/[^0-9a-zA-Z]+/g, "")) {
              notas.push(this.table.array_todas_notas[i]);
            }
          }
        }
      }
      if (this.filtroForSearch.value == "tudo") {
        var new_filter = function new_filter(val, search) {
          return val !== null && ["undefined", "boolean"].indexOf(typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === -1 && val.toString().toLowerCase().replace(/[^0-9a-zA-Z]+/g, "").indexOf(search.toString().toLowerCase().replace(/[^0-9a-zA-Z]+/g, "").split(" ")) !== -1;
        };

        var needleAry = search.toString().toLowerCase().split(" ").filter(function (x) {
          return x;
        });
        var auxHeadersTable = this.table.headers;
        notas = this.table.array_todas_notas.filter(function (row) {
          return needleAry.every(function (needle) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              var customPesq = false;
              if (key.indexOf("custom_") != -1) {
                //caso a coluna for alguma de custom verificar se nela está setado para entrar nas opções de busca
                auxHeadersTable.forEach(function (e) {
                  if (e.value == key) {
                    if (e.pesq) {
                      customPesq = true;
                      return;
                    }
                    customPesq = false;
                    return;
                  }
                });
              }
              //colunas customns possuem um objeto em seus valores, onde é preciso especificar o caminho diferente das colunas padrões
              if (customPesq) {
                return new_filter(row[key].value, needle);
              }
              return new_filter(row[key], needle);
            });
          });
        });
      }
      this.table.qnt_total_notas = notas.length;
      this.table.setPages(notas.length, this.table.pagination.rowsPerPage);

      this.table.arraySearch = notas;
      return notas;
    },

    getDadosApi: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.range == "tudo" && !this.table.urlFiltros)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                this.table.busca = true;
                this.table.loading = true;
                this.pagination.page = 1;

                if (!(this.component.name == "NFeRecebidas" && this.component.tipo == "recebida")) {
                  _context5.next = 10;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                this.getItems("getNfeRecebidas", 2);
                _context5.next = 90;
                break;

              case 10:
                if (!(this.component.name == "NFeRecebidas" && this.component.tipo == "emitida")) {
                  _context5.next = 15;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                this.getItems("getNfeEmitidas", 2);
                _context5.next = 90;
                break;

              case 15:
                if (!(this.component.name == "NFeRecebidas" && this.component.tipo == "transportados")) {
                  _context5.next = 20;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                this.getItems("getNfeTransportados", 2);
                _context5.next = 90;
                break;

              case 20:
                if (!(this.component.name == "CTE" && this.component.tipo == "todos")) {
                  _context5.next = 25;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_7__domain_notas_cte_CteService__["a" /* default */](this.$http);
                this.getItems("getCte", 2);
                _context5.next = 90;
                break;

              case 25:
                if (!(this.component.name == "CTE" && this.component.tipo == "tomados")) {
                  _context5.next = 30;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_7__domain_notas_cte_CteService__["a" /* default */](this.$http);
                this.getItems("getCteTomados", 2);
                _context5.next = 90;
                break;

              case 30:
                if (!(this.component.name == "usuario")) {
                  _context5.next = 39;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_14__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
                this.table.arrayNotas = [];
                this.table.qnt_total_notas = this.arrayItems.length;
                this.table.setNota(this.table.arrayNotas, this.arrayItems);
                this.table.array_todas_notas = this.table.arrayNotas.slice();
                this.table.setPages(this.table.arrayNotas.length, this.table.pagination.rowsPerPage);
                _context5.next = 90;
                break;

              case 39:
                if (!(this.component.name == "rela_usuario")) {
                  _context5.next = 44;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_14__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
                this.getItems("relatorio", 2);
                // this.table.arrayNotas = [];
                // this.table.qnt_total_notas = this.arrayItems.length;
                // this.table.setNota(this.table.arrayNotas, this.arrayItems);
                // this.table.array_todas_notas = this.table.arrayNotas.slice();
                // this.table.setPages(
                //   this.table.arrayNotas.length,
                //   this.table.pagination.rowsPerPage
                // );
                _context5.next = 90;
                break;

              case 44:
                if (!(this.component.name == "NFSE" && this.component.tipo === "emitida" && this.empresa.servicos && this.empresa.servicos.robotizacao && this.empresa.servicos.robotizacao.find(function (item) {
                  return item.nomeServico === "NFSE_TOMADOS";
                }))) {
                  _context5.next = 49;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_8__domain_notas_nfse_NfseService__["a" /* default */](this.$http);
                this.getItems("getNfseEmitidas", 2);
                _context5.next = 90;
                break;

              case 49:
                if (!(this.component.name == "NFSE")) {
                  _context5.next = 54;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_8__domain_notas_nfse_NfseService__["a" /* default */](this.$http);
                this.getItems("getNfse", 2);
                _context5.next = 90;
                break;

              case 54:
                if (!(this.component.name == "fornecedores")) {
                  _context5.next = 59;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_13__domain_fornecedores_FornecedoresService__["a" /* default */](this.$http);
                this.getItems("getFornecedores", 2);
                _context5.next = 90;
                break;

              case 59:
                if (!(this.component.name == "clientes")) {
                  _context5.next = 64;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_9__domain_clientes_ClientesService__["a" /* default */](this.$http);
                this.getItems("getClientes", 2);
                _context5.next = 90;
                break;

              case 64:
                if (!(this.component.name == "produtos")) {
                  _context5.next = 69;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_12__domain_produtos_ProdutosService__["a" /* default */](this.$http);
                this.getItems("getProdutos", 2);
                _context5.next = 90;
                break;

              case 69:
                if (!(this.component.name == "Iptu")) {
                  _context5.next = 74;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_16__domain_automacaoFiscal_iptu_IptuService__["a" /* default */](this.$http);
                this.getItems("getImoveis", 2);
                _context5.next = 90;
                break;

              case 74:
                if (!(this.component.name == "empresa")) {
                  _context5.next = 79;
                  break;
                }

                // let qtdDiferente = false;
                // let qtdBuscar = 0;

                this.service = new __WEBPACK_IMPORTED_MODULE_10__domain_conta_empresa_EmpresaService__["a" /* default */](this.$http);
                this.service.getEmpresasConta(this.conta.conta, 1, 10).then(function (body) {
                  _this.table.qnt_total_notas = body.empresas.length + body.emprs_not_admin.length;
                }).then(function () {
                  if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.tableEmpresas) !== "{}") {
                    if (_this.tableEmpresas.array_todas_notas.length === _this.table.qnt_total_notas) {
                      // qtdDiferente = true;
                      // qtdBuscar = this.table.qnt_total_notas - this.tableEmpresas.array_todas_notas.length;
                      _this.table = _this.tableEmpresas;
                      return;
                    }
                    // else {
                    //   this.table = this.tableEmpresas;
                    //   return;
                    // }
                  }

                  var auxQtd = _this.table.qnt_total_notas;

                  // if(qtdDiferente) {
                  //   auxQtd = qtdBuscar;
                  // }

                  _this.service.getEmpresasConta(_this.conta.conta, 1, auxQtd).then(function (body) {
                    if (body && body.empresas) {
                      // if(!qtdDiferente) {
                      _this.table.arrayNotas = [];
                      // }

                      _this.table.qnt_total_notas = body.empresas.length + body.emprs_not_admin.length;
                      var arrayEmpresas = body.empresas.concat(body.emprs_not_admin);
                      _this.table.setNota(_this.table.arrayNotas, arrayEmpresas, body.faturamento);
                      _this.table.array_todas_notas = _this.table.arrayNotas.slice();
                      _this.table.setPages(_this.table.arrayNotas.length, _this.table.pagination.rowsPerPage);
                    }
                  }).then(function () {
                    _this.$store.commit("addTableEmpresas", _this.table);
                  });
                });
                _context5.next = 90;
                break;

              case 79:
                if (!(this.component.name == "certificado")) {
                  _context5.next = 84;
                  break;
                }

                // let qtdDiferente = false;
                // let qtdBuscar = 0;

                this.service = new __WEBPACK_IMPORTED_MODULE_11__domain_conta_empresa_certificado_CertificadoService__["a" /* default */](this.$http);
                this.service.getCertificadosConta(this.conta.conta, 1, 10).then(function (body) {
                  if (!body.items && !body.certs_not_owner) {
                    _this.table.loading = false;
                    return false;
                  }
                  var owner_length = body.certs_not_owner && body.certs_not_owner.items ? body.certs_not_owner.items.length : 0;
                  _this.table.qnt_total_notas = owner_length + body.items.length;
                  return true;
                }).then(function (hasData) {
                  if (hasData) {
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.tableCertificados) !== "{}") {
                      if (_this.tableCertificados.array_todas_notas.length === _this.table.qnt_total_notas) {
                        // qtdDiferente = true;
                        // qtdBuscar = this.table.qnt_total_notas - this.tableCertificados.array_todas_notas.length;
                        _this.table = _this.tableCertificados;
                        return;
                      }
                      // else {
                      //   this.table = this.tableCertificados;
                      //   return;
                      // }
                    }

                    var auxQtd = _this.table.qnt_total_notas;

                    // if(qtdDiferente) {
                    //   auxQtd = qtdBuscar;
                    // }

                    _this.service.getCertificadosConta(_this.conta.conta, 1, auxQtd).then(function (body) {
                      // if(!qtdDiferente) {
                      _this.table.arrayNotas = [];
                      // }
                      var owner_length = body.certs_not_owner && body.certs_not_owner.items ? body.certs_not_owner.items.length : 0;
                      _this.qnt_total_notas = owner_length + body.items.length;
                      var arrayEmpresas = body.items.concat(body.certs_not_owner.items);
                      _this.table.setNota(_this.table.arrayNotas, arrayEmpresas);

                      _this.table.array_todas_notas = _this.table.arrayNotas.slice();
                      _this.table.setPages(_this.table.arrayNotas.length, _this.table.pagination.rowsPerPage);
                    }).then(function () {
                      _this.$store.commit("addTableCertificados", _this.table);
                    });
                  }
                });
                _context5.next = 90;
                break;

              case 84:
                if (!(this.component.name == "conta")) {
                  _context5.next = 89;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_15__domain_conta_ContaService_js__["a" /* default */](this.$http);
                this.getItems("relatorio", 2);
                // this.service.relatorio(this.conta.id_usuario).then(res => {
                //   this.table.arrayNotas = [];
                //   this.table.qnt_total_notas = res.body.items
                //     ? res.body.items.length
                //     : 0;
                //   this.table.setNota(this.table.arrayNotas, res.body.items);
                //   this.table.array_todas_notas = this.table.arrayNotas.slice();
                //   this.table.setPages(
                //     this.table.arrayNotas.length,
                //     this.table.pagination.rowsPerPage
                //   );
                // });
                _context5.next = 90;
                break;

              case 89:
                throw new Error("Erro ao tentar buscar items para a tabela, servi\xE7o do '" + this.component.name + "' n\xE3o codificado");

              case 90:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getDadosApi() {
        return _ref5.apply(this, arguments);
      }

      return getDadosApi;
    }(),
    getItems: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8(method, tipo) {
        var emp, NotasPorPage;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.t0 = tipo;
                _context8.next = _context8.t0 === 1 ? 3 : _context8.t0 === 2 ? 10 : 15;
                break;

              case 3:
                _context8.next = 5;
                return this.service[method](this.empresa._id).then(function (body) {
                  this.table.arrayNotas = [];
                  this.table.qnt_total_notas = body.length;
                  this.table.setNota(this.table.arrayNotas, body);
                });

              case 5:
                // console.log(12123123321 ,arrayNotas);

                this.table.qnt_total_notas = this.table.arrayNotas.length;
                this.table.array_todas_notas = this.table.arrayNotas.slice();
                this.table.setPages(this.table.array_todas_notas.length, this.table.pagination.rowsPerPage);
                this.conta.getNotificacoes = true;
                return _context8.abrupt("break", 16);

              case 10:
                // Verifica se a quantidade de notas armazenadas no vuex é a mesma que esta no banco
                // let qtdDiferente = false;
                // Busca a diferença de notas entre o vuex e o banco
                // let qtdBuscar = 0;
                emp = this.empresa ? this.empresa._id : "";
                NotasPorPage = this.table.setQntPorPage(this.table.pagination.rowsPerPage);
                _context8.next = 14;
                return this.service[method](1, NotasPorPage, this.empresa ? this.empresa._id : this.empresa, this.range, this.table.urlFiltros, this.component.tipo, this.conta.id_usuario).then(function (body) {
                  // if(!body._links.totalItens) {
                  //   body._links.totalItens = body.items.length;
                  //   body._links.self = '/imoveis/'+emp;
                  // }
                  // if(!body) {

                  //   return false;
                  // }

                  this.nextPage = body._links && body._links.next ? body._links.next : "";
                  this.table.array_todas_notas = [];
                  this.table.arrayNotas = [];
                  if (body != undefined && body.hasOwnProperty("items")) {
                    this.table.qnt_total_notas = body._links.totalItens;
                    this.table.setNota(this.table.arrayNotas, body.items);
                    return true;
                  }
                }).then(function next(v) {
                  if (v) {
                    this.table.arrayNotas = [];
                    this.table.arrayNotas = this.setNotasByHeaders(this.table.arrayNotas);
                    return true;
                  }
                }).then(function () {
                  var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(v) {
                    var _this2 = this;

                    var _ret;

                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (!v) {
                              _context7.next = 5;
                              break;
                            }

                            return _context7.delegateYield( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
                              var qtdAux, auxQtd, paginas, auxTable;
                              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                                while (1) {
                                  switch (_context6.prev = _context6.next) {
                                    case 0:
                                      qtdAux = _this2.table.qnt_total_notas;
                                      // Verifica se existem dados armazenados na store ( vuex )

                                      if (!(_this2.component.name === "NFeRecebidas")) {
                                        _context6.next = 14;
                                        break;
                                      }

                                      if (!(_this2.component.tipo === "recebida" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableNfeRecebidas) !== "{}")) {
                                        _context6.next = 6;
                                        break;
                                      }

                                      if (!(_this2.tableNfeRecebidas.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 6;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableNfeRecebidas.array_todas_notas.length;
                                      _this2.table = _this2.tableNfeRecebidas;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 6:
                                      if (!(_this2.component.tipo === "emitida" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableNfeEmitidas) !== "{}")) {
                                        _context6.next = 10;
                                        break;
                                      }

                                      if (!(_this2.tableNfeEmitidas.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 10;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableNfeEmitidas.array_todas_notas.length;
                                      _this2.table = _this2.tableNfeEmitidas;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 10:
                                      if (!(_this2.component.tipo === "transportados" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableNfeTransportados) !== "{}")) {
                                        _context6.next = 14;
                                        break;
                                      }

                                      if (!(_this2.tableNfeTransportados.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 14;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableNfeEmitidas.array_todas_notas.length;
                                      _this2.table = _this2.tableNfeTransportados;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 14:
                                      if (!(_this2.component.name === "CTE")) {
                                        _context6.next = 23;
                                        break;
                                      }

                                      if (!(_this2.component.tipo === "todos" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableCteTodos) !== "{}")) {
                                        _context6.next = 19;
                                        break;
                                      }

                                      if (!(_this2.tableCteTodos.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 19;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableCteTodos.array_todas_notas.length;
                                      _this2.table = _this2.tableCteTodos;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 19:
                                      if (!(_this2.component.tipo === "tomados" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableCteTomados) !== "{}")) {
                                        _context6.next = 23;
                                        break;
                                      }

                                      if (!(_this2.tableCteTomados.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 23;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableCteTomados.array_todas_notas.length;
                                      _this2.table = _this2.tableCteTomados;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 23:
                                      if (!(_this2.component.name === "clientes" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableClientes) !== "{}")) {
                                        _context6.next = 27;
                                        break;
                                      }

                                      if (!(_this2.tableClientes.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 27;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableClientes.array_todas_notas.length;
                                      _this2.table = _this2.tableClientes;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 27:
                                      if (!(_this2.component.name === "fornecedores" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableFornecedores) !== "{}")) {
                                        _context6.next = 31;
                                        break;
                                      }

                                      if (!(_this2.tableFornecedores.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 31;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableFornecedores.array_todas_notas.length;
                                      _this2.table = _this2.tableFornecedores;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 31:
                                      if (!(_this2.component.name === "produtos")) {
                                        _context6.next = 42;
                                        break;
                                      }

                                      if (!(_this2.component.tipo === "recebida" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableProdutos) !== "{}")) {
                                        _context6.next = 38;
                                        break;
                                      }

                                      if (!(_this2.tableProdutos.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 36;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableProdutos.array_todas_notas.length;
                                      _this2.table = _this2.tableProdutos;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 36:
                                      _context6.next = 42;
                                      break;

                                    case 38:
                                      if (!(_this2.component.tipo === "emitida" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableProdutosEmitidas) !== "{}")) {
                                        _context6.next = 42;
                                        break;
                                      }

                                      if (!(_this2.tableProdutosEmitidas.array_todas_notas.length === _this2.table.qnt_total_notas)) {
                                        _context6.next = 42;
                                        break;
                                      }

                                      // qtdDiferente = true;
                                      // qtdBuscar = this.table.qnt_total_notas - this.tableProdutosEmitidas.array_todas_notas.length;
                                      _this2.table = _this2.tableProdutosEmitidas;
                                      return _context6.abrupt("return", {
                                        v: void 0
                                      });

                                    case 42:
                                      auxQtd = _this2.table.qnt_total_notas;

                                      if (_this2.table.qnt_total_notas >= 30000) {
                                        auxQtd = 5000;
                                      }

                                      // if(qtdDiferente) {
                                      //   auxQtd = qtdBuscar;
                                      //   console.log(auxQtd);
                                      //   this.table.qnt_total_notas = qtdAux;
                                      // }

                                      paginas = 1;
                                      auxTable = {};

                                      // Se possuir mais notas que a quantidade maxima, será feito o carregamento em partes.

                                    case 46:
                                      if (!paginas) {
                                        _context6.next = 54;
                                        break;
                                      }

                                      if (paginas > 1) {
                                        _this2.$store.commit("addBuscaCTE", true);
                                      }
                                      _this2.table.loading = true;
                                      _context6.next = 51;
                                      return _this2.service[method](paginas, auxQtd, _this2.empresa ? _this2.empresa._id : _this2.empresa, _this2.range, _this2.table.urlFiltros, _this2.component.tipo, _this2.conta.id_usuario).then(function (body) {
                                        this.nextPage = body._links && body._links.next ? body._links.next : "";
                                        //seta todas as notas
                                        if (paginas === 1) {
                                          this.table.array_todas_notas = [];
                                          this.table.arrayNotas = [];
                                        }
                                        this.table.setNota(this.table.array_todas_notas, body.items);
                                      }).then(function () {
                                        //seta os headers na tabela
                                        this.table.array_todas_notas = this.setNotasByHeaders(this.table.array_todas_notas);
                                      }).then(function () {
                                        //seta os headers qntd de pagina
                                        this.table.qnt_total_paginas = this.table.setPages(this.table.array_todas_notas.length, this.table.pagination.rowsPerPage);
                                      }).then(function () {
                                        //seta as notas notas exbidas na tela
                                        this.table.arrayNotas = this.table.array_todas_notas.slice();
                                      }).then(function () {
                                        //Quando não houver nota no periodo de 7 dias, troca para busca completa.
                                        if (this.component.enable.rangeDate && this.range == "mesAtual" && this.table.array_todas_notas.length == 0 && this.table.firstAcess) {
                                          this.table.snack.text = "Aus\xEAncia de dados neste m\xEAs.\n Para uma nova busca altere o filtro.";
                                          this.table.snackDefault();
                                          this.table.snack.time = 4000;
                                          this.table.snack.show = true;
                                          this.table.firstAcess = false;
                                          var that = this;
                                          // setTimeout(function() {
                                          //   that.range = "tudo";
                                          // }, 4000);
                                        }
                                      }).then(function () {
                                        //busca notificacoes
                                        this.conta.getNotificacoes = true;
                                      });

                                    case 51:

                                      if (_this2.nextPage) {
                                        paginas = _this2.nextPage.substring(_this2.nextPage.indexOf("=") + 1, _this2.nextPage.indexOf("&"));
                                        _this2.table.loading = false;
                                        // if(paginas < 9){
                                        //   let test = this.nextPage.substr(12,1);
                                        //   paginas = test;

                                        //   this.table.loading = false;
                                        // }else {
                                        //   let test = this.nextPage.substr(12,2);
                                        //   paginas = test;
                                        //   this.table = {...this.table};
                                        //   this.table.loading = false;
                                        // }
                                      } else {
                                        // this.table = {...this.table};
                                        _this2.$store.commit("addBuscaCTE", false);
                                        paginas = 0;
                                      }
                                      _context6.next = 46;
                                      break;

                                    case 54:
                                    case "end":
                                      return _context6.stop();
                                  }
                                }
                              }, _callee6, _this2);
                            })(), "t0", 2);

                          case 2:
                            _ret = _context7.t0;

                            if (!((typeof _ret === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_ret)) === "object")) {
                              _context7.next = 5;
                              break;
                            }

                            return _context7.abrupt("return", _ret.v);

                          case 5:
                            this.table.loading = false;

                            // Armazenar tabelas no vuex

                            if (!(this.component.name === "NFeRecebidas")) {
                              _context7.next = 22;
                              break;
                            }

                            if (!(this.component.tipo === "recebida")) {
                              _context7.next = 11;
                              break;
                            }

                            this.$store.commit("addTableNfeRecebidas", this.table);
                            _context7.next = 20;
                            break;

                          case 11:
                            if (!(this.component.tipo === "emitida")) {
                              _context7.next = 15;
                              break;
                            }

                            this.$store.commit("addTableNfeEmitidas", this.table);
                            _context7.next = 20;
                            break;

                          case 15:
                            if (!(this.component.tipo === "transportados")) {
                              _context7.next = 19;
                              break;
                            }

                            this.$store.commit("addTableNfeTransportados", this.table);
                            _context7.next = 20;
                            break;

                          case 19:
                            return _context7.abrupt("return");

                          case 20:
                            _context7.next = 67;
                            break;

                          case 22:
                            if (!(this.component.name === "CTE")) {
                              _context7.next = 34;
                              break;
                            }

                            if (!(this.component.tipo === "todos")) {
                              _context7.next = 27;
                              break;
                            }

                            this.$store.commit("addTableCteTodos", this.table);
                            _context7.next = 32;
                            break;

                          case 27:
                            if (!(this.component.tipo === "tomados")) {
                              _context7.next = 31;
                              break;
                            }

                            this.$store.commit("addTableCteTomados", this.table);
                            _context7.next = 32;
                            break;

                          case 31:
                            return _context7.abrupt("return");

                          case 32:
                            _context7.next = 67;
                            break;

                          case 34:
                            if (!(this.component.name === "NFSE")) {
                              _context7.next = 46;
                              break;
                            }

                            if (!(this.component.tipo === "recebida")) {
                              _context7.next = 39;
                              break;
                            }

                            this.$store.commit("addTableNfseRecebidas", this.table);
                            _context7.next = 44;
                            break;

                          case 39:
                            if (!(this.component.tipo === "emitida")) {
                              _context7.next = 43;
                              break;
                            }

                            this.$store.commit("addTableNfseEmitidas", this.table);
                            _context7.next = 44;
                            break;

                          case 43:
                            return _context7.abrupt("return");

                          case 44:
                            _context7.next = 67;
                            break;

                          case 46:
                            if (!(this.component.name === "clientes")) {
                              _context7.next = 50;
                              break;
                            }

                            this.$store.commit("addTableClientes", this.table);
                            _context7.next = 67;
                            break;

                          case 50:
                            if (!(this.component.name === "fornecedores")) {
                              _context7.next = 54;
                              break;
                            }

                            this.$store.commit("addTableFornecedores", this.table);
                            _context7.next = 67;
                            break;

                          case 54:
                            if (!(this.component.name === "produtos")) {
                              _context7.next = 66;
                              break;
                            }

                            if (!(this.component.tipo === "recebida")) {
                              _context7.next = 59;
                              break;
                            }

                            this.$store.commit("addTableProdutos", this.table);
                            _context7.next = 64;
                            break;

                          case 59:
                            if (!(this.component.tipo === "emitida")) {
                              _context7.next = 63;
                              break;
                            }

                            this.$store.commit("addTableProdutosEmitidas", this.table);
                            _context7.next = 64;
                            break;

                          case 63:
                            return _context7.abrupt("return");

                          case 64:
                            _context7.next = 67;
                            break;

                          case 66:
                            return _context7.abrupt("return");

                          case 67:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7, this);
                  }));

                  function next(_x11) {
                    return _ref7.apply(this, arguments);
                  }

                  return next;
                }());

              case 14:
                return _context8.abrupt("break", 16);

              case 15:
                throw new Error("Erro ao fazer requisição");

              case 16:
                if (tipo == 1) {
                  this.table.arrayNotas = this.setNotasByHeaders(this.table.arrayNotas).slice();
                  this.table.array_todas_notas = this.table.arrayNotas.slice();
                }

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getItems(_x9, _x10) {
        return _ref6.apply(this, arguments);
      }

      return getItems;
    }(),
    selectRow: function selectRow(props) {
      var index = undefined;
      if (this.table.selected) {
        // console.log(props.item);
        if (!this.table.selected.find(function (item) {
          return item._id == props.item._id;
        })) {
          this.table.selected.push(props.item);
        } else {
          index = this.table.selected.findIndex(function (item) {
            return item._id == props.item._id;
          });
          if (index != undefined) {
            this.table.selected.splice(index, 1);
          }
        }
      }
    },
    setNotasByHeaders: function setNotasByHeaders(array) {
      var _this3 = this;

      // return this.table.getHeaders();
      // this.table.headers = this.table.getHeaders();
      // return array
      var tipoHeader = "";
      this.component.name == "clientes" ? tipoHeader = "clienteHeader" : this.component.name == "fornecedores" ? tipoHeader = "fornecHeader" : this.component.name == "CTE" && this.component.tipo == "todos" ? tipoHeader = "cteHeaderRecebidos" : this.component.name == "CTE" && this.component.tipo == "tomados" ? tipoHeader = "cteHeaderTomados" : this.component.name == "produtos" && this.component.tipo == "recebida" ? tipoHeader = "produtoHeaderRecebidos" : this.component.name == "produtos" && this.component.tipo == "emitida" ? tipoHeader = "produtoHeaderEmitidos" : this.component.name.indexOf("NFe") != -1 && this.component.tipo == "recebida" ? tipoHeader = "nfeHeaderRecebidas" : this.component.name.indexOf("NFe") != -1 && this.component.tipo == "emitida" ? tipoHeader = "nfeHeaderEmitidas" : this.component.name.indexOf("NFe") != -1 && this.component.tipo == "transportados" ? tipoHeader = "nfeHeaderTransportados" : this.component.name == "NFSE" && this.component.tipo == "emitida" ? tipoHeader = "nfseHeaderEmitidos" : this.component.name == "NFSE" && this.component.tipo == "recebida" ? tipoHeader = "nfseHeaderRecebidos" : this.component.name == "Iptu" ? tipoHeader = "iptuHeader" : tipoHeader = "";

      if (this.empresa != undefined && this.empresa[tipoHeader] != undefined && this.empresa[tipoHeader].length > 0 && this.empresa.servicos && this.empresa.servicos.robotizacao && this.empresa.servicos.robotizacao.find(function (item) {
        return item.nomeServico === "NFSE_TOMADOS";
      }) && this.table.getHeaders(true).length === this.empresa[tipoHeader].length) {
        var cont_c_column;

        var _ret2 = function () {
          var empresa_id = _this3.empresa._id;
          var auxNotas = array;
          var arrayNfe = [];
          _this3.table.headers = [];
          var i = 0;
          cont_c_column = 0;

          // ADICIONANDO O CAMPO SISTEMA NA TABELA

          if (tipoHeader === "cteHeaderTomados" || tipoHeader === "cteHeaderRecebidos") {
            var sistema = {
              enable: true,
              id: "verProc",
              pesq: true,
              show: true,
              titulo: "Sistema"
            };
            var data_erp = {
              enable: true,
              id: "data_erp",
              pesq: false,
              show: true,
              titulo: "Data ERP"
            };
            var departamento = {
              enable: true,
              id: "departamento",
              pesq: false,
              show: true,
              titulo: "Departamento"
            };

            var modal = {
              enable: true,
              id: "modal",
              pesq: true,
              show: true,
              titulo: "Modal"
            };

            var possuiDepartamento = false;
            var possuiDataerp = false;
            var possuiSistema = false;
            var possuiModal = false;

            _this3.empresa[tipoHeader].forEach(function (header) {
              if (header.id === "verProc") {
                possuiSistema = true;
              }
              if (header.id === "data_erp") {
                possuiDataerp = true;
              }
              if (header.id === "departamento") {
                possuiDepartamento = true;
              }
              if (header.id === "modal") {
                possuiModal = true;
              }
            });

            // Adiciona o campo sistema para o header
            if (!possuiDataerp) {
              _this3.empresa[tipoHeader].push(data_erp);
            }
            if (!possuiSistema) {
              _this3.empresa[tipoHeader].push(sistema);
            }
            if (!possuiDepartamento) {
              _this3.empresa[tipoHeader].push(departamento);
            }
            if (!possuiModal) {
              _this3.empresa[tipoHeader].push(modal);
            }
          }

          // ADICIONANDO O CAMPO MANIFESTAÇÃO NA TABELA
          if (tipoHeader === "cteHeaderTomados") {
            var manifestacao = {
              enable: true,
              id: "manifestacao",
              value: "manifestacao",
              pesq: true,
              show: true,
              titulo: "Manifestação"
            };
            var id_fluig = {
              enable: true,
              id: "id_fluig",
              pesq: true,
              show: true,
              titulo: "Id Fluig"
            };
            var log_statusErp = {
              enable: true,
              id: "log_statusErp",
              pesq: false,
              show: false,
              titulo: "log_statusErp"
            };
            var log_statusErpDois = {
              enable: true,
              id: "log_statusErpDois",
              pesq: false,
              show: false,
              titulo: "log_statusErpDois"
            };
            var statusErpDois = {
              enable: true,
              id: "statusErpDois",
              pesq: false,
              show: true,
              titulo: "statusErpDois"
            };
            var possuiIdFluig = false;
            var possuiLogStatusErp = false;
            var possuiLogStatusErpDois = false;
            var possuiStatusErpDois = false;
            var possuiManifestacao = false;
            _this3.empresa[tipoHeader].forEach(function (header) {
              if (header.id === "manifestacao") {
                possuiManifestacao = true;
              }
              if (header.id === "id_fluig") {
                possuiIdFluig = true;
              }
              if (header.id === "log_statusErp") {
                possuiLogStatusErp = true;
              }
              if (header.id === "log_statusErpDois") {
                possuiLogStatusErpDois = true;
              }
              if (header.id === "statusErpDois") {
                possuiStatusErpDois = true;
              }
            });

            // Adiciona o campo manifestacao para o header
            if (!possuiManifestacao) {
              _this3.empresa[tipoHeader].push(manifestacao);
            }
            if (!possuiIdFluig) {
              _this3.empresa[tipoHeader].push(id_fluig);
            }
            if (!possuiLogStatusErp) {
              _this3.empresa[tipoHeader].push(log_statusErp);
            }
            if (!possuiLogStatusErpDois) {
              _this3.empresa[tipoHeader].push(log_statusErpDois);
            }
            if (!possuiStatusErpDois) {
              _this3.empresa[tipoHeader].push(statusErpDois);
            }
          }

          // ADICIONANDO O CAMPO DOCZIP NA TABELA
          if (tipoHeader === "nfeHeaderRecebidas" || tipoHeader === "nfeHeaderEmitidas") {
            // Cria o docZip para adicionar ao header nfeHeaderRecebidas
            var docZip = {
              enable: true,
              id: "docZip",
              pesq: false,
              show: false,
              titulo: "docZip"
            };

            var natOp = {
              enable: true,
              id: "natOp",
              pesq: true,
              show: true,
              titulo: "Natureza Operação"
            };

            var infAd = {
              enable: true,
              id: "inf_ad",
              pesq: false,
              show: true,
              titulo: "Informações adicionais"
            };
            var produtos = {
              enable: true,
              id: "produtos",
              pesq: false,
              show: true,
              titulo: "Produtos"
            };
            var verProc = {
              enable: true,
              id: "verProc",
              pesq: false,
              show: true,
              titulo: "Sistema"
            };
            var valorFcp = {
              enable: true,
              id: "valorFcp",
              pesq: false,
              show: true,
              titulo: "Valor do FCP"
            };
            var valorBcst = {
              enable: true,
              id: "valorBcst",
              pesq: false,
              show: true,
              titulo: "Valor do BCST"
            };
            var _data_erp = {
              enable: true,
              id: "data_erp",
              pesq: false,
              show: true,
              titulo: "Data ERP"
            };
            var _departamento = {
              enable: true,
              id: "departamento",
              pesq: false,
              show: true
            };
            var _log_statusErp = {
              enable: true,
              id: "log_statusErp",
              pesq: true,
              show: false
            };
            var _log_statusErpDois = {
              enable: true,
              id: "log_statusErpDois",
              pesq: true,
              show: false
            };
            var _statusErpDois = {
              enable: true,
              id: "statusErpDois",
              pesq: true,
              show: true
            };
            var _id_fluig = {
              enable: true,
              id: "id_fluig",
              pesq: true,
              show: true,
              titulo: "Id Fluig"
            };
            var posFechamento = {
              enable: true,
              id: "posFechamento",
              pesq: true,
              show: true,
              titulo: "Pós Faturamento"
            };

            var possuiDocZip = false;
            var possuiNatOp = false;
            var possuiInfAd = false;
            var possuiProdutos = false;
            var possuiSistem = false;
            var _possuiDataerp = false;
            var possuiFcp = false;
            var possuiBcst = false;
            var _possuiDepartamento = false;
            var possuilog_statusErp = false;
            var possuilog_statusErpDois = false;
            var _possuiStatusErpDois = false;
            var _possuiIdFluig = false;
            var possuiPosFechamento = false;

            _this3.empresa[tipoHeader].forEach(function (header) {
              if (header.id === "docZip") {
                possuiDocZip = true;
              }

              if (header.id === "natOp") {
                possuiNatOp = true;
              }

              if (header.id === "inf_ad") {
                possuiInfAd = true;
              }

              if (header.id === "verProc") {
                possuiSistem = true;
              }
              if (header.id === "valorFcp") {
                possuiFcp = true;
              }
              if (header.id === "valorBcst") {
                possuiBcst = true;
              }

              if (header.id === "data_erp") {
                _possuiDataerp = true;
              }
              if (header.id === "departamento") {
                _possuiDepartamento = true;
              }
              if (header.id === "log_statusErp") {
                possuilog_statusErp = true;
              }
              if (header.id === "log_statusErpDois") {
                possuilog_statusErpDois = true;
              }
              if (header.id === "statusErpDois") {
                _possuiStatusErpDois = true;
              }
              if (header.id === "produtos") {
                possuiProdutos = true;
              }
              if (header.id === "id_fluig") {
                _possuiIdFluig = true;
              }
              if (header.id === "posFechamento") {
                possuiPosFechamento = true;
              }
            });

            // Adiciona o docZip para o header
            try {
              if (!possuiDocZip) {
                _this3.empresa[tipoHeader].push(docZip);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiNatOp) {
                _this3.empresa[tipoHeader].push(natOp);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiInfAd) {
                _this3.empresa[tipoHeader].push(infAd);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiProdutos) {
                _this3.empresa[tipoHeader].push(produtos);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiSistem) {
                _this3.empresa[tipoHeader].push(verProc);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiFcp) {
                _this3.empresa[tipoHeader].push(valorFcp);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiBcst) {
                _this3.empresa[tipoHeader].push(valorBcst);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!_possuiDataerp) {
                _this3.empresa[tipoHeader].push(_data_erp);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!_possuiDepartamento) {
                _this3.empresa[tipoHeader].push(_departamento);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuilog_statusErp) {
                _this3.empresa[tipoHeader].push(_log_statusErp);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuilog_statusErpDois) {
                _this3.empresa[tipoHeader].push(_log_statusErpDois);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!_possuiStatusErpDois) {
                _this3.empresa[tipoHeader].push(_statusErpDois);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!_possuiIdFluig) {
                _this3.empresa[tipoHeader].push(_id_fluig);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiPosFechamento) {
                _this3.empresa[tipoHeader].push(posFechamento);
              }
            } catch (error) {
              console.log(error);
            }
          }
          if (tipoHeader === "nfseHeaderRecebidos" || tipoHeader === "nfseHeaderEmitidos") {

            if (tipoHeader === 'nfseHeaderEmitidos') {
              var pdv = {
                enable: true,
                id: "pdv",
                pesq: false,
                show: true,
                titulo: "Pdv"
              };
              var numero_pdv = {
                enable: true,
                id: "numero_pdv",
                pesq: false,
                show: true,
                titulo: "Numero do Pdv"
              };

              var data_pdv = {
                enable: true,
                id: "data_pdv",
                pesq: false,
                show: true,
                titulo: "Data Pdv"
              };

              var possuiPdv = false;
              var possuiNumeroPdv = false;
              var possuiDataPdv = false;

              _this3.empresa[tipoHeader].forEach(function (header) {
                if (header.id === 'pdv') {
                  possuiPdv = true;
                }

                if (header.id === 'numero_pdv') {
                  possuiNumeroPdv = true;
                }

                if (header.id === 'data_pdv') {
                  possuiDataPdv = true;
                }
              });
              if (!possuiPdv) {
                _this3.empresa[tipoHeader].push(pdv);
              }
              if (!possuiNumeroPdv) {
                _this3.empresa[tipoHeader].push(numero_pdv);
              }

              if (!possuiDataPdv) {
                _this3.empresa[tipoHeader].push(data_pdv);
              }
            }

            var _posFechamento = {
              enable: true,
              id: "posFechamento",
              pesq: true,
              show: true,
              titulo: "Pós Faturamento"
            };

            var _data_erp2 = {
              enable: true,
              id: "data_erp",
              pesq: false,
              show: true,
              titulo: "Data ERP"
            };

            var gzipPath = {
              enable: true,
              id: "gzipPath",
              pesq: false,
              show: false,
              titulo: "gzipPath"
            };

            var status_escrituracao = {
              enable: true,
              id: "status_escrituracao",
              pesq: false,
              show: true,
              titulo: "NFTS"
            };

            var _id_fluig2 = {
              enable: true,
              id: "id_fluig",
              pesq: true,
              show: true,
              titulo: "Id Fluig"
            };

            var _log_statusErp2 = {
              enable: true,
              id: "log_statusErp",
              pesq: false,
              show: false,
              titulo: "log integração ERP"
            };
            var _log_statusErpDois2 = {
              enable: true,
              id: "log_statusErpDois",
              pesq: false,
              show: false,
              titulo: "log integração ERP Dois"
            };
            var _statusErpDois2 = {
              enable: true,
              id: "statusErpDois",
              pesq: false,
              show: true,
              titulo: "Status ERP Dois"
            };

            var log_escrituracao = {
              enable: true,
              id: "log_escrituracao",
              pesq: false,
              show: false,
              titulo: "log_escrituracao"
            };
            var pathPdfMotor = {
              enable: true,
              id: "pathPdfMotor",
              pesq: false,
              show: false,
              titulo: "pathPdfMotor"
            };
            var nome_municipio = {
              enable: true,
              id: "nome_municipio",
              pesq: false,
              show: true,
              titulo: "Nome Município"
            };
            var simples_nacional = {
              enable: true,
              id: "simples_nacional",
              pesq: true,
              show: true,
              titulo: "Simples Nacional"
            };

            var _possuiDataerp2 = false;
            var possuiGzipPath = false;
            var possuiLogEscrituracao = false;
            var possuiNfts = false;
            var possuiNomeMunicipio = false;
            var possuiSimplesNacional = false;
            var possuiPathPdfMotor = false;
            var _possuiLogStatusErp = false;
            var _possuiLogStatusErpDois = false;
            var _possuiStatusErpDois2 = false;
            var _possuiIdFluig2 = false;
            var _possuiPosFechamento = false;

            _this3.empresa[tipoHeader].forEach(function (header) {
              if (header.id === "data_erp") {
                _possuiDataerp2 = true;
              }
              if (header.id === 'gzipPath') {
                possuiGzipPath = true;
              }
              if (header.id === "status_escrituracao") {
                possuiNfts = true;
              }
              if (header.id === "log_statusErp") {
                _possuiLogStatusErp = true;
              }
              if (header.id === "log_statusErpDois") {
                _possuiLogStatusErpDois = true;
              }
              if (header.id === "statusErpDois") {
                _possuiStatusErpDois2 = true;
              }
              if (header.id === "id_fluig") {
                _possuiIdFluig2 = true;
              }
              if (header.id === "nome_municipio") {
                possuiNomeMunicipio = true;
              }
              if (header.id === "simples_nacional") {
                possuiSimplesNacional = true;
              }
              if (header.id === "log_escrituracao") {
                possuiLogEscrituracao = true;
              }
              if (header.id === "pathPdfMotor") {
                possuiPathPdfMotor = true;
              }
              if (header.id === 'posFechamento') {
                _possuiPosFechamento = true;
              }
            });

            if (!_possuiDataerp2) {
              _this3.empresa[tipoHeader].push(_data_erp2);
            }
            if (!possuiGzipPath) {
              _this3.empresa[tipoHeader].push(gzipPath);
            }
            if (!possuiNfts) {
              _this3.empresa[tipoHeader].push(status_escrituracao);
            }
            if (!_possuiLogStatusErp) {
              _this3.empresa[tipoHeader].push(_log_statusErp2);
            }
            if (!_possuiLogStatusErpDois) {
              _this3.empresa[tipoHeader].push(_log_statusErpDois2);
            }
            if (!_possuiStatusErpDois2) {
              _this3.empresa[tipoHeader].push(_statusErpDois2);
            }
            if (!_possuiIdFluig2) {
              _this3.empresa[tipoHeader].push(_id_fluig2);
            }
            if (!possuiNomeMunicipio) {
              _this3.empresa[tipoHeader].push(nome_municipio);
            }
            if (!possuiSimplesNacional) {
              _this3.empresa[tipoHeader].push(simples_nacional);
            }
            if (!possuiLogEscrituracao) {
              _this3.empresa[tipoHeader].push(log_escrituracao);
            }
            if (!possuiPathPdfMotor) {
              _this3.empresa[tipoHeader].push(pathPdfMotor);
            }
            if (!_possuiPosFechamento) {
              _this3.empresa[tipoHeader].push(_posFechamento);
            }
          }

          _this3.empresa[tipoHeader].forEach(function (item) {
            var obj = {};
            obj["text"] = item.titulo;
            obj["value"] = item.id;
            obj["show"] = item.show;
            obj["pesq"] = item.pesq;
            obj["enable"] = item.enable;

            _this3.table.headers.push(obj);
          });

          var _loop = function _loop() {
            var objNfe = {};
            cont_c_column = 0;
            _this3.empresa[tipoHeader].forEach(function (item) {
              if (item.id.indexOf("custom") == -1 && item.id.indexOf("acoes") == -1) {
                objNfe[item.id] = auxNotas[i][item.id];
                if (item.show) {
                  document.querySelectorAll("#" + item.id).forEach(function (item) {
                    item.display = "table-cell";
                    item.removeAttribute("style");
                  });
                }
              } else if (item.id.indexOf("custom") != -1) {
                item.id;
                if (auxNotas[i].customValues != undefined && auxNotas[i].customValues.length > 0 && cont_c_column < auxNotas[i].customValues.length && auxNotas[i].customValues[cont_c_column] != null && item.id == auxNotas[i].customValues[cont_c_column].key) {
                  var newObjCustom = {};
                  if (_this3.component.name == "produtos" || _this3.component.name == "fornecedores" || _this3.component.name == "clientes") {
                    if (auxNotas[i].customValues[cont_c_column].key.split("_")[2] == empresa_id) {
                      newObjCustom["value"] = auxNotas[i].customValues[cont_c_column].value;
                      newObjCustom["key"] = auxNotas[i].customValues[cont_c_column].key;
                      objNfe[item.id] = newObjCustom;
                    } else {
                      console.log("Item possui coluna customizada que não é desta empresa");
                    }
                  } else {
                    newObjCustom["value"] = auxNotas[i].customValues[cont_c_column].value;
                    newObjCustom["key"] = auxNotas[i].customValues[cont_c_column].key;
                    objNfe[item.id] = newObjCustom;
                  }

                  cont_c_column++;
                } else {
                  var _newObjCustom = {};
                  _newObjCustom["value"] = "";
                  _newObjCustom["key"] = item.id;
                  objNfe[item.id] = _newObjCustom;
                  cont_c_column++;
                }
              }
            });
            arrayNfe.push(objNfe);
            i++;
          };

          while (i < auxNotas.length) {
            _loop();
          }

          if (tipoHeader === "nfeHeaderRecebidas" || tipoHeader === "nfeHeaderEmitidas") {
            return {
              v: _this3.setDocZip(arrayNfe, auxNotas)
            };
          } else {
            return {
              v: arrayNfe
            };
          }
        }();

        if ((typeof _ret2 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_ret2)) === "object") return _ret2.v;
      } else if (this.empresa != undefined && this.empresa[tipoHeader] != undefined && this.empresa[tipoHeader].length > 0) {
        var cont_c_column;

        var _ret4 = function () {
          var empresa_id = _this3.empresa._id;
          var auxNotas = array;
          var arrayNfe = [];
          _this3.table.headers = [];
          var i = 0;
          cont_c_column = 0;

          // ADICIONANDO O CAMPO SISTEMA NA TABELA

          if (tipoHeader === "cteHeaderTomados" || tipoHeader === "cteHeaderRecebidos") {
            var sistema = {
              enable: true,
              id: "verProc",
              pesq: true,
              show: true,
              titulo: "Sistema"
            };
            var data_erp = {
              enable: true,
              id: "data_erp",
              pesq: true,
              show: true,
              titulo: "Data ERP"
            };
            var departamento = {
              enable: true,
              id: "departamento",
              pesq: true,
              show: true,
              titulo: "Departamento"
            };
            var modal = {
              enable: true,
              id: "modal",
              pesq: true,
              show: true,
              titulo: "Modal"
            };
            var id_fluig = {
              enable: true,
              id: "id_fluig",
              pesq: true,
              show: true,
              titulo: "Id Fluig"
            };
            var log_statusErp = {
              enable: true,
              id: "log_statusErp",
              pesq: false,
              show: false,
              titulo: "log_statusErp"
            };
            var log_statusErpDois = {
              enable: true,
              id: "log_statusErpDois",
              pesq: false,
              show: false,
              titulo: "log_statusErpDois"
            };
            var statusErpDois = {
              enable: true,
              id: "statusErpDois",
              pesq: false,
              show: true,
              titulo: "statusErpDois"
            };

            var possuiModal = false;
            var possuiDepartamento = false;
            var possuiDataerp = false;
            var possuiSistema = false;
            var possuiIdFluig = false;
            var possuiLogStatusErp = false;
            var possuiLogStatusErpDois = false;
            var possuiStatusErpDois = false;

            _this3.empresa[tipoHeader].forEach(function (header) {
              if (header.id === "verProc") {
                possuiSistema = true;
              }
              if (header.id === "modal") {
                possuiModal = true;
              }
              if (header.id === "data_erp") {
                possuiDataerp = true;
              }
              if (header.id === "departamento") {
                possuiDepartamento = true;
              }
              if (header.id === "id_fluig") {
                possuiIdFluig = true;
              }
              if (header.id === "log_statusErp") {
                possuiLogStatusErp = true;
              }
              if (header.id === "log_statusErpDois") {
                possuiLogStatusErpDois = true;
              }
              if (header.id === "statusErpDois") {
                possuiStatusErpDois = true;
              }
            });

            // Adiciona o campo sistema para o header
            if (!possuiModal) {
              _this3.empresa[tipoHeader].push(modal);
            }
            if (!possuiSistema) {
              _this3.empresa[tipoHeader].push(sistema);
            }
            if (!possuiDataerp) {
              _this3.empresa[tipoHeader].push(data_erp);
            }
            if (!possuiDepartamento) {
              _this3.empresa[tipoHeader].push(departamento);
            }
            if (!possuiIdFluig) {
              _this3.empresa[tipoHeader].push(id_fluig);
            }
            if (!possuiLogStatusErp) {
              _this3.empresa[tipoHeader].push(log_statusErp);
            }
            if (!possuiLogStatusErpDois) {
              _this3.empresa[tipoHeader].push(log_statusErpDois);
            }
            if (!possuiStatusErpDois) {
              _this3.empresa[tipoHeader].push(statusErpDois);
            }
          }
          if (tipoHeader === "nfseHeaderRecebidos" || tipoHeader === "nfseHeaderEmitidos") {

            if (tipoHeader === 'nfseHeaderEmitidos') {
              var pdv = {
                enable: true,
                id: "pdv",
                pesq: false,
                show: true,
                titulo: "Pdv"
              };
              var numero_pdv = {
                enable: true,
                id: "numero_pdv",
                pesq: false,
                show: true,
                titulo: "Numero do Pdv"
              };

              var data_pdv = {
                enable: true,
                id: "data_pdv",
                pesq: false,
                show: true,
                titulo: "Data Pdv"
              };

              var possuiPdv = false;
              var possuiNumeroPdv = false;
              var possuiDataPdv = false;

              _this3.empresa[tipoHeader].forEach(function (header) {
                if (header.id === 'pdv') {
                  possuiPdv = true;
                }

                if (header.id === 'numero_pdv') {
                  possuiNumeroPdv = true;
                }

                if (header.id === 'data_pdv') {
                  possuiDataPdv = true;
                }
              });
              if (!possuiPdv) {
                _this3.empresa[tipoHeader].push(pdv);
              }
              if (!possuiNumeroPdv) {
                _this3.empresa[tipoHeader].push(numero_pdv);
              }

              if (!possuiDataPdv) {
                _this3.empresa[tipoHeader].push(data_pdv);
              }
            }
            var _data_erp3 = {
              enable: true,
              id: "data_erp",
              pesq: false,
              show: true,
              titulo: "Data ERP"
            };
            var status_escrituracao = {
              enable: true,
              id: "status_escrituracao",
              pesq: false,
              show: true,
              titulo: "NFTS"
            };
            var log_escrituracao = {
              enable: true,
              id: "log_escrituracao",
              pesq: false,
              show: false,
              titulo: "log_escrituracao"
            };
            var _log_statusErp3 = {
              enable: true,
              id: "log_statusErp",
              pesq: false,
              show: false,
              titulo: "log_statusErp"
            };
            var _log_statusErpDois3 = {
              enable: true,
              id: "log_statusErpDois",
              pesq: false,
              show: false,
              titulo: "log_statusErpDois"
            };
            var _statusErpDois3 = {
              enable: true,
              id: "statusErpDois",
              pesq: false,
              show: true,
              titulo: "statusErpDois"
            };
            var _id_fluig3 = {
              enable: true,
              id: "id_fluig",
              pesq: false,
              show: false,
              titulo: "Id Fluig"
            };
            var pathPdfMotor = {
              enable: true,
              id: "pathPdfMotor",
              pesq: false,
              show: false,
              titulo: "pathPdfMotor"
            };
            var nome_municipio = {
              enable: true,
              id: "nome_municipio",
              pesq: true,
              show: true,
              titulo: "Nome Município"
            };
            var simples_nacional = {
              enable: true,
              id: "simples_nacional",
              pesq: true,
              show: true,
              titulo: "Simples Nacional"
            };
            var numeroPedido = {
              enable: true,
              id: "numeroPedido",
              pesq: true,
              show: true,
              titulo: "Número do pedido"
            };
            var posFechamento = {
              enable: true,
              id: "posFechamento",
              pesq: true,
              show: true,
              titulo: "Pós Fechamento"
            };
            var valorTotalRecebido = {
              enable: true,
              id: "valorTotalRecebido",
              pesq: true,
              show: true,
              titulo: "Valor Recebido"
            };
            var provedor = {
              enable: true,
              id: "provedor",
              pesq: true,
              show: true,
              titulo: "Provedor"
            };
            var documento = {
              enable: true,
              id: "documento",
              pesq: true,
              show: true,
              titulo: "Documento"
            };
            var tipoTomador = {
              enable: true,
              id: "tipoTomador",
              pesq: true,
              show: true,
              titulo: "Tipo Tomador"
            };
            var nomeArquivo = {
              enable: true,
              id: "nomeArquivo",
              pesq: true,
              show: true,
              titulo: "Nome Arquivo"
            };

            var gzipPath = {
              enable: true,
              id: "gzipPath",
              pesq: false,
              show: false,
              titulo: "gzipPath"
            };

            var possuiNfts = false;
            var _possuiDataerp3 = false;
            var possuiGzipPath = false;
            var possuiNomeMunicipio = false;
            var possuiLogEscrituracao = false;
            var possuiSimplesNacional = false;
            var possuiPathPdfMotor = false;
            var _possuiLogStatusErp2 = false;
            var _possuiLogStatusErpDois2 = false;
            var _possuiStatusErpDois3 = false;
            var _possuiIdFluig3 = false;
            var possuiNumeroPedido = false;
            var possuiPosFechamento = false;
            var possuiValorTotalRecebido = false;
            var possuiProvedor = false;
            var possuiDocumento = false;
            var possuiTipoTomador = false;
            var possuiNomeArquivo = false;

            _this3.empresa[tipoHeader].forEach(function (header) {
              if (header.id === "data_erp") {
                _possuiDataerp3 = true;
              }
              if (header.id === "status_escrituracao") {
                possuiNfts = true;
              }
              if (header.id === "nome_municipio") {
                possuiNomeMunicipio = true;
              }
              if (header.id === "simples_nacional") {
                possuiSimplesNacional = true;
              }
              if (header.id === 'gzipPath') {
                possuiGzipPath = true;
              }
              if (header.id === "log_escrituracao") {
                possuiLogEscrituracao = true;
              }
              if (header.id === "log_statusErp") {
                _possuiLogStatusErp2 = true;
              }
              if (header.id === "log_statusErpDois") {
                _possuiLogStatusErpDois2 = true;
              }
              if (header.id === "statusErpDois") {
                _possuiStatusErpDois3 = true;
              }
              if (header.id === "id_fluig") {
                _possuiIdFluig3 = true;
              }
              if (header.id === "pathPdfMotor") {
                possuiPathPdfMotor = true;
              }
              if (header.id === "numeroPedido") {
                possuiNumeroPedido = true;
              }
              if (header.id === "posFechamento") {
                possuiPosFechamento = true;
              }
              if (header.id === "valorTotalRecebido") {
                possuiValorTotalRecebido = true;
              }
              if (header.id === "provedor") {
                possuiProvedor = true;
              }
              if (header.id === 'documento') {
                possuiDocumento = true;
              }
              if (header.id === 'tipoTomador') {
                possuiTipoTomador = true;
              }
              if (header.id === 'nomeArquivo') {
                possuiNomeArquivo = true;
              }
            });

            if (!_possuiDataerp3) {
              _this3.empresa[tipoHeader].push(_data_erp3);
            }
            if (!possuiNfts) {
              _this3.empresa[tipoHeader].push(status_escrituracao);
            }
            if (!_possuiLogStatusErp2) {
              _this3.empresa[tipoHeader].push(_log_statusErp3);
            }
            if (!_possuiLogStatusErpDois2) {
              _this3.empresa[tipoHeader].push(_log_statusErpDois3);
            }
            if (!_possuiStatusErpDois3) {
              _this3.empresa[tipoHeader].push(_statusErpDois3);
            }
            if (!_possuiIdFluig3) {
              _this3.empresa[tipoHeader].push(_id_fluig3);
            }
            if (!possuiNomeMunicipio) {
              _this3.empresa[tipoHeader].push(nome_municipio);
            }
            if (!possuiSimplesNacional) {
              _this3.empresa[tipoHeader].push(simples_nacional);
            }
            if (!possuiGzipPath) {
              _this3.empresa[tipoHeader].push(gzipPath);
            }
            if (!possuiLogEscrituracao) {
              _this3.empresa[tipoHeader].push(log_escrituracao);
            }
            if (!possuiPathPdfMotor) {
              _this3.empresa[tipoHeader].push(pathPdfMotor);
            }
            if (!possuiNumeroPedido) {
              _this3.empresa[tipoHeader].push(numeroPedido);
            }
            if (!possuiPosFechamento) {
              _this3.empresa[tipoHeader].push(posFechamento);
            }
            if (!possuiValorTotalRecebido) {
              _this3.empresa[tipoHeader].push(valorTotalRecebido);
            }
            if (!possuiProvedor) {
              _this3.empresa[tipoHeader].push(provedor);
            }
            if (!possuiDocumento) {
              _this3.empresa[tipoHeader].push(documento);
            }
            if (!possuiTipoTomador) {
              _this3.empresa[tipoHeader].push(tipoTomador);
            }
            if (!possuiNomeArquivo) {
              _this3.empresa[tipoHeader].push(nomeArquivo);
            }
          }

          if (tipoHeader === "nfeHeaderRecebidas" || tipoHeader === "nfeHeaderEmitidas" || tipoHeader === "nfeHeaderTransportados") {
            // ADICIONANDO O CAMPO DOCZIP NA TABELA
            // Cria o docZip para adicionar ao header nfeHeaderRecebidas
            var docZip = {
              enable: true,
              id: "docZip",
              pesq: false,
              show: false,
              titulo: "docZip"
            };

            var natOp = {
              enable: true,
              id: "natOp",
              pesq: true,
              show: true,
              titulo: "Natureza Operação"
            };

            var infAd = {
              enable: true,
              id: "inf_ad",
              pesq: false,
              show: true,
              titulo: "Informações adicionais"
            };
            var produtos = {
              enable: true,
              id: "produtos",
              pesq: false,
              show: true,
              titulo: "Produtos"
            };

            var verProc = {
              enable: true,
              id: "verProc",
              pesq: false,
              show: true,
              titulo: "Sistema"
            };
            var valorFcp = {
              enable: true,
              id: "valorFcp",
              pesq: false,
              show: true,
              titulo: "Valor do FCP"
            };
            var valorBcst = {
              enable: true,
              id: "valorBcst",
              pesq: false,
              show: true,
              titulo: "Valor do BCST"
            };
            var _data_erp4 = {
              enable: true,
              id: "data_erp",
              pesq: false,
              show: true,
              titulo: "Data ERP"
            };
            var _departamento2 = {
              enable: true,
              id: "departamento",
              pesq: false,
              show: true,
              titulo: "Departamento"
            };
            var trans_cnpj = {
              enable: true,
              id: "trans_cnpj",
              pesq: true,
              show: true,
              titulo: "CNPJ da Transportadora"
            };
            var trans_nome = {
              enable: true,
              id: "trans_nome",
              pesq: true,
              show: true,
              titulo: "Nome da Transportadora"
            };
            var trans_pesoL = {
              enable: true,
              id: "trans_pesoL",
              pesq: true,
              show: true,
              titulo: "Peso Líquido (em kg)"
            };
            var trans_pesoB = {
              enable: true,
              id: "trans_pesoB",
              pesq: true,
              show: true,
              titulo: "Peso Bruto (em kg)"
            };
            var trans_esp = {
              enable: true,
              id: "trans_esp",
              pesq: true,
              show: true,
              titulo: "Espécie dos volumes transportados"
            };
            var trans_qVol = {
              enable: true,
              id: "trans_qVol",
              pesq: true,
              show: true,
              titulo: "Quantidade de volumes transportados"
            };
            var trans_modFrete = {
              enable: true,
              id: "trans_modFrete",
              pesq: true,
              show: true,
              titulo: "Modalidade do frete"
            };
            var _log_statusErp4 = {
              enable: true,
              id: "log_statusErp",
              pesq: true,
              show: false,
              titulo: "log integração ERP"
            };
            var _log_statusErpDois4 = {
              enable: true,
              id: "log_statusErpDois",
              pesq: true,
              show: false,
              titulo: "log integração ERP Dois"
            };
            var _statusErpDois4 = {
              enable: true,
              id: "statusErpDois",
              pesq: false,
              show: true,
              titulo: "Status ERP Dois"
            };

            var _id_fluig4 = {
              enable: true,
              id: "id_fluig",
              pesq: true,
              show: true,
              titulo: "Id Fluig"
            };
            var _posFechamento2 = {
              enable: true,
              id: "posFechamento",
              pesq: true,
              show: true,
              titulo: "Pós Fechamento"
            };

            var _possuiDepartamento2 = false;
            var possuiDocZip = false;
            var possuiNatOp = false;
            var possuiInfAd = false;
            var possuiProdutos = false;
            var possuiSistem = false;
            var _possuiDataerp4 = false;
            var possuiFcp = false;
            var possuiBcst = false;
            var possui_trans_cnpj = false;
            var possui_trans_nome = false;
            var possui_trans_pesoL = false;
            var possui_trans_pesoB = false;
            var possui_trans_esp = false;
            var possui_trans_qVol = false;
            var possui_trans_modFrete = false;
            var possui_log_statusErp = false;
            var possui_log_statusErpDois = false;
            var possui_statusErpDois = false;
            var _possuiIdFluig4 = false;
            var _possuiPosFechamento2 = false;

            _this3.empresa[tipoHeader].forEach(function (header) {
              if (header.id === "docZip") {
                possuiDocZip = true;
              }

              if (header.id === "natOp") {
                possuiNatOp = true;
              }

              if (header.id === "inf_ad") {
                possuiInfAd = true;
              }
              if (header.id === "produtos") {
                possuiProdutos = true;
              }

              if (header.id === "verProc") {
                possuiSistem = true;
              }
              if (header.id === "valorFcp") {
                possuiFcp = true;
              }
              if (header.id === "valorBcst") {
                possuiBcst = true;
              }
              if (header.id === "data_erp") {
                _possuiDataerp4 = true;
              }
              if (header.id === "departamento") {
                _possuiDepartamento2 = true;
              }
              if (header.id === "trans_cnpj") {
                possui_trans_cnpj = true;
              }
              if (header.id === "trans_nome") {
                possui_trans_nome = true;
              }
              if (header.id === "trans_pesoL") {
                possui_trans_pesoL = true;
              }
              if (header.id === "trans_pesoB") {
                possui_trans_pesoB = true;
              }
              if (header.id === "trans_esp") {
                possui_trans_esp = true;
              }
              if (header.id === "trans_qVol") {
                possui_trans_qVol = true;
              }
              if (header.id === "trans_modFrete") {
                possui_trans_modFrete = true;
              }
              if (header.id === "log_statusErp") {
                possui_log_statusErp = true;
              }
              if (header.id === "log_statusErpDois") {
                possui_log_statusErpDois = true;
              }
              if (header.id === "statusErpDois") {
                possui_statusErpDois = true;
              }
              if (header.id === "id_fluig") {
                _possuiIdFluig4 = true;
              }
              if (header.id === "posFechamento") {
                _possuiPosFechamento2 = true;
              }
            });

            // Adiciona o docZip para o header
            try {
              if (!possuiDocZip) {
                _this3.empresa[tipoHeader].push(docZip);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiNatOp) {
                _this3.empresa[tipoHeader].push(natOp);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiInfAd) {
                _this3.empresa[tipoHeader].push(infAd);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiProdutos) {
                _this3.empresa[tipoHeader].push(produtos);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiSistem) {
                _this3.empresa[tipoHeader].push(verProc);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiFcp) {
                _this3.empresa[tipoHeader].push(valorFcp);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possuiBcst) {
                _this3.empresa[tipoHeader].push(valorBcst);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!_possuiDataerp4) {
                _this3.empresa[tipoHeader].push(_data_erp4);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!_possuiDepartamento2) {
                _this3.empresa[tipoHeader].push(_departamento2);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possui_trans_cnpj) {
                _this3.empresa[tipoHeader].push(trans_cnpj);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possui_trans_nome) {
                _this3.empresa[tipoHeader].push(trans_nome);
              }
            } catch (error) {
              console.log(error);
            }

            try {
              if (!possui_trans_pesoL) {
                _this3.empresa[tipoHeader].push(trans_pesoL);
              }
            } catch (error) {
              console.log(error);
            }

            try {
              if (!possui_trans_pesoB) {
                _this3.empresa[tipoHeader].push(trans_pesoB);
              }
            } catch (error) {
              console.log(error);
            }

            try {
              if (!possui_trans_esp) {
                _this3.empresa[tipoHeader].push(trans_esp);
              }
            } catch (error) {
              console.log(error);
            }

            try {
              if (!possui_trans_qVol) {
                _this3.empresa[tipoHeader].push(trans_qVol);
              }
            } catch (error) {
              console.log(error);
            }

            try {
              if (!possui_trans_modFrete) {
                _this3.empresa[tipoHeader].push(trans_modFrete);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possui_log_statusErp) {
                _this3.empresa[tipoHeader].push(_log_statusErp4);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possui_log_statusErpDois) {
                _this3.empresa[tipoHeader].push(_log_statusErpDois4);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!possui_statusErpDois) {
                _this3.empresa[tipoHeader].push(_statusErpDois4);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!_possuiIdFluig4) {
                _this3.empresa[tipoHeader].push(_id_fluig4);
              }
            } catch (error) {
              console.log(error);
            }
            try {
              if (!_possuiPosFechamento2) {
                _this3.empresa[tipoHeader].push(_posFechamento2);
              }
            } catch (error) {
              console.log(error);
            }
          }

          _this3.empresa[tipoHeader].forEach(function (item) {
            var obj = {};
            obj["text"] = item.titulo;
            obj["value"] = item.id;
            obj["show"] = item.show;
            obj["pesq"] = item.pesq;
            obj["enable"] = item.enable;

            _this3.table.headers.push(obj);
          });

          var _loop2 = function _loop2() {
            var objNfe = {};
            cont_c_column = 0;
            _this3.empresa[tipoHeader].forEach(function (item) {
              if (item.id.indexOf("custom") == -1 && item.id.indexOf("acoes") == -1) {
                objNfe[item.id] = auxNotas[i][item.id];
                if (item.show) {
                  document.querySelectorAll("#" + item.id).forEach(function (item) {
                    item.display = "table-cell";
                    item.removeAttribute("style");
                  });
                }
              } else if (item.id.indexOf("custom") != -1) {
                item.id;
                if (auxNotas[i].customValues != undefined && auxNotas[i].customValues.length > 0 && cont_c_column < auxNotas[i].customValues.length && auxNotas[i].customValues[cont_c_column] != null && item.id == auxNotas[i].customValues[cont_c_column].key) {
                  var newObjCustom = {};
                  if (_this3.component.name == "produtos" || _this3.component.name == "fornecedores" || _this3.component.name == "clientes") {
                    if (auxNotas[i].customValues[cont_c_column].key.split("_")[2] == empresa_id) {
                      newObjCustom["value"] = auxNotas[i].customValues[cont_c_column].value;
                      newObjCustom["key"] = auxNotas[i].customValues[cont_c_column].key;
                      objNfe[item.id] = newObjCustom;
                    } else {
                      console.log("Item possui coluna customizada que não é desta empresa");
                    }
                  } else {
                    newObjCustom["value"] = auxNotas[i].customValues[cont_c_column].value;
                    newObjCustom["key"] = auxNotas[i].customValues[cont_c_column].key;
                    objNfe[item.id] = newObjCustom;
                  }

                  cont_c_column++;
                } else {
                  var _newObjCustom2 = {};
                  _newObjCustom2["value"] = "";
                  _newObjCustom2["key"] = item.id;
                  objNfe[item.id] = _newObjCustom2;
                  cont_c_column++;
                }
              }
            });
            arrayNfe.push(objNfe);
            i++;
          };

          while (i < auxNotas.length) {
            _loop2();
          }

          if (tipoHeader === "nfeHeaderRecebidas" || tipoHeader === "nfeHeaderEmitidas") {
            return {
              v: _this3.setDocZip(arrayNfe, auxNotas)
            };
          } else {
            return {
              v: arrayNfe
            };
          }
        }();

        if ((typeof _ret4 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_ret4)) === "object") return _ret4.v;
      } else {
        var _ret6 = function () {
          var auxNotas = array.slice();
          var arrayNfe = [];
          var i = 0;
          if (_this3.empresa && _this3.empresa.servicos && _this3.empresa.servicos.robotizacao && _this3.empresa.servicos.robotizacao.find(function (item) {
            return item.nomeServico === "NFSE_TOMADOS";
          })) {
            // this.pagination.sortBy = 'dataServico';
            _this3.table.headers = _this3.table.getHeaders(true);
          } else {
            _this3.table.headers = _this3.table.getHeaders();
          }

          var _loop3 = function _loop3() {
            var objNfe = {};
            _this3.table.headers.forEach(function (item) {
              if (item.value.indexOf("custom") == -1 && item.value.indexOf("acoes") == -1) {
                objNfe[item.value] = auxNotas[i][item.value];
                if (document.querySelector("#" + item.value)) {
                  document.querySelector("#" + item.value).display = "table-cell";
                }
              } else if (item.value.indexOf("custom") != -1) {
                objNfe[item.value];
              }
            });
            arrayNfe.push(objNfe);
            i++;
          };

          while (i < auxNotas.length) {
            _loop3();
          }

          if (tipoHeader === "nfeHeaderRecebidas" || tipoHeader === "nfeHeaderEmitidas") {
            return {
              v: _this3.setDocZip(arrayNfe, auxNotas)
            };
          } else {
            return {
              v: arrayNfe
            };
          }
          t;
        }();

        if ((typeof _ret6 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_ret6)) === "object") return _ret6.v;
      }
    },
    setDocZip: function setDocZip(arrayNfe, auxNotas) {
      arrayNfe.map(function (item) {
        auxNotas.forEach(function (nota) {
          if (nota.chave === item.chave) {
            if (nota.docZip) {
              item.docZip = item.chave;
            }
          }
        });
      });
      return arrayNfe;
    },
    getOpenFiltro: function getOpenFiltro($event) {
      this.filtro = !this.filtro;
    },
    getSearch: function getSearch($event) {
      this.search = $event;
    },
    tagForSearch: function tagForSearch($event) {
      this.filtroForSearch = $event;
    },
    getLogConsulta: function getLogConsulta($event) {
      this.$emit("attLogConsulta", $event);
    },
    getTextPlano: function getTextPlano(plano) {
      // return arrayPlanos.indexOf(item) != -1 ? arrayPlanos[arrayPlanos.indexOf(item)] : item}}
      var planoText = plano ? plano : "-";
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_50__domain_planos_planos_js__["a" /* arrayPlanos */].length; i++) {
        var item = __WEBPACK_IMPORTED_MODULE_50__domain_planos_planos_js__["a" /* arrayPlanos */][i];
        if (item._id == plano) {
          planoText = item.text;
        }
      }
      return planoText;
    },
    emitEditEmp: function emitEditEmp($event) {
      this.$emit("emitEditEmp", $event);
    },

    save: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9(nota, index) {
        var _this4 = this;

        var arrayCustomColumn, prop;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(index == "faturamento")) {
                  _context9.next = 5;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_10__domain_conta_empresa_EmpresaService__["a" /* default */](this.$http);
                this.service.faturamento(this.conta.conta, nota._id).then(function (success) {
                  if (success) {
                    _this4.snack = true;
                    _this4.snackColor = "success";
                    _this4.snackText = "Dado salvo";
                    return true;
                  }
                }).then(function (next) {
                  if (next) {
                    _this4.table.array_todas_notas.forEach(function (item) {
                      if (item._id != nota._id) {
                        item.faturamento = "Não";
                      }
                    });
                    _this4.table.arrayNotas = _this4.table.array_todas_notas.slice();
                  }
                });
                _context9.next = 14;
                break;

              case 5:
                if (!(index.indexOf("custom_") != -1)) {
                  _context9.next = 14;
                  break;
                }

                arrayCustomColumn = [];


                for (prop in nota) {
                  if (prop.indexOf("custom") != -1) {
                    arrayCustomColumn.push(nota[prop]);
                  }
                }
                this.service = new __WEBPACK_IMPORTED_MODULE_49__domain_dataTable_commonService_CommonService_js__["a" /* default */](this.$http);
                _context9.next = 11;
                return this.service.saveCustomColumn(nota._id, arrayCustomColumn, this.component.name).then(function (x) {});

              case 11:
                this.snack = true;
                this.snackColor = "success";
                this.snackText = "Dado salvo";

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function save(_x12, _x13) {
        return _ref8.apply(this, arguments);
      }

      return save;
    }(),
    cancel: function cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Cancelado";
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__masks_masks__ = __webpack_require__(102);



var Nfe = function Nfe(_id, empresa, chave, emitNome, destNome, emitCnpj, emitCpf, emitIe, destCnpj, destCpf, origem, protocolada, serie, status, tipo, transportados, ufOrigem, manifestacao, numero, valorCofins, valorIcms, valorPis, valorIpi, valorFcp, valorBcst, valor, dtImportacao, emissao, danfe, xmlCce, cte, customValues, duplicata, produtos, statusErp, ftpPython, ftpPythonPdf, logErroFtpXml, logErroFtpPdf, log_statusErp, id_fluig, log_statusErpDois, statusErpDois, docZip, natOp, inf_ad, verProc, data_erp, departamento, trans_cnpj, trans_nome, trans_pesoL, trans_pesoB, trans_esp, trans_qVol, trans_modFrete, posFechamento) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Nfe);

  // this.emissao = ,
  this.emissao = new Date(emissao), this.numero = parseInt(numero), this.serie = serie, this.emitNome = emitNome, this.destNome = destNome, this.valor = valor, this.valorPis = valorPis, this.valorIpi = valorIpi, this.valorIcms = valorIcms, this.valorCofins = valorCofins, this.valorFcp = valorFcp, this.valorBcst = valorBcst, emitCnpj != undefined && emitCpf != undefined ? this.emitCnpj = emitCnpj + " - " + emitCpf : emitCnpj != undefined && emitCpf == undefined ? this.emitCnpj = emitCnpj : this.emitCnpj = emitCpf;
  destCnpj != undefined && destCpf != undefined ? this.destCnpj = destCnpj + " - " + destCpf : destCnpj != undefined && destCpf == undefined ? this.destCnpj = destCnpj : this.destCnpj = destCpf;
  this.chave = chave, this.emitIe = emitIe, this.origem = origem, this.protocolada = protocolada, this.status = status, this.tipo = tipo;
  this.transportados = transportados, this.ufOrigem = ufOrigem, this.manifestacao = manifestacao, this.dtImportacao = new Date(dtImportacao), this.vinculo = "", this.duplicata = duplicata, this.produtos = produtos, this.statusErp = statusErp, this.ftpPython = ftpPython, this.ftpPythonPdf = ftpPythonPdf, this.logErroFtpXml = logErroFtpXml, this.logErroFtpPdf = logErroFtpPdf, this.log_statusErp = log_statusErp, this.id_fluig = id_fluig, this.log_statusErpDois = log_statusErpDois, this.statusErpDois = statusErpDois, this.xmlCce = xmlCce, this.cte = cte, this.danfe = danfe, this._id = _id, this.empresa = empresa, this.customValues = customValues, this.docZip = docZip, this.natOp = natOp, this.inf_ad = inf_ad, this.verProc = verProc, this.data_erp = Object(__WEBPACK_IMPORTED_MODULE_1__masks_masks__["a" /* converter */])(data_erp), this.departamento = departamento, this.trans_cnpj = trans_cnpj, this.trans_nome = trans_nome, this.trans_pesoL = trans_pesoL, this.trans_pesoB = trans_pesoB, this.trans_esp = trans_esp, this.trans_qVol = trans_qVol, this.trans_modFrete = trans_modFrete, this.posFechamento = posFechamento;
};

/* harmony default export */ __webpack_exports__["a"] = (Nfe);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__masks_masks__ = __webpack_require__(102);




var Nfse = function Nfse(_id, empresa, dtEmissaoNfe, numeroNfe, vlrCredito, vlrServico, ISSRetido, codServico, codVerificacao, aliqServico, statusNFe, origem, tipo, opcaoSimples, numLote, numRPS, serieRPS, tipoRPS, dtEmissaoRPS, cnpjCpf, razao, insc, tribNfe, vlrISS, discriminacao, pathPdf, pathPdfMotor, gzipPath, customValues, statusErp, PIS, COFINS, CSLL, INSS, IR, codLei, lei, statusEmissao, razaoTomador, inscPrestador, emissaoMotor, dataServico, codMun, cnpjCpfTomador, cnpjCpfPrestador, statusDES, erroDES, erroEmissao, data_erp, status_escrituracao, id_fluig, log_statusErpDois, statusErpDois, log_statusErp, log_escrituracao, pdv, numero_pdv, data_pdv, nome_municipio, simples_nacional, posFechamento, numeroPedido, valorTotalRecebido, provedor, documento, tipoTomador, nomeArquivo) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Nfse);

  // let convertedDate = dataServico.substring(0,10);
  // convertedDate = convertedDate.split('-').reverse().join('/');
  var serviceDate = void 0;
  if (dataServico) {
    var currentServiceDate = new Date(dataServico);
    if (origem != 'MotorV2') {
      serviceDate = new Date(currentServiceDate.getTime() + 86400000);
    } else {
      serviceDate = new Date(currentServiceDate.getTime());
    }
  } else {
    serviceDate = "";
  }

  this.dtEmissaoNfe = dtEmissaoNfe ? new Date(dtEmissaoNfe) : "", this.numeroNfe = numeroNfe, this.vlrCredito = vlrCredito ? parseFloat(vlrCredito) : parseFloat(0), this.vlrServico = parseFloat(vlrServico), this.ISSRetido = ISSRetido, this.codServico = codServico, this.codVerificacao = codVerificacao,
  // this.aliqServico = parseFloat(aliqServico) == 0 ? parseFloat(aliqServico).toFixed(2) : parseFloat(aliqServico);
  // (this.aliqServico = aliqServico ? (parseFloat(aliqServico) * 100).toFixed(2) : ''),
  this.aliqServico = Object(__WEBPACK_IMPORTED_MODULE_1__util_js__["c" /* formataAliquota */])(aliqServico);
  this.statusNFe = statusNFe, this.origem = origem, this.tipo = tipo, this.opcaoSimples = opcaoSimples, this.numRPS = numRPS, this.serieRPS = serieRPS, this.numLote = numLote, this.tipoRPS = tipoRPS, this.dtEmissaoRPS = dtEmissaoRPS ? new Date(dtEmissaoRPS) : "", this.cnpjCpf = cnpjCpf, this.razao = razao, this.insc = insc, this.tribNfe = tribNfe, this.vlrISS = vlrISS, this.discriminacao = discriminacao, this.pathPdf = pathPdf, this.pathPdfMotor = pathPdfMotor, this.gzipPath = gzipPath, this.customValues = customValues, this._id = _id, this.statusErp = statusErp, this.empresa = empresa, this.PIS = PIS, this.COFINS = COFINS, this.CSLL = CSLL, this.INSS = INSS, this.IR = IR, this.codLei = codLei, this.nome_municipio = nome_municipio ? nome_municipio : '', this.simples_nacional = simples_nacional ? simples_nacional.descricao : '', this.lei = lei, this.statusEmissao = statusEmissao, this.razaoTomador = razaoTomador, this.inscPrestador = inscPrestador, this.emissaoMotor = emissaoMotor, this.dataServico = serviceDate, this.codMun = codMun, this.cnpjCpfTomador = cnpjCpfTomador, this.cnpjCpfPrestador = cnpjCpfPrestador, this.statusDES = statusDES, this.erroDES = erroDES, this.erroEmissao = erroEmissao, this.log_escrituracao = log_escrituracao, this.data_erp = Object(__WEBPACK_IMPORTED_MODULE_2__masks_masks__["a" /* converter */])(data_erp), this.status_escrituracao = status_escrituracao, this.id_fluig = id_fluig, this.log_statusErpDois = log_statusErpDois, this.statusErpDois = statusErpDois, this.log_statusErp = log_statusErp, this.pdv = pdv, this.numero_pdv = numero_pdv, this.data_pdv = data_pdv, this.posFechamento = posFechamento, this.numeroPedido = numeroPedido, this.valorTotalRecebido = valorTotalRecebido, this.documento = documento, this.provedor = provedor, this.tipoTomador = tipoTomador, this.nomeArquivo = nomeArquivo;
};

/* harmony default export */ __webpack_exports__["a"] = (Nfse);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Produtos = function Produtos(_id, xProd, cProd, NCM, uCom, CFOP, cEAN, prodRastro, fornCnpj, fornRazao, dtReg, fornId, customValues, conta, nfes) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Produtos);

    // this.emissao = ,
    // this.emissao = emissao.substring(0, emissao.indexOf("T")).split('-').reverse().join('/'),
    this.xProd = xProd != undefined ? xProd.toLocaleUpperCase() : '', this.cProd = cProd != undefined ? cProd.toLocaleUpperCase() : '', this.NCM = NCM != undefined ? NCM.toLocaleUpperCase() : '', this.uCom = uCom != undefined ? uCom.toLocaleUpperCase() : '', this.CFOP = CFOP != undefined ? CFOP.toLocaleUpperCase() : '', this.cEAN = cEAN != undefined ? cEAN.toLocaleUpperCase() : '', this.prodRastro = prodRastro;
    this.dtReg = new Date(dtReg);
    this.fornCnpj = fornCnpj != undefined ? fornCnpj.toLocaleUpperCase() : '', this.fornRazao = fornRazao != undefined ? fornRazao.toLocaleUpperCase() : '', this.fornId = fornId != undefined ? fornId.toLocaleUpperCase() : '', this._id = _id, this.customValues = customValues, this.conta = conta != undefined ? conta.toLocaleUpperCase() : '', this.nfes = nfes;
};

/* harmony default export */ __webpack_exports__["a"] = (Produtos);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_conta_empresa_Empresa_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableEmpresas = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableEmpresas, _Table);

    function TableEmpresas() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableEmpresas);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableEmpresas.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableEmpresas)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableEmpresas, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers;
            headers = [{ text: "Ações", value: "acoes", show: true, pesq: false, enable: false }, { text: "CNPJ", value: "cnpj", show: true, pesq: true, enable: true }, { text: "Razão Social", value: "razao", show: true, pesq: true, enable: true }, { text: "Grupo", value: "grupo", show: true, pesq: false, enable: true }, { text: "Apelido", value: "apelido", show: true, pesq: true, enable: true }, { text: "Endereço", value: "endereco", show: true, pesq: false, enable: true }, { text: "Bairro", value: "bairro", show: true, pesq: false, enable: true }, { text: "Complemento", value: "complemento", show: true, pesq: false, enable: true }, { text: "CCM", value: "ccm", show: true, pesq: false, enable: true }, { text: "IE", value: "ie", show: true, pesq: false, enable: true }, { text: "CEP", value: "cep", show: true, pesq: false, enable: true }, { text: "Município", value: "municipio", show: true, pesq: false, enable: true }, { text: "UF", value: "uf", show: true, pesq: false, enable: true }, { text: "COD Município", value: "codMun", show: true, pesq: false, enable: true }, { text: "Colaboradores", value: "colaboradores", show: true, pesq: false, enable: true }, { text: "Faturamento", value: "faturamento", show: true, pesq: false, enable: true }, { text: "Certificado", value: "certificado", show: true, pesq: false, enable: true }, { text: "nfeTask", value: "nfeTask", show: false, pesq: false, enable: false }, { text: "cteTask", value: "cteTask", show: false, pesq: false, enable: false }, { text: "enviaEmails", value: "enviaEmails", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }, { text: "tknIntegracao", value: "tknIntegracao", show: false, pesq: false, enable: false }, { text: "Data de Cadastro", value: "dtReg", show: true, pesq: false, enable: true }, { text: "Bloqueada", value: "bloqueada", show: true, pesq: true, enable: true }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas, faturamento, pagination) {
            var newArray = arrayNotas;
            this.loading = false;
            //pega os colaboradores ativos.
            for (var i = 0; i < notas.length; i++) {
                var colabAtivos = [];
                for (var j = 0; j < notas[i].colaboradores.length; j++) {
                    if (notas[i].colaboradores[j].status) {
                        colabAtivos.push(notas[i].colaboradores[j]);
                    }
                }
                newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_conta_empresa_Empresa_js__["a" /* default */](notas[i].empresa.cnpj, notas[i].empresa.razao, notas[i].empresa.grupo, notas[i].empresa.apelido, notas[i].empresa.ie, notas[i].empresa.ccm, notas[i].empresa.endereco, notas[i].empresa.bairro, notas[i].empresa.complemento, notas[i].empresa.cep, notas[i].empresa.municipio, notas[i].empresa.uf, notas[i].empresa.codMun, notas[i].empresa._id == faturamento ? 'Sim' : 'Não', colabAtivos, notas[i].empresa.certificado, notas[i].empresa.nfeTask, notas[i].empresa.cteTask, notas[i].empresa.enviaEmails, notas[i].empresa._id, notas[i].empresa.tknIntegracao, notas[i].empresa.dtReg, notas[i].empresa.bloqueada));

                if (pagination != undefined) {
                    this.pagination = pagination;
                } else {
                    this.pagination.sortBy = 'razao';
                    this.pagination.descending = false;
                }
            }
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableEmpresas;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableEmpresas);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_conta_ContaService__ = __webpack_require__(48);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item", "empresa", "component"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false,
      currentFilter: '',
      total_cte_nao_tomada: '',
      total_cte_tomada: '',
      total_nfe_emitida: '',
      total_nfe_recebida: '',
      total_nfse_emitida: '',
      total_nfse_recebida: ''
    };
  },
  methods: {
    getMouthData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(label, month) {
        var resp, auxList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.currentFilter = label;
                this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_conta_ContaService__["a" /* default */](this.$http);
                this.activeGlobalLoader();
                _context.next = 5;
                return this.service.relatorioContasNotas('5c798e5640bd8100176b1650', this.item._id, month);

              case 5:
                resp = _context.sent;


                if (resp && resp.conta) {
                  auxList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.item.arrayEmpresas));

                  if (auxList && auxList.length > 0) {
                    auxList.map(function (comp, key) {
                      if (comp.empresa._id === resp.conta.empresas[key].empresa._id) {
                        comp.empresa.nfe_recebida = resp.conta.empresas[key].empresa.nfe_recebida;
                        comp.empresa.nfe_emitida = resp.conta.empresas[key].empresa.nfe_emitida;
                        comp.empresa.nfse_recebida = resp.conta.empresas[key].empresa.nfse_recebida;
                        comp.empresa.nfse_emitida = resp.conta.empresas[key].empresa.nfse_emitida;
                        comp.empresa.cte_tomada = resp.conta.empresas[key].empresa.cte_tomada;
                        comp.empresa.cte_nao_tomada = resp.conta.empresas[key].empresa.cte_nao_tomada;
                      }
                    });

                    this.item.arrayEmpresas = auxList;
                  }
                  this.total_nfe_recebida = resp.conta.total_nfe_recebida;
                  this.total_nfe_emitida = resp.conta.total_nfe_emitida;
                  this.total_cte_tomada = resp.conta.total_cte_tomada;
                  this.total_cte_nao_tomada = resp.conta.total_cte_nao_tomada;
                  this.total_nfse_recebida = resp.conta.total_nfse_recebida;
                  this.total_nfse_emitida = resp.conta.total_nfse_emitida;
                }
                this.desactiveGlobalLoader();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMouthData(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getMouthData;
    }(),
    maskCnpj: function maskCnpj(cnpj) {
      // console.log('CNPJ', cnpj)
      return cnpj != undefined ? cnpj.length > 11 ? cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4") : "";
    },
    item_consulta: function item_consulta(item) {
      console.log('ITEM', item);
      return '';
    },
    openTabela: function openTabela() {
      this.openDialog = true;
    },
    downloadExcelReport: function downloadExcelReport() {
      var id = "tabela-relatorio-contas-" + this.item._id;

      var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
      var j = 0;
      var tab = document.getElementById(id);
      var sa;

      for (j = 0; j < tab.rows.length; j++) {
        tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
      }

      tab_text = tab_text + "</table>";
      tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
      tab_text = tab_text.replace(/<img[^>]*>/gi, "");
      tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        txtArea1.document.open("txt/html", "replace");
        txtArea1.document.write(tab_text);
        txtArea1.document.close();
        txtArea1.focus();
        sa = txtArea1.document.execCommand("SaveAs", true, "Say Thanks to Sumit.xls");
      } else sa = window.open('data:application/vnd.ms-excel,' + escape(tab_text));

      return sa;
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item", "empresa", "component"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false
    };
  },
  computed: {
    sortArrayItemDesc: function sortArrayItemDesc() {
      return this.item.rela_arrayLogins && this.item.rela_arrayLogins.length > 0 ? this.item.rela_arrayLogins.sort(function (a, b) {
        return a < b ? 1 : a > b ? -1 : 0;
      }) : [];
    }
  },
  methods: {
    openTabelaParcela: function openTabelaParcela() {
      this.openDialog = true;
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__btnDownload_BtnDownload_vue__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__btnVisualizar_BtnVisualizar_vue__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__btnManifestar_BtnManifestar_vue__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__btnEmail_BtnEmail_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__btnUserEmpresa_BtnUserEmpresa_vue__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_notas_cte_CteService__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__btnInfClientFornc_BtnInfClientFornc__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__btnInfNfses_btnInfNfses_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rmvCertificado_RmvCertificado_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rmvColaborador_RmvColaborador_vue__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__btnLinkIntegracao_LinkIntegracao_vue__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reenvioEmail_ReenvioEmail_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_dataTable_commonTable_actionsHeader_btnNovaNota_BtnNovaNota_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_loggedArea_configuracoes_configuracoesAutomacao_BtnNovoImovel_BtnNovoImovel_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonTable_coluna_actions_btnDownload_btnXml_BtnXml_vue__ = __webpack_require__(165);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "alert", "nota", "empresa", "component", "table", "IBGE"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false
    };
  },
  components: {
    btnDownload: __WEBPACK_IMPORTED_MODULE_0__btnDownload_BtnDownload_vue__["a" /* default */],
    btnVisualizar: __WEBPACK_IMPORTED_MODULE_1__btnVisualizar_BtnVisualizar_vue__["a" /* default */],
    btnManifestar: __WEBPACK_IMPORTED_MODULE_2__btnManifestar_BtnManifestar_vue__["a" /* default */],
    btnEmail: __WEBPACK_IMPORTED_MODULE_3__btnEmail_BtnEmail_vue__["a" /* default */],
    btnInfClientFornc: __WEBPACK_IMPORTED_MODULE_7__btnInfClientFornc_BtnInfClientFornc__["a" /* default */],
    btnInfNfses: __WEBPACK_IMPORTED_MODULE_8__btnInfNfses_btnInfNfses_vue__["a" /* default */],
    btnUserEmpresa: __WEBPACK_IMPORTED_MODULE_4__btnUserEmpresa_BtnUserEmpresa_vue__["a" /* default */],
    rmvColaborador: __WEBPACK_IMPORTED_MODULE_10__rmvColaborador_RmvColaborador_vue__["a" /* default */],
    rmvCertificado: __WEBPACK_IMPORTED_MODULE_9__rmvCertificado_RmvCertificado_vue__["a" /* default */],
    btnLinkIntegracao: __WEBPACK_IMPORTED_MODULE_11__btnLinkIntegracao_LinkIntegracao_vue__["a" /* default */],
    reenvioEmail: __WEBPACK_IMPORTED_MODULE_12__reenvioEmail_ReenvioEmail_vue__["a" /* default */],
    btnNovaNota: __WEBPACK_IMPORTED_MODULE_13__components_dataTable_commonTable_actionsHeader_btnNovaNota_BtnNovaNota_vue__["a" /* default */],
    btnNovoImovel: __WEBPACK_IMPORTED_MODULE_14__pages_loggedArea_configuracoes_configuracoesAutomacao_BtnNovoImovel_BtnNovoImovel_vue__["a" /* default */],
    btnXml: __WEBPACK_IMPORTED_MODULE_15__commonTable_coluna_actions_btnDownload_btnXml_BtnXml_vue__["a" /* default */]
  },
  computed: {},
  methods: {
    attTableEmp: function attTableEmp(value) {
      this.$emit("attTableEmp", value);
    },
    emitEditEmp: function emitEditEmp() {
      this.$emit("emitEditEmp", this.nota.item);
    },

    getPDFXml: function getPDFXml(id, option) {
      if (this.component.name.indexOf("NFe") != -1) {
        this.service = new __WEBPACK_IMPORTED_MODULE_5__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
      } else {
        this.service = new __WEBPACK_IMPORTED_MODULE_6__domain_notas_cte_CteService__["a" /* default */](this.$http);
      }
      return;
      switch (option) {
        case 1:
          this.getPDF(id);
          break;
        case 2:
          this.getPDF(id);
          this.getXml(id);
          break;
      }
    },
    getPDF: function getPDF(id) {
      var _this = this;

      if (!this.nota.item.danfe) {
        if (this.component.name.indexOf("NFe") != -1) {
          this.service.getDanfe(id).then(function (danfe) {
            return _this.nota.item.danfe = danfe;
          });
        } else {
          this.service.getDacte(id).then(function (danfe) {
            return _this.nota.item.danfe = danfe;
          });
        }
      }
    },
    getXml: function getXml(id) {
      var _this2 = this;

      if (!this.nota.item.xml) {
        this.service.getXml(id).then(function (xml) {
          return _this2.nota.item.xml = xml;
        });
      }
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__btnXml_BtnXml_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__btnPdf_BtnPdf_vue__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__btnIptu_BtnIptu_vue__ = __webpack_require__(564);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    btnXml: __WEBPACK_IMPORTED_MODULE_0__btnXml_BtnXml_vue__["a" /* default */],
    btnPdf: __WEBPACK_IMPORTED_MODULE_1__btnPdf_BtnPdf_vue__["a" /* default */],
    btnIptu: __WEBPACK_IMPORTED_MODULE_2__btnIptu_BtnIptu_vue__["a" /* default */]
  },
  props: ["nota", "component"],
  data: function data() {
    return {
      direction: "right",
      fab: false,
      fling: false,
      hover: false,
      tabs: true,
      top: false,
      right: false,
      bottom: false,
      left: false,
      transition: "slide-x-transition"
    };
  },
  updated: function updated() {
    this.$nextTick(function () {});
  },
  computed: {
    activeFab: function activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    }
  },
  watch: {
    top: function top(val) {
      this.bottom = !val;
    },
    right: function right(val) {
      this.left = !val;
    },
    bottom: function bottom(val) {
      this.top = !val;
    },
    left: function left(val) {
      this.right = !val;
    }
  },
  methods: {}
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnXml_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40fef0b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnXml_vue__ = __webpack_require__(560);
function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40fef0b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnXml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40fef0b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnXml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_notas_cte_CteService__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_notas_nfse_NfseService__ = __webpack_require__(22);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota", "component"],
  data: function data() {
    return {
      xml: ""
    };
  },
  updated: function updated() {
    this.$nextTick(function () {});
  },
  computed: {
    desabilitar: function desabilitar() {

      if (this.component.name.toLowerCase().indexOf("nfse") != -1) {
        if (this.nota.item.gzipPath !== undefined) {
          return false;
        } else {
          return true;
        }
      }
      //caso não ter o gzipPath bloquear recebidas
      if (this.component.name.toLowerCase().indexOf("nfe") != -1) {
        if (this.nota.item.docZip !== undefined && this.nota.item.docZip.length) {
          return false;
        } else {
          return true;
        }
      }
    }
  },
  methods: {
    setXml: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.component.name.indexOf("NFe") != -1) {
                  this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                } else if (this.component.name == "CTE") {
                  this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_notas_cte_CteService__["a" /* default */](this.$http);
                } else if (this.component.name == "NFSE") {
                  this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_notas_nfse_NfseService__["a" /* default */](this.$http);
                }

                _context.next = 3;
                return this.service.getXml(this.nota.item._id).then(function (xml) {
                  _this.xml = xml;
                });

              case 3:
                this.setDownload();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setXml() {
        return _ref.apply(this, arguments);
      }

      return setXml;
    }(),
    setDownload: function setDownload() {
      var nome = this.component.name != "NFSE" ? this.nota.item.chave : this.nota.item.cnpjCpf + "_" + this.nota.item.numeroNfe;
      var a = document.querySelector("#dLinkXml");
      a.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(this.xml));
      a.setAttribute("download", nome + ".xml");
      a.click();
      a.removeAttribute("href");
      a.removeAttribute("download");

      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_notas_cte_CteService__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_notas_nfse_NfseService__ = __webpack_require__(22);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: ["nota", "component", "pathPdfMotor"],
  data: function data() {
    return {
      danfe: ""
    };
  },
  updated: function updated() {
    this.$nextTick(function () {});
  },
  computed: {
    disableButton: function disableButton() {

      if (this.component.name.toLowerCase().indexOf("nfse") != -1 && this.pathPdfMotor) {
        return !this.nota.item.pathPdfMotor;
      }
      if (this.component.name.toLowerCase().indexOf("nfse") != -1 && !this.pathPdfMotor) {
        return !this.nota.item.pathPdf;
      }

      if (this.component.name.toLowerCase().indexOf("nfe") != -1) {
        if (this.nota.item.docZip !== undefined && this.nota.item.docZip.length) {
          return false;
        } else {
          return true;
        }
      }
    }
  },
  watch: {},
  methods: {
    setDanfe: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.component.name.indexOf("NFe") != -1)) {
                  _context.next = 7;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                _context.next = 4;
                return this.service.getDanfe(this.nota.item._id).then(function (danfe) {
                  _this.danfe = danfe;
                });

              case 4:
                this.setDownload();
                _context.next = 19;
                break;

              case 7:
                if (!(this.component.name.indexOf("CTE") != -1)) {
                  _context.next = 14;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_notas_cte_CteService__["a" /* default */](this.$http);
                _context.next = 11;
                return this.service.getDacte(this.nota.item._id).then(function (danfe) {
                  return _this.danfe = danfe;
                });

              case 11:
                this.setDownload();
                _context.next = 19;
                break;

              case 14:
                if (!(this.component.name.toLowerCase().indexOf("nfse") != -1)) {
                  _context.next = 19;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_notas_nfse_NfseService__["a" /* default */](this.$http);
                _context.next = 18;
                return this.service.getPdfById(this.nota.item._id, !this.pathPdfMotor).then(function (danfe) {
                  return _this.danfe = danfe;
                });

              case 18:
                this.setDownload();

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setDanfe() {
        return _ref.apply(this, arguments);
      }

      return setDanfe;
    }(),
    setDownload: function setDownload() {
      var a = document.querySelector("#dLinkPdf");
      a.setAttribute("href", "data:application/pdf;base64," + encodeURIComponent(this.danfe));
      var nome = this.nota.item.chave ? this.nota.item.chave : this.nota.item.numeroNfe;
      a.setAttribute("download", nome + ".pdf");
      a.click();
      a.removeAttribute("href");
      a.removeAttribute("download");

      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_automacaoFiscal_iptu_IptuService__ = __webpack_require__(56);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: ["nota", "component"],
  data: function data() {
    return {
      danfe: ""
    };
  },
  updated: function updated() {
    this.$nextTick(function () {});
  },
  computed: {},
  watch: {},
  methods: {
    setDanfe: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.component.name.indexOf("Iptu") != -1)) {
                  _context.next = 5;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_automacaoFiscal_iptu_IptuService__["a" /* default */](this.$http);
                _context.next = 4;
                return this.service.getPdfById(this.nota.item._id).then(function (danfe) {
                  _this.danfe = danfe;
                });

              case 4:
                this.setDownload();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setDanfe() {
        return _ref.apply(this, arguments);
      }

      return setDanfe;
    }(),
    setDownload: function setDownload() {
      var a = document.querySelector("#dLinkPdf");
      a.setAttribute("href", "data:application/pdf;base64," + encodeURIComponent(this.danfe));
      var nome = this.nota.item.inscricao;
      a.setAttribute("download", nome + ".pdf");
      a.click();
      a.removeAttribute("href");
      a.removeAttribute("download");

      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__btnNFe_BtnNFe__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__btnCTe_BtnCTe__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__btnCce_BtnCce__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__btnNfse_BtnNFSe__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__btnIptu_BtnIptu_vue__ = __webpack_require__(582);


//
//
//
//
//
//
//
//
//







//  v-if="(nota.item.xmlCce.length > 0)"
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota", "component"],
  components: {
    btnNFe: __WEBPACK_IMPORTED_MODULE_3__btnNFe_BtnNFe__["a" /* default */],
    btnCce: __WEBPACK_IMPORTED_MODULE_5__btnCce_BtnCce__["a" /* default */],
    btnCTe: __WEBPACK_IMPORTED_MODULE_4__btnCTe_BtnCTe__["a" /* default */],
    btnNFSe: __WEBPACK_IMPORTED_MODULE_6__btnNfse_BtnNFSe__["a" /* default */],
    btnIptu: __WEBPACK_IMPORTED_MODULE_7__btnIptu_BtnIptu_vue__["a" /* default */]
  },
  data: function data() {
    return {
      menu: false,
      dialog: false,
      danfeB64: "",
      dacceB64: "",
      items: [{
        id: "danfe",
        title: "Nota Fiscal - DANFE",
        mostrar: true,
        content: null
      }, {
        id: "cce",
        title: "Carta de correção - Cce ",
        mostrar: true,
        quantidade: 0,
        content: null
      }],
      modal: { id: "", text: "", content: "", info: "" }
    };
  },

  watch: {},
  computed: {},
  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.component.name.indexOf("NFe") != -1) {
        var cce = null;
        var qntidade_cce = this.nota.item.xmlCce ? this.nota.item.xmlCce.length : 0;
        qntidade_cce > 0 ? cce = true : cce = false;
        this.items.forEach(function (item) {
          item.id == "cce" ? (item.mostrar = cce, item.quantidade = qntidade_cce) : null;
        });
      }
    });
  },
  methods: {
    getDanfe: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id, item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.danfeB64 = "";
                this.menu = true;

                if (this.nota.item.danfe) {
                  _context.next = 6;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                _context.next = 6;
                return this.service.getDanfe(id).then(function (danfe) {
                  this.nota.item.danfe = danfe;
                  this.danfeB64 = danfe;
                });

              case 6:
                this.open(item);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDanfe(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getDanfe;
    }(),
    getCce: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id, indice) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                _context2.next = 3;
                return this.service.getDacce(id, indice).then(function (dacce) {
                  this.modal.content = dacce;
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCce(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return getCce;
    }(),
    open: function open(item) {
      this.modal.content = "";

      this.modal.text = item.title;
      this.modal.id = item.id;
      item.id == "danfe" ? (this.modal.content = this.danfeB64, this.modal.info = "") : this.modal.info = "Selecione uma Cce para visualizar";
      this.dialog = true;
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__ = __webpack_require__(14);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota"],
  data: function data() {
    return {
      dialog: false,
      danfeB64: ""
    };
  },

  watch: {},
  computed: {},
  methods: {
    getDanfe: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.nota.item.danfe) {
                  _context.next = 4;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                _context.next = 4;
                return this.service.getDanfe(id).then(function (danfe) {
                  return _this.nota.item.danfe = danfe;
                });

              case 4:
                if (this.nota.item.danfe != null) {
                  this.dialog = true;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDanfe(_x) {
        return _ref.apply(this, arguments);
      }

      return getDanfe;
    }()
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_cte_CteService__ = __webpack_require__(21);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota"],
  data: function data() {
    return {
      dialog: false
    };
  },

  watch: {},
  computed: {},
  methods: {
    getDacte: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.nota.item.danfe) {
                  _context.next = 4;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_cte_CteService__["a" /* default */](this.$http);
                _context.next = 4;
                return this.service.getDacte(id).then(function (danfe) {
                  return _this.nota.item.danfe = danfe;
                });

              case 4:

                if (this.nota.item.danfe != null) {
                  this.dialog = true;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDacte(_x) {
        return _ref.apply(this, arguments);
      }

      return getDacte;
    }()
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__ = __webpack_require__(14);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota"],
  data: function data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "Clique na Cce para exibi-lá"
    };
  },

  watch: {},
  computed: {},
  methods: {
    getCce: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id, indice) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                _context.next = 3;
                return this.service.getDacce(id, indice).then(function (dacce) {
                  this.danfeB64 = dacce;
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCce(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getCce;
    }(),
    setPdfData: function setPdfData() {
      if (this.danfeB64) {
        this.text_info = "";
        if (document.getElementById("pdf")) {
          document.getElementById("pdf").remove();
        }
        var embed = document.createElement("EMBED");
        embed.setAttribute("src", "data:application/pdf;base64," + encodeURIComponent(this.danfeB64));
        embed.setAttribute("id", "pdf");
        document.querySelector("#bodyNFeVinculada").appendChild(embed);
      } else {
        this.text_info = "Cce não encontrada em nosso sistema, disponivel somente em consulta individual no sefaz";
      }
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_NfseService__ = __webpack_require__(22);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota"],
  data: function data() {
    return {
      dialog: false,
      pdfB64: undefined
    };
  },

  watch: {},
  computed: {},
  methods: {

    getPdfById: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var motor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.pdfB64 = null;
                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_NfseService__["a" /* default */](this.$http);
                _context.next = 4;
                return this.service.getPdfById(id, motor);

              case 4:
                this.pdfB64 = _context.sent;

                if (this.pdfB64 != null) {
                  this.dialog = true;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPdfById(_x) {
        return _ref.apply(this, arguments);
      }

      return getPdfById;
    }()
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_automacaoFiscal_iptu_IptuService__ = __webpack_require__(56);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota"],
  data: function data() {
    return {
      dialog: false
    };
  },

  watch: {},
  computed: {},
  methods: {
    getPdfById: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id, pathIPTU) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.nota.item.danfe) {
                  _context.next = 4;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_automacaoFiscal_iptu_IptuService__["a" /* default */](this.$http);
                _context.next = 4;
                return this.service.getPdfById(id, pathIPTU).then(function (danfe) {
                  return _this.nota.item.danfe = danfe;
                });

              case 4:

                if (this.nota.item.danfe != null) {
                  this.dialog = true;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPdfById(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getPdfById;
    }()
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_notas_cte_CteService__ = __webpack_require__(21);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["chave", "empresa", "component", "nota"],
  data: function data() {
    return {
      rules: {
        tam: function tam(value) {
          if (value && (value.length > 200 || value.length < 15)) {
            return "Justificativa necessita estar entre 15 à 200 caracteres";
          } else {
            return true;
          }
        },
        empty: function empty(value) {
          return !!value || "Necess\xE1rio enviar uma justificativa";
        }
      },
      eventoSelecionado: {},
      snackbar: false,
      y: "bottom",
      x: null,
      mode: "",
      timeout: 5000,
      text: "",
      menu: false,
      menuX: 0,
      menuY: 0,
      show: false,
      dialog: false,
      carregando: false
    };
  },
  computed: {
    items: function items() {
      if (this.component.name.indexOf('CTE') != -1) {
        return [{
          title: "Desacordo",
          tooltip: "Manifestar a não realização de uma operação",
          icon: "cancel",
          tpEvento: "210240" // - Operação não realizada
        }];
      } else {
        return [{
          title: "Confirmação da Operação",
          tooltip: "Confirmar uma operação concluida e bem sucedida",
          icon: "check_circle",
          tpEvento: "210200" // - Confirmação da Operação
        }, {
          title: "Ciência da Operação",
          tooltip: "Efetua Ciência da operação para a SEFAZ \n e habilita o arquivamento da nota",
          icon: "adjust",
          tpEvento: "210210" // - Ciência da Operação
        }, {
          title: "Desconhecimento da Operação",
          tooltip: "Manifestar desconhecimento de uma operação",
          icon: "help",
          tpEvento: "210220" // - Desconhecimento da Operação
        }, {
          title: "Operação não realizada",
          tooltip: "Manifestar a não realização de uma operação",
          icon: "cancel",
          tpEvento: "210240" // - Operação não realizada
        }];
      }
    },

    disableButton: function disableButton() {
      if (this.component.name.toLowerCase().indexOf("cte") != -1) {
        if (this.nota.item.manifestacao === 'Desacordo') {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  methods: {
    vereficaOperacao: function vereficaOperacao(evento) {
      if (evento) {
        var tpEvento = evento.tpEvento;
        if (tpEvento == "210240") {
          //se for diferente de ciência da operação habilitar campo para justificar a operação
          this.eventoSelecionado = evento;
          this.dialog = true;
        } else {
          this.manifestar(evento);
        }
      }
    },
    validarJust: function validarJust(eventoSelecionado) {
      if (this.component.name.indexOf('CTE') != -1) {
        if (this.$refs.just.validate()) {
          this.carregando = true;
          this.desacordo(eventoSelecionado);
        } else {
          this.$refs.just.valid = false;
        }
      } else {
        if (this.$refs.just.validate()) {
          this.carregando = true;
          this.manifestar(eventoSelecionado);
        } else {
          this.$refs.just.valid = false;
        }
      }
    },
    manifestar: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(evento) {
        var _this = this;

        var tpEvento, just;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tpEvento = evento.tpEvento;
                just = evento.hasOwnProperty("just") ? evento.just : undefined;

                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                _context.next = 5;
                return this.service.manifestar(this.chave, tpEvento, this.empresa, just).then(function (message) {
                  return _this.text = message;
                }).then(function (reset) {
                  _this.eventoSelecionado = {};
                  _this.eventoSelecionado["just"] = '';
                  _this.dialog = false;
                  _this.carregando = false;
                });

              case 5:
                if (this.text != "") {
                  this.snackbar = true;
                  this.menu = false;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function manifestar(_x) {
        return _ref.apply(this, arguments);
      }

      return manifestar;
    }(),
    desacordo: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(evento) {
        var _this2 = this;

        var just;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                just = evento.hasOwnProperty("just") ? evento.just : undefined;

                this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_notas_cte_CteService__["a" /* default */](this.$http);
                _context2.next = 4;
                return this.service.desacordo(this.chave, this.empresa, just).then(function (message) {
                  return _this2.text = message;
                }).then(function (reset) {
                  _this2.eventoSelecionado = {};
                  _this2.eventoSelecionado["just"] = '';
                  _this2.dialog = false;
                  _this2.carregando = false;
                });

              case 4:
                if (this.text != "") {
                  this.snackbar = true;
                  this.menu = false;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function desacordo(_x2) {
        return _ref2.apply(this, arguments);
      }

      return desacordo;
    }(),
    setPositionMenu: function setPositionMenu(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnEmail_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae82b73_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnEmail_vue__ = __webpack_require__(590);
function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ae82b73"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae82b73_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["id_nota", "component", "table", "conta", "zip", "empresa"],
  data: function data() {
    var _ref;

    return _ref = {
      dialog: false,
      email: "",
      emailRules: [function (v) {
        return !!v || "Campo obrigatório";
      }],
      snackbar: false,
      y: "bottom",
      x: null,
      mode: "",
      timeout: 5000,
      text: "",
      chkDanfe: true,
      chkXml: true,
      activator: null,
      attach: null,
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      index: -1,
      items: [{ header: "Selecione uma opção ou digite um e-mail" }],
      nonce: 1,
      menu: false,
      mailDelete: "",
      model: []
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "x", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "search", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "y", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "auxEmail", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "sendingMail", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dialogDelete", false), _ref;
  },
  mounted: function mounted() {
    // this.$nextTick(function() {});
  },
  watch: {
    model: function model(val, prev) {
      var _this = this;

      if (val.length === prev.length) return;
      this.model = val.map(function (v) {
        if (v != undefined && v.text != undefined) {
          return v;
        }
        if (typeof v === "string" && /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v)) {
          v = {
            text: v,
            color: _this.colors[_this.nonce - 1]
          };
          _this.items.push(v);

          _this.nonce++;
          return v;
        }
      });
    },
    dialog: function dialog(val, prev) {
      if (val) {
        if (this.zip) {
          if (this.id_nota && this.id_nota.length == 0) {
            this.table.snackAlert();
            this.table.snack.text = "Necessário selecionar ao menos uma nota.";
            this.table.snack.show = true;
            return this.dialog = false;
          }
        }
        this.model = [];
        this.items = [{ header: "Selecione uma opção ou digite um e-mail" }];
        var obj = {};

        if (this.conta.favEmails && this.conta.favEmails.length > 0) {
          var favMails = this.conta.favEmails.slice();
          for (var i = 0; i < favMails.length; i++) {
            var mail = {};
            mail["text"] = favMails[i];
            mail["color"] = this.colors[Math.floor(Math.random() * this.colors.length)];
            this.items.push(mail);
          }
        } else if (!this.conta.favEmail) {
          this.model.push(obj);
          this.items.push(obj);
          obj["text"] = this.conta.email;
          obj["color"] = "info";
        }
      }
    }
  },
  methods: {
    enviarEmail: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.model.length >= 1)) {
                  _context.next = 25;
                  break;
                }

                this.sendingMail = true;
                i = 0;

              case 3:
                if (!(i < this.model.length)) {
                  _context.next = 22;
                  break;
                }

                if (!(this.model[i].text.length > 0 && /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(this.model[i].text))) {
                  _context.next = 18;
                  break;
                }

                if (this.component.name == "NFSE") {
                  this.chkDanfe = false;
                }
                this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_dataTable_commonService_CommonService_js__["a" /* default */](this.$http);
                this.table.resetAlert();

                if (!this.zip) {
                  _context.next = 14;
                  break;
                }

                this.activeGlobalLoader();
                _context.next = 12;
                return this.service.zipEmailNotas(this.id_nota, this.model[i].text, this.chkXml, this.chkDanfe, this.component.name, this.empresa._id).then(function (res) {
                  _this2.table.snack.text = "Erro ao enviar E-mail";
                  if (res.ok) {
                    _this2.table.snack.text = "Motor Fiscal enviou E-mail com as informações da nota";
                    _this2.dialog = false;
                  }
                  _this2.desactiveGlobalLoader();
                });

              case 12:
                _context.next = 16;
                break;

              case 14:
                _context.next = 16;
                return this.service.enviarEmail(this.id_nota, this.model[i].text, this.chkXml, this.chkDanfe, this.component.name, this.empresa._id).then(function (res) {
                  _this2.table.snack.text = "Erro ao enviar E-mail";
                  if (res.ok) {
                    _this2.table.snack.text = "Motor Fiscal enviou E-mail com as informações da nota";
                    _this2.dialog = false;
                  }
                });

              case 16:
                _context.next = 19;
                break;

              case 18:
                this.table.snack.text = "E-mail inv\xE1lido: " + this.model[i].text;

              case 19:
                i++;
                _context.next = 3;
                break;

              case 22:
                this.sendingMail = false;
                _context.next = 26;
                break;

              case 25:
                this.table.snack.text = "Insira algum E-mail.";

              case 26:
                this.table.snack.show = true;
                this.saveMailsFavoritos();

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function enviarEmail() {
        return _ref2.apply(this, arguments);
      }

      return enviarEmail;
    }(),
    saveMailsFavoritos: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var favItems, i, userFavMails;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                favItems = [];

                for (i = 1; i < this.items.length; i++) {
                  favItems.push(this.items[i].text);
                }
                userFavMails = {
                  favEmails: favItems
                };

                this.conta["favEmails"] = favItems.slice();
                this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
                this.service.editar(userFavMails, this.conta.id_usuario);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveMailsFavoritos() {
        return _ref3.apply(this, arguments);
      }

      return saveMailsFavoritos;
    }(),
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    edit: function edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.auxEmail = item.text;
        this.index = index;
      } else {
        if (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(this.editing.text) == false) {
          item.text = this.auxEmail;
        }
        this.auxEmail = "";
        this.editing = null;
        this.index = -1;
      }
    },
    middleDel: function middleDel(item) {
      this.dialogDelete = true;
      this.mailDelete = item;
    },
    delMail: function delMail(action) {
      this.dialogDelete = false;
      if (action) {
        this.items.splice(this.items.indexOf(this.mailDelete), 1);
        this.saveMailsFavoritos();
      }
      this.mailDelete = undefined;
    },
    filter: function filter(item, queryText, itemText) {
      if (item.header) return false;

      var hasValue = function hasValue(val) {
        return val != null ? val : "";
      };

      var text = hasValue(itemText);
      var query = hasValue(queryText);

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dataTable_RenderTableNFe_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_conta_usuario_formUsuario_FormUsuario_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "empresa", "alert", "nota", "table"],
  components: {
    RenderTableNFe: __WEBPACK_IMPORTED_MODULE_2__components_dataTable_RenderTableNFe_vue__["default"],
    FormUsuario: __WEBPACK_IMPORTED_MODULE_3__components_conta_usuario_formUsuario_FormUsuario_vue__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    this.$options.components.RenderTableNFe = __webpack_require__(46).default;
  },
  data: function data() {
    return {
      dialog: false,
      dialog2: false,
      sendAttTable: false,
      resetForm: false,
      formEmp: { show: false, titulo: "", btnSuccess: "" },
      route: this.$router.history.current.path,
      empEdit: {},
      edit: false,
      getDadosForm: false

    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$session.exists()) {
        if (this.$session.get("jwt").gravatarProfile != undefined) {
          this.avatarProfile = this.$session.get("jwt").gravatarProfile.thumbnailUrl + "?s=200";
        }
      }
    });
  },
  updated: function updated() {},
  watch: {
    dialog: function dialog(newV, oldV) {
      if (!newV) {
        this.edit = newV;
      }
    }
  },
  computed: {},
  methods: {
    emitEditEmp: function emitEditEmp($event) {
      this.formEmp.titulo = "Editar Empresa: ";
      this.formEmp.btnSuccess = "Salvar";
      this.empEdit = $event;
      this.edit = true;
      this.dialog = true;
    },
    showFormCadastrar: function showFormCadastrar(tipo) {
      this.formEmp.titulo = "Cadastro de " + tipo + ":";
      this.formEmp.btnSuccess = "Cadastrar";
      this.empEdit = {};
      this.edit = false;
      this.resetForm = true;
      this.dialog = true;
    },
    salvarDados: function salvarDados() {
      this.getDadosForm = true;
    },
    changResetForm: function changResetForm(value) {
      this.resetForm = value;
    },
    emitDadosForm: function emitDadosForm(value) {
      var envDados = false;
      if (value != false) {
        this.dialog = false;
        this.edit = false;
        if (value.tipo.component == "empresa") {
          this.service = new __WEBPACK_IMPORTED_MODULE_5__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
        } else if (value.tipo.component == "usuario") {
          this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
        } else {
          throw new Error("Serviço de configuração não codificado");
        }

        envDados = true;
      } else {
        this.alert.snackAlert();
        this.alert.snack.text = "Verificamos que possuem campos com erros.";
        this.alert.snack.show = true;
      }
      this.getDadosForm = false;

      if (envDados) {
        var method = void 0;
        var id = void 0;
        var body = {};
        if (value.tipo.acao == "create") {
          id = this.conta.conta;
          method = "cadastrar";

          body["colaborador"] = value.dados;
          var empresas = [];
          empresas.push(this.nota.item._id);
          body["empresas"] = empresas;
        } else {
          body = value.dados;
          id = value.dados._id;
          method = "editar";
        }

        this.service[method](body, id).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resp) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:

                    this.attTableEmp(resp);

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function next(_x) {
            return _ref.apply(this, arguments);
          }

          return next;
        }());
      }
    },
    attSendTable: function attSendTable(value) {
      this.sendAttTable = value;
    },

    attTableEmp: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resp) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.service = new __WEBPACK_IMPORTED_MODULE_5__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
                _context2.next = 3;
                return this.service.getEmpresasConta(this.conta.conta).then(function (body) {
                  _this.table.arrayNotas = [];
                  _this.table.qnt_total_notas = body.empresas.length;
                  _this.table.qnt_total_notas = body.empresas.length + body.emprs_not_admin.length;
                  var arrayEmpresas = body.empresas.concat(body.emprs_not_admin);
                  _this.table.setNota(_this.table.arrayNotas, arrayEmpresas, body.faturamento);

                  // this.table.arrayNotas = [];
                  // this.table.qnt_total_notas = body.empresas.length;
                  // this.table.setNota(
                  //   this.table.arrayNotas,
                  //   body.empresas,
                  //   body.faturamento,
                  //   this.table.pagination
                  // );
                  _this.table.array_todas_notas = _this.table.arrayNotas.slice();
                  _this.table.setPages(_this.table.arrayNotas.length, _this.table.pagination.rowsPerPage);
                });

              case 3:

                this.sendAttTable = true;
                this.alert.snackDanger();
                resp.body.message != undefined && resp.body.message.length != 0 ? this.alert.snack.text = resp.body.message : this.alert.snack.text = resp.infoMessage.msg;
                if (resp.ok) {
                  this.alert.snackSuccess();
                }
                this.alert.snack.show = true;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function attTableEmp(_x2) {
        return _ref2.apply(this, arguments);
      }

      return attTableEmp;
    }()
  },
  beforeMount: function beforeMount() {
    this.$nextTick(function () {});
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_conta_usuario_FormUsuario_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["displayFlex", "create", "edit", "getDadosForm", "resetForm", "empEdit", "conta", "formEmp"],
  components: {},
  data: function data() {
    return {
      nomeRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        return (/^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]{3,90}$/.test(v) || "Digite um nome válido"
        );
      }],
      emailRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        return (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) || "Digite um e-mail válido"
        );
      }],
      passRules: [function (v) {
        if (v.length == 0) {
          return "Campo obrigatório";
        } else {
          return true;
        }
      }],
      formUsuario: new __WEBPACK_IMPORTED_MODULE_1__domain_conta_usuario_FormUsuario_js__["a" /* default */](),
      valid: true,
      menu0: false,
      show1: false,
      show2: false,
      show3: false,
      arrayEstados: [],
      select: [],
      arrayCidades: [],
      estado: "",
      cidade: "",
      itemsEmp: [],
      logConsulta: "",
      route: this.$router.history.current.path
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      this.getEstados;
      this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
      if (this.edit && this.conta.id_usuario != undefined) {
        this.service.getUsuarioId(this.conta.id_usuario).then(function (success) {
          _this.formUsuario.form.items.forEach(function (item) {
            if (success != undefined && success.body[item.item_id] != undefined) {
              item.valor = success.body[item.item_id];
            }
          });
        });
      }

      if (this.formEmp) {
        this.getEmpresas();
      }
    });
  },
  updated: function updated() {},
  watch: {
    resetForm: function resetForm(newV, oldV) {
      if (this.resetForm) {
        this.$refs.form.reset();
        this.$emit("changResetForm", false);
      }
    },
    estado: function estado() {
      this.getCidades();
    },
    getDadosForm: function getDadosForm(newV, oldV) {
      if (this.$refs.form.validate() && this.getDadosForm) {
        var dadosForm = {};
        this.emitDadosForm();
      } else if (!this.$refs.form.validate()) {
        this.$emit("emitDadosForm", false);
      }
    }
  },
  computed: {
    empresasMenu: function empresasMenu() {
      return this.$store.getters.empresasMenu;
    }
  },
  methods: {
    filter: function filter(item, queryText, itemText) {
      if (item.header) return false;

      var hasValue = function hasValue(val) {
        return val != null ? val : "";
      };

      var text = hasValue(itemText);
      var query = hasValue(queryText);

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
    },
    remove: function remove(item) {
      var index = this.select.indexOf(item);
      if (index >= 0) this.select.splice(index, 1);
    },
    getEmpresas: function getEmpresas() {
      // this.service = new EmpresaService(this.$http);
      // this.service.getEmpresasConta(this.conta.conta).then(body => {
      var body = this.empresasMenu;
      this.itemsEmp = body.empresas ? body.empresas.concat(body.emprs_not_admin) : [];
      // });
    },
    emitDadosForm: function emitDadosForm() {

      var dados = {};
      this.formUsuario.form.items.forEach(function (item) {
        dados[item.item_id] = item.valor;
      });
      dados["estado"] = this.estado;
      dados["cidade"] = this.cidade;

      if (this.create) {
        var obj = {};
        dados["password"] = "teste";
        obj["dados"] = dados;
        obj["tipo"] = { component: "usuario" };
        if (this.formEmp) {
          var arrayIdEmp = [];
          this.select.forEach(function (item) {
            return arrayIdEmp.push(item.empresa._id);
          });
          obj["empresas"] = arrayIdEmp;
        }
        obj.tipo["acao"] = this.edit == true ? "edit" : "create";
        this.$emit("emitDadosForm", obj);
      } else {
        this.$emit("emitDadosForm", dados);
      }
    },
    validateDate: function validateDate(field, item) {
      if (field.target.value.length == 10) {
        item.valor = field.target.value.split("-").join("");
        item.data = field.target.value.split("-").reverse().join("-");
      }
    },
    formatDate: function formatDate(date, menu) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "-" + month + "-" + year;
    }
  },
  beforeMount: function beforeMount() {
    this.$nextTick(function () {});
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FormUsuario = function () {
    function FormUsuario() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FormUsuario);

        this.form = this.form();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FormUsuario, [{
        key: 'form',
        value: function form() {
            return {
                fechar: false,
                items: [{ type: 'T', text: "Nome", item_id: 'nome', valor: null, prepIcon: 'person', class: "input-required", mask: null }, { type: 'T', text: "Sobrenome", item_id: 'sobrenome', valor: null, prepIcon: 'person', class: null, mask: null }, { type: 'T', text: "E-mail (Login)", item_id: 'email', valor: null, prepIcon: 'mail', class: "input-required", mask: null }, { type: 'T', text: "Telefone", item_id: 'telefone', valor: null, prepIcon: 'phone', class: null, mask: "(##) ##### - ####" }, { type: 'D', text: "Data de nascimento", item_id: 'dtNascimento', valor: null, data: null, index: this.menu0, class: null, mask: "##-##-####" }]
            };
        }
    }]);

    return FormUsuario;
}();

/* harmony default export */ __webpack_exports__["a"] = (FormUsuario);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["forn", "table", "component"],
  updated: function updated() {
    this.$nextTick(function () {});
  },
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      dialog: false,
      notifications: false,
      sound: false,
      widgets: false,
      noDataText: true
    };
  },
  watch: {
    dialog: function dialog(newV, oldV) {
      this.noDataText = true;
    }
  },
  components: {},
  methods: {
    printInfos: function printInfos() {
      var conteudo = document.getElementById("infoBody_" + this.forn._id).innerHTML,
          tela_impressao = window.open("Motor Fiscal");
      tela_impressao.document.write("<html><head><title>Motor Fiscal - " + this.component.text + "</title>");
      tela_impressao.document.write("<style>html,body {margin: 0;padding: 0;border: 0;}.v-list__tile__content {text-align: left;flex: 1 1 auto;overflow: hidden;display: flex;align-items: flex-start;justify-content: center;flex-direction: column;}.v-list__tile__title {font-weight: bold;height: 24px;line-height: 24px;position: relative;text-align: left;}.fundo_destaque {background-color: whitesmoke;padding-left: 10px;}.flex.md3 {flex-basis: 25%;flex-grow: 0;max-width: 25%;}.flex.xs6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}.child-flex > *,.flex {flex: 1 1 auto;max-width: 100%;}.layout.wrap {flex-wrap: wrap;}   .layout.row {flex-direction: row;}.layout {display: flex;flex: 1 1 auto;flex-wrap: nowrap;min-width: 0;}</style>");
      tela_impressao.document.write("</head><body >");
      tela_impressao.document.write(conteudo);
      tela_impressao.document.write("</body></html>");

      tela_impressao.window.print();
      tela_impressao.window.close();
      //   #infoBody
    },

    nomeColumn: function nomeColumn(i) {
      var nomeColumn = "";
      this.table.headers.forEach(function (element) {
        if (element.value == i) {
          nomeColumn = element.text;
        }
      });
      if (nomeColumn != "") {
        this.noDataText = false;
      }
      return nomeColumn;
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_util__ = __webpack_require__(57);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota", "table", "component"],
  updated: function updated() {
    this.$nextTick(function () {});
  },
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      dialog: false,
      notifications: false,
      sound: false,
      widgets: false,
      noDataText: true,
      tributacao: null,
      simples: null
    };
  },
  watch: {
    dialog: function dialog(newV, oldV) {
      this.noDataText = true;
    }
  },
  components: {},
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.$nextTick(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _this = this;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        Object(__WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_util__["b" /* findTributacao */])(this.nota.tribNfe).then(function (res) {
                          _this.tributacao = res;
                        });
                        Object(__WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_util__["a" /* findSimples */])(this.nota.opcaoSimples).then(function (res) {
                          _this.simples = res;
                        });

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              })));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    printInfos: function printInfos() {
      var conteudo = document.getElementById("infoBody_" + this.nota._id).innerHTML,
          tela_impressao = window.open("Motor Fiscal");
      tela_impressao.document.write("<html><head><title>Motor Fiscal - " + this.component.text + "</title>");
      tela_impressao.document.write("<style>html,body {margin: 0;padding: 0;border: 0;}.v-list__tile__content {text-align: left;flex: 1 1 auto;overflow: hidden;display: flex;align-items: flex-start;justify-content: center;flex-direction: column;}.v-list__tile__title {font-weight: bold;height: 24px;line-height: 24px;position: relative;text-align: left;}.fundo_destaque {background-color: whitesmoke;padding-left: 10px;}.flex.md3 {flex-basis: 25%;flex-grow: 0;max-width: 25%;}.flex.xs6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}.child-flex > *,.flex {flex: 1 1 auto;max-width: 100%;}.layout.wrap {flex-wrap: wrap;}   .layout.row {flex-direction: row;}.layout {display: flex;flex: 1 1 auto;flex-wrap: nowrap;min-width: 0;}</style>");
      tela_impressao.document.write("</head><body >");
      tela_impressao.document.write(conteudo);
      tela_impressao.document.write("</body></html>");

      tela_impressao.window.print();
      tela_impressao.window.close();
      //   #infoBody
    },

    nomeColumn: function nomeColumn(i) {
      var nomeColumn = "";
      this.table.headers.forEach(function (element) {
        if (element.value == i) {
          nomeColumn = element.text;
        }
      });
      if (nomeColumn != "") {
        this.noDataText = false;
      }
      return nomeColumn;
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_conta_empresa_certificado_CertificadoService_js__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "empresa", "alert", "nota", "table"],
  components: {},

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  updated: function updated() {},
  watch: {},
  computed: {},
  methods: {
    rmvCertificado: function rmvCertificado() {
      var _this = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_0__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);
      this.service.removerDaConta(this.nota.item._id).then(function (res) {
        if (res) {
          res.body.message != undefined && res.body.message.length != 0 ? _this.alert.snack.text = res.body.message : _this.alert.snack.text = res.infoMessage.msg;
          if (res.ok) {
            _this.alert.snackSuccess();
            _this.$emit("attTableEmp", res);
          } else {
            _this.alert.snackDanger();
          }
          _this.alert.snack.show = true;
        }
      });
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "empresa", "alert", "nota", "table"],
  components: {},

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  updated: function updated() {},
  watch: {},
  computed: {},
  methods: {
    rmvColaborador: function rmvColaborador() {
      var _this = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_0__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
      this.service.removerDaConta(this.conta.conta, this.nota.item._id, this.empresa._id).then(function (res) {
        _this.$emit("attTableEmp", res);
      });
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_token_TokenService__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "alert", "nota", "empresa", "component", "table"],
  data: function data() {
    return {
      dialogIntegracao: false,
      loader: null,
      loading: false,
      dialogConfirmacao: false,
      page1: true,
      pageVerTokens: false,
      emprVinculoSelecionada: undefined,
      tknBuscado: ""
    };
  },

  methods: {
    buscaToken: function buscaToken() {
      var _this = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_token_TokenService__["a" /* default */](this.$http);
      this.service.buscaToken(this.nota.item._id).then(function (res) {
        if (res.ok) {
          _this.tknBuscado = res.body.token;
        } else {
          _this.tknBuscado = "";
        }
      });
    },
    acaoBtnVinculadas: function acaoBtnVinculadas() {
      var _this2 = this;

      if (this.pageVerTokens) {
        if (!this.emprVinculoSelecionada) {
          this.alert.snackDefault();
          this.alert.snack.text = "Necessário selecionar alguma empresa";
          this.alert.snack.show = true;
          return;
        }
        this.loader = "loading";
        this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_token_TokenService__["a" /* default */](this.$http);
        this.service.vinculaEmpr(this.nota.item._id, this.emprVinculoSelecionada._id).then(function (res) {
          if (res.ok) {
            _this2.attTableEmp();
          } else {
            _this2.alert.snackSuccess();
            _this2.alert.snack.text = "Motor fiscal não conseguiu vincular";
            _this2.alert.snack.show = true;
            _this2.resetDialog();
            _this2.limparLoadingBtn();
          }
        });
      } else {
        this.page1 = false;
        this.pageVerTokens = true;
      }
    },
    middle: function middle() {
      if (this.nota && this.nota.item) {
        if (this.nota.item.tknIntegracao && (this.nota.item.tknIntegracao.token || this.nota.item.tknIntegracao.refEmpresa)) {
          this.dialogConfirmacao = true;
        } else {
          this.gerarToken();
        }
      }
    },
    getRazaoEmprVinculada: function getRazaoEmprVinculada(idEmprVinculada) {
      return this.table.array_todas_notas.filter(function (empr) {
        if (empr) {
          if (empr._id == idEmprVinculada) {
            return empr;
          }
        }
      })[0].razao;
    },
    copyToken: function copyToken(element) {
      var doc = document;
      var text = doc.getElementById(element);
      if (doc.body.createTextRange) {
        // ms
        var range = doc.body.createTextRange();
        range.moveToElementText(text);
        range.select();
        doc.execCommand("copy");
      } else if (window.getSelection) {
        var selection = window.getSelection();
        var range = doc.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
        doc.execCommand("copy");
      } else {
        console.warn("Could not select text in node: Unsupported browser.");
      }
    },

    gerarToken: function gerarToken() {
      var _this3 = this;

      this.loader = "loading";
      this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_token_TokenService__["a" /* default */](this.$http);
      this.service.nvToken(this.nota.item._id).then(function (res) {
        if (res.ok) {
          _this3.attTableEmp();
        } else {
          _this3.alert.snackSuccess();
          _this3.alert.snack.text = "Motor fiscal não conseguiu gerar um novo token";
          _this3.alert.snack.show = true;
          _this3.limparLoadingBtn();
        }
      });
    },
    limparLoadingBtn: function limparLoadingBtn() {
      clearInterval(this.timer);
      this.loading = false;
      this.timer = null;
      this.loader = null;
    },
    setLabel: function setLabel(item) {
      return item.razao + " - \n      " + (item.cnpj.length > 11 ? "CNPJ:  " + item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : item.cnpj.length == 11 ? "CPF: " + item.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") + " " : "");
    },
    getEmpresasComTokensCadastrados: function getEmpresasComTokensCadastrados() {
      var _this4 = this;

      return this.table.array_todas_notas.filter(function (empr) {
        if (empr) {
          if (empr.tknIntegracao && empr.tknIntegracao.token) {
            if (!(empr._id == _this4.nota.item._id)) {
              return empr;
            }
          }
        }
      });
    },

    resetDialog: function resetDialog() {
      this.page1 = true;
      this.pageVerTokens = false;
      this.emprVinculoSelecionada = undefined;
    },
    attTableEmp: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resp) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
                _context.next = 3;
                return this.service.getEmpresasConta(this.conta.conta).then(function (body) {
                  _this5.table.arrayNotas = [];
                  _this5.table.qnt_total_notas = body.empresas.length;
                  _this5.table.setNota(_this5.table.arrayNotas, body.empresas, body.faturamento, _this5.table.pagination);
                  _this5.table.array_todas_notas = _this5.table.arrayNotas.slice();
                  _this5.table.setPages(_this5.table.arrayNotas.length, _this5.table.pagination.rowsPerPage);

                  _this5.sendAttTable = true;
                  _this5.resetDialog();
                  _this5.alert.snack.text = "Novo token foi gerado";
                  _this5.alert.snackSuccess();

                  _this5.limparLoadingBtn();
                  _this5.alert.snack.show = true;
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function attTableEmp(_x) {
        return _ref.apply(this, arguments);
      }

      return attTableEmp;
    }()
  },
  watch: {
    dialogIntegracao: function dialogIntegracao(newV, oldV) {
      this.resetDialog();
    },
    loader: function loader() {
      var _this6 = this;

      if (this.loader != null) {
        var l = this.loader;
        this[l] = !this[l];

        this.timer = setTimeout(function () {
          return _this6[l] = false;
        }, 20000000);

        this.loader = null;
      }
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_conta_usuario_FormUsuario_js__ = __webpack_require__(180);

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "empresa", "alert", "nota", "table", "cert"],
  components: { formUsuario: __WEBPACK_IMPORTED_MODULE_2__domain_conta_usuario_FormUsuario_js__["a" /* default */] },

  updated: function updated() {},
  data: function data() {
    return {
      usuario: {
        colaborador: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.nota)),
        empresas: [this.empresa._id]
      },
      reenvio: true
    };
  },

  watch: {},
  computed: {},
  methods: {
    reenviar: function reenviar() {
      var _this = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_1__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
      this.service.cadastrar(this.usuario, this.conta.conta, this.reenvio).then(function (res) {
        _this.$emit("attTableEmp", res);
      });
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNovaNota_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263239de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNovaNota_vue__ = __webpack_require__(619);
function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-263239de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNovaNota_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263239de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNovaNota_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_notas_nfse_NfseService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(35);






var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["empresa", "table", "component", "conta", "edit", "nota"],
  data: function data() {
    return {
      inscricaoMunicipal: null,
      dialog: false,
      dialogAviso: false,
      failureMessages: '',
      cnpjAviso: '',
      dataAviso: '',
      valorAviso: '',
      cnpj: '',
      razao: '',
      estado: '',
      municipio: '',
      email: '',
      cep: '',
      bairro: '',
      logradouro: '',
      numero: '',
      complemento: '',
      codigoTributacao: 'Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.',
      naturezaOperacao: 'Tributação no município',
      regimeTributacao: 'Estimativa',
      issqn: 'Belo Horizonte',
      valor: '',
      telefone: '',
      date2: null,
      discriminacao: '',
      cepMax: '',
      showDate: false,
      arrayEstados: [],
      arrayMunicipios: [],
      valid: true,
      date: null,
      nowDate: new Date().toISOString().slice(0, 10),
      today: new Date(),
      jsonDuplicidade: {},
      // dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      mask: { cnpj: "", cep: "", date: '##/##/####', telefone: '' },
      cpfRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (cpf) {
        var sum = void 0,
            rest = void 0;
        if (cpf === undefined || cpf === null || cpf.trim().length === 0 || cpf === "00000000000" || cpf === "11111111111" || cpf === "22222222222" || cpf === "33333333333" || cpf === "44444444444" || cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777" || cpf === "88888888888" || cpf === "99999999999") {
          return "CPF inválido";
        }
        cpf = cpf.replace(".", "").replace(".", "").replace("-", "");

        sum = 0;
        for (var i = 1; i <= 9; i++) {
          sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        rest = sum * 10 % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(9, 10))) {
          return "CPF inválido";
        }

        sum = 0;
        for (var _i = 1; _i <= 10; _i++) {
          sum = sum + parseInt(cpf.substring(_i - 1, _i)) * (12 - _i);
        }
        rest = sum * 10 % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(10, 11))) {
          return "CPF inválido";
        }
        return true;
      }],
      cnpjRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        if (v == null) {
          return false;
        }
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

        if (/0{14}/.test(v)) return "CNPJ inválido";

        for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]) {}
        if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]) {}
        if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        return true;
      }],
      razaoRules: [function (v) {
        return !!v || "Campo obrigatório";
      }],
      dateRules: [function (v) {
        return !!v && v.length > 7 || "Data inválida";
      }, function (v) {
        if (v) {
          try {
            var currentYear = new Date().toISOString().substring(0, 10).split('-');
            var date = v.substring(0, 2) + '-' + v.substring(2, 4) + '-' + v.substring(4, 8);
            date = date.split('-').reverse();
            var year = date[0];
            date = date.join('-');

            var dateAux = Date.parse(date);
            var today = Date.parse(new Date().toISOString().substring(0, 10));

            var validDate = new Date(date).toISOString().substring(0, 10);
            if (date != validDate) return 'Data inválida';
            if (!new Date(date).toISOString()) return 'Data inválida';
            if (today < dateAux) return 'Data inválida';
            if (Number(currentYear[0] - 1) > Number(year)) return 'Data inválida';

            return true;
          } catch (err) {
            return 'Data inválida';
          }
        } else {
          return "Campo obrigatório";
        }
      }],
      emailRules: [function (v) {
        return !!v && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail inválido';
      }],
      telefoneRules: [function (v) {
        return !!v && v.length > 9 || 'Telefone inválido';
      }]
    };
  },
  computed: {
    ufArray: function ufArray() {
      return this.$store.getters.ufArray;
    },

    getEstados: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.arrayEstados = this.ufArray;
                this.arrayMunicipios = [];
                // this.resource = this.$resource(
                //   "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
                // );
                // this.resource.query().then(
                //   success => {
                //     this.arrayMunicipios = [];
                //     this.arrayEstados = success.body;

                //     return success.body;
                //   },
                //   failed => {
                //     this.arrayEstados = [];
                //     return [];
                //   }
                // );

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEstados() {
        return _ref.apply(this, arguments);
      }

      return getEstados;
    }(),
    computedDateFormatted: {
      get: function get() {
        return this.formatDate(this.date);
      }
    }
  },
  watch: {
    date: function date(val) {
      this.dateFormatted = this.formatDate(this.date);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getEstados;
    });
  },
  methods: (_methods = {
    eventDate: function eventDate(event) {
      this.date = event;
      this.$refs.dataInput.focus();
    },
    validateDate: function validateDate() {
      if (this.date2 && this.date2.length === 8) {
        var stringAux = '';
        stringAux = this.date2.substring(0, 2) + '-' + this.date2.substring(2, 4) + '-' + this.date2.substring(4, 8);
        this.date = stringAux.split("-").reverse().join("-");
      } else {
        return;
      }
    },
    formatDate: function formatDate(date, menu) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "-" + month + "-" + year;
    },
    handleOpenDialogInsert: function handleOpenDialogInsert() {
      this.codigoTributacao = '0403-0/04-88 Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.';
      this.naturezaOperacao = 'Tributação no município';
      this.regimeTributacao = 'Estimativa';
      this.issqn = 'Belo Horizonte';
      this.dialog = true;
    },
    handleOpenDialog: function handleOpenDialog() {
      this.cnpj = this.nota.cnpjCpf;
      if (this.nota.cnpjCpf.length > 11) {
        this.mask.cnpj = "##.###.###/####-##";
      } else {
        this.mask.cnpj = "###.###.###-##";
      }

      this.failureMessages = this.nota.erroEmissao ? this.nota.erroEmissao : '';

      this.codigoTributacao = '0403-0/04-88 Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.';
      this.naturezaOperacao = 'Tributação no município';
      this.regimeTributacao = 'Estimativa';
      this.issqn = 'Belo Horizonte';
      this.valor = this.nota.vlrServico;
      this.razao = this.nota.razao;
      this.date2 = this.nota.dataServico.toLocaleDateString('pt-BR');
      this.date = this.date2.split('/').reverse().join('-');
      this.inscricaoMunicipal = this.nota.insc;
      for (var i in this.arrayEstados) {
        if (this.arrayEstados[i].sigla === this.nota.emissaoMotor.estado) {
          this.estado = this.arrayEstados[i];
          this.getMunicipios(this.nota.emissaoMotor.codMun);
          break;
        }
      }

      this.email = this.nota.emissaoMotor.email, this.cep = this.nota.emissaoMotor.cep, this.mask.cep = "#####-###";
      this.bairro = this.nota.emissaoMotor.bairro, this.logradouro = this.nota.emissaoMotor.logradouro, this.numero = this.nota.emissaoMotor.numero, this.complemento = this.nota.emissaoMotor.complemento, this.discriminacao = this.nota.discriminacao;
      this.telefone = this.nota.emissaoMotor.telefone;

      this.dialog = true;
    },

    getMunicipios: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this = this;

        var codMun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.estado) {
                  _context2.next = 5;
                  break;
                }

                this.resource = this.$resource("https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + this.estado.id + "/municipios");
                this.resource.query().then(function (success) {
                  if (codMun.length > 1) {
                    if (success.body.length) {
                      for (var i in success.body) {
                        if (success.body[i].id == codMun) {
                          _this.municipio = success.body[i];
                          break;
                        }
                      }
                    }
                  }
                  _this.arrayMunicipios = success.body;
                }, function (failed) {
                  _this.arrayMunicipios = [];
                });
                _context2.next = 6;
                break;

              case 5:
                return _context2.abrupt("return");

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMunicipios() {
        return _ref2.apply(this, arguments);
      }

      return getMunicipios;
    }(),
    isNumber: function isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    maskValor: function maskValor(valor, event) {
      if (valor != null) {
        var v = valor;
        v = this.addVirgula(v);
        v = v.replace(/(\d+)(\d{3},\d{2})$/g, "$1.$2");
        var qtdLoop = (v.length - 3) / 3;
        var count = 0;
        while (qtdLoop > count) {
          count++;
          v = v.replace(/(\d+)(\d{3}.*)/, "$1.$2");
        }
        v = v.replace(/^(0+)(\d)/g, "$2");
        this.valor = v;
      }
    },

    addVirgula: function addVirgula(v) {
      v = v.replace(/\D/g, ""); //Remode tudo o que não é dígito
      v = v.replace(/(\d+)(\d{2})/, "$1,$2");
      return v;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "formatDate", function formatDate(date) {
    if (!date) return null;

    var _date$split3 = date.split('-'),
        _date$split4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
        year = _date$split4[0],
        month = _date$split4[1],
        day = _date$split4[2];

    return day + "/" + month + "/" + year;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "parseDate", function parseDate(date) {
    if (!date) return null;

    var _date$split5 = date.split('/'),
        _date$split6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_date$split5, 3),
        month = _date$split6[0],
        day = _date$split6[1],
        year = _date$split6[2];

    return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "trocaCampoCpfCnpj", function trocaCampoCpfCnpj(e, v) {
    if (!v || v && v.length == 0) {
      this.mask.cnpj = "";
    } else {
      if (this.trocaCPFCNPJ && v && v.length >= 12) {
        this.mask.cnpj = "##.###.###/####-##";
      } else if (v && v.length >= 11) {
        this.trocaCPFCNPJ = true;
        this.mask.cnpj = "###.###.###-###";
      } else {
        this.trocaCPFCNPJ = false;
        this.mask.cnpj = "###.###.###-##";
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "trocaCampoDate", function trocaCampoDate(e, v) {
    if (!v || v && v.length == 0) {
      this.mask.date = "";
    } else {
      this.mask.date = "##/##/####";
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "trocaCampoCep", function trocaCampoCep(e, v) {
    if (!v || v && v.length == 0) {
      this.mask.cep = "";
    } else {
      this.mask.cep = "#####-###";
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "verificaCNPJ", function verificaCNPJ($event) {
    this.setRazao();
    this.consultaCNPJbd();
    this.returnEmpresa($event);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "setRazao", function setRazao() {
    var _this2 = this;

    this.service.getAPIReceita(this.cnpj).then(function (success) {
      if (success && success.body) {
        if (success.body.hasOwnProperty("nome")) {
          _this2.razao = success.body.nome;
        }
        if (success.body.hasOwnProperty("uf") && success.body.uf.length > 0) {
          _this2.arrayEstados.forEach(function (estado) {
            if (success.body.uf.toLocaleLowerCase() == estado.sigla.toLocaleLowerCase()) {
              _this2.estado = estado;
              _this2.empresa["uf"] = estado.id;
            }
          });
        }
        _this2.$refs.cnpj.validate();
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "consultaCNPJbd", function consultaCNPJbd() {
    var _this3 = this;

    this.service.getEmpresasCnpj(this.cnpj).then(function (success) {
      // trocar para algo melhor
      if (_this3.cnpjRules[_this3.cnpjRules.length - 1].name.length != 0) {
        _this3.cnpjRules.pop();
      }
      if (_this3.cpfRules[_this3.cpfRules.length - 1].name.length != 0) {
        _this3.cpfRules.pop();
      }
      if (success && success.status != 404) {
        _this3.cnpjRules.push(function indisponivel(value) {
          if (success.body.items.length > 0 && value == success.body.items[0].cnpj) {
            return "CNPJ já utilizado no sistema";
          }
          return true;
        });
        _this3.cpfRules.push(function indisponivel(value) {
          if (success.body.items.length > 0 && value == success.body.items[0].cnpj) {
            return "CPF já utilizado no sistema";
          }
          return true;
        });
      }
      _this3.$refs.cnpj.validate();
      return _this3.$refs.cnpj.valid;
    }, function (failed) {
      return failed;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "handleCancelar", function handleCancelar() {
    this.dialog = false;
    this.arrayMunicipios = [];
    this.resetForm();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "onSubmit", function onSubmit() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var convertData, nfseObj;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!_this4.$refs.form.validate()) {
                _context5.next = 27;
                break;
              }

              _this4.cnpjAviso = '', _this4.dataAviso = '', _this4.valorAviso = '', _this4.cnpjAviso = _this4.cnpj;
              _this4.dataAviso = _this4.date.split('-').reverse().join('/');
              _this4.valorAviso = _this4.valor;

              _this4.telefone.replace('(', '');
              _this4.telefone.replace(')', '');

              if (_this4.valor.length > 2) {
                _this4.valor = _this4.valor.split('.').join('');
                _this4.valor = _this4.valor.replace(',', '.');
              }

              if (_this4.cnpj.length > 14) {
                _this4.cnpj = _this4.cnpj.split('/').join('');
              }
              _this4.cnpj = _this4.cnpj.split('.').join('');
              _this4.cnpj = _this4.cnpj.split('-').join('');

              convertData = _this4.date.split('-');

              if (Number(convertData[2]) < 10) {
                convertData[2] = convertData[2].replace('0', '');
              }

              _this4.date = convertData.join('-');

              nfseObj = {
                dataServico: _this4.date,
                cpfCnpj: _this4.cnpj,
                razao: _this4.razao,
                email: _this4.email,
                cep: _this4.cep,
                estado: _this4.estado.sigla,
                codMun: _this4.municipio.id,
                bairro: _this4.bairro,
                logradouro: _this4.logradouro,
                numero: _this4.numero,
                complemento: _this4.complemento,
                inscTomador: _this4.inscricaoMunicipal,
                codigoTributacao: _this4.codigoTributacao,
                naturezaOperacao: _this4.naturezaOperacao,
                regimeTributacao: _this4.regimeTributacao,
                issqn: _this4.issqn,
                telefone: _this4.telefone,
                valorTotal: _this4.valor,
                discriminacao: _this4.discriminacao
              };


              _this4.snackbar = true;
              _this4.dialog = false;
              _this4.resetForm();

              _this4.service = new __WEBPACK_IMPORTED_MODULE_5__domain_notas_nfse_NfseService__["a" /* default */](_this4.$http);

              if (_this4.edit) {
                _context5.next = 24;
                break;
              }

              _this4.table.loading = true;
              _context5.next = 22;
              return _this4.service.inserirNovaNota(nfseObj, _this4.empresa._id).then(function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(resp) {
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this4.$store.commit('addUpdateTable', true);
                          if (resp.message === 'Duplicidade') {
                            _this4.jsonDuplicidade = nfseObj;
                            _this4.dialogAviso = true;
                          }

                        case 2:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this4);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()).then(function () {
                _this4.$store.commit('addUpdateTable', false);
              });

            case 22:
              _context5.next = 27;
              break;

            case 24:
              _this4.table.loading = true;
              _context5.next = 27;
              return _this4.service.atualizarNota(nfseObj, _this4.nota._id).then(function () {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(resp) {
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _this4.$store.commit('addUpdateTable', true);
                          if (resp.message === 'Duplicidade') {
                            _this4.jsonDuplicidade = nfseObj;
                            _this4.dialogAviso = true;
                          }

                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this4);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }()).then(function () {
                _this4.$store.commit('addUpdateTable', false);
              });

            case 27:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "handleDuplicidade", function handleDuplicidade() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var json;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this5.service = new __WEBPACK_IMPORTED_MODULE_5__domain_notas_nfse_NfseService__["a" /* default */](_this5.$http);
              json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this5.jsonDuplicidade, { aceiteDuplicidade: _this5.conta.id_usuario });

              _this5.table.loading = true;
              _context6.next = 5;
              return _this5.service.inserirNovaNota(json).then(function () {
                _this5.dialogAviso = false;
                _this5.$store.commit('addUpdateTable', true);
              }).then(function () {
                _this5.$store.commit('addUpdateTable', false);
              });

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this5);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetForm", function resetForm() {
    this.$refs.form.reset();
  }), _methods)
});

/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNovoImovel_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1197a3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNovoImovel_vue__ = __webpack_require__(621);
function injectStyle (ssrContext) {
  __webpack_require__(620)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNovoImovel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1197a3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNovoImovel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_automacaoFiscal_iptu_IptuService__ = __webpack_require__(56);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["edit", "IBGE", "nota", "empresa"],
  data: function data() {
    return {
      dialog: false,
      inscricao: '',
      prefixo: '',
      uf: '',
      municipio: '',
      description: '',
      pagamento: '',
      arrayEstados: [],
      arrayMunicipios: [],
      comboPagamento: ['A vista', 'Parcelado', 'Ambos'],
      valid: true,
      id: '',
      razaoRules: [function (v) {
        return !!v || "Campo obrigatório";
      }]
    };
  },

  methods: {
    isNumber: function isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    handleOpenDialog: function handleOpenDialog() {
      if (!this.arrayEstados.length) {
        this.arrayEstados = this.IBGE.estados;
        this.arrayMunicipios = [];
      }
      this.dialog = true;
    },
    handleOpenDialogEdit: function handleOpenDialogEdit() {
      if (!this.arrayEstados.length) {
        this.arrayEstados = this.IBGE.estados;
        this.arrayMunicipios = [];
      }
      for (var i in this.arrayEstados) {
        if (this.arrayEstados[i].sigla == this.nota.uf) {
          this.uf = this.arrayEstados[i];
          this.getMunicipios(this.nota.codMun);
          break;
        }
      }
      this.prefixo = this.nota.prefixo;
      this.inscricao = this.nota.inscricaoImovel;
      if (this.nota.pagtoIptu == 'avista') {
        this.pagamento = 'A vista';
      } else if (this.nota.pagtoIptu == 'parcelado') {
        this.pagamento = 'Parcelado';
      } else if (this.nota.pagtoIptu == 'ambos') {
        this.pagamento = 'Ambos';
      } else {
        this.pagamento = '';
      }

      this.description = this.nota.descricao;
      this.id = this.nota._id;

      this.dialog = true;
    },

    getMunicipios: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var codMun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.uf) {
                  _context.next = 5;
                  break;
                }

                this.resource = this.$resource("https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + this.uf.id + "/municipios");
                this.resource.query().then(function (success) {
                  if (codMun.length > 1) {
                    if (success.body.length) {
                      for (var i in success.body) {
                        if (success.body[i].id == codMun) {
                          _this.municipio = success.body[i];
                          break;
                        }
                      }
                    }
                  }
                  _this.arrayMunicipios = success.body;
                }, function (failed) {
                  _this.arrayMunicipios = [];
                });
                _context.next = 6;
                break;

              case 5:
                return _context.abrupt("return");

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMunicipios() {
        return _ref.apply(this, arguments);
      }

      return getMunicipios;
    }(),
    resetForm: function resetForm() {
      this.$refs.form.reset();
    },
    handleCancelar: function handleCancelar() {
      this.dialog = false;
      this.arrayMunicipios = [];
      this.resetForm();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var imovel;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$refs.form.validate()) {
                  _context2.next = 14;
                  break;
                }

                imovel = {
                  empresa: _this2.empresa._id,
                  descricao: _this2.description,
                  uf: _this2.uf.sigla,
                  codUf: _this2.uf.id,
                  municipio: _this2.municipio.nome,
                  codMun: _this2.municipio.id,
                  inscricaoImovel: _this2.inscricao,
                  pagtoIptu: _this2.pagamento.toLowerCase().replace(' ', ''),
                  prefixo: _this2.prefixo
                };


                _this2.snackbar = true;
                _this2.dialog = false;
                _this2.resetForm();

                _this2.service = new __WEBPACK_IMPORTED_MODULE_2__domain_automacaoFiscal_iptu_IptuService__["a" /* default */](_this2.$http);

                if (_this2.edit) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return _this2.service.setImovel(imovel);

              case 9:
                _context2.next = 13;
                break;

              case 11:
                _context2.next = 13;
                return _this2.service.updateImovel(imovel, _this2.id);

              case 13:
                _this2.$store.commit('addUpdateTable', true);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__btnDias_BtnDias_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__btnConsultaAvulsa_BtnConsultaAvulsa__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__btnColumn_BtnColumn__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__btnExpExcell_BtnExpExcell_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__btnSelectAll_btnSelectAll_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dataTable_commonTable_coluna_actions_btnEmail_BtnEmail_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dataTable_commonTable_actionsHeader_btnUpload_BtnUpload_vue__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dataTable_commonTable_actionsHeader_btnDownload_BtnDownload_vue__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dataTable_commonTable_actionsHeader_btnImportadorXml_BtnImportadorXml_vue__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dataTable_commonTable_actionsHeader_btnNovaNota_BtnNovaNota_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dataTable_commonTable_actionsHeader_btnUploadPlanilha_BtnUploadPlanilha_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dataTable_commonTable_actionsHeader_btnUploadPlanilha_BtnUploadPlanilhaEscrituracao_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_dataTable_commonTable_actionsHeader_btnEnviaFtp_BtnEnviaFtp_vue__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_dataTable_commonTable_actionsHeader_btnEnviaFluig_BtnEnviaFluig_vue__ = __webpack_require__(705);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["headers", "table", "selected", "empresa", "component", "range", "logConsulta", "logQtd", "conta", "openFiltro", "alert"],
  components: {
    btnConsultaAvulsa: __WEBPACK_IMPORTED_MODULE_1__btnConsultaAvulsa_BtnConsultaAvulsa__["a" /* default */],
    btnColumns: __WEBPACK_IMPORTED_MODULE_2__btnColumn_BtnColumn__["a" /* default */],
    btnExpExcell: __WEBPACK_IMPORTED_MODULE_3__btnExpExcell_BtnExpExcell_vue__["a" /* default */],
    btnSelectAll: __WEBPACK_IMPORTED_MODULE_4__btnSelectAll_btnSelectAll_vue__["a" /* default */],
    btnDias: __WEBPACK_IMPORTED_MODULE_0__btnDias_BtnDias_vue__["a" /* default */],
    btnEmail: __WEBPACK_IMPORTED_MODULE_5__components_dataTable_commonTable_coluna_actions_btnEmail_BtnEmail_vue__["a" /* default */],
    btnDownload: __WEBPACK_IMPORTED_MODULE_7__components_dataTable_commonTable_actionsHeader_btnDownload_BtnDownload_vue__["a" /* default */],
    btnImportadorXml: __WEBPACK_IMPORTED_MODULE_8__components_dataTable_commonTable_actionsHeader_btnImportadorXml_BtnImportadorXml_vue__["a" /* default */],
    btnUpload: __WEBPACK_IMPORTED_MODULE_6__components_dataTable_commonTable_actionsHeader_btnUpload_BtnUpload_vue__["a" /* default */],
    btnNovaNota: __WEBPACK_IMPORTED_MODULE_9__components_dataTable_commonTable_actionsHeader_btnNovaNota_BtnNovaNota_vue__["a" /* default */],
    btnUploadPlanilha: __WEBPACK_IMPORTED_MODULE_10__components_dataTable_commonTable_actionsHeader_btnUploadPlanilha_BtnUploadPlanilha_vue__["a" /* default */],
    btnUploadPlanilhaEscrituracao: __WEBPACK_IMPORTED_MODULE_11__components_dataTable_commonTable_actionsHeader_btnUploadPlanilha_BtnUploadPlanilhaEscrituracao_vue__["a" /* default */],
    BtnEnviaFluig: __WEBPACK_IMPORTED_MODULE_13__components_dataTable_commonTable_actionsHeader_btnEnviaFluig_BtnEnviaFluig_vue__["a" /* default */],
    BtnEnviaFtp: __WEBPACK_IMPORTED_MODULE_12__components_dataTable_commonTable_actionsHeader_btnEnviaFtp_BtnEnviaFtp_vue__["a" /* default */]
  },
  data: function data() {
    return {
      search: "",
      filtroForSearch: { text: "Tudo", value: "tudo" }
    };
  },
  watch: {
    table: function table() {}
  },
  methods: {
    getHeader: function getHeader($event) {
      this.$emit("getHeader", $event);
    },
    getSelected: function getSelected($event) {
      var selected = $event;
      this.$emit("updatedSelected", selected);
    },
    emitFiltro: function emitFiltro($event) {
      this.$emit("getSearch", $event);
    },
    getOpenFiltro: function getOpenFiltro($event) {
      this.$emit("getOpenFiltro", $event);
    },
    getLogConsulta: function getLogConsulta($event) {
      this.$emit("getLogConsulta", $event);
    },

    getDataBusca: function getDataBusca($event) {
      this.$emit("getDataBusca", $event);
    },
    filterItensSearch: function filterItensSearch() {
      var array = [{ text: "Tudo", value: "tudo" }];
      this.table.headers.forEach(function (item) {
        if (item.pesq) {
          array.push(item);
        }
      });
      return array.sort(function (a, b) {
        if (a > b) return -1;else return 1;
      });
    }
  },
  computed: {
    getSearchTag: function getSearchTag() {
      this.$emit("tagForSearch", this.filtroForSearch);
    },

    getIdSelecteds: function getIdSelecteds() {
      var array = [];
      this.table.selected.filter(function (v) {
        return array.push(v._id);
      });
      return array;
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDias_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5d46a04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDias_vue__ = __webpack_require__(626);
function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5d46a04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5d46a04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["component", "openFiltro", "buttons", "empresa", "table", "conta"],
  data: function data() {
    return {};
  },
  components: {},
  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.component.enable.rangeDate) {
        var btn = document.querySelector(".btn_mesAtual_" + this.component.name);
        btn.classList.remove("v-btn--outline");
        btn.classList.remove("bg_white");
        btn.classList.remove("teal--text");
        btn.classList.add("teal");
        btn.classList.add("white--text");
      }
    });
  },
  watch: {},
  methods: {
    changeOptionData: function changeOptionData(item) {
      if (item.value == "tudo") {
        this.openPanelFiltro();
      }
      this.$emit("getDataBusca", item.value);
    },
    openPanelFiltro: function openPanelFiltro() {
      this.$emit("getOpenFiltro", this.openFiltro);
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_notas_cte_CteService__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_notas_nfse_NfseService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["empresa", "table", "component", "range", "conta", "logConsulta", "logQtd"],
  data: function data() {
    return {
      loading4: false,
      loader: null,
      dialog: false,
      qntNovosItens: 0,
      timeout: 6000,
      interval: false,
      text: "Estamos buscando novos itens",
      timer: "",
      tooltipMessage: "Fazer uma busca avulsa por novas notas",
      empresaChamada: "",
      hrRestante: { timer: "", bloq: false }
    };
  },
  watch: {
    loader: function loader() {
      var _this = this;

      if (!this.interval) {
        this.interval = setInterval(function () {
          try {
            var l = _this.loader;
            _this[l] = !_this[l];

            _this.timer = setInterval(function () {
              _this[l] = false;
            }, 200000000);
            _this.loader = null;
          } catch (error) {
            throw new Error("Erro ao tentar scrollar tabela usando botão" + error);
          }
        }, 30);
      }
    },

    "table.buscarNotas": function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(newV, oldV) {
        var i;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!newV) {
                  _context.next = 9;
                  break;
                }

                //logica para fazer primeira busca automaticamente
                this.table.buscarNotas = false;
                i = 0;

              case 3:
                if (!(i < 3)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return this.consultar();

              case 6:
                i++;
                _context.next = 3;
                break;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function tableBuscarNotas(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return tableBuscarNotas;
    }(),
    logQtd: function logQtd(newV, oldV) {
      this.hrRestante.busca = false;
      if (this.logQtd && this.logQtd == 10) {
        this.relogio(this.logConsulta);
      } else {
        this.loading4 = false;
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  methods: {
    relogio: function relogio(ultData) {
      // ultData é timeStamp
      var data = new Date(ultData.getFullYear() + "-" + (ultData.getMonth() + 1) + "-" + ultData.getDate() + " " + (ultData.getHours() + 1) + ":00:00");
      // var data = new Date("Fri Jan 18 2019 11:21:32 GMT-0200");
      var falta = (new Date(data).getTime() - new Date().getTime()) / 1000;
      var segundos = Math.round(falta % 60);
      var minutos = Math.round(falta / 60 % 60);
      var horas = Math.round(falta / 60 / 60 % 24);
      var dias = Math.round(falta / 60 / 60 / 24);
      var auxThis = this;
      if (falta > 0) {
        this.hrRestante.busca = true;
        this.loading4 = true;
        setInterval(function () {
          segundos = parseInt(segundos);
          minutos = parseInt(minutos);
          if (segundos == 0 && minutos > 0) {
            segundos = 60;
            minutos--;
          } else if (segundos == 0 && minutos == 0) {
            auxThis.loading4 = false;
            auxThis.hrRestante.busca = false;
          }
          segundos--;
          if (segundos < 10) {
            segundos = "0" + segundos.toString();
          }
          if (minutos < 10) {
            minutos = "0" + minutos.toString();
          }
          auxThis.hrRestante.timer = "00:" + minutos + ":" + segundos;
        }, 1000);
      }
    },

    consultar: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loader = "loading4";
                this.empresaChamada = this.empresa.razao;
                this.tooltipMessage = "Motor fiscal está buscando novas notas para: " + this.empresa.razao;

                if (this.component.name == "NFSE") {
                  this.table.snack.text = "Motor fiscal está buscando novas notas";
                } else {
                  this.table.snack.text = "Motor fiscal está buscando notas no Sefaz";
                }
                this.table.snackDefault();
                this.table.snack.show = true;
                if (this.component.name.indexOf("NFe") != -1) {
                  this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                } else if (this.component.name == "CTE") {
                  this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_notas_cte_CteService__["a" /* default */](this.$http);
                } else if (this.component.name == "NFSE") {
                  this.service = new __WEBPACK_IMPORTED_MODULE_5__domain_notas_nfse_NfseService__["a" /* default */](this.$http);
                }
                _context2.next = 9;
                return this.service.consultaAvulsaNota(this.empresa._id, this.component.tipo).then(function (resp) {
                  this.table.busca = true;
                  if (resp.status == 200) {
                    this.qntNovosItens = resp.body.baixadas;
                    if (this.qntNovosItens > 0) {
                      this.table.loading = true;
                      this.table.array_todas_notas = [];
                      this.table.time = 7000;
                      return this.table.qnt_total_notas + this.qntNovosItens;
                    } else {
                      if (this.empresa.cnpj && this.empresa.cnpj.length == 11) {
                        this.table.snack.text = "Motor fiscal está processando as notas, que tal um cafézinho ?";
                      } else {
                        this.table.snack.text = "Não foram encontradas novas notas.";
                      }
                      return 0;
                    }
                  } else if (resp.status == 500 || resp.status == 404) {
                    //
                    if (resp.body.message == 'Certificado digital não pertence a empresa') {
                      this.conta.getEmpresas = true;
                    }
                    this.table.loading = false;
                    this.table.snack.text = resp.body.message;
                  } else {
                    this.table.snack.text = "Não conseguimos fazer uma busca, tente mais tarde ou entre em contato";
                  }
                }).then(function (novototal) {
                  if (novototal > 0) {
                    _this2.table.snack.text = _this2.qntNovosItens == 1 ? _this2.qntNovosItens + " nova nota foi encontrada." : _this2.qntNovosItens + " novas notas foram encontradas.";
                    var auxThis = _this2;

                    setTimeout(function () {
                      auxThis.table.sendAtt = true;
                      auxThis.conta.getLog = true;
                    }, 5000);
                  }
                }).then(function () {
                  this.table.snack.show = true;

                  this.loader = null;

                  clearInterval(this.timer);
                  this.timer = null;

                  clearInterval(this.interval);
                  this.interval = false;
                  this.timer = false;
                  this.loader = null;
                  this.loading4 = false;
                  this.tooltipMessage = "Fazer uma busca avulsa por novas notas";
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function consultar() {
        return _ref2.apply(this, arguments);
      }

      return consultar;
    }(),
    setNotasByHeaders: function setNotasByHeaders(array) {
      var _this3 = this;

      switch (this.component.name) {
        case "CTE":
          if (this.table.headers.length > 0) {
            var cont_c_column;

            var _ret = function () {
              var auxNotas = array;
              var arrayNfe = [];

              var i = 0;
              cont_c_column = 0;

              var _loop = function _loop() {
                var objNfe = {};
                cont_c_column = 0;
                _this3.table.headers.forEach(function (item) {
                  if (item.value.indexOf("custom") == -1 && item.value.indexOf("acoes") == -1) {
                    objNfe[item.value] = auxNotas[i][item.value];
                    if (item.show) {
                      document.querySelectorAll("#" + item.value).forEach(function (item) {
                        item.display = "table-cell";
                        item.removeAttribute("style");
                      });
                    }
                  } else if (item.value.indexOf("custom") != -1) {
                    item.value;
                    if (auxNotas[i].customValues != undefined && auxNotas[i].customValues.length > 0 && cont_c_column < auxNotas[i].customValues.length && auxNotas[i].customValues[cont_c_column] != null && item.value == auxNotas[i].customValues[cont_c_column].key) {
                      var newObjCustom = {};
                      newObjCustom["value"] = auxNotas[i].customValues[cont_c_column].value;
                      newObjCustom["key"] = auxNotas[i].customValues[cont_c_column].key;
                      objNfe[item.value] = newObjCustom;
                      cont_c_column++;
                    } else {
                      var _newObjCustom = {};
                      _newObjCustom["value"] = "";
                      _newObjCustom["key"] = item.value;
                      objNfe[item.value] = _newObjCustom;
                      cont_c_column++;
                    }
                  }
                });
                arrayNfe.push(objNfe);
                i++;
              };

              while (i < auxNotas.length) {
                _loop();
              }
              return {
                v: arrayNfe
              };
            }();

            if ((typeof _ret === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
          } else {
            var _ret3 = function () {
              var auxNotas = _this3.table.arrayNotas.slice();
              var arrayNfe = [];
              var i = 0;
              _this3.table.headers = _this3.table.getHeaders();

              var _loop2 = function _loop2() {
                var objNfe = {};
                _this3.table.headers.forEach(function (item) {
                  if (item.value.indexOf("custom") == -1 && item.value.indexOf("acoes") == -1) {
                    if (item.show) {
                      objNfe[item.value] = auxNotas[i][item.value];
                      document.querySelector("#" + item.value).display = "table-cell";
                    }
                  } else if (item.value.indexOf("custom") != -1) {
                    objNfe[item.value];
                  }
                });
                arrayNfe.push(objNfe);
                i++;
              };

              while (i < auxNotas.length) {
                _loop2();
              }
              return {
                v: arrayNfe
              };
            }();

            if ((typeof _ret3 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret3)) === "object") return _ret3.v;
          }
          break;
        default:
          if (this.table.headers.length > 0) {
            var cont_c_column;

            var _ret5 = function () {
              var auxNotas = array;

              var arrayNfe = [];
              var i = 0;
              cont_c_column = 0;

              var _loop3 = function _loop3() {
                var objNfe = {};
                cont_c_column = 0;
                _this3.table.headers.forEach(function (item) {
                  if (item.value.indexOf("custom") == -1 && item.value.indexOf("acoes") == -1) {
                    objNfe[item.value] = auxNotas[i][item.value];
                    if (item.show) {
                      document.querySelectorAll("#" + item.value).forEach(function (item) {
                        item.display = "table-cell";
                        item.removeAttribute("style");
                      });
                    }
                  } else if (item.value.indexOf("custom") != -1) {
                    if (auxNotas[i].customValues != undefined && auxNotas[i].customValues.length > 0 && cont_c_column < auxNotas[i].customValues.length && auxNotas[i].customValues[cont_c_column] != null && item.value == auxNotas[i].customValues[cont_c_column].key) {
                      var newObjCustom = {};
                      newObjCustom["value"] = auxNotas[i].customValues[cont_c_column].value;
                      newObjCustom["key"] = auxNotas[i].customValues[cont_c_column].key;
                      objNfe[item.value] = newObjCustom;
                      cont_c_column++;
                    } else {
                      var _newObjCustom2 = {};
                      _newObjCustom2["value"] = "";
                      _newObjCustom2["key"] = item.value;
                      objNfe[item.value] = _newObjCustom2;
                      cont_c_column++;
                    }
                  }
                });
                arrayNfe.push(objNfe);
                i++;
              };

              while (i < auxNotas.length) {
                _loop3();
              }
              return {
                v: arrayNfe
              };
            }();

            if ((typeof _ret5 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret5)) === "object") return _ret5.v;
          } else {
            var _ret7 = function () {
              var auxNotas = _this3.table.arrayNotas.slice();
              var arrayNfe = [];
              var i = 0;
              _this3.table.headers = _this3.table.getHeaders();

              var _loop4 = function _loop4() {
                var objNfe = {};
                _this3.table.headers.forEach(function (item) {
                  if (item.value.indexOf("custom") == -1 && item.value.indexOf("acoes") == -1) {
                    if (item.show) {
                      objNfe[item.value] = auxNotas[i][item.value];
                      document.querySelector("#" + item.value).display = "table-cell";
                    }
                  } else if (item.value.indexOf("custom") != -1) {
                    objNfe[item.value];
                  }
                });
                arrayNfe.push(objNfe);
                i++;
              };

              while (i < auxNotas.length) {
                _loop4();
              }
              return {
                v: arrayNfe
              };
            }();

            if ((typeof _ret7 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret7)) === "object") return _ret7.v;
          }
      }
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__btnNewColumn_BtnNewColumn_vue__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__btnRmvColumn_BtnRmvColumn_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["headers", "table", "component", "empresa", "conta"],
  components: {
    btnNewColumn: __WEBPACK_IMPORTED_MODULE_2__btnNewColumn_BtnNewColumn_vue__["a" /* default */],
    btnRmvColumn: __WEBPACK_IMPORTED_MODULE_4__btnRmvColumn_BtnRmvColumn_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a
  },
  data: function data() {
    return {
      dialog: false,
      qnt: 0,
      editable: true,
      isDragging: false,
      delayedDragging: false
    };
  },
  computed: {
    dragOptions: function dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    dialog: function dialog() {
      this.table.auxHeaders = this.table.headers.slice();
      this.table.auxNotas = [];
    },
    "table.headers": function tableHeaders(newV) {
      if (newV.length != this.table.auxHeaders.length) {
        this.table.auxHeaders = newV.slice();
        this.table.auxNotas = [];
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.table.auxHeaders = this.table.headers.slice();
    });
  },
  methods: {
    resetHeaders: function resetHeaders() {
      var _this = this;

      try {
        var arrayCustom = [];
        this.table.auxHeaders.forEach(function (x) {
          if (x.value.indexOf("custom_") != -1) {
            arrayCustom.push(x);
          }
        });
        this.table.snack.show = true;
        this.table.snack.text = "Colunas ordenadas no padrão motor fiscal";
        this.table.snackSuccess();
        this.table.auxHeaders = this.table.getHeaders();
        if (arrayCustom.length > 0) {
          arrayCustom.forEach(function (x) {
            _this.table.auxHeaders.push(x);
          });
        }
      } catch (error) {
        throw new Error("Não foi possível resetar os headers: " + error);
      }
    },
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },
    onEnd: function onEnd(_ref2) {
      var relatedContext = _ref2.relatedContext,
          draggedContext = _ref2.draggedContext;
    },
    headerShow: function headerShow(header, action) {
      if (header.enable && action == "ativa" && header.show) {
        return true;
      } else if (!header.enable && action == "oculta") {
        return false;
      } else if (!header.enable && action == "ativa") {
        return false;
      }
      if (!header.show && action == "oculta") return true;
      if (header.show && action == "ativa") return true;
    },
    orderUp: function orderUp(idItem) {
      var posItem;
      var auxItemAnt;

      for (var i = 0; i < this.table.auxHeaders.length; i++) {
        if (this.table.auxHeaders[i].value == idItem) {
          posItem = i;
        }
      }
      auxItemAnt = this.table.auxHeaders[posItem - 1];
      this.table.auxHeaders.splice(posItem - 1, 1, this.table.auxHeaders[posItem]);
      this.table.auxHeaders.splice(posItem, 1, auxItemAnt);
    },
    orderDown: function orderDown(idItem) {
      var posItem;
      var auxProxItem;

      for (var i = 0; i < this.table.auxHeaders.length; i++) {
        if (this.table.auxHeaders[i].value == idItem) {
          posItem = i;
        }
      }
      auxProxItem = this.table.auxHeaders[posItem + 1];
      this.table.auxHeaders.splice(posItem + 1, 1, this.table.auxHeaders[posItem]);
      this.table.auxHeaders.splice(posItem, 1, auxProxItem);
    },
    addAllColumn: function addAllColumn(headers) {
      var funcao = this.toggleDisplayBody;

      headers.forEach(function (item) {
        if (item.enable) {
          item.show = true;
          funcao(item.value, "table-cell");
        }
      });
    },
    addColumn: function addColumn(idItem) {
      this.toggleDisplayItens(this.table.auxHeaders, idItem, true);
    },
    removeAllColumn: function removeAllColumn(headers) {
      var funcao = this.toggleDisplayBody;
      headers.forEach(function (item) {
        if (item.enable) {
          item.show = false;
          funcao(item.value, "none");
        }
      });
    },
    removeColumn: function removeColumn(idItem, $event) {
      if ($event.target.nodeName != "I") {
        this.toggleDisplayItens(this.table.auxHeaders, idItem, false);
      }
    },
    toggleDisplayBody: function toggleDisplayBody(idItem, display) {
      var id = "#" + idItem;
      document.querySelectorAll(id).forEach(function (item) {
        if (item.nodeName == "TD") {
          item.style.display = display;
        } else {
          item.style.display = "inline-block";
        }
      });
    },
    toggleDisplayItens: function toggleDisplayItens(array1, idItem, action) {
      //Header da tabela
      var posItem = void 0;
      for (var i = 0; i < array1.length; i++) {
        if (array1[i].value == idItem) {
          posItem = i;
        }
      }
      var display = "none";
      if (action) display = "table-cell";
      this.toggleDisplayBody(idItem, display);
      this.table.auxHeaders[posItem].show = action;

      var qntHeaders = document.querySelectorAll("#listaHeader li").length;
      if (action) {
        qntHeaders += 1;
      }
      var item = this.table.auxHeaders[posItem];
      this.table.auxHeaders.splice(posItem, 1);
      this.table.auxHeaders.splice(qntHeaders, 0, item);
    },

    closeModal: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(acao) {
        var _this2 = this;

        var cont_c_column, arrayHeaders, serv;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.delegateYield( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                  var auxNotas, tableAux, arrayNfe, i, _loop;

                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.t0 = acao;
                          _context.next = _context.t0 === "salvar" ? 3 : 19;
                          break;

                        case 3:
                          _this2.table.headers = [];

                          _this2.table.headers = _this2.table.auxHeaders.slice();

                          auxNotas = _this2.table.array_todas_notas;
                          tableAux = _this2.table.auxNotas;
                          arrayNfe = [];
                          i = 0;
                          cont_c_column = 0;

                          _loop = function _loop() {
                            var objNfe = {};
                            cont_c_column = 0;
                            _this2.table.auxHeaders.forEach(function (item) {
                              if (item.value.indexOf("acoes") == -1) {
                                var newObjNota = "";
                                if (_this2.table.auxNotas.length > 0) {
                                  _this2.table.auxNotas.forEach(function (element) {
                                    if (element == item.value) {
                                      newObjNota = {};
                                      newObjNota["value"] = "";
                                      newObjNota["key"] = item.value;

                                      objNfe[item.value] = newObjNota;
                                    } else {
                                      if (auxNotas[i][item.value] != undefined) {
                                        newObjNota = auxNotas[i][item.value];
                                      }
                                    }
                                  });
                                } else {
                                  if (auxNotas[i][item.value] != undefined) {
                                    newObjNota = auxNotas[i][item.value];
                                  }
                                }
                                objNfe[item.value] = newObjNota;
                                if (item.show) {
                                  document.querySelectorAll("#" + item.value).forEach(function (item) {
                                    item.display = "table-cell";
                                    item.removeAttribute("style");
                                  });
                                }
                              }
                            });
                            arrayNfe.push(objNfe);
                            i++;
                          };

                          while (i < auxNotas.length) {
                            _loop();
                          }
                          _this2.table.array_todas_notas = arrayNfe.slice();
                          _this2.table.arrayNotas = arrayNfe.slice();

                          arrayHeaders = [];


                          _this2.table.auxHeaders.forEach(function (item) {
                            var obj = {};
                            obj["titulo"] = item.text;
                            obj["id"] = item.value;
                            obj["show"] = item.show;
                            obj["pesq"] = item.pesq;
                            obj["enable"] = item.enable;

                            arrayHeaders.push(obj);
                          });
                          serv = new __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__["a" /* default */](_this2.$http);
                          _context.next = 19;
                          return serv.saveHeadersByEmp(_this2.empresa._id, arrayHeaders, _this2.component.name, _this2.component.tipo);

                        case 19:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                })(), "t0", 1);

              case 1:
                if (this.table.addedCustomColumn) {
                  this.table.showSnackAtt = true;
                }
                this.dialog = false;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function closeModal(_x) {
        return _ref3.apply(this, arguments);
      }

      return closeModal;
    }()
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["table", "empresa"],
  data: function data() {
    return {
      dialog: false,
      columnName: "",
      columnPesq: false,
      text: "",
      rules: [function (v) {
        return v.length <= 30 || "Máximo 30 caracteres para criação da coluna. ";
      }, function (v) {
        return !new RegExp(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').test(v) || "Não é possível o uso de caracteres especiais";
      }]
    };
  },
  watch: {},
  methods: {
    openModal: function openModal() {
      this.dialog = true;
      this.columnName = "";
      this.columnPesq = false;
    },

    newColumn: function newColumn() {

      if (this.columnName && this.columnName.length <= 30 && this.$refs.inputText.validate()) {
        var pos = 0;
        this.table.auxHeaders.forEach(function (item) {
          if (item.show) pos++;
        });
        var chave = "";
        var newHeader = { show: true, enable: true };
        newHeader["text"] = this.columnName;
        chave = "custom_" + this.columnName.split(" ").join("") + "_" + this.empresa._id;
        newHeader["value"] = chave;
        newHeader["pesq"] = this.columnPesq;
        this.table.auxHeaders.splice(pos, 0, newHeader);
        this.table.auxNotas.push(chave);

        this.dialog = false;
        this.table.snack.text = "Coluna \"" + this.columnName + "\" adicionada ao fim da tabela";
        this.table.snackSuccess();
        this.table.snack.show = true;

        this.table.addedCustomColumn = true;
      }
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__btnEditColumn_BtnEditColumn_vue__ = __webpack_require__(637);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["table"],
  components: {
    btnEditColumn: __WEBPACK_IMPORTED_MODULE_1__btnEditColumn_BtnEditColumn_vue__["a" /* default */]
  },
  data: function data() {
    return {
      dialog: false,
      columnName: "",
      text: ""
    };
  },
  watch: {
    "table.auxHeaders": function tableAuxHeaders() {
      this.vrfcaColumn;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.vrfcaColumn;
    });
  },
  computed: {
    vrfcaColumn: function vrfcaColumn() {
      var aux_text = "";
      var aux_temColumn = false;
      aux_text = "Não há colunas personalizáveis";
      this.table.auxHeaders.forEach(function (item) {
        if (item.value.indexOf("custom_") != -1) {
          aux_text = "Coluna personalizáveis existente: ";
        }
      });
      this.text = aux_text;
    }
  },
  methods: {
    openModal: function openModal() {
      this.dialog = true;
    },
    removeColumn: function removeColumn(columnItem, i) {
      var id = columnItem.value;
      this.table.auxHeaders.splice(i, 1);

      this.table.snack.text = "Coluna: \"" + columnItem.text + "\" removida da tabela";
      this.table.snackDanger();
      this.table.snack.show = true;
    },
    mergeColumn: function mergeColumn($event) {}
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_notas_nfe_NfeService__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["table", "item"],
  data: function data() {
    return {
      dialog: false,
      columnName: "",
      columnPesq: false,
      text: "",
      rules: [function (v) {
        return v.length <= 30 || "Máximo 30 caracteres para criação da coluna. ";
      }, function (v) {
        return !new RegExp(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').test(v) || "Não é possível o uso de caracteres especiais";
      }]
    };
  },
  watch: {},
  methods: {
    openModal: function openModal() {
      this.dialog = true;
      this.columnName = this.item.text;
      this.columnPesq = this.item.pesq;
    },
    editColumn: function editColumn() {

      if (this.$refs.inputText.validate()) {
        this.item.text = this.columnName;
        this.item.pesq = this.columnPesq;
        this.table.snack.text = "Altera\xE7\xF5es na coluna: \"" + this.columnName + "\" concluidas";
        this.table.snackAlert();
        this.table.snack.show = true;
        this.dialog = false;
      }

      //   this.$emit("mergeColumn", obj);
    }
  }
});

/***/ }),
/* 200 */,
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_util__ = __webpack_require__(57);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["component", "table", "nfseErros", "nfseDes"],
  data: function data() {
    return {
      dialog: false,
      menu: false,
      menuX: 0,
      menuY: 0,
      items: [{
        title: "Exportação completa",
        tooltip: "Exportar todos os itens da tabela.",
        icon: "done_all",
        evento: "all"
      }],
      objExpSelected: {
        title: "Exportação selecionada",
        tooltip: "Exportar apenas os itens que foram selecionados da tabela.",
        icon: "selected",
        evento: "selected"
      }
    };
  },
  computed: {
    getOpcoesMenu: function getOpcoesMenu() {
      if (!this.nfseErros && !this.nfseDes) {
        this.items.push({
          title: "Exportação parcial",
          tooltip: "Exportar apenas os itens exibidos da tabela.",
          icon: "adjust",
          evento: "parce"
        });
      }
      if (this.component.enable.selectAll && !this.nfseErros && !this.nfseDes) {
        this.items.push(this.objExpSelected);
      }
      return this.items;
    }
  },
  methods: {
    setPositionMenu: function setPositionMenu(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    setDownload: function setDownload(evento) {
      switch (evento) {
        case "all":
          this.exportExcel(1);
          break;
        case "parce":
          this.exportExcel(2);
          break;
        case "selected":
          this.exportExcel(3);
          break;
      }
    },

    exportExcel: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(tipo) {
        var tab_text, textRange, tab, lines, arrayNotas, pos, idHeaders, b, header, i, titleExcel, downName, linhas, prop, vlr, data, _data, status, issRetido, prodLength, possuiCert, _item, arrayCte, arrayCce, arrayNfe, formatTabela, chaves, obj, _chaves, _obj, _obj2, arrayVenc, item, _i, _i2, text_planos, _item2, _item3, _item4, ua, msie, data_type, template, base64, format, ctx, blob, downloadUrl;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                tab_text = '<table border="1px" style="text-align: center;">';

                if (this.nfseErros) {
                  tab = document.querySelector("#tableErros table");
                } else if (this.nfseDes) {
                  tab = document.querySelector("#tableDes table");
                } else {
                  tab = document.querySelector("#table table");
                }
                arrayNotas = void 0;
                pos = void 0;

                if (tipo == 1) {
                  lines = this.table.array_todas_notas.length;
                  arrayNotas = this.table.array_todas_notas;
                  pos = 0;
                } else if (tipo == 2) {
                  arrayNotas = this.table.arrayNotas;
                  pos = this.table.pagination.page * this.table.pagination.rowsPerPage - this.table.pagination.rowsPerPage;
                  lines = pos + this.table.pagination.rowsPerPage;
                } else if (tipo == 3) {
                  arrayNotas = this.table.selected;
                  lines = this.table.selected.length;
                  pos = 0;
                }
                idHeaders = [];
                b = document.createElement("a");

                b.style = "display:none";
                document.body.appendChild(b);

                // header da tabela
                if (lines > 0) {
                  header = "";

                  for (i = 0; i < tab.rows[0].cells.length; i++) {
                    if (tab.rows[0].cells[i].outerHTML.indexOf("display: none;") == -1 && tab.rows[0].cells[i].outerHTML.indexOf("acoes") == -1 && tab.rows[0].cells[i].outerHTML.indexOf("slctBox") == -1 && tab.rows[0].cells[i].outerHTML.indexOf("auxFix") == -1 || tab.rows[0].cells[i].outerHTML.indexOf("h_arrayEmpresas") != -1 || tab.rows[0].cells[i].outerHTML.indexOf("h_rela_arrayLogins") != -1) {
                      // debugger;
                      header = header + "<th>" + tab.rows[0].cells[i].innerHTML + "</th>";
                      idHeaders.push(tab.rows[0].cells[i].id.replace(/h_/gi, ""));
                    }
                  }
                  if (this.nfseErros) {
                    idHeaders = ["cnpj", "razao", "erro", "vlEnviado", "discriminacao"];
                  }
                  if (this.nfseDes) {
                    idHeaders = ["cnpj", "razao", "numeroNfse", "vlEnviado", "dtEmissao"];
                  }
                  titleExcel = this.component.textPlural;
                  downName = this.component.name.charAt(0).toUpperCase() + this.component.name.slice(1);

                  if (this.component.name == "NFeRecebidas" && this.component.tipo == "recebida") {
                    titleExcel = "Nota Fiscal Eletrônica(NF-e) Recebidas";
                    downName = "NFeRecebidas";
                  } else if (this.component.name == "NFeRecebidas" && this.component.tipo == "emitida") {
                    titleExcel = "Nota Fiscal Eletrônica(NF-e) Emitidas";
                    downName = "NFeEmitidas";
                  }

                  if (this.component.name == "NFSE" && this.component.tipo == "recebida") {
                    titleExcel = this.nfseDes ? "Inconsistencia DES" : "Nota Fiscal de Serviço Eletrônica(NF-e) - Recebidas";
                    downName = this.nfseDes ? "Inconsistencia DES" : "NFseRecebidas";
                  } else if (this.component.name == "NFSE" && this.component.tipo == "emitida") {
                    titleExcel = this.nfseErros ? "Erros Nota Fiscal de Serviço Eletrônica(NF-e) - Emitidas" : "Nota Fiscal de Serviço Eletrônica(NF-e) - Emitidas";
                    downName = this.nfseErros ? "ErrosNFseEmitidas" : "NFseEmitidas";
                  }
                  if (this.component.name == "produtos" && this.component.tipo == "recebida") {
                    titleExcel = "Produtos de Entrada";
                    downName = "ProdutosEntrada";
                  } else if (this.component.name == "produtos" && this.component.tipo == "emitida") {
                    titleExcel = "Produtos de Saída";
                    downName = "ProdutosSaida";
                  } else if (this.component.name == "usuario") {
                    titleExcel = "Colaboradores";
                    downName = "Colaboradores";
                  } else {
                    downName = downName + ".xls";
                  }
                  tab_text = tab_text + "<b>" + titleExcel + "</b>" + '<tr bgcolor="#32a3d5" color: white;">' + header + "</tr>";
                  b.download = downName;
                }
                //corpo da tabela
                pos;

              case 12:
                if (!(pos < lines)) {
                  _context.next = 143;
                  break;
                }

                linhas = "";
                _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(arrayNotas[pos]);

              case 15:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 139;
                  break;
                }

                prop = _context.t1.value;

                if (!(idHeaders.indexOf(prop) != -1)) {
                  _context.next = 137;
                  break;
                }

                if (!(prop.toLowerCase().indexOf("valor") != -1 || prop.toLowerCase().indexOf("vlr") != -1)) {
                  _context.next = 24;
                  break;
                }

                vlr = " ";

                if (arrayNotas[pos][prop] != undefined) {
                  vlr += "R$ " + arrayNotas[pos][prop].toLocaleString("pt-BR", {
                    minimumFractionDigits: 2
                  });
                }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' + vlr + "</td>";
                _context.next = 137;
                break;

              case 24:
                if (!(prop.toLowerCase().indexOf("validade") != -1)) {
                  _context.next = 30;
                  break;
                }

                data = "";

                if (arrayNotas[pos][prop].data != undefined) {
                  data = arrayNotas[pos][prop].data.toLocaleDateString();
                } else {
                  data = arrayNotas[pos][prop];
                }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + data + "</td>";
                _context.next = 137;
                break;

              case 30:
                if (!(prop.toLowerCase().indexOf("opcaosimples") != -1)) {
                  _context.next = 35;
                  break;
                }

                _context.next = 33;
                return Object(__WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_util__["a" /* findSimples */])(arrayNotas[pos][prop]).then(function (simples) {
                  return simples;
                }).then(function (simples) {
                  if (simples) {
                    linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + simples.tipo + " - " + simples.desc + "</td>";
                  } else {
                    linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + '' + "</td>";
                  }
                });

              case 33:
                _context.next = 137;
                break;

              case 35:
                if (!(prop.toLowerCase().indexOf("tribnfe") != -1)) {
                  _context.next = 40;
                  break;
                }

                _context.next = 38;
                return Object(__WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_util__["b" /* findTributacao */])(arrayNotas[pos][prop]).then(function (trib) {
                  return trib;
                }).then(function (trib) {
                  if (trib) {
                    linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + trib.tipo + " - " + trib.desc + "</td>";
                  } else {
                    linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + '' + "</td>";
                  }
                });

              case 38:
                _context.next = 137;
                break;

              case 40:
                if (!(prop.toLowerCase().indexOf("emissao") != -1 || prop.toLowerCase().indexOf("dt") != -1)) {
                  _context.next = 46;
                  break;
                }

                _data = " ";

                if (arrayNotas[pos][prop] && arrayNotas[pos][prop] != undefined) {
                  if (arrayNotas[pos][prop] instanceof Date && !isNaN(arrayNotas[pos][prop])) {
                    _data = arrayNotas[pos][prop].toLocaleDateString();
                  } else {
                    _data = arrayNotas[pos][prop];
                  }
                }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + _data + "</td>";
                _context.next = 137;
                break;

              case 46:
                if (!(prop.toLowerCase().indexOf("custom") != -1)) {
                  _context.next = 50;
                  break;
                }

                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' + arrayNotas[pos][prop].value + "</td>";
                _context.next = 137;
                break;

              case 50:
                if (!(prop.toLowerCase().indexOf("statusin") != -1)) {
                  _context.next = 56;
                  break;
                }

                status = "";

                if (arrayNotas[pos].preCadastro == undefined && arrayNotas[pos][prop] || arrayNotas[pos][prop] && arrayNotas[pos].preCadastro.length == 0) {
                  status = "Ativo";
                } else if (arrayNotas[pos] && arrayNotas[pos].preCadastro != undefined && arrayNotas[pos].preCadastro.length > 0) {
                  status = "Pendente";
                } else if (arrayNotas[pos][prop] != undefined && !arrayNotas[pos][prop]) {
                  status = "Inativo";
                }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black;text-align: center;">' + status + "</td>";
                _context.next = 137;
                break;

              case 56:
                if (!(prop.toLowerCase().indexOf("issretido") != -1)) {
                  _context.next = 62;
                  break;
                }

                issRetido = "Não";

                if (arrayNotas[pos][prop] == "true") {
                  issRetido = "Sim";
                }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' + issRetido + "</td>";
                _context.next = 137;
                break;

              case 62:
                if (!(prop.toLowerCase().indexOf("xprod") != -1 || prop.toLowerCase().indexOf("cprod") != -1 || prop.toLowerCase().indexOf("fornrazao") != -1 || prop.toLowerCase().indexOf("xnome") != -1 || prop.toLowerCase().indexOf("xfant") != -1)) {
                  _context.next = 66;
                  break;
                }

                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: left;">' + arrayNotas[pos][prop] + "</td>";
                _context.next = 137;
                break;

              case 66:
                if (!(prop.toLowerCase().indexOf("produto") != -1 || prop.toLowerCase().indexOf("colaboradores") != -1)) {
                  _context.next = 72;
                  break;
                }

                prodLength = 0;

                if (arrayNotas[pos][prop] != undefined) {
                  prodLength = arrayNotas[pos][prop].length;
                }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' + prodLength + "</td>";
                _context.next = 137;
                break;

              case 72:
                if (!(prop.toLowerCase().indexOf("certificado") != -1)) {
                  _context.next = 78;
                  break;
                }

                possuiCert = 'Pendente';

                if (arrayNotas[pos][prop] !== undefined && arrayNotas[pos][prop].validade && arrayNotas[pos][prop].validade.data) {
                  possuiCert = arrayNotas[pos][prop].validade.data.toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
                }
                // let possuiCert = "Não";
                // if (arrayNotas[pos][prop] != undefined) {
                //   possuiCert = "Sim";
                // }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' + possuiCert + "</td>";
                _context.next = 137;
                break;

              case 78:
                if (!(prop.toLowerCase().indexOf("enderEmit") != -1)) {
                  _context.next = 83;
                  break;
                }

                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' + "<table><thead><th>Endereço</th><th>CEP</th></thead><tbody>" + "<tr><td>" + arrayNotas[pos][prop].xLgr + ", " + arrayNotas[pos][prop].nro + "</td><td>" + arrayNotas[pos][prop].CEP + "</td><tr/>" + "</table>";
                "</td>";
                _context.next = 137;
                break;

              case 83:
                if (!(prop.toLowerCase().indexOf("cnpj") != -1 || prop.toLowerCase().indexOf("cpf") != -1)) {
                  _context.next = 87;
                  break;
                }

                if (arrayNotas[pos][prop] != undefined) {
                  if (arrayNotas[pos][prop].length == 11) {
                    linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + arrayNotas[pos][prop].replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") + "</td>";
                  } else {
                    linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + arrayNotas[pos][prop].replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") + "</td>";
                  }
                } else {
                  linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' + "" + "</td>";
                }
                _context.next = 137;
                break;

              case 87:
                if (!(prop.toLowerCase().indexOf("vinculo") != -1)) {
                  _context.next = 101;
                  break;
                }

                _item = "";
                arrayCte = arrayNotas[pos]["cte"];
                arrayCce = arrayNotas[pos]["xmlCce"];
                arrayNfe = arrayNotas[pos]["nfe"];
                formatTabela = [];

                if ((!arrayNfe || arrayNfe && arrayNfe.length == 0) && (!arrayCte || arrayCte && arrayCte.length == 0) && (!arrayCce || arrayCce && arrayCce.length == 0)) {
                  _item = "Não possui vínculo";
                }

                // console.log(arrayCte[0])
                if (arrayCte && arrayCte.length > 0) {
                  chaves = "";

                  if (arrayCte.chave) {
                    arrayCte.forEach(function (item) {
                      return chaves += item.chave.toString() + " " + "\n";
                    });
                  } else {
                    arrayCte.forEach(function (item) {
                      return chaves += item.toString() + " " + "\n";
                    });
                  }

                  obj = { tipo: "CTE", vlr: chaves };

                  formatTabela.push(obj);
                }
                if (arrayNfe && arrayNfe.length > 0) {
                  _chaves = "";

                  arrayNfe.forEach(function (item) {
                    return _chaves += item.toString() + " " + "\n";
                  });
                  // console.log(chaves)

                  _obj = { tipo: "NFE", vlr: _chaves };

                  formatTabela.push(_obj);
                }
                if (arrayCce && arrayCce.length > 0) {
                  _obj2 = {
                    tipo: "CCE",
                    vlr: "Quantidade: " + arrayCce.length
                  };

                  formatTabela.push(_obj2);
                }
                if (formatTabela.length > 0) {
                  _item = "<table><thead><th>Tipo</th><th>Informação</th></thead><tbody>";
                  formatTabela.forEach(function (v) {
                    _item += '<tr style="vertical-align: middle;"><td>' + v.tipo + '</td><td style="text-align: center;">' + ("" + v.vlr) + "</td><tr/>";
                  });
                  _item += "</table>";
                }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;width:400px">' + _item + "</td>";
                _context.next = 137;
                break;

              case 101:
                if (!(prop.toLowerCase().indexOf("duplicata") != -1)) {
                  _context.next = 108;
                  break;
                }

                arrayVenc = arrayNotas[pos][prop];
                item = "";

                if (!arrayVenc || arrayVenc && arrayVenc.length == 0) {
                  item = "Não informada";
                } else if (arrayVenc.length == 1) {
                  item = arrayVenc[0].dVenc.substring(0, arrayVenc[0].dVenc.indexOf("T")).split("-").reverse().join("/");
                } else {
                  item += "<table><thead><th>parcelas</th><th>valor</th></thead><tbody>";
                  arrayVenc.forEach(function (v) {
                    item += "<tr><td>" + v.dVenc.substring(0, v.dVenc.indexOf("T")).split("-").reverse().join("/") + "</td><td>" + v.vDup.toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }) + "</td><tr/>";
                  });
                  item += "</table>";
                }
                linhas = linhas + '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' + item + "</td>";
                _context.next = 137;
                break;

              case 108:
                if (!(prop.toLowerCase().indexOf("rela_arraylogins") != -1)) {
                  _context.next = 113;
                  break;
                }

                linhas = linhas + '<td bgcolor="#f5f5f5" style="vertical-align: middle; color: black; text-align: right;">';
                if (arrayNotas[pos][prop].length > 0) {
                  linhas = linhas + "<table><thead><th>Datas</th><th>Horários</th></thead><tbody>";
                  for (_i = 0; _i < arrayNotas[pos][prop].length; _i++) {
                    linhas = linhas + "<tr><td>";
                    if (new Date(arrayNotas[pos][prop][_i]) instanceof Date && !isNaN(new Date(arrayNotas[pos][prop][_i]))) {
                      linhas = linhas + new Date(arrayNotas[pos][prop][_i]).toLocaleDateString() + "</td><td>" + new Date(arrayNotas[pos][prop][_i]).toLocaleTimeString() + "</td>";
                    }
                  }
                  linhas = linhas + "<tbody>" + "</table>" + "</td>";
                } else {
                  linhas = linhas + "Sem Acessos" + "</td>";
                }

                _context.next = 137;
                break;

              case 113:
                if (!(prop.toLowerCase().indexOf("arrayempresas") != -1)) {
                  _context.next = 118;
                  break;
                }

                linhas = linhas + '<td bgcolor="#f5f5f5" style="vertical-align: middle; color: black; text-align: right;">';
                if (arrayNotas[pos][prop].length > 0) {
                  linhas = linhas + "<table><thead><th>CNPJ/CPF</th><th>RAZÃO</th><th>Data Cadastro</th><th>NF-e</th><th>CT-e</th><th>NFS-e</th></thead><tbody>";
                  for (_i2 = 0; _i2 < arrayNotas[pos][prop].length; _i2++) {
                    linhas = linhas + "<tr><td>" + (arrayNotas[pos][prop][_i2].empresa.cnpj != undefined ? arrayNotas[pos][prop][_i2].empresa.cnpj.length > 11 ? arrayNotas[pos][prop][_i2].empresa.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : arrayNotas[pos][prop][_i2].empresa.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4") : "") + " " + "</td><td>" + arrayNotas[pos][prop][_i2].empresa.razao + "</td><td>";
                    if (new Date(arrayNotas[pos][prop][_i2].empresa.dtReg) instanceof Date && !isNaN(new Date(arrayNotas[pos][prop][_i2].empresa.dtReg))) {
                      linhas = linhas + new Date(arrayNotas[pos][prop][_i2].empresa.dtReg).toLocaleDateString() + "</td>";
                    } else {
                      linhas = linhas + arrayNotas[pos][prop][_i2].empresa.dtReg + "</td>";
                    }
                    linhas = linhas + "<td>" + (arrayNotas[pos][prop][_i2].empresa.nfe_recebida + arrayNotas[pos][prop][_i2].empresa.nfe_emitida) + "</td><td>" + (arrayNotas[pos][prop][_i2].empresa.cte_tomada + arrayNotas[pos][prop][_i2].empresa.cte_nao_tomada) + "</td><td>" + (arrayNotas[pos][prop][_i2].empresa.nfse_recebida + arrayNotas[pos][prop][_i2].empresa.nfse_emitida) + "</td><tr/>";
                  }
                  linhas = linhas + "<tbody>" + "</table>" + "</td>";
                } else {
                  linhas = linhas + "Sem empresas" + "</td>";
                }
                _context.next = 137;
                break;

              case 118:
                if (!(prop.toLowerCase().indexOf("rela_plano") != -1)) {
                  _context.next = 136;
                  break;
                }

                text_planos = "";

                if (!arrayNotas[pos][prop]) {
                  _context.next = 133;
                  break;
                }

                _context.t2 = arrayNotas[pos][prop].toLowerCase();
                _context.next = _context.t2 === "super" ? 124 : _context.t2 === "gestao" ? 126 : _context.t2 === "performance" ? 128 : _context.t2 === "micro" ? 130 : 132;
                break;

              case 124:
                text_planos = "Super";
                return _context.abrupt("break", 133);

              case 126:
                text_planos = "Gestão";
                return _context.abrupt("break", 133);

              case 128:
                text_planos = "Performance";
                return _context.abrupt("break", 133);

              case 130:
                text_planos = "Micro";
                return _context.abrupt("break", 133);

              case 132:
                text_planos = arrayNotas[pos][prop];

              case 133:
                linhas = linhas + '<td bgcolor="#f5f5f5" style="vertical-align: middle; color: black; text-align: center;">' + text_planos + "</td>";
                _context.next = 137;
                break;

              case 136:
                if (prop.toLowerCase().indexOf("chave") != -1) {
                  _item2 = "";

                  if (arrayNotas[pos][prop] != undefined) {
                    _item2 = arrayNotas[pos][prop];
                  }
                  linhas = linhas + ("<td bgcolor=\"#f5f5f5\" style=\" color: black; text-align: center;\">\n                  '" + _item2 + "\n                  </td>");
                } else if (prop.toLowerCase().indexOf("emitIe") != -1) {
                  _item3 = "";

                  if (arrayNotas[pos][prop] != undefined) {
                    _item3 = arrayNotas[pos][prop];
                  }
                  linhas = linhas + ("<td bgcolor=\"#f5f5f5\" style=\" color: black; text-align: center;\">\n                  '" + _item3 + "\n                  </td>");
                } else {
                  _item4 = "";

                  if (arrayNotas[pos][prop] != undefined) {
                    _item4 = arrayNotas[pos][prop].toString();
                  }
                  linhas = linhas + ("<td bgcolor=\"#f5f5f5\" style=\" color: black; text-align: center;\">\n                  " + _item4 + "\n                  </td>");
                }

              case 137:
                _context.next = 15;
                break;

              case 139:
                if (linhas.length > 0) {
                  tab_text = tab_text + "<tr>" + linhas + "</tr>";
                }

              case 140:
                pos++;
                _context.next = 12;
                break;

              case 143:
                tab_text = tab_text + "</table>";
                tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
                tab_text = tab_text.replace(/<img[^>]*>/gi, "");
                tab_text = tab_text.replace(/arrow_upward/gi, "");
                tab_text = tab_text.replace(/help/gi, "");
                tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

                ua = window.navigator.userAgent;
                msie = ua.indexOf("MSIE ");
                data_type = "data:application/vnd.ms-excel;base64,", template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>', base64 = function base64(s) {
                  return window.btoa(unescape(encodeURIComponent(s)));
                }, format = function format(s, c) {
                  return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                  });
                };
                ctx = {
                  worksheet: "Sheet 1" || "Worksheet",
                  table: tab_text
                };
                blob = new Blob(["\uFEFF" + tab_text], {
                  type: "application/vnd.ms-excel;charset=UTF-8",
                  encoding: "UTF-8"
                });
                downloadUrl = URL.createObjectURL(blob);


                b.href = downloadUrl;
                b.click();
                window.URL.revokeObjectURL(downloadUrl);
                b.remove();
                _context.next = 164;
                break;

              case 161:
                _context.prev = 161;
                _context.t3 = _context["catch"](0);

                console.log("Ocorreu algum erro ao exportar para excell " + _context.t3);

              case 164:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 161]]);
      }));

      function exportExcel(_x) {
        return _ref.apply(this, arguments);
      }

      return exportExcel;
    }(),
    str2bytes: function str2bytes(str) {
      var bytes = new Uint8Array(str.length);
      for (var i = 0; i < str.length; i++) {
        bytes[i] = str.charCodeAt(i);
      }
      return bytes;
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["selected", "table"],
  data: function data() {
    return {
      dialog: false
    };
  },
  methods: {
    selecionarTodosItens: function selecionarTodosItens() {
      this.table.selecionarTodosItens('primeiro_check');
      var selected = this.table.selecionarTodosItens('all');
      this.$emit("getSelected", selected);
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_notas_cte_CteService__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_notas_nfse_NfseService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_inputFile_InputFile_vue__ = __webpack_require__(58);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["component", "empresa", "table"],
  components: {
    inputFile: __WEBPACK_IMPORTED_MODULE_5__components_shared_inputFile_InputFile_vue__["a" /* default */]
  },
  data: function data() {
    return {
      dialog: false,
      file: [],
      fileEnviado: [],
      sendingXML: false,
      errorSending: false,
      degradeColor: "greyDegrade",
      progressEnviando: 0,
      selectedMun: 0
    };
  },
  watch: {
    dialog: function dialog(newV, oldV) {
      this.resetFiles();
      this.sendingXML = false;
      this.progressEnviando = 0;
      this.fileEnviado = [];
    }
  },
  methods: {
    changeMunSelected: function changeMunSelected(codmun) {
      this.selectedMun = codmun;
    },
    getFile: function getFile(file) {
      var _this = this;

      if (file != undefined) {
        if (this.file.length > 0) {
          this.errorSending = false;
          this.degradeColor = "greyDegrade";

          var _loop = function _loop(i) {
            if (!_this.file.find(function (item, index, array) {
              var hasItem = false;
              array.forEach(function (elem) {
                if (elem.name == file[i].name && elem.size == file[i].size) {
                  hasItem = true;
                  return;
                }
              });
              return hasItem;
            })) {
              _this.file.push(file[i]);
            }
          };

          for (var i = 0; i < file.length; i++) {
            _loop(i);
          }
        } else {
          this.file = file.slice();
        }
      }
    },
    emitResetInput: function emitResetInput(evento) {},

    resetFiles: function resetFiles() {
      this.errorSending = false;
      this.degradeColor = "greyDegrade";
      this.file = [];
    },
    removeColumn: function removeColumn(item, i) {
      this.file.splice(i, 1);
      console.log(this.file);
    },

    envXml: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.progressEnviando = 0;
                this.table.resetAlert();

                if (!(this.file != undefined && this.file.length > 0)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.delegateYield( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                  var length, msgFailed, msgSuccess, contOk, posEnviados, arrayError, _loop2, i, timeOut, auxAlert, auxThis;

                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (_this2.component.name == 'CTE') {
                            _this2.service = new __WEBPACK_IMPORTED_MODULE_3__domain_notas_cte_CteService__["a" /* default */](_this2.$http);
                          } else {

                            _this2.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](_this2.$http);
                          }
                          length = _this2.file.length;
                          msgFailed = "Erro ao enviar seguintes xml: \n\n";
                          msgSuccess = "";
                          contOk = 0;
                          posEnviados = [];
                          arrayError = [];

                          _this2.sendingXML = true;
                          _loop2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop2(i) {
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop2$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    _context.next = 2;
                                    return _this2.service.sendXml(_this2.empresa._id, _this2.file[i]).then(function (resp) {
                                      _this2.progressEnviando = i * 100 / _this2.file.length;
                                      if (!resp.ok) {
                                        arrayError.push(_this2.file[i]);
                                        msgFailed += "\"" + _this2.file[i].name + "\": " + resp.body.message + ".\n\n";
                                      } else {
                                        // console.log(`ITEM ENVIADO: ${this.file[i].name} ------- ${i}`)
                                        msgSuccess += "\"" + _this2.file[i].name + "\": enviado com sucesso. \n\n";
                                        contOk++;
                                        posEnviados.push(i);
                                      }
                                    });

                                  case 2:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _loop2, _this2);
                          });
                          i = 0;

                        case 10:
                          if (!(i < _this2.file.length)) {
                            _context2.next = 15;
                            break;
                          }

                          return _context2.delegateYield(_loop2(i), "t0", 12);

                        case 12:
                          i++;
                          _context2.next = 10;
                          break;

                        case 15:
                          if (posEnviados.length > 0) {
                            for (i = 0; i < posEnviados.length; i++) {
                              // console.log(`COLOCANDO ITEM NA LISTA: ${this.file[posEnviados[i]].name}  ------- ${i}`)
                              _this2.fileEnviado.push(_this2.file[posEnviados[i]]);
                            }
                          }
                          _this2.file = arrayError.slice();
                          _this2.sendingXML = false;
                          if (contOk == length) {
                            //debugger;
                            _this2.table.snackSuccess();
                            _this2.table.snack.text = contOk == 1 ? "Arquivo enviado com sucesso!" : "Arquivos enviados com sucesso!";
                            _this2.table.snack.show = true;
                            _this2.dialog = false;
                          } else {
                            _this2.degradeColor = "dangerDegrade";
                            _this2.errorSending = true;
                            timeOut = 0;
                            //debugger;

                            if (contOk > 0) {
                              contOk > 1 ? _this2.table.snack.multiple = true : _this2.table.snack.multiple = false;
                              _this2.table.snack.text = msgSuccess;
                              _this2.table.snackSuccess();
                              _this2.table.snack.show = true;
                              _this2.table.snack.time = 7000;
                              timeOut = 8000;
                            }

                            if (arrayError.length > 0) {
                              auxAlert = _this2.table;

                              setTimeout(function () {
                                auxAlert.snack.multiple = true;
                                auxAlert.snack.text = msgFailed;
                                auxAlert.snackDanger();
                                auxAlert.snack.time = length * 3000;
                                auxAlert.snack.show = true;
                              }, timeOut);
                            }
                          }

                          auxThis = _this2;

                          _this2.table.loading = true;
                          setTimeout(function () {
                            auxThis.table.sendAtt = true;
                          }, 3000);
                          // this.table.sendAtt = true;

                        case 22:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee, _this2);
                })(), "t0", 4);

              case 4:
                _context3.next = 9;
                break;

              case 6:
                this.table.snack.text = "Necessário selecionar um arquivo!";
                this.table.snackAlert();
                this.table.snack.show = true;

              case 9:
                this.table.resetAlert();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function envXml() {
        return _ref.apply(this, arguments);
      }

      return envXml;
    }(),
    enviarPDF: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                //debugger;
                this.progressEnviando = 0;
                this.table.resetAlert();

                if (!(this.file != undefined && this.file.length > 0)) {
                  _context6.next = 6;
                  break;
                }

                return _context6.delegateYield( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                  var length, msgFailed, msgSuccess, contOk, posEnviados, arrayError, _loop3, i, timeOut, auxAlert, auxThis;

                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _this3.service = new __WEBPACK_IMPORTED_MODULE_4__domain_notas_nfse_NfseService__["a" /* default */](_this3.$http);
                          length = _this3.file.length;
                          msgFailed = "Erro ao enviar seguintes pdfs: \n\n";
                          msgSuccess = "";
                          contOk = 0;
                          posEnviados = [];
                          arrayError = [];

                          _this3.sendingXML = true;
                          _loop3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop3(i) {
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop3$(_context4) {
                              while (1) {
                                switch (_context4.prev = _context4.next) {
                                  case 0:
                                    _context4.next = 2;
                                    return _this3.service.sendPdfRobo(_this3.empresa._id, _this3.file[i], _this3.file[i].name, _this3.selectedMun).then(function (resp) {
                                      _this3.progressEnviando = i * 100 / _this3.file.length;
                                      if (!resp && resp.status !== 200) {
                                        arrayError.push(_this3.file[i]);
                                        msgFailed += "\"" + _this3.file[i].name + "\": " + resp.body.error + ".\n\n";
                                      } else {
                                        // console.log(`ITEM ENVIADO: ${this.file[i].name} ------- ${i}`)
                                        msgSuccess += "\"" + _this3.file[i].name + "\": enviado com sucesso. \n\n";
                                        contOk++;
                                        posEnviados.push(i);
                                      }
                                    });

                                  case 2:
                                  case "end":
                                    return _context4.stop();
                                }
                              }
                            }, _loop3, _this3);
                          });
                          i = 0;

                        case 10:
                          if (!(i < _this3.file.length)) {
                            _context5.next = 15;
                            break;
                          }

                          return _context5.delegateYield(_loop3(i), "t0", 12);

                        case 12:
                          i++;
                          _context5.next = 10;
                          break;

                        case 15:
                          if (posEnviados.length > 0) {
                            for (i = 0; i < posEnviados.length; i++) {
                              // console.log(`COLOCANDO ITEM NA LISTA: ${this.file[posEnviados[i]].name}  ------- ${i}`)
                              _this3.fileEnviado.push(_this3.file[posEnviados[i]]);
                            }
                          }
                          _this3.file = arrayError.slice();
                          _this3.sendingXML = false;
                          if (contOk == length) {
                            //debugger;
                            _this3.table.snackSuccess();
                            _this3.table.snack.text = contOk == 1 ? "Arquivo enviado com sucesso!" : "Arquivos enviados com sucesso!";
                            _this3.table.snack.show = true;
                            _this3.dialog = false;
                          } else {
                            _this3.degradeColor = "dangerDegrade";
                            _this3.errorSending = true;
                            timeOut = 0;
                            //debugger;

                            if (contOk > 0) {
                              contOk > 1 ? _this3.table.snack.multiple = true : _this3.table.snack.multiple = false;
                              _this3.table.snack.text = msgSuccess;
                              _this3.table.snackSuccess();
                              _this3.table.snack.show = true;
                              _this3.table.snack.time = 7000;
                              timeOut = 8000;
                            }

                            if (arrayError.length > 0) {
                              auxAlert = _this3.table;

                              setTimeout(function () {
                                auxAlert.snack.multiple = true;
                                auxAlert.snack.text = msgFailed;
                                auxAlert.snackDanger();
                                auxAlert.snack.time = length * 3000;
                                auxAlert.snack.show = true;
                              }, timeOut);
                            }
                          }

                          auxThis = _this3;

                          _this3.table.loading = true;
                          setTimeout(function () {
                            auxThis.table.sendAtt = true;
                          }, 3000);
                          // this.table.sendAtt = true;

                        case 22:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee3, _this3);
                })(), "t0", 4);

              case 4:
                _context6.next = 9;
                break;

              case 6:
                this.table.snack.text = "Necessário selecionar um arquivo!";
                this.table.snackAlert();
                this.table.snack.show = true;

              case 9:
                this.table.resetAlert();

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee4, this);
      }));

      function enviarPDF() {
        return _ref2.apply(this, arguments);
      }

      return enviarPDF;
    }()
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["text", "prevIcon", "resetInput", "component"],
  data: function data() {
    return {
      color: null,
      fileText: "Nenhum arquivo selecionado",
      path: "",
      //tamanho em bites.
      //cada 1000000 bites equivale à um mb
      tamMaximo: 2500000
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  watch: {
    resetInput: function resetInput(newV, oldV) {
      if (newV) {
        this.resetInfos();
      }
    }
  },
  methods: {
    resetInfos: function resetInfos() {
      var file = document.querySelector("#file-upload");
      file.value = "";

      this.path = "";
      this.fileText = "Nenhum arquivo selecionado";
      this.$emit("emitResetInput", false);
    },

    setFile: function setFile(e) {
      this.path = "";
      this.color = null;
      if (e.target.type == "file") {
        if (e.target.files.length > 0) {
          if (this.component == "imagem") {
            if (e.target.files[0].type != "image/jpeg") {
              this.fileText = "Formato de arquivo inválido";
              this.color = "red--text text--darken-4";
              return;
            } else if (e.target.files[0].size > this.tamMaximo) {
              this.fileText = "Arquivo muito grande";
              this.color = "red--text text--darken-4";
              return;
            } else {
              this.fileText = "Arquivo selecionado: ";
              this.path = e.target.files[0].name;
              this.$emit("getFile", e.target.files);
            }
          } else if (this.component == "certificado" && e.target.files[0].type != "application/x-pkcs12") {
            this.fileText = "Formato de arquivo inválido";
            this.color = "red--text text--darken-4";
          } else if (this.component == "xml") {
            var arqValidos = [];
            var arqInvalidos = [];
            var path = "";
            var invPath = "";
            for (var i = 0; i < e.target.files.length; i++) {
              var elem = e.target.files[i];
              if (elem.type != "text/xml") {
                invPath += "\"" + elem.name + "\" ";
                arqInvalidos.push(elem);
              } else {
                path += "\"" + elem.name + "\" ";
                arqValidos.push(elem);
              }
            }
            if (arqInvalidos.length > 0) {
              this.fileText = "Formato de arquivo inválido em: " + invPath;
              this.color = "red--text text--darken-4";
            } else {
              this.fileText = e.target.files.length == 1 ? "Arquivo selecionado: " : "Arquivos selecionados";
              this.path = path;
              this.fileText = "";
              this.path = "";
            }
            this.$emit("getFile", arqValidos);
            var file = document.querySelector("#file-upload");
            file.value = "";
          } else if (this.component == "pdf") {
            var _arqValidos = [];
            var _arqInvalidos = [];
            var _path = "";
            var _invPath = "";
            for (var _i = 0; _i < e.target.files.length; _i++) {
              var _elem = e.target.files[_i];
              if (_elem.type != "application/pdf") {
                _invPath += "\"" + _elem.name + "\" ";
                _arqInvalidos.push(_elem);
              } else {
                _path += "\"" + _elem.name + "\" ";
                _arqValidos.push(_elem);
              }
            }
            if (_arqInvalidos.length > 0) {
              this.fileText = "Formato de arquivo inválido em: " + _invPath;
              this.color = "red--text text--darken-4";
            } else {
              this.fileText = e.target.files.length == 1 ? "Arquivo selecionado: " : "Arquivos selecionados";
              this.path = _path;
              this.fileText = "";
              this.path = "";
            }
            this.$emit("getFile", _arqValidos);
            var _file = document.querySelector("#file-upload");
            _file.value = "";
          } else {
            this.fileText = "Arquivo selecionado: ";
            this.path = e.target.files[0].name;
            this.$emit("getFile", e.target.files);
          }
        } else {
          this.fileText = "Nenhum arquivo selecionado";
          this.$emit("getFile", undefined);
        }
      }
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["component", "arraySelect", "empresa", "table", "conta"],
  data: function data() {
    return {
      menu: false,
      menuX: 0,
      menuY: 0,
      items: [{
        title: "XML",
        tooltip: "Baixar apenas XML das notas selecionadas",
        icon: "",
        evento: "xml"
      }, {
        title: "PDF",
        tooltip: "Baixar apenas PDF das notas selecionadas",
        icon: "",
        evento: "pdf"
      }, {
        title: "XML e PDF",
        tooltip: "Baixar XML e PDF das notas selecionadas",
        icon: "",
        evento: "xml-pdf"
      }]
    };
  },
  methods: {
    setPositionMenu: function setPositionMenu(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    downloadMulti: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(evento) {
        var idNota, notas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                idNota = [];

                if (!(this.arraySelect.length > 0)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 4;
                return this.arraySelect.forEach(function (item) {
                  if (item) {
                    idNota.push(item._id);
                  }
                });

              case 4:
                notas = { notas: idNota, acao: evento };

                this.setDownload(notas);
                _context.next = 11;
                break;

              case 8:
                this.table.snackAlert();
                this.table.snack.text = "Necessário escolher ao menos uma nota";
                this.table.snack.show = true;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadMulti(_x) {
        return _ref.apply(this, arguments);
      }

      return downloadMulti;
    }(),
    setDownload: function setDownload(notas) {
      //debugger;
      var url = this.$http.options.root;
      switch (this.component.name) {
        case "CTE":
          url += "ctes/download/multi";
          break;
        case "NFeRecebidas":
          url += "nfes/download/multi";
          break;
        case "NFSE":
          url += "nfses/download/multi";
          break;
        default:
          throw new Error("Não foi possísvel setar url para buscar zip");
      }
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-type", "application/json");
      this.activeGlobalLoader();
      var fileName = this.component.abrev + "-" + notas.acao + ".zip";
      var auxRmvGlobalLoader = this.desactiveGlobalLoader;
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          var blob = new Blob([xhr.response], {
            type: "application/zip"
          });
          if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display:none";
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            auxRmvGlobalLoader();
          }
        } else {
          auxRmvGlobalLoader();
        }
      };

      xhr.responseType = "arraybuffer";
      xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notas));

      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // let url = this.$http.options.root;
      // switch (this.component.name) {
      //   case "CTE":
      //     url += "ctes/download/multi";
      //     break;
      //   case "NFeRecebidas":
      //     url += "nfes/download/multi";
      //     break;
      //   case "NFSE":
      //     url += "nfses/download/multi";
      //     break;
      //   default:
      //     throw new Error("Não foi possísvel setar url para buscar zip");
      // }
      // url = 'http://localhost:3050/util/gerarZip'
      // var xhr = new XMLHttpRequest();
      // xhr.open("POST", url, true);
      // xhr.setRequestHeader("Content-type", "application/json");
      // xhr.setRequestHeader("Authorization", Vue.http.headers.common['Authorization']);
      // this.activeGlobalLoader();
      // var fileName = `${this.component.abrev}-${notas.acao}.zip`;
      // let auxRmvGlobalLoader = this.desactiveGlobalLoader;
      // xhr.onreadystatechange = function() {
      //   if (xhr.readyState == 4 && xhr.status == 200) {
      //     var blob = new Blob([new Uint8Array(xhr.response.zip.data)], {
      //       type: "application/zip"
      //     });
      //     if (navigator.msSaveOrOpenBlob) {
      //       navigator.msSaveOrOpenBlob(blob, fileName);
      //     } else {
      //       var a = document.createElement("a");
      //       document.body.appendChild(a);
      //       a.style = "display:none";
      //       var url = window.URL.createObjectURL(blob);
      //       a.href = url;
      //       a.download = fileName;
      //       a.click();
      //       window.URL.revokeObjectURL(url);
      //       a.remove();
      //       auxRmvGlobalLoader();
      //     }
      //   } else {
      //     auxRmvGlobalLoader();
      //   }
      // };

      // xhr.responseType = "json";
      // notas['tipo_doc'] = this.component.name.toLowerCase();
      // xhr.send(JSON.stringify(notas));
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["component", "arraySelect", "empresa", "table", "conta", "selected"],
  data: function data() {
    return {
      menu: false,
      menuX: 0,
      menuY: 0,
      items: [{
        title: "XML",
        tooltip: "Baixar apenas XML das notas selecionadas",
        icon: "",
        evento: "xml"
      }, {
        title: "PDF",
        tooltip: "Baixar apenas PDF das notas selecionadas",
        icon: "",
        evento: "pdf"
      }, {
        title: "XML e PDF",
        tooltip: "Baixar XML e PDF das notas selecionadas",
        icon: "",
        evento: "xml-pdf"
      }]
    };
  },
  methods: {
    setPositionMenu: function setPositionMenu(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    selecionarTodosItens: function selecionarTodosItens() {
      this.table.selecionarTodosItens('primeiro_check');
      var selected = this.table.selecionarTodosItens('importador_xml');
      this.$emit("getSelected", selected);
    },
    alterarStatusErp: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(evento) {
        var chaves, auxRmvGlobalLoader, itens_ignorados;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                chaves = [];

                this.activeGlobalLoader();
                // await new Promise(r => setTimeout(r, 2000));
                auxRmvGlobalLoader = this.desactiveGlobalLoader;

                if (!(this.arraySelect.length > 0)) {
                  _context.next = 12;
                  break;
                }

                itens_ignorados = false;
                _context.next = 7;
                return this.arraySelect.forEach(function (item) {
                  if (item) {
                    if (item.statusErp != undefined) {
                      if (item.statusErp != 'validada' && item.statusErp != "") {
                        itens_ignorados = true;
                        return false;
                      } else if (item.statusErp == '') {
                        item.statusErp = "validada";
                      } else if (item.statusErp == 'validada') {
                        item.statusErp = "";
                      }
                      chaves.push(item.chave);
                    } else {
                      item.statusErp = "validada";
                      chaves.push(item.chave);
                    }
                  }
                });

              case 7:
                // this.table.selecionarTodosItens('importador_xml')
                if (itens_ignorados) {
                  this.table.snackAlert();
                  this.table.snack.text = "Existe itens selecionados que já foram integrados, e não foi possivel alterar o status";
                  this.table.snack.show = true;
                }
                _context.next = 10;
                return this.setStatusErp(chaves);

              case 10:
                _context.next = 15;
                break;

              case 12:
                this.table.snackAlert();
                this.table.snack.text = "Necessário escolher ao menos uma nota";
                this.table.snack.show = true;

              case 15:
                this.selecionarTodosItens();
                auxRmvGlobalLoader();

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function alterarStatusErp(_x) {
        return _ref.apply(this, arguments);
      }

      return alterarStatusErp;
    }(),
    setStatusErp: function setStatusErp(chaves) {
      //debugger;
      var url = this.$http.options.root;
      switch (this.component.name) {
        case "CTE":
          url += "ctes/download/multi";
          break;
        case "NFeRecebidas":
          url += "nfe/statusErp/mult";
          break;
        case "NFSE":
          url += "nfses/download/multi";
          break;
        default:
          throw new Error("Não foi possísvel setar url para alterar statusErp");
      }
      // WARNING: For POST requests, body is set to null by browsers.
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        "id_empresa": this.empresa._id,
        "chaves": chaves,
        "cnpj": this.empresa.cnpj
      });

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: data,
        redirect: 'follow'
      };

      return fetch(url, requestOptions);

      // var xhr = new XMLHttpRequest();
      // xhr.withCredentials = true;

      // xhr.addEventListener("readystatechange", function() {
      // if(this.readyState === 4) {
      //   console.log(this.responseText);
      // }
      // });

      // xhr.open("POST", url, true);

      // xhr.setRequestHeader("Content-Type", "application/json");

      // xhr.send(data);


      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // let url = this.$http.options.root;
      // switch (this.component.name) {
      //   case "CTE":
      //     url += "ctes/download/multi";
      //     break;
      //   case "NFeRecebidas":
      //     url += "nfes/download/multi";
      //     break;
      //   case "NFSE":
      //     url += "nfses/download/multi";
      //     break;
      //   default:
      //     throw new Error("Não foi possísvel setar url para buscar zip");
      // }
      // url = 'http://localhost:3050/util/gerarZip'
      // var xhr = new XMLHttpRequest();
      // xhr.open("POST", url, true);
      // xhr.setRequestHeader("Content-type", "application/json");
      // xhr.setRequestHeader("Authorization", Vue.http.headers.common['Authorization']);
      // this.activeGlobalLoader();
      // var fileName = `${this.component.abrev}-${notas.acao}.zip`;
      // let auxRmvGlobalLoader = this.desactiveGlobalLoader;
      // xhr.onreadystatechange = function() {
      //   if (xhr.readyState == 4 && xhr.status == 200) {
      //     var blob = new Blob([new Uint8Array(xhr.response.zip.data)], {
      //       type: "application/zip"
      //     });
      //     if (navigator.msSaveOrOpenBlob) {
      //       navigator.msSaveOrOpenBlob(blob, fileName);
      //     } else {
      //       var a = document.createElement("a");
      //       document.body.appendChild(a);
      //       a.style = "display:none";
      //       var url = window.URL.createObjectURL(blob);
      //       a.href = url;
      //       a.download = fileName;
      //       a.click();
      //       window.URL.revokeObjectURL(url);
      //       a.remove();
      //       auxRmvGlobalLoader();
      //     }
      //   } else {
      //     auxRmvGlobalLoader();
      //   }
      // };

      // xhr.responseType = "json";
      // notas['tipo_doc'] = this.component.name.toLowerCase();
      // xhr.send(JSON.stringify(notas));
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_notas_nfse_NfseService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zlib__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zlib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_zlib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__btnExpExcell_BtnExpExcell__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_socket_io_client__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_socket_io_client__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "component", "empresa", "table", "conta", "alert"],
  components: {
    btnExpExcell: __WEBPACK_IMPORTED_MODULE_5__btnExpExcell_BtnExpExcell__["a" /* default */]
  },
  data: function data() {
    return {
      checkboxDuplicidades: false,
      dialog: false,
      dialogAviso: false,
      fileText: "Nenhum arquivo selecionado",
      path: "",
      file: {},
      formData: new FormData(),
      cnpj: '',
      dataServico: '',
      vlEnviado: '',
      dtEmissao: null,
      duplicidade: null,
      quantity: 0,
      tableErros: null,
      headers: [],
      items: [],
      pagination: {
        rowsPerPage: 10,
        rowsPerPageItems: [10, 30, 50],
        sortBy: 'nome',
        page: 1
      },
      socket: null,
      isDes: false,
      tableId: ''
    };
  },
  created: function created() {
    this.socket = __WEBPACK_IMPORTED_MODULE_6_socket_io_client___default()(this.$http.options.root, {
      transports: ['websocket'],
      secure: true,
      query: {
        "user_id": this.conta.id_usuario,
        "sessionId": this.$session.id()
      }
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.socket.on('processandoPlanilha', function (resp) {
      var percent = resp.inseridas / resp.totalNotas * 100;
      _this.$store.commit('addProgressBar', Math.ceil(percent));
    });

    this.socket.on('processandoDES', function (resp) {
      var percent = resp.inseridas / resp.totalNotas * 100;
      _this.$store.commit('addProgressBar', Math.ceil(percent));
    });
  },

  computed: {
    paginationNumber: function paginationNumber() {
      var errors = this.quantity;
      var rows = this.pagination.rowsPerPage;

      if (errors <= 10) {
        return 1;
      } else if (errors >= rows) {
        return Math.ceil(errors / rows, 1);
      } else {
        return Math.ceil(rows / errors, 1);
      }
    }
  },
  destroyed: function destroyed() {
    this.socket.disconnect();
  },

  methods: {
    resetInfos: function resetInfos(closeDialog) {
      var file = document.querySelector("#file-upload");
      file.value = "";

      this.path = "";
      this.fileText = "Nenhum arquivo selecionado";
      if (closeDialog) {
        this.dialog = false;
      } else {
        this.dialog = true;
      }
    },

    setFile: function setFile(e) {
      this.path = "";
      if (e.target.type == "file") {
        if (e.target.files.length > 0) {
          this.fileText = "Arquivo selecionado: ";
          this.path = e.target.files[0].name;
          this.file = e.target.files[0];
        } else {
          this.fileText = "Nenhum arquivo selecionado";
        }
      } else {
        return;
      }
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var loading = document.querySelector(".c_custom-progress");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      var h4Msg = document.querySelector('.c_custom-msg');
      h4Msg.textContent = 'Aguarde enquanto a planilha é processada.';
      h4Msg.classList.add("loading_global");
      body.classList.add("loading_global");
      html.classList.add("loading_global");
      appDom.classList.add("loading_global");

      icon.classList.add("loading_global");
      loading.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      var loading = document.querySelector(".c_custom-progress");
      var h4Msg = document.querySelector('.c_custom-msg');
      h4Msg.textContent = 'Aguarde enquanto a planilha é processada.';
      h4Msg.classList.remove("loading_global");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
      loading.classList.remove("loading_global");
    },
    handleUploadDes: function handleUploadDes() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.headers = [];
                _this2.formData = new FormData();

                if (!_this2.file) {
                  _context.next = 11;
                  break;
                }

                _this2.formData.append('file', _this2.file);
                _this2.headers.push({ text: 'CNPJ/CPF Tomador', align: 'center', value: 'cnpj' }, { text: 'Razao Tomador', align: 'center', height: '37', value: 'razao' }, { text: 'Número da Nota', align: 'center', value: 'numeroNfse' }, { text: 'Valor Enviado', align: 'center', value: 'vlEnviado' }, { text: 'Data de Emissão', align: 'center', value: 'dtEmissao' });
                _this2.resetInfos(true);
                _this2.service = new __WEBPACK_IMPORTED_MODULE_3__domain_notas_nfse_NfseService__["a" /* default */](_this2.$http);
                _this2.table.loading = true;
                _this2.activeGlobalLoader();
                _context.next = 11;
                return _this2.service.uploadDes(_this2.formData, _this2.empresa._id).then(function (responseHttp) {
                  if (responseHttp) {
                    _this2.table.loading = false;

                    _this2.socket.on('responseDes', function (responseSocket) {
                      if (responseSocket && responseSocket.length > 0) {
                        _this2.quantity = responseSocket.length;
                        _this2.items = [];

                        responseSocket.map(function (nota) {
                          _this2.items.push({
                            cnpj: nota.cnpj,
                            razao: nota.razao,
                            numeroNfse: nota.numeroNfse,
                            vlEnviado: nota.valorServico,
                            dtEmissao: nota.dtEmissao.slice(0, 2) + '/' + nota.dtEmissao.slice(2, 4) + '/' + nota.dtEmissao.slice(4, 8)
                          });
                        });
                        _this2.tableId = 'tableDes';
                        _this2.duplicidade = false;
                        _this2.isDes = true;
                        _this2.table.loading = false;
                        _this2.tableErros = {};
                        _this2.tableErros.array_todas_notas = _this2.items;
                        _this2.tableErros.arrayNotas = _this2.items;
                        _this2.tableErros.pagination = _this2.pagination;
                        _this2.desactiveGlobalLoader();
                        _this2.dialogAviso = true;
                      } else {
                        _this2.desactiveGlobalLoader();
                        _this2.table.loading = false;
                        _this2.alert.snackSuccess();
                        _this2.alert.snack.time = 10000;
                        _this2.alert.snack.text = "Arquivo carregado com sucesso!";
                        _this2.alert.snack.show = true;
                        _this2.$store.commit('addUpdateTable', true);
                      }

                      _this2.$store.commit('addProgressBar', 0);
                    });
                  } else {
                    _this2.table.loading = false;
                    _this2.desactiveGlobalLoader();
                    _this2.alert.snackDanger();
                    _this2.alert.snack.time = 10000;
                    _this2.alert.snack.text = "Erro interno, favor constatar o administrador do sistema";
                    _this2.alert.snack.show = true;
                  }
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleUpload: function handleUpload() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.headers = [];
                _this3.formData = new FormData();

                if (!_this3.file) {
                  _context3.next = 11;
                  break;
                }

                _this3.formData.append('file', _this3.file);
                _this3.headers.push({ text: 'CNPJ/CPF Tomador', align: 'center', value: 'cnpj' }, { text: 'Razao Tomador', align: 'center', height: '37', value: 'razao' }, { text: 'Erro', align: 'center', value: 'erro' }, { text: 'Valor Enviado', align: 'center', value: 'vlEnviado' }, { text: 'Discriminação', align: 'center', value: 'discriminacao' });
                _this3.resetInfos(true);
                _this3.service = new __WEBPACK_IMPORTED_MODULE_3__domain_notas_nfse_NfseService__["a" /* default */](_this3.$http);
                _this3.table.loading = true;
                _this3.activeGlobalLoader();
                _context3.next = 11;
                return _this3.service.enviarPlanilha(_this3.formData, _this3.empresa._id).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (response) {
                              _this3.table.loading = false;
                              _this3.socket.on('responsePlanilha', function (resp) {
                                if (resp.erros && resp.erros.length > 0) {

                                  _this3.quantity = resp.erros.length;
                                  _this3.items = [];

                                  resp.erros.map(function (erro) {
                                    _this3.items.push({
                                      cnpj: erro.cpfCnpj,
                                      razao: erro.cliente,
                                      erro: erro.erro,
                                      vlEnviado: erro.valorEnviado,
                                      discriminacao: erro.discriminacao,
                                      emissao: erro.emissao
                                    });
                                  });
                                  _this3.tableId = 'tableErros';
                                  _this3.isDes = false;
                                  _this3.duplicidade = _this3.items.find(function (item) {
                                    return item.erro.toLowerCase().indexOf('duplicidade') > -1;
                                  });
                                  _this3.table.loading = false;
                                  _this3.tableErros = {};
                                  _this3.tableErros.array_todas_notas = _this3.items;
                                  _this3.tableErros.arrayNotas = _this3.items;
                                  _this3.tableErros.pagination = _this3.pagination;
                                  _this3.desactiveGlobalLoader();
                                  _this3.dialogAviso = true;
                                } else {
                                  _this3.desactiveGlobalLoader();
                                  _this3.table.loading = false;
                                  _this3.alert.snackSuccess();
                                  _this3.alert.snack.time = 10000;
                                  _this3.alert.snack.text = "Planilha importada com sucesso";
                                  _this3.alert.snack.show = true;
                                  _this3.$store.commit('addUpdateTable', true);
                                }
                                _this3.$store.commit('addProgressBar', 0);
                              });
                            } else {
                              _this3.table.loading = false;
                              _this3.desactiveGlobalLoader();
                              _this3.alert.snackDanger();
                              _this3.alert.snack.time = 10000;
                              _this3.alert.snack.text = "Erro interno, favor constatar o administrador do sistema";
                              _this3.alert.snack.show = true;
                            }

                          case 1:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleErros: function handleErros() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.service = new __WEBPACK_IMPORTED_MODULE_3__domain_notas_nfse_NfseService__["a" /* default */](_this4.$http);
                if (_this4.checkboxDuplicidades) {
                  _this4.dialogAviso = false;
                  _this4.table.loading = true;
                  _this4.items.map(function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(item) {
                      var json, respJson;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              if (!(item.erro.toLowerCase().indexOf('duplicidade') > -1)) {
                                _context4.next = 5;
                                break;
                              }

                              json = {
                                dataServico: item.emissao.dataServico,
                                cpfCnpj: item.emissao.cpfCnpj,
                                razao: item.emissao.razao,
                                email: item.emissao.email,
                                cep: item.emissao.cep,
                                estado: item.emissao.estado,
                                codMun: item.emissao.codMun,
                                bairro: item.emissao.bairro,
                                logradouro: item.emissao.logradouro,
                                numero: item.emissao.numero,
                                complemento: item.emissao.complemento,
                                codigoTributacao: '0403-0/04-88 Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.',
                                naturezaOperacao: 'Tributação no município',
                                regimeTributacao: 'Estimativa',
                                issqn: 'Belo Horizonte',
                                telefone: item.emissao.telefone,
                                valorTotal: item.emissao.valorTotal,
                                discriminacao: item.emissao.discriminacao
                              };
                              respJson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, json, { aceiteDuplicidade: _this4.conta.id_usuario });
                              _context4.next = 5;
                              return _this4.service.inserirNovaNota(respJson);

                            case 5:
                            case 'end':
                              return _context4.stop();
                          }
                        }
                      }, _callee4, _this4);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }
                _this4.table.loading = false;
                _this4.$store.commit('addUpdateTable', true);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    }
  }
});

/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_NfseService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zlib__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zlib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_zlib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__btnExpExcell_BtnExpExcell__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_socket_io_client__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_socket_io_client__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "component", "empresa", "table", "conta", "alert"],
  components: {
    btnExpExcell: __WEBPACK_IMPORTED_MODULE_4__btnExpExcell_BtnExpExcell__["a" /* default */]
  },
  data: function data() {
    return {
      checkboxDuplicidades: false,
      dialog: false,
      dialogAviso: false,
      fileText: "Nenhum arquivo selecionado",
      path: "",
      file: {},
      formData: new FormData(),
      cnpj: '',
      dataServico: '',
      vlEnviado: '',
      dtEmissao: null,
      duplicidade: null,
      quantity: 0,
      tableErros: null,
      headers: [],
      items: [],
      pagination: {
        rowsPerPage: 10,
        rowsPerPageItems: [10, 30, 50],
        sortBy: 'nome',
        page: 1
      },
      socket: null,
      tableId: ''
    };
  },
  created: function created() {
    this.socket = __WEBPACK_IMPORTED_MODULE_5_socket_io_client___default()(this.$http.options.root, {
      transports: ['websocket'],
      secure: true,
      query: {
        "user_id": this.conta.id_usuario,
        "sessionId": this.$session.id()
      }
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.socket.on('processandoPlanilhaEscrituracao', function (resp) {
      var percent = resp.inseridas / resp.totalNotas * 100;
      _this.$store.commit('addProgressBar', Math.ceil(percent));
    });
  },

  computed: {
    paginationNumber: function paginationNumber() {
      var errors = this.quantity;
      var rows = this.pagination.rowsPerPage;

      if (errors <= 10) {
        return 1;
      } else if (errors >= rows) {
        return Math.ceil(errors / rows, 1);
      } else {
        return Math.ceil(rows / errors, 1);
      }
    }
  },
  destroyed: function destroyed() {
    this.socket.disconnect();
  },

  methods: {
    resetInfos: function resetInfos(closeDialog) {
      var file = document.querySelector("#file-upload");
      file.value = "";

      this.path = "";
      this.fileText = "Nenhum arquivo selecionado";
      if (closeDialog) {
        this.dialog = false;
      } else {
        this.dialog = true;
      }
    },

    setFile: function setFile(e) {
      this.path = "";
      if (e.target.type == "file") {
        if (e.target.files.length > 0) {
          this.fileText = "Arquivo selecionado: ";
          this.path = e.target.files[0].name;
          this.file = e.target.files[0];
        } else {
          this.fileText = "Nenhum arquivo selecionado";
        }
      } else {
        return;
      }
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var loading = document.querySelector(".c_custom-progress");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      var h4Msg = document.querySelector('.c_custom-msg');
      h4Msg.textContent = 'Aguarde enquanto a planilha é processada.';
      h4Msg.classList.add("loading_global");
      body.classList.add("loading_global");
      html.classList.add("loading_global");
      appDom.classList.add("loading_global");

      icon.classList.add("loading_global");
      loading.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      var loading = document.querySelector(".c_custom-progress");
      var h4Msg = document.querySelector('.c_custom-msg');
      h4Msg.textContent = 'Aguarde enquanto a planilha é processada.';
      h4Msg.classList.remove("loading_global");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
      loading.classList.remove("loading_global");
    },

    handleUpload: function handleUpload() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.headers = [];
                _this2.formData = new FormData();

                if (!_this2.file) {
                  _context2.next = 11;
                  break;
                }

                _this2.formData.append('file', _this2.file);
                _this2.headers.push({ text: 'CNPJ/CPF Prestador', align: 'center', value: 'cnpjCpfPrestador' }, { text: 'Razao Prestador', align: 'center', height: '37', value: 'razaoPrestador' }, { text: 'Erro', align: 'center', value: 'erro' }, { text: 'Número da Nota', align: 'center', value: 'numero' });
                _this2.resetInfos(true);
                _this2.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_NfseService__["a" /* default */](_this2.$http);
                _this2.table.loading = true;
                _this2.activeGlobalLoader();
                _context2.next = 11;
                return _this2.service.enviarPlanilhaEscrituracao(_this2.formData, _this2.empresa._id).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (response) {
                              _this2.table.loading = false;
                              _this2.socket.on('responsePlanilhaEscrituracao', function (resp) {
                                if (resp.erros && resp.erros.length > 0) {

                                  _this2.quantity = resp.erros.length;
                                  _this2.items = [];

                                  resp.erros.map(function (erro) {
                                    _this2.items.push({
                                      cnpjCpfPrestador: erro.cnpjCpfPrestador,
                                      razaoPrestador: erro.razaoPrestador,
                                      erro: erro.erro,
                                      numero: erro.numero
                                    });
                                  });
                                  _this2.tableId = 'tableErros';
                                  _this2.duplicidade = _this2.items.find(function (item) {
                                    return item.erro.toLowerCase().indexOf('duplicidade') > -1;
                                  });
                                  _this2.table.loading = false;
                                  _this2.tableErros = {};
                                  _this2.tableErros.array_todas_notas = _this2.items;
                                  _this2.tableErros.arrayNotas = _this2.items;
                                  _this2.tableErros.pagination = _this2.pagination;
                                  _this2.desactiveGlobalLoader();
                                  _this2.dialogAviso = true;
                                } else {
                                  _this2.desactiveGlobalLoader();
                                  _this2.table.loading = false;
                                  _this2.alert.snackSuccess();
                                  _this2.alert.snack.time = 10000;
                                  _this2.alert.snack.text = "Planilha importada com sucesso";
                                  _this2.alert.snack.show = true;
                                  _this2.$store.commit('addUpdateTable', true);
                                }
                                _this2.$store.commit('addProgressBar', 0);
                              });
                            } else {
                              _this2.table.loading = false;
                              _this2.desactiveGlobalLoader();
                              _this2.alert.snackDanger();
                              _this2.alert.snack.time = 10000;
                              _this2.alert.snack.text = "Erro interno, favor constatar o administrador do sistema";
                              _this2.alert.snack.show = true;
                            }

                          case 1:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleErros: function handleErros() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfse_NfseService__["a" /* default */](_this3.$http);
                // if(this.checkboxDuplicidades) {
                //   this.dialogAviso = false;
                //   this.table.loading = true;
                //   this.items.map(async (item) => {
                //     if(item.erro.toLowerCase().indexOf('duplicidade') > -1) {
                //       const json = {
                //         dataServico: item.emissao.dataServico,
                //         cpfCnpj: item.emissao.cpfCnpj,
                //         razao: item.emissao.razao,
                //         email: item.emissao.email,
                //         cep: item.emissao.cep,
                //         estado: item.emissao.estado,
                //         codMun: item.emissao.codMun,
                //         bairro: item.emissao.bairro,
                //         logradouro: item.emissao.logradouro,
                //         numero: item.emissao.numero,
                //         complemento: item.emissao.complemento,
                //         codigoTributacao: '0403-0/04-88 Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.',
                //         naturezaOperacao: 'Tributação no município',
                //         regimeTributacao: 'Estimativa',
                //         issqn: 'Belo Horizonte',
                //         telefone: item.emissao.telefone,
                //         valorTotal: item.emissao.valorTotal,
                //         discriminacao: item.emissao.discriminacao,
                //       }

                //       const respJson = { ...json, aceiteDuplicidade: this.conta.id_usuario };
                //       await this.service.inserirNovaNota(respJson);
                //     }
                //   })
                // }
                _this3.table.loading = false;
                _this3.$store.commit('addUpdateTable', true);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["component", "arraySelect", "empresa", "table", "conta"],
  data: function data() {
    return {
      menu: false,
      menuX: 0,
      menuY: 0,
      items: [{
        title: "XML",
        tooltip: "Enviar apenas XML das notas selecionadas",
        icon: "",
        evento: "xml"
      }, {
        title: "PDF",
        tooltip: "Enviar apenas PDF das notas selecionadas",
        icon: "",
        evento: "pdf"
      }, {
        title: "XML e PDF",
        tooltip: "Enviar XML e PDF das notas selecionadas",
        icon: "",
        evento: "xml-pdf"
      }]
    };
  },
  methods: {
    setPositionMenu: function setPositionMenu(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    downloadMulti: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(evento) {
        var idNota, notas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                idNota = [];

                if (!(this.arraySelect.length > 0)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 4;
                return this.arraySelect.forEach(function (item) {
                  if (item) {
                    idNota.push(item._id);
                  }
                });

              case 4:
                notas = { notas: idNota, acao: evento };

                this.setDownload(notas, this.arraySelect);
                _context.next = 11;
                break;

              case 8:
                this.table.snackAlert();
                this.table.snack.text = "Necessário escolher ao menos uma nota";
                this.table.snack.show = true;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadMulti(_x) {
        return _ref.apply(this, arguments);
      }

      return downloadMulti;
    }(),
    setDownload: function setDownload(notas, itens) {
      //debugger;

      var url = this.$http.options.root;
      switch (this.component.name) {

        case "NFeRecebidas":
          url += "nfes/send/ftp";
          break;

        default:
          throw new Error("Não foi possísvel setar url para buscar zip");
      }
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-type", "application/json");
      this.activeGlobalLoader();

      var auxRmvGlobalLoader = this.desactiveGlobalLoader;
      xhr.onreadystatechange = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(xhr.readyState == 4 && xhr.status == 200)) {
                  _context2.next = 17;
                  break;
                }

                if (!(notas.acao == 'xml-pdf')) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return itens.forEach(function (item) {
                  if (item) {
                    item.ftpPython = 'pendente';
                    item.ftpPythonPdf = 'pendente';
                    item.logErroFtpPdf = '';
                    item.logErroFtpXml = '';
                  }
                });

              case 4:
                _context2.next = 14;
                break;

              case 6:
                if (!(notas.acao == 'xml')) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return itens.forEach(function (item) {
                  if (item) {
                    item.ftpPython = 'pendente';
                    item.logErroFtpXml = '';
                  }
                });

              case 9:
                _context2.next = 14;
                break;

              case 11:
                if (!(notas.acao == 'pdf')) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 14;
                return itens.forEach(function (item) {
                  if (item) {
                    item.ftpPythonPdf = 'pendente';
                    item.logErroFtpPdf = '';
                  }
                });

              case 14:
                auxRmvGlobalLoader();

                _context2.next = 18;
                break;

              case 17:
                auxRmvGlobalLoader();

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notas));
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["component", "arraySelect", "empresa", "table", "conta"],
  data: function data() {
    return {
      menu: false,
      menuX: 0,
      menuY: 0,
      items: [{
        title: "Iniciar solicitação",
        tooltip: "Iniciar solicitação no Fluig",
        icon: "",
        evento: "iniciar"
      }, {
        title: "Cancelar solicitação",
        tooltip: "Cancelar solicitação no Fluig, (SOMENTE AS QUE DERAM FALHA NO CANCELAMENTO)",
        icon: "",
        evento: "cancelar"
      }]
    };
  },
  methods: {
    setPositionMenu: function setPositionMenu(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    downloadMulti: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(evento) {
        var idNota, notas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                idNota = [];

                if (!(this.arraySelect.length > 0)) {
                  _context.next = 13;
                  break;
                }

                if (!(evento == 'cancelar')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return this.arraySelect.forEach(function (item) {
                  if (item) {
                    if (item.statusErpDois.toLowerCase() === 'falha-cancelamento') {

                      idNota.push(item._id);
                    }
                  }
                });

              case 5:
                _context.next = 10;
                break;

              case 7:
                if (!(evento == 'iniciar')) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return this.arraySelect.forEach(function (item) {
                  if (item) {
                    //if (!item.statusErpDois || item.statusErpDois.toLowerCase() !== 'integrado'
                    //&& item.statusErpDois.toLowerCase() !== 'falha-cancelamento'){
                    //idNota.push(item._id);
                    //}
                    idNota.push(item._id);
                  }
                });

              case 10:
                if (idNota.length > 0) {
                  notas = { notas: idNota, acao: evento };

                  this.setDownload(notas, this.arraySelect);
                }
                _context.next = 16;
                break;

              case 13:
                this.table.snackAlert();
                this.table.snack.text = "Necessário escolher ao menos uma nota";
                this.table.snack.show = true;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadMulti(_x) {
        return _ref.apply(this, arguments);
      }

      return downloadMulti;
    }(),
    setDownload: function setDownload(notas, itens) {
      //debugger;

      var url = this.$http.options.root;
      switch (this.component.name) {

        case "NFeRecebidas":
          url += "nfes/send/fluig";
          break;

        case "NFSE":
          url += "nfses/send/fluig";
          break;

        case "CTE":
          url += "ctes/send/fluig";
          break;

        default:
          throw new Error("Não foi possísvel setar url para buscar zip");
      }
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-type", "application/json");
      this.activeGlobalLoader();

      var auxRmvGlobalLoader = this.desactiveGlobalLoader;
      xhr.onreadystatechange = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(xhr.readyState == 4 && xhr.status == 200)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return itens.forEach(function (item) {
                  if (item) {
                    item.statusErpDois = 'processando';
                    item.log_statusErpDois = '';
                  }
                });

              case 3:

                auxRmvGlobalLoader();

                _context2.next = 7;
                break;

              case 6:
                auxRmvGlobalLoader();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notas));
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  methods: {}
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["mostrar", "table", "component", "empresa"],
  data: function data() {
    return {
      menu0: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      real: "",
      maskData: "##-##-####"
    };
  },
  updated: function updated() {
    this.$nextTick(function () {
      // this.getSelect(this.table.filtros.items[12].valor);
    });
  },
  computed: {},
  watch: {},
  methods: {
    getSelect: function getSelect(v) {
      if (v != null) {
        var fields = document.querySelectorAll(".fDtVencimento");
        if (v.valor == "Não informado") {
          fields.forEach(function (e) {
            e.classList.add("v-menu__activator--disabled");
          });
          this.vencimentoIni = null;
          this.vencimentoFim = null;
        } else {
          fields.forEach(function (e) {
            e.classList.remove("v-menu__activator--disabled");
          });
        }
      }
    },
    mask: function mask(item) {
      if (item.valor != null) {
        var v = item.valor;
        v = this.addVirgula(v);
        v = v.replace(/(\d+)(\d{3},\d{2})$/g, "$1.$2"); //Coloca o primeiro ponto
        var qtdLoop = (v.length - 3) / 3;
        var count = 0;
        while (qtdLoop > count) {
          count++;
          v = v.replace(/(\d+)(\d{3}.*)/, "$1.$2"); //Coloca o resto dos pontos
        }
        v = v.replace(/^(0+)(\d)/g, "$2"); //remove "0" Ă  esquerda
        item.valor = v;
      }
    },

    addVirgula: function addVirgula(v) {
      v = v.replace(/\D/g, ""); //Remode tudo o que não é dígito
      v = v.replace(/(\d+)(\d{2})/, "$1,$2");
      return v;
    },
    resetFiltro: function resetFiltro() {
      this.table.resetFiltro();
      this.emissaoIni = null;
      this.emissaoFim = null;
      this.importacaoIni = null;
      this.importacaoFim = null;
      this.vencimentoIni = null;
      this.vencimentoFim = null;
    },
    fecharPanelFiltro: function fecharPanelFiltro() {
      this.table.filtros.fechar = true;
      this.$emit("getFiltro", this.table.filtros);
    },

    returnFiltro: function returnFiltro(boolean) {
      this.table.filtros.fechar = boolean;
      if (!boolean) {
        this.resetFiltro();
      }
      this.table.filtros.items.forEach(function (item) {
        switch (item.type) {
          case "D":
            if (item.valor != null && item.valor.length == 8) {
              var aux = item.valor.substring(0, 2).concat("-");
              aux += item.valor.substring(2, 4).concat("-");
              aux += item.valor.substring(4, 8);
              item.valor = aux;
            } else {
              item.valor = null;
            }
            break;
        }
      });
      this.$emit("getFiltro", this.table.filtros);
    },
    openMenu: function openMenu(e) {},
    validateDate: function validateDate(field, item) {
      if (field.target.value.length == 10) {
        item.valor = field.target.value.split("-").join("");
        item.data = field.target.value.split("-").reverse().join("-");
      }
    },
    setHifenDate: function setHifenDate(v) {},
    formatDate: function formatDate(date, menu) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "-" + month + "-" + year;
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__btnCTeVinculadas_BtnCTeVinculadas_vue__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__btnCCeVinculadas_BtnCCeVinculadas_vue__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__btnNFeVinculadas_BtnNFeVinculadas_vue__ = __webpack_require__(723);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota", "empresa", "component"],
  updated: function updated() {
    this.$nextTick(function () {});
  },
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false
    };
  },
  components: {
    btnCTeVinculadas: __WEBPACK_IMPORTED_MODULE_0__btnCTeVinculadas_BtnCTeVinculadas_vue__["a" /* default */],
    btnCCeVinculadas: __WEBPACK_IMPORTED_MODULE_1__btnCCeVinculadas_BtnCCeVinculadas_vue__["a" /* default */],
    btnNFeVinculadas: __WEBPACK_IMPORTED_MODULE_2__btnNFeVinculadas_BtnNFeVinculadas_vue__["a" /* default */]
  },
  methods: {
    teste: function teste() {}
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_cte_CteService__ = __webpack_require__(21);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota"],
  data: function data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "Clique na chave para exibir a nota"
    };
  },

  watch: {
    dialog: function dialog(newV, oldV) {
      if (newV) {
        this.getNFeVinculada(this.nota.item.cte[0]._id);
      }
    }
  },
  computed: {},
  created: function created() {},
  methods: {
    getNFeVinculada: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id_cte) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_cte_CteService__["a" /* default */](this.$http);
                _context.next = 3;
                return this.service.getDacte(id_cte).then(function (danfe) {
                  return _this.danfeB64 = danfe;
                });

              case 3:

                this.setPdfData();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getNFeVinculada(_x) {
        return _ref.apply(this, arguments);
      }

      return getNFeVinculada;
    }(),
    setPdfData: function setPdfData() {
      if (this.danfeB64) {
        this.text_info = "";
        if (document.getElementById("pdf")) {
          document.getElementById("pdf").remove();
        }
        var embed = document.createElement("EMBED");
        embed.setAttribute("src", "data:application/pdf;base64," + encodeURIComponent(this.danfeB64));
        embed.setAttribute("id", "pdf");
        document.querySelector("#bodyNFeVinculada").appendChild(embed);
      } else {
        this.text_info = "Nota não encontrada em nosso sistema, disponivel somente em consulta individual no sefaz";
      }
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__ = __webpack_require__(14);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota"],
  data: function data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "Clique na Cce para exibi-lá"
    };
  },

  watch: {
    dialog: function dialog(newV, oldV) {
      if (newV) {

        this.getCce(this.nota.item._id, 0);
      }
    }
  },
  computed: {},
  methods: {
    getCce: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id, indice) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_nfe_NfeService__["a" /* default */](this.$http);
                _context.next = 3;
                return this.service.getDacce(id, indice).then(function (dacce) {
                  this.danfeB64 = dacce;
                  this.setPdfData();
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCce(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getCce;
    }(),
    setPdfData: function setPdfData() {
      if (this.danfeB64) {
        this.text_info = "";
        if (document.getElementById("pdf")) {
          document.getElementById("pdf").remove();
        }
        var embed = document.createElement("EMBED");
        embed.setAttribute("src", "data:application/pdf;base64," + encodeURIComponent(this.danfeB64));
        embed.setAttribute("id", "pdf");
        document.querySelector("#bodyNFeVinculada").appendChild(embed);
      } else {
        this.text_info = "Cce não encontrada em nosso sistema, disponivel somente em consulta individual no sefaz";
      }
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_cte_CteService__ = __webpack_require__(21);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["nota"],
  data: function data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "Clique na chave para exibir a nota"
    };
  },

  watch: {},
  computed: {},
  methods: {
    getNFeVinculada: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(chave) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_notas_cte_CteService__["a" /* default */](this.$http);
                _context.next = 3;
                return this.service.getNfeByChave(chave).then(function (success) {
                  return _this.danfeB64 = success;
                });

              case 3:
                this.setPdfData();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getNFeVinculada(_x) {
        return _ref.apply(this, arguments);
      }

      return getNFeVinculada;
    }(),
    setPdfData: function setPdfData() {
      if (this.danfeB64) {
        this.text_info = "";
        if (document.getElementById("pdf")) {
          document.getElementById("pdf").remove();
        }
        var embed = document.createElement("EMBED");
        embed.setAttribute("src", "data:application/pdf;base64," + encodeURIComponent(this.danfeB64));
        embed.setAttribute("id", "pdf");
        document.querySelector("#bodyNFeVinculada").appendChild(embed);
      } else {
        this.text_info = "Nota não encontrada em nosso sistema, disponivel somente em consulta individual no sefaz";
      }
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_notas_manifesto_colunaManifestoService_js__ = __webpack_require__(729);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['item', 'nota', 'empresa'],
  data: function data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "",
      token: '',
      showError: false
    };
  },
  mounted: function mounted() {
    if (this.empresa.tknIntegracao && this.empresa.tknIntegracao.token) {
      this.token = this.empresa.tknIntegracao.token;
    } else {
      this.token = this.empresa.tknIntegracao ? this.empresa.tknIntegracao.refEmpresa : null;
    }
  },

  methods: {
    getNotaManifestada: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var json, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.danfeB64 = '';
                this.showError = false;
                this.activeGlobalLoader();

                json = {
                  chave: this.nota.item && this.nota.item.chave ? this.nota.item.chave : '',
                  componente: this.nota.item && this.nota.item.nfe ? 'CTE' : 'NFE'
                };
                _context.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_2__domain_notas_manifesto_colunaManifestoService_js__["a" /* getDocumentoManifesto */])(this.empresa._id, json, this.token);

              case 6:
                response = _context.sent;

                this.desactiveGlobalLoader();
                this.dialog = true;
                if (response && response.pdf) {
                  this.danfeB64 = response.pdf;
                } else {
                  this.showError = true;
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getNotaManifestada() {
        return _ref.apply(this, arguments);
      }

      return getNotaManifestada;
    }(),
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item", "empresa", "component"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false
    };
  },
  methods: {
    openTabelaParcela: function openTabelaParcela() {
      this.openDialog = true;
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item", "empresa", "component"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false
    };
  },
  methods: {
    openTabelaParcela: function openTabelaParcela(item) {
      this.openDialog = true;
      console.log(item);
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item", "empresa", "component"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false
    };
  },
  methods: {
    openTabelaParcela: function openTabelaParcela() {
      this.openDialog = true;
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_notas_nfse_util__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item", "table", "component"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false,
      desc: []
    };
  },
  methods: {
    openTabelaParcela: function openTabelaParcela() {
      this.openDialog = true;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.desc = __WEBPACK_IMPORTED_MODULE_0__domain_notas_nfse_util__["d" /* simples */];
    });
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_notas_nfse_util__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item", "table", "component"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false,
      dataVerificao: new Date("2015-02-22T00:00:00"),
      descAntiga: [{ tipo: "T", desc: "Tributação no município de São Paulo." }, { tipo: "F", desc: "Tributação fora do município de São Paulo." }, { tipo: "I", desc: "Isento/Imune." }, { tipo: "J", desc: "ISS Suspenso por Decisão Judicial." }],
      descAtt: []
    };
  },
  methods: {
    openTabelaParcela: function openTabelaParcela() {
      this.openDialog = true;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.descAtt = __WEBPACK_IMPORTED_MODULE_0__domain_notas_nfse_util__["e" /* tributacao */];
    });
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false
    };
  },
  methods: {
    openTabelaLei: function openTabelaLei() {
      this.openDialog = true;
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item"],
  beforeMount: function beforeMount() {},

  data: function data() {
    return {
      openDialog: false
    };
  },
  methods: {
    openTabelaInfAd: function openTabelaInfAd() {
      this.openDialog = true;
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["component", "table"],
  data: function data() {
    return {
      interval: false,
      pos: 3,
      lastPos: null,
      soma: 0
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  methods: {
    scroll: function scroll(e) {
      var _this = this;

      if (!this.interval) {

        this.interval = setInterval(function () {
          if (_this.lastPos == null) {
            var auxListaColunas = document.querySelector("#table table tbody tr").childNodes;
            var listaColunas = [];
            auxListaColunas.forEach(function (element) {
              if (element.nodeName == "TD") {
                listaColunas.push(element);
              }
            });
            try {
              if (e == "left" && _this.pos > 3) {
                _this.pos--;
              }
              var content = document.querySelector("#table .v-table__overflow");
              var scrollX = listaColunas[_this.pos].offsetWidth;

              if (e == "left") {
                scrollX = scrollX * -1;
              } else if (content.scrollLeft < content.scrollWidth - content.offsetWidth - 2) {
                _this.pos++;
              } else {
                _this.lastPos == _this.pos;
              }

              content.scrollBy(scrollX, 0);
            } catch (error) {
              throw new Error("Erro ao tentar scrollar tabela usando botão" + error);
            }
          }
        }, 120);
      }
    },
    stop: function stop() {
      clearInterval(this.interval);
      this.interval = false;
    },
    handleRefresh: function handleRefresh() {
      // this.table.loading = true; 
      this.$store.commit('addUpdateTable', true);
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrayPlanos; });

var arrayPlanos = [{ text: "Micro", _id: "micro" }, { text: "Gestão", _id: "gestao" }, { text: "Performance", _id: "performance" }, { text: "Super", _id: "super" }];

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['table'],
  data: function data() {
    return {};
  },
  watch: {
    "table.showSnackAtt": function tableShowSnackAtt(oldv, newv) {
      if (this.table.showSnackAtt) {
        var auxTable = this.table;
        setTimeout(function () {
          auxTable.busca = false;
          auxTable.loading = false;
          auxTable.snack.text = "Informações da tabela foram atualizadas";
          auxTable.snackDefault();
          auxTable.snack.show = true;
          auxTable.addedCustomColumn = false;
          auxTable.showSnackAtt = false;
        }, 500);
      }
    }
  }

});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocsFederal_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c24f7f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocsFederal_vue__ = __webpack_require__(769);
function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c24f7f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocsFederal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c24f7f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocsFederal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TreeBrowser_TreeBrowser__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_documentos_Documentos__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_automacaoFiscal_iptu_IptuService__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfe_NfeService__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_uploadFile_UploadFile__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_notas_nfse_NfseService__ = __webpack_require__(22);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

  props: ["conta", "empresa", "alert", 'IBGE', 'component'],
  data: function data() {
    return {
      imoveisList: [],
      fileItems: [],
      currentNode: '',
      root: [],
      dialog: false,
      dialogRenomearArquivo: false,
      dialogPDF: false,
      danfe: null,
      download: null,
      selectedItem: '',
      headers: [{ text: 'Ações', align: 'center', value: 'actions' }, { text: 'Nome', align: 'center', height: '37', value: 'nome' }, { text: 'Data de inclusão', align: 'center', value: 'insertDate' }, { text: 'Ultima atualização', align: 'center', value: 'dateUpdate' }],
      editedIndex: -1,
      editedItem: {
        name: '',
        createdBy: '',
        dateUpdate: ''
      },
      search: '',
      pagination: {
        rowsPerPage: 10,
        rowsPerPageItems: [10, 30, 50],
        sortBy: 'nome'
      },
      items: [{
        title: "PDF",
        tooltip: "Baixar apenas PDF das notas selecionadas",
        icon: "",
        evento: "pdf"
      }],
      open: [],
      active: [],
      selectedPasta: [],
      fileList: [],
      formatedJson: [],
      bread: [],
      nodeChildren: [],
      tamanho: '',
      dataIni: '',
      dataMod: '',
      nomeDoc: '',
      iptuName: ''
    };
  },
  mounted: function mounted() {
    this.handleTreeView();
  },

  watch: {
    empresa: function empresa(newV, oldV) {
      if (newV._id != oldV._id) {
        var changePage = newV.servicos ? newV.servicos.robotizacao.find(function (item) {
          return item.nomeServico == "IPTU";
        }) : null;
        if (!changePage) {
          this.$router.push('/DashBoard');
          return;
        } else {
          this.handleTreeView();
        }
      }
    }
  },

  methods: {
    handleTreeView: function handleTreeView() {
      var _this = this;

      this.imoveisList = [];
      this.formatedJson = [];
      var service = new __WEBPACK_IMPORTED_MODULE_4__domain_documentos_Documentos__["a" /* default */](this.$http);
      var iptuService = new __WEBPACK_IMPORTED_MODULE_5__domain_automacaoFiscal_iptu_IptuService__["a" /* default */](this.$http);
      this.activeGlobalLoader();
      iptuService.getImoveis(0, 0, this.empresa._id).then(function (imoveis) {
        service.getDocsFederal(imoveis).then(function (json) {
          _this.imoveisList.push(json);
          service.convertJson(json).then(function (json) {
            _this.root = json;
            _this.desactiveGlobalLoader();
          });
        });
      });

      // service.getDbData(this.imoveisList).then(response => {
      this.formatedJson.push(this.imoveisList);
      this.$store.commit('addMongoFolderReturn', this.imoveisList);
      // });
    },
    updateFileList: function updateFileList() {
      this.fileItems = this.files;
    },

    getDanfe: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(idImovel, idIptu, name) {
        var _this2 = this;

        var service;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.iptuName = name;
                service = new __WEBPACK_IMPORTED_MODULE_4__domain_documentos_Documentos__["a" /* default */](this.$http);
                _context.next = 4;
                return service.getIptu(idImovel, idIptu).then(function (file) {
                  _this2.danfe = file;
                  if (_this2.danfe != null) {
                    _this2.dialogPDF = true;
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDanfe(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return getDanfe;
    }(),
    setDanfe: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(idImovel, idIptu, fileName) {
        var _this3 = this;

        var service;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                service = new __WEBPACK_IMPORTED_MODULE_4__domain_documentos_Documentos__["a" /* default */](this.$http);
                _context2.next = 3;
                return service.getIptu(idImovel, idIptu).then(function (file) {
                  _this3.download = file;
                  _this3.setDownload(fileName);
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setDanfe(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      }

      return setDanfe;
    }(),
    setDownload: function setDownload(fileName) {
      var a = document.querySelector("#dLinkPdf");
      a.setAttribute("href", "data:application/pdf;base64," + encodeURIComponent(this.download));

      a.setAttribute("download", fileName);
      a.click();
      a.removeAttribute("href");
      a.removeAttribute("download");

      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    },
    setDownloadXml: function setDownloadXml() {
      // var a = document.querySelector("#dLinkPdf");
      // a.setAttribute(
      //   "href",
      //   "data:text/plain;charset=utf-8," + encodeURIComponent(this.download)
      // );
      // console.log(this.nomeDoc);
      // let nome = this.component.tipo + '_novembro';
      // if(this.editedItem.nome) {
      //   nome = this.editedItem.nome;
      // }
      // a.setAttribute("download", nome + ".csv");
      // a.click();
      // a.removeAttribute("href");
      // a.removeAttribute("download");

      var csvContent = atob(this.download);
      var blob = new Blob([csvContent], { type: "data:application/octet-stream;base64" });
      var url = window.URL.createObjectURL(blob);
      // you need to precise a front-end button to have a name
      var dlnk = document.querySelector("#dLinkPdf");
      dlnk.href = url;
      var nome = this.nomeDoc;
      if (this.editedItem.nome) {
        nome = this.editedItem.nome;
      }
      dlnk.setAttribute("download", this.nomeDoc);
      dlnk.click();
      dlnk.removeAttribute("href");
      dlnk.removeAttribute("download");

      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    disableButton: function disableButton(fileName) {
      if (fileName && fileName.includes('pdf')) {
        return true;
      } else {
        return false;
      }
    },
    changeSort: function changeSort(column) {
      console.log('changeSort');
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    handleBreadcrumbs: function handleBreadcrumbs(e) {
      var _this4 = this;

      var activeNode = {};
      if (this.bread) {
        this.bread.map(function (node) {
          if (node.id == e.target.id) {
            activeNode = node;
            // this.handleFocus(e.target.innerText);
          }
        });
      }
      this.montaArvoreSelecionada(activeNode.id).then(function (folderList) {
        var auxList = [];
        _this4.nodeChildren = [];
        if (folderList.length) {
          folderList.length = folderList.length;

          folderList.map(function (item, index) {
            auxList.push({ text: item.nome, id: item.idPasta, parentId: item.idPai ? item.idPai : "root" });
            if (folderList.length - 1 === index) {

              _this4.findChildren(item.idPasta).then(function () {
                _this4.fileList = _this4.nodeChildren;
                if (_this4.fileList.length) {
                  _this4.$store.commit('addFiles', _this4.fileList);
                  _this4.fileItems = _this4.fileList;
                } else {
                  var json = _this4.formatedJson;
                  var parent = json[0][0].find(function (pasta) {
                    return pasta.idPai === item.idPasta;
                  });
                  if (parent) {
                    _this4.$store.commit('addLastExpandedFolder', { name: parent.nome, id: parent.idPasta, parentId: undefined, origin: parent.origin, children: parent.children });
                    _this4.fileList = [];
                    _this4.$store.commit('resetFiles');
                    _this4.fileItems = [];
                  }
                }
              });
            }
          });
          _this4.bread = auxList;
        }
      });
    },
    setFile: function setFile(e) {
      this.file = e.target.files;
    },
    findChildren: function findChildren(nodeId) {
      var _this5 = this;

      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.root.map(function (node) {
                  var obj = node;

                  if (children) {
                    obj = children;
                  }

                  if (obj.idPasta === nodeId) {
                    if (obj.arquivos) {
                      _this5.nodeChildren = obj.arquivos;
                    }

                    return true;
                  }
                  if (obj.children) {
                    obj.children.map(function (child) {

                      _this5.findChildren(nodeId, child);
                    });
                  }

                  return false;
                });

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    pushFiles: function pushFiles(node) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!node.arquivos) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return', node.arquivos);

              case 4:
                return _context4.abrupt('return', []);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    handleOpenFolder: function handleOpenFolder(item, open) {
      var _this7 = this;

      if (!open) {
        this.$store.commit('addLastExpandedFolder', { name: '', id: '', parentId: '', origin: '', children: [] });
        return '';
      }

      // let treeview = document.querySelectorAll('#treeview-id .v-treeview-node__content');
      // let icon = document.querySelectorAll('#treeview-id .v-treeview-node__content i');
      // let label = document.querySelectorAll('#treeview-id .v-treeview-node__content .v-treeview-node__label');
      // if(treeview.length > 1) {
      //   for(let i=0; i<treeview.length; i++) {
      //     if(treeview[i].innerText !== item.nome && treeview[i].innerText.includes('-')) {
      //       treeview[i].classList.remove('openedFolder');
      //     }else if(treeview[i].innerText === item.nome && treeview[i].innerText.includes('-')) {
      //       treeview[i].classList.add('openedFolder');
      //       icon[i].classList.add('openedFolderIcon')
      //     }
      //   }
      // }

      // this.handleFocus(item.idPasta);

      this.montaBreadCrumbs(item.idPasta);
      this.$store.commit('addLastExpandedFolder', { name: item.nome, id: item.idPasta, parentId: item.idPai, origin: item.origin, children: item.children });
      this.pushFiles(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item))).then(function (files) {
        _this7.fileList = files;
        _this7.$store.commit('resetFiles');
        _this7.fileItems = [];
        files.map(function (file) {
          _this7.$store.commit('addFiles', file);
          _this7.fileItems.push(file);
          _this7.currentNode = item.idPasta;
        });
      });
      return '';
    },
    handleFocus: function handleFocus(nodeName) {
      nodeName = nodeName.trim();
      var treeview = document.querySelectorAll('#treeview-id .v-treeview-node__content');
      var icon = document.querySelectorAll('#treeview-id .v-treeview-node__content i');
      var label = document.querySelectorAll('#treeview-id .v-treeview-node__content .v-treeview-node__label');

      if (treeview.length > 1) {
        for (var i = 0; i < treeview.length; i++) {
          if (treeview[i].innerText != nodeName) {
            treeview[i].classList.remove('openedFolder');
            icon[i].classList.remove('openedFolderIcon');
          } else if (treeview[i].innerText == nodeName && !treeview[i].innerText.includes('20')) {
            treeview[i].classList.add('openedFolder');
            icon[i].classList.add('openedFolderIcon');
          } else {
            treeview[i].classList.add('openedFolder');
            icon[i].classList.add('openedFolderIcon');
          }
        }
      }
    },
    handleCloseFolder: function handleCloseFolder(item, open) {
      var _this8 = this;

      var activeNode = {};
      if (this.bread) {
        this.bread.map(function (node) {
          if (node.id == item.idPasta) {
            activeNode = node;
            var json = _this8.formatedJson;
            var parent = json[0][0].find(function (pasta) {
              return pasta.idPasta === item.idPai;
            });
            if (parent) {

              _this8.$store.commit('addLastExpandedFolder', { name: parent.nome, id: parent.idPasta, parentId: parent.idPai, origin: parent.origin, children: parent.children });
              _this8.fileList = [];
              _this8.$store.commit('resetFiles');
              _this8.fileItems = [];
            }
          }
        });
      }

      this.montaArvoreSelecionada(activeNode.id).then(function (folderList) {
        var auxList = [];
        if (folderList.length) {
          folderList.length = folderList.length - 1;

          folderList.map(function (item) {
            auxList.push({ text: item.nome, id: item.idPasta, parentId: item.idPai ? item.idPai : "root" });
          });
          _this8.bread = auxList;
          return '';
        } else {
          return '';
        }
      });

      return '';
    },
    montaBreadCrumbs: function montaBreadCrumbs(idPasta) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var auxList, folderList;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                auxList = [];
                _context5.next = 3;
                return _this9.montaArvoreSelecionada(idPasta);

              case 3:
                folderList = _context5.sent;


                folderList.map(function (item) {
                  auxList.push({ text: item.nome, id: item.idPasta, parentId: item.idPai ? item.idPai : "root" });
                });

                _this9.bread = auxList;

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    montaArvoreSelecionada: function montaArvoreSelecionada(idPasta) {
      var _this10 = this;

      var expand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var buscaPai, idBusca, estruturaPastas, json, pastaAtual;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                buscaPai = false;
                idBusca = idPasta;
                estruturaPastas = [];
                json = _this10.formatedJson;

                if (idBusca != undefined) {
                  while (!buscaPai) {
                    pastaAtual = json[0][0].find(function (pasta) {
                      return pasta.idPasta == idBusca;
                    });


                    if (pastaAtual) {
                      estruturaPastas.push(pastaAtual);
                      idBusca = pastaAtual.idPai;
                      buscaPai = !pastaAtual.idPai;
                    } else {
                      buscaPai = true;
                    }
                  }
                }
                return _context6.abrupt('return', estruturaPastas.reverse());

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10);
      }))();
    }
  },
  components: {
    TreeBrowser: __WEBPACK_IMPORTED_MODULE_3__TreeBrowser_TreeBrowser__["a" /* default */],
    UploadFile: __WEBPACK_IMPORTED_MODULE_7__components_shared_uploadFile_UploadFile__["a" /* default */]
  },
  computed: {
    files: function files() {
      return this.$store.getters.files;
    },
    lastExpandedFolder: function lastExpandedFolder() {
      return this.$store.state.lastExpandedFolder;
    },
    breadcrumbs: function breadcrumbs() {
      return this.$store.state.breadcrumbs;
    },
    paginationNumber: function paginationNumber() {
      var files = this.fileList.length;
      var rows = this.pagination.rowsPerPage;

      if (files <= 10) {
        return 1;
      } else if (files >= rows) {
        return Math.ceil(files / rows, 1);
      } else {
        return Math.ceil(rows / files, 1);
      }
    },
    quantity: function quantity() {
      return this.fileItems.length;
    },
    mongoFolderReturn: function mongoFolderReturn() {
      return this.$store.state.mongoFolderReturn;
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_documentos_Documentos__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__guestArea_login_Login_vue__ = __webpack_require__(256);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TreeBrowser',
  props: {
    node: Object,
    depth: {
      type: Number,
      default: 0
    },
    root: Array,
    selected: Array,
    open: Array
  },
  data: function data() {
    return {
      // expanded: false,
      expandedFolder: '',
      globalArea: true,
      dialogRenomearArquivo: false,
      renameType: '',
      editedItem: {
        name: '',
        createdBy: '',
        dateUpdate: ''
      }
    };
  },

  methods: {
    updateBreadcrumbsNode: function updateBreadcrumbsNode(node) {
      this.$store.commit('addLastExpandedFolder', { name: node.nome, id: node.idPasta, parentId: node.idPai, origin: node.origin });
      node.expanded = true;
      var position = this.breadcrumbs.map(function (e) {
        return e.id;
      }).indexOf(this.lastExpandedFolder.id);

      if (this.breadcrumbs.length !== position + 1) {
        this.$store.commit('updateBreadcrumbs', position);
        this.handleCloseFolders(node);
      }
    },
    selectFolder: function selectFolder() {
      this.node.expanded = false;
      var folderName = this.node.nome;
      if (folderName) {
        this.editedItem.name = folderName.replace(/['"]+/g, '');
        // this.editedIndex = JSON.stringify(this.lastExpandedFolder.id).replace(/['"]+/g, '');
        // this.renameType = 'diretorio';
        this.dialogRenomearArquivo = true;
      }
    },
    renameFolder: function renameFolder() {
      if (this.node.nome) {
        this.node.nome = this.editedItem.name;
      }

      this.dialogRenomearArquivo = false;
    },
    nodeClicked: function nodeClicked() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newFileList, position;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.node.idPasta !== _this.lastExpandedFolder.id || !_this.node.expanded || _this.node.root)) {
                  _context.next = 27;
                  break;
                }

                _this.node.expanded = !_this.node.expanded;

                _this.handleParentFolder(_this.node);

                if (_this.hasChildren) {
                  _context.next = 7;
                  break;
                }

                _this.$emit('onClick', _this.node);
                _context.next = 25;
                break;

              case 7:
                if (!_this.expanded) {
                  _context.next = 19;
                  break;
                }

                // this.handleBreadcrumbsPositions(this.node, true);
                _this.$store.commit('resetBreadcrumbs');
                _this.montaBreadCrumbs(_this.node.idPasta);

                _this.$store.commit('addLastExpandedFolder', { name: _this.node.nome, id: _this.node.idPasta, parentId: _this.node.idPai, origin: _this.node.origin });
                _this.expandedFolder = _this.node.nome;
                _context.next = 14;
                return _this.getFiles(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.node.children)));

              case 14:
                newFileList = _context.sent;


                if (_this.files !== newFileList && _this.newFileList !== {}) {
                  _this.$store.commit('resetFiles');
                }
                _this.$store.commit('addFiles', newFileList);

                _context.next = 25;
                break;

              case 19:
                if (_this.node.nome === _this.lastExpandedFolder.name || _this.node.root && _this.lastExpandedFolder.name !== '') {
                  // this.handleBreadcrumbsPositions(this.node, false);
                  if (_this.node.root) {
                    _this.$store.commit('addLastExpandedFolder', { name: '', id: '', parentId: '', origin: '' });
                    // this.handleRootFolder(this.node);
                    // this.handleCloseFolders(this.node);
                  }
                  // else {
                  // this.handleCloseFoldersNotRoot(this.node);
                  // }
                } else {
                  if (!_this.node.root) {
                    _this.$store.commit('addLastExpandedFolder', { name: _this.node.nome, id: _this.node.idPasta, parentId: _this.node.idPai, origin: _this.node.origin });
                  }
                }
                // this.handleCloseFoldersNotRoot(this.node);
                _this.handleCloseFolders(_this.node);
                position = _this.breadcrumbs.map(function (e) {
                  return e.id;
                }).indexOf(_this.lastExpandedFolder.id);

                if (_this.breadcrumbs.length !== position + 1) {
                  _this.$store.commit('updateBreadcrumbs', position);
                }
                _this.$store.commit('resetFiles');
                _this.$store.commit('addFiles', []);

              case 25:
                _context.next = 28;
                break;

              case 27:
                _this.$store.commit('addLastExpandedFolder', { name: _this.node.nome, id: _this.node.idPasta, parentId: _this.node.idPai, origin: _this.node.origin });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleParentFolder: function handleParentFolder(clickedNode) {
      var _this2 = this;

      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (clickedNode.idPai) {
        this.root.map(function (node) {
          var obj = node;

          if (children) {
            obj = children;
          }

          if (obj.idPasta === clickedNode.idPasta) {
            _this2.$store.commit('addLastExpandedFolder', { name: obj.nome, id: obj.idPasta, parentId: obj.idPai, origin: obj.origin });
            _this2.handleCloseFolders(obj);
            obj.expanded = true;
          }

          if (obj.idPai === clickedNode.idPai && obj.idPasta !== clickedNode.idPasta) {
            obj.expanded = false;
            return true;
          }
          if (obj.children) {
            obj.children.map(function (child) {
              _this2.handleParentFolder(clickedNode, child);
            });
          }

          return false;
        });
      } else {
        return;
      }
    },

    // handleRootFolder(clickedNode, children=null, firstLoop=true) {


    //     this.root.map(node => {
    //       console.log('1');
    //       let obj = node;

    //       if(children) {
    //         obj = children;
    //       }

    //       if(firstLoop) {
    //         if(obj.idPasta === clickedNode.idPasta) {
    //           obj.expanded = false;
    //           if(obj.children) {
    //             obj.children.map(child => {
    //               this.handleRootFolder(clickedNode, child, false);
    //             });
    //           }  
    //         }
    //       }else {
    //         obj.expanded = false;
    //           if(obj.children) {
    //             obj.children.map(child => {
    //               this.handleRootFolder(clickedNode, child, false);
    //             });
    //           }
    //       }

    //       return false;

    //     });

    // },
    // handleBreadcrumbsPositions( node, expanded ) {
    //   if(expanded){
    //     if(node.root) {
    //         this.$store.commit('resetBreadcrumbs');
    //         this.$store.commit('addBreadcrumbs', { text: node.nome, id: node.idPasta, parentId: 'root' });
    //         this.root.map(root => {
    //           if(root.idPasta !== node.idPasta) {
    //             root.expanded = false;
    //             this.handleRootFolder(root);
    //             return;
    //           }
    //         });
    //       }else {
    //         let findNode = true;
    //         while(findNode) {
    //           const lastPosition = this.breadcrumbs[this.breadcrumbs.length -1];
    //           if(lastPosition && node.idPai === lastPosition.id){
    //             this.$store.commit('addBreadcrumbs', { text: node.nome, id: node.idPasta, parentId: node.isPai });
    //             findNode = false;
    //           }else {
    //             this.$store.commit('removeBreadcrumbsLastPosition');
    //           }
    //         }
    //       }
    //   }else {
    //     if(node.root) {
    //       this.$store.commit('resetBreadcrumbs');
    //     }else {
    //       let findNode = true;
    //         while(findNode) {
    //           const lastPosition = this.breadcrumbs[this.breadcrumbs.length -1];

    //           if(node.idPasta === lastPosition.id){
    //             // this.$store.commit('addBreadcrumbs', { text: node.name, id: node._id, parentId: node.parent_id });
    //             findNode = false;
    //           }else {
    //             this.$store.commit('removeBreadcrumbsLastPosition');
    //             // this.$store.commit('addBreadcrumbs', { text: node.name, id: node._id, parentId: node.parent_id });
    //           }
    //     }
    //   }
    //   }
    // },
    handleCloseFolders: function handleCloseFolders(activeNode) {
      var _this3 = this;

      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      activeNode.children.map(function (node) {
        var obj = node;

        if (children) {
          obj = children;
        }

        obj.expanded = false;
        if (obj.children) {
          obj.children.map(function (child) {
            _this3.handleCloseFolders(activeNode, child);
          });
        }
      });
    },

    // handleCloseFoldersNotRoot(activeNode, children=null) {
    //   activeNode.children.map(node => {
    //     let obj = node;

    //       if(children) {
    //         obj = children;
    //       }

    //       obj.expanded = false;
    //       if(obj.children) {
    //         obj.children.map(child => {
    //           this.handleRootFolder(activeNode, child);
    //         });
    //       }  


    //   });
    // },
    getFiles: function getFiles(nodes) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var docs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                docs = [];


                nodes.map(function (child) {
                  if (child.arquivos) {
                    child.arquivos.map(function (file) {
                      return docs.push(file);
                    });
                  } else {
                    return;
                  }
                });
                return _context2.abrupt('return', docs);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    montaBreadCrumbs: function montaBreadCrumbs(idPasta) {
      var _this5 = this;

      return this.montaArvoreSelecionada(idPasta).map(function (pasta) {
        _this5.$store.commit('addBreadcrumbs', { text: pasta.nome, id: pasta.idPasta, parentId: pasta.idPai ? pasta.idPai : "root" });
      });
    },
    montaArvoreSelecionada: function montaArvoreSelecionada(idPasta) {
      var expand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var buscaPai = false;
      var idBusca = idPasta;
      var estruturaPastas = [];
      while (!buscaPai) {
        var json = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.mongoFolderReturn));
        var pastaAtual = json[0].situacao_fiscal.find(function (pasta) {
          return pasta.idPasta === idBusca;
        });
        estruturaPastas.push(pastaAtual);
        idBusca = pastaAtual.idPai;
        buscaPai = !pastaAtual.idPai;
      }
      return estruturaPastas.reverse();
    }
  },
  updated: function updated() {
    this.$nextTick(function () {});
  },

  computed: {
    hasChildren: function hasChildren() {
      return this.node.children;
    },
    files: function files() {
      this.$emit("resetCheckedOptions", this.node);
      return this.$store.state.files;
    },
    lastExpandedFolder: function lastExpandedFolder() {
      return this.$store.state.lastExpandedFolder;
    },
    expanded: function expanded() {
      return this.node.expanded;
    },
    breadcrumbs: function breadcrumbs() {
      return this.$store.state.breadcrumbs;
    },
    mongoFolderReturn: function mongoFolderReturn() {
      return this.$store.state.mongoFolderReturn;
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);











var DocumentosService = function (_CommonService) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(DocumentosService, _CommonService);

  function DocumentosService() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, DocumentosService);

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumentosService.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(DocumentosService)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(DocumentosService, [{
    key: 'getDbData',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var mock;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.mockJson();

              case 2:
                mock = _context.sent;
                return _context.abrupt('return', mock);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDbData() {
        return _ref.apply(this, arguments);
      }

      return getDbData;
    }()
  }, {
    key: 'getDocsFederal',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(imoveis) {
        var response, newArray;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                response = imoveis;
                newArray = [];

                response.items.map(function (item) {
                  var name = item.descricao ? '_' + item.descricao : '';

                  if (newArray.length == 0 || !newArray.find(function (node) {
                    return node.idPasta == item.uf + '-' + item.municipio;
                  })) {
                    newArray.push({
                      nome: item.uf + '-' + item.municipio,
                      idPasta: item.uf + '-' + item.municipio
                    });
                  }

                  if (!newArray.find(function (node) {
                    return node.idPasta == item.inscricaoImovel + ' ' + name;
                  })) {
                    newArray.push({
                      nome: item.inscricaoImovel + ' ' + name,
                      idPai: item.uf + '-' + item.municipio,
                      idPasta: item.inscricaoImovel + ' ' + name
                    });
                  }

                  if (item.iptu.length > 0) {
                    item.iptu.map(function (iptu) {
                      if (!newArray.find(function (node) {
                        return node.idPasta == iptu.ano + '-' + item.inscricaoImovel;
                      })) {
                        newArray.push({
                          nome: iptu.ano,
                          idPai: item.inscricaoImovel + ' ' + name,
                          idPasta: iptu.ano + '-' + item.inscricaoImovel,
                          arquivos: [{
                            nome: iptu.nomeArq,
                            idDocumento: iptu._id,
                            path: iptu.path,
                            idImovel: item._id,
                            dataIni: new Date(iptu.createdAt).toLocaleString('pt-BR'),
                            dataMod: new Date(iptu.updatedAt).toLocaleString('pt-BR')
                          }]
                        });
                      } else {
                        var fileArray = newArray.find(function (node) {
                          return node.idPasta == iptu.ano + '-' + item.inscricaoImovel;
                        });
                        fileArray.arquivos.push({
                          nome: iptu.nomeArq,
                          idDocumento: iptu._id,
                          path: iptu.path,
                          idImovel: item._id,
                          dataIni: new Date(iptu.createdAt).toLocaleString('pt-BR'),
                          dataMod: new Date(iptu.updatedAt).toLocaleString('pt-BR')
                        });
                      }
                    });
                  }
                });

                return _context2.abrupt('return', newArray);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getDocsFederal(_x) {
        return _ref2.apply(this, arguments);
      }

      return getDocsFederal;
    }()
  }, {
    key: 'getIptu',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(idImovel, idIptu) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this._resource.get('imoveis/' + idImovel + '/pdf/' + idIptu).then(function (success) {
                  var data = new Uint8Array(success.body.pdf.data);
                  return _this2.bufferToBase64(data);
                }, function (failed) {
                  return _this2.bufferToBase64('');
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getIptu(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return getIptu;
    }()
  }, {
    key: 'convertJson',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(array) {
        var copyDadosEmpresa, treeDados, i, pai;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                copyDadosEmpresa = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(array));
                treeDados = copyDadosEmpresa.filter(function (pasta) {
                  return !pasta.idPai;
                }).map(function (pasta) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, pasta, {
                    children: [],
                    root: true,
                    expanded: false
                  });
                });


                copyDadosEmpresa = copyDadosEmpresa.filter(function (pasta) {
                  return !treeDados.some(function (tPasta) {
                    return tPasta.idPasta === pasta.idPasta;
                  });
                });

                for (i = 0; i < treeDados.length; i++) {
                  pai = treeDados[i];

                  pai.children = this.buscaFilhos(pai.idPasta, copyDadosEmpresa);
                }

                return _context4.abrupt('return', treeDados);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function convertJson(_x4) {
        return _ref4.apply(this, arguments);
      }

      return convertJson;
    }()
  }, {
    key: 'buscaFilhos',
    value: function buscaFilhos(idPai, array) {
      var expanded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var filhos = array.filter(function (filho) {
        return filho.idPai === idPai;
      }).map(function (filho) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filho, {
          children: [],
          expanded: expanded
        });
      });
      array = array.filter(function (pasta) {
        return !filhos.some(function (tPasta) {
          return tPasta.idPasta === pasta.idPasta;
        });
      });

      for (var i = 0; i < filhos.length; i++) {
        var filho = filhos[i];
        filho.children = this.buscaFilhos(filho.idPasta, array);
      }
      return filhos;
    }
  }, {
    key: 'mockJson',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', {
                  empresa: "123412345",
                  situacao_fiscal: [{
                    idPasta: "12345633",
                    nome: "2020",
                    origin: true
                  }, {
                    idPasta: "123456",
                    idPai: "12345633",
                    nome: "São Paulo",
                    origin: true
                  }, {
                    idPasta: "16121324123412355345",
                    idPai: "123456",
                    nome: "NOME1 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaaaa",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "16122423411134345",
                    idPai: "123456",
                    nome: "NOME2 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaaaa",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "161212341234345",
                    idPai: "123456",
                    nome: "NOME3 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaaaa",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "16123423214342345",
                    idPai: "123456",
                    nome: "NOME4 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaaaa",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "16124342355342345",
                    idPai: "123456",
                    nome: "NOME5 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaaaa",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "16123421123122345",
                    idPai: "123456",
                    nome: "NOME6 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaaaa",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "1612342342342432342342345",
                    idPai: "123456",
                    nome: "NOME7 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaaa2242a",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "2342342211",
                    idPai: "123456",
                    nome: "NOME8 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaa234234aa",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "123234234",
                    idPai: "123456",
                    nome: "NOME9 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aa23424aaa",
                      origem: "robo"
                    }, {
                      nome: "teste3.pdf",
                      idDocumento: "123asdfsd3412",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "1612567",
                    idPai: "123456",
                    nome: "NOME10 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste3.pdf",
                      idDocumento: "123afsd3412asda",
                      origem: "robo"
                    }, {
                      nome: "teste4.pdf",
                      idDocumento: "123asdfsd3412asd",
                      origem: "robo"
                    }]
                  }, {
                    idPasta: "161211234556363345",
                    idPai: "123456",
                    nome: "NOME11 - CNPJ",
                    origin: true,
                    arquivos: [{
                      nome: "teste",
                      idDocumento: "123afsd3412aaaaa",
                      origem: "robo"
                    }]
                  }]
                });

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function mockJson() {
        return _ref5.apply(this, arguments);
      }

      return mockJson;
    }()
  }]);

  return DocumentosService;
}(__WEBPACK_IMPORTED_MODULE_9__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DocumentosService);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171961c1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(764);
function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-171961c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171961c1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_gravatar_GravatarService_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_conta_ContaService_js__ = __webpack_require__(48);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["alert"],
  components: {},
  data: function data() {
    return {
      valid: false,
      forgotMenu: false,
      conta: { email: "", password: "" },
      forgotForm: "",
      forgotEmail: { email: "" },
      message: "",
      openDialog: false,
      showPass: false,
      emailRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        return (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) || "Digite um e-mail válido"
        );
      }],
      passRules: [function (v) {
        return !!v || "Campo obrigatório";
      }],
      images: ['/static/img/bg1.jpg', '/static/img/bg2.jpg', '/static/img/bg3.jpg', '/static/img/bg4.jpg', '/static/img/bg5.jpg', '/static/img/bg6.jpg', '/static/img/bg7.jpg']
    };
  },
  mounted: function mounted() {
    this.changeBackgroundImage();
  },

  methods: {
    changeBackgroundImage: function changeBackgroundImage() {
      document.querySelector('#content_login').style.backgroundImage = 'url(' + this.images[Math.floor(Math.random() * this.images.length)] + ')';
    },

    logar: function logar() {
      var _this = this;

      var body = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.conta);
      this.$http.post("usuarios/authenticate", body).then(function (success) {
        _this.passRules = [];
        if (success.body.bloqueado) {
          _this.openDialog = true;
        } else {
          _this.redirectUser(success);
        }
      }, function (failed) {
        _this.message = "";
        _this.alert.snackDanger();
        if (failed.status == 403) {
          _this.alert.snack.text = "Credenciais inválidas";
        } else {
          _this.alert.snack.text = "Algo não deu certo";
        }
        _this.alert.snack.show = true;
      });
    },
    redirectUser: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(success) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$session.start();
                this.conta = success.body;
                this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_gravatar_GravatarService_js__["a" /* default */](this.$http);
                _context.next = 5;
                return this.service.getGravatar(success.body.email).then(function (success) {
                  if (success) {
                    if (success.hasOwnProperty("thumbnailUrl")) {
                      _this2.conta["gravatarProfile"] = success;
                    }
                  }
                }).then(function (x) {
                  _this2.$session.set("jwt", _this2.conta);
                  _this2.$router.push("/DashBoard");
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function redirectUser(_x) {
        return _ref.apply(this, arguments);
      }

      return redirectUser;
    }(),
    recover: function recover() {
      var _this3 = this;

      if (this.$refs.form.validate()) {
        this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_ContaService_js__["a" /* default */](this.$http);
        this.service.recoverPassword(this.forgotEmail).then(function (success) {
          _this3.alert.snackDanger();
          _this3.alert.snack.text = success.body.message;
          if (success.ok) {
            _this3.alert.snackSuccess();
            _this3.resetRecover();
          }
          _this3.alert.snack.time = 5000;
          _this3.alert.snack.show = true;
        }, function (failed) {
          _this3.alert.snackDanger();
          _this3.alert.snack.text = "Ocorreu algum erro ao recuperar a senha, por favor entre em contato" || success.body.message;
          _this3.alert.snack.show = true;
        });
      }
    },
    resetRecover: function resetRecover() {
      this.forgotEmail.email = "";
      this.forgotMenu = false;
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/÷cone Negativo.c852ef6.png";

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["component"],
    data: function data() {
        return {
            dialog: false,
            fileText: "Nenhum arquivo selecionado",
            path: "",
            file: {}
        };
    },

    computed: {
        files: function files() {
            return this.$store.getters.files;
        }
    },
    methods: {
        resetInfos: function resetInfos() {
            var file = document.querySelector("#file-upload");
            file.value = "";

            this.path = "";
            this.fileText = "Nenhum arquivo selecionado";
            this.dialog = true;
        },

        setFile: function setFile(e) {
            console.log(e.target);
            this.path = "";
            if (e.target.type == "file") {
                if (e.target.files.length > 0) {
                    console.log(e);
                    this.fileText = "Arquivo selecionado: ";
                    this.path = e.target.files[0].name;
                    console.log((e.target.files[0].size / 1000).toFixed(1));
                    console.log(this.convertDate());
                    console.log(this.convertDate(e.target.files[0].lastModifiedDate));
                    this.file = {
                        idDocumento: "111111111111111111",
                        nome: e.target.files[0].name,
                        origem: "robo"
                        // tamanho: (e.target.files[0].size / 1000).toFixed(1),
                        // dataIni: this.convertDate(),
                        // dataMod: this.convertDate(e.target.files[0].lastModifiedDate),
                    };
                } else {
                    this.fileText = "Nenhum arquivo selecionado";
                }
            } else {
                return;
            }
        },
        handleUpload: function handleUpload() {
            // console.log(this.file);
            this.$store.commit('addFiles', this.file);
            // console.log('UPLOAD')
            // console.log(this.files);
            this.dialog = false;
            this.$emit('updateFileList', false);
            // await toBase64(this.file);
        },
        convertDate: function convertDate() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var convert1 = void 0;

            if (date) {
                convert1 = new Date(date);
            } else {
                convert1 = new Date();
            }

            var convert2 = convert1.toLocaleDateString();

            var _convert2$split = convert2.split("/"),
                _convert2$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_convert2$split, 3),
                month = _convert2$split2[0],
                day = _convert2$split2[1],
                year = _convert2$split2[2];

            if (day.length == 1) {
                day = '0' + day;
            }
            var finalDate = day + '/' + month + '/' + year;
            return finalDate;
        }
    }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapBrasil_MapBrasil_vue__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__charts_chartPie_ChartPie_vue__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__charts_chartBar_ChatBar_vue__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_dashboard_DashBoardService__ = __webpack_require__(783);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pieChart: __WEBPACK_IMPORTED_MODULE_5__charts_chartPie_ChartPie_vue__["a" /* default */],
    mapBrasil: __WEBPACK_IMPORTED_MODULE_4__mapBrasil_MapBrasil_vue__["a" /* default */],
    barChart: __WEBPACK_IMPORTED_MODULE_6__charts_chartBar_ChatBar_vue__["a" /* default */]
  },
  props: ["conta", "empresa", "IBGE", "alert"],
  data: function data() {
    return {
      month: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      rangeButtons: [{
        text: "7 Dias",
        value: "semana",
        width: "500px",
        noDataText: "nos últimos 7 Dias",
        selected: false,
        show: true
      }, {
        text: "Mês Atual",
        value: "mesAtual",
        selected: true,
        noDataText: "neste Mês",
        show: true,
        width: "500px"
      }, {
        text: "Mês anterior",
        selected: false,
        noDataText: "no Mês passado",
        value: "mesAnterior",
        show: true
      }],
      primLoadDash: true,
      colors: ["yellow", "cyan", "blue", "green", "red"],
      pieEntradaLabels: [],
      colorsEntrada: [],
      pieEntrada: [],
      pieSaidaLabels: [],
      pieSaida: [],
      colorsSaida: [],
      consultando: true,
      bar1Data: [{
        label: "Total de NF-e entrada",
        data: [],
        backgroundColor: "rgba(255, 0, 0, 0.2)",
        borderColor: "rgba(255, 0, 0, 1)",
        borderWidth: 1
      }, {
        label: "Total de NF-e saída",
        data: [],
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1
      }],
      bar1Labels: [],
      cards: [{
        id: "nfe_Entrada",
        title: "NF-e entrada",
        valor: "",
        analise: "",
        cor: "c_primary",
        path: "static\\img\\file_entrada.png"
      }, {
        id: "nfe_Saida",
        title: "NF-e saída",
        valor: "",
        analise: "",
        cor: "c_teal",
        path: "static\\img\\file-saida.png"
      }, {
        id: "nfe_Entrada_canc",
        title: "NF-e entrada canceladas",
        valor: " ",
        analise: "",
        cor: "c_little-grey",
        path: "static\\img\\file-cancel.png"
      }, {
        id: "nfe_Saida_canc",
        title: "NF-e saída canceladas",
        valor: " ",
        analise: "",
        cor: "c_black",
        path: "static\\img\\file-cancel-saida.png"
      }],
      changingEmp: false,
      activeProgress: false,
      range: "mesAtual"
    };
  },
  computed: {
    // dashboard() {
    //   return this.$store.state.dashboard;
    // },
  },
  watch: {
    empresa: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(newV, oldV) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(oldV != undefined && oldV.hasOwnProperty("_id") || newV != oldV)) {
                  _context.next = 7;
                  break;
                }

                if (!(newV && oldV && newV._id != oldV._id || newV && !oldV)) {
                  _context.next = 7;
                  break;
                }

                this.changingEmp = true;
                this.primLoadDash = true;
                _context.next = 6;
                return this.getDadosDashBoard(this.range);

              case 6:
                this.changingEmp = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function empresa(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return empresa;
    }(),
    range: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(newV, oldV) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!newV) {
                  _context2.next = 6;
                  break;
                }

                this.changeSelected(newV);
                this.changingEmp = true;
                _context2.next = 5;
                return this.getDadosDashBoard(this.range);

              case 5:
                this.changingEmp = false;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function range(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return range;
    }(),
    $route: {
      deep: true,
      handler: function handler(refreshPage) {}
    }
  },
  methods: {
    refresh: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.changingEmp = true;
                _context3.next = 3;
                return this.getDadosDashBoard(this.range);

              case 3:
                this.changingEmp = false;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refresh() {
        return _ref3.apply(this, arguments);
      }

      return refresh;
    }(),
    activeLoader: function activeLoader() {
      this.activeProgress = true;
      var appDom = document.querySelectorAll(".c_before");
      if (appDom && appDom.length > 0) {
        appDom.forEach(function (item) {
          item.classList.add("loading");
        });
      }
    },
    desactiveLoader: function desactiveLoader() {
      this.activeProgress = false;
      var appDom = document.querySelectorAll(".loading");
      if (appDom && appDom.length > 0) {
        appDom.forEach(function (item) {
          item.classList.remove("loading");
        });
      }
    },
    logout: function logout() {
      this.$session.destroy();
      this.$router.push("/");
    },
    animateValue: function animateValue(id, start, end, duration, speed) {
      var range = end - start;
      var current = start;
      var increment = end > start ? speed : 5;
      var stepTime = Math.abs(Math.floor(duration / range));
      var obj = document.getElementById(id);
      var timer = setInterval(function () {
        current += increment;
        obj.innerHTML = current;
        if (current == end || current >= end) {
          clearInterval(timer);
        }
      }, stepTime);
    },

    resetInfos: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.colorsEntrada = [];
                this.pieEntradaLabels = [];
                this.pieEntrada = [];
                this.pieSaidaLabels = [];
                this.pieSaida = [];
                this.colorsSaida = [];
                this.bar1Data = [{
                  label: "Total de NF-e entrada",
                  data: [],
                  backgroundColor: "rgba(255, 0, 0, 0.2)",
                  borderColor: "rgba(255, 0, 0, 1)",
                  borderWidth: 1
                }, {
                  label: "Total de NF-e saída",
                  data: [],
                  backgroundColor: "rgba(54, 162, 235, 0.2)",
                  borderColor: "rgba(54, 162, 235, 1)",
                  borderWidth: 1
                }];
                // this.bar1Labels = [];
                this.cards = [{
                  id: "nfe_Entrada",
                  title: "NF-e entrada",
                  valor: "R$ 0,00",
                  analise: "",
                  cor: "c_primary",
                  path: "static\\img\\file_entrada.png"
                }, {
                  id: "nfe_Saida",
                  title: "NF-e saída",
                  valor: "R$ 0,00",
                  analise: "",
                  cor: "c_teal",
                  path: "static\\img\\file-saida.png"
                }, {
                  id: "nfe_Entrada_canc",
                  title: "NF-e entrada canceladas",
                  valor: " ",
                  analise: "",
                  cor: "c_little-grey",
                  path: "static\\img\\file-cancel.png"
                }, {
                  id: "nfe_Saida_canc",
                  title: "NF-e saída canceladas",
                  valor: " ",
                  analise: "",
                  cor: "c_black",
                  path: "static\\img\\file-cancel-saida.png"
                }];

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function resetInfos() {
        return _ref4.apply(this, arguments);
      }

      return resetInfos;
    }(),
    getDadosDashBoard: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(range) {
        var _this = this;

        var i, tipo, dados;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.empresa) {
                  this.resetInfos();
                  this.service = new __WEBPACK_IMPORTED_MODULE_7__domain_dashboard_DashBoardService__["a" /* default */](this.$http);
                  this.activeLoader();
                  i = 0;
                  tipo = "Entrada";
                  dados = {
                    qntdNfeCancSaida: 0,
                    qntdNfeCancEntrada: 0,
                    vlrNfeSaida: 0,
                    vlrNfeEntrada: 0,
                    top5NfeSaidaRegiao: [],
                    top5NfeEntradaRegiao: [],
                    periodoNfeSaida: [],
                    periodoNfeEntrada: []
                  };

                  this.consultando = true;
                  new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                    var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(resolve, reject) {
                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.next = 2;
                              return _this.service.qntNfeEmpresa(_this.empresa._id, range).then(function () {
                                var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(qntdNFe) {
                                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                                    while (1) {
                                      switch (_context5.prev = _context5.next) {
                                        case 0:
                                          if (!qntdNFe.ok) {
                                            _context5.next = 22;
                                            break;
                                          }

                                          if (!(qntdNFe.body.qntd >= 0)) {
                                            _context5.next = 19;
                                            break;
                                          }

                                        case 2:
                                          if (!(i < 2)) {
                                            _context5.next = 17;
                                            break;
                                          }

                                          _context5.next = 5;
                                          return _this.service.buscaQntdCancelada(_this.empresa.cnpj, tipo, range).then(function (resp) {
                                            if (resp.ok) {
                                              if (resp.body) dados["qntdNfeCanc" + tipo] = resp.body.qntd;
                                            }
                                          });

                                        case 5:
                                          _context5.next = 7;
                                          return _this.service.buscaVlrTotal(_this.empresa.cnpj, tipo, range).then(function (resp) {
                                            if (resp.ok) {
                                              if (resp.body) dados["vlrNfe" + tipo] = resp.body.total;
                                            }
                                          });

                                        case 7:

                                          _this.setCard(dados["vlrNfe" + tipo], parseInt(dados["qntdNfeCanc" + tipo]), tipo);
                                          _context5.next = 10;
                                          return _this.service.buscaTop5(_this.empresa.cnpj, tipo, range).then(function (resp) {
                                            if (resp.ok) {
                                              if (resp.body) dados["top5Nfe" + tipo + "Regiao"] = resp.body.slice();
                                              _this.setPieChart(dados["top5Nfe" + tipo + "Regiao"], tipo);
                                            }
                                          });

                                        case 10:
                                          _context5.next = 12;
                                          return _this.service.buscaPeriodo(_this.empresa.cnpj, tipo, "ano").then(function (resp) {
                                            if (resp.ok) {
                                              if (resp.body) dados["periodoNfe" + tipo] = resp.body.slice();
                                            }
                                          }).then(function () {
                                            if (i == 1) {
                                              _this.setBarChart(dados.periodoNfeEntrada, dados.periodoNfeSaida);
                                            }
                                          });

                                        case 12:
                                          tipo = "Saida";
                                          i++;
                                          if (i == 2) {
                                            resolve(true);
                                          }
                                          _context5.next = 2;
                                          break;

                                        case 17:
                                          _context5.next = 20;
                                          break;

                                        case 19:
                                          resolve(false);

                                        case 20:
                                          _context5.next = 23;
                                          break;

                                        case 22:
                                          resolve(false);

                                        case 23:
                                        case "end":
                                          return _context5.stop();
                                      }
                                    }
                                  }, _callee5, _this);
                                }));

                                return function (_x8) {
                                  return _ref7.apply(this, arguments);
                                };
                              }());

                            case 2:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6, _this);
                    }));

                    return function (_x6, _x7) {
                      return _ref6.apply(this, arguments);
                    };
                  }()).then(function (temNota) {
                    _this.desactiveLoader();
                    if (!temNota) {
                      var _tipo = "Saida";
                      _this.setCard(dados["vlrNfe" + _tipo], parseInt(dados["qntdNfeCanc" + _tipo]), _tipo);
                      _this.setPieChart(dados["top5Nfe" + _tipo + "Regiao"], _tipo);
                      _tipo = "Entrada";
                      _this.setCard(dados["vlrNfe" + _tipo], parseInt(dados["qntdNfeCanc" + _tipo]), _tipo);
                      _this.setPieChart(dados["top5Nfe" + _tipo + "Regiao"], _tipo);
                      _this.setBarChart(dados.periodoNfeEntrada, dados.periodoNfeSaida);
                    }
                    return temNota;
                  }).then(function (temNota) {
                    if (_this.$router.history.current.path == "/DashBoard" && _this.range == "mesAtual" && _this.primLoadDash == true && !temNota) {
                      _this.alert.snack.text = "Ausência de dados neste mês.\n Para uma nova busca altere o filtro.";
                      _this.alert.snack.show = true;
                      _this.alert.snack.time = 5000;
                      var auxThis = _this;
                      // setTimeout(() => {
                      //   auxThis.range = "tudo";
                      // }, 5000);
                    }
                  }).then(function () {
                    setTimeout(function () {
                      _this.consultando = false;
                    }, 800);
                    _this.primLoadDash = false;
                    // this.$store.commit('addDashboard', dados);
                  });
                }

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getDadosDashBoard(_x5) {
        return _ref5.apply(this, arguments);
      }

      return getDadosDashBoard;
    }(),
    setBarChart: function setBarChart(arrayEntrada, arraySaida) {
      var _this2 = this;

      new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(resolve, reject) {
          var arrayMerged;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  arrayMerged = [];
                  _context8.next = 3;
                  return arrayEntrada.concat(arraySaida).slice();

                case 3:
                  arrayMerged = _context8.sent;
                  _context8.next = 6;
                  return arrayMerged.sort(function (a, b) {
                    return a.emissao < b.emissao ? -1 : 1;
                  });

                case 6:
                  resolve(arrayMerged);

                case 7:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, _this2);
        }));

        return function (_x9, _x10) {
          return _ref8.apply(this, arguments);
        };
      }()).then(function (arrayMerged) {
        _this2.bar1Labels = [];
        _this2.bar1Data[0].data = [];
        _this2.bar1Data[1].data = [];
        var auxThis = _this2;
        if (arrayMerged) {
          arrayMerged.forEach(function (item, i) {
            var objProxItem = {};

            if (item.emissao) {
              ;

              var _item$emissao$split = item.emissao.split("-");

              var _item$emissao$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_item$emissao$split, 3);

              item["ano"] = _item$emissao$split2[0];
              item["mes"] = _item$emissao$split2[1];
              item["dia"] = _item$emissao$split2[2];
            }if (arrayMerged[i + 1] != undefined && arrayMerged[i + 1].emissao != undefined) {
              ;

              var _arrayMerged$emissao$ = arrayMerged[i + 1].emissao.split("-");

              var _arrayMerged$emissao$2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_arrayMerged$emissao$, 3);

              objProxItem["ano"] = _arrayMerged$emissao$2[0];
              objProxItem["mes"] = _arrayMerged$emissao$2[1];
              objProxItem["dia"] = _arrayMerged$emissao$2[2];
            }var dateItem = new Date("" + parseInt(item.ano), "" + (parseInt(item.mes) - 1));
            var dateProxItem = new Date("" + parseInt(objProxItem.ano), "" + parseInt(objProxItem.mes - 1));
            var textBarLabel = _this2.month[dateItem.getMonth()] + " - " + dateItem.getFullYear();

            if (auxThis.bar1Labels.indexOf(textBarLabel) == -1) {
              //se não existe a data na label adicionar ela.
              auxThis.bar1Labels.push(textBarLabel);
              switch (item.tipo) {
                case "Entrada":
                  //se o item for do tipo entrada adicionar qntd no array de Entrada.
                  auxThis.bar1Data[0].data.push(item.qntd.toString());
                  if (dateItem.toLocaleDateString() != dateProxItem.toLocaleDateString()) {
                    //verifica se o proximo item é da mesma data, caso não for adicionar 0 ao array de saída
                    auxThis.bar1Data[1].data.push("0");
                  }
                  break;
                case "Saída":
                  //se o item for do tipo Saida adicionar qntd no array de Saida.
                  auxThis.bar1Data[1].data.push(item.qntd.toString());
                  if (dateItem.toLocaleDateString() != dateProxItem.toLocaleDateString()) {
                    //verifica se o proximo item é da mesma data, caso não for adicionar 0 ao array de entrada
                    auxThis.bar1Data[0].data.push("0");
                  }
                  break;
              }
            } else {
              if (item.tipo == "Entrada") {
                auxThis.bar1Data[0].data.push(item.qntd.toString());
              } else if (item.tipo == "Saída") {
                auxThis.bar1Data[1].data.push(item.qntd.toString());
              }
            }
          });
        }
      });
    },
    setPieChart: function setPieChart(arrayAPI, tipo) {
      if (arrayAPI && arrayAPI.length >= 0) {
        this["pie" + tipo] = [];
        this["pie" + tipo + "Labels"] = [];
        var auxColors = this.colors.slice();
        this["colors" + tipo] = [];
        var auxThis = this;
        arrayAPI.forEach(function (item) {
          if (item.uf && item.uf != undefined) {
            auxThis["pie" + tipo].push(item.qntd);
            var randPos = Math.floor(Math.random() * auxColors.length);
            auxThis["colors" + tipo].push(auxColors[randPos]);
            auxColors.splice(randPos, 1);
            auxThis.IBGE.estados.forEach(function (uf) {
              if (uf.sigla.toLowerCase() == item.uf.toLowerCase()) {
                auxThis["pie" + tipo + "Labels"].push(uf.nome);
              }
            });
          }
        });
      }
      //   pieEntrada: [3000, 1200, 100, 33, 55],
      // pieSaidaLabels: ["São Paulo", "Minas Gerais", "Bahia", "Rio de janeiro"],
    },

    setCard: function setCard(vlrTotal, qntdCancelada, tipo) {
      var auxVlrTotal = vlrTotal != undefined ? vlrTotal.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
      }) : "R$ 0,00";
      var auxQntdCancelada = "" + (qntdCancelada && qntdCancelada >= 1 ? qntdCancelada + " notas" : qntdCancelada == 1 ? qntdCancelada + " nota" : qntdCancelada == 0 ? "nenhuma nota" : "");
      this.cards.find(function (o) {
        return o.id == "nfe_" + tipo ? o.valor = auxVlrTotal : "";
      });
      this.cards.find(function (o) {
        return o.id == "nfe_" + tipo + "_canc" ? o.valor = auxQntdCancelada : "";
      });
    },
    buscarComRange: function buscarComRange(periodo) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this3.range = periodo;

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this3);
      }))();
    },
    changeSelected: function changeSelected(value) {
      // this.resetSelected();
      // return;
      this.rangeButtons.forEach(function (item) {
        if (item) {
          if (item.value == value) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        }
      });
    },


    animeValues: function animeValues() {
      this.animateValue("value0", 0, document.querySelector("#value0").innerHTML, 28000, 20);

      this.animateValue("value1", 0, document.querySelector("#value1").innerHTML, 28000, 20);

      this.animateValue("value2", 0, document.querySelector("#value2").innerHTML, 28000, 20);

      this.animateValue("value3", 0, document.querySelector("#value3").innerHTML, 28000, 20);
    },
    setLabelsBar: function setLabelsBar() {
      var ini = new Date();
      var fim = new Date();
      var dataPeriodo = void 0;
      switch (this.range) {
        case "semana":
          dataPeriodo = new Date(ini.setDate(ini.getDate() - 7));
          this.bar1Labels = [];
          this.bar1Labels = this.getDiasSemana(dataPeriodo).slice();
          break;
        case "mesAtual":
          dataPeriodo = new Date();
          this.bar1Labels = [];
          this.bar1Labels = this.getDiasMes(dataPeriodo.getMonth() + 1, dataPeriodo.getFullYear()).slice();
          break;
        case "mesAnterior":
          dataPeriodo = new Date(ini.getFullYear(), ini.getMonth() - 1, 1);
          this.bar1Labels = [];
          this.bar1Labels = this.getDiasMes(dataPeriodo.getMonth() + 1, dataPeriodo.getFullYear()).slice();
          break;
        default:
          break;
      }
      // new Date(ini.setDate(ini.getDate() - 7));
    },
    getDiasSemana: function getDiasSemana(data) {
      var today = new Date();
      var days = [];
      while (data.getDate() != today.getDate() + 1) {
        days.push(data.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "2-digit"
        }));
        data.setDate(data.getDate() + 1);
      }
      return days;
    },
    getDiasMes: function getDiasMes(month, year) {
      month--;

      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push(date.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "2-digit"
        }));
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
  },
  updated: function updated() {},

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this4 = this;

      // let auxThis = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
        var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(resolve, reject) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _this4.activeLoader();

                  if (!_this4.empresa.hasOwnProperty("_id")) {
                    _context10.next = 8;
                    break;
                  }

                  _this4.changingEmp = true;
                  _context10.next = 5;
                  return _this4.getDadosDashBoard(_this4.range);

                case 5:
                  _this4.changingEmp = false;
                  _context10.next = 9;
                  break;

                case 8:
                  _this4.desactiveLoader();

                case 9:
                  return _context10.abrupt("return", resolve());

                case 10:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, _this4);
        }));

        return function (_x11, _x12) {
          return _ref9.apply(this, arguments);
        };
      }()).catch(function (err) {
        return console.log(err);
      });
    });
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  beforeCreate: function beforeCreate() {},
  methods: {
    logout: function logout() {
      this.$session.destroy();
      this.$router.push("/");
    },
    animateValue: function animateValue(id, start, end, duration, speed) {
      var range = end - start;
      var current = start;
      var increment = end > start ? speed : 10;
      var stepTime = Math.abs(Math.floor(duration / range));
      var obj = document.getElementById(id);
      var timer = setInterval(function () {
        current += increment;
        obj.innerHTML = current;
        if (current == end || current >= end) {
          clearInterval(timer);
          // document.querySelector("#" + id).innerHTML = end;
        }
      }, stepTime);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var states = document.getElementsByClassName("estado");

      for (var i = 0; i < states.length; i++) {
        states[i].onclick = function () {
          alert(this.getAttribute("name") + " " + this.getAttribute("code") + " Notas de Saida: " + this.getAttribute("saida") + " Notas de entrada: " + this.getAttribute("entrada"));
        };
      }
    });
  }

});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "labels", "data", "backgroundColor", "borderColor", "customId", "title", "icon"],
  data: function data() {
    return {
      pieChart: {
        type: "pie",
        data: {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: [],
            borderColor: []
          }],
          options: {
            legend: {
              display: false
            },
            elements: {},
            center: {
              text: "90%",
              color: "#FFF", // Default is #000000
              fontStyle: "Arial", // Default is Arial
              sidePadding: 20 // Defualt is 20 (as a percentage)
            }
          },
          display: false
        }
      },
      showMsgNoData: false,
      total: 0
    };
  },
  watch: {
    data: function data(newV, oldV) {
      if (newV) {
        this.begin();
      }
    },
    backgroundColor: function backgroundColor(newV, oldV) {
      if (newV) {
        this.begin();
      }
    },
    borderColor: function borderColor(newV, oldV) {
      if (newV) {
        this.begin();
      }
    },
    labels: function labels(newV, oldV) {
      if (newV) {
        this.begin();
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  methods: {
    begin: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ctxpie, pieChart, totalID;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.setData();

              case 3:

                if (this.total == 0) {
                  this.pieChart.data.options.center.text = '';
                  this.showMsgNoData = true;
                } else {
                  this.pieChart.data.options.center.text = this.total;
                  this.showMsgNoData = false;
                }

                this.setTextCenterPie();

                Chart.defaults.pie.cutoutPercentage = 60;
                Chart.defaults.global.legend.display = false;
                ctxpie = document.getElementById(this.customId);
                pieChart = new Chart(ctxpie, this.pieChart);
                totalID = "vlr" + this.customId;
                // this.animateValue(totalID, 0, 0, 28000, 20);

                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                console.log("Erro ao tentar montar pieChart: \n\n " + _context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function begin() {
        return _ref.apply(this, arguments);
      }

      return begin;
    }(),
    setTextCenterPie: function setTextCenterPie() {
      var vlrTotal = this.total;
      if (vlrTotal == 0) {
        return;
      }
      Chart.pluginService.register({
        beforeDraw: function beforeDraw(chart) {
          if (chart.config.data.options != undefined && chart.config.data.options.center) {
            //Get ctx from string
            var ctx = chart.chart.ctx;

            //Get options from the center object in options

            var centerConfig = chart.config.data.options.center;
            var fontStyle = centerConfig.fontStyle || "Arial";
            var txt = centerConfig.text;
            var color = centerConfig.color || "#000";
            var sidePadding = centerConfig.sidePadding || 20;
            var sidePaddingCalculated = sidePadding / 100 * (chart.innerRadius * 2);
            //Start with a base font of 30px
            ctx.font = "60px " + fontStyle;

            //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
            var stringWidth = ctx.measureText(txt).width;
            var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

            // Find out how much the font can grow in width.
            var widthRatio = elementWidth / stringWidth;
            var newFontSize = Math.floor(30 * widthRatio);
            var elementHeight = chart.innerRadius * 2;

            // Pick a new font size so it will not be larger than the height of label.
            var fontSizeToUse = Math.min(newFontSize, elementHeight);

            //Set font settings to draw it correctly.
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.font = fontSizeToUse + "px " + fontStyle;
            ctx.fillStyle = color;

            //Draw text in center
            ctx.fillText(txt, centerX, centerY);
          }
        }
      });
    },
    animateValue: function animateValue(id, start, end, duration, speed) {
      var range = end - start;
      var current = start;
      var increment = end > start ? speed : 5;
      var stepTime = Math.abs(Math.floor(duration / range));
      var obj = document.getElementById(id);
      var timer = setInterval(function () {
        current += increment;
        obj.innerHTML = current;
        if (current == end || current >= end) {
          clearInterval(timer);
        }
      }, stepTime);
    },

    vlrTotal: function vlrTotal() {
      if (this.data != undefined && this.data.length > 0) {
        var vlr = 0;
        this.data.forEach(function (valor) {
          vlr += valor;
        });
        this.total = vlr;
      }
    },
    setData: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.showCanvas = true;
                this.pieChart.data.labels = this.labels.slice();
                this.pieChart.data.datasets[0].data = this.data.slice();
                _context2.next = 5;
                return this.setColors();

              case 5:
                _context2.next = 7;
                return this.vlrTotal();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setData() {
        return _ref2.apply(this, arguments);
      }

      return setData;
    }(),
    setColors: function setColors() {
      this.setBackgroundColor();
      this.setBorderColor();
    },
    setBackgroundColor: function setBackgroundColor() {
      if (this.backgroundColor != undefined && this.backgroundColor.length > 0) {
        var pieCharBackground = [];
        for (var i = 0; i < this.backgroundColor.length; i++) {
          var cor = this.backgroundColor[i];
          switch (cor.toLocaleLowerCase()) {
            case "red":
              pieCharBackground.push("rgba(255, 0, 0, 0.5)");
              break;
            case "yellow":
              pieCharBackground.push("rgba(247, 255, 0, 0.5)");
              break;
            case "green":
              pieCharBackground.push("rgba(37, 198, 45, 0.5)");
              break;
            case "cyan":
              pieCharBackground.push("rgba(23, 182, 164, 0.5)");
              break;
            case "blue":
              pieCharBackground.push("rgba(54, 162, 235, 0.5)");
              break;
          }
        }
        this.pieChart.data.datasets[0].backgroundColor = pieCharBackground.slice();
      } else {
        this.pieChart.data.datasets[0].backgroundColor = [];
      }
    },
    setBorderColor: function setBorderColor() {
      if (this.borderColor != undefined && this.borderColor.length > 0) {
        var pieChartBorder = [];
        for (var i = 0; i < this.borderColor.length; i++) {
          var cor = this.borderColor[i];
          switch (cor.toLocaleLowerCase()) {
            case "red":
              pieChartBorder.push("rgba(255, 0, 0, 1)");
              break;
            case "yellow":
              pieChartBorder.push("rgba(247, 255, 0, 1)");
              break;
            case "green":
              pieChartBorder.push("rgba(37, 198, 45, 1)");
              break;
            case "cyan":
              pieChartBorder.push("rgba(23, 182, 164, 1)");
              break;
            case "blue":
              pieChartBorder.push("rgba(54, 162, 235, 1)");
              break;
          }
        }
        this.pieChart.data.datasets[0].borderColor = pieChartBorder.slice();
      } else {
        this.pieChart.data.datasets[0].borderColor = [];
      }
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "labels", "data", "backgroundColor", "borderColor", "customId", "title", "icon"],
  data: function data() {
    return {
      barChart: {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      },
      total: 0,
      showMsgNoData: false
    };
  },
  watch: {
    'data': {
      handler: function handler(val, oldVal) {
        if (val && val.length > 0) {
          this.begin();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  methods: {
    begin: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                      var ctxpie;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              ctxpie = document.getElementById(_this.customId);

                              if (ctxpie) {
                                resolve(ctxpie);
                              }

                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x, _x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }()).then(function () {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(ctxpie) {
                      var barChart;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return _this.setData();

                            case 2:
                              Chart.defaults.global.legend.display = true;
                              barChart = new Chart(ctxpie, _this.barChart);

                            case 4:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                } catch (err) {
                  console.log("Erro ao tentar montar barChart: \n\n " + err);
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function begin() {
        return _ref.apply(this, arguments);
      }

      return begin;
    }(),
    setData: function setData() {
      if (this.labels != undefined) {
        if (this.labels.length == 0) {
          this.showMsgNoData = true;
        } else {
          this.showMsgNoData = false;
          this.barChart.data.labels = this.labels;
          this.setDatasets();
        }
      } else {
        this.showMsgNoData = true;
      }
    },
    setDatasets: function setDatasets() {
      if (this.data != undefined && this.data.length > 0) {

        var datasets = [];
        for (var i = 0; i < this.data.length; i++) {
          var props = {};
          var element = this.data[i];
          props["label"] = element.label;
          props["data"] = element.data;
          props["backgroundColor"] = element.backgroundColor;
          props["borderColor"] = element.borderColor;
          props["borderWidth"] = element.borderWidth;
          datasets.push(props);
        }
        this.barChart.data.datasets = datasets.slice();
      } else {

        this.barChart.data.datasets = [];
      }
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditarPerfil_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4165cecd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditarPerfil_vue__ = __webpack_require__(786);
function injectStyle (ssrContext) {
  __webpack_require__(785)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4165cecd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditarPerfil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4165cecd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditarPerfil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_conta_usuario_formUsuario_FormUsuario_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_inputFile_InputFile_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_gravatar_GravatarService_js__ = __webpack_require__(61);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    inputFile: __WEBPACK_IMPORTED_MODULE_5__components_shared_inputFile_InputFile_vue__["a" /* default */],
    FormUsuario: __WEBPACK_IMPORTED_MODULE_3__components_conta_usuario_formUsuario_FormUsuario_vue__["a" /* default */]
  },
  props: ["alert", "conta", "cadastro", "empresa"],
  data: function data() {
    return {
      getDadosForm: false,
      notificacoes: {
        geral: {
          ativo: [],
          notaCancelada: [],
          ultConsulta: []
        },
        email: {
          ativo: [],
          resumoDiario: [],
          resumoSemanal: [],
          novoFornecedor: [],
          novoCliente: [],
          vencimentoNF: [],
          notaCancelada: [],
          nvNotaNfe: [],
          nvNotaCte: [],
          nvNotaNfse: []
        }
      },
      validPass: true,
      show1: false,
      show2: false,
      show3: false,
      avatarProfile: "",
      pass1: "",
      pass2: "",
      pass3: "",
      enviandoDados: false,
      buscaGravatar: false,
      gravatarSuccess: false,
      gravatarError: false,
      usarGravatar: false,
      resetInputImage: false,
      msgErrorGravatar: "",
      passwordRules: [function (v) {
        return !!v || "Campo é obrigatório";
      }],
      route: this.$router.history.current.path,
      currentItem: "",
      img: null,
      tabs: [{
        title: "Dados Pessoais"
      }, {
        title: "Minha senha"
      }, {
        title: "Notificações"
      }]
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.cadastro) {
        this.currentItem = 1;
      }
      if (this.cadastro != true) {
        if (this.conta.imagem) {
          this.resetGravatar();
          var dataImg = "data:image/jpg;base64," + this.bufferToBase64(this.conta.imagem.data);
          this.avatarProfile = "" + dataImg;
        } else if (this.conta != undefined && this.conta.gravatarProfile != undefined && !this.conta.gravatarProfile.hasOwnProperty('body')) {
          this.usarGravatar = true;
          this.avatarProfile = this.conta.gravatarProfile.thumbnailUrl + "?s=200";
        }
      }
      // if (this.cadastro != true && this.$session.exists()) {
      //   if (this.$session.get("jwt").gravatarProfile != undefined) {
      //     this.avatarProfile =
      //       this.$session.get("jwt").gravatarProfile.thumbnailUrl + "?s=200";
      //   }
      // }
      // if (this.cadastro && this.conta.gravatarProfile != undefined) {
      //   this.avatarProfile = this.conta.gravatarProfile + "?s=200";
      // }
    });
  },
  watch: {
    empresa: function empresa(newV, oldV) {
      if (newV._id != oldV._id) {
        this.getUserById();
      }
    },
    currentItem: function currentItem(newV, oldV) {
      if (this.empresa) {
        this.getUserById();
      }
    }
  },
  updated: function updated() {},
  computed: {
    resetNotificacoesEmail: function resetNotificacoesEmail() {
      this.notificacoes.email.resumoDiario = [];
      this.notificacoes.email.resumoSemanal = [];
      this.notificacoes.email.novoFornecedor = [];
      this.notificacoes.email.novoCliente = [];
      this.notificacoes.email.vencimentoNF = [];
      this.notificacoes.email.notaCancelada = [];
      this.notificacoes.email.nvNotaNfe = [];
      this.notificacoes.email.nvNotaCte = [];
      this.notificacoes.email.nvNotaNfse = [];
    }
  },
  methods: {
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    emitResetInput: function emitResetInput($event) {
      this.resetInputImage = $event;
    },
    bufferToBase64: function bufferToBase64(buf) {
      var binstr = Array.prototype.map.call(buf, function (ch) {
        return String.fromCharCode(ch);
      }).join("");
      return btoa(binstr);
    },

    getGravatar: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.usarGravatar) {
                  _context.next = 9;
                  break;
                }

                this.resetInputImage = true;
                this.buscaGravatar = true;

                if (!this.conta.email) {
                  _context.next = 7;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_6__domain_gravatar_GravatarService_js__["a" /* default */](this.$http);
                _context.next = 7;
                return this.service.getGravatar(this.conta.email).then(function (resp) {
                  _this.buscaGravatar = false;
                  if (resp.ok == false) {
                    _this.gravatarSuccess = false;
                    _this.gravatarError = true;
                    _this.usarGravatar = false;
                    _this.msgErrorGravatar = "Usuário não encontrado no Gravatar.";
                  } else {
                    _this.gravatarSuccess = true;
                    _this.gravatarError = false;
                    _this.conta["gravatarProfile"] = resp;
                    var output = document.querySelectorAll("#userLogo_ePerfil");
                    output.forEach(function (element) {
                      element.src = resp.thumbnailUrl + "?size=200";
                    });
                    _this.img = undefined;
                  }
                });

              case 7:
                _context.next = 10;
                break;

              case 9:
                this.resetGravatar();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getGravatar() {
        return _ref.apply(this, arguments);
      }

      return getGravatar;
    }(),
    getUserById: function getUserById() {
      var _this2 = this;

      if (this.conta) {
        if (this.conta.id_usuario) {
          this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
          this.service.getUsuarioId(this.conta.id_usuario).then(function (resp) {
            _this2.notificacoes.email = resp.body.notificacoesEmail;
            _this2.notificacoes.geral = resp.body.notificacoesGeral;
          });
        }
      }
    },
    resetGravatar: function resetGravatar() {
      this.usarGravatar = false;
      this.buscaGravatar = false;
      this.gravatarSuccess = false;
      this.gravatarError = false;
    },
    getFile: function getFile(file) {
      this.resetGravatar();
      this.img = file;
      if (file) {
        var output = document.querySelectorAll("#userLogo_ePerfil");
        output.forEach(function (element) {
          element.src = URL.createObjectURL(file[0]);
        });
        this.img = file[0];
      }
    },

    verifSenha: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var conta, body;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                conta = { email: this.conta.email, password: this.pass1 };
                body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(conta);
                _context2.next = 4;
                return this.$http.post("usuarios/authenticate", body).then(function (success) {
                  return true;
                }, function (failed) {
                  _this3.passwordRules.push(function senhaInvalida(value) {
                    return "Senha invalida";
                  });
                  return false;
                });

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function verifSenha() {
        return _ref2.apply(this, arguments);
      }

      return verifSenha;
    }(),
    emitDadosForm: function emitDadosForm(value) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var envDados, data, prop, idUsuario;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                envDados = false;

                if (!(value != false)) {
                  _context3.next = 18;
                  break;
                }

                if (_this4.img != null) {
                  value["img"] = _this4.img;
                }

                if (!(_this4.pass1 != "" || _this4.cadastro)) {
                  _context3.next = 15;
                  break;
                }

                if (_this4.passwordRules.length > 2) {
                  _this4.passwordRules.pop();
                }

                if (_this4.cadastro) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 8;
                return _this4.verifSenha();

              case 8:
                if (_this4.$refs.pass1.validate()) {
                  _context3.next = 12;
                  break;
                }

                _this4.currentItem = 1;
                _this4.getDadosForm = false;
                return _context3.abrupt("return");

              case 12:
                if (_this4.pass2 != _this4.pass3) {
                  if (_this4.passwordRules.length > 2) {
                    _this4.passwordRules.pop();
                  }
                  _this4.currentItem = 1;
                  _this4.passwordRules.push(function diferentes(value) {
                    return "Senhas não coincídem";
                  });
                  _this4.$refs.pass2.validate();
                  _this4.$refs.pass3.validate();
                } else if (_this4.$refs.formPass.validate()) {
                  value["password"] = _this4.pass2;
                  envDados = true;
                } else {
                  _this4.currentItem = 1;
                }
                _context3.next = 16;
                break;

              case 15:
                envDados = true;

              case 16:
                _context3.next = 19;
                break;

              case 18:
                _this4.currentItem = 0;

              case 19:
                _this4.getDadosForm = false;
                data = new FormData();

                if (_this4.empresa) {
                  if (_this4.empresa._id) {
                    value["notificacoesGeral"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.notificacoes.geral);
                    value["notificacoesEmail"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.notificacoes.email);
                  }
                }
                //removendo os atributos que não vão ser editados.
                for (prop in value) {
                  if (value[prop] == null || value[prop] == undefined) {
                    delete value[prop];
                  } else {
                    data.append(prop, value[prop]);
                  }
                }
                if (envDados) {
                  if (_this4.cadastro) {
                    value["preCadastro"] = "";
                    data.append("preCadastro", value["preCadastro"]);
                  }

                  idUsuario = _this4.conta.id_usuario;

                  _this4.enviandoDados = true;
                  _this4.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_usuario_UsuarioService_js__["a" /* default */](_this4.$http);
                  _this4.activeGlobalLoader();
                  document.querySelector('html').scrollTo(0, 0);
                  _this4.service.editar(data, idUsuario).then(function (resp) {
                    _this4.desactiveGlobalLoader();
                    _this4.alert.snackDanger();
                    _this4.enviandoDados = false;
                    _this4.alert.snack.text = "Ocorreu algum erro";
                    if (resp.ok) {
                      _this4.conta.nome = data.get('nome');
                      _this4.alert.snackSuccess();
                      _this4.alert.snack.text = "Informações alteradas.";
                      if (_this4.cadastro) {
                        _this4.alert.snack.text = "Cadastro concluido, agora poderá acessar o Motor Fiscal.";

                        var conta = {};
                        conta["email"] = value.email;
                        conta["password"] = value.password;
                        var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(conta);
                        _this4.$http.post("usuarios/authenticate", body).then(function (success) {
                          _this4.redirectUser(success);
                        }, function (failed) {
                          var router = _this4.$router;
                          setTimeout(function () {
                            router.push("/login");
                          }, 4000);
                        });
                        // this.$router.push('/login');
                      } else {
                        if (_this4.img || _this4.usarGravatar) {
                          if (resp.body.imgBuffer) {
                            var output = document.querySelectorAll("#userLogo");
                            output.forEach(function (element) {
                              element.src = URL.createObjectURL(_this4.img);
                            });
                            _this4.img = resp.body.imgBuffer;
                          } else {
                            var _output = document.querySelectorAll("#userLogo");
                            _output.forEach(function (element) {
                              element.src = _this4.conta["gravatarProfile"].thumbnailUrl + "?size=200";
                            });
                          }
                          try {
                            _this4.conta.imagem = _this4.img;
                            var auxConta = _this4.$session.get("jwt");
                            auxConta["img"] = _this4.img;
                            _this4.$session.set("jwt", auxConta);
                            _this4.img = undefined;
                          } catch (err) {
                            console.log("N\xE3o foi possivel setar imagem " + err);
                          }
                        }
                      }
                    }
                    _this4.alert.snack.show = true;
                  }).then(function () {
                    if (_this4.conta && !_this4.cadastro) {
                      _this4.conta.getNotificacoes = true;
                    }
                  });
                }

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },


    resetOpcaoNotificacoes: function resetOpcaoNotificacoes(tipo) {
      switch (tipo) {
        case "email":
          this.rmvItemArray(this.notificacoes.email.resumoDiario.indexOf(this.empresa._id), this.notificacoes.email.resumoDiario);

          this.rmvItemArray(this.notificacoes.email.resumoSemanal.indexOf(this.empresa._id), this.notificacoes.email.resumoSemanal);

          this.rmvItemArray(this.notificacoes.email.novoFornecedor.indexOf(this.empresa._id), this.notificacoes.email.novoFornecedor);

          this.rmvItemArray(this.notificacoes.email.novoCliente.indexOf(this.empresa._id), this.notificacoes.email.novoCliente);

          this.rmvItemArray(this.notificacoes.email.vencimentoNF.indexOf(this.empresa._id), this.notificacoes.email.vencimentoNF);

          this.rmvItemArray(this.notificacoes.email.notaCancelada.indexOf(this.empresa._id), this.notificacoes.email.notaCancelada);

          this.rmvItemArray(this.notificacoes.email.nvNotaNfe.indexOf(this.empresa._id), this.notificacoes.email.nvNotaNfe);

          this.rmvItemArray(this.notificacoes.email.nvNotaCte.indexOf(this.empresa._id), this.notificacoes.email.nvNotaCte);

          this.rmvItemArray(this.notificacoes.email.nvNotaNfse.indexOf(this.empresa._id), this.notificacoes.email.nvNotaNfse);
          break;
        case "geral":
          this.rmvItemArray(this.notificacoes.geral.notaCancelada.indexOf(this.empresa._id), this.notificacoes.geral.notaCancelada);
          this.rmvItemArray(this.notificacoes.geral.ultConsulta.indexOf(this.empresa._id), this.notificacoes.geral.ultConsulta);
          break;
      }
    },
    rmvItemArray: function rmvItemArray(pos, array) {
      if (pos != -1) {
        array.splice(pos, 1);
      }
    },
    salvarDados: function salvarDados() {
      this.getDadosForm = true;
      // alert("Implementar Lógica");
    },

    redirectUser: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(success) {
        var _this5 = this;

        var router, conta;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                router = this.$router;
                conta = success.body;

                this.$session.start();
                this.service = new __WEBPACK_IMPORTED_MODULE_6__domain_gravatar_GravatarService_js__["a" /* default */](this.$http);
                _context4.next = 6;
                return this.service.getGravatar(success.body.email).then(function (success) {
                  if (success) {
                    if (success.hasOwnProperty('thumbnailUrl')) {
                      conta["gravatarProfile"] = success;
                    }
                  }
                }).then(function (x) {
                  _this5.$session.set("jwt", conta);
                  setTimeout(function () {
                    router.push("/DashBoard");
                  }, 4000);
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function redirectUser(_x) {
        return _ref3.apply(this, arguments);
      }

      return redirectUser;
    }()
  },

  beforeMount: function beforeMount() {
    this.$nextTick(function () {});
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dataTable_RenderTableNFe_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_conta_usuario_formUsuario_FormUsuario_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_conta_empresa_formEmpresa_FormEmpresa_vue__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_conta_empresa_certificado_formCertificado_FormCertificado_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_conta_empresa_certificado_CertificadoService_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_dataTable_TableEmpresas__ = __webpack_require__(160);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["empresa", "alert", "conta", "IBGE"],
  components: {
    RenderTableNFe: __WEBPACK_IMPORTED_MODULE_2__components_dataTable_RenderTableNFe_vue__["default"],
    FormUsuario: __WEBPACK_IMPORTED_MODULE_3__components_conta_usuario_formUsuario_FormUsuario_vue__["a" /* default */],
    FormEmpresa: __WEBPACK_IMPORTED_MODULE_4__components_conta_empresa_formEmpresa_FormEmpresa_vue__["a" /* default */],
    FormCertificado: __WEBPACK_IMPORTED_MODULE_5__components_conta_empresa_certificado_formCertificado_FormCertificado_vue__["a" /* default */]
  },
  data: function data() {
    return {
      dialog: false,
      dialog2: false,
      sendAttTable: false,
      resetForm: false,
      formEmp: { show: false, titulo: "", btnSuccess: "" },
      route: this.$router.history.current.path,
      currentItem: "",
      empEdit: {},
      edit: false,
      currentTabInComp: undefined,
      getDadosForm: false,
      tabs: [{
        title: "Empresas"
      }, {
        title: "Certificado"
      }],
      notificacoes: {
        objetos: []
      }
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$session.exists()) {
        if (this.$session.get("jwt").gravatarProfile != undefined) {
          this.avatarProfile = this.$session.get("jwt").gravatarProfile.thumbnailUrl + "?s=200";
        }
      }
    });
  },
  updated: function updated() {},
  watch: {
    dialog: function dialog(newV, oldV) {
      if (!newV) {
        this.edit = newV;
      }
    }
  },
  computed: {},
  methods: {
    emitEditEmp: function emitEditEmp($event) {
      this.notificacoes.objetos = [];
      this.formEmp.titulo = "Editar Empresa: ";
      this.formEmp.btnSuccess = "Salvar";
      this.empEdit = $event;
      this.notificacoes.objetos = $event.enviaEmails.slice();
      this.edit = true;
      this.dialog = true;
    },
    showFormCadastrar: function showFormCadastrar(tipo) {
      this.formEmp.titulo = "Cadastro de " + tipo + ":";
      this.formEmp.btnSuccess = "Cadastrar";
      this.empEdit = {};
      this.edit = false;
      this.resetForm = true;
      this.dialog = true;
      this.notificacoes.objetos = [];
    },
    salvarDados: function salvarDados() {
      this.getDadosForm = true;
    },
    changResetForm: function changResetForm(value) {
      this.resetForm = value;
    },
    emitAttEmpresas: function emitAttEmpresas() {
      this.$emit("emitAttEmpresas", true);
    },

    emitDadosForm: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        var envDados;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                envDados = false;

                this.alert.resetAlert();

                if (!(value != false)) {
                  _context.next = 19;
                  break;
                }

                if (!(value.tipo.component == "empresa")) {
                  _context.next = 7;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_6__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
                _context.next = 16;
                break;

              case 7:
                if (!(value.tipo.component == "usuario")) {
                  _context.next = 11;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_7__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
                _context.next = 16;
                break;

              case 11:
                if (!(value.tipo.component == "certificado")) {
                  _context.next = 15;
                  break;
                }

                this.service = new __WEBPACK_IMPORTED_MODULE_8__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);
                _context.next = 16;
                break;

              case 15:
                throw new Error("Serviço de configuração não codificado");

              case 16:
                envDados = true;
                _context.next = 23;
                break;

              case 19:
                this.currentTabInComp = 0;
                this.alert.snackAlert();
                this.alert.snack.text = "Verificamos que possuem campos com erros.";
                this.alert.snack.show = true;

              case 23:
                if (!envDados) {
                  _context.next = 26;
                  break;
                }

                _context.next = 26;
                return this.envDadosApi(value);

              case 26:
                this.getDadosForm = false;
                this.resetForm = false;

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function emitDadosForm(_x) {
        return _ref.apply(this, arguments);
      }

      return emitDadosForm;
    }(),
    envDadosApi: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(value) {
        var _this2 = this;

        var method, id, body, notificacoes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                method = void 0;
                id = void 0;

                //metodos variam de acordo com ação. Tanto empresa,certificado,usúario possuem opções de cadastrar/editar em seus serviços.
                //id variam de acordo com o metodo, se for editar, no form do componente estará atrelado o id para edição. Criação o id tem que ser vinculado a conta.

                value.tipo.acao == "create" ? id = this.conta.conta : id = value.dados._id;
                value.tipo.acao == "create" ? method = "cadastrar" : method = "editar";

                body = {};

                if (value.tipo.component == "usuario") {
                  body["colaborador"] = value.dados;
                  body["empresas"] = value.empresas;
                } else if (value.tipo.component == "empresa") {
                  notificacoes = [];

                  this.notificacoes.objetos.forEach(function (curr) {
                    if (!curr.hasOwnProperty("delete") || curr["delete"] == false) {
                      notificacoes.push(curr);
                    }
                  });
                  value.dados["enviaEmails"] = notificacoes;
                  body = value.dados;
                } else {
                  body = value.dados;
                }
                _context4.next = 8;
                return this.service[method](body, id).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resp) {
                    var currentEmp, data;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            //adicionar empresa cadastrada na conta.
                            if (resp.body.hasOwnProperty("empresas")) {
                              currentEmp = undefined;

                              resp.body.empresas.forEach(function (emp) {
                                if (emp.empresa.hasOwnProperty("_id")) {
                                  currentEmp = emp.empresa;
                                }
                              });
                              if (currentEmp) {
                                this.conta.admin.push(currentEmp);
                              }
                            }
                            this.alert.snackDanger();
                            resp.body.message != undefined && resp.body.message.length != 0 ? this.alert.snack.text = resp.body.message : this.alert.snack.text = resp.infoMessage.msg;

                            if (!(resp.ok && value.tipo.component != "empresa")) {
                              _context3.next = 9;
                              break;
                            }

                            this.alert.snackSuccess();
                            this.dialog = false;
                            this.dialog2 = false;
                            this.edit = false;
                            return _context3.abrupt("return");

                          case 9:
                            if (!(value.tipo.component == "empresa")) {
                              _context3.next = 17;
                              break;
                            }

                            if (resp.ok) {
                              //necessario pois ao cadastrar uma empresa e alguma informação do certificado estivesse errada ele retornaria um erro que a 'empresa já estava cadastrada'
                              this.alert.snackSuccess();
                            }
                            data = new FormData();

                            if (value.cert != false && value.cert.dados.file != undefined) {
                              data.append("file", value.cert.dados.file[0]);
                              data.append("password", value.cert.dados.password);
                            }
                            _context3.next = 15;
                            return this.service.getEmpresasCnpj(value.dados.cnpj).then(function () {
                              var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
                                var _this = this;

                                var arrayEmp, _arrayEmp;

                                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        if (value.cert != false) {
                                          value.cert.dados["empresa"] = res.body.items[0]._id;
                                          value.cert.dados.file = data.get("file");
                                          value.cert.dados.password = data.get("password");
                                        }

                                        this.service = new __WEBPACK_IMPORTED_MODULE_8__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);

                                        if (!(value.cert != false && value.cert.dados.file != undefined)) {
                                          _context2.next = 10;
                                          break;
                                        }

                                        arrayEmp = [];

                                        arrayEmp.push(value.cert.dados.empresa);
                                        value.cert.dados["empresa"] = arrayEmp;

                                        _context2.next = 8;
                                        return this.service.cadastrar(value.cert.dados, this.conta.conta).then(function (resp) {
                                          if (resp.ok) {
                                            _this.alert.snackSuccess();
                                            _this.dialog = false;
                                            _this.edit = false;
                                          } else {
                                            _this.alert.snackDanger();
                                            resp.body.message != undefined && resp.body.message.length != 0 ? _this.alert.snack.text = resp.body.message : _this.alert.snack.text = resp.infoMessage.msg;
                                          }
                                        });

                                      case 8:
                                        _context2.next = 20;
                                        break;

                                      case 10:
                                        if (!(value.cert != false && value.cert.dados._id != undefined)) {
                                          _context2.next = 18;
                                          break;
                                        }

                                        this.service = new __WEBPACK_IMPORTED_MODULE_8__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);
                                        _arrayEmp = [];

                                        _arrayEmp.push(res.body.items[0]._id);
                                        _context2.next = 16;
                                        return this.service.vincularEmpresa(value.cert.dados._id, _arrayEmp).then(function (resp) {
                                          if (resp.ok) {
                                            _this.alert.snackSuccess();
                                            _this.dialog = false;
                                            _this.edit = false;
                                          } else {
                                            _this.alert.snackDanger();
                                            resp.body.message != undefined && resp.body.message.length != 0 ? _this.alert.snack.text = resp.body.message : _this.alert.snack.text = resp.infoMessage.msg;
                                          }
                                        });

                                      case 16:
                                        _context2.next = 20;
                                        break;

                                      case 18:
                                        this.dialog = false;
                                        this.edit = false;

                                      case 20:
                                        return _context2.abrupt("return", res.body.items[0].cnpj);

                                      case 21:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, this);
                              }));

                              return function (_x4) {
                                return _ref4.apply(this, arguments);
                              };
                            }());

                          case 15:
                            _context3.next = 19;
                            break;

                          case 17:
                            this.dialog = false;
                            this.edit = false;

                          case 19:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }()).then(function (v) {
                  _this2.emitAttEmpresas();
                  _this2.conta.getEmpresas = true;
                }).then(function (v) {
                  _this2.sendAttTable = true;
                  _this2.alert.snack.show = true;
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function envDadosApi(_x2) {
        return _ref2.apply(this, arguments);
      }

      return envDadosApi;
    }(),
    attSendTable: function attSendTable(value) {
      this.sendAttTable = value;
    }
  },
  beforeMount: function beforeMount() {
    this.$nextTick(function () {});
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_FormEmpresa_js__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_conta_empresa_certificado_formCertificado_FormCertificado_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_conta_empresa_formEmpresa_tabNotificacoes_TabNotificacoes_vue__ = __webpack_require__(794);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["displayFlex", "create", "edit", "getDadosForm", "resetForm", "empEdit", "conta", "currentTab", "IBGE", "notificacoes"],
  components: {
    FormCertificado: __WEBPACK_IMPORTED_MODULE_6__components_conta_empresa_certificado_formCertificado_FormCertificado_vue__["a" /* default */],
    TabNotificacoes: __WEBPACK_IMPORTED_MODULE_7__components_conta_empresa_formEmpresa_tabNotificacoes_TabNotificacoes_vue__["a" /* default */]
  },
  data: function data() {
    return {
      valid: true,
      currentItem: 0,
      tabs: [{
        title: "Cadastrar novo"
      }, {
        title: "Vincular um previamente cadastrado"
      }],
      prodRural: false,
      currentItemModal: 0,
      tabsModal: [{
        title: "Informações"
      }, {
        title: "Certificado"
      }, {
        title: "Notificações"
      }],
      cpfRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (cpf) {
        var sum = void 0,
            rest = void 0;
        if (cpf === undefined || cpf === null || cpf.trim().length === 0 || cpf === "00000000000" || cpf === "11111111111" || cpf === "22222222222" || cpf === "33333333333" || cpf === "44444444444" || cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777" || cpf === "88888888888" || cpf === "99999999999") {
          return "CPF inválido";
        }
        cpf = cpf.replace(".", "").replace(".", "").replace("-", "");

        sum = 0;
        for (var i = 1; i <= 9; i++) {
          sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        rest = sum * 10 % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(9, 10))) {
          return "CPF inválido";
        }

        sum = 0;
        for (var _i = 1; _i <= 10; _i++) {
          sum = sum + parseInt(cpf.substring(_i - 1, _i)) * (12 - _i);
        }
        rest = sum * 10 % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(10, 11))) {
          return "CPF inválido";
        }
        return true;
      }],

      cnpjRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        if (v == null) {
          return false;
        }
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

        if (/0{14}/.test(v)) return "CNPJ inválido";

        for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]) {}
        if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]) {}
        if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        return true;
      }],
      razaoRules: [function (v) {
        return !!v || "Campo obrigatório";
      }],
      modelForm: new __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_FormEmpresa_js__["a" /* default */](),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menuCte1: false,
      menuCte2: false,
      menuCte3: false,
      menuCte4: false,
      show1: false,
      show2: false,
      show3: false,
      trocaCPFCNPJ: false,
      getDadosCert: false,
      arrayEstados: [],
      arrayCidades: [],
      uf: "",
      municipio: "",
      logConsulta: "",
      route: this.$router.history.current.path,
      resetFormCert: false
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.getEstados;
      this.service = new __WEBPACK_IMPORTED_MODULE_5__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
    });
  },
  updated: function updated() {},
  watch: {
    "IBGE.cidades.items": function IBGECidadesItems(newV, oldV) {
      if (newV != oldV) {
        this.arrayCidades = newV;
      }
    },
    "IBGE.estados": function IBGEEstados(newV, oldV) {
      if (newV != oldV) {
        this.arrayEstados = newV;
      }
    },
    currentTab: function currentTab(newV, oldV) {
      this.currentItemModal = newV;
    },
    resetForm: function resetForm(newV, oldV) {
      if (this.resetForm) {
        this.resetarForm();
      }
    },
    edit: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.resetarForm();

                if (this.edit && this.empEdit.hasOwnProperty("cnpj")) {
                  new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return _this.$refs.form.reset();

                            case 2:
                              setTimeout(function () {
                                resolve();
                              }, 1000);

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x, _x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }()).then(function () {
                    var auxEmpEdit = _this.empEdit;
                    for (var prop in _this.empEdit) {
                      _this.modelForm.form.items.forEach(function (item) {
                        if (item.item_id == prop) {
                          item.valor = auxEmpEdit[prop];
                        }
                      });
                    }
                    var auxUf = _this.empEdit.uf;
                    var auxEstado = void 0;
                    _this.arrayEstados.forEach(function (item) {
                      if (item.id == auxUf) {
                        auxEstado = item;
                      }
                    });
                    _this.uf = auxEstado;
                    _this.municipio = _this.empEdit.municipio;
                    _this.resetFormCert = true;
                    if (_this.empEdit.cnpj.length > 11) {
                      _this.prodRural = false;
                    } else if (_this.empEdit.cnpj.length == 11) {
                      _this.prodRural = true;
                    }
                  });
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function edit() {
        return _ref.apply(this, arguments);
      }

      return edit;
    }(),
    uf: function uf() {
      this.getCidades();
    },
    getDadosForm: function getDadosForm(newV, oldV) {
      if (newV) {
        this.getDadosCert = true;
      }
    }
  },
  computed: {
    getEstados: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.arrayEstados = this.IBGE.estados;

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getEstados() {
        return _ref3.apply(this, arguments);
      }

      return getEstados;
    }()
  },
  methods: {
    trocaCampoCpfCnpj: function trocaCampoCpfCnpj(e, obj) {
      if (!obj.valor || obj.valor.length == 0) {
        //qnd o campo estiver em branco tirar regra da mascara para possivel CTRL + V do usuário
        obj.mask = "";
      } else {
        if (this.trocaCPFCNPJ && obj.valor && obj.valor.length >= 12) {
          //Trocar para mask cnpj
          obj.mask = obj.maskCNPJ.v;
        } else if (obj.valor && obj.valor.length >= 11) {
          //Trocar para mascara flexivel em receber mais 1 caractere.
          this.trocaCPFCNPJ = true;
          obj.mask = "###.###.###-###";
        } else {
          //Trocar para mascara de cpf
          this.trocaCPFCNPJ = false;
          obj.mask = obj.maskCPF.v;
        }
      }
    },
    resetarForm: function resetarForm() {
      if (!this.edit) {
        this.$refs.form.reset();
        this.currentItemModal = 0;
        this.resetFormCert = true;
        this.$emit("changResetForm", false);
      }
    },
    verificaCNPJ: function verificaCNPJ(item) {
      var _this2 = this;

      // success.body.nome  success.body.cep success.body.logradouro success.body.municipio success.body.uf
      if (this.$refs.cnpj[0].valid) {
        if (item.valor.length > 14) {
          item.valor = item.valor.split('/').join('');
        }
        item.valor = item.valor.split('.').join('');
        item.valor = item.valor.split('-').join('');
        this.service.getEmpresasCnpj(item.valor).then(function (success) {
          // trocar para algo melhor
          if (_this2.cnpjRules[_this2.cnpjRules.length - 1].name.length != 0) {
            _this2.cnpjRules.pop();
          }
          if (_this2.cpfRules[_this2.cpfRules.length - 1].name.length != 0) {
            _this2.cpfRules.pop();
          }
          if (success && success.status != 404) {
            _this2.cnpjRules.push(function indisponivel(value) {
              if (success.body.items.length > 0 && value == success.body.items[0].cnpj) {
                return "CNPJ já utilizado no sistema";
              }
              return true;
            });
            _this2.cpfRules.push(function indisponivel(value) {
              if (success.body.items.length > 0 && value == success.body.items[0].cnpj) {
                return "CPF já utilizado no sistema";
              }
              return true;
            });
          }
          _this2.$refs.cnpj[0].validate();
          return _this2.$refs.cnpj[0].valid;
        }, function (failed) {
          return failed;
        }).then(function (cnpjValid) {
          if (cnpjValid) {
            _this2.service.getAPIReceita(item.valor).then(function (success) {
              if (success && success.status == 200 && success.body.status != "ERROR") {
                _this2.modelForm.form.items.forEach(function (item) {
                  if (item.item_id == "razao") {
                    item.valor = success.body.nome;
                  } else if (item.item_id == "cep") {
                    item.valor = success.body.cep;
                  } else if (item.item_id == "endereco") {
                    item.valor = success.body.logradouro;
                  } else if (item.item_id == "bairro") {
                    item.valor = success.body.bairro;
                  }
                });
                var auxEstado = void 0;
                var auxCidade = void 0;
                _this2.uf = _this2.arrayEstados.forEach(function (item) {
                  if (item.sigla == success.body.uf) {
                    auxEstado = item;
                  }
                });
                _this2.uf = auxEstado;
                if (_this2.arrayCidades) {
                  if (success.body.municipio) {
                    _this2.municipio = _this2.arrayCidades.forEach(function (item) {
                      if (item.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9ÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÑÕÄËÏÖÜÇ]/ig, "") == success.body.municipio.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9ÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÑÕÄËÏÖÜÇ]/ig, "")) {
                        console.log(item);
                        auxCidade = item;
                      }
                    });
                  }
                }

                _this2.municipio = auxCidade;
              }
            });
          }
        });
      }
    },
    emitDadosForm: function emitDadosForm(cert) {
      if (this.$refs.form.validate() && this.getDadosForm) {
        var dados = {};
        this.modelForm.form.items.forEach(function (item) {
          if (item.valor != null && item.valor != undefined && item.valor != "") {
            dados[item.item_id] = item.valor;
          }
        });
        this.uf != undefined && this.uf != "" && this.uf != null ? dados["uf"] = this.uf.id : this.uf = undefined;
        this.municipio != undefined && this.municipio != "" && this.municipio != null ? dados["municipio"] = this.municipio.nome : this.municipio = undefined;
        this.municipio != undefined && this.municipio != "" && this.municipio != null ? dados["codMun"] = this.municipio.id : this.municipio = undefined;

        // dados["uf"] = this.uf;
        // dados["municipio"] = this.municipio;
        var obj = {};
        obj["dados"] = dados;
        obj["tipo"] = { component: "empresa" };
        obj["cert"] = cert;
        obj.tipo["acao"] = this.edit == true ? "edit" : "create";
        if (this.edit) {
          obj.dados["_id"] = this.empEdit._id;
        }
        this.getDadosCert = false;
        this.$emit("emitDadosForm", obj);
      } else if (!this.$refs.form.validate()) {
        this.getDadosCert = false;
        this.$emit("emitDadosForm", false);
      }
    },
    validateDate: function validateDate(field, item) {
      if (field.target.value.length == 10) {
        item.valor = field.target.value.split("-").join("");
        item.data = field.target.value.split("-").reverse().join("-");
      }
    },
    formatDate: function formatDate(date, menu) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "-" + month + "-" + year;
    },

    getCidades: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.uf) {
                  this.IBGE.cidades.uf = this.uf.id;
                  this.IBGE.cidades.att = true;
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getCidades() {
        return _ref4.apply(this, arguments);
      }

      return getCidades;
    }(),
    changResetForm: function changResetForm(value) {
      this.resetFormCert = value;
    }
  },
  beforeMount: function beforeMount() {
    this.$nextTick(function () {});
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCertificado_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4ac1de8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCertificado_vue__ = __webpack_require__(793);
function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4ac1de8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCertificado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4ac1de8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCertificado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_inputFile_InputFile_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_certificado_CertificadoService_js__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import FormCertificado from "@/domain/conta/empresa/certificado/FormCertificado.js";



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["displayFlex", "create", "vincular", "getDadosForm", "resetForm", "edit", "formEmp", "conta"],
  components: {
    InputFile: __WEBPACK_IMPORTED_MODULE_0__components_shared_inputFile_InputFile_vue__["a" /* default */]
  },
  data: function data() {
    return {
      cert: { file: undefined, password: "" },
      certSelect: "",
      arrayCert: [],
      valid: true,
      showPassword: false,
      menu0: false,
      show1: false,
      show2: false,
      show3: false,
      route: this.$router.history.current.path,
      passRules: [function (v) {
        return !!v || "Campo obrigatório";
      }],
      select: "",
      items: [],
      resetInput: false
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.getEmpresas();
      this.getCertificados();
    });
  },
  updated: function updated() {},
  watch: {
    resetForm: function resetForm(newV, oldV) {
      if (this.resetForm) {
        this.$refs.form.reset();
        if (this.cert) {
          this.cert["file"] = undefined;
        }
        this.resetInput = true;
        this.$emit("changResetForm", false);
      }
    },
    getDadosForm: function getDadosForm(newV, oldV) {
      if (newV) {
        if (this.formEmp && this.cert != undefined && this.cert.file != "" || this.$refs.form.validate() && this.getDadosForm && this.cert != undefined && this.cert.file != "") {
          this.emitDadosForm();
        } else {
          this.$emit("emitDadosForm", false);
        }
      }
    }
  },
  computed: {
    certificate: function certificate() {
      return this.$store.getters.certificate;
    }
  },
  methods: {
    getCertificados: function getCertificados() {
      var _this = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);
      this.service.getCertificadosConta(this.conta.conta).then(function (body) {
        var arrayEmpresas = body.items.concat(body.certs_not_owner);

        arrayEmpresas.forEach(function (item) {
          item["desc_venc"] = item.nome + " - val.: " + new Date(item.validade).toLocaleDateString();
        });
        _this.arrayCert = arrayEmpresas.slice();
      });
    },
    getEmpresas: function getEmpresas() {
      var _this2 = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_1__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
      this.service.getEmpresasConta(this.conta.conta).then(function (body) {
        _this2.items = body.empresas;
      });
    },
    getFile: function getFile(file) {
      this.cert.file = file;
    },
    emitResetInput: function emitResetInput(value) {
      this.resetInput = false;
    },
    getSelected: function getSelected() {
      // this.cert = this.certSelect;
      if (this.certSelect !== undefined) {
        this.$store.commit('addCertificate', this.certSelect);
      } else {
        this.$store.commit('addCertificate', {});
      }
    },
    remove: function remove(item) {
      var index = this.select.indexOf(item);
      if (index >= 0) this.select.splice(index, 1);
    },
    selectItem: function selectItem(value) {},
    emitDadosForm: function emitDadosForm() {
      if (this.certificate && this.certificate._id && !this.cert.file) {
        this.cert = this.certificate;
        this.$store.commit('addCertificate', {});
      }
      if (this.cert.file || this.cert._id) {
        var empIds = [];

        if (this.select != undefined && this.select.length > 0) {
          this.select.forEach(function (item) {
            empIds.push(item.empresa._id);
          });
          this.cert["empresa"] = empIds;
        } else {
          this.select != "" && this.select != undefined ? this.cert["empresa"] = this.select.empresa._id : "";
        }
        var obj = {};
        obj["dados"] = this.cert;
        obj["tipo"] = { component: "certificado" };
        obj.tipo["acao"] = this.edit == true ? "edit" : "create";
        this.cert = { file: undefined, password: "" };
        this.$emit("emitDadosForm", obj);
      } else {
        this.$emit("emitDadosForm", false);
      }
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_conta_empresa_formEmpresa_tabNotificacoes_modalAddEdit_ModalAddEdit_vue__ = __webpack_require__(796);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["notificacoes"],
  components: { ModalAddEdit: __WEBPACK_IMPORTED_MODULE_0__components_conta_empresa_formEmpresa_tabNotificacoes_modalAddEdit_ModalAddEdit_vue__["a" /* default */] },
  data: function data() {
    return {
      acao: {
        edit: false,
        create: false
      },
      editItem: {},
      fakeDelete: []
    };
  },
  watch: {},
  methods: {
    activeItem: function activeItem() {
      var lastPos = this.fakeDelete.length - 1;
      if (this.fakeDelete[lastPos].hasOwnProperty("delete")) {
        this.fakeDelete[lastPos].delete = false;
        this.fakeDelete.splice(lastPos, 1);
      }
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_conta_empresa_formEmpresa_tabNotificacoes_opcoes_Opcoes_vue__ = __webpack_require__(798);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Opcoes: __WEBPACK_IMPORTED_MODULE_2__components_conta_empresa_formEmpresa_tabNotificacoes_opcoes_Opcoes_vue__["a" /* default */] },

  props: ["notificacoes", "acao", "editItem"],
  data: function data() {
    return {
      dialog: false,
      columnName: "",
      columnPesq: false,
      titulo: "",
      showCampoEmail: false,
      showNotificacoes: true,
      btnFinishText: "",
      tipo: "",
      emailRules: [],
      obj: {
        email: "",
        resumoDiario: false,
        resumoSemanal: false,
        novoFornecedor: false,
        novoCliente: false,
        vencimentoNF: false,
        notaCancelada: false,
        nvNotaNfe: false,
        nvNotaCte: false,
        nvNotaNfse: false
      },
      auxEdit: {}
    };
  },
  watch: {
    "acao.edit": function acaoEdit(newV, oldV) {
      if (newV) {
        this.dialog = true;
        this.acao.edit = false;
        this.setTipo("edit");
      }
    },
    "acao.create": function acaoCreate(newV, oldV) {
      if (newV) {
        this.dialog = true;
        this.acao.create = false;
        this.setTipo("create");
      }
    },
    dialog: function dialog(newV, oldV) {
      if (!newV && this.tipo == "edit") {}
    }
  },
  methods: {
    setTipo: function setTipo(acao) {
      switch (acao) {
        case "edit":
          this.tipo = "edit";
          this.titulo = "Editar Notificações";
          this.btnFinishText = "Salvar";
          this.showCampoEmail = true;
          this.createCopia(this.editItem, this.obj);
          break;
        case "create":
          this.tipo = "create";
          this.showCampoEmail = true;
          this.titulo = "Cadastrar Novo E-mail";
          this.btnFinishText = "Cadastrar";
          break;
        default:
          throw new Error("Não foi possível setar AÇÃO na notificação da empresa");
      }
    },
    createCopia: function createCopia(obj, copia) {
      copia["email"] = obj["email"];
      copia["resumoDiario"] = obj["resumoDiario"];
      copia["resumoSemanal"] = obj["resumoSemanal"];
      copia["novoFornecedor"] = obj["novoFornecedor"];
      copia["novoCliente"] = obj["novoCliente"];
      copia["vencimentoNF"] = obj["vencimentoNF"];
      copia["notaCancelada"] = obj["notaCancelada"];
      copia["nvNotaNfe"] = obj["nvNotaNfe"];
      copia["nvNotaCte"] = obj["nvNotaCte"];
      copia["nvNotaNfse"] = obj["nvNotaNfse"];
    },
    verificaEmail: function verificaEmail() {
      if (this.obj.email == "") {
        if (this.emailRules.length > 0) {
          this.emailRules.pop();
        }
        this.emailRules.push(function (v) {
          return "Campo obrigatório";
        });
      }
      if (this.obj.email != "" && !/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(this.obj.email)) {
        if (this.emailRules.length > 0) {
          this.emailRules.pop();
        }
        this.emailRules.push(function (v) {
          return "Digite um e-mail válido";
        });
      }
      if (this.notificacoes.objetos && this.notificacoes.objetos.length > 0) {
        var auxThis = this;
        this.notificacoes.objetos.forEach(function (item) {
          if (item.email == auxThis.obj.email) {
            if (auxThis.emailRules.length > 0) {
              auxThis.emailRules.pop();
            }
            auxThis.emailRules.push(function (v) {
              return "E-mail já está cadastrado para está empresa.";
            });
          }
        });
      }
    },
    editarItem: function editarItem() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.editItem.email != _this.obj.email)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this.verificaEmail();

              case 3:
                if (_this.$refs.email.validate()) {
                  _this.editItem.email = _this.obj.email;
                  _this.editItem.resumoDiario = _this.obj.resumoDiario;
                  _this.editItem.resumoSemanal = _this.obj.resumoSemanal;
                  _this.editItem.novoFornecedor = _this.obj.novoFornecedor;
                  _this.editItem.novoCliente = _this.obj.novoCliente;
                  _this.editItem.vencimentoNF = _this.obj.vencimentoNF;
                  _this.editItem.notaCancelada = _this.obj.notaCancelada;
                  _this.editItem.nvNotaNfe = _this.obj.nvNotaNfe;
                  _this.editItem.nvNotaNfse = _this.obj.nvNotaNfse;
                  _this.dialog = false;
                  _this.resetObj();
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    salvarItem: function salvarItem() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.verificaEmail();

              case 2:
                if (_this2.$refs.email.validate()) {
                  _this2.notificacoes.objetos.push(_this2.obj);
                  _this2.dialog = false;
                  _this2.resetObj();
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    resetObj: function resetObj() {
      this.obj = {
        email: "",
        resumoDiario: false,
        resumoSemanal: false,
        novoFornecedor: false,
        novoCliente: false,
        vencimentoNF: false,
        notaCancelada: false,
        nvNotaNfe: false,
        nvNotaCte: false,
        nvNotaNfse: false
      };
      this.$refs.email.reset();
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['notificacoes', 'opcoes'],
  data: function data() {
    return {};
  },
  watch: {},
  methods: {}
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dataTable_RenderTableNFe_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_loggedArea_configuracoes_configuracoesAutomacao_BtnNovoImovel_BtnNovoImovel_vue__ = __webpack_require__(190);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["empresa", "alert", "conta", "IBGE"],
  components: {
    RenderTableNFe: __WEBPACK_IMPORTED_MODULE_0__components_dataTable_RenderTableNFe_vue__["default"],
    BtnNovoImovel: __WEBPACK_IMPORTED_MODULE_1__pages_loggedArea_configuracoes_configuracoesAutomacao_BtnNovoImovel_BtnNovoImovel_vue__["a" /* default */]
  },
  data: function data() {
    return {
      currentItem: "",
      sendAttTable: false,
      tabs: [{
        title: "IPTU"
      }]
    };
  },

  mounted: function mounted() {
    this.handleUfs();
  },
  updated: function updated() {},
  watch: {
    empresa: function empresa(newV, oldV) {
      if (newV._id != oldV._id) {
        var changePage = newV.servicos ? newV.servicos.robotizacao.find(function (item) {
          return item.nomeServico == "IPTU";
        }) : null;
        if (!changePage) {
          this.$router.push('/DashBoard');
          return;
        } else {
          this.handleUfs();
        }
      }
    }
  },
  computed: {},
  methods: {
    handleUfs: function handleUfs() {
      if (this.IBGE) {
        this.$store.commit('addUfArray', this.IBGE.estados);
      }
    }
  },
  beforeMount: function beforeMount() {
    // this.$nextTick(function() {});
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Conta = function Conta(admin, conta, email, gravatarProfile, id_usuario, nome, colaborador, favEmails, notificacoes, primAcesso, imagem) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Conta);

    this.admin = admin;
    this.conta = conta;
    this.email = email;
    this.gravatarProfile = gravatarProfile;
    this.id_usuario = id_usuario;
    this.nome = nome;
    this.colaborador = colaborador;
    this.favEmails = favEmails;
    this.notificacoes = notificacoes;
    this.primAcesso = primAcesso;
    this.imagem = imagem;
    this.getEmpresas = false;
    this.getLog = false;
    this.getNotificacoes = false;
    this.getNewImage = false;
};

/* harmony default export */ __webpack_exports__["a"] = (Conta);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['alert'],
  data: function data() {
    return {};
  },
  watch: {},
  mounted: function mounted() {
    this.$nextTick(function () {});
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_conta_ContaService_js__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["firstAccess", "conta", "empresa"],
  data: function data() {
    return {
      cards: [{
        id: "nfe",
        title: "NF-e:",
        subTitle: "Nota Fiscal Eletrônica",
        valor: 0,
        cor: "c_primary"
      }, {
        id: "cte",
        title: "CT-e:",
        subTitle: "Conhecimento de Transporte Eletrônico",
        valor: 0,

        cor: "c_teal"
      }, {
        id: "nfse",
        title: "NFS-e:",
        subTitle: "Nota Fiscal de Serviço Eletrônica",
        valor: 0,

        cor: "c_little-grey"
      }]
    };
  },
  created: function created() {},

  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  watch: {
    "firstAccess.buscando": function firstAccessBuscando(newV, oldV) {
      if (newV == false) {
        this.begin();
      }
    }
  },
  methods: {
    begin: function begin() {
      var _this = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_0__domain_conta_ContaService_js__["a" /* default */](this.$http);
      this.service.attPrimAcesso(this.conta.conta).then(function (resp) {
        if (resp.ok) {
          var auxConta = _this.$session.get("jwt");
          _this.conta["accessToken"] = auxConta.accessToken;
          _this.conta.primAcesso = false;
          _this.$session.set("jwt", _this.conta);
        } else {
          throw new Error('Não foi possível iniciar motor fiscal');
        }
      });
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_certificado_CertificadoService_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dataTable_RenderTableNFe_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_gravatar_GravatarService_js__ = __webpack_require__(61);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["alert", "firstAccess", "conta", "empresa"],
  components: {
    RenderTableNFe: __WEBPACK_IMPORTED_MODULE_5__components_dataTable_RenderTableNFe_vue__["default"]
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.buscaQntdCertVenc();
    });
  },
  data: function data() {
    return {
      loadingUsers: false,
      loadingCertificados: false,
      loadingContas: false,
      qntdCertVencendo: 0,
      listaDisponivel: false,
      listaCertDisponivel: false,
      listaContaDisponivel: false,
      usuarios: [],
      certificados: [],
      usuarioSelecionado: false,
      certificadoSelecionado: false,
      informacoesUsuario: {},
      informacoesCert: {},
      avatar: null
    };
  },

  watch: {
    informacoesUsuario: "randomAvatar"
  },
  computed: {
    sortDescDtLogins: function sortDescDtLogins() {
      return this.informacoesUsuario && this.informacoesUsuario.hasOwnProperty("dtLogin") ? this.informacoesUsuario.dtLogin.sort(function (a, b) {
        return a > b ? -1 : a < b ? 1 : 0;
      }) : [];
    }
  },
  methods: {

    envMail: function envMail(idCert, email) {
      var _this = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);
      return this.service.envMail(idCert, email).then(function (res) {
        console.log(res);
        if (res.status) {
          _this.alert.snackSuccess();
          _this.alert.snack.text = "E-mail enviado.";
          _this.alert.snack.show = true;
        } else {
          _this.alert.snackDanger();
          _this.alert.snack.text = "Não foi possível enviar e-mail.";
          _this.alert.snack.show = true;
        }
      });
    },
    buscaQntdCertVenc: function buscaQntdCertVenc() {
      var _this2 = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);
      return this.service.getQntdVencendo(this.conta.id_usuario).then(function (res) {
        if (res.status) {
          _this2.qntdCertVencendo = res.body.qntdCertVencendo;
        } else {
          _this2.qntdCertVencendo = 0;
        }
      });
    },
    resetUsuarios: function resetUsuarios() {
      this.loadingUsers = false;
      this.listaDisponivel = false;
      this.usuarios = [];
      this.usuarioSelecionado = false;
      this.informacoesUsuario = {};
      this.avatar = null;
    },
    resetCertificados: function resetCertificados() {
      this.loadingCertificados = false;
      this.listaCertDisponivel = false;
      this.certificados = [];
      this.certificadoSelecionado = false;
      this.informacoesCert = {};
    },
    resetContas: function resetContas() {
      this.loadingContas = false;
      this.listaContaDisponivel = false;
    },
    reset: function reset() {
      this.resetUsuarios();
      this.resetCertificados();
      this.resetContas();
    },
    getCertificados: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("Get Certificados");
                this.reset();
                this.loadingCertificados = true;
                _context.next = 5;
                return this.listaCertificados();

              case 5:
                this.certificados = _context.sent;

                this.listaCertDisponivel = true;
                this.loadingCertificados = false;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCertificados() {
        return _ref.apply(this, arguments);
      }

      return getCertificados;
    }(),
    getContas: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("Get Conta");
                this.reset();
                this.loadingContas = true;
                // this.Contaificados = await this.listaContaificados();
                this.listaContaDisponivel = true;
                this.loadingContas = false;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getContas() {
        return _ref2.apply(this, arguments);
      }

      return getContas;
    }(),

    getUsuarios: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("Get Usuarios");
                this.reset();
                this.loadingUsers = true;
                // this.usuarios = await this.listaUsuarios();
                this.listaDisponivel = true;
                this.loadingUsers = false;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getUsuarios() {
        return _ref3.apply(this, arguments);
      }

      return getUsuarios;
    }(),
    selectUsuario: function selectUsuario(usuario) {
      var _this3 = this;

      this.informacoesUsuario = {};
      setTimeout(function () {
        _this3.informacoesUsuario = usuario;
        _this3.usuarioSelecionado = true;
      }, 500);
    },

    selectCert: function selectCert(cert) {
      this.informacoesConta = {};
      this.informacoesCert = cert;
      this.certificadoSelecionado = true;
    },
    bufferToBase64: function bufferToBase64(buf) {
      var binstr = Array.prototype.map.call(buf, function (ch) {
        return String.fromCharCode(ch);
      }).join("");
      return btoa(binstr);
    },

    listaUsuarios: function listaUsuarios() {
      this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
      return this.service.relatorio(this.conta.id_usuario).then(function (res) {
        if (res.ok) {
          return res.body;
        } else {
          return [];
        }
      });
    },

    listaCertificados: function listaCertificados() {
      this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);
      return this.service.relatorio(this.conta.id_usuario).then(function (res) {
        if (res.ok) {
          return res.body;
        } else {
          return [];
        }
      });
    },
    getGravatar: function getGravatar() {
      if (this.informacoesUsuario && this.informacoesUsuario.hasOwnProperty("email")) {
        this.service = new __WEBPACK_IMPORTED_MODULE_6__domain_gravatar_GravatarService_js__["a" /* default */](this.$http);
        return this.service.getGravatar(this.informacoesUsuario.email).then(function (success) {
          if (success) {
            if (success.hasOwnProperty("thumbnailUrl")) {
              return success.thumbnailUrl + "?s=200";
            }
          }
          return undefined;
        });
      }
    },
    diffDays: function diffDays(certDate, today) {
      var timeDiff = Math.abs(certDate.getTime() - today.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays;
    },
    randomAvatar: function randomAvatar() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
          var dataImg;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!(_this4.informacoesUsuario && _this4.informacoesUsuario.hasOwnProperty("img"))) {
                    _context4.next = 5;
                    break;
                  }

                  dataImg = "data:image/jpg;base64," + _this4.bufferToBase64(_this4.informacoesUsuario.img.data);

                  _this4.avatar = "" + dataImg;
                  _context4.next = 8;
                  break;

                case 5:
                  _context4.next = 7;
                  return _this4.getGravatar();

                case 7:
                  _this4.avatar = _context4.sent;

                case 8:
                  resolve();

                case 9:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, _this4);
        }));

        return function (_x, _x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_conta_ContaService_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_ribbon_Ribbon_vue__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_stepperFechamentoMes_StepperFechamentoMes__ = __webpack_require__(821);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "empresa", "alert"],
  components: {
    Ribbon: __WEBPACK_IMPORTED_MODULE_1__components_shared_ribbon_Ribbon_vue__["a" /* default */],
    Stepper: __WEBPACK_IMPORTED_MODULE_2__components_stepperFechamentoMes_StepperFechamentoMes__["a" /* default */]
  },
  data: function data() {
    return {
      emprSelecionadas: [],
      modalEmpresas: false
    };
  },
  created: function created() {},

  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  methods: {
    handleEmpresas: function handleEmpresas() {
      var _this = this;

      if (this.emprSelecionadas.length > 0) {
        this.emprSelecionadas.map(function (item, index) {
          if (!item.razao) {
            _this.emprSelecionadas.splice(index, 1);
          }
        });
      }
    },
    remove: function remove(item) {
      var index = this.emprSelecionadas.indexOf(item);
      if (index >= 0) this.emprSelecionadas.splice(index, 1);
    },
    rmvItem: function rmvItem(item) {
      if (item) {
        var index = this.emprSelecionadas.indexOf(item);
        this.emprSelecionadas.splice(index, 1);
      }
    },

    maskCnpj: function maskCnpj(cnpj) {
      return cnpj ? cnpj.length > 11 ? cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4") : "";
    },
    begin: function begin() {}
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["mainText", "icon", "cnpjCpf"],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  computed: {
    maskCnpj: function maskCnpj() {
      return this.cnpjCpf ? this.cnpjCpf.length > 11 ? this.cnpjCpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : this.cnpjCpf.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4") : "";
    },
    adptaTextCpfCnpj: function adptaTextCpfCnpj() {
      return this.cnpjCpf.length > 11 ? 'CNPJ' : 'CPF';
    }
  },
  watch: {},
  methods: {}
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["empresa", "conta", "alert"],
  data: function data() {
    return {
      e6: 0,
      active: "",
      model: [],
      search: null,
      selectedAno: "",
      selectedMes: "",
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      items: [{ header: "Selecione uma opção ou digite um e-mail" }],
      nonce: 1,
      editing: null,
      mailDelete: "",
      listaMeses: [],
      dialogDelete: false,
      meses: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      activeMes: "",
      nfes_lista: [{ id: "recebida", text: "Recebidas", value: "" }, { id: "emitida", text: "Emitidas", value: "" }, { id: "pdf", text: "Incluir PDF", value: "" }],
      nfes_selected: [],
      ctes_lista: [{ id: "tomador", text: "Tomador", value: "" }, { id: "naoTomador", text: "Não Tomador", value: "" }, { id: "pdf", text: "Incluir PDF", value: "" }],
      ctes_selected: [],
      nfses_lista: [{ id: "recebida", text: "Recebidas", value: "" }, { id: "emitida", text: "Emitidas", value: "" }, { id: "pdf", text: "Incluir PDF", value: "" }],
      nfses_selected: []
    };
  },

  watch: {
    model: function model(val, prev) {
      var _this = this;

      if (val.length === prev.length) return;
      this.model = val.map(function (v) {
        if (v != undefined && v.text != undefined) {
          return v;
        }
        if (typeof v === "string" && /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v)) {
          v = {
            text: v,
            color: _this.colors[_this.nonce - 1]
          };
          _this.items.push(v);

          _this.nonce++;
          return v;
        }
      });
    },

    e6: function e6(oldV, newV) {
      if (newV != 1) {
        this.e6 = 1;
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.active = this.setActiveAno;
      this.activeMes = this.setActiveMes;

      if (this.conta.favEmails && this.conta.favEmails.length > 0) {
        var favMails = this.conta.favEmails.slice();
        for (var i = 0; i < favMails.length; i++) {
          var mail = {};
          mail["text"] = favMails[i];
          mail["color"] = this.colors[Math.floor(Math.random() * this.colors.length)];
          this.items.push(mail);
        }
      } else if (!this.conta.favEmail) {
        this.model.push(obj);
        this.items.push(obj);
        obj["text"] = this.conta.email;
        obj["color"] = "info";
      }
    });
  },
  computed: {
    geraListaMeses: function geraListaMeses() {
      var listaMeses = [];
      if (this.selectedAno < parseInt(new Date().getFullYear())) {
        listaMeses = this.meses.slice();
      } else {
        listaMeses = this.meses.slice(0, new Date().getMonth() + 1);
      }
      return listaMeses;
    },
    setActiveMes: function setActiveMes() {
      var data = new Date().getMonth();
      this.selectedMes = data;
      var meses = this.geraListaMeses;
      return "tab-" + meses[data];
    },
    setActiveAno: function setActiveAno() {
      var data = new Date().getFullYear();
      this.selectedAno = data;
      return "tab-" + data;
    },
    geraListaAno: function geraListaAno() {
      var ano = parseInt(new Date().getFullYear());
      var listaAno = [];
      for (var i = 2018; i <= ano; i++) {
        listaAno.push(i);
      }
      return listaAno;
    }
  },
  methods: {
    handleEmails: function handleEmails() {
      var _this2 = this;

      if (this.model.length > 0) {
        this.model.map(function (item, index) {
          if (!item.text) {
            if (typeof item !== "string" || !/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(item)) {
              _this2.model.splice(index, 1);
            }
          }
        });
      }
    },
    filter: function filter(item, queryText, itemText) {
      if (item.header) return false;

      var hasValue = function hasValue(val) {
        return val != null ? val : "";
      };

      var text = hasValue(itemText);
      var query = hasValue(queryText);

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
    },

    downloadFechamento: function downloadFechamento(emails, emprsCnpj) {
      var _this3 = this;

      if (!emprsCnpj || emprsCnpj.length == 0) {
        this.alert.resetAlert();
        this.alert.snack.text = "Necessário informar ao menos uma empresa para o Fechamento Mensal.";
        this.alert.snack.show = true;
        return;
      }
      if (this.nfes_selected.length == 0 && this.ctes_selected.length == 0 && this.nfses_selected.length == 0) {
        this.alert.resetAlert();
        this.alert.snack.text = "Necessário especificar informação de ao menos um documento fiscal.";
        this.alert.snack.show = true;
        return;
      }
      if (emails.length < 1) {
        this.alert.resetAlert();
        this.alert.snack.text = "Necessário informar ao menos um E-mail.";
        this.alert.snack.show = true;
        return;
      }
      //emails e emprsCnpj precisam ser array.
      var objEnvio = {
        cpfsCnpjs: emprsCnpj.map(function (item) {
          return item.cnpj;
        }),
        nfes: this.nfes_selected.length > 0 ? this.nfes_selected.map(function (item) {
          return item.id;
        }) : [],
        ctes: this.ctes_selected.length > 0 ? this.ctes_selected.map(function (item) {
          return item.id;
        }) : [],
        nfses: this.nfses_selected.length > 0 ? this.nfses_selected.map(function (item) {
          return item.id;
        }) : [],
        data: this.selectedMes + "-" + this.selectedAno,
        emails: emails
      };
      this.service = new __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
      this.alert.resetAlert();
      // this.alert.snack.text = "Processando os documentos";
      // this.alert.snack.show = true;
      // this.alert.snack.time = 4000;
      this.activeGlobalLoader();
      this.service.fechamentoMensal(objEnvio).then(function (res) {
        if (res.status == 200) {
          _this3.alert.resetAlert();
          _this3.alert.snack.text = "Processando o Fechamento Mensal, notificaremos por e-mail e na central do Motor Fiscal assim que concluido!";
          _this3.alert.snack.show = true;
          _this3.alert.snack.time = 8000;
          _this3.desactiveGlobalLoader();
        } else {
          _this3.alert.snackDanger();
          _this3.alert.snack.text = "Motor Fiscal não conseguiu gerar o fechamento mensal";
          _this3.alert.snack.show = true;
          _this3.alert.snack.time = 4000;
          _this3.desactiveGlobalLoader();
        }
      });
    },
    activeGlobalLoader: function activeGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    edit: function edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.auxEmail = item.text;
        this.index = index;
      } else {
        if (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(this.editing.text) == false) {
          item.text = this.auxEmail;
        }
        this.auxEmail = "";
        this.editing = null;
        this.index = -1;
      }
    },

    desactiveGlobalLoader: function desactiveGlobalLoader() {
      var appDom = document.querySelector("#app");
      var icon = document.querySelector("#app main +i.c_custom-loader");
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    middleDel: function middleDel(item) {
      this.dialogDelete = true;
      this.mailDelete = item;
    },
    delMail: function delMail(action) {
      this.dialogDelete = false;
      if (action) {
        this.items.splice(this.items.indexOf(this.mailDelete), 1);
        this.saveMailsFavoritos();
      }
      this.mailDelete = undefined;
    },

    saveMailsFavoritos: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var favItems, i, userFavMails;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                favItems = [];

                for (i = 1; i < this.items.length; i++) {
                  favItems.push(this.items[i].text);
                }
                userFavMails = {
                  favEmails: favItems
                };

                this.conta["favEmails"] = favItems.slice();
                this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
                this.service.editar(userFavMails, this.conta.id_usuario);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveMailsFavoritos() {
        return _ref.apply(this, arguments);
      }

      return saveMailsFavoritos;
    }()
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_loggedArea_loja_lojaItem_LojaItem_vue__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_loja_LojaService__ = __webpack_require__(283);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["conta", "empresa", "alert"],
  components: { LojaItem: __WEBPACK_IMPORTED_MODULE_0__pages_loggedArea_loja_lojaItem_LojaItem_vue__["a" /* default */] },
  mounted: function mounted() {
    var service = new __WEBPACK_IMPORTED_MODULE_1__domain_loja_LojaService__["a" /* default */]();
    var lojaItems = service.getItem();
    this.items = lojaItems;
  },
  data: function data() {
    return {
      items: []
    };
  },

  watch: {
    empresa: function empresa(newV, oldV) {
      if (newV !== oldV) {
        this.$store.commit('addOpenStore', true);
      }
    }
  },
  computed: {
    openStore: function openStore() {
      return this.$store.getters.openStore;
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_loja_LojaService__ = __webpack_require__(283);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["item", "conta", "empresa"],
    methods: {
        handleClickButton: function handleClickButton() {
            if (this.item.buttonValue === 'Teste grátis' && this.status !== 'Em andamento') {
                this.status = 'Em andamento';
                var service = new __WEBPACK_IMPORTED_MODULE_0__domain_loja_LojaService__["a" /* default */]();
                service.sendEmail(this.conta.id_usuario, this.empresa.cnpj, this.item.id);
            }
        }
    },
    data: function data() {
        return {
            status: this.item.buttonValue
        };
    },

    computed: {
        icon: function icon() {
            if (this.status === 'Em andamento') {
                return 'schedule';
            } else if (this.status === 'Adquirido') {
                return 'done';
            } else {
                return 'mdi-timer-outline';
            }
        }
    }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);







var LojaService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LojaService, _CommonService);

    function LojaService() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LojaService);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LojaService.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LojaService)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LojaService, [{
        key: 'getItem',
        value: function getItem() {
            return [{
                id: 'situacao_fiscal',
                name: 'Sitação Fiscal',
                description: 'Consulte automaticamente a situação fiscal da sua empresa.',
                buttonValue: 'Adquirido',
                price: '59,90',
                image: "situacao_fiscal.png",
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=195s'
            }, {
                id: 'extrato_dctf',
                name: 'Extrato DCTF',
                description: 'Analise o extrato da DCTF sem a necessidade de acessar o site da receita federal',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'extrato_dctf.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=260s'
            }, {
                id: 'relação_de_darfs_pagos',
                name: 'Relação de Darfs Pagos',
                description: 'Exporte a lista de Darfs pagos sem a necessidade de acessar a receita federal.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'relação_de_darfs_pagos.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=320s'
            }, {
                id: 'emails_caixa_postal',
                name: 'E-mails Caixa Postal',
                description: 'Recebe os emails enviados pela receita federal direto do Motor Fiscal.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'emails_caixa_postal.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=382s'
            }, {
                id: 'processos',
                name: 'Processos',
                description: 'Consulte os processos que estão andamento na receita federal.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'processos.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=439s'
            }, {
                id: 'cnd_federal',
                name: 'CND Federal',
                description: 'Certifique-se de que sua empresas não contem nenhum débito com a receita federal.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'cnd_federal.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=503s'
            }, {
                id: 'relação_de_nfs',
                name: 'Relação de NFs',
                description: 'Visualize as notas de serviços tomados emitidas contra o seu CNPJ de forma automatica.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'relação_de_nfs.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=579s'
            }, {
                id: 'guias',
                name: 'Guias',
                description: 'Agende a geração de guias municipais e evite retrabalho.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'guias.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=710s'
            }, {
                id: 'cnd_municipal',
                name: 'CND Municipal',
                description: 'Verifique se sua empresa possui débitos com a prefeitura de forma automática.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'cnd_municipal.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=800s'
            }, {
                id: 'iptu',
                name: 'IPTU',
                description: 'Baixe de forma automática todas as guias de IPTU do seu imóvel.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'iptu.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=829s'
            }];
        }
    }, {
        key: 'sendEmail',
        value: function sendEmail(conta, cnpj, item) {
            console.log('Sending email...');
            console.log(conta);
            console.log(cnpj);
            console.log(item);
        }
    }]);

    return LojaService;
}(__WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LojaService);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_conta_Conta__ = __webpack_require__(274);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    conta: this.conta
  },
  mounted: function mounted() {
    this.vOcrUpdate();
    this.getEstados;
    this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
  },
  data: function data() {
    var _this = this;

    return {
      estado: '',
      cidade: '',
      estadoTomador: '',
      cidadeTomador: '',
      arrayEstados: [],
      arrayMunicipiosPrestador: [],
      arrayMunicipiosTomador: [],
      mask: { cnpjTomador: "", cnpjPrestador: "" },
      status_ocr: 'pendente',
      successMessage: '',
      successMessageDuplicidade: '',
      errorMessage: '',
      desabilita_campo: true,
      isBtnLoading: false,
      isFileLoading: false,
      dataIni: '',
      dataFim: '',
      cnpj: '',
      verificado: '',
      ocrFile: '',
      isLoading: false,
      emailInvalido: false,
      dialog: false,
      search: '',
      pagination: {
        rowsPerPage: 10,
        totalItems: 0
      },
      selected: [],
      headers: [{ text: 'Ações', align: 'center', sortable: false, value: '' }, { text: 'Verificado', align: 'center', value: 'verificadoOcr' }, { text: 'Status OCR', align: 'center', value: 'ocr_status' }, { text: 'Empresa Upload', align: 'center', value: 'empresa.razao' }, { text: 'Número', align: 'center', value: 'numeroNfe' }, { text: 'Código Verificação', align: 'center', value: 'codVerificacao' }, { text: 'CNPJ Tomador', align: 'center', value: 'cnpjCpfTomador' }, { text: 'Razão Tomador', align: 'center', value: 'razaoTomador' }, { text: 'Data Emissão', align: 'center', value: 'dtEmissaoNfe' }, { text: 'Log OCR', align: 'center', value: 'ocr_log' }, { text: 'CNPJ Prestador', align: 'center', value: 'cnpjCpfPrestador' }, { text: 'Razão Prestador', align: 'center', value: 'razaoPrestador' }, { text: 'Data de criação', align: 'center', value: 'createdAt' }, { text: 'Código de Serviço', align: 'center', value: 'codServico' }, { text: 'Percentual ISS', align: 'center', value: 'aliqServico' }, { text: 'Valor ISS', align: 'center', value: 'ISS' }, { text: 'ISS Retido', align: 'center', value: 'ISSRetido' }, { text: 'ID', align: 'center', value: '_id' }, { text: 'Nome do Municipio Prestador', align: 'center', value: 'nome_municipio' }, { text: 'UF Prestador', align: 'center', value: 'UFPrestador' }, { text: 'Data de Processamento', align: 'center', value: 'dt_processamento' }],
      body: [],
      editedItem: {},
      editedIndex: -1,
      docPrestador: false,
      docTomador: false,
      cpfRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (cpf) {
        _this.cnpjCpfInvalido(cpf, false);
        var sum = void 0,
            rest = void 0;
        if (cpf === undefined || cpf === null || cpf.trim().length === 0 || cpf === "00000000000" || cpf === "11111111111" || cpf === "22222222222" || cpf === "33333333333" || cpf === "44444444444" || cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777" || cpf === "88888888888" || cpf === "99999999999") {
          return "CPF inválido";
        }
        cpf = cpf.replace(".", "").replace(".", "").replace("-", "");

        sum = 0;
        for (var i = 1; i <= 9; i++) {
          sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        rest = sum * 10 % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(9, 10))) {
          return "CPF inválido";
        }

        sum = 0;
        for (var _i = 1; _i <= 10; _i++) {
          sum = sum + parseInt(cpf.substring(_i - 1, _i)) * (12 - _i);
        }
        rest = sum * 10 % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(10, 11))) {
          return "CPF inválido";
        }

        _this.cnpjCpfInvalido(cpf, true);
        return true;
      }],

      cnpjRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        _this.cnpjCpfInvalido(v, false);

        if (v == null) {
          return false;
        }
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

        if (/0{14}/.test(v)) return "CNPJ inválido";

        for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]) {}
        if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]) {}
        if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        _this.cnpjCpfInvalido(v, true);

        return true;
      }]
    };
  },

  computed: {
    pages: function pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
    buscaReceitaPrestador: function buscaReceitaPrestador() {
      var _this2 = this;

      if (this.editedItem.cnpjCpfPrestador) {
        this.service.getAPIReceita(this.editedItem.cnpjCpfPrestador).then(function (success) {
          if (success && success.status == 200 && success.body.status != "ERROR") {
            _this2.editedItem.razaoPrestador = success.body.nome;
            _this2.editedItem.enderecoPrestadorLogradouro = success.body.logradouro;
            _this2.editedItem.enderecoPrestadorCEP = success.body.cep;
            _this2.editedItem.enderecoPrestadorBairro = success.body.bairro;
            _this2.editedItem.inscPrestador = success.body.inscricao_municipal;
            _this2.editedItem.inscriEsPrestador = success.body.inscricao_estadual;
            _this2.editedItem.telefonePrestador = success.body.telefone;
            _this2.editedItem.emailPrestador = success.body.email;
            _this2.editedItem.enderecoPrestadorComplementoEndereco = success.body.complemento;

            var auxEstado = void 0;
            _this2.uf = _this2.arrayEstados.forEach(function (item) {
              if (item.sigla == success.body.uf) {
                auxEstado = item;
              }
            });
            _this2.estado = auxEstado;
            _this2.getMunicipiosPrestador();
            _this2.cidade = success.body.municipio;
          }
        });
      }
    },
    buscaReceitaTomador: function buscaReceitaTomador() {
      var _this3 = this;

      if (this.editedItem.cnpjCpfTomador) {
        this.service.getAPIReceita(this.editedItem.cnpjCpfTomador).then(function (success) {
          if (success && success.status == 200 && success.body.status != "ERROR") {
            _this3.editedItem.razaoTomador = success.body.nome;
            _this3.editedItem.enderecoTomadorLogradouro = success.body.logradouro;
            _this3.editedItem.enderecoTomadorCEP = success.body.cep;
            _this3.editedItem.enderecoTomadorBairro = success.body.bairro;
            _this3.editedItem.inscTomador = success.body.inscricao_municipal;
            _this3.editedItem.inscriEsTomador = success.body.inscricao_estadual;
            _this3.editedItem.telefoneTomador = success.body.telefone;
            _this3.editedItem.emailTomador = success.body.email;
            _this3.editedItem.enderecoTomadorComplementoEndereco = success.body.complemento;

            var auxEstado = void 0;
            _this3.uf = _this3.arrayEstados.forEach(function (item) {
              if (item.sigla == success.body.uf) {
                auxEstado = item;
              }
            });
            _this3.estadoTomador = auxEstado;
            _this3.getMunicipiosTomador();
            _this3.cidadeTomador = success.body.municipio;
          }
        });
      }
    },

    getEstados: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.arrayMunicipiosPrestador = [];
                this.arrayMunicipiosTomador = [];
                this.resource = this.$resource("https://servicodados.ibge.gov.br/api/v1/localidades/estados");
                this.resource.query().then(function (success) {

                  _this4.arrayMunicipiosPrestador = [];
                  _this4.arrayMunicipiosTomador = [];
                  _this4.arrayEstados = success.body;

                  return success.body;
                }, function (failed) {
                  _this4.arrayEstados = [{ "id": 11, "sigla": "RO", "nome": "Rondônia", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 12, "sigla": "AC", "nome": "Acre", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 13, "sigla": "AM", "nome": "Amazonas", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 14, "sigla": "RR", "nome": "Roraima", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 15, "sigla": "PA", "nome": "Pará", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 16, "sigla": "AP", "nome": "Amapá", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 17, "sigla": "TO", "nome": "Tocantins", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 21, "sigla": "MA", "nome": "Maranhão", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 22, "sigla": "PI", "nome": "Piauí", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 23, "sigla": "CE", "nome": "Ceará", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 24, "sigla": "RN", "nome": "Rio Grande do Norte", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 25, "sigla": "PB", "nome": "Paraíba", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 26, "sigla": "PE", "nome": "Pernambuco", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 27, "sigla": "AL", "nome": "Alagoas", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 28, "sigla": "SE", "nome": "Sergipe", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 29, "sigla": "BA", "nome": "Bahia", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 31, "sigla": "MG", "nome": "Minas Gerais", "regiao": { "id": 3, "sigla": "SE", "nome": "Sudeste" } }, { "id": 32, "sigla": "ES", "nome": "Espírito Santo", "regiao": { "id": 3, "sigla": "SE", "nome": "Sudeste" } }, { "id": 33, "sigla": "RJ", "nome": "Rio de Janeiro", "regiao": { "id": 3, "sigla": "SE", "nome": "Sudeste" } }, { "id": 35, "sigla": "SP", "nome": "São Paulo", "regiao": { "id": 3, "sigla": "SE", "nome": "Sudeste" } }, { "id": 41, "sigla": "PR", "nome": "Paraná", "regiao": { "id": 4, "sigla": "S", "nome": "Sul" } }, { "id": 42, "sigla": "SC", "nome": "Santa Catarina", "regiao": { "id": 4, "sigla": "S", "nome": "Sul" } }, { "id": 43, "sigla": "RS", "nome": "Rio Grande do Sul", "regiao": { "id": 4, "sigla": "S", "nome": "Sul" } }, { "id": 50, "sigla": "MS", "nome": "Mato Grosso do Sul", "regiao": { "id": 5, "sigla": "CO", "nome": "Centro-Oeste" } }, { "id": 51, "sigla": "MT", "nome": "Mato Grosso", "regiao": { "id": 5, "sigla": "CO", "nome": "Centro-Oeste" } }, { "id": 52, "sigla": "GO", "nome": "Goiás", "regiao": { "id": 5, "sigla": "CO", "nome": "Centro-Oeste" } }, { "id": 53, "sigla": "DF", "nome": "Distrito Federal", "regiao": { "id": 5, "sigla": "CO", "nome": "Centro-Oeste" } }];
                  return _this4.arrayEstados;
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEstados() {
        return _ref.apply(this, arguments);
      }

      return getEstados;
    }(),
    validationRules: function validationRules() {
      return [function (v) {
        return !!v || "Campo obrigatório";
      }];
    },
    validaEmail: function validaEmail() {
      var _this5 = this;

      var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return [function (v) {
        if (v && !regex.test(v)) {
          _this5.emailInvalido = true;
          return "Email Inválido!";
        }
        _this5.emailInvalido = false;
        return true;
      }];
    }
  },
  methods: {
    cnpjCpfInvalido: function cnpjCpfInvalido(v, booleanValue) {
      if (v === this.editedItem.cnpjCpfPrestador) {
        this.docPrestador = booleanValue;
      }

      if (v === this.editedItem.cnpjCpfTomador) {
        this.docTomador = booleanValue;
      }
    },
    getMunicipiosTomador: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this6 = this;

        var codMun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.estadoTomador) {
                  _context2.next = 5;
                  break;
                }

                this.resource = this.$resource("https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + this.estadoTomador.id + "/municipios");
                this.resource.query().then(function (success) {
                  if (codMun) {
                    if (success.body.length) {
                      for (var i in success.body) {
                        if (success.body[i].id == codMun) {
                          _this6.cidadeTomador = success.body[i];
                          break;
                        }
                      }
                    }
                  }
                  _this6.arrayMunicipiosTomador = success.body;
                }, function (failed) {
                  _this6.arrayMunicipiosTomador = [];
                });
                _context2.next = 6;
                break;

              case 5:
                return _context2.abrupt("return");

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMunicipiosTomador() {
        return _ref2.apply(this, arguments);
      }

      return getMunicipiosTomador;
    }(),
    getMunicipiosPrestador: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this7 = this;

        var codMun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.estado) {
                  _context3.next = 5;
                  break;
                }

                this.resource = this.$resource("https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + this.estado.id + "/municipios");
                this.resource.query().then(function (success) {
                  if (codMun && codMun != 'None') {
                    if (success.body.length) {
                      for (var i in success.body) {
                        if (success.body[i].id == codMun) {
                          _this7.cidade = success.body[i];
                          break;
                        }
                      }
                    }
                  } else if (_this7.cidade) {
                    if (success.body.length) {
                      for (var j in success.body) {
                        if (success.body[j].nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9ÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÑÕÄËÏÖÜÇ]/ig, "") == _this7.cidade.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9ÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÑÕÄËÏÖÜÇ]/ig, "")) {
                          _this7.cidade = success.body[j];
                          break;
                        }
                      }
                    }
                  }
                  _this7.arrayMunicipiosPrestador = success.body;
                  _this7.regra_verifica_duplicidade();
                }, function (failed) {
                  _this7.arrayMunicipiosPrestador = [];
                });
                _context3.next = 6;
                break;

              case 5:
                return _context3.abrupt("return");

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMunicipiosPrestador() {
        return _ref3.apply(this, arguments);
      }

      return getMunicipiosPrestador;
    }(),

    regra_verifica_duplicidade: function regra_verifica_duplicidade() {
      console.log('entrou');
      if (!this.docPrestador || !this.cidade || !this.editedItem.numeroNfe || !this.editedItem.codVerificacao) {
        this.desabilita_campo = true;
      } else {
        // this.desabilita_campo = false
        this.VeriricaDuplicidade();
      }
    },
    vOcrUpdate: function vOcrUpdate() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var verified, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                verified = _this8.verificado ? _this8.verificado === 'Sim' ? true : false : '';

                _this8.isLoading = true;
                _context4.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["c" /* getNfseOcr */])(_this8.dataIni, _this8.dataFim, _this8.cnpj, verified, _this8.status_ocr);

              case 4:
                response = _context4.sent;

                if (response) {
                  _this8.body = response.nfse;
                  _this8.pagination.totalItems = response.nfse.length;
                  _this8.isLoading = false;
                } else {
                  _this8.isLoading = false;
                  alert('Erro ao buscar as notas.');
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    vOcrSevenDays: function vOcrSevenDays() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var verified, days, date, last, day, month, year, dtIni, dtFim, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                verified = _this9.verificado ? _this9.verificado === 'Sim' ? true : false : '';

                _this9.isLoading = true;
                days = 7;
                date = new Date();
                last = new Date(date.getTime() - days * 24 * 60 * 60 * 1000);
                day = last.getDate();
                month = last.getMonth() + 1;
                year = last.getFullYear();
                dtIni = (day && String(day).length === 1 ? '0' + day : day) + "-" + month + "-" + year;
                dtFim = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
                _context5.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["c" /* getNfseOcr */])(dtIni, dtFim, _this9.cnpj, verified, _this9.status_ocr);

              case 12:
                response = _context5.sent;


                if (response) {
                  _this9.body = response.nfse;
                  _this9.pagination.totalItems = response.nfse.length;
                  _this9.isLoading = false;
                } else {
                  _this9.isLoading = false;
                  alert('Erro ao buscar as notas.');
                }

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    vOcrCurrentMonth: function vOcrCurrentMonth() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var verified, date, dtIni, dtFim, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                verified = _this10.verificado ? _this10.verificado === 'Sim' ? true : false : '';

                _this10.isLoading = true;
                date = new Date();
                dtIni = "01-" + (date.getMonth() + 1) + "-" + date.getFullYear();
                dtFim = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
                _context6.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["c" /* getNfseOcr */])(dtIni, dtFim, _this10.cnpj, verified, _this10.status_ocr);

              case 7:
                response = _context6.sent;


                if (response) {
                  _this10.body = response.nfse;
                  _this10.pagination.totalItems = response.nfse.length;
                  _this10.isLoading = false;
                } else {
                  _this10.isLoading = false;
                  alert('Erro ao buscar as notas.');
                }

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this10);
      }))();
    },
    vOcrLastMonth: function vOcrLastMonth() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var verified, date, lastDay, dtIni, dtFim, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                verified = _this11.verificado ? _this11.verificado === 'Sim' ? true : false : '';

                _this11.isLoading = true;
                date = new Date();
                lastDay = new Date(2008, date.getMonth(), 0);
                dtIni = "01-" + date.getMonth() + "-" + date.getFullYear();
                dtFim = lastDay.getDate().toString() + "-" + date.getMonth() + "-" + date.getFullYear();
                _context7.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["c" /* getNfseOcr */])(dtIni, dtFim, _this11.cnpj, verified, _this11.status_ocr);

              case 8:
                response = _context7.sent;


                if (response) {
                  _this11.body = response.nfse;
                  _this11.pagination.totalItems = response.nfse.length;
                  _this11.isLoading = false;
                } else {
                  _this11.isLoading = false;
                  alert('Erro ao buscar as notas.');
                }

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this11);
      }))();
    },
    vOcrOpenFile: function vOcrOpenFile(item) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response, i, _i2;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log(item);
                _this12.isFileLoading = true;
                _this12.cidade = '';
                _this12.estado = '';
                _this12.estadoTomador = '';
                _this12.cidadeTomador = '';

                if (!(!item || !item.pathPdf)) {
                  _context8.next = 10;
                  break;
                }

                alert('Arquivo não encontrado');
                _this12.isFileLoading = false;
                return _context8.abrupt("return");

              case 10:
                _context8.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["b" /* getFileOcr */])(item._id);

              case 12:
                response = _context8.sent;

                if (!response) {
                  _context8.next = 55;
                  break;
                }

                _this12.ocrFile = response.pdfBase64.conteudo;
                _this12.editedIndex = _this12.body.indexOf(item);
                _this12.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
                _this12.editedItem.enderecoPrestadorNumeroEndereco = item.enderecoPrestador && item.enderecoPrestador.NumeroEndereco ? item.enderecoPrestador.NumeroEndereco : '';
                _this12.editedItem.enderecoPrestadorTipoLogradouro = item.enderecoPrestador && item.enderecoPrestador.TipoLogradouro ? item.enderecoPrestador.TipoLogradouro : '';
                _this12.editedItem.enderecoPrestadorLogradouro = item.enderecoPrestador && item.enderecoPrestador.Logradouro ? item.enderecoPrestador.Logradouro : '';
                _this12.editedItem.enderecoPrestadorComplementoEndereco = item.enderecoPrestador && item.enderecoPrestador.ComplementoEndereco ? item.enderecoPrestador.ComplementoEndereco : '';
                _this12.editedItem.enderecoPrestadorBairro = item.enderecoPrestador && item.enderecoPrestador.Bairro ? item.enderecoPrestador.Bairro : '';
                _this12.editedItem.enderecoPrestadorCEP = item.enderecoPrestador && item.enderecoPrestador.CEP ? item.enderecoPrestador.CEP : '';

                _this12.editedItem.enderecoTomadorTipoLogradouro = item.enderecoTomador && item.enderecoTomador.TipoLogradouro ? item.enderecoTomador.TipoLogradouro : '';
                _this12.editedItem.enderecoTomadorNumeroEndereco = item.enderecoTomador && item.enderecoTomador.NumeroEndereco ? item.enderecoTomador.NumeroEndereco : '';
                _this12.editedItem.enderecoTomadorBairro = item.enderecoTomador && item.enderecoTomador.Bairro ? item.enderecoTomador.Bairro : '';
                _this12.editedItem.enderecoTomadorLogradouro = item.enderecoTomador && item.enderecoTomador.Logradouro ? item.enderecoTomador.Logradouro : '';
                _this12.editedItem.enderecoTomadorComplementoEndereco = item.enderecoTomador && item.enderecoTomador.ComplementoEndereco ? item.enderecoTomador.ComplementoEndereco : '';
                _this12.editedItem.enderecoTomadorCEP = item.enderecoTomador && item.enderecoTomador.CEP ? item.enderecoTomador.CEP : '';

                if (_this12.editedItem && _this12.editedItem.cnpjCpfPrestador && _this12.editedItem.cnpjCpfPrestador.length > 11) {
                  _this12.mask.cnpjPrestador = "##.###.###/####-##";
                } else if (_this12.editedItem && !_this12.editedItem.cnpjCpfPrestador) {
                  _this12.mask.cnpjPrestador = "##.###.###/####-##";
                } else {
                  _this12.mask.cnpjPrestador = "###.###.###-##";
                }

                if (_this12.editedItem && _this12.editedItem.cnpjCpfTomador && _this12.editedItem.cnpjCpfTomador.length > 11) {
                  _this12.mask.cnpjTomador = "##.###.###/####-##";
                } else if (_this12.editedItem && !_this12.editedItem.cnpjCpfTomador) {
                  _this12.mask.cnpjTomador = "##.###.###/####-##";
                } else {
                  _this12.mask.cnpjTomador = "###.###.###-##";
                }

                _context8.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this12.arrayEstados);

              case 32:
                if ((_context8.t1 = _context8.t0()).done) {
                  _context8.next = 40;
                  break;
                }

                i = _context8.t1.value;

                if (!(_this12.arrayEstados[i].sigla === _this12.editedItem.UFPrestador)) {
                  _context8.next = 38;
                  break;
                }

                _this12.estado = _this12.arrayEstados[i];
                _this12.getMunicipiosPrestador(_this12.editedItem.codMun);
                return _context8.abrupt("break", 40);

              case 38:
                _context8.next = 32;
                break;

              case 40:
                if (!(_this12.editedItem.enderecoTomador && _this12.editedItem.enderecoTomador.UF)) {
                  _context8.next = 50;
                  break;
                }

                _context8.t2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this12.arrayEstados);

              case 42:
                if ((_context8.t3 = _context8.t2()).done) {
                  _context8.next = 50;
                  break;
                }

                _i2 = _context8.t3.value;

                if (!(_this12.arrayEstados[_i2].sigla === _this12.editedItem.enderecoTomador.UF)) {
                  _context8.next = 48;
                  break;
                }

                _this12.estadoTomador = _this12.arrayEstados[_i2];

                _this12.getMunicipiosTomador(_this12.editedItem.enderecoTomador.codMun);
                return _context8.abrupt("break", 50);

              case 48:
                _context8.next = 42;
                break;

              case 50:

                _this12.dialog = true;
                _this12.isFileLoading = false;
                if (response.pdfBase64.status == 'falha') {
                  alert(response.pdfBase64.mensagem);
                }

                _context8.next = 57;
                break;

              case 55:
                _this12.isFileLoading = false;
                alert('Erro ao abrir a nota.');

              case 57:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this12);
      }))();
    },
    VeriricaDuplicidade: function VeriricaDuplicidade() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var auxList, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this13.isBtnLoading = true;
                auxList = _this13.body;
                _context9.next = 4;
                return _this13.handleFields();

              case 4:
                _context9.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["e" /* verifyDuplicate */])(_this13.editedItem.numeroNfe, _this13.editedItem.codVerificacao, _this13.editedItem.cnpjCpfPrestador, _this13.editedItem.codMun, _this13.editedItem._id, _this13.conta.id_usuario);

              case 6:
                response = _context9.sent;


                if (response && response.MESSAGE !== 'NOTA SEM DUPLICIDADE') {
                  auxList[_this13.editedIndex] = _this13.editedItem;

                  if (response.STATUS === 'Duplicada') {
                    auxList[_this13.editedIndex].ocr_status = "Duplicada";
                  }

                  if (response.STATUS === 'Falha') {
                    auxList[_this13.editedIndex].ocr_status = "Falha";
                  }

                  auxList[_this13.editedIndex].verificadoOcr = true;
                  _this13.body = [];

                  setTimeout(function () {
                    _this13.body = auxList;
                    _this13.dialog = false;
                    _this13.isBtnLoading = false;
                    _this13.errorMessage = 'Nota Existente no motor "Duplicada"!';
                    setTimeout(function () {
                      _this13.errorMessage = '';
                    }, 6000);
                  }, 2000);
                } else {
                  _this13.isBtnLoading = false;
                  _this13.desabilita_campo = false;

                  _this13.successMessageDuplicidade = 'Nota não existente no motor!';
                  setTimeout(function () {
                    _this13.successMessageDuplicidade = '';
                  }, 6000);
                }

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this13);
      }))();
    },
    vOcrSave: function vOcrSave() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var auxList, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!_this14.editedItem.emailInvalido) {
                  _context10.next = 3;
                  break;
                }

                alert('Informe um E-mail válido.');
                return _context10.abrupt("return");

              case 3:
                _this14.isBtnLoading = true;
                auxList = _this14.body;
                _context10.next = 7;
                return _this14.handleFields();

              case 7:
                _context10.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["d" /* saveOcr */])(_this14.editedItem, _this14.conta.id_usuario);

              case 9:
                response = _context10.sent;


                if (response && response.STATUS) {
                  auxList[_this14.editedIndex] = _this14.editedItem;

                  if (response.STATUS === 'Duplicada') {
                    auxList[_this14.editedIndex].ocr_status = "Duplicada";
                  }

                  if (response.STATUS === 'Falha') {
                    auxList[_this14.editedIndex].ocr_status = "Falha";
                  }

                  auxList[_this14.editedIndex].verificadoOcr = true;
                  _this14.body = [];

                  setTimeout(function () {
                    _this14.body = auxList;
                    _this14.dialog = false;
                    _this14.isBtnLoading = false;
                    _this14.successMessage = 'NFSe salva!';
                    setTimeout(function () {
                      _this14.successMessage = '';
                    }, 3000);
                  }, 500);
                } else {
                  _this14.isBtnLoading = false;
                  alert('Erro ao salvar.');
                }

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this14);
      }))();
    },
    handleFields: function handleFields() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this15.editedItem.codVerificacao = _this15.editedItem.codVerificacao ? _this15.editedItem.codVerificacao.toUpperCase() : '';
                _this15.editedItem.serie = _this15.editedItem.serie ? _this15.editedItem.serie : '';
                _this15.editedItem.codMun = _this15.cidade && _this15.cidade.id ? _this15.cidade.id : '';
                _this15.editedItem.cidade = _this15.cidade && _this15.cidade.nome ? _this15.cidade.nome : '';
                _this15.editedItem.UFPrestador = _this15.estado && _this15.estado.sigla ? _this15.estado.sigla : '';
                _this15.editedItem.municipio = _this15.cidadeTomador && _this15.cidadeTomador.nome ? _this15.cidadeTomador.nome : '';
                _this15.editedItem.estado = _this15.estado && _this15.estado.sigla ? _this15.estado.sigla : '';
                _this15.editedItem.razaoSocial = _this15.editedItem.razaoTomador ? _this15.editedItem.razaoTomador : '';
                _this15.editedItem.enderecoTomador = {};
                _this15.editedItem.enderecoTomador.TipoLogradouro = _this15.editedItem.enderecoTomadorTipoLogradouro ? _this15.editedItem.enderecoTomadorTipoLogradouro : '';
                _this15.editedItem.enderecoTomador.Logradouro = _this15.editedItem.enderecoTomadorLogradouro ? _this15.editedItem.enderecoTomadorLogradouro : '';
                _this15.editedItem.enderecoTomador.NumeroEndereco = _this15.editedItem.enderecoTomadorNumeroEndereco ? _this15.editedItem.enderecoTomadorNumeroEndereco : '';
                _this15.editedItem.enderecoTomador.ComplementoEndereco = _this15.editedItem.enderecoTomadorComplementoEndereco ? _this15.editedItem.enderecoTomadorComplementoEndereco : '';
                _this15.editedItem.enderecoTomador.Bairro = _this15.editedItem.enderecoTomadorBairro ? _this15.editedItem.enderecoTomadorBairro : '';
                _this15.editedItem.enderecoTomador.Cidade = _this15.cidadeTomador && _this15.cidadeTomador.nome ? _this15.cidadeTomador.nome : '';
                _this15.editedItem.enderecoTomador.codMun = _this15.cidadeTomador && _this15.cidadeTomador.id ? _this15.cidadeTomador.id : '';
                _this15.editedItem.enderecoTomador.UF = _this15.estadoTomador && _this15.estadoTomador.sigla ? _this15.estadoTomador.sigla : '';
                _this15.editedItem.enderecoTomador.CEP = _this15.editedItem.enderecoTomadorCEP ? _this15.editedItem.enderecoTomadorCEP : '';

                _this15.editedItem.enderecoPrestador = {};
                _this15.editedItem.enderecoPrestador.TipoLogradouro = _this15.editedItem.enderecoPrestadorTipoLogradouro ? _this15.editedItem.enderecoPrestadorTipoLogradouro : '';
                _this15.editedItem.enderecoPrestador.Logradouro = _this15.editedItem.enderecoPrestadorLogradouro ? _this15.editedItem.enderecoPrestadorLogradouro : '';
                _this15.editedItem.enderecoPrestador.NumeroEndereco = _this15.editedItem.enderecoPrestadorNumeroEndereco ? _this15.editedItem.enderecoPrestadorNumeroEndereco : '';
                _this15.editedItem.enderecoPrestador.ComplementoEndereco = _this15.editedItem.enderecoPrestadorComplementoEndereco ? _this15.editedItem.enderecoPrestadorComplementoEndereco : '';
                _this15.editedItem.enderecoPrestador.Bairro = _this15.editedItem.enderecoPrestadorBairro ? _this15.editedItem.enderecoPrestadorBairro : '';
                _this15.editedItem.enderecoPrestador.Cidade = _this15.cidade && _this15.cidade.nome ? _this15.cidade.nome : '';
                _this15.editedItem.enderecoPrestador.UF = _this15.estado && _this15.estado.sigla ? _this15.estado.sigla : '';
                _this15.editedItem.enderecoPrestador.CEP = _this15.editedItem.enderecoPrestadorCEP ? _this15.editedItem.enderecoPrestadorCEP : '';

                _this15.editedItem.cnpj = _this15.editedItem.cnpjCpfTomador ? _this15.editedItem.cnpjCpfTomador : '';
                _this15.editedItem.inscriEsPrestador = _this15.editedItem && _this15.editedItem.inscriEsPrestador ? _this15.editedItem.inscriEsPrestador : '';
                _this15.editedItem.cepPrestador = _this15.editedItem && _this15.editedItem.cepPrestador ? _this15.editedItem.cepPrestador : '';
                _this15.editedItem.telefonePrestador = _this15.editedItem && _this15.editedItem.telefonePrestador ? _this15.editedItem.telefonePrestador : '';
                _this15.editedItem.emailPrestador = _this15.editedItem && _this15.editedItem.emailPrestador ? _this15.editedItem.emailPrestador : '';
                _this15.editedItem.ISSRetido = _this15.editedItem.ISSRetido && _this15.editedItem.ISSRetido === 'true' ? 'true' : 'false';
                _this15.editedItem.opcaoSimples = _this15.editedItem.opcaoSimples ? _this15.editedItem.opcaoSimples : '5';
                _this15.editedItem.tribNfe = _this15.editedItem.tribNfe ? _this15.editedItem.tribNfe : 'U0';
                _this15.editedItem.totalImpostos = _this15.editedItem.aliqServico ? _this15.editedItem.aliqServico.replaceAll('.', '').replace(',', '.') : '';
                _this15.editedItem.deducoes = _this15.editedItem.deducoes ? _this15.editedItem.deducoes : '';

                if (_this15.editedItem.IR && String(_this15.editedItem.IR).includes(',')) {
                  _this15.editedItem.IR = _this15.editedItem.IR.replaceAll('.', '').replace(',', '.');
                }
                if (_this15.editedItem.COFINS && String(_this15.editedItem.COFINS).includes(',')) {
                  _this15.editedItem.COFINS = _this15.editedItem.COFINS.replaceAll('.', '').replace(',', '.');
                }
                if (_this15.editedItem.CSLL && String(_this15.editedItem.CSLL).includes(',')) {
                  _this15.editedItem.CSLL = _this15.editedItem.CSLL.replaceAll('.', '').replace(',', '.');
                }
                if (_this15.editedItem.INSS && String(_this15.editedItem.INSS).includes(',')) {
                  _this15.editedItem.INSS = _this15.editedItem.INSS.replaceAll('.', '').replace(',', '.');
                }
                if (_this15.editedItem.ISS && String(_this15.editedItem.ISS).includes(',')) {
                  _this15.editedItem.ISS = _this15.editedItem.ISS.replaceAll('.', '').replace(',', '.');
                }
                if (_this15.editedItem.PIS && String(_this15.editedItem.PIS).includes(',')) {
                  _this15.editedItem.PIS = _this15.editedItem.PIS.replaceAll('.', '').replace(',', '.');
                }
                if (_this15.editedItem.aliqServico && String(_this15.editedItem.aliqServico).includes(',')) {
                  _this15.editedItem.aliqServico = _this15.editedItem.aliqServico.replaceAll('.', '').replace(',', '.');
                }
                if (_this15.editedItem.vlrCredito && String(_this15.editedItem.vlrCredito).includes(',')) {
                  _this15.editedItem.vlrCredito = _this15.editedItem.vlrCredito.replaceAll('.', '').replace(',', '.');
                }
                if (_this15.editedItem.vlrServico && String(_this15.editedItem.vlrServico).includes(',')) {
                  _this15.editedItem.vlrServico = _this15.editedItem.vlrServico.replaceAll('.', '').replace(',', '.');
                }

              case 46:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this15);
      }))();
    },
    vOcrVerify: function vOcrVerify() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var auxList, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this16.isBtnLoading = true;
                auxList = _this16.body;
                _context12.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["f" /* verifyOcr */])(_this16.editedItem._id, _this16.conta.id_usuario);

              case 4:
                response = _context12.sent;


                if (response) {
                  auxList[_this16.editedIndex].verificadoOcr = true;
                  _this16.body = [];
                  _this16.body = auxList;
                  _this16.dialog = false;
                  _this16.isBtnLoading = false;
                  _this16.successMessage = 'NFSe verificada!';
                  setTimeout(function () {
                    _this16.successMessage = '';
                  }, 3000);
                } else {
                  _this16.isBtnLoading = false;
                  alert('Erro ao verificar.');
                }

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this16);
      }))();
    },
    vOcrClear: function vOcrClear() {
      this.dataIni = '';
      this.dataFim = '';
      this.cnpj = '';
      this.verificado = '';
    },
    vOcrAlterState: function vOcrAlterState(state) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var auxList, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                console.log(_this17.conta);
                _this17.isBtnLoading = true;
                auxList = _this17.body;
                _context13.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__domain_notas_nfseOcr_NfseOcrService__["a" /* denyOcr */])(_this17.editedItem._id, state, _this17.conta.id_usuario);

              case 5:
                response = _context13.sent;


                if (response) {
                  auxList[_this17.editedIndex].verificadoOcr = true;
                  auxList[_this17.editedIndex].ocr_status = state;
                  _this17.body = [];
                  _this17.body = auxList;
                  _this17.dialog = false;
                  _this17.isBtnLoading = false;
                  _this17.successMessage = "NFSe " + state + "!";
                  setTimeout(function () {
                    _this17.successMessage = '';
                  }, 3000);
                } else {
                  _this17.isBtnLoading = false;
                  alert("Erro ao " + state + ".");
                }

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this17);
      }))();
    },

    trocaCampoCpfCnpjPrestador: function trocaCampoCpfCnpjPrestador(e, v) {
      if (!v || v && v.length == 0) {
        this.mask.cnpjPrestador = "";
      } else {
        if (this.trocaCPFCNPJ && v && v.length >= 12) {
          this.mask.cnpjPrestador = "##.###.###/####-##";
        } else if (v && v.length <= 11) {
          this.trocaCPFCNPJ = true;
          this.mask.cnpjPrestador = "###.###.###-###";
        } else {
          this.trocaCPFCNPJ = false;
          this.mask.cnpjPrestador = "##.###.###/####-##";
        }
      }
    },
    trocaCampoCpfCnpjTomador: function trocaCampoCpfCnpjTomador(e, v) {
      if (!v || v && v.length == 0) {
        this.mask.cnpjTomador = "";
      } else {
        if (this.trocaCPFCNPJ && v && v.length >= 12) {
          this.mask.cnpjTomador = "##.###.###/####-##";
        } else if (v && v.length <= 11) {
          this.trocaCPFCNPJ = true;
          this.mask.cnpjTomador = "###.###.###-###";
        } else {
          this.trocaCPFCNPJ = false;
          this.mask.cnpjTomador = "##.###.###/####-##";
        }
      }
    },
    submitForm: function submitForm() {
      if (this.$refs.form.validate()) {
        console.log("Form submitted");
      }
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return estados; });
var estados = [{
    id: 11,
    sigla: "RO",
    nome: "Rondônia",
    regiao: {
        id: 1,
        sigla: "N",
        nome: "Norte"
    }
}, {
    id: 12,
    sigla: "AC",
    nome: "Acre",
    regiao: {
        id: 1,
        sigla: "N",
        nome: "Norte"
    }
}, {
    id: 13,
    sigla: "AM",
    nome: "Amazonas",
    regiao: {
        id: 1,
        sigla: "N",
        nome: "Norte"
    }
}, {
    id: 14,
    sigla: "RR",
    nome: "Roraima",
    regiao: {
        id: 1,
        sigla: "N",
        nome: "Norte"
    }
}, {
    id: 15,
    sigla: "PA",
    nome: "Pará",
    regiao: {
        id: 1,
        sigla: "N",
        nome: "Norte"
    }
}, {
    id: 16,
    sigla: "AP",
    nome: "Amapá",
    regiao: {
        id: 1,
        sigla: "N",
        nome: "Norte"
    }
}, {
    id: 17,
    sigla: "TO",
    nome: "Tocantins",
    regiao: {
        id: 1,
        sigla: "N",
        nome: "Norte"
    }
}, {
    id: 21,
    sigla: "MA",
    nome: "Maranhão",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 22,
    sigla: "PI",
    nome: "Piauí",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 23,
    sigla: "CE",
    nome: "Ceará",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 24,
    sigla: "RN",
    nome: "Rio Grande do Norte",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 25,
    sigla: "PB",
    nome: "Paraíba",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 26,
    sigla: "PE",
    nome: "Pernambuco",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 27,
    sigla: "AL",
    nome: "Alagoas",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 28,
    sigla: "SE",
    nome: "Sergipe",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 29,
    sigla: "BA",
    nome: "Bahia",
    regiao: {
        id: 2,
        sigla: "NE",
        nome: "Nordeste"
    }
}, {
    id: 31,
    sigla: "MG",
    nome: "Minas Gerais",
    regiao: {
        id: 3,
        sigla: "SE",
        nome: "Sudeste"
    }
}, {
    id: 32,
    sigla: "ES",
    nome: "Espírito Santo",
    regiao: {
        id: 3,
        sigla: "SE",
        nome: "Sudeste"
    }
}, {
    id: 33,
    sigla: "RJ",
    nome: "Rio de Janeiro",
    regiao: {
        id: 3,
        sigla: "SE",
        nome: "Sudeste"
    }
}, {
    id: 35,
    sigla: "SP",
    nome: "São Paulo",
    regiao: {
        id: 3,
        sigla: "SE",
        nome: "Sudeste"
    }
}, {
    id: 41,
    sigla: "PR",
    nome: "Paraná",
    regiao: {
        id: 4,
        sigla: "S",
        nome: "Sul"
    }
}, {
    id: 42,
    sigla: "SC",
    nome: "Santa Catarina",
    regiao: {
        id: 4,
        sigla: "S",
        nome: "Sul"
    }
}, {
    id: 43,
    sigla: "RS",
    nome: "Rio Grande do Sul",
    regiao: {
        id: 4,
        sigla: "S",
        nome: "Sul"
    }
}, {
    id: 50,
    sigla: "MS",
    nome: "Mato Grosso do Sul",
    regiao: {
        id: 5,
        sigla: "CO",
        nome: "Centro-Oeste"
    }
}, {
    id: 51,
    sigla: "MT",
    nome: "Mato Grosso",
    regiao: {
        id: 5,
        sigla: "CO",
        nome: "Centro-Oeste"
    }
}, {
    id: 52,
    sigla: "GO",
    nome: "Goiás",
    regiao: {
        id: 5,
        sigla: "CO",
        nome: "Centro-Oeste"
    }
}, {
    id: 53,
    sigla: "DF",
    nome: "Distrito Federal",
    regiao: {
        id: 5,
        sigla: "CO",
        nome: "Centro-Oeste"
    }
}];

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu_GuestMenu_vue__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_alertMessage_AlertMessage_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_alertMessage_AlertMessage_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_guestArea_home_Home_vue__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_guestArea_login_Login_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_guestArea_novaConta_NovaConta_vue__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_guestArea_download_fechamentoMensal_Download_vue__ = __webpack_require__(865);
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    guestMenu: __WEBPACK_IMPORTED_MODULE_0__components_menu_GuestMenu_vue__["a" /* default */],
    AlertComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_alertMessage_AlertMessage_vue__["a" /* default */],
    home: __WEBPACK_IMPORTED_MODULE_3__pages_guestArea_home_Home_vue__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_4__pages_guestArea_login_Login_vue__["a" /* default */],
    cadastrar: __WEBPACK_IMPORTED_MODULE_5__pages_guestArea_novaConta_NovaConta_vue__["a" /* default */],
    fechaMensalDownload: __WEBPACK_IMPORTED_MODULE_6__pages_guestArea_download_fechamentoMensal_Download_vue__["a" /* default */]
  },
  data: function data() {
    return {
      alert: new __WEBPACK_IMPORTED_MODULE_2__domain_alertMessage_AlertMessage_js__["a" /* default */](),
      component: { name: "" }
    };
  },

  created: function created() {},
  mounted: function mounted() {
    // this.closeJivoChat();
    this.$nextTick(function () {
      if (this.$router.history.current.path == "/" || this.$router.history.current.path == "/login") {
        if (this.$router.afterHooks.length > 0) {
          this.alert.snackDanger();
          this.alert.snack.text = this.$router.afterHooks[0].msg;
          this.alert.snack.show = true;
        }
        this.component.name = "login";
      } else if (this.$router.history.current.path == "/cadastrar") {
        this.component.name = "cadastrar";
      } else if (this.$router.history.current.path == "/download/fechamentoMensal") {
        this.component.name = "fechaMensalDownload";
      }
    });
  },
  watch: {
    $route: function $route() {
      if (this.$router.history.current.path == "/" || this.$router.history.current.path == "/login") {
        if (this.$router.afterHooks.length > 0) {
          this.alert.snackDanger();
          this.alert.snack.text = this.$router.afterHooks[0].msg;
          this.alert.snack.show = true;
        }
        this.component.name = "login";
      } else if (this.$router.history.current.path == "/cadastrar") {
        this.component.name = "cadastrar";
      } else if (this.$router.history.current.path == "/download/fechamentoMensal") {
        this.component.name = "fechaMensalDownload";
      }
    }
  },
  computed: {},
  methods: {
    closeJivoChat: function closeJivoChat() {
      var jivoChat = document.querySelector('jdiv');
      if (jivoChat) {
        // jivoChat.remove();
        jivoChat.style.display = "none";
      }
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {};
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {};
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_conta_precadastro_Empresa_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_conta_precadastro_Usuario_vue__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_menu_Menu_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_inputFile_InputFile_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_conta_empresa_certificado_CertificadoService_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_gravatar_GravatarService_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_conta_PreConta_js__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_conta_empresa_Empresa_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__domain_conta_usuario_Usuario_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__domain_conta_empresa_certificado_Certificado_js__ = __webpack_require__(72);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preCadastroEmpresa: __WEBPACK_IMPORTED_MODULE_3__components_conta_precadastro_Empresa_vue__["a" /* default */],
    preCadastroUsuario: __WEBPACK_IMPORTED_MODULE_4__components_conta_precadastro_Usuario_vue__["a" /* default */],
    mainMenu: __WEBPACK_IMPORTED_MODULE_5__components_menu_Menu_vue__["a" /* default */],
    InputFile: __WEBPACK_IMPORTED_MODULE_6__components_shared_inputFile_InputFile_vue__["a" /* default */]
  },
  data: function data() {
    return {
      e1: 0,
      cert: { file: undefined, password: "", empresa: [] },
      preConta: new __WEBPACK_IMPORTED_MODULE_9__domain_conta_PreConta_js__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_10__domain_conta_empresa_Empresa_js__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_11__domain_conta_usuario_Usuario_js__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_12__domain_conta_empresa_certificado_Certificado_js__["a" /* default */]()),
      file_cert: "",
      step: { usuario: false, empresa: false, cert: false },
      message: "Não conseguimos cadastrar sua conta",
      colorOfMessage: "red--text",
      passRules: [],
      showPassword: false,
      erroCadastro: false,
      conta: undefined,
      certCadastrado: false,
      envCert: false,
      loading: false
    };
  },

  computed: {
    UserIsValid: function UserIsValid() {
      return this.step.usuario === true;
    },
    EmpIsValid: function EmpIsValid() {
      return this.step.empresa === true;
    },
    certValido: function certValido() {
      return this.step.cert === true;
    }
  },
  methods: {
    getFile: function getFile(file) {
      this.cert.file = file[0];
      this.setRequiredPass();
    },
    checkCertValid: function checkCertValid() {
      if (this.cert.file != undefined && this.$refs.passCert.validate()) {
        this.step.cert = true;
      } else {
        this.step.cert = false;
      }
    },
    finalizar: function finalizar() {
      var _this = this;

      if (this.erroCadastro == false) {
        var conta = {};
        this.loading = true;
        conta["email"] = this.preConta.usuario.email;
        conta["password"] = this.preConta.usuario.password;
        var body = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(conta);
        this.$http.post("usuarios/authenticate", body).then(function (success) {
          _this.loading = false;
          _this.redirectUser(success);
        }, function (failed) {
          _this.loading = false;
          var router = _this.$router;
          router.push("/login");
        });
      } else {
        this.$router.push("/login");
      }
    },

    redirectUser: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(success) {
        var _this2 = this;

        var conta;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$session.start();
                conta = success.body;

                this.service = new __WEBPACK_IMPORTED_MODULE_8__domain_gravatar_GravatarService_js__["a" /* default */](this.$http);
                this.loading = true;
                _context.next = 6;
                return this.service.getGravatar(success.body.email).then(function (success) {
                  conta["gravatarProfile"] = success;
                }, function (failed) {}).then(function (x) {
                  _this2.loading = false;
                  _this2.$session.set("jwt", conta);
                  _this2.$router.push("/DashBoard");
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function redirectUser(_x) {
        return _ref.apply(this, arguments);
      }

      return redirectUser;
    }(),
    vincular: function vincular() {
      var _this3 = this;

      this.service = new __WEBPACK_IMPORTED_MODULE_7__domain_conta_empresa_certificado_CertificadoService_js__["a" /* default */](this.$http);
      this.loading = true;
      this.service.cadastrar(this.cert, this.conta._id).then(function (resp) {
        _this3.loading = false;
        if (resp.ok) {
          _this3.message = resp.infoMessage.msg;
          _this3.colorOfMessage = "green--text";
          _this3.certCadastrado = true;
          _this3.step.cert = false;
          _this3.envCert = false;
        } else {
          _this3.colorOfMessage = "red--text";
          resp.body.message != undefined && resp.body.message.length != 0 ? _this3.message = resp.body.message : _this3.message = resp.infoMessage.msg;
        }
      });
    },

    setRequiredPass: function setRequiredPass() {
      if (this.passRules.length > 0 && this.passRules[this.passRules.length - 1].name.length != 0) {
        this.passRules.pop();
      }

      if (this.cert.file != undefined) {
        this.passRules.push(function obrigatorio(value) {
          if (!value || value.length == 0) {
            return "Campo obrigatório";
          }
          return true;
        });
      }
      this.$refs.passCert.validate();
    },
    getUsuario: function getUsuario($event) {
      if ($event) {
        this.preConta.usuario = $event;
        this.step.usuario = true;
      } else {
        this.step.usuario = false;
      }
    },
    getEmpresa: function getEmpresa($event) {
      if ($event) {
        //popula as variaveis com os dados de retorno
        for (var i = 0; i < $event.length; i++) {
          if ($event[i].cnpj) {
            this.preConta.empresa = $event[i];
          } else if ($event[i].file) {
            this.preConta.certificado = $event[i];
            this.file_cert = $event[i].file;
          }
        }
        this.step.empresa = true;
      } else {
        this.step.empresa = false;
      }
    },
    cadastraConta: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this4 = this;

        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //Criação do form Data para passar os dados no cadastro
                this.loading = true;
                data = new FormData();

                if (this.file_cert != undefined && this.file_cert != null && this.file_cert.length > 0) {
                  data.append("file", this.file_cert);
                }
                data.append("plano", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.preConta.usuario.plano));
                data.append("cert", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.preConta.certificado));
                data.append("usuario", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.preConta.usuario));
                data.append("empresa", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.preConta.empresa));

                this.resource = this.$resource("contas/pre", {}, {}, { emulateJSON: true });
                _context2.next = 10;
                return this.resource.save({}, data).then(function (success) {
                  _this4.loading = false;
                  _this4.envCert == false ? _this4.message = "Sua conta foi cadastrada." : _this4.message = "Sua conta foi cadastrada, falta apenas o certificado.";
                  _this4.colorOfMessage = "green--text";
                  _this4.conta = success.body;
                  _this4.erroCadastro = false;
                  _this4.cert.empresa.push(success.body.empresas[0].empresa._id);
                }, function (failed) {
                  _this4.loading = false;
                  _this4.erroCadastro = true;
                  _this4.conta = undefined;
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function cadastraConta() {
        return _ref2.apply(this, arguments);
      }

      return cadastraConta;
    }(),
    avançarStep: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(e) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = this.e1;
                _context3.next = _context3.t0 === 1 ? 3 : _context3.t0 === 2 ? 4 : _context3.t0 === 3 ? 7 : 8;
                break;

              case 3:
                return _context3.abrupt("break", 8);

              case 4:
                _context3.next = 6;
                return this.cadastraConta();

              case 6:
                return _context3.abrupt("break", 8);

              case 7:
                return _context3.abrupt("break", 8);

              case 8:
                this.e1++;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function avanArStep(_x2) {
        return _ref3.apply(this, arguments);
      }

      return avanArStep;
    }(),
    retornarStep: function retornarStep() {
      this.$refs.btn_avan_user.disabled = false;

      switch (this.e1) {
        case 2:
          this.$refs.btn_avan_user.disabled = false;
          break;
        case 3:
          break;
      }
      this.e1--;
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_Empresa_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_conta_empresa_certificado_Certificado_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_EmpresaService_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_ibge_estados_js__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(35);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      empresa: new __WEBPACK_IMPORTED_MODULE_2__domain_conta_empresa_Empresa_js__["a" /* default */](),
      cert: new __WEBPACK_IMPORTED_MODULE_3__domain_conta_empresa_certificado_Certificado_js__["a" /* default */](),
      valid: false,
      arrayEstados: [],
      resource: "",
      auxEstado: "",
      showPassword: false,
      trocaCPFCNPJ: false,
      mask: { cnpj: "" },
      cpfRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (cpf) {
        var sum = void 0,
            rest = void 0;
        if (cpf === undefined || cpf === null || cpf.trim().length === 0 || cpf === "00000000000" || cpf === "11111111111" || cpf === "22222222222" || cpf === "33333333333" || cpf === "44444444444" || cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777" || cpf === "88888888888" || cpf === "99999999999") {
          return "CPF inválido";
        }
        cpf = cpf.replace(".", "").replace(".", "").replace("-", "");

        sum = 0;
        for (var i = 1; i <= 9; i++) {
          sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        rest = sum * 10 % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(9, 10))) {
          return "CPF inválido";
        }

        sum = 0;
        for (var _i = 1; _i <= 10; _i++) {
          sum = sum + parseInt(cpf.substring(_i - 1, _i)) * (12 - _i);
        }
        rest = sum * 10 % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(10, 11))) {
          return "CPF inválido";
        }
        return true;
      }],

      cnpjRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        if (v == null) {
          return false;
        }
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

        if (/0{14}/.test(v)) return "CNPJ inválido";

        for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]) {}
        if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]) {}
        if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        return true;
      }],
      razaoRules: [function (v) {
        return !!v || "Campo obrigatório";
      }],
      passRules: []
    };
  },
  computed: {
    emailErrors: function emailErrors() {},
    getEstados: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.arrayCidades = [];
                delete __WEBPACK_IMPORTED_MODULE_6_vue__["default"].http.headers.common["Authorization"];
                this.resource = this.$resource("https://servicodados.ibge.gov.br/api/v1/localidades/estados");
                this.resource.query().then(function (success) {
                  _this.arrayEstados = success.body;

                  return success.body;
                }, function (failed) {
                  _this.arrayEstados = __WEBPACK_IMPORTED_MODULE_5__domain_ibge_estados_js__["a" /* estados */];
                  return __WEBPACK_IMPORTED_MODULE_5__domain_ibge_estados_js__["a" /* estados */];
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEstados() {
        return _ref.apply(this, arguments);
      }

      return getEstados;
    }()
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getEstados;
      this.service = new __WEBPACK_IMPORTED_MODULE_4__domain_conta_empresa_EmpresaService_js__["a" /* default */](this.$http);
    });
  },
  methods: {
    setUfEmpresa: function setUfEmpresa() {
      if (this.auxEstado.hasOwnProperty("id") && this.auxEstado.id != undefined) {
        this.empresa["uf"] = this.auxEstado.id;
      }
    },
    trocaCampoCpfCnpj: function trocaCampoCpfCnpj(e, v) {
      if (!v || v && v.length == 0) {
        this.mask.cnpj = "";
      } else {
        if (this.trocaCPFCNPJ && v && v.length >= 12) {
          this.mask.cnpj = "##.###.###/####-##";
        } else if (v && v.length >= 11) {
          this.trocaCPFCNPJ = true;
          this.mask.cnpj = "###.###.###-###";
        } else {
          this.trocaCPFCNPJ = false;
          this.mask.cnpj = "###.###.###-##";
        }
      }
    },
    verificaCNPJ: function verificaCNPJ($event) {
      this.setRazao();
      this.consultaCNPJbd();
      this.returnEmpresa($event);
    },
    setRazao: function setRazao() {
      var _this2 = this;

      this.service.getAPIReceita(this.empresa.cnpj).then(function (success) {
        if (success && success.body) {
          if (success.body.hasOwnProperty("nome")) {
            _this2.empresa.razao = success.body.nome;
          }
          if (success.body.hasOwnProperty("uf") && success.body.uf.length > 0) {
            _this2.arrayEstados.forEach(function (estado) {
              if (success.body.uf.toLocaleLowerCase() == estado.sigla.toLocaleLowerCase()) {
                _this2.auxEstado = estado;
                _this2.empresa["uf"] = estado.id;
              }
            });
          }
          _this2.$refs.cnpj.validate();
        }
      });
    },
    consultaCNPJbd: function consultaCNPJbd() {
      var _this3 = this;

      this.service.getEmpresasCnpj(this.empresa.cnpj).then(function (success) {
        // trocar para algo melhor
        if (_this3.cnpjRules[_this3.cnpjRules.length - 1].name.length != 0) {
          _this3.cnpjRules.pop();
        }
        if (_this3.cpfRules[_this3.cpfRules.length - 1].name.length != 0) {
          _this3.cpfRules.pop();
        }
        if (success && success.status != 404) {
          _this3.cnpjRules.push(function indisponivel(value) {
            if (success.body.items.length > 0 && value == success.body.items[0].cnpj) {
              return "CNPJ já utilizado no sistema";
            }
            return true;
          });
          _this3.cpfRules.push(function indisponivel(value) {
            if (success.body.items.length > 0 && value == success.body.items[0].cnpj) {
              return "CPF já utilizado no sistema";
            }
            return true;
          });
        }
        _this3.$refs.cnpj.validate();
        return _this3.$refs.cnpj.valid;
      }, function (failed) {
        return failed;
      });
    },
    getFile: function getFile(file) {
      this.cert.file = file;
      this.setRequiredPass();
    },

    setRequiredPass: function setRequiredPass() {
      if (this.passRules.length > 0 && this.passRules[this.passRules.length - 1].name.length != 0) {
        this.passRules.pop();
      }

      if (this.cert.file != undefined) {
        this.passRules.push(function obrigatorio(value) {
          if (!value || value.length == 0) {
            return "Campo obrigatório";
          }
          return true;
        });
      }
      this.$refs.passCert.validate();
      this.returnEmpresa();
    },
    returnEmpresa: function returnEmpresa(e) {
      // this.setFile(e);
      //Seta o arquivo do input file e torna a senha obrigatória

      //se Tudo estiver de acordo Envia
      if (this.verificaCampos()) {
        this.empresa["cnpj"] = this.empresa["cnpj"].replace(/[^\d]+/g, "");
        return this.$emit("getEmpresa", [this.empresa, this.cert]);
      } else {
        return this.$emit("getEmpresa", false);
      }
    },
    verificaCampos: function verificaCampos() {
      var cont = 0;

      var fields = [document.querySelector("#empresa-cnpj"), document.querySelector("#empresa-razao"), document.querySelector("#empresa-uf")];
      fields.forEach(function (item) {
        if (item.value != null && item.value != "") {
          cont++;
        }
      });
      if (cont >= fields.length - 2) {
        if (this.$refs.form.validate()) {
          return true;
        }
      }
      return false;
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_conta_usuario_Usuario_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_planos_planos_js__ = __webpack_require__(250);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//URL PARA BUSCAR SE EMAIL JÁ CONSTA NO SISTEMA: usuarios?email=diego.humberto@compila.com.br


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: false,
      usuario: new __WEBPACK_IMPORTED_MODULE_0__domain_conta_usuario_Usuario_js__["a" /* default */](),
      showPassword: false,
      mask: { nome: "" },
      planoSelecionado: null,
      resource: "",
      nomeRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        return (/^[a-zA-Z _-]{1,90}$/.test(v) || "Digite um nome válido"
        );
      }],
      // [a-zA-Z _-]+$
      emailRules: [function (v) {
        return !!v || "Campo obrigatório";
      }, function (v) {
        return (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) || "Digite um e-mail válido"
        );
      }],
      passRules: [function (v) {
        return !!v || "Campo é obrigatório";
      }],
      planos: __WEBPACK_IMPORTED_MODULE_1__domain_planos_planos_js__["a" /* arrayPlanos */]
    };
  },
  computed: {},
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      // SUPER  PERFORMANCE MICRO GESTÃO
      var urlPlano = this.$route.query.plano ? this.$route.query.plano.toLowerCase() : undefined;
      if (urlPlano) {
        urlPlano == "gestão" ? urlPlano = urlPlano.replace(/ã/g, "a") : "";

        this.planos.filter(function (a, b) {
          if (a._id == urlPlano) {
            _this.planoSelecionado = a;
          }
        });
      }
    });
  },
  methods: {
    verificaDispEmail: function verificaDispEmail() {
      var _this2 = this;

      if (this.$refs.form.$el[1].validity.valid) {
        this.resource = this.$resource("usuarios?email=" + this.usuario.email);
        this.resource.query().then(function (success) {
          _this2.emailRules.push(function indisponível(value) {
            if (value == success.body.items[0].email) {
              return "Email já utilizado no sistema";
            }
            return true;
          });
          _this2.$refs.form.validate();
        }, function (failed) {
          if (failed.status == 404) {
            _this2.returnUsuario();
          }
        });
      }
      return false;
    },
    returnUsuario: function returnUsuario() {
      if (this.verificaCampos()) {
        this.usuario.plano = this.planoSelecionado._id;
        return this.$emit("getUsuario", this.usuario);
      } else {
        return this.$emit("getUsuario", false);
      }
    },
    verificaCampos: function verificaCampos() {
      var cont = 0;
      var fields = [document.querySelector("#usuario-nome"), document.querySelector("#usuario-email"), document.querySelector("#usuario-password"), document.querySelector("#usuario-planos"), document.querySelector("#usuario-telefone")];

      document.querySelector("#usuario-planos").value = " ";

      fields.forEach(function (item) {
        if (item.value != null && item.value != "") {
          cont++;
        }
      });

      if (cont === fields.length) {
        if (this.$refs.form.validate()) return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_fechamentoMensal_FechamentoMensal__ = __webpack_require__(867);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["alert"],
  components: {},
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.downloadZip();
    });
  },
  methods: {
    downloadZip: function downloadZip() {
      var _this = this;

      var urlZip = this.$route.query._link;
      this.alert.snackSuccess();
      this.alert.snack.text = "Motor Fiscal está buscando o arquivo";
      this.alert.snack.show = true;
      this.alert.snack.time = 4000;
      this._service = new __WEBPACK_IMPORTED_MODULE_0__domain_fechamentoMensal_FechamentoMensal__["a" /* default */](this.$http);
      this._service.fechamentoMensal(urlZip).then(function (res) {
        if (res.status == 200) {
          var blob = new Blob([_this._base64ToArrayBuffer(res.body.doc)], {
            type: "application/zip"
          });
          if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display:none";
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "FechamentoMensal_" + new Date().getTime();
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
          }
        } else {
          _this.alert.snackDanger();
          _this.alert.snack.text = "Motor Fiscal não conseguiu buscar o arquivo gerado";
          _this.alert.snack.show = true;
          _this.alert.snack.time = 4000;
        }
      });
    },
    _base64ToArrayBuffer: function _base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_conta_usuario_formUsuario_FormUsuario_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_conta_usuario_UsuarioService_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_inputFile_InputFile_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_loggedArea_editarPerfil_EditarPerfil_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_alertMessage_AlertMessage_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_gravatar_GravatarService_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_alertMessage_AlertMessage_js__ = __webpack_require__(117);


//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    inputFile: __WEBPACK_IMPORTED_MODULE_4__components_shared_inputFile_InputFile_vue__["a" /* default */],
    FormUsuario: __WEBPACK_IMPORTED_MODULE_2__components_conta_usuario_formUsuario_FormUsuario_vue__["a" /* default */],
    editarPerfil: __WEBPACK_IMPORTED_MODULE_5__pages_loggedArea_editarPerfil_EditarPerfil_vue__["a" /* default */],
    AlertComponent: __WEBPACK_IMPORTED_MODULE_6__components_shared_alertMessage_AlertMessage_vue__["a" /* default */]
  },
  data: function data() {
    return {
      usuario: {},
      validPass: true,
      show2: false,
      show3: false,
      pass1: "",
      pass2: "",
      loading: true,
      passwordRules: [function (v) {
        return !!v || "Campo é obrigatório";
      }, function (v) {
        return !!v && v.length <= 25 || "Precisa conter menos que 25 caracteres";
      }, function (v) {
        return !!v && v.length >= 5 || "Precisa conter mais que 5 caracteres";
      }],
      currentItem: "",
      render: false,
      tabs: [{
        title: "Minha senha"
      }],
      alert: new __WEBPACK_IMPORTED_MODULE_8__domain_alertMessage_AlertMessage_js__["a" /* default */]()
    };
  },

  beforeCreate: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$nextTick(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _this = this;

                var token;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        token = this.$router.currentRoute.params.token;

                        this.service = new __WEBPACK_IMPORTED_MODULE_3__domain_conta_usuario_UsuarioService_js__["a" /* default */](this.$http);
                        _context2.next = 4;
                        return this.service.getUsuarioByToken(token).then(function (resp) {
                          _this.loading = false;
                          if (resp.ok) {
                            _this.usuario = resp.body;
                            _this.usuario["id_usuario"] = resp.body._id;
                            _this.render = true;
                            return resp.body.email;
                          } else {
                            _this.alert.snackAlert();
                            _this.alert.snack.text = "Pendência de cadastro não localizada.";
                            _this.alert.snack.show = true;
                            var router = _this.$router;
                            setTimeout(function () {
                              router.push("/");
                            }, 4000);
                          }
                        }).then(function () {
                          var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(email) {
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    if (!email) {
                                      _context.next = 4;
                                      break;
                                    }

                                    _this.service = new __WEBPACK_IMPORTED_MODULE_7__domain_gravatar_GravatarService_js__["a" /* default */](_this.$http);
                                    _context.next = 4;
                                    return _this.service.getGravatar(email).then(function (success) {
                                      _this.usuario["gravatarProfile"] = success;
                                    }, function (failed) {});

                                  case 4:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee, _this);
                          }));

                          return function (_x) {
                            return _ref3.apply(this, arguments);
                          };
                        }());

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              })));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function beforeCreate() {
      return _ref.apply(this, arguments);
    }

    return beforeCreate;
  }(),
  updated: function updated() {},
  computed: {},
  methods: {
    salvarDados: function salvarDados() {
      var envDados = false;
      if (this.$refs.formPass.validate()) {
        if (this.pass1 != this.pass2) {
          this.passwordRules.push(function diferentes(v) {
            return "Senhas diferem uma da outra.";
          });
          this.$refs.pass2.validate();
          if (this.passwordRules[this.passwordRules.length - 1].name.length != 0) {
            this.passwordRules.pop();
          }
        } else {
          envDados = true;
        }
      }
      if (envDados) {
        alert("Implementar logica");
      }
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InformeRendimentosService__ = __webpack_require__(875);




var _mounted$data$compute;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (_mounted$data$compute = {
    mounted: function mounted() {
        this.vOcrUpdate();
    },
    data: function data() {
        return {
            mask: { cnpjTomador: "", cnpjPrestador: "" },
            successMessage: '',
            isBtnLoading: false,
            tipo: '',
            status_arquivo: '',
            status_email: '',
            dataIni: '',
            dataFim: '',
            isLoading: false,
            dialog: false,
            search: '',
            pagination: {
                rowsPerPage: 10,
                totalItems: 0
            },
            selected: [],
            headers: [{ text: 'PDF', align: 'center', sortable: false, value: '' }, { text: 'Data registro', align: 'center', value: 'data_registro' }, { text: 'Tipo arquivo', align: 'center', value: 'tipo_arquivo' }, { text: 'Status OCR', align: 'center', value: 'status_ocr' }, { text: 'Status envio e-mail', align: 'center', value: 'status_envio_email' }, { text: 'CNPJ beneficiario', align: 'center', value: 'cnpj_beneficiario' }, { text: 'Razão beneficiario', align: 'center', value: 'razao_beneficiario' }, { text: 'E-mail beneficiario', align: 'center', value: 'email_beneficiario' }, { text: 'Data envio e-mail', align: 'center', value: 'data_email' }, { text: 'Ano calendario', align: 'center', value: 'ano_calendario' }],
            body: [],
            editedItem: {},
            editedIndex: -1,
            fileText: "Nenhum arquivo selecionado",
            path: "",
            file: {},
            token: "",
            isFileUploading: false,
            errorMessage: '',
            pdf: '',
            isFileLoading: false
        };
    },

    computed: {
        pages: function pages() {
            if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;

            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
        }
    }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mounted$data$compute, "mounted", function mounted() {
    this.token = this.$router.currentRoute.params.token;
    this.buscaInformeRendimentos();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mounted$data$compute, "methods", {
    exportatExcel: function exportatExcel() {
        var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
        var j = 0;
        var tab = document.querySelector('.v-datatable');
        var sa = void 0;
        var aux = tab.rows[2].innerHTML;

        aux = aux.replace('<td class="text-xs-center"><span data-v-', '');
        var componenteId = aux.substr(0, 8);

        for (j = 0; j < tab.rows.length; j++) {
            var pdf = '<th role="columnheader" scope="col" aria-label="PDF: Not sorted." aria-sort="none" class="column text-xs-center">PDF</th>';

            if (!tab.rows[j].innerHTML.includes('<th colspan="10" class="column"></th>')) {
                tab_text = tab_text + tab.rows[j].innerHTML.replace(pdf, '').replaceAll('arrow_upward', '').replaceAll("<td class=\"text-xs-center\"><span data-v-" + componenteId + "=\"\" class=\"ocrLink\">Visualizar</span></td>", '').replaceAll("<td data-v-" + componenteId + "=\"\" class=\"text-xs-center\"><span data-v-" + componenteId + "=\"\" class=\"ocrLink\">Visualizar</span></td>", '') + "</tr>";
            }
        }

        tab_text = tab_text + "</table>";
        tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
        tab_text = tab_text.replace(/<img[^>]*>/gi, "");
        tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            txtArea1.document.open("txt/html", "replace");
            txtArea1.document.write(tab_text);
            txtArea1.document.close();
            txtArea1.focus();
            sa = txtArea1.document.execCommand("SaveAs", true, "Say Thanks to Sumit.xls");
        } else
            // sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));
            sa = window.open('data:application/vnd.ms-excel,' + escape(tab_text));

        return sa;
    },
    resetInfos: function resetInfos() {
        this.file = {};
        var file = document.querySelector("#file-upload");
        file.value = "";

        this.path = "";
        this.fileText = "Nenhum arquivo selecionado";
    },

    setFile: function setFile(e) {
        this.path = "";
        if (e.target.type == "file") {
            if (e.target.files.length > 0) {
                this.fileText = "Arquivo selecionado: ";
                this.path = e.target.files[0].name;
                this.file = e.target.files[0];
            } else {
                this.fileText = "Nenhum arquivo selecionado";
            }
        } else {
            return;
        }
    },
    vOcrClear: function vOcrClear() {
        this.dataIni = '';
        this.dataFim = '';
        this.tipo = '';
        this.status_arquivo = '';
        this.status_email = '';
    },

    handleUploadFile: function handleUploadFile() {
        var _this = this;

        if (!this.file || !this.file.name) return;

        this.isFileUploading = true;
        var reader = new FileReader();
        reader.onload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            var name, base64, json, response;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            name = _this.file.name;
                            base64 = reader.result.split('data:application/pdf;base64,')[1];
                            json = {
                                NOME_ARQUIVO: name,
                                ARQUIVO: base64
                            };
                            _context.next = 5;
                            return Object(__WEBPACK_IMPORTED_MODULE_3__InformeRendimentosService__["c" /* informeRendimentosUploadFileApi */])(json, _this.token);

                        case 5:
                            response = _context.sent;


                            _this.isFileUploading = false;

                            if (response && response.STATUS === 'SUCESSO') {
                                _this.resetInfos();
                                _this.successMessage = 'Arquivo enviado!';

                                setTimeout(function () {
                                    _this.successMessage = '';
                                }, 5000);
                            } else {
                                _this.errorMessage = 'Erro ao enviar o arquivo.';

                                setTimeout(function () {
                                    _this.errorMessage = '';
                                }, 5000);
                            }

                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));
        reader.readAsDataURL(this.file);
    },
    buscaInformeRendimentos: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var _this2 = this;

            var informeDataInicial, informeDataFinal, informeTipo, informeStatusArquivo, informeStatusEmail, response;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            this.isLoading = true;
                            informeDataInicial = this.dataIni && this.dataIni.length === 10 ? this.dataIni : '';
                            informeDataFinal = this.dataFim && this.dataFim.length === 10 ? this.dataFim : '';
                            informeTipo = this.tipo ? this.tipo : '';
                            informeStatusArquivo = this.status_arquivo ? this.status_arquivo : '';
                            informeStatusEmail = this.status_email ? this.status_email : '';
                            _context2.next = 8;
                            return Object(__WEBPACK_IMPORTED_MODULE_3__InformeRendimentosService__["a" /* getInformeRendimentosApi */])(informeDataInicial, informeDataFinal, informeTipo, informeStatusArquivo, informeStatusEmail, this.token);

                        case 8:
                            response = _context2.sent;


                            if (response) {
                                this.body = response.rendimentos;
                                this.pagination.totalItems = response.rendimentos.length;
                                this.isLoading = false;
                            } else {
                                this.isLoading = false;
                                this.errorMessage = 'Erro ao buscar os dados.';

                                setTimeout(function () {
                                    _this2.errorMessage = '';
                                }, 5000);
                            }
                            this.isLoading = false;

                        case 11:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function buscaInformeRendimentos() {
            return _ref2.apply(this, arguments);
        }

        return buscaInformeRendimentos;
    }(),
    handleOpenFile: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(item) {
            var _this3 = this;

            var response;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(item && item._id && item.pathPdf)) {
                                _context3.next = 9;
                                break;
                            }

                            this.isFileLoading = true;
                            _context3.next = 4;
                            return Object(__WEBPACK_IMPORTED_MODULE_3__InformeRendimentosService__["b" /* informeRendimentosBuscaArquivoApi */])(item._id, this.token);

                        case 4:
                            response = _context3.sent;

                            this.isFileLoading = false;
                            if (response && response.pdfBase64) {
                                this.pdf = response.pdfBase64;
                                this.dialog = true;
                            } else {
                                this.errorMessage = 'Arquivo não encontrado.';

                                setTimeout(function () {
                                    _this3.errorMessage = '';
                                }, 5000);
                            }
                            _context3.next = 11;
                            break;

                        case 9:
                            this.errorMessage = 'Arquivo não encontrado.';

                            setTimeout(function () {
                                _this3.errorMessage = '';
                            }, 5000);

                        case 11:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function handleOpenFile(_x) {
            return _ref3.apply(this, arguments);
        }

        return handleOpenFile;
    }(),
    trocaCampoCpfCnpjPrestador: function trocaCampoCpfCnpjPrestador(e, v) {
        if (!v || v && v.length == 0) {
            this.mask.cnpjPrestador = "";
        } else {
            if (this.trocaCPFCNPJ && v && v.length >= 12) {
                this.mask.cnpjPrestador = "##.###.###/####-##";
            } else if (v && v.length <= 11) {
                this.trocaCPFCNPJ = true;
                this.mask.cnpjPrestador = "###.###.###-###";
            } else {
                this.trocaCPFCNPJ = false;
                this.mask.cnpjPrestador = "##.###.###/####-##";
            }
        }
    },
    trocaCampoCpfCnpjTomador: function trocaCampoCpfCnpjTomador(e, v) {
        if (!v || v && v.length == 0) {
            this.mask.cnpjTomador = "";
        } else {
            if (this.trocaCPFCNPJ && v && v.length >= 12) {
                this.mask.cnpjTomador = "##.###.###/####-##";
            } else if (v && v.length <= 11) {
                this.trocaCPFCNPJ = true;
                this.mask.cnpjTomador = "###.###.###-###";
            } else {
                this.trocaCPFCNPJ = false;
                this.mask.cnpjTomador = "##.###.###/####-##";
            }
        }
    }
}), _mounted$data$compute);

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_session__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pako__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pako___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pako__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(930);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












var producao = window.location.href.indexOf("app.motorfiscal") != -1 ? true : false;
var canAccessRelatorio = ["fernando.ribeiro@compila.com.br", "giovanne.ribeiro@compila.com.br", "geovanna.brito@compila.com.br", "nycollas.meneses@compila.com.br", "wesley.peres@compila.com.br", "giovanna.santos@compila.com.br"];
var uriAPI = producao ? "https://api.motorfiscal.com.br/" : "https://apiteste.motorfiscal.com.br/";

__WEBPACK_IMPORTED_MODULE_9_chart_js___default.a.defaults.global.defaultFontColor = "white";

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_pako___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);
var options = { persist: false };
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_session___default.a, options);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$canAccessRelatorio = canAccessRelatorio;

// Vue.http.headers.common['Authorization'] = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ3aWxsaWFtLnJvY2hhQGNvbXBpbGEuY29tLmJyIiwiaXNzIjoibW90b3ItYXBpIiwiaWF0IjoxNTQ5NDYxNDU0fQ.zOL9Ku5ympvkRFTNzrwx3LxgMmx_dXicu8cPHQQorJw';
// Vue.http.options.root = 'https://api.motorfiscal.com.br/';
// Vue.http.options.root = 'http://192.168.99.100/';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = uriAPI;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: "<App/>"
});

/***/ }),
/* 427 */,
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f0fb9e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(431);
function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f0fb9e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */,
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{},[_c('v-content',{attrs:{"id":_vm.$router.history.current.path.split('/')[1].length > 0 ? 'content_'+_vm.$router.history.current.path.split('/')[1] : 'content_login'}},[_c('router-view')],1),_vm._v(" "),_c('v-icon',{staticClass:"c_custom-loader"},[_vm._v("cached")]),_vm._v(" "),_c('v-progress-linear',{staticClass:"c_custom-progress",attrs:{"color":"teal","height":"20","value":_vm.progressBar}}),_vm._v(" "),_c('h4',{staticClass:"c_custom-msg"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_guestArea_GuestArea_vue__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_guestArea_novoUsuario_NovoUsuario_vue__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_loggedArea_informeRendimentos_InformeRendimentos_vue__ = __webpack_require__(873);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/DashBoard',
    name: 'DashBoard',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_guestArea_GuestArea_vue__["a" /* default */]
  }, {
    path: '/cadastrar',
    name: 'Cadastro',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_guestArea_GuestArea_vue__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_guestArea_GuestArea_vue__["a" /* default */]
  }, {
    path: '/consultaNFe',
    name: 'Consulta NF-e',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/consultaIptu',
    name: 'Consulta IPTU',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/consultaCTe',
    name: 'Consulta CT-e',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/ePerfil',
    name: 'Editar Perfil',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/relatorio',
    name: 'Relatório',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/validaOcr',
    name: 'Valida OCR',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/verPerfil',
    name: 'Ver Perfil',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    // consultaNFSe
    path: '/consultaNFSe',
    name: 'Consulta NFS-e',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/fornecedores',
    name: 'Consulta Fornecedores',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/clientes',
    name: 'Consulta Clientes',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/produtos',
    name: 'Consulta Produtos',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/configuracoes',
    name: 'Configurações',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/configuracoesAutomacao',
    name: 'ConfiguraçõesAutomacao',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/nvusuario/:token',
    name: 'Cadastro de usuário',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_guestArea_novoUsuario_NovoUsuario_vue__["a" /* default */]
  }, {
    path: '/primeiroAcesso',
    name: 'Primeiro Acesso',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/fechamento',
    name: 'Fechamento de Mês',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/loja',
    name: 'Loja',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/download/fechamentoMensal',
    name: 'Download - Fechamento Mensal',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_guestArea_GuestArea_vue__["a" /* default */]
  }, {
    path: '/docsFederal',
    name: 'Docs Federal',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/docsMunicipal',
    name: 'Docs Municipal',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */]
  }, {
    path: '/informe-rendimentos/:token',
    name: 'Informe Rendimentos',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_loggedArea_informeRendimentos_InformeRendimentos_vue__["a" /* default */]
  }, { path: "*", component: __WEBPACK_IMPORTED_MODULE_2__pages_loggedArea_LoggedArea__["a" /* default */] }],
  mode: 'history'
}));

/***/ }),
/* 433 */,
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoggedArea_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29643933_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoggedArea_vue__ = __webpack_require__(846);
function injectStyle (ssrContext) {
  __webpack_require__(435)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29643933"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoggedArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29643933_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoggedArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersistInfo_vue__ = __webpack_require__(140);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6160e346_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersistInfo_vue__ = __webpack_require__(487);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6160e346"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersistInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6160e346_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersistInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CertDigitalElement_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df5af44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CertDigitalElement_vue__ = __webpack_require__(485);
function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CertDigitalElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df5af44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CertDigitalElement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showInfoCertificado),expression:"!showInfoCertificado"}],staticClass:"divRenovarCertificadoImg"},[_c('img',{attrs:{"src":__webpack_require__(486),"alt":"Imagem para descrever a renovação do certificado digital."}}),_vm._v(" "),_c('button',{staticClass:"btnRenovarCertificadoImg",staticStyle:{"padding":"0 21px!important"},on:{"click":function($event){return _vm.handleShowRenovarCertificado()}}},[_vm._v("Renovar")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInfoCertificado),expression:"showInfoCertificado"}],attrs:{"id":"h4-Cert-DigitalElement","cert-token":"T-5a6f64","cert-company":"C-8a0193","accountant":"A-626df1","f":"F-2","p":"P-14"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renovar-certificado.989ef59.png";

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.mostrarNewFeatures)?_c('v-layout',{staticClass:"panel",class:'darkBlue',attrs:{"id":"persistInfo","align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticClass:"message deftColor"},[_vm._v("\n      Agora você pode fazer o\n      "),_c('strong',[_vm._v("Fechamento Mensal")]),_vm._v(" de uma forma mais fácil e simples!\n    ")]),_vm._v(" "),_c('div',{staticClass:"link deftColor",on:{"click":function($event){return _vm.$router.push('/fechamento')}}},[_vm._v("Venha conhecer")]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},nativeOn:{"click":function($event){return _vm.desativarNewFeature()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Fechar essa notificação")])],1)],1):_vm._e(),_vm._v(" "),(_vm.sefazLentidao)?_c('v-layout',{staticClass:"panel",class:'red',attrs:{"id":"persistInfo","align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticClass:"message deftColor"},[_c('strong',[_vm._v("SEFAZ")]),_vm._v(" está com lentidão e quedas repentinas, ocasionando uma demanda maior de espera para consultar "),_c('strong',[_vm._v("NF-e")]),_vm._v(" e "),_c('strong',[_vm._v("CT-e")]),_vm._v(", agradecemos a compreensão!\n    ")]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},nativeOn:{"click":function($event){return _vm.desativarNewFeature()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Fechar essa notificação")])],1)],1):_vm._e(),_vm._v(" "),(_vm.prefSpLentidao)?_c('v-layout',{staticClass:"panel",class:'red',attrs:{"id":"persistInfo","align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticClass:"message deftColor"},[_c('strong',[_vm._v("Prefeitura de SP")]),_vm._v(" está com lentidão e quedas repentinas, ocasionando uma demanda maior de espera para consultar "),_c('strong',[_vm._v("NFs-e")]),_vm._v(", agradecemos a compreensão!\n    ")]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},nativeOn:{"click":function($event){return _vm.desativarNewFeature()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Fechar essa notificação")])],1)],1):_vm._e(),_vm._v(" "),(_vm.config.show)?_c('v-layout',{staticClass:"panel",class:this.config.color,attrs:{"id":"persistInfo","align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticClass:"message deftColor"},[_vm._v(_vm._s(_vm.config.msg))]),_vm._v(" "),(_vm.config.link.has)?_c('div',{staticClass:"link deftColor",on:{"click":function($event){return _vm.$router.push(_vm.config.link.url)}}},[_vm._v(_vm._s(_vm.config.link.msg))]):_vm._e(),_vm._v(" "),(_vm.config.link.has && _vm.config.link.msg && (
        String(_vm.config.msg).includes('Certificado') || String(_vm.config.msg).includes('certificado')
      ))?_c('div',{staticClass:"redirectAgendaDiv"},[_c('v-btn',{attrs:{"href":"https://agendaonline.gerencert.app?T-5a6f64C-8a0193A-626df1F-2P-14","target":"_blank"}},[_vm._v("Renove Agora! Apenas R$ 140,00")])],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.InformacaoSefaz)?_c('v-layout',{staticClass:"panel",class:'red lighten-2',attrs:{"id":"persistInfo","align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticClass:"message deftColor"},[_c('strong',{staticStyle:{"color":"black"},attrs:{"color":"black"}},[_vm._v("No momento o Motor Fiscal não está baixando os CTEs devido a um problema na Sefaz - "),_c('a',{attrs:{"href":"https://www.cte.fazenda.gov.br/portal/principal.aspx"}},[_vm._v("Leia o Comunicado!")])])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},nativeOn:{"click":function($event){return _vm.desativarNewFeatureInfoSefaz()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Fechar essa notificação")])],1)],1):_vm._e(),_vm._v(" "),(_vm.buscaCTE)?_c('v-layout',{staticClass:"panel",class:'yellow lighten-2',attrs:{"id":"persistInfo","align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticClass:"message deftColor"},[_c('strong',{staticStyle:{"color":"black"},attrs:{"color":"black"}},[_vm._v("Devido a alta quantidade de notas a busca pode levar alguns minutos, agradecemos a compreensão!")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},nativeOn:{"click":function($event){return _vm.desativarNewFeature()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Fechar essa notificação")])],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":(_vm.dialogWidthRC + "px")},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Renovar Certificado")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog=false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',[_c('v-card-text',{staticClass:"form_empresa_inputs",staticStyle:{"width":"90%","margin":"auto"}},[_c('CertDigitalElement',{attrs:{"dialog":_vm.dialog,"showInfoCertificado":_vm.showInfoCertificado}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notificacoes_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cd24e80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notificacoes_vue__ = __webpack_require__(491);
function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8cd24e80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notificacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cd24e80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notificacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */,
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"content-class":"custom_menu","close-on-content-click":false,"bottom":"","offset-y":"","nudge-bottom":"15","nudge-left":"270"}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#fff","d":"M16,17H7V10.5C7,8 9,6 11.5,6C14,6 16,8 16,10.5M18,16V10.5C18,7.43 15.86,4.86 13,4.18V3.5A1.5,1.5 0 0,0 11.5,2A1.5,1.5 0 0,0 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18M11.5,22A2,2 0 0,0 13.5,20H9.5A2,2 0 0,0 11.5,22Z"}})]),_vm._v(" "),_c('span',{staticClass:"custom_badge"},[_vm._v(_vm._s(_vm.naoVistos.length))])]),_vm._v(" "),_c('v-layout',{staticClass:"notificacoes"},[_c('v-flex',[_c('v-card',{staticClass:"panel"},[_c('v-toolbar',{staticStyle:{"background-color":"#fff","box-shadow":"#e0e0e0 1px 1px 1px 1px"}},[_c('v-toolbar-title',{staticClass:"grey-sm-title"},[_vm._v("Novas notificações ("+_vm._s(_vm.naoVistos.length)+") Total: "+_vm._s(_vm.naoVistos.length + _vm.vistos.length))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.naoVistos.length > 0)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{staticClass:"grey-sm-title",staticStyle:{"font-size":"9px !important","cursor":"pointer"},attrs:{"slot":"activator"},on:{"click":function($event){return _vm.marcarVisto(_vm.naoVistos, 'all')}},slot:"activator"},[_vm._v("Visualizar todas")]),_vm._v(" "),_c('span',[_vm._v("Marcar todas notificações como lidas")])]):_vm._e()],1),_vm._v(" "),(this.loading)?_c('v-progress-linear',{staticStyle:{"margin":"0"},attrs:{"color":"teal","indeterminate":true}}):_vm._e(),_vm._v(" "),(!this.loading)?_c('v-list',{attrs:{"two-line":"","subheader":""}},[_vm._l((_vm.setArray(this.naoVistos)),function(item,i){return _c('v-list-tile',{key:item._id,staticClass:"notificacao naoVista",attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[(item.tipo !='zipFechamento')?_c('v-list-tile-title',[_vm._v(_vm._s(item.tipo)+" "+_vm._s(item.componente))]):_c('v-list-tile-title',[_vm._v(_vm._s(item.componente))]),_vm._v(" "),(item.tipo !='zipFechamento')?_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.desc))]):_c('v-list-tile-sub-title',[_c('a',{attrs:{"target":"_blank","href":_vm.gerarLinkZIP(item.desc)}},[_vm._v("Clique para baixar!")])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(new Date(item.dtReg).toLocaleDateString())+" - "+_vm._s(new Date(item.dtReg).toLocaleTimeString()))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","ripple":""},nativeOn:{"click":function($event){return _vm.marcarVisto(item, 'parse')}},slot:"activator"},[_c('v-icon',{staticClass:"grey lighten-1 white--text",staticStyle:{"border-radius":"50%","font-size":"12px","padding":"2px"}},[_vm._v("check")])],1),_vm._v(" "),_c('span',[_vm._v("Marcar como lida")])],1)],1)],1)}),_vm._v(" "),_vm._l((_vm.setArray(this.vistos)),function(item,i){return _c('v-list-tile',{key:item._id,staticClass:"notificacao",attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[(item.tipo !='zipFechamento')?_c('v-list-tile-title',[_vm._v(_vm._s(item.tipo)+" "+_vm._s(item.componente))]):_c('v-list-tile-title',[_vm._v(_vm._s(item.componente))]),_vm._v(" "),(item.tipo !='zipFechamento')?_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.desc))]):_c('v-list-tile-sub-title',[_c('a',{attrs:{"target":"_blank","href":_vm.gerarLinkZIP(item.desc)}},[_vm._v("Clique para baixar!")])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(new Date(item.dtReg).toLocaleDateString())+" - "+_vm._s(new Date(item.dtReg).toLocaleTimeString()))])],1)],1)}),_vm._v(" "),_c('v-layout',{staticClass:"grey-sm-title",staticStyle:{"height":"36px","margin-top":"9px"},attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[(!_vm.msg || _vm.msg == '')?_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(_vm.naoVistos.length == 0 && _vm.vistos.length == 0 ? 'Não há notificações.' : ''))]):(_vm.msg && _vm.msg != '')?_c('span',{staticStyle:{"cursor":"pointer","text-align":"center"}},[_vm._v(_vm._s(_vm.msg))]):_vm._e(),_vm._v(" "),((!_vm.msg || _vm.msg == '') && _vm.empresa)?_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getNotificacoes()}}},[_vm._v("Ver mais")]):_vm._e()])],2):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('v-navigation-drawer',{class:[this.logado ? 'side_active' : 'side_desable', this.miniVariant ? 'hover_fnc' : ''],attrs:{"persistent":"","mini-variant":_vm.miniVariant,"clipped":_vm.clipped,"width":195,"enable-resize-watcher":"","fixed":"","app":"","id":'sideBar',"miniVariantWidth":75},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-layout',{staticClass:"v-list__tile v-list__tile--active primary--text",attrs:{"row":"","id":"logo"}},[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","id":"lineLogo"}},[(!this.miniVariant)?_c('router-link',{attrs:{"to":'/DashBoard'}},[_c('img',{attrs:{"id":"logo-image","src":__webpack_require__(101),"alt":"Logo da Empresa(Motor Fiscal)"}})]):_vm._e(),_vm._v(" "),(this.miniVariant)?_c('router-link',{attrs:{"to":'/DashBoard'}},[_c('img',{attrs:{"id":"logo-image","src":__webpack_require__(152),"alt":"Logo da Empresa(Motor Fiscal)"}})]):_vm._e()],1)],1)],1),_vm._v(" "),(this.logado)?_c('span',{staticClass:"aside_body"},[_c('v-layout',{attrs:{"row":"","wrap":"","id":"userCard"}},[(!this.miniVariant)?_c('v-flex',{attrs:{"d-flex":"","xs12":"","order-xs5":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":"","column":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-card-text',[(_vm.avatarProfile != '')?_c('img',{attrs:{"id":"userLogo","src":_vm.avatarProfile,"alt":"Avatar de Perfil(Motor Fiscal)"}}):_c('img',{attrs:{"id":"userLogo","src":__webpack_require__(153),"alt":"Avatar de Perfil(Motor Fiscal)"}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","id":"userInfo"},on:{"click":function($event){return _vm.$router.push('/ePerfil')}}},[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-card-text',[_c('div',{attrs:{"id":"userName"}},[_vm._v("\n                      "+_vm._s(_vm.conta != undefined && _vm.conta.nome != undefined  ? _vm.conta.nome : 'Aaron Chavez')+"\n                    ")]),_vm._v(" "),_c('div',{attrs:{"id":"userEmail","title":_vm.conta != undefined ? _vm.conta.email : 'aaron.cha@themeon.net'}},[_vm._v(_vm._s(_vm.conta != undefined ? _vm.conta.email : 'aaron.cha@themeon.net'))])])],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"d-none",attrs:{"id":"userInfoMenu"}},[_c('ul',[_c('li',[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#25476a","d":"M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"}})]),_vm._v(" "),_c('span',{staticClass:"descricao"},[_c('router-link',{attrs:{"to":"/ePerfil"}},[_vm._v("Perfil")])],1)]),_vm._v(" "),(this.seeConfig)?_c('li',[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#25476a","d":"M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z"}})]),_vm._v(" "),_c('span',{staticClass:"descricao"},[_c('router-link',{attrs:{"to":"/configuracoes"}},[_vm._v("Configurações")])],1)]):_vm._e(),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.deslogar()}}},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#25476a","d":"M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13"}})]),_vm._v(" "),_c('span',{staticClass:"descricao"},[_vm._v("Deslogar")])])])]),_vm._v(" "),_vm._l((_vm.items),function(item,i){return (
          ( item.title != 'Configurações' && item.title != 'Relátorio' && item.title != 'Valida OCR' )
          || 
          ( item.title == 'Configurações' && _vm.seeConfig )
          || 
          ( item.title == 'Relátorio' && _vm.$canAccessRelatorio.includes(_vm.conta.email) )
          ||
          ( item.title == 'Valida OCR' && _vm.$canAccessRelatorio.includes(_vm.conta.email) )
        )?_c('div',{key:i,attrs:{"id":"subMenu"}},[(!item.subLinks)?_c('v-list-tile',{class:'navItem ',attrs:{"id":item.rota,"value":"true"},nativeOn:{"click":function($event){return _vm.$router.push(item.rota)}}},[_c('v-list-tile-action',[_c('v-icon',{style:(item.rota === '/loja' && 'color:orange!important'),attrs:{"color":"teal","dark":""}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('span',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)])],1):_c('v-list-group',{class:'navItem ',scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile',{attrs:{"value":"true","id":item.rota}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"teal","dark":""}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)]},proxy:true}],null,true)},[_vm._v(" "),_vm._l((item.subLinks),function(sublink){return _c('v-list-tile',{key:sublink.text,class:'navItem ',attrs:{"value":"true","id":sublink.rota},nativeOn:{"click":function($event){return _vm.$router.push(sublink.rota)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"teal","dark":""}},[_vm._v(_vm._s(sublink.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(sublink.title)}})],1)],1)})],2)],1):_vm._e()})],2):_vm._e()],1)],1),_vm._v(" "),(this.logado)?_c('div',{staticStyle:{"position":"relative"}},[_c('v-toolbar',{style:(_vm.homolog ? 'background-color: #e21f1f' : ''),attrs:{"dark":"","clipped-left":_vm.clipped,"id":"menuBar"}},[(this.$router.history.current.path != '/primeiroAcesso')?_c('div',{staticClass:"custom_hamb",on:{"click":function($event){return _vm.toggleSideMenu()}}},[_c('div',{staticClass:"custom_line"}),_vm._v(" "),_c('div',{staticClass:"custom_line"}),_vm._v(" "),_c('div',{staticClass:"custom_line"})]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.logado)?_c('div',{attrs:{"id":"panelEmpresa"}},[_c('v-flex',{attrs:{"xs12":"","sm11":"","d-flex":""}},[_c('v-autocomplete',{staticClass:"empSelect menuInput",attrs:{"id":"inputMenu","hide-no-data":"","hide-selected":"","items":_vm.empresas,"item-text":_vm.itemText,"item-value":"_id","return-object":"","flat":"","single-line":"","disabled":_vm.liberarInput === 0,"menu-props":"offsetY","outline":"","textarea":"","no-data-text":"Nenhuma empresa cadastrada"},on:{"change":_vm.handleChange,"focus":function($event){_vm.emprSelect = ''},"input":_vm.handleFocus,"click":function($event){_vm.emprSelect = ''},"blur":_vm.verificarCampo},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px"},attrs:{"dark":"","color":"teal"}},[_vm._v("domain")]),_vm._v(" "),_c('small',{attrs:{"id":"empRazao"}},[_vm._v(_vm._s(props.item.razao))]),_vm._v(" "),_c('small',{attrs:{"id":"empCnpj"}},[_vm._v(_vm._s(props.item.apelido && ((props.item.apelido) + " - "))+" "+_vm._s(props.item.cnpj.length > 11 ? ("CNPJ:  " + (props.item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"))) : props.item.cnpj.length == 11 ? ("CPF: " + (props.item.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")) + " ") : ''))]),_vm._v(" "),(props.item.not_admin)?_c('v-tooltip',{staticStyle:{"position":"absolute","right":"40px","margin-top":"4px"},attrs:{"bottom":""}},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"slot":"activator","viewBox":"0 0 24 24"},slot:"activator"},[_c('path',{attrs:{"fill":"#009688","d":"M16,9C18.33,9 23,10.17 23,12.5V15H17V12.5C17,11 16.19,9.89 15.04,9.05L16,9M8,9C10.33,9 15,10.17 15,12.5V15H1V12.5C1,10.17 5.67,9 8,9M8,7A3,3 0 0,1 5,4A3,3 0 0,1 8,1A3,3 0 0,1 11,4A3,3 0 0,1 8,7M16,7A3,3 0 0,1 13,4A3,3 0 0,1 16,1A3,3 0 0,1 19,4A3,3 0 0,1 16,7M9,16.75V19H15V16.75L18.25,20L15,23.25V21H9V23.25L5.75,20L9,16.75Z"}})]),_vm._v(" "),_c('span',[_vm._v("Empresa pertence a outra conta")])]):(props.item.faturamento)?_c('v-tooltip',{staticStyle:{"position":"absolute","right":"40px","margin-top":"4px"},attrs:{"bottom":""}},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"slot":"activator","viewBox":"0 0 24 24"},slot:"activator"},[_c('path',{staticStyle:{"fill":"#dba400","border":"stroke","stroke":"black","stroke-width":"0.5","stroke-linecap":"round","stroke-dasharray":"1000","stroke-dashoffset":"1000","-webkit-animation":"dash-data-v-177e43c8 3s linear alternate infinite","animation":"dash-data-v-177e43c8 3s linear alternate infinite"},attrs:{"d":"M19,22H5V20H19V22M17,10C15.58,10 14.26,10.77 13.55,12H13V7H16V5H13V2H11V5H8V7H11V12H10.45C9.35,10.09 6.9,9.43 5,10.54C3.07,11.64 2.42,14.09 3.5,16C4.24,17.24 5.57,18 7,18H17A4,4 0 0,0 21,14A4,4 0 0,0 17,10Z"}})]),_vm._v(" "),_c('span',[_vm._v("Empresa de faturamento")])]):_vm._e()]}},{key:"selection",fn:function(props){return [_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px"},attrs:{"dark":"","color":"white"}},[_vm._v("domain")]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.emprSelect = ''},"focus":function($event){_vm.emprSelect = ''}}},[_c('small',[_vm._v(_vm._s(props.item.razao))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(props.item.apelido && ((props.item.apelido) + " - "))+" "+_vm._s(props.item.cnpj.length > 11 ? ("CNPJ:  " + (props.item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"))) : props.item.cnpj.length == 11 ? ("CPF: " + (props.item.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")) + " ") : ''))]),_vm._v(" "),(props.item.not_admin)?_c('v-tooltip',{staticStyle:{"position":"absolute","right":"40px","margin-top":"4px"},attrs:{"bottom":""}},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"slot":"activator","viewBox":"0 0 24 24"},slot:"activator"},[_c('path',{attrs:{"fill":"#ffffff","d":"M16,9C18.33,9 23,10.17 23,12.5V15H17V12.5C17,11 16.19,9.89 15.04,9.05L16,9M8,9C10.33,9 15,10.17 15,12.5V15H1V12.5C1,10.17 5.67,9 8,9M8,7A3,3 0 0,1 5,4A3,3 0 0,1 8,1A3,3 0 0,1 11,4A3,3 0 0,1 8,7M16,7A3,3 0 0,1 13,4A3,3 0 0,1 16,1A3,3 0 0,1 19,4A3,3 0 0,1 16,7M9,16.75V19H15V16.75L18.25,20L15,23.25V21H9V23.25L5.75,20L9,16.75Z"}})]),_vm._v(" "),_c('span',[_vm._v("Empresa pertence a outra conta")])]):_vm._e(),_vm._v(" "),(props.item.faturamento)?_c('v-tooltip',{staticStyle:{"position":"absolute","right":"40px","margin-top":"4px"},attrs:{"bottom":""}},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"slot":"activator","viewBox":"0 0 24 24"},slot:"activator"},[_c('path',{staticStyle:{"fill":"#dba400","border":"stroke","stroke":"black","stroke-width":"0.5","stroke-linecap":"round","stroke-dasharray":"1000","stroke-dashoffset":"1000","-webkit-animation":"dash-data-v-177e43c8 3s linear alternate infinite","animation":"dash-data-v-177e43c8 3s linear alternate infinite"},attrs:{"d":"M19,22H5V20H19V22M17,10C15.58,10 14.26,10.77 13.55,12H13V7H16V5H13V2H11V5H8V7H11V12H10.45C9.35,10.09 6.9,9.43 5,10.54C3.07,11.64 2.42,14.09 3.5,16C4.24,17.24 5.57,18 7,18H17A4,4 0 0,0 21,14A4,4 0 0,0 17,10Z"}})]),_vm._v(" "),_c('span',[_vm._v("Empresa de faturamento")])]):_vm._e()]}}],null,false,2498672110),model:{value:(_vm.emprSelect),callback:function ($$v) {_vm.emprSelect=$$v},expression:"emprSelect"}},[_c('template',{slot:"label"},[_c('small',{staticStyle:{"color":"white","padding-left":"10px"}},[_vm._v(_vm._s(_vm.liberarInput === 0 ? 'Carregando' : 'Pesquisar empresa:'))])])],2)],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('Notificacoes',{attrs:{"empresa":this.select,"conta":this.conta}}),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.show($event)}}},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#fff","d":"M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"}})])]),_vm._v(" "),_c('v-menu',{attrs:{"position-x":_vm.x,"position-y":_vm.y,"absolute":"","offset-y":"","bottom":"","content-class":"custom_menu","nudge-bottom":"15"},model:{value:(_vm.menuConfig),callback:function ($$v) {_vm.menuConfig=$$v},expression:"menuConfig"}},[_c('v-list',{staticClass:"dropDown",attrs:{"id":"perfil"}},[_c('v-list-tile',{staticClass:"list",nativeOn:{"click":function($event){return _vm.$router.push('/ePerfil')}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"}})]),_vm._v(" "),_c('v-list-tile-title',{staticClass:"grey_title"},[_vm._v("Perfil")])],1),_vm._v(" "),(this.seeConfig)?_c('v-list-tile',{staticClass:"list",nativeOn:{"click":function($event){return _vm.$router.push('/configuracoes')}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z"}})]),_vm._v(" "),_c('v-list-tile-title',{staticClass:"grey_title"},[_vm._v("Configurações")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{staticClass:"list",nativeOn:{"click":function($event){return _vm.deslogar()}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13"}})]),_vm._v(" "),_c('v-list-tile-title',{staticClass:"grey_title"},[_vm._v("Deslogar")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('persistInfo',{attrs:{"empresa":this.select,"conta":this.conta}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsultaNotas_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64cd3de0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsultaNotas_vue__ = __webpack_require__(771);
function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64cd3de0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsultaNotas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64cd3de0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsultaNotas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonTable_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f0e5ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonTable_vue__ = __webpack_require__(758);
function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06f0e5ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f0e5ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);







var ClientesService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ClientesService, _CommonService);

    function ClientesService() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ClientesService);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClientesService.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ClientesService)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ClientesService, [{
        key: "getClientes",
        value: function getClientes(page, qntd, id_empresa) {
            var url = "clientes/cliente/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntd;
            // https://app.motorfiscal.com.br/teste/fornecedores/fornecedor/5b4cc42de471d50362ddce00
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return failed;
            });
        }
    }]);

    return ClientesService;
}(__WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ClientesService);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);







var ProdutosServices = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ProdutosServices, _CommonService);

    function ProdutosServices(http) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ProdutosServices);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProdutosServices.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ProdutosServices)).call(this, http));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ProdutosServices, [{
        key: "getProdutos",
        value: function getProdutos(page, qntd, id_empresa, range, filtro, tipo) {
            var url = "produtos/produto/" + id_empresa + "?tipo=" + tipo + "&_page=" + page + "&_pagesize=" + qntd;
            // https://app.motorfiscal.com.br/teste/fornecedores/fornecedor/5b4cc42de471d50362ddce00
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                return false;
            });
        }
    }]);

    return ProdutosServices;
}(__WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ProdutosServices);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);







var FornecedoresService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FornecedoresService, _CommonService);

    function FornecedoresService() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FornecedoresService);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FornecedoresService.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FornecedoresService)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FornecedoresService, [{
        key: "getFornecedores",
        value: function getFornecedores(page, qntd, id_empresa) {
            var url = "fornecedores/fornecedor/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntd;
            return this._resource.get(url).then(function (success) {
                return success.body;
            }, function (failed) {
                console.log(failed);
            });
        }
    }]);

    return FornecedoresService;
}(__WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FornecedoresService);

/***/ }),
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfe_Nfe_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableNfe = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableNfe, _Table);

    function TableNfe(component) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableNfe);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableNfe.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableNfe)).call(this, component));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableNfe, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers;
            var nameTipo = this.component != undefined ? this.component.tipo == 'recebida' ? "Fornecedor" : 'Cliente' : '';
            var valueTipo = this.component != undefined ? this.component.tipo == 'recebida' ? "emitNome" : 'destNome' : '';
            headers = [{ text: "Ações", value: "acoes", show: true, pesq: false, enable: false }, { text: "Data de Emissão", value: "emissao", show: true, pesq: false, enable: true }, { text: "Número", value: "numero", show: true, pesq: true, enable: true }, { text: "Série", value: "serie", show: true, pesq: false, enable: true }, { text: nameTipo, value: valueTipo, show: true, pesq: false, enable: true }, { text: "Valor da NF-e", value: "valor", show: true, pesq: false, enable: true }, { text: "Valor do PIS", value: "valorPis", show: true, pesq: false, enable: true }, { text: "Valor do IPI", value: "valorIpi", show: true, pesq: false, enable: true }, { text: "Valor do ICMS", value: "valorIcms", show: true, pesq: false, enable: true }, { text: "Valor do COFINS", value: "valorCofins", show: true, pesq: false, enable: true }, { text: "Valor do FCP", value: "valorFcp", show: true, pesq: false, enable: true }, { text: "Valor do BCST", value: "valorBcst", show: true, pesq: false, enable: true }, { text: "CNPJ do Emitente", value: "emitCnpj", show: true, pesq: true, enable: true }, { text: "Chave de Acesso", value: "chave", show: true, pesq: true, enable: true }, { text: "IE", value: "emitIe", show: true, pesq: true, enable: true }, { text: "CNPJ/CPF do Destinatário", value: "destCnpj", show: true, pesq: false, enable: true }, { text: "Origem", value: "origem", show: true, pesq: false, enable: true }, { text: "Protocolada", value: "protocolada", show: true, pesq: false, enable: true }, { text: "Status", value: "status", show: true, pesq: false, enable: true }, { text: "Tipo", value: "tipo", show: true, pesq: false, enable: true }, { text: "Transportados", value: "transportados", show: true, pesq: false, enable: true }, { text: "UF de Origem", value: "ufOrigem", show: true, pesq: false, enable: true }, { text: "Manifestacao", value: "manifestacao", show: true, pesq: false, enable: true }, { text: "Data de Importação", value: "dtImportacao", show: true, pesq: false, enable: true }, { text: "Vínculo", value: "vinculo", show: true, pesq: false, enable: true }, { text: "Status ERP", value: "statusErp", show: true, pesq: false, enable: true }, { text: "Status XML FTP", value: "ftpPython", show: true, pesq: false, enable: true }, { text: "Status PDF FTP", value: "ftpPythonPdf", show: true, pesq: false, enable: true }, { text: "log integração XML FTP", value: "logErroFtpXml", show: false, pesq: false, enable: true }, { text: "log integração PDF FTP", value: "logErroFtpPdf", show: false, pesq: false, enable: true }, { text: "log integração ERP", value: "log_statusErp", show: false, pesq: false, enable: true }, { text: "Id Fluig", value: "id_fluig", show: true, pesq: true, enable: true }, { text: "log integração ERP Dois", value: "log_statusErpDois", show: false, pesq: false, enable: true }, { text: "StatusErp Dois", value: "statusErpDois", show: true, pesq: false, enable: true }, { text: "Vencimento", value: "duplicata", show: true, pesq: false, enable: true }, { text: "Produtos", value: "produtos", show: true, pesq: false, enable: true }, { text: "xmlCce", value: "xmlCce", show: false, pesq: false, enable: false }, { text: "cte", value: "cte", show: false, pesq: false, enable: false }, { text: "Danfe", value: "danfe", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }, { text: "id_empresa", value: "empresa", show: false, pesq: false, enable: false }, { text: "docZip", value: "docZip", show: false, pesq: false, enable: false }, { text: "Natureza Operação", value: "natOp", show: true, pesq: true, enable: true }, { text: "Informações adicionais", value: "inf_ad", show: true, pesq: false, enable: true }, { text: "Sistema", value: "verProc", show: true, pesq: false, enable: true }, { text: "Data ERP", value: "data_erp", show: true, pesq: false, enable: true }, { text: "Departamento", value: "departamento", show: true, pesq: false, enable: true }, { text: "CNPJ da Transportadora", value: "trans_cnpj", show: true, pesq: true, enable: true }, { text: "Nome da Transportadora", value: "trans_nome", show: true, pesq: true, enable: true }, { text: "Peso Líquido (em kg)", value: "trans_pesoL", show: true, pesq: true, enable: true }, { text: "Peso Bruto (em kg)", value: "trans_pesoB", show: true, pesq: true, enable: true }, { text: "Espécie dos volumes transportados", value: "trans_esp", show: true, pesq: true, enable: true }, { text: "Quantidade de volumes transportados", value: "trans_qVol", show: true, pesq: true, enable: true }, { text: "Modalidade do frete", value: "trans_modFrete", show: true, pesq: true, enable: true }, { text: "Pós Fechametno", value: "posFechamento", show: true, pesq: false, enable: true }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {
            var newArray = arrayNotas;
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfe_Nfe_js__["a" /* default */](notas[i]._id, notas[i].empresa, notas[i].chave, notas[i].emitNome, notas[i].destNome, notas[i].emitCnpj, notas[i].emitCpf, notas[i].emitIe, notas[i].destCnpj, notas[i].destCpf, notas[i].origem, notas[i].protocolada, notas[i].serie, notas[i].status, notas[i].tipo, notas[i].transportados, notas[i].ufOrigem, notas[i].manifestacao, notas[i].numero, notas[i].valorCofins, notas[i].valorIcms, notas[i].valorPis, notas[i].valorIpi, notas[i].valorFcp, notas[i].valorBcst, notas[i].valor, notas[i].dtImportacao, notas[i].emissao, notas[i].danfe, notas[i].xmlCce, notas[i].cte, notas[i].customValues, notas[i].duplicata, notas[i].produtos, notas[i]['statusErp'], notas[i].ftpPython, notas[i].ftpPythonPdf, notas[i].logErroFtpXml, notas[i].logErroFtpPdf, notas[i].log_statusErp, notas[i].id_fluig, notas[i].log_statusErpDois, notas[i].statusErpDois, notas[i].docZip, notas[i].natOp, notas[i].inf_ad, notas[i].verProc, notas[i].data_erp, notas[i].departamento, notas[i].trans_cnpj, notas[i].trans_nome, notas[i].trans_pesoL, notas[i].trans_pesoB, notas[i].trans_esp, notas[i].trans_qVol, notas[i].trans_modFrete, notas[i].posFechamento));
                this.pagination.sortBy = 'emissao';
                this.pagination.descending = true;
                // arrayNotas.sort(function (a, b) {
                //     return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
                // });
            }
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableNfe;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableNfe);

/***/ }),
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfse_Nfse_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableNfse = function (_Table) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableNfse, _Table);

  function TableNfse() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableNfse);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableNfse.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableNfse)).call(this));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableNfse, [{
    key: "getHeaders",
    value: function getHeaders() {
      var nfseTomados = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var headers = [{ text: "Ações", value: "acoes", show: true, pesq: false, enable: false }, { text: "Data de Emissão", value: "dtEmissaoNfe", show: true, width: "500px", pesq: false, enable: true }, { text: "Número", value: "numeroNfe", show: true, pesq: true, enable: true }, { text: "Valor do Crédito", value: "vlrCredito", show: true, pesq: false, enable: true }, { text: "Valor do Serviço", value: "vlrServico", show: true, pesq: false, enable: true }, { text: "ISS Retido", value: "ISSRetido", show: true, pesq: false, enable: true }, { text: "Código do Serviço", value: "codServico", show: true, pesq: false, enable: true }, { text: "Código de Verificação", value: "codVerificacao", show: true, pesq: false, enable: true }, { text: "Aliquota do Serviço (%)", value: "aliqServico", show: true, pesq: false, enable: true }, { text: "Status", value: "statusNFe", show: true, pesq: false, enable: true }, { text: "Origem", value: "origem", show: true, pesq: false, enable: true }, { text: "Opção do Simples", value: "opcaoSimples", show: true, pesq: false, enable: true }, { text: "Número do Lote", value: "numLote", show: true, pesq: true, enable: true }, { text: "Número RPS", value: "numRPS", show: true, pesq: false, enable: true }, { text: "Série RPS", value: "serieRPS", show: true, pesq: false, enable: true }, { text: "Tipo RPS", value: "tipoRPS", show: true, pesq: false, enable: true }, { text: "Data Emissão RPS", value: "dtEmissaoRPS", show: true, pesq: false, enable: true }, { text: "CNPJ/CPF Tomador", value: "cnpjCpf", show: true, pesq: true, enable: true }, { text: "Razão Social Tomador", value: "razao", show: true, pesq: true, enable: true }, { text: "Inscrição Tomador", value: "insc", show: true, pesq: true, enable: true }, { text: "Tributação", value: "tribNfe", show: true, pesq: false, enable: true }, { text: "Valor do ISS", value: "vlrISS", show: true, pesq: false, enable: true }, { text: "Discriminação", value: "discriminacao", show: true, pesq: false, enable: true }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }, { text: "pathPdf", value: "pathPdf", show: false, pesq: false, enable: false }, { text: "pathPdfMotor", value: "pathPdfMotor", show: false, pesq: false, enable: true }, { text: "gzipPath", value: "gzipPath", show: false, pesq: false, enable: false }, { text: "id_empresa", value: "empresa", show: false, pesq: false, enable: false }, { text: "Pis", value: "PIS", show: true, pesq: true, enable: true }, { text: "COFINS", value: "COFINS", show: true, pesq: false, enable: true }, { text: "CSLL", value: "CSLL", show: true, pesq: false, enable: true }, { text: "INSS", value: "INSS", show: true, pesq: false, enable: true }, { text: "IR", value: "IR", show: true, pesq: false, enable: true }, { text: "Código Lei 116", value: "codLei", show: true, pesq: false, enable: true }, { text: "Descrição Lei 116", value: "lei", show: true, pesq: false, enable: false }, { text: "Data ERP", value: "data_erp", show: true, pesq: false, enable: true }, { text: "Nome Município", value: "nome_municipio", show: true, pesq: true, enable: true }, { text: "Simples Nacional", value: "simples_nacional", show: true, pesq: true, enable: true }, { text: "NFTS", value: "status_escrituracao", show: true, pesq: false, enable: true }, { text: "log integração ERP", value: "log_statusErp", show: false, pesq: false, enable: true }, { text: "Id Fluig", value: "id_fluig", show: true, pesq: true, enable: true }, { text: "log integração ERP Dois", value: "log_statusErpDois", show: false, pesq: false, enable: true }, { text: "StatusErp Dois", value: "statusErpDois", show: true, pesq: false, enable: true }, { text: "log_escrituracao", value: "log_escrituracao", show: false, pesq: false, enable: true }, { text: "Número do pedido", value: "numeroPedido", show: true, pesq: true, enable: true }, {
        text: "Pós Fechamento",
        value: "posFechamento",
        show: true,
        pesq: true,
        enable: true
      }, { text: "Valor Recebido", value: "valorTotalRecebido", show: true, pesq: true, enable: true }, { text: "Provedor", value: "provedor", show: true, pesq: true, enable: true }, { text: "Documento", value: "documento", show: true, pesq: true, enable: true }, { text: "Nome Arquvo", value: "nomeArquivo", show: true, pesq: true, enable: true }];

      if (nfseTomados) {
        headers.push({ text: "Status da Emissão", value: "statusEmissao", show: true, pesq: true, enable: true }, { text: "Data serviço", value: "dataServico", show: true, pesq: true, enable: true }, { text: "Emissao Motor", value: "emissaoMotor", show: false, pesq: false, enable: true }, { text: "Erro Emissao", value: "erroEmissao", show: false, pesq: false, enable: true }, { text: "log_escrituracao", value: "log_escrituracao", show: false, pesq: false, enable: true }, { text: "Pdv", value: "pdv", show: true, pesq: false, enable: true }, { text: "pathPdfMotor", value: "pathPdfMotor", show: false, pesq: false, enable: false }, { text: "Numero do Pdv", value: "numero_pdv", show: true, pesq: false, enable: true }, { text: "Data Pdv", value: "data_pdv", show: true, pesq: false, enable: true });
      }

      return headers;
    }
  }, {
    key: "setNota",
    value: function setNota(arrayNotas, notas) {
      var newArray = arrayNotas;
      this.loading = false;
      for (var i = 0; i < notas.length; i++) {
        newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfse_Nfse_js__["a" /* default */](notas[i]._id, notas[i].empresa, notas[i].dtEmissaoNfe, notas[i].numeroNfe, notas[i].vlrCredito, notas[i].vlrServico, notas[i].ISSRetido, notas[i].codServico, notas[i].codVerificacao, notas[i].aliqServico, notas[i].statusNFe, notas[i].origem, notas[i].tipo, notas[i].opcaoSimples, notas[i].numLote, notas[i].numRPS, notas[i].serieRPS, notas[i].tipoRPS, notas[i].dtEmissaoRPS, notas[i].cnpjCpfTomador, notas[i].razaoTomador, notas[i].inscTomador, notas[i].tribNfe, notas[i].ISS, notas[i].discriminacao, notas[i].pathPdf, notas[i].pathPdfMotor, notas[i].gzipPath, notas[i].customValues, notas[i].statusErp, notas[i].PIS, notas[i].COFINS, notas[i].CSLL, notas[i].INSS, notas[i].IR, notas[i].lei ? notas[i].lei.codigo : undefined, notas[i].lei ? notas[i].lei : undefined, notas[i].statusEmissao, notas[i].razaoTomador, notas[i].inscPrestador, notas[i].emissaoMotor, notas[i].dataServico, notas[i].codMun, notas[i].cnpjCpfTomador, notas[i].cnpjCpfPrestador, notas[i].statusDES, notas[i].erroDES, notas[i].erroEmissao, notas[i].data_erp, notas[i].status_escrituracao, notas[i].log_statusErp, notas[i].id_fluig, notas[i].log_statusErpDois, notas[i].statusErpDois, notas[i].log_escrituracao, notas[i].pdv, notas[i].numero_pdv, notas[i].data_pdv, notas[i].nome_municipio ? notas[i].nome_municipio : '', notas[i].simples_nacional ? notas[i].simples_nacional.descricao : '', notas[i].posFechamento, notas[i].numeroPedido, notas[i].valorTotalRecebido, notas[i].provedor, notas[i].documento, notas[i].tipoTomador));
        this.pagination.sortBy = "dtEmissaoNfe";
        this.pagination.descending = true;
      }
      if (arrayNotas.length > 0) {
        arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
        return arrayNotas;
      } else {
        return newArray;
      }
    }
  }]);

  return TableNfse;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableNfse);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfse_Nfse_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableNfse = function (_Table) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableNfse, _Table);

  function TableNfse() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableNfse);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableNfse.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableNfse)).call(this));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableNfse, [{
    key: "getHeaders",
    value: function getHeaders() {
      var nfseDES = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var headers = [{ text: "Ações", value: "acoes", show: true, pesq: false, enable: false }, {
        text: "Data de Emissão",
        value: "dtEmissaoNfe",
        show: true,
        width: "500px",
        pesq: false,
        enable: true
      }, {
        text: "Número",
        value: "numeroNfe",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Valor do Crédito",
        value: "vlrCredito",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Valor do Serviço",
        value: "vlrServico",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "ISS Retido",
        value: "ISSRetido",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Código do Serviço",
        value: "codServico",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Código de Verificação",
        value: "codVerificacao",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Aliquota do Serviço (%)",
        value: "aliqServico",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Data ERP",
        value: "data_erp",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Status",
        value: "statusNFe",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "NFTS",
        value: "status_escrituracao",
        show: true,
        pesq: false,
        enable: true
      }, { text: "log integração ERP", value: "log_statusErp", show: false, pesq: false, enable: true }, { text: "Id Fluig", value: "id_fluig", show: true, pesq: true, enable: true }, { text: "log integração ERP Dois", value: "log_statusErpDois", show: false, pesq: false, enable: true }, { text: "StatusErp Dois", value: "statusErpDois", show: true, pesq: false, enable: true }, {
        text: "Origem",
        value: "origem",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Opção do Simples",
        value: "opcaoSimples",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Número do Lote",
        value: "numLote",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Número RPS",
        value: "numRPS",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Série RPS",
        value: "serieRPS",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Tipo RPS",
        value: "tipoRPS",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Data Emissão RPS",
        value: "dtEmissaoRPS",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "CNPJ/CPF Prestador",
        value: "cnpjCpf",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Razão Social Prestador",
        value: "razao",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Inscrição Prestador",
        value: "insc",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Tributação",
        value: "tribNfe",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Valor do ISS",
        value: "vlrISS",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Discriminação",
        value: "discriminacao",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Status ERP",
        value: "statusErp",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "_id",
        value: "_id",
        show: false,
        pesq: false,
        enable: false
      }, {
        text: "pathPdf",
        value: "pathPdf",
        show: false,
        pesq: false,
        enable: false
      }, {
        text: "pathPdfMotor",
        value: "pathPdfMotor",
        show: false,
        pesq: false,
        enable: true
      }, {
        text: "gzipPath",
        value: "gzipPath",
        show: false,
        pesq: false,
        enable: false
      }, {
        text: "log_escrituracao",
        value: "log_escrituracao",
        show: false,
        pesq: false,
        enable: false
      }, {
        text: "id_empresa",
        value: "empresa",
        show: false,
        pesq: false,
        enable: false
      }, {
        text: "Pis",
        value: "PIS",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "COFINS",
        value: "COFINS",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "CSLL",
        value: "CSLL",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "INSS",
        value: "INSS",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "IR",
        value: "IR",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Código Lei 116",
        value: "codLei",
        show: true,
        pesq: false,
        enable: true
      }, {
        text: "Descrição Lei 116",
        value: "lei",
        show: true,
        pesq: false,
        enable: false
      }, {
        text: "Cód Município",
        value: "codMun",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Nome Município",
        value: "nome_municipio",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Simples Nacional",
        value: "simples_nacional",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Número do pedido",
        value: "numeroPedido",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Pós Fechamento",
        value: "posFechamento",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Valor Recebido",
        value: "valorTotalRecebido",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Provedor",
        value: "provedor",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Documento",
        value: "documento",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "TipoTomador",
        value: "tipoTomador",
        show: true,
        pesq: true,
        enable: true
      }, {
        text: "Nome Arquivo",
        value: "nomeArquivo",
        show: true,
        pesq: true,
        enable: true
      }];
      if (nfseDES) {
        headers.push({
          text: "Status da Des",
          value: "statusDES",
          show: true,
          pesq: true,
          enable: true
        }, {
          text: "Erro da DES",
          value: "erroDES",
          show: true,
          pesq: true,
          enable: true
        }, {
          text: "Pdv",
          value: "pdv",
          show: true,
          pesq: true,
          enable: true
        }, {
          text: "Numero do Pdv",
          value: "numero_pdv",
          show: true,
          pesq: true,
          enable: true
        }, {
          text: "Data Pdv",
          value: "data_pdv",
          show: true,
          pesq: true,
          enable: true
        });
      }
      return headers;
    }
  }, {
    key: "setNota",
    value: function setNota(arrayNotas, notas) {
      this.loading = false;
      var newArray = arrayNotas;
      for (var i = 0; i < notas.length; i++) {
        newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_notas_nfse_Nfse_js__["a" /* default */](notas[i]._id, notas[i].empresa, notas[i].dtEmissaoNfe, notas[i].numeroNfe, notas[i].vlrCredito, notas[i].vlrServico, notas[i].ISSRetido, notas[i].codServico, notas[i].codVerificacao, notas[i].aliqServico, notas[i].statusNFe, notas[i].origem, notas[i].tipo, notas[i].opcaoSimples, notas[i].numLote, notas[i].numRPS, notas[i].serieRPS, notas[i].tipoRPS, notas[i].dtEmissaoRPS, notas[i].cnpjCpfPrestador, notas[i].razaoPrestador, notas[i].inscPrestador, notas[i].tribNfe, notas[i].ISS, notas[i].discriminacao, notas[i].pathPdf, notas[i].pathPdfMotor, notas[i].gzipPath, notas[i].customValues, notas[i]["statusErp"], notas[i].PIS, notas[i].COFINS, notas[i].CSLL, notas[i].INSS, notas[i].IR, notas[i].lei ? notas[i].lei.codigo : undefined, notas[i].lei ? notas[i].lei : undefined, notas[i].statusEmissao, notas[i].razaoTomador, notas[i].inscPrestador, notas[i].emissaoMotor, notas[i].dataServico, notas[i].codMun, notas[i].cnpjCpfTomador, notas[i].cnpjCpfPrestador, notas[i].statusDES, notas[i].erroDES, notas[i].erroEmissao, notas[i].data_erp, notas[i].status_escrituracao, notas[i].id_fluig, notas[i].log_statusErpDois, notas[i].statusErpDois, notas[i].log_statusErp, notas[i].log_escrituracao, notas[i].pdv, notas[i].numero_pdv, notas[i].data_pdv, notas[i].nome_municipio ? notas[i].nome_municipio : undefined, notas[i].simples_nacional ? notas[i].simples_nacional : undefined, notas[i].posFechamento, notas[i].numeroPedido, notas[i].valorTotalRecebido, notas[i].provedor, notas[i].documento, notas[i].tipoTomador, notas[i].nomeArquivo));
        this.pagination.sortBy = "dtEmissaoNfe";
        this.pagination.descending = true;
      }
      if (arrayNotas.length > 0) {
        arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
        return arrayNotas;
      } else {
        return newArray;
      }
    }
  }]);

  return TableNfse;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableNfse);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_notas_cte_Cte_js__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableCte = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableCte, _Table);

    function TableCte() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableCte);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableCte.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableCte)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableCte, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers = [{ text: "Ações", sortable: false, value: "acoes", show: true, pesq: false, enable: false }, { text: "Data de Emissão", value: "emissao", show: true, width: "500px", pesq: false, enable: true }, { text: "Número", value: "numero", width: "500px", show: true, pesq: true, enable: true }, { text: "Remetente", value: "remetNome", width: "300000px", show: true, pesq: false, enable: true }, { text: "Valor da CT-e", value: "valor", width: "500px", show: true, pesq: false, enable: true }, { text: "IE do Remetente", value: "remetIe", width: "500px", show: true, pesq: false, enable: true }, { text: "CNPJ/CPF do Remetente", value: "remetCnpj", width: "500px", show: true, pesq: true, enable: true }, { text: "Chave de Acesso", value: "chave", width: "500px", show: true, pesq: true, enable: true }, { text: "Destinatário", value: "destNome", width: "500px", show: true, pesq: false, enable: true }, { text: "CNPJ/CPF do Destinatário", value: "destCnpj", width: "500px", show: true, pesq: true, enable: true }, { text: "IE do Destinatário", value: "destIe", width: "500px", show: true, pesq: false, enable: true }, { text: "Origem", value: "origem", width: "500px", show: true, pesq: false, enable: true }, { text: "Status", value: "status", width: "500px", show: true, pesq: false, enable: true }, { text: "Tipo", value: "tipo", width: "500px", show: true, pesq: false, enable: true }, { text: "CNPJ/CPF do Tomador", value: "tomadorCnpj", width: "500px", show: true, pesq: true, enable: true }, { text: "Tomador", value: "tomadorNome", width: "500px", show: true, pesq: false, enable: true }, { text: "IE do Tomador", value: "tomadorIe", width: "500px", show: true, pesq: false, enable: true }, { text: "CNPJ/CPF do Emitente", value: "emitCnpj", width: "500px", show: true, pesq: true, enable: true }, { text: "Emitente", value: "emitNome", width: "500px", show: true, pesq: false, enable: true }, { text: "IE do Emitente", value: "emitIe", width: "500px", show: true, pesq: false, enable: true }, { text: "CNPJ/CPF do Expedidor", value: "expedidorCnpj", width: "500px", show: true, pesq: true, enable: true }, { text: "Expedidor", value: "expedidorNome", width: "500px", show: true, pesq: false, enable: true }, { text: "IE do Expedidor", value: "expedidorIe", width: "500px", show: true, pesq: false, enable: true }, { text: "CNPJ/CPF do Recebedor", value: "recebCnpj", width: "500px", show: true, pesq: true, enable: true }, { text: "Recebedor", value: "recebNome", width: "500px", show: true, pesq: false, enable: true }, { text: "IE do Recebedor", value: "recebIe", width: "500px", show: true, pesq: false, enable: true }, { text: "Data de Importação", value: "dtImportacao", width: "500px", show: true, pesq: false, enable: true }, { text: "Vínculo", value: "vinculo", width: "500px", show: true, pesq: false, enable: true }, { text: "Status ERP", value: "statusErp", width: "500px", show: true, pesq: false, enable: true }, { text: "Danfe", value: "danfe", width: "500px", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", width: "500px", show: false, pesq: false, enable: false }, { text: "id_empresa", value: "empresa", width: "500px", show: false, pesq: false, enable: false }, { text: "nfe", value: "nfe", width: "500px", show: false, pesq: false, enable: false }, { text: "xml", value: "xml", width: "500px", show: false, pesq: false, enable: false }, { text: "Manifestacao", value: "manifestacao", show: true, pesq: false, enable: true }, { text: "Modal", value: "modal", show: true, pesq: true, enable: true }, { text: "Sistema", value: "verProc", show: true, pesq: true, enable: true }, { text: "Data ERP", value: "data_erp", show: true, pesq: true, enable: true }, { text: "Departamento", value: "departamento", show: true, pesq: true, enable: true }, { text: "log integração ERP", value: "log_statusErp", show: false, pesq: false, enable: true }, { text: "Id Fluig", value: "id_fluig", show: true, pesq: true, enable: true }, { text: "log integração ERP Dois", value: "log_statusErpDois", show: false, pesq: false, enable: true }, { text: "StatusErp Dois", value: "statusErpDois", show: true, pesq: false, enable: true }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {
            var newArray = arrayNotas;
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_notas_cte_Cte_js__["a" /* default */](notas[i].chave, notas[i].destCnpjCpf, notas[i].destIe, notas[i].destNome, notas[i].emissao, notas[i].dtImportacao, notas[i].emitCnpjCpf, notas[i].emitIe, notas[i].emitNome, notas[i].empresa, notas[i].expedidorCnpjCpf, notas[i].expedidorIe, notas[i].expedidorNome, notas[i].nfe, notas[i].numero, notas[i].origem, notas[i].recebCnpjCpf, notas[i].recebIe, notas[i].recebNome, notas[i].remetCnpjCpf, notas[i].remetIe, notas[i].remetNome, notas[i].status, notas[i].tipo, notas[i].tomadorCnpjCpf, notas[i].tomadorIe, notas[i].tomadorNome, notas[i]['statusErp'], notas[i].valor, notas[i]._id, notas[i].customValues, notas[i].danfe, notas[i].manifestacao, notas[i].modal, notas[i].verProc, notas[i].data_erp, notas[i].departamento, notas[i].log_statusErp, notas[i].id_fluig, notas[i].log_statusErpDois, notas[i].statusErpDois));

                this.pagination.sortBy = 'emissao';
                this.pagination.descending = true;
            }
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableCte;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableCte);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__masks_masks__ = __webpack_require__(102);



var Cte = function Cte(chave, destCnpj, destIe, destNome, emissao, dtImportacao, emitCnpj, emitIe, emitNome, empresa, expedidorCnpj, expedidorIe, expedidorNome, nfe, numero, origem, recebCnpj, recebIe, recebNome, remetCnpj, remetIe, remetNome, status, tipo, tomadorCnpj, tomadorIe, tomadorNome, statusErp, valor, _id, customValues, danfe, manifestacao, modal, verProc, data_erp, departamento, log_statusErp, id_fluig, log_statusErpDois, statusErpDois) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Cte);

    this.emissao = new Date(emissao), this.numero = numero, this.remetNome = remetNome, this.valor = valor, this.remetIe = remetIe, this.remetCnpj = remetCnpj, this.chave = chave, this.destNome = destNome, this.destCnpj = destCnpj, this.destIe = destIe, this.origem = origem, this.status = status, this.tipo = tipo, this.tomadorCnpj = tomadorCnpj, this.tomadorNome = tomadorNome, this.tomadorIe = tomadorIe, this.emitCnpj = emitCnpj, this.emitNome = emitNome, this.emitIe = emitIe, this.expedidorCnpj = expedidorCnpj, this.expedidorNome = expedidorNome, this.expedidorIe = expedidorIe, this.recebCnpj = recebCnpj, this.recebNome = recebNome, this.recebIe = recebIe, this.dtImportacao = new Date(dtImportacao), this.vinculo = '', this.statusErp = statusErp, this.customValues = customValues, this.manifestacao = manifestacao, this.modal = modal, this.verProc = verProc, this.data_erp = Object(__WEBPACK_IMPORTED_MODULE_1__masks_masks__["a" /* converter */])(data_erp), this.departamento = departamento, this.id_fluig = id_fluig, this.log_statusErpDois = log_statusErpDois, this.statusErpDois = statusErpDois, this.log_statusErp = log_statusErp, this.danfe = danfe, this._id = _id, this.empresa = empresa, this.nfe = nfe, this.xml = '';
};

/* harmony default export */ __webpack_exports__["a"] = (Cte);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_clientes_Clientes_js__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableClientes = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableClientes, _Table);

    function TableClientes() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableClientes);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableClientes.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableClientes)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableClientes, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers = [{ text: "Ações", sortable: false, value: "acoes", show: true, pesq: false, enable: false }, { text: "Razão Social", value: "xNome", show: true, width: "500px", pesq: true, enable: true }, { text: "CNPJ", value: "CNPJ", width: "500px", show: true, pesq: true, enable: true }, { text: "Tipo", value: "trabFiliado", width: "500px", show: true, pesq: true, enable: true }, { text: "Primeira venda", value: "dtPrimeiraCompra", width: "500px", show: true, pesq: false, enable: true }, { text: "Última venda", value: "dtUltimaCompra", width: "500px", show: true, pesq: false, enable: true }, { text: "Menor valor de venda", value: "vlrMin", width: "500px", show: true, pesq: false, enable: true }, { text: "Maior valor de venda", value: "vlrMax", width: "500px", show: true, pesq: false, enable: true }, { text: "Vendas", value: "qtd", width: "500px", show: true, pesq: false, enable: true }, { text: "Serviço prestado", value: "qntServico", width: "500px", show: true, pesq: false, enable: true }, { text: "Data da inclusão", value: "dtInclusao", width: "500px", show: false, pesq: false, enable: true }, { text: "IE", value: "IE", width: "500px", show: false, pesq: false, enable: true }, { text: "_id", value: "_id", show: false, pesq: false, enable: false },
            // { text: "customValues", value: "customValues", show: false, pesq: false, enable: false},
            { text: "enderEmit", value: "enderEmit", show: false, pesq: false, enable: false }, { text: "conta", value: "conta", show: false, pesq: false, enable: false }, { text: "nfes", value: "nfes", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {

            var newArray = arrayNotas;
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {

                try {
                    if (!notas[i].primeiraCompra) {
                        throw new Error("Data inv\xE1lida para constru\xE7\xE3o");
                    }
                    newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_clientes_Clientes_js__["a" /* default */](notas[i].client._id, notas[i].client.dtInclusao, notas[i].client.CNPJ, notas[i].client.CPF, notas[i].client.xNome, notas[i].client.IE, notas[i].qtd, notas[i].vlrMin, notas[i].vlrMax, notas[i].primeiraCompra, notas[i].ultimaCompra, notas[i].servicoPrestado, notas[i].client.customValues, notas[i].client.enderDest, notas[i].client.nfes, notas[i].client.cliente));
                } catch (err) {
                    console.log("Erro ao instanciar cliente: " + notas[i].client.xNome + " \n\n" + err);
                }
            }
            this.pagination.sortBy = 'xNome';
            this.pagination.descending = false;
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableClientes;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableClientes);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Cliente = function Cliente(_id, dtInclusao, CNPJ, CPF, xNome, IE, qtd, vlrMin, vlrMax, dtPrimeiraCompra, dtUltimaCompra, qntServico, customValues, enderEmit, nfes, conta) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Cliente);

    this.xNome = xNome, this.CNPJ = CNPJ != undefined ? CNPJ : CPF != undefined ? CPF : undefined, this.Tipo = this.trabFiliado = qtd > 0 && qntServico > 0 ? 'nfe_nfse' : qtd > 0 && qntServico == 0 ? 'nfe' : 'nfse', this.dtInclusao = new Date(dtInclusao), this.enderEmit = enderEmit, this.IE = IE, this.qtd = qtd, this.vlrMin = vlrMin, this.vlrMax = vlrMax, this.dtPrimeiraCompra = new Date(dtPrimeiraCompra), this.dtUltimaCompra = new Date(dtUltimaCompra), this.qntServico = qntServico, this._id = _id, this.customValues = customValues, this.nfes = nfes, this.conta = conta;
};

/* harmony default export */ __webpack_exports__["a"] = (Cliente);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_fornecedores_Fornecedores_js__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableFornecedores = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableFornecedores, _Table);

    function TableFornecedores() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableFornecedores);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableFornecedores.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableFornecedores)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableFornecedores, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers = [{ text: "Ações", sortable: false, value: "acoes", show: true, pesq: false, enable: false }, { text: "Razão Social", value: "xNome", show: true, width: "500px", pesq: true, enable: true }, { text: "CNPJ", value: "CNPJ", width: "500px", show: true, pesq: true, enable: true }, { text: "Tipo", value: "trabFiliado", width: "500px", show: true, pesq: false, enable: true }, { text: "Primeira compra", value: "dtPrimeiraCompra", width: "500px", show: true, pesq: false, enable: true }, { text: "Última compra", value: "dtUltimaCompra", width: "500px", show: true, pesq: false, enable: true }, { text: "Menor valor de compra", value: "vlrMin", width: "500px", show: true, pesq: false, enable: true }, { text: "Maior valor de compra", value: "vlrMax", width: "500px", show: true, pesq: false, enable: true }, { text: "Compras", value: "qtd", width: "500px", show: true, pesq: false, enable: true }, { text: "Serviço tomado", value: "qntServico", width: "500px", show: true, pesq: false, enable: true }, { text: "Data da inclusão", value: "dtInclusao", width: "500px", show: false, pesq: false, enable: true }, { text: "Nome Fantazia", value: "xFant", width: "500px", show: false, pesq: false, enable: true }, { text: "IE", value: "IE", width: "500px", show: false, pesq: false, enable: true }, { text: "Regime", value: "CRT", width: "500px", show: false, pesq: false, enable: true }, { text: "_id", value: "_id", show: false, pesq: false, enable: false },
            // { text: "customValues", value: "customValues", show: false, pesq: false, enable: false},
            { text: "enderEmit", value: "enderEmit", show: false, pesq: false, enable: false }, { text: "conta", value: "conta", show: false, pesq: false, enable: false }, { text: "nfes", value: "nfes", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {

            var newArray = arrayNotas;
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                try {
                    if (!notas[i].primeiraCompra) {
                        throw new Error("Data inv\xE1lida para constru\xE7\xE3o");
                    }
                    newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_fornecedores_Fornecedores_js__["a" /* default */](notas[i].forn._id, notas[i].forn.dtInclusao, notas[i].forn.produto, notas[i].forn.CNPJ, notas[i].forn.xNome, notas[i].forn.xFant, notas[i].forn.IE, notas[i].forn.CRT, notas[i].qtd, notas[i].vlrMin, notas[i].vlrMax, notas[i].primeiraCompra, notas[i].ultimaCompra, notas[i].servicoTomado, notas[i].forn.CPF, notas[i].forn.customValues, notas[i].forn.enderEmit, notas[i].forn.nfes, notas[i].forn.conta));
                } catch (err) {
                    console.log("Erro ao instanciar Fornecedor: " + notas[i].forn.xNome + " \n\n " + err + " ");
                }
            }
            this.pagination.sortBy = 'xNome';
            this.pagination.descending = false;
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableFornecedores;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableFornecedores);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Fornecedor = function Fornecedor(_id, dtInclusao, produto, CNPJ, xNome, xFant, IE, CRT, qtd, vlrMin, vlrMax, dtPrimeiraCompra, dtUltimaCompra, qntServico, CPF, customValues, enderEmit, nfes, conta) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Fornecedor);

    // this.emissao = ,
    // this.emissao = emissao.substring(0, emissao.indexOf("T")).split('-').reverse().join('/'),
    this.xNome = xNome, CNPJ != undefined && CPF != undefined ? this.CNPJ = CNPJ + ' - ' + CPF : CNPJ != undefined && CPF == undefined ? this.CNPJ = CNPJ : this.CNPJ = CPF, this.trabFiliado = qtd > 0 && qntServico > 0 ? 'nfe_nfse' : qtd > 0 && qntServico == 0 ? 'nfe' : 'nfse', this.dtPrimeiraCompra = new Date(dtPrimeiraCompra), this.dtUltimaCompra = new Date(dtUltimaCompra), this.vlrMin = vlrMin, this.vlrMax = vlrMax, this.qtd = qtd, this.qntServico = qntServico, this.dtInclusao = new Date(dtInclusao), this.xFant = xFant, this.IE = IE, this.CRT = CRT, this._id = _id, this.enderEmit = enderEmit, this.conta = conta, this.nfes = nfes, this.customValues = customValues;
};

/* harmony default export */ __webpack_exports__["a"] = (Fornecedor);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_produtos_Produtos_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableProdutos = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableProdutos, _Table);

    function TableProdutos() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableProdutos);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableProdutos.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableProdutos)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableProdutos, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers = [{ text: "Ações", value: "acoes", show: false, pesq: false, enable: false }, { text: "Nome do Produto", value: "xProd", show: true, pesq: true, enable: true }, { text: "Código do Produto", value: "cProd", show: true, pesq: true, enable: true }, { text: "NCM", value: "NCM", show: true, pesq: false, enable: true }, { text: "Unidade", value: "uCom", show: true, pesq: false, enable: true }, { text: "CNPJ Fornecedor", value: "fornCnpj", show: true, pesq: false, enable: true }, { text: "Razão Social Fornecedor", value: "fornRazao", show: true, pesq: false, enable: true },
            // { text: "Data de inclusão", value: "dtInclusao", width: "500px", show: true, pesq: false , enable: true},
            // { text: "Lote/Vencimento", value: "prodRastro", show: true, pesq: false , enable: true},
            { text: "Data da inclusão", value: "dtReg", width: "500px", show: false, pesq: false, enable: true }, { text: "CFOP", value: "CFOP", show: false, pesq: false, enable: false }, { text: "cEAN", value: "cEAN", show: false, pesq: false, enable: false }, { text: "conta", value: "conta", show: false, pesq: false, enable: false }, { text: "fornId", value: "fornId", show: false, pesq: false, enable: false }, { text: "nfes", value: "nfes", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {
            var newArray = arrayNotas;
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_produtos_Produtos_js__["a" /* default */](notas[i].prod._id, notas[i].prod.xProd, notas[i].prod.cProd, notas[i].prod.NCM, notas[i].prod.uCom, notas[i].prod.CFOP, notas[i].prod.cEAN, notas[i].prodRastro, notas[i].cpfCnpj, notas[i].razao, notas[i].prod.dtReg, notas[i]._id, notas[i].prod.customValues, notas[i].prod.conta, notas[i].prod.nfes));

                this.pagination.sortBy = 'xProd';
                this.pagination.descending = false;
                // arrayNotas.sort(function (a, b) {
                //     return a.xProd < b.xProd ? -1 : a.xProd > b.xProd ? 1 : 0;
                // });
            }
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableProdutos;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableProdutos);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_produtos_Produtos_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableProdutosEmitida = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableProdutosEmitida, _Table);

    function TableProdutosEmitida() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableProdutosEmitida);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableProdutosEmitida.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableProdutosEmitida)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableProdutosEmitida, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers = [{ text: "Ações", value: "acoes", show: false, pesq: false, enable: false }, { text: "Nome do Produto", value: "xProd", show: true, pesq: true, enable: true }, { text: "Código do Produto", value: "cProd", show: true, pesq: true, enable: true }, { text: "NCM", value: "NCM", show: true, pesq: false, enable: true }, { text: "Unidade", value: "uCom", show: true, pesq: false, enable: true }, { text: "CNPJ Cliente", value: "fornCnpj", show: true, pesq: false, enable: true }, { text: "Razão Social Cliente", value: "fornRazao", show: true, pesq: false, enable: true },
            // { text: "Data de inclusão", value: "dtInclusao", width: "500px", show: true, pesq: false , enable: true},
            // { text: "Lote/Vencimento", value: "prodRastro", show: true, pesq: false , enable: true},
            { text: "Data da inclusão", value: "dtReg", width: "500px", show: false, pesq: false, enable: true }, { text: "CFOP", value: "CFOP", show: false, pesq: false, enable: false }, { text: "cEAN", value: "cEAN", show: false, pesq: false, enable: false }, { text: "conta", value: "conta", show: false, pesq: false, enable: false }, { text: "fornId", value: "fornId", show: false, pesq: false, enable: false }, { text: "nfes", value: "nfes", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {
            var newArray = arrayNotas;
            // debugger;
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_produtos_Produtos_js__["a" /* default */](notas[i].prod._id, notas[i].prod.xProd, notas[i].prod.cProd, notas[i].prod.NCM, notas[i].prod.uCom, notas[i].prod.CFOP, notas[i].prod.cEAN, notas[i].prodRastro, notas[i].prod.cpfCnpjForn, notas[i].razao, notas[i].prod.dtReg, notas[i].fornId, notas[i].prod.customValues, notas[i].prod.conta, notas[i].prod.nfes));

                this.pagination.sortBy = 'xProd';
                this.pagination.descending = false;
                // arrayNotas.sort(function (a, b) {
                //     return a.xProd < b.xProd ? -1 : a.xProd > b.xProd ? 1 : 0;
                // });
            }
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableProdutosEmitida;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableProdutosEmitida);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_conta_empresa_certificado_Certificado_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableCertificados = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableCertificados, _Table);

    function TableCertificados() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableCertificados);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableCertificados.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableCertificados)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableCertificados, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers;
            headers = [{ text: "Ações", sortable: false, value: "acoes", show: true, pesq: false, enable: false }, { text: "Nome", value: "nome", show: true, pesq: true, enable: true }, { text: "Data de Expiração", value: "validade", show: true, pesq: true, enable: true }, { text: "bvenc", value: "bvenc", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {
            var newArray = arrayNotas;
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                newArray.push(
                // password = "", file = "", dtExpiracao
                new __WEBPACK_IMPORTED_MODULE_6__domain_conta_empresa_certificado_Certificado_js__["a" /* default */](notas[i].nome, notas[i].validade, notas[i]._id));
                this.pagination.sortBy = 'nome';
                this.pagination.descending = false;
                // arrayNotas.sort(function (a, b) {
                //     return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
                // });
            }
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableCertificados;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableCertificados);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_conta_usuario_Usuario_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(15);








var TableUsuarios = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TableUsuarios, _Table);

    function TableUsuarios() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TableUsuarios);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableUsuarios.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TableUsuarios)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TableUsuarios, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers;
            headers = [{ text: "Ações", value: "acoes", show: true, pesq: false, enable: false }, { text: "Nome", value: "nome", show: true, pesq: true, enable: true }, { text: "Sobrenome", value: "sobrenome", show: true, pesq: false, enable: true }, { text: "E-mail", value: "email", show: true, pesq: true, enable: true }, { text: "Telefone", value: "telefone", show: true, pesq: false, enable: true }, { text: "Data de Nascimento", value: "dtNascimento", show: true, pesq: false, enable: true }, { text: "Estado", value: "estado", show: true, pesq: false, enable: true }, { text: "Cidade", value: "cidade", show: true, pesq: false, enable: true }, { text: "Status", value: "statusIn", show: true, pesq: false, enable: true }, { text: "preCadastro", value: "preCadastro", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {

            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                if (notas[i].status) {
                    arrayNotas.push(new __WEBPACK_IMPORTED_MODULE_5__domain_conta_usuario_Usuario_js__["a" /* default */](notas[i].colaborador.nome, notas[i].colaborador.sobrenome, notas[i].colaborador.email, notas[i].colaborador.telefone, notas[i].colaborador.dtNascimento, notas[i].colaborador.estado, notas[i].colaborador.cidade, notas[i].status, notas[i].colaborador.preCadastro, notas[i].colaborador._id));
                }
                this.pagination.sortBy = 'nome';
                this.pagination.descending = false;
            }
            return arrayNotas;
        }
    }]);

    return TableUsuarios;
}(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableUsuarios);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_conta_RelatorioConta_js__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(15);








var TableContas = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TableContas, _Table);

    function TableContas() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TableContas);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableContas.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TableContas)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TableContas, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers;
            headers = [{ text: "Nome", value: "rela_nome", show: true, pesq: true, enable: true }, { text: "Data de Cadastro da Conta", value: "rela_dtRegConta", show: true, pesq: true, enable: true }, { text: "E-mail da Conta", value: "rela_email", show: true, pesq: false, enable: true }, { text: "Plano da Conta", value: "rela_plano", show: true, pesq: false, enable: true }, { text: "Empresa de Faturamento", value: "rela_fat_razao", show: true, pesq: false, enable: true }, { text: "CNPJ/CPF da Empresa de Faturamento", value: "rela_fat_cnpj", show: true, pesq: false, enable: true }, { text: "Total de Empresas", value: "rela_totalEmp", show: true, pesq: false, enable: true }, { text: "Total de Colaboradores", value: "rela_totalColab", show: true, pesq: false, enable: true },
            // { text: "Total de NF-e da Conta", value: "rela_totalNfe", show: true, pesq: false, enable: true },
            // { text: "Total de NFS-e da Conta", value: "rela_totalNfse", show: true, pesq: false, enable: true },
            // { text: "Total de CT-e da Conta", value: "rela_totalCte", show: true, pesq: false, enable: true },
            { text: "Empresas da conta", value: "arrayEmpresas", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                var totalColab = 0;
                for (var j = 0; j < notas[i].empresas.length; j++) {
                    totalColab += notas[i].empresas[j].colaboradores.length;
                }
                arrayNotas.push(
                // password = "", file = "", dtExpiracao
                new __WEBPACK_IMPORTED_MODULE_5__domain_conta_RelatorioConta_js__["a" /* default */](notas[i].master ? notas[i].master.nome : '', notas[i].dtReg, notas[i].master ? notas[i].master.email : '', notas[i].plano, notas[i].faturamento.razao, notas[i].faturamento.cnpj, notas[i].empresas.length, totalColab,
                // notas[i].total_nfe,
                // notas[i].total_nfse,
                // notas[i].total_cte,
                notas[i].empresas, notas[i]._id));
                this.pagination.sortBy = 'rela_dtRegConta';
                this.pagination.descending = true;
                // arrayNotas.sort(function (a, b) {
                //     return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
                // });
            }
            return arrayNotas;
        }
    }]);

    return TableContas;
}(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableContas);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var RelatorioConta = function RelatorioConta(rela_nome, rela_dtRegConta, rela_email, rela_plano, rela_fat_razao, rela_fat_cnpj, rela_totalEmp, rela_totalColab, arrayEmpresas, _id) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RelatorioConta);

    // notas[i].master.nome,
    // notas[i].dtRegIn,
    // notas[i].master.email,
    // notas[i].rela_plano,
    // notas[i].faturamento.rela_fat_razao,
    // notas[i].faturamento.cnpj,
    // notas[i].empresas.length,
    // totalColab,
    // notas[i].total_nfe,
    // notas[i].total_nfse,
    // notas[i].total_cte,
    // notas[i].arrayEmpresas,
    // notas[i]._id

    this.rela_nome = rela_nome;
    this.rela_dtRegConta = new Date(rela_dtRegConta);
    this.rela_email = rela_email;
    this.rela_plano = rela_plano;
    this.rela_fat_razao = rela_fat_razao;
    this.rela_fat_cnpj = rela_fat_cnpj;
    this.rela_totalEmp = rela_totalEmp;
    this.rela_totalColab = rela_totalColab;
    // this.rela_totalNfe = rela_totalNfe;
    // this.rela_totalNfse = rela_totalNfse;
    // this.rela_totalCte = rela_totalCte;
    this.arrayEmpresas = arrayEmpresas;
    this._id = _id;
};

/* harmony default export */ __webpack_exports__["a"] = (RelatorioConta);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_conta_usuario_RelatorioUsuario_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(15);








var TableRelaUsuarios = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TableRelaUsuarios, _Table);

    function TableRelaUsuarios() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TableRelaUsuarios);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableRelaUsuarios.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TableRelaUsuarios)).call(this));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TableRelaUsuarios, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers;
            headers = [{ text: "Nome", value: "rela_nome", show: true, pesq: true, enable: true }, { text: "Sobrenome", value: "rela_sobrenome", show: true, pesq: false, enable: true }, { text: "Data de Registro", value: "rela_dtReg", show: true, pesq: false, enable: true }, { text: "Data do Último Acesso", value: "rela_dtLastLogin", show: true, pesq: false, enable: true }, { text: "Total de Acessos", value: "rela_qntLogins", show: true, pesq: false, enable: true }, { text: "E-mail", value: "rela_email", show: true, pesq: true, enable: true }, { text: "Telefone", value: "rela_telefone", show: true, pesq: false, enable: true }, { text: "Empresa Faturamento", value: "rela_faturaRazao", show: true, pesq: false, enable: true }, { text: "Lista de Acesso", value: "rela_arrayLogins", show: false, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {
            this.loading = false;

            for (var i = 0; i < notas.length; i++) {
                notas[i].dtLogin ? notas[i].dtLogin = notas[i].dtLogin.sort(function (a, b) {
                    return a < b ? 1 : a > b ? -1 : 0;
                }).slice() : notas[i].dtLogin = [];
                arrayNotas.push(new __WEBPACK_IMPORTED_MODULE_5__domain_conta_usuario_RelatorioUsuario_js__["a" /* default */](notas[i].nome, notas[i].sobrenome, notas[i].dtReg, notas[i].dtLogin && notas[i].dtLogin.length > 0 && notas[i].dtLogin[0] ? notas[i].dtLogin[0] : undefined, notas[i].dtLogin ? notas[i].dtLogin.length : 0, notas[i].email, notas[i].telefone, notas[i].empresa ? notas[i].empresa.razao : '-', notas[i].dtLogin, notas[i]._id));
            }
            this.pagination.sortBy = 'rela_dtLastLogin';
            this.pagination.descending = true;
            return arrayNotas;
        }
    }]);

    return TableRelaUsuarios;
}(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableRelaUsuarios);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Usuario = function Usuario(rela_nome, rela_sobrenome, rela_dtReg, rela_dtLastLogin, rela_qntLogins, rela_email, rela_telefone, rela_faturaRazao, rela_arrayLogins, _id) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Usuario);

    this.rela_nome = rela_nome;
    this.rela_sobrenome = rela_sobrenome;
    this.rela_dtReg = new Date(rela_dtReg);
    this.rela_dtLastLogin = rela_dtLastLogin ? new Date(rela_dtLastLogin) : undefined;
    this.rela_qntLogins = rela_qntLogins;
    this.rela_email = rela_email;
    this.rela_telefone = rela_telefone != undefined && rela_telefone.length == 8 ? rela_telefone.replace(/^(\d{4})(\d)/, "$1-$2") : rela_telefone != undefined && rela_telefone.length == 11 ? rela_telefone.replace(/^(\d{2})(\d{5})(\d)/, "($1) $2-$3") : rela_telefone;
    this.rela_faturaRazao = rela_faturaRazao;
    this.rela_arrayLogins = rela_arrayLogins;
    this._id = _id;
};

/* harmony default export */ __webpack_exports__["a"] = (Usuario);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_automacaoFiscal_iptu_Iptu__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(15);









var TableIptu = function (_Table) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableIptu, _Table);

    function TableIptu() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableIptu);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableIptu.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TableIptu)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableIptu, [{
        key: "getHeaders",
        value: function getHeaders() {
            var headers;
            headers = [{ text: "Ações", value: "acoes", show: true, pesq: false, enable: false }, { text: "_id", value: "_id", show: false, pesq: false, enable: true }, { text: "Inscricao", value: "inscricao", show: true, pesq: true, enable: true }, { text: "Obra", value: "obra", show: true, pesq: true, enable: true }, { text: "Ano", value: "anoIPTU", show: true, pesq: true, enable: true }, { text: "Parcela", value: "parcela", show: true, pesq: true, enable: true }, { text: "Bairro", value: "bairro", show: true, pesq: true, enable: true }, { text: "Data Importação", value: "createdAt", show: true, pesq: true, enable: true }, { text: "Cidade", value: "cidade", show: true, pesq: true, enable: true }, { text: "Status OCR", value: "statusOcr", show: true, pesq: true, enable: true }, { text: "Status Integração", value: "statusIntegracao", show: true, pesq: true, enable: true }, { text: "Número do Documento", value: "numDoc", show: true, pesq: true, enable: true }, { text: "Logradouro", value: "logradouro", show: true, pesq: true, enable: true }, { text: "Vencimento", value: "vencimento", show: true, pesq: true, enable: true }, { text: "Código de barras", value: "codBarras", show: true, pesq: true, enable: true }, { text: "Valor Cobrado", value: "valorCobrado", show: true, pesq: true, enable: true }, { text: "Acréscimo", value: "acrescimos", show: true, pesq: true, enable: true }, { text: "Dedução", value: "deducoes", show: true, pesq: true, enable: true }, { text: "Desconto", value: "desconto", show: true, pesq: true, enable: true }, { text: "Multa", value: "multa", show: true, pesq: true, enable: true }, { text: "Valor", value: "valor", show: true, pesq: true, enable: true }, { text: "Log de Integração", value: "log_integracao", show: false, pesq: false, enable: false }, { text: "pathIPTU", value: "pathIPTU", show: false, pesq: false, enable: false }];
            return headers;
        }
    }, {
        key: "setNota",
        value: function setNota(arrayNotas, notas) {
            var newArray = arrayNotas;
            this.loading = false;
            for (var i = 0; i < notas.length; i++) {
                newArray.push(new __WEBPACK_IMPORTED_MODULE_6__domain_automacaoFiscal_iptu_Iptu__["a" /* default */](notas[i]._id, notas[i].inscricao, notas[i].obra, notas[i].anoIPTU, notas[i].parcela, notas[i].bairro, notas[i].createdAt, notas[i].cidade, notas[i].statusOcr, notas[i].statusIntegracao, notas[i].numDoc, notas[i].logradouro, notas[i].vencimento, notas[i].codBarras, notas[i].valorCobrado, notas[i].acrescimos, notas[i].deducoes, notas[i].desconto, notas[i].multa, notas[i].valor, notas[i].log_integracao, notas[i].pathIPTU));
            }

            this.pagination.sortBy = 'inscricaoImovel';
            this.pagination.descending = false;
            if (arrayNotas.length > 0) {
                arrayNotas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayNotas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newArray));
                return arrayNotas;
            } else {
                return newArray;
            }
        }
    }]);

    return TableIptu;
}(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TableIptu);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Iptu = function Iptu(_id, inscricao, obra, anoIPTU, parcela, bairro, createdAt, cidade, statusOcr, statusIntegracao, numDoc, logradouro, vencimento, codBarras, valorCobrado, acrescimos, deducoes, desconto, multa, valor, log_integracao, pathIPTU) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Iptu);

  this._id = _id, this.inscricao = inscricao, this.obra = obra, this.anoIPTU = anoIPTU, this.parcela = parcela, this.bairro = bairro, this.createdAt = createdAt ? new Date(createdAt) : "", this.cidade = cidade, this.statusOcr = statusOcr, this.statusIntegracao = statusIntegracao, this.numDoc = numDoc, this.logradouro = logradouro, this.vencimento = vencimento ? new Date(vencimento) : "", this.codBarras = codBarras, this.valorCobrado = valorCobrado, this.acrescimos = acrescimos, this.deducoes = deducoes ? deducoes : 0.0, this.desconto = desconto, this.multa = multa, this.valor = valor, this.log_integracao = log_integracao, this.pathIPTU = pathIPTU;
};

/* harmony default export */ __webpack_exports__["a"] = (Iptu);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_listEmprConta_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e0d8f1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_listEmprConta_vue__ = __webpack_require__(551);
function injectStyle (ssrContext) {
  __webpack_require__(550)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_listEmprConta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e0d8f1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_listEmprConta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"empresas_conta_relatorio"},[_c('span',{staticClass:"duplicata_parcelada"},[_c('v-tooltip',{attrs:{"top":"","close-delay":500,"allow-overflow":""}},[_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabela(_vm.item)}},slot:"activator"},[_vm._v(_vm._s(_vm.item.rela_totalEmp))]),_vm._v(" "),_c('span',[_vm._v("Visualizar tabela de empresas")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Empresas de: "+_vm._s(_vm.item.rela_nome))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{staticStyle:{"max-width":"100%"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('table',{staticClass:"table_vencimento",attrs:{"border":"1","id":("tabela-relatorio-contas-" + (_vm.item._id))}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"1"}},[_vm._v("CNPJ/CPF")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"388px"},attrs:{"colspan":"1"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Data de Cadastro da Empresa")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Colaboradores")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Vencimento certificado")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Bloqueada")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.item.arrayEmpresas),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.maskCnpj(item.empresa.cnpj)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(item.empresa.razao))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(item.empresa.dtReg != undefined && new Date(item.empresa.dtReg) instanceof Date && !isNaN((new Date(item.empresa.dtReg))) ? new Date(item.empresa.dtReg).toLocaleDateString('pt-BR') : item.empresa.dtReg))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(item.colaboradores.length))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(item.empresa.certificado != undefined && new Date(item.empresa.certificado.validade) instanceof Date && !isNaN((new Date(item.empresa.certificado.validade))) ? new Date(item.empresa.certificado.validade).toLocaleDateString('pt-BR') : 'Certificado não vinculado'))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(item.empresa.bloqueada ? 'Sim' : 'Não'))])])}),0)])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_Logins_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cff78b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_Logins_vue__ = __webpack_require__(554);
function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_Logins_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cff78b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_Logins_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('span',{staticClass:"duplicata_parcelada"},[_c('v-tooltip',{attrs:{"top":"","close-delay":500,"allow-overflow":""}},[_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaParcela(_vm.item)}},slot:"activator"},[_vm._v(_vm._s(_vm.item.rela_arrayLogins.length))]),_vm._v(" "),_c('span',[_vm._v("Visualizar tabela de Acessos")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.item.rela_nome))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('table',{staticClass:"table_vencimento",attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"3"}},[_vm._v("Acessos")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"1"}},[_vm._v("Datas")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Horário")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.sortArrayItemDesc),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(item ? new Date(item).toLocaleDateString(): '-'))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(item ? new Date(item).toLocaleTimeString(): '-'))])])}),0)])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColumnActions_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c37eca9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColumnActions_vue__ = __webpack_require__(622);
function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c37eca9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColumnActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c37eca9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColumnActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownload_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c8d9e41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownload_vue__ = __webpack_require__(567);
function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c8d9e41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c8d9e41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('a',{attrs:{"id":"dLinkXml"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{class:[_vm.desabilitar ? 'c_disabled' : ''],attrs:{"slot":"activator","disabled":_vm.desabilitar,"color":"light-blue darken-4","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.setXml()}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_action",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6.12,15.5L9.86,19.24L11.28,17.83L8.95,15.5L11.28,13.17L9.86,11.76L6.12,15.5M17.28,15.5L13.54,11.76L12.12,13.17L14.45,15.5L12.12,17.83L13.54,19.24L17.28,15.5Z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n        Baixar\n        "),(_vm.component.name.indexOf('NFe') != -1)?_c('span',[_vm._v("XML")]):(_vm.desabilitar)?_c('span',[_vm._v("XML ainda não está disponível, Motor Fiscal está trabalhando nisso!")]):_c('span',[_vm._v("XML")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnPdf_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af0770cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnPdf_vue__ = __webpack_require__(563);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af0770cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnPdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af0770cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnPdf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('a',{attrs:{"id":"dLinkPdf"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{class:[_vm.disableButton ? 'c_disabled' : ''],attrs:{"slot":"activator","disabled":_vm.disableButton,"color":"light-blue darken-4","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.setDanfe()}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_action",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M14,9H19.5L14,3.5V9M7,2H15L21,8V20A2,2 0 0,1 19,22H7C5.89,22 5,21.1 5,20V4A2,2 0 0,1 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n        Baixar\n        "),(_vm.component.name.indexOf('NFe') != -1)?_c('span',[_vm._v("DANFE")]):(_vm.disableButton && !_vm.pathPdfMotor)?_c('span',[_vm._v("de PDF ainda não disponível, Motor Fiscal está trabalhando nisso!")]):(_vm.disableButton && _vm.pathPdfMotor)?_c('span',[_vm._v("de PDF padrão Motor Fiscal ainda não disponível, Motor Fiscal está trabalhando nisso!")]):(!_vm.pathPdfMotor)?_c('span',[_vm._v("PDF")]):_c('span',[_vm._v("PDF Padrão Motor Fiscal")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnIptu_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_545b59da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnIptu_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-545b59da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnIptu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_545b59da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnIptu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('a',{attrs:{"id":"dLinkPdf"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{class:[!_vm.nota.item.pathIPTU ? 'c_disabled' : ''],attrs:{"slot":"activator","disabled":!_vm.nota.item.pathIPTU,"color":"light-blue darken-4","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.setDanfe()}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_action",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M14,9H19.5L14,3.5V9M7,2H15L21,8V20A2,2 0 0,1 19,22H7C5.89,22 5,21.1 5,20V4A2,2 0 0,1 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n        Baixar IPTU\n      ")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"content"}},[(this.component.enable.downXML)?_c('btnXml',{attrs:{"nota":this.nota,"component":this.component}}):_vm._e(),_vm._v(" "),(this.component.enable.downPdf)?_c('btnPdf',{attrs:{"nota":this.nota,"component":this.component,"pathPdfMotor":false}}):_vm._e(),_vm._v(" "),(this.component.enable.downIptu)?_c('btnIptu',{attrs:{"nota":this.nota,"component":this.component}}):_vm._e(),_vm._v(" "),(this.component.name.toLowerCase().indexOf('nfse') != -1 && this.component.enable.downPdf)?_c('btnPdf',{attrs:{"nota":this.nota,"component":this.component,"pathPdfMotor":true}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnVisualizar_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192ef098_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnVisualizar_vue__ = __webpack_require__(585);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnVisualizar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192ef098_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnVisualizar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNFe_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54dc286e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNFe_vue__ = __webpack_require__(572);
function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNFe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54dc286e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNFe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.getDanfe(_vm.nota.item._id)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('span',[_vm._v("Visualizar DANFE")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue",staticStyle:{"color":"white"},attrs:{"text-color":"white"}},[_vm._v("\n                        DANFE\n                        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"tst"}},[_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"src":'data:application/pdf;base64,'+encodeURIComponent(this.nota.item.danfe),"frameborder":"0"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                            Fechar\n                        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCTe_vue__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d953da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCTe_vue__ = __webpack_require__(575);
function injectStyle (ssrContext) {
  __webpack_require__(574)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCTe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d953da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCTe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.getDacte(_vm.nota.item._id)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('span',[_vm._v("Visualizar DACTE")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue text-xs-center",staticStyle:{"color":"white"},attrs:{"text-color":"white"}},[_vm._v("\n                        DACTE\n                        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"tst"}},[_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"src":'data:application/pdf;base64,'+encodeURIComponent(this.nota.item.danfe),"frameborder":"0"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                            Fechar\n                        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCce_vue__ = __webpack_require__(172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72809804_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCce_vue__ = __webpack_require__(578);
function injectStyle (ssrContext) {
  __webpack_require__(577)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72809804_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){_vm.dialog = !_vm.dialog}}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.getDanfe(_vm.nota.item._id)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"id":"ico"}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('span',[_vm._v("Visualizar DANFE")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue text-xs-center",staticStyle:{"color":"white"},attrs:{"text-color":"white","primary-title":""}},[_vm._v("\n                        Cc-e Vinculadas\n                        "),_c('v-spacer'),_vm._v(" "),(_vm.nota.item.xmlCce.length > 0)?_c('div',{attrs:{"id":"listaNfe"}},[_c('span',[_vm._v("Cc-e Vinculadas")]),_vm._v(" "),_c('ol',_vm._l((_vm.nota.item.xmlCce),function(chave,i){return _c('li',{key:i,on:{"click":function($event){return _vm.getCce(_vm.nota.item._id,i)}}},[_c('h6',[_vm._v("\n                                Cce\n                              ")])])}),0)]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"bodyNFeVinculada"}},[(_vm.nota.item.xmlCce.length > 0)?_c('h2',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.text_info))]):_vm._e()]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                            Fechar\n                        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNFSe_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4853ade8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNFSe_vue__ = __webpack_require__(581);
function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNFSe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4853ade8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNFSe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{class:[!_vm.nota.item.pathPdf && !_vm.nota.item.pathPdfMotor? 'c_disabled' : ''],attrs:{"slot":"activator","disabled":!_vm.nota.item.pathPdf && !_vm.nota.item.pathPdfMotor,"dark":"","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.getPdfById(_vm.nota.item._id, _vm.nota.item.pathPdf)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.nota.item.pathPdf  || _vm.nota.item.pathPdfMotor ?'Visualizar PDF' : 'PDF ainda não disponível, Motor Fiscal está trabalhando nisso.'))])],1),_vm._v(" "),(_vm.nota.item.hasOwnProperty('pathPdf') && _vm.nota.item.pathPdf || _vm.nota.item.hasOwnProperty('pathPdfMotor') && _vm.nota.item.pathPdfMotor)?_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue",staticStyle:{"color":"white"},attrs:{"text-color":"white"}},[_vm._v("\n        PDF NFSE\n        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"tst"}},[_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"src":'data:application/pdf;base64,'+encodeURIComponent(this.pdfB64),"frameborder":"0"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Fechar")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnIptu_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84b3540e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnIptu_vue__ = __webpack_require__(584);
function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnIptu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84b3540e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnIptu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{class:[!_vm.nota.item.pathIPTU ? 'c_disabled' : ''],attrs:{"slot":"activator","disabled":!_vm.nota.item.pathIPTU,"icon":"","small":"","flat":""},on:{"click":function($event){return _vm.getPdfById(_vm.nota.item._id,_vm.nota.item.pathIPTU)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.nota.item.pathIPTU ?'Visualizar PDF' : 'PDF não disponível.'))])],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue text-xs-center",staticStyle:{"color":"white"},attrs:{"text-color":"white"}},[_vm._v("\n                        IPTU\n                        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"tst"}},[_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"src":'data:application/pdf;base64,'+encodeURIComponent(this.nota.item.danfe),"frameborder":"0"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                            Fechar\n                        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[(_vm.component.name.toLowerCase().indexOf('nfe') != -1)?_c('span',[_c('btnNFe',{attrs:{"nota":_vm.nota}})],1):_vm._e(),_vm._v(" "),(_vm.component.name == 'CTE')?_c('span',[_c('btnCTe',{attrs:{"nota":_vm.nota}})],1):_vm._e(),_vm._v(" "),(_vm.component.name == 'NFSE')?_c('span',[_c('btnNFSe',{attrs:{"nota":_vm.nota}})],1):_vm._e(),_vm._v(" "),(_vm.component.name == 'Iptu')?_c('span',[_c('btnIptu',{attrs:{"nota":_vm.nota}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnManifestar_vue__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439d14fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnManifestar_vue__ = __webpack_require__(588);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-439d14fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnManifestar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439d14fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnManifestar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('v-tooltip',{attrs:{"bottom":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-btn',{class:[_vm.disableButton ? 'c_disabled' : ''],attrs:{"slot":"activator","disabled":_vm.disableButton,"icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.setPositionMenu($event)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("touch_app")])],1),_vm._v(" "),_c('span',[_vm._v("Opções de manifesto da nota")])],1),_vm._v(" "),_c('v-menu',{attrs:{"nudge-top":"20","position-x":_vm.menuX,"position-y":_vm.menuY,"close-on-content-click":false,"bottom":"","offset-y":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-list',{attrs:{"id":"options"}},[_c('div',{attrs:{"id":"title"}},[_vm._v("Manifestar")]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('v-list-tile',{key:index,staticClass:"item"},[_c('v-list-tile-title',{on:{"click":function($event){return _vm.vereficaOperacao(item)}}},[_c('v-tooltip',{attrs:{"right":""}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n              "+_vm._s(item.title)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.tooltip))])])],1)],1)})],2)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":_vm.y === 'bottom',"left":_vm.x === 'left',"multi-line":_vm.mode === 'multi-line',"right":_vm.x === 'right',"timeout":_vm.timeout,"top":_vm.y === 'top',"vertical":_vm.mode === 'vertical',"id":"snack"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"color":"orange","flat":""},on:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Fechar")])],1),_vm._v(" "),_c('v-dialog',{directives:[{name:"show",rawName:"v-show",value:(_vm.eventoSelecionado && _vm.eventoSelecionado.hasOwnProperty('tpEvento') && _vm.dialog),expression:"eventoSelecionado && eventoSelecionado.hasOwnProperty('tpEvento') && dialog"}],attrs:{"width":"500"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"grey lighten-2",staticStyle:{"font-size":"14px"},attrs:{"primary-title":""}},[_c('span',[_vm._v("\n          Justifique a manifestação:\n          "),_c('strong',[_vm._v(_vm._s(_vm.eventoSelecionado.title))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.carregando)?_c('v-progress-linear',{staticStyle:{"z-index":"3"},attrs:{"color":"teal","height":"4","indeterminate":""}}):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('v-textarea',{ref:"just",attrs:{"auto-grow":"","box":"","counter":"200","rules":[_vm.rules.tam, _vm.rules.empty],"color":"teal","validate-on-blur":"","label":"Justificativa","rows":"1"},model:{value:(_vm.eventoSelecionado['just']),callback:function ($$v) {_vm.$set(_vm.eventoSelecionado, 'just', $$v)},expression:"eventoSelecionado['just']"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"black","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","text":"white"},on:{"click":function($event){return _vm.validarJust(_vm.eventoSelecionado)}}},[_vm._v("Manifestar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[(_vm.zip)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"d-inline bg_white btnMargin",attrs:{"slot":"activator"},on:{"click":function($event){_vm.dialog = true}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"margin-left":"-5px","margin-right":"8px"},attrs:{"small":"","color":"teal"}},[_vm._v("email")]),_vm._v(" "),_c('small',[_vm._v("E-mail")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.component.name == 'NFSE' ? 'Enviar XML das notas selecionadas por e-mail':'Enviar PDF e XML das notas selecionadas por e-mail'))])],1):_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":""},on:{"click":function($event){_vm.dialog = true}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("email")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.component.name == 'NFSE' ? 'Enviar XML por e-mail':'Enviar PDF e XML por e-mail'))])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px","lazy":true},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue",staticStyle:{"color":"white"},attrs:{"text-color":"white"}},[_vm._v("\n        Enviar E-mail\n        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(this.sendingMail)?_c('v-progress-linear',{staticStyle:{"margin":"0"},attrs:{"color":"teal","indeterminate":true}}):_vm._e(),_vm._v(" "),_c('v-combobox',{staticClass:"email_combo",attrs:{"filter":_vm.filter,"hide-no-data":!_vm.search,"items":_vm.items,"search-input":_vm.search,"hide-selected":"","label":"E-mail:","multiple":"","small-chips":"","solo":"","content-class":"email_combo"},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var parent = ref.parent;
var selected = ref.selected;
return (item === Object(item))?[_c('v-chip',{attrs:{"color":((item.color) + " lighten-3"),"selected":selected,"label":"","small":""}},[_c('span',{staticClass:"pr-2"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return parent.selectItem(item)}}},[_vm._v("close")])],1)]:undefined}},{key:"item",fn:function(ref){
var index = ref.index;
var item = ref.item;
var parent = ref.parent;
return [_c('v-list-tile-content',[(_vm.editing === item)?_c('v-text-field',{attrs:{"autofocus":"","flat":"","background-color":"transparent","hide-details":"","solo":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.edit(index, item)}},model:{value:(_vm.editing.text),callback:function ($$v) {_vm.$set(_vm.editing, "text", $$v)},expression:"editing.text"}}):_c('v-chip',{attrs:{"color":((item.color) + " lighten-3"),"dark":"","label":"","small":""}},[_vm._v(_vm._s(item.text))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-list-tile-action',{on:{"click":function($event){$event.stopPropagation();}}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.edit(index, item)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.editing !== item ? 'edit' : 'check'))])],1)],1),_vm._v(" "),_c('v-list-tile-action',{on:{"click":function($event){$event.stopPropagation();}}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.middleDel(item)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}],null,true),model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('template',{staticStyle:{},slot:"no-data"},[_c('v-list-tile',{staticStyle:{"max-height":"110px"}},[_c('small',[_vm._v("\n              Aperte\n              "),_c('b',[_vm._v("enter")]),_vm._v(" para adicionar o e-mail\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-chip',{staticClass:"env_email",attrs:{"title":_vm.search,"color":((_vm.colors[_vm.nonce - 1]) + " lighten-3"),"label":"","small":""}},[_vm._v(_vm._s(_vm.search))])],1)],1)],2),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding-top":"93px"}},[_c('v-btn',{attrs:{"color":"red","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"teal","dark":""},nativeOn:{"click":function($event){return _vm.enviarEmail()}}},[_vm._v("Enviar")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.component.name != 'NFSE')?_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":""}},[_c('v-flex',{attrs:{"d-flex":"","xs6":"","sm8":"","md8":""}},[_c('v-checkbox',{attrs:{"color":"green","label":this.component.name == 'CTE' ? 'Dacte' : 'Danfe'},model:{value:(_vm.chkDanfe),callback:function ($$v) {_vm.chkDanfe=$$v},expression:"chkDanfe"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"green","label":'XML'},model:{value:(_vm.chkXml),callback:function ($$v) {_vm.chkXml=$$v},expression:"chkXml"}})],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialogDelete),callback:function ($$v) {_vm.dialogDelete=$$v},expression:"dialogDelete"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('small',[_vm._v("Confirmar remoção de e-mail")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Deseja remover \"\n        "),_c('strong',[_vm._v(_vm._s(_vm.mailDelete ? _vm.mailDelete.text : ''))]),_vm._v("\" da lista ?\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","small":"","flat":"flat"},on:{"click":function($event){return _vm.delMail(false)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"success"},on:{"click":function($event){return _vm.delMail(true)}}},[_vm._v("Remover")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":_vm.y === 'bottom',"left":_vm.x === 'left',"multi-line":_vm.mode === 'multi-line',"right":_vm.x === 'right',"timeout":_vm.timeout,"top":_vm.y === 'top',"vertical":_vm.mode === 'vertical',"id":"snack"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"color":"orange","flat":""},on:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUserEmpresa_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2535eea5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUserEmpresa_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUserEmpresa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2535eea5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUserEmpresa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_usuario"},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.formUsuario.form.items),function(item,i){return (item.type == 'T' && !_vm.create ||
              _vm.create && item.item_id == 'nome' ||
              _vm.create && item.item_id == 'email')?_c('v-flex',{key:i,class:[_vm.displayFlex, item.class]},[_c('v-text-field',{attrs:{"color":"teal","prepend-icon":item.prepIcon,"mask":item.mask,"validate-on-blur":"","clearable":"","rules":item.item_id == 'nome' ? _vm.nomeRules : item.item_id == 'email' ? _vm.emailRules : undefined,"disabled":_vm.edit && item.item_id == 'email'},model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}},[_c('template',{slot:"label"},[_vm._v(_vm._s(item.text)+":")])],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.formUsuario.form.items),function(item,i){return (item.type == 'D' && !_vm.create)?_c('v-flex',{key:i,class:_vm.displayFlex},[_c('v-menu',{ref:item.index,refInFor:true,attrs:{"close-on-content-click":false,"nudge-right":40,"color":"teal","lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(item.index),callback:function ($$v) {_vm.$set(item, "index", $$v)},expression:"item.index"}},[_c('v-text-field',{attrs:{"slot":"activator","close-on-content-click":true,"color":"teal","persistent-hint":"","prepend-icon":"event","clearable":"","mask":item.mask},on:{"click:prepend-inner":function($event){return _vm.openMenu($event)},"blur":function($event){return _vm.validateDate($event,item)}},slot:"activator",model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}},[_c('template',{slot:"label"},[_vm._v(_vm._s(item.text))])],2),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","no-title":"","scrollable":""},on:{"input":function($event){item.valor = _vm.formatDate($event), item.index = false}},model:{value:(item.data),callback:function ($$v) {_vm.$set(item, "data", $$v)},expression:"item.data"}})],1)],1):_vm._e()})],2),_vm._v(" "),(_vm.create && _vm.formEmp)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs12 sm12 md12"},[_c('v-combobox',{staticClass:"input-required",attrs:{"filter":_vm.filter,"items":_vm.itemsEmp,"chips":"","label":"Vincular a empresa: ","item-text":"empresa.razao","multiple":true,"prepend-icon":"domain","color":"teal","item-value":"_id","rules":_vm.passRules},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"v-chip--select-multi",attrs:{"selected":data.selected,"disabled":data.disabled,"close":""},on:{"input":function($event){return _vm.remove(data.item)}}},[_c('v-avatar',{staticClass:"teal white--text"},[_vm._v(_vm._s(data.item.empresa != undefined ? data.item.empresa.razao.slice(0, 1).toUpperCase() : ''))]),_vm._v("\n                "+_vm._s(data.item.empresa != undefined ? data.item.empresa.razao : '')+"\n              ")],1)]}}],null,false,2793543426),model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){_vm.dialog2 = !_vm.dialog2}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("person")])],1),_vm._v(" "),_c('span',[_vm._v("Visualizar colaboradores")])],1),_vm._v(" "),(_vm.dialog2)?_c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog2),callback:function ($$v) {_vm.dialog2=$$v},expression:"dialog2"}},[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Colaboradores vinculados a "+_vm._s(_vm.nota.item.razao))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog2 = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"d-inline-block",attrs:{"slot":"activator","outline":"","color":"black","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.showFormCadastrar('Colaborador')}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px"},attrs:{"dark":"","color":"teal"}},[_vm._v("person_add")]),_vm._v(" "),_c('small',[_vm._v("Adicionar Colaborador")])],1),_vm._v(" "),_c('span',[_vm._v("Adicionar um novo colaborador a \""+_vm._s(_vm.nota.item.razao)+"\"")])],1),_vm._v(" "),_c('article',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"700px","transition":"dialog-bottom-transition"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.salvarDados()}]},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Configuração do Colaborador")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',[_c('v-subheader',{staticClass:".container",attrs:{"subheader":""}},[_c('h2',[_vm._v(_vm._s(_vm.formEmp.titulo))])]),_vm._v(" "),_c('FormUsuario',{attrs:{"displayFlex":'xs6 sm6 md6',"create":true,"resetForm":_vm.resetForm,"getDadosForm":_vm.getDadosForm},on:{"changResetForm":function($event){return _vm.changResetForm($event)},"emitDadosForm":function($event){return _vm.emitDadosForm($event)}}}),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","small":"","color":"teal"},nativeOn:{"click":function($event){return _vm.salvarDados()}}},[_vm._v(_vm._s(_vm.formEmp.btnSuccess))])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.formEmp.show)?_c('v-container',{staticClass:"panelFiltro"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","margin-left":"1em"}},[_vm._v(" "+_vm._s(_vm.formEmp.titulo)+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cardPerfil"},[_c('div',{staticClass:"cardPerfil-body"},[_c('RenderTableNFe',{attrs:{"empresa":this.nota.item,"conta":this.conta,"alert":this.alert,"sendAttTable":this.sendAttTable,"table":'usuario',"arrayItems":_vm.nota.item.colaboradores,"attTableEmp":this.attTableEmp},on:{"attSendTable":function($event){return _vm.attSendTable($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)},"attTableEmp":function($event){return _vm.attTableEmp($event)}}})],1)])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnInfClientFornc_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d33b0da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnInfClientFornc_vue__ = __webpack_require__(598);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnInfClientFornc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d33b0da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnInfClientFornc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticStyle:{"margin-top":"4px"}},[_c('span',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){_vm.dialog = !_vm.dialog}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_action",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z"}})])]),_vm._v(" "),_c('span',[_vm._v("Visualizar Endereço / Inf. adicionais")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Informações adicionais do "+_vm._s(_vm.component.text))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.printInfos()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',{attrs:{"id":("infoBody_" + (this.forn._id))}},[_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_c('h2',[_vm._v(_vm._s(_vm.component.text)+":")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Razão Social:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.xNome))])])],1)],1)],1),_vm._v(" "),(_vm.component.name == 'fornecedores')?_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Nome fantasia:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.xFant))])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("CNPJ/CPF:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.CNPJ != undefined ? (_vm.forn.CNPJ.length > 11 ? _vm.forn.CNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : _vm.forn.CNPJ.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.component.name == 'fornecedores' ? 'Compras:' : 'Vendas:'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.qtd))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.component.name == 'fornecedores' ? 'Serviço Tomado:' : 'Serviço Prestado:'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.qntServico))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Menor Valor de "+_vm._s(_vm.component.name == 'fornecedores' ? 'Compra:' : 'Venda:'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.vlrMin.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Maior Valor de "+_vm._s(_vm.component.name == 'fornecedores' ? 'Compra:' : 'Venda:'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.vlrMax.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Primeira "+_vm._s(_vm.component.name == 'fornecedores' ? 'Compra:' : 'Venda:'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.dtPrimeiraCompra != undefined ? _vm.forn.dtPrimeiraCompra.toLocaleDateString('pt-BR') : ''))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Última "+_vm._s(_vm.component.name == 'fornecedores' ? 'Compra:' : 'Venda:'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.dtUltimaCompra != undefined ? _vm.forn.dtUltimaCompra.toLocaleDateString('pt-BR') : ''))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Data de Inclusão:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.dtInclusao != undefined ? new Date(_vm.forn.dtInclusao).toLocaleDateString('pt-BR') : ''))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Inscrição Estadual:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.IE))])])],1)],1)],1),_vm._v(" "),(_vm.component.name == 'fornecedores')?_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Regime:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.CRT))])])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_c('h2',[_vm._v("Localização:")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Endereço:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.enderEmit.xLgr)+", "+_vm._s(_vm.forn.enderEmit.nro))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Bairro:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.enderEmit.xBairro))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("CEP:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.enderEmit.CEP.replace(/^(\d{5})(\d)/,"$1-$2")))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("UF:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.enderEmit.UF))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Município:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.enderEmit.xMun))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("País:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.enderEmit.xPais))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Telefone:")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.forn.enderEmit.fone != undefined && _vm.forn.enderEmit.fone.length == 8 ? _vm.forn.enderEmit.fone.replace(/^(\d{4})(\d)/,"$1-$2") : _vm.forn.enderEmit.fone != undefined && _vm.forn.enderEmit.fone.length == 11 ? _vm.forn.enderEmit.fone.replace(/^(\d{3})(\d{4})(\d)/,"($1) $2-$3") : _vm.forn.fone))])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_c('h2',[_vm._v("Dados customizados:")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.forn),function(item,i){return (i.indexOf('custom_') != -1 && item.value != null && item.value.length > 0)?_c('v-flex',{key:item._id,attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.nomeColumn(i))+":")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(item.value))])])],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.noDataText)?_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"text-transform":"capitalize"}},[_vm._v("Não possui informações customizadas.")])],1)],1)],1):_vm._e()],2)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btnInfNfses_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09031cdf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btnInfNfses_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btnInfNfses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09031cdf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btnInfNfses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){_vm.dialog = !_vm.dialog}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_action",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z"}})])]),_vm._v(" "),_c('span',[_vm._v("Visualizar Inf. Estruturadas")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Informações da "+_vm._s(_vm.component.text)+" - "+_vm._s(_vm.component.tipo.charAt(0).toUpperCase() + _vm.component.tipo.slice(1)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.printInfos()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',{staticClass:"view_indo_nfse",attrs:{"id":("infoBody_" + (this.nota._id))}},[_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_c('h2',[_vm._v(_vm._s(_vm.component.text)+":")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.table.headers),function(headers,i){return (headers.show && headers.enable && headers.value.indexOf('custom_') == -1)?_c('v-flex',{key:i,class:[headers.value == 'discriminacao' ? 'flex xs12 sm12 md12 xl12' : 'flex xs6 sm3 md3 xl3']},[_c('v-list-tile',{class:[headers.value == 'discriminacao' ? 'altura_maior' : ''],attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"padding-bottom":"20px"}},[_vm._v(_vm._s(headers.text)+":")]),_vm._v(" "),_c('v-list-tile-sub-title',{attrs:{"id":headers.value}},[(headers.value.indexOf('dt') != -1)?_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.nota[headers.value] ? _vm.nota[headers.value].toLocaleDateString() : ''))]):(headers.value.indexOf('vlr') != -1)?_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.nota[headers.value] ? _vm.nota[headers.value].toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : ''))]):(headers.value.indexOf('tribNfe') != -1)?_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.tributacao ? ((_vm.tributacao.tipo) + " - " + (_vm.tributacao.desc)) : ''))]):(headers.value.indexOf('opcaoSimples') != -1)?_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.simples ? ((_vm.simples.tipo) + " - " + (_vm.simples.desc)) : ''))]):(headers.value.indexOf('ISSRetido') != -1)?_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.nota[headers.value] ? _vm.nota[headers.value] == 'true' ? 'Sim' : 'Não' : ''))]):(headers.value.indexOf('vlr') != -1)?_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.nota[headers.value] ? _vm.nota[headers.value].toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : ''))]):(headers.value.indexOf('cnpj') != -1)?_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.nota[headers.value] ? _vm.nota[headers.value].length == 14 ? _vm.nota[headers.value].replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : _vm.nota[headers.value].replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : ''))]):_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(_vm.nota[headers.value]))])]),_vm._v(" "),_c('v-list-tile-sub-title')],1)],1)],1):_vm._e()}),1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_c('h2',[_vm._v("Dados customizados:")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.nota),function(item,i){return (i.indexOf('custom_') != -1 && item.value != null && item.value.length > 0)?_c('v-flex',{key:item._id,attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.nomeColumn(i))+":")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"fundo_destaque"},[_vm._v(_vm._s(item.value))])])],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.noDataText)?_c('v-flex',{attrs:{"xs6":"","sm3":"","md3":"","xl3":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"text-transform":"capitalize"}},[_vm._v("Não possui informações customizadas.")])],1)],1)],1):_vm._e()],2)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RmvCertificado_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2f68e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RmvCertificado_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RmvCertificado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2f68e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RmvCertificado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('v-tooltip',{staticStyle:{"z-index":"929"},attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.rmvCertificado()}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("delete_outline")])],1),_vm._v(" "),_c('span',[_vm._v("Remover certificado")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RmvColaborador_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4600175a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RmvColaborador_vue__ = __webpack_require__(607);
function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RmvColaborador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4600175a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RmvColaborador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('v-tooltip',{staticStyle:{"z-index":"929"},attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.rmvColaborador()}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("delete_outline")])],1),_vm._v(" "),_c('span',[_vm._v("Remover colaborador")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkIntegracao_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01dbb766_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkIntegracao_vue__ = __webpack_require__(611);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01dbb766"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkIntegracao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01dbb766_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkIntegracao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);








var TokenService = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TokenService, _CommonService);

    function TokenService(http) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TokenService);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TokenService.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TokenService)).call(this, http));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TokenService, [{
        key: "nvToken",
        value: function nvToken(idEmpr) {
            var url = "integracoes/token/novo/" + idEmpr;
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ nvToken: true });
            return this._resource.post(url, body).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "vinculaEmpr",
        value: function vinculaEmpr(idEmpr, refEmpresa) {
            var url = "integracoes/token/novo/" + idEmpr;
            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ nvToken: false, refEmpresa: refEmpresa });
            return this._resource.post(url, body).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "buscaToken",
        value: function buscaToken(idEmpr) {
            var url = "integracoes/token/" + idEmpr;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }]);

    return TokenService;
}(__WEBPACK_IMPORTED_MODULE_6__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TokenService);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){_vm.dialogIntegracao = !_vm.dialogIntegracao}},slot:"activator"},[_c('svg',{staticClass:"E_icon customIcon i_action",staticStyle:{"width":"18px","height":"18px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M14.28,14.08L12.26,16.1C11.66,16.7 10.87,17 10.08,17C9.29,17 8.5,16.7 7.9,16.1C6.7,14.9 6.7,12.95 7.9,11.74L9.15,10.5L9.14,11.06C9.14,11.5 9.21,11.95 9.36,12.37L9.41,12.5L9.04,12.87C8.76,13.15 8.6,13.53 8.6,13.92C8.6,14.32 8.76,14.69 9.04,14.97C9.6,15.53 10.57,15.53 11.13,14.97L13.14,12.96C13.43,12.67 13.58,12.3 13.58,11.91C13.58,11.5 13.43,11.14 13.15,10.86C13,10.71 12.9,10.5 12.9,10.29C12.9,10.08 13,9.88 13.15,9.73C13.45,9.42 14,9.43 14.28,9.73C14.86,10.31 15.18,11.08 15.18,11.9C15.18,12.73 14.86,13.5 14.28,14.08M17.1,11.26L15.85,12.5L15.86,11.94C15.86,11.5 15.79,11.06 15.64,10.64L15.6,10.5L15.96,10.13C16.25,9.85 16.4,9.5 16.4,9.08C16.4,8.69 16.25,8.32 15.97,8.04C15.4,7.47 14.43,7.47 13.87,8.04L11.86,10.05C11.58,10.33 11.42,10.7 11.42,11.1C11.42,11.5 11.57,11.86 11.86,12.14C12,12.29 12.1,12.5 12.1,12.71C12.1,12.93 12,13.13 11.85,13.28C11.7,13.44 11.5,13.5 11.29,13.5C11.09,13.5 10.88,13.43 10.72,13.28C9.5,12.08 9.5,10.12 10.72,8.92L12.74,6.9C13.95,5.7 15.9,5.7 17.1,6.9C17.68,7.5 18,8.26 18,9.08C18,9.9 17.68,10.68 17.1,11.26Z"}})])]),_vm._v(" "),_c('span',[_vm._v("Token de integração desta empresa")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialogIntegracao == true && _vm.dialogConfirmacao == false ? _vm.dialogIntegracao = false : ''}},model:{value:(_vm.dialogIntegracao),callback:function ($$v) {_vm.dialogIntegracao=$$v},expression:"dialogIntegracao"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue"},[_c('small',{staticClass:"white--text"},[_vm._v("Token")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogIntegracao = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-card-text',[(this.page1 && this.nota.item.tknIntegracao && this.nota.item.tknIntegracao.token)?_c('article',{staticClass:"fadeInUp"},[_c('small',{staticClass:"token_title"},[_vm._v("Token:")]),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"-5px"},attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('div',{staticClass:"white--text blue-grey lighten-2 text-xs-center fieldToken",attrs:{"id":("fieldToken_" + (_vm.nota.item.cnpj))}},[_vm._v(_vm._s(this.nota.item.tknIntegracao.token))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"teal","icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.copyToken(("fieldToken_" + (_vm.nota.item.cnpj)))}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_action",staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"}})])]),_vm._v(" "),_c('span',[_vm._v("Copiar Token")])],1)],1)],1)],1):((this.page1 && !this.nota.item.tknIntegracao) || (this.page1 && !this.nota.item.tknIntegracao.token && !this.nota.item.tknIntegracao.refEmpresa))?_c('article',{staticClass:"fadeInUp"},[_c('div',{staticClass:"token_title text-xs-center"},[_vm._v("Deseja realizar integração com Motor Fiscal?")])]):(this.page1 && this.nota.item.tknIntegracao && this.nota.item.tknIntegracao.refEmpresa)?_c('article',{staticClass:"fadeInUp"},[_c('div',{staticClass:"token_title text-xs-center"},[_vm._v("\n            Token de: \""+_vm._s(_vm.nota.item && _vm.nota.item.razao ? _vm.nota.item.razao.split(' ')[0] : '')+"\" é o mesmo token de:\n            "),_c('div',{staticClass:"emprRazaoVinculada",attrs:{"title":_vm.getRazaoEmprVinculada(_vm.nota.item.tknIntegracao.refEmpresa)}},[_vm._v(_vm._s(_vm.getRazaoEmprVinculada(_vm.nota.item.tknIntegracao.refEmpresa)))])]),_vm._v("\n          "+_vm._s(this.buscaToken())+"\n          "),_c('small',{staticClass:"token_title"},[_vm._v("Token:")]),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"-5px"},attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('div',{staticClass:"white--text blue-grey lighten-2 text-xs-center fieldToken",attrs:{"id":("fieldToken_" + (_vm.nota.item.cnpj))}},[_vm._v(_vm._s(this.tknBuscado))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"teal","icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.copyToken(("fieldToken_" + (_vm.nota.item.cnpj)))}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_action",staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"}})])]),_vm._v(" "),_c('span',[_vm._v("Copiar Token")])],1)],1)],1)],1):(!this.page1 && this.pageVerTokens)?_c('article',{staticClass:"fadeInUp",staticStyle:{"margin-top":"-15px"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":""},nativeOn:{"click":function($event){return _vm.resetDialog()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("arrow_back")])],1),_vm._v(" "),_c('span',[_vm._v("Voltar")])],1),_vm._v(" "),_c('div',[_c('v-autocomplete',{staticClass:"selectEmprVinculo",attrs:{"item-text":_vm.setLabel,"items":_vm.getEmpresasComTokensCadastrados(),"label":"Empresas:","color":"teal","prepend-icon":"location_city","no-data-text":"Não possui empresas com tokens cadastrados","return-object":""},model:{value:(_vm.emprVinculoSelecionada),callback:function ($$v) {_vm.emprVinculoSelecionada=$$v},expression:"emprVinculoSelecionada"}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"small":"","loading":_vm.loading,"disabled":_vm.loading,"color":"dark_blue"},on:{"click":function($event){return _vm.middle()}}},[_vm._v(_vm._s(this.nota.item.tknIntegracao && this.nota.item.tknIntegracao.token ? 'Renovar Token' : 'Gerar Token'))]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","small":"","loading":_vm.loading,"disabled":_vm.loading,"color":"teal"},on:{"click":function($event){return _vm.acaoBtnVinculadas()}},slot:"activator"},[_vm._v(_vm._s(this.pageVerTokens ? 'Vincular' : 'Tokens existentes'))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.pageVerTokens ? 'Vincular com empresa selecionada' : 'Vincular esta empresa com alguma que já possua token'))])],1)],1)])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialogConfirmacao = false}},model:{value:(_vm.dialogConfirmacao),callback:function ($$v) {_vm.dialogConfirmacao=$$v},expression:"dialogConfirmacao"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('small',[_vm._v("Confirmar renovação de token")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Token de integração para: \"\n        "),_c('strong',[_vm._v(_vm._s(_vm.nota ? _vm.nota.item.razao : ''))]),_vm._v("\" será renovado.\n        "),_c('br'),_vm._v("Com isso vem a necessidade de atualizar os ambientes que utilizam o token\n        "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Confirmar operação?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","small":"","flat":"flat"},on:{"click":function($event){_vm.dialogConfirmacao = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"teal"},on:{"click":function($event){_vm.gerarToken(), _vm.dialogConfirmacao = false}}},[_vm._v("Renovar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReenvioEmail_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a870db30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReenvioEmail_vue__ = __webpack_require__(614);
function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReenvioEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a870db30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReenvioEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('v-tooltip',{staticStyle:{"z-index":"929"},attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.reenviar()}},slot:"activator"},[_c('v-icon',[_vm._v("compare_arrows")])],1),_vm._v(" "),_c('span',[_vm._v("Reenviar solicitação por E-mail")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[(!_vm.edit)?_c('v-btn',{staticClass:"d-inline-block bg_white",attrs:{"slot":"activator","text-color":"white","id":"btn_consultaAvulsa"},nativeOn:{"click":function($event){return _vm.handleOpenDialogInsert($event)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal","small":""}},[_vm._v("mdi-plus")]),_vm._v(" "),_c('small',[_vm._v("Nova Nota")])],1):(_vm.edit && _vm.nota.origem != 'MotorV2' && _vm.nota.statusEmissao === 'falha')?_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.handleOpenDialog($event)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"margin-top":"1px","margin-right":"1px"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(!_vm.edit)?_c('span',[_vm._v("Incluir nova nota")]):_c('span',[_vm._v("Editar nota")]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"760px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleCancelar($event)}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[(!_vm.edit)?_c('v-toolbar-title',[_vm._v("Incluir Nova Nota")]):_c('v-toolbar-title',[_vm._v("Editar Nota")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.handleCancelar($event)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',[(_vm.failureMessages)?_c('div',[_c('v-alert',{staticStyle:{"padding":"5px"},attrs:{"value":true,"type":"error","dismissible":true}},[_vm._v("\n          "+_vm._s(_vm.failureMessages)+"\n            \n          ")])],1):_vm._e(),_vm._v(" "),_c('v-card-text',{staticClass:"form_empresa_inputs",staticStyle:{"width":"90%","margin":"auto"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"color":"teal","lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.showDate),callback:function ($$v) {_vm.showDate=$$v},expression:"showDate"}},[_c('v-text-field',{ref:"dataInput",staticClass:"input-required",attrs:{"slot":"activator","close-on-content-click":true,"color":"teal","persistent-hint":"","clearable":"","rules":_vm.date2 ? _vm.dateRules : _vm.razaoRules,"mask":_vm.mask.date,"validate-on-blur":"","required":""},on:{"blur":function($event){return _vm.validateDate()}},slot:"activator",model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}},[_c('template',{slot:"label"},[_vm._v("Data da prestação do serviço")])],2),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","max":_vm.nowDate,"no-title":"","scrollable":""},on:{"input":function($event){_vm.date2 = _vm.formatDate($event), _vm.showDate = false},"change":function($event){return _vm.eventDate($event)}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"required":"","flat":"","mask":_vm.mask.cnpj,"rules":_vm.cnpj && _vm.cnpj.length > 11 ? _vm.cnpjRules : _vm.cpfRules,"label":"CPF/CNPJ","clearable":"","validate-on-blur":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }_vm.mask ? _vm.mask.cnpj = '' : ''},"keyup":function($event){return _vm.trocaCampoCpfCnpj($event, _vm.cnpj)}},model:{value:(_vm.cnpj),callback:function ($$v) {_vm.cnpj=$$v},expression:"cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"Razão Social / Nome do Tomador","required":"","clearable":"","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.razao),callback:function ($$v) {_vm.razao=$$v},expression:"razao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"E-mail","required":"","clearable":"","validate-on-blur":"","rules":_vm.email ? _vm.emailRules : _vm.razaoRules},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"CEP","required":"","mask":_vm.mask.cep,"clearable":"","validate-on-blur":"","rules":_vm.razaoRules},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }_vm.mask ? _vm.mask.cep = '' : ''},"keyup":function($event){return _vm.trocaCampoCep($event, _vm.cep)},"keypress":function($event){return _vm.isNumber($event)}},model:{value:(_vm.cep),callback:function ($$v) {_vm.cep=$$v},expression:"cep"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{staticClass:"input-required",attrs:{"autocomplete":false,"validate-on-blur":"","item-text":"sigla","items":_vm.arrayEstados,"label":"Estado","clearable":"","persistent-hint":"","no-data-text":"Consulta de Estado indisponível","return-object":"","rules":_vm.razaoRules},on:{"change":_vm.getMunicipios},model:{value:(_vm.estado),callback:function ($$v) {_vm.estado=$$v},expression:"estado"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{staticClass:"input-required",attrs:{"label":"Município","autocomplete":false,"validate-on-blur":"","item-text":"nome","items":_vm.arrayMunicipios,"clearable":"","persistent-hint":"","no-data-text":"Selecione um Estado","return-object":"","rules":_vm.razaoRules},model:{value:(_vm.municipio),callback:function ($$v) {_vm.municipio=$$v},expression:"municipio"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"Bairro","required":"","clearable":"","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.bairro),callback:function ($$v) {_vm.bairro=$$v},expression:"bairro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"Logradouro","required":"","clearable":"","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.logradouro),callback:function ($$v) {_vm.logradouro=$$v},expression:"logradouro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"Número","required":"","type":"number","clearable":"","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.numero),callback:function ($$v) {_vm.numero=$$v},expression:"numero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Complemento","clearable":""},model:{value:(_vm.complemento),callback:function ($$v) {_vm.complemento=$$v},expression:"complemento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Inscrição municipal do tomador","clearable":""},on:{"keypress":function($event){return _vm.isNumber($event)}},model:{value:(_vm.inscricaoMunicipal),callback:function ($$v) {_vm.inscricaoMunicipal=$$v},expression:"inscricaoMunicipal"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Telefone","clearable":"","validate-on-blur":"","mask":'(##)#########',"rules":_vm.telefone ? _vm.telefoneRules : []},on:{"keypress":function($event){return _vm.isNumber($event)}},model:{value:(_vm.telefone),callback:function ($$v) {_vm.telefone=$$v},expression:"telefone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"Valor","required":"","clearable":"","validate-on-blur":"","rules":_vm.razaoRules},on:{"input":function($event){return _vm.maskValor(_vm.valor)},"keypress":function($event){return _vm.isNumber($event)}},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-textarea',{staticClass:"input-required",staticStyle:{"font-size":"0.8em"},attrs:{"label":"Discriminação do(s) serviço(s) prestados","required":"","clearable":"","auto-grow":"","row-height":"4","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.discriminacao),callback:function ($$v) {_vm.discriminacao=$$v},expression:"discriminacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Natureza da Operação","required":"","readonly":"","disabled":"","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.naturezaOperacao),callback:function ($$v) {_vm.naturezaOperacao=$$v},expression:"naturezaOperacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Regime Especial de Tributação","required":"","readonly":"","disabled":"","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.regimeTributacao),callback:function ($$v) {_vm.regimeTributacao=$$v},expression:"regimeTributacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Município da incidência do ISSQN","readonly":"","disabled":"","required":"","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.issqn),callback:function ($$v) {_vm.issqn=$$v},expression:"issqn"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-textarea',{staticStyle:{"font-size":"0.8em"},attrs:{"label":"Código de Tributação do Município (CTISS)","readonly":"","disabled":"","required":"","row-height":"10","validate-on-blur":"","auto-grow":"","rules":_vm.razaoRules},model:{value:(_vm.codigoTributacao),callback:function ($$v) {_vm.codigoTributacao=$$v},expression:"codigoTributacao"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px"},attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},on:{"click":_vm.handleCancelar}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","small":"","color":"teal"},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(!_vm.edit ? 'Incluir' : 'Atualizar'))])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialogAviso = false}},model:{value:(_vm.dialogAviso),callback:function ($$v) {_vm.dialogAviso=$$v},expression:"dialogAviso"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Aviso")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAviso = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',[_c('v-card-text',[_c('v-container',[_c('h3',[_vm._v("Foram encontradas duplicidades nos campos:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_c('b',[_vm._v("CPF/CNPJ:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.cnpjAviso))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_c('b',[_vm._v("Data serviço:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.dataAviso))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_c('b',[_vm._v("Valor:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.valorAviso ? ("R$ " + _vm.valorAviso) : ''))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("Deseja prosseguir com a inclusão?")])])],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px"},attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},on:{"click":function($event){_vm.dialogAviso=false}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","small":"","color":"teal"},on:{"click":_vm.handleDuplicidade}},[_vm._v("Incluir")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[(!_vm.edit)?_c('v-btn',{staticClass:"d-inline-block",attrs:{"slot":"activator","outline":"","color":"black","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.handleOpenDialog($event)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px","font-size":"13px!important","position":"absolute","left":"-8%"},attrs:{"dark":"","color":"teal"}},[_vm._v("add")]),_vm._v(" "),_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px"},attrs:{"dark":"","color":"teal"}},[_vm._v("domain")]),_vm._v(" "),_c('small',[_vm._v("Adicionar imóvel")])],1):(_vm.edit)?_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.handleOpenDialogEdit($event)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(!_vm.edit)?_c('span',[_vm._v("Adicionar um novo imóvel")]):_c('span',[_vm._v("Editar imóvel")]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"760px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleCancelar($event)}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[(!_vm.edit)?_c('v-toolbar-title',[_vm._v("Adicionar novo Imóvel")]):_c('v-toolbar-title',[_vm._v("Editar Imóvel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.handleCancelar($event)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',[_c('v-card-text',{staticClass:"form_empresa_inputs",staticStyle:{"width":"90%","margin":"auto"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"Numero da Inscrição do Imóvel ","required":"","clearable":"","validate-on-blur":"","rules":_vm.razaoRules},on:{"keypress":function($event){return _vm.isNumber($event)}},model:{value:(_vm.inscricao),callback:function ($$v) {_vm.inscricao=$$v},expression:"inscricao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{staticClass:"input-required",attrs:{"items":_vm.comboPagamento,"label":"Forma de Pagamento","required":"","clearable":"","validate-on-blur":"","rules":_vm.razaoRules},model:{value:(_vm.pagamento),callback:function ($$v) {_vm.pagamento=$$v},expression:"pagamento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{staticClass:"input-required",attrs:{"validate-on-blur":"","item-text":"sigla","items":_vm.arrayEstados,"label":"Estado","clearable":"","persistent-hint":"","no-data-text":"Consulta de Estado indisponível","return-object":"","rules":_vm.razaoRules},on:{"change":_vm.getMunicipios},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{staticClass:"input-required",attrs:{"label":"Município","validate-on-blur":"","item-text":"nome","items":_vm.arrayMunicipios,"clearable":"","persistent-hint":"","no-data-text":"Selecione um Estado","return-object":"","rules":_vm.razaoRules},model:{value:(_vm.municipio),callback:function ($$v) {_vm.municipio=$$v},expression:"municipio"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-textarea',{staticStyle:{"font-size":"0.8em"},attrs:{"label":"Descrição do Imóvel","clearable":"","auto-grow":"","row-height":"4","validate-on-blur":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Prefixo do nome do arquivo","clearable":"","validate-on-blur":""},model:{value:(_vm.prefixo),callback:function ($$v) {_vm.prefixo=$$v},expression:"prefixo"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px"},attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},on:{"click":_vm.handleCancelar}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","small":"","color":"teal"},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(!_vm.edit ? 'Adicionar' : 'Atualizar'))])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actionsDisplay"},[(_vm.component.name === 'NFSE' && _vm.component.tipo === 'emitida'  && _vm.empresa.servicos && _vm.empresa.servicos.robotizacao && _vm.empresa.servicos.robotizacao.find(function (item) { return item.nomeServico === 'NFSE_TOMADOS'; }))?_c('btnNovaNota',{attrs:{"conta":_vm.conta,"empresa":_vm.empresa,"table":_vm.table,"component":_vm.component,"edit":true,"nota":this.nota.item}}):_vm._e(),_vm._v(" "),(_vm.component.name =='automacaoFiscal')?_c('btnNovoImovel',{attrs:{"IBGE":this.IBGE,"edit":true,"nota":this.nota.item,"empresa":_vm.empresa}}):_vm._e(),_vm._v(" "),(_vm.component.name =='NFSE')?_c('btnInfNfses',{staticStyle:{"display":"inline-grid"},attrs:{"nota":this.nota.item,"table":this.table,"component":this.component}}):_vm._e(),_vm._v(" "),(this.component.enable.verPdf)?_c('btnVisualizar',{attrs:{"component":this.component,"nota":this.nota}}):_vm._e(),_vm._v(" "),((this.component.name.indexOf('NFeRecebidas') != -1 && this.component.tipo != 'emitida' && this.component.tipo != 'transportados' || this.component.name.indexOf('CTE') != -1  && this.component.tipo == 'tomados') && this.empresa.cnpj.length > 11)?_c('btnManifestar',{attrs:{"chave":this.nota.item.chave,"empresa":_vm.empresa._id,"component":this.component,"nota":this.nota}}):_vm._e(),_vm._v(" "),_c('btnDownload',{attrs:{"component":this.component,"nota":this.nota},nativeOn:{"click":function($event){return _vm.getPDFXml(_vm.nota.item._id, 2)}}}),_vm._v(" "),(_vm.component.name === 'NFSE' && _vm.empresa.servicos && _vm.empresa.servicos.robotizacao && _vm.empresa.servicos.robotizacao.find(function (item) { return item.nomeServico === 'NFSE_TOMADOS'; }))?_c('btnXml',{attrs:{"conta":_vm.conta,"empresa":_vm.empresa,"nota":this.nota,"component":_vm.component}}):_vm._e(),_vm._v(" "),(this.component.enable.envEmail)?_c('btnEmail',{staticStyle:{"display":"inline-block"},attrs:{"empresa":this.empresa,"id_nota":this.nota.item._id,"conta":this.conta,"table":this.table,"component":this.component}}):_vm._e(),_vm._v(" "),(_vm.component.name =='fornecedores' || _vm.component.name == 'clientes')?_c('btnInfClientFornc',{staticStyle:{"display":"inline-block"},attrs:{"forn":this.nota.item,"table":this.table,"component":this.component}}):_vm._e(),_vm._v(" "),(_vm.component.name =='certificado')?_c('rmvCertificado',{attrs:{"attTableEmp":this.attTableEmp,"empresa":this.empresa,"table":this.table,"alert":this.alert,"nota":_vm.nota,"conta":this.conta},on:{"attTableEmp":function($event){return _vm.attTableEmp($event)}}}):_vm._e(),_vm._v(" "),(_vm.component.name =='empresa')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","small":"","flat":""},nativeOn:{"click":function($event){return _vm.emitEditEmp()}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons"},[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Alterar informações desta empresa")])],1):_vm._e(),_vm._v(" "),(_vm.component.name =='empresa')?_c('btnUserEmpresa',{attrs:{"table":this.table,"alert":this.alert,"nota":_vm.nota,"conta":this.conta}}):_vm._e(),_vm._v(" "),(_vm.component.name =='empresa')?_c('btnLinkIntegracao',{attrs:{"table":this.table,"alert":this.alert,"nota":_vm.nota,"conta":this.conta}}):_vm._e(),_vm._v(" "),(_vm.component.name =='usuario')?_c('rmvColaborador',{attrs:{"attTableEmp":this.attTableEmp,"empresa":this.empresa,"table":this.table,"alert":this.alert,"nota":_vm.nota,"conta":this.conta},on:{"attTableEmp":function($event){return _vm.attTableEmp($event)}}}):_vm._e(),_vm._v(" "),(_vm.component.name =='usuario' && (_vm.nota.item.preCadastro != undefined && _vm.nota.item.preCadastro.length > 0))?_c('reenvioEmail',{attrs:{"attTableEmp":this.attTableEmp,"empresa":this.empresa,"nota":this.nota.item,"conta":this.conta},on:{"attTableEmp":function($event){return _vm.attTableEmp($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionsHeader_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7624903a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionsHeader_vue__ = __webpack_require__(708);
function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7624903a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionsHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7624903a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionsHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component.enable.rangeDate)?_c('span',{staticStyle:{"display":"flex"}},_vm._l((_vm.buttons),function(item,i){return _c('v-flex',{key:i,staticClass:"rangeDate",attrs:{"xs6":"","sm2":"","md2":"","d-flex":""}},[_c('v-btn',{class:'d-inline-block'+ ' btn_'+item.value+'_'+_vm.component.name,attrs:{"slot":"activator","outline":"","color":"teal","text-color":"white","dark":"","round":""},nativeOn:{"click":function($event){return _vm.changeOptionData(item,$event)}},slot:"activator"},[(item.value == 'tudo')?[_c('v-icon',{staticClass:"iconFiltrarRangedButtons",attrs:{"small":"","color":"teal"}},[_vm._v("filter_list")])]:_vm._e(),_vm._v(" "),_c('small',[_vm._v(_vm._s(item.text))])],2)],1)}),1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnConsultaAvulsa_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e32fdc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnConsultaAvulsa_vue__ = __webpack_require__(629);
function injectStyle (ssrContext) {
  __webpack_require__(628)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e32fdc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnConsultaAvulsa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e32fdc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnConsultaAvulsa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"article_btnConsulta"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"d-inline-block bg_white",attrs:{"slot":"activator","loading":_vm.loading4,"disabled":_vm.loading4,"text-color":"white","id":"btn_consultaAvulsa"},nativeOn:{"click":function($event){return _vm.consultar()}},slot:"activator"},[_c('span',{staticClass:"TST",attrs:{"slot":"loader"},slot:"loader"},[((_vm.logQtd && _vm.logQtd >= 10) && _vm.hrRestante.busca == true)?_c('small',{staticClass:"restante"},[_vm._v(_vm._s(_vm.hrRestante.timer))]):_c('v-icon',{staticClass:"custom-loader",attrs:{"light":""}},[_vm._v("cached")])],1),_vm._v(" "),_c('svg',{staticClass:"customIcon i_header",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M12,4C15.64,4 18.67,6.59 19.35,10.04C21.95,10.22 24,12.36 24,15A5,5 0 0,1 19,20H6A6,6 0 0,1 0,14C0,10.91 2.34,8.36 5.35,8.04C6.6,5.64 9.11,4 12,4M7.5,9.69C6.06,11.5 6.2,14.06 7.82,15.68C8.66,16.5 9.81,17 11,17V18.86L13.83,16.04L11,13.21V15C10.34,15 9.7,14.74 9.23,14.27C8.39,13.43 8.26,12.11 8.92,11.12L7.5,9.69M9.17,8.97L10.62,10.42L12,11.79V10C12.66,10 13.3,10.26 13.77,10.73C14.61,11.57 14.74,12.89 14.08,13.88L15.5,15.31C16.94,13.5 16.8,10.94 15.18,9.32C14.34,8.5 13.19,8 12,8V6.14L9.17,8.97Z"}})]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.component.name != 'NFSE' ? 'Consulta Sefaz' : 'Consulta Avulsa'))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tooltipMessage))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnColumn_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bd07f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnColumn_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42bd07f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bd07f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNewColumn_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11dff55f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNewColumn_vue__ = __webpack_require__(634);
function injectStyle (ssrContext) {
  __webpack_require__(633)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11dff55f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNewColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11dff55f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNewColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"green darken-2","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.openModal()}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"dark":"","color":"green"}},[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Criar nova coluna personalizável")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.newColumn()}]},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Adicionar nova coluna personalizável")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title')],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h4',[_vm._v("Nome da coluna")]),_vm._v(" "),_c('v-form',{ref:"newColumn"},[_c('v-text-field',{ref:"inputText",attrs:{"counter":"30","rules":_vm.rules,"placeholder":"Ex: anotação"},model:{value:(_vm.columnName),callback:function ($$v) {_vm.columnName=$$v},expression:"columnName"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-switch',{attrs:{"color":"success","label":"Acrescentar coluna nas buscas da tabela"},model:{value:(_vm.columnPesq),callback:function ($$v) {_vm.columnPesq=$$v},expression:"columnPesq"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.newColumn()}}},[_vm._v("Criar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnRmvColumn_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5efdde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnRmvColumn_vue__ = __webpack_require__(640);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d5efdde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnRmvColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5efdde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnRmvColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnEditColumn_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5dc341_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnEditColumn_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f5dc341"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnEditColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5dc341_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnEditColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"inline-block","margin-right":"-23px"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"warning darken-2","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.openModal()}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"dark":"","color":"warning"}},[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Editar coluna personalizável")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editColumn()}]},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Editar coluna personalizável")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title')],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h4',[_vm._v("Nome da coluna")]),_vm._v(" "),_c('v-text-field',{ref:"inputText",attrs:{"placeholder":"Ex: anotação","rules":_vm.rules},model:{value:(_vm.columnName),callback:function ($$v) {_vm.columnName=$$v},expression:"columnName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-switch',{attrs:{"color":"success","label":"Acrescentar coluna nas buscas da tabela"},model:{value:(_vm.columnPesq),callback:function ($$v) {_vm.columnPesq=$$v},expression:"columnPesq"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.editColumn()}}},[_vm._v("Salvar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"yellow darken-4","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.openModal()}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"dark":"","color":"yellow darken-4"}},[_vm._v("vertical_split")])],1),_vm._v(" "),_c('span',[_vm._v("Ver colunas personalizáveis")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Colunas personalizáveis")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title')],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{attrs:{"id":"tst"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h4',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('ol',_vm._l((_vm.table.auxHeaders),function(item,i){return (item.value.indexOf('custom_') != -1)?_c('li',{key:i},[_c('div',{staticStyle:{"display":"inline-block","min-width":"50%"}},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('btnEditColumn',{attrs:{"table":_vm.table,"item":item},on:{"mergeColumn":function($event){return _vm.mergeColumn($event)}}}),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"red darken-4","icon":"","flat":"","text-color":"white","dark":""},on:{"click":function($event){return _vm.removeColumn(item,i)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"dark":"","color":"red darken-4"}},[_vm._v("delete_forever")])],1),_vm._v(" "),_c('span',[_vm._v("Remover esta coluna personalizáveil")])],1)],1):_vm._e()}),0)])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 641 */,
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","lazy":true,"width":"50%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{staticClass:"d-inline-block bg_white custom_pos_column",attrs:{"slot":"activator","text-color":"white"},slot:"activator"},[_c('svg',{staticClass:"customIcon i_header",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M3,3H11V5H3V3M13,3H21V5H13V3M3,7H11V9H3V7M13,7H21V9H13V7M3,11H11V13H3V11M13,11H21V13H13V11M3,15H11V17H3V15M13,15H21V17H13V15M3,19H11V21H3V19M13,19H21V21H13V19Z"}})]),_vm._v(" "),_c('small',[_vm._v(" Colunas")])]),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue",staticStyle:{"color":"white"},attrs:{"text-color":"white"}},[_vm._v("\n                  Organizar colunas da tabela\n                  "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeModal('cancelar')}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"tst"}},[_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","fill-height":""}},[_c('btnRmvColumn',{attrs:{"table":_vm.table,"empresa":_vm.empresa}}),_vm._v(" "),_c('btnNewColumn',{attrs:{"table":_vm.table,"empresa":_vm.empresa}}),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"indigo darken-4","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.resetHeaders()}},slot:"activator"},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M11,4C13.05,4 15.09,4.77 16.65,6.33C19.78,9.46 19.77,14.5 16.64,17.64C14.81,19.5 12.3,20.24 9.91,19.92L10.44,17.96C12.15,18.12 13.93,17.54 15.24,16.23C17.58,13.89 17.58,10.09 15.24,7.75C14.06,6.57 12.53,6 11,6V10.58L6.04,5.63L11,0.68V4M5.34,17.65C2.7,15 2.3,11 4.11,7.94L5.59,9.41C4.5,11.64 4.91,14.39 6.75,16.23C7.27,16.75 7.87,17.16 8.5,17.45L8,19.4C7,19 6.12,18.43 5.34,17.65Z"}})])]),_vm._v(" "),_c('span',[_vm._v("Voltar colunas para o padrão do motor fiscal")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"lista-colunas",attrs:{"id":"colItensAtivas"}},[_c('v-layout',{attrs:{"align-end":"","justify-end":"","row":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"indigo darken-4","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.addAllColumn(_vm.table.auxHeaders)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px"},attrs:{"dark":"","color":"indigo darken-4"}},[_vm._v("reply_all")])],1),_vm._v(" "),_c('span',[_vm._v("Ativar todas as colunas")])],1)],1),_vm._v(" "),_c('h3',{staticClass:"text-xs-center"},[_vm._v("Colunas Ocultas")]),_vm._v(" "),_c('ul',_vm._l((_vm.table.auxHeaders),function(header){return (_vm.headerShow(header,'oculta'))?_c('li',{key:header.text,on:{"click":function($event){return _vm.addColumn(header.value)}}},[_c('v-btn',{attrs:{"outline":"","block":"","color":header.value.indexOf('custom') == -1 ? 'red accent-4' : 'pink darken-4',"text-color":"white"}},[_vm._v(_vm._s(header.text)+"\n                                        \n                                      ")])],1):_vm._e()}),0)],1),_vm._v(" "),_c('div',{staticClass:"lista-colunas",attrs:{"id":"colItensOcultos"}},[_c('v-layout',{attrs:{"align-end":"","justify-start":"","row":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"red darken-4","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.removeAllColumn(_vm.table.auxHeaders)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px"},attrs:{"dark":"","color":"red darken-4"}},[_vm._v("reply_all")])],1),_vm._v(" "),_c('span',[_vm._v("Ocultar todas as colunas")])],1)],1),_vm._v(" "),_c('h3',{staticClass:"text-xs-center"},[_vm._v("Colunas Ativas")]),_vm._v(" "),_c('draggable',{attrs:{"id":"listaHeader","element":"ul","move":_vm.onMove,"options":_vm.dragOptions},on:{"start":function($event){_vm.isDragging=true},"end":_vm.onEnd},model:{value:(_vm.table.auxHeaders),callback:function ($$v) {_vm.$set(_vm.table, "auxHeaders", $$v)},expression:"table.auxHeaders"}},[_c('transition-group',{attrs:{"type":"transition","name":'flip-list'}},_vm._l((this.table.auxHeaders),function(header,index){return (_vm.headerShow(header,'ativa'))?_c('li',{directives:[{name:"show",rawName:"v-show",value:(header.show),expression:"header.show"}],key:header.text,staticClass:"parent v-btn v-btn--block v-btn--outline v-btn--depressed",class:header.value.indexOf('custom') == -1 ? ' indigo darken-4' : ' teal',on:{"click":function($event){return _vm.removeColumn(header.value, $event)}}},[_c('span',{staticClass:"desc_header_titulo"},[_vm._v(_vm._s(header.text))]),_vm._v(" "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(index))]),_vm._v(" "),_c('v-icon',{staticClass:"material-icons up",attrs:{"color":"red","dark":""},on:{"click":function($event){return _vm.orderUp(header.value)}}},[_vm._v("arrow_drop_up")]),_vm._v(" "),_c('v-icon',{staticClass:"material-icons down",attrs:{"color":"red","dark":""},on:{"click":function($event){return _vm.orderDown(header.value)}}},[_vm._v("arrow_drop_down")])],1):_vm._e()}),0)],1)],1)])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},on:{"click":function($event){return _vm.closeModal('cancelar')}}},[_vm._v("\n                      Cancelar\n                  ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){return _vm.closeModal('salvar')}}},[_vm._v("\n                      Salvar\n                  ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"dlink"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"d-inline-block bg_white custom_pos_excell",attrs:{"slot":"activator","text-color":"white"},nativeOn:{"click":function($event){return _vm.setPositionMenu($event)}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_header",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M13,3.5V9H18.5L13,3.5M17,11H13V13H14L12,14.67L10,13H11V11H7V13H8L11,15.5L8,18H7V20H11V18H10L12,16.33L14,18H13V20H17V18H16L13,15.5L16,13H17V11Z"}})]),_vm._v(" "),_c('small',[_vm._v("Exportar para excel")])]),_vm._v(" "),_c('span',[_vm._v("Exportar a tabela para o formato .xls")])],1),_vm._v(" "),_c('v-menu',{attrs:{"nudge-top":"20","position-x":_vm.menuX,"position-y":_vm.menuY,"close-on-content-click":true,"bottom":"","offset-y":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-list',{attrs:{"id":"options"}},[_c('div',{attrs:{"id":"title"}},[_vm._v("Opções de exportação")]),_vm._v(" "),_vm._l((_vm.getOpcoesMenu),function(item,index){return _c('v-list-tile',{key:index,staticClass:"item",staticStyle:{"cursor":"pointer"}},[_c('v-list-tile-title',{on:{"click":function($event){return _vm.setDownload(item.evento)}}},[_c('v-tooltip',{attrs:{"right":""}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[(item.icon == 'selected')?_c('svg',{staticStyle:{"width":"16px","height":"17px","margin-bottom":"-4px"},attrs:{"data-v-1ab5010e":"","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"data-v-1ab5010e":"","fill":"#808080","d":"M20,16V10H22V16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H16V4H8V16H20M10.91,7.08L14,10.17L20.59,3.58L22,5L14,13L9.5,8.5L10.91,7.08M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z"}})]):_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n              "+_vm._s(item.title)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.tooltip))])])],1)],1)})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btnSelectAll_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ff27c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btnSelectAll_vue__ = __webpack_require__(647);
function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34ff27c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btnSelectAll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ff27c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btnSelectAll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"d-inline bg_white",attrs:{"slot":"activator","text-color":"white"},nativeOn:{"click":function($event){return _vm.selecionarTodosItens()}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_header",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M20,16V10H22V16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H16V4H8V16H20M10.91,7.08L14,10.17L20.59,3.58L22,5L14,13L9.5,8.5L10.91,7.08M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z"}})]),_vm._v(" "),_c('small',[_vm._v("Selecionar todas: ")]),_vm._v(" "),_c('small',{staticClass:"selected_Total"},[_vm._v(_vm._s(this.table.selected.length)+"/"+_vm._s(this.table.qnt_total_notas))])]),_vm._v(" "),_c('span',[_vm._v("Notas selecionadas / Total de notas")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUpload_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b47250b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUpload_vue__ = __webpack_require__(652);
function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b47250b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inputFile"},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"file-upload"},on:{"click":function($event){return _vm.resetInfos()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.prevIcon))]),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")],1),_vm._v(" "),_c('small',{class:_vm.color},[_vm._v("\n    "+_vm._s(_vm.fileText)+"\n    "),_c('span',{staticClass:"teal_bold"},[_vm._v(_vm._s(_vm.path))])]),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"file-upload","value":"file","id":"file-upload","accept":this.component == 'certificado' ? '.pfx' : this.component == 'imagem' ? 'image/jpg' : this.component == 'xml' ? '.xml' : '',"multiple":this.component == 'xml' || this.component == 'pdf' ? true : false},on:{"change":function($event){return _vm.setFile($event)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"typeArquivo"},[_vm._v("\n    Formato aceito:\n    "),_c('strong',{staticClass:"teal--text text--darken-4"},[(_vm.component == 'certificado')?_c('span',[_vm._v(".pfx")]):(_vm.component == 'xml')?_c('span',[_vm._v(".xml")]):(_vm.component == 'pdf')?_c('span',[_vm._v(".pdf")]):(_vm.component == 'imagem')?_c('span',[_vm._v(".jpg .jpeg")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.component == 'imagem')?_c('small',{staticClass:"typeArquivo"},[_vm._v("\n    Tamanho máximo do arquivo:\n    "),_c('strong',{staticClass:"teal--text text--darken-4"},[_c('span',[_vm._v(_vm._s(_vm.tamMaximo/1000000)+" MB")])])]):_vm._e(),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((this.component.name == 'NFeRecebidas') || (this.component.name == 'CTE' && this.component.tipo === 'tomados') ||
                (this.component.name == 'NFSE' && this.component.tipo !== 'emitida'))?_c('article',{staticClass:"d-inline-block"},[_c('v-flex',{attrs:{"xs6":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"bg_white",staticStyle:{"min-width":"109px"},attrs:{"slot":"activator"},nativeOn:{"click":function($event){_vm.dialog = !_vm.dialog}},slot:"activator"},[_c('v-icon',{staticStyle:{"margin-right":"6px"},attrs:{"small":"","color":"teal"}},[_vm._v("cloud_upload")]),_vm._v(" "),(this.component.name === 'CTE')?_c('small',{staticStyle:{"color":"black"}},[_vm._v("Upload CT-e")]):_vm._e(),_vm._v(" "),(this.component.name === 'NFeRecebidas')?_c('small',{staticStyle:{"color":"black"}},[_vm._v("Upload NF-e")]):_vm._e(),_vm._v(" "),(this.component.name === 'NFSE')?_c('small',{staticStyle:{"color":"black"}},[_vm._v("Upload NFS-e")]):_vm._e()],1)],1),_vm._v(" "),(_vm.dialog && (this.component.name == 'NFeRecebidas') || (this.component.name == 'CTE') ||
                (this.component.name == 'NFSE' && this.component.tipo !== 'emitida'))?_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false,_vm.table.resetAlert()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }this.component.name == 'NFeRecebidas' || this.component.name === 'CTE' ? _vm.envXml() : _vm.enviarPDF()}]},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[(this.component.name === 'NFeRecebidas')?_c('strong',[_vm._v("Enviar Nota Fiscal Eletrônica (NF-e)")]):_vm._e(),_vm._v(" "),(this.component.name === 'CTE')?_c('strong',[_vm._v("Enviar Conhecimento de Transporte (CT-e)")]):_vm._e(),_vm._v(" "),(this.component.name === 'NFSE')?_c('strong',[_vm._v("Enviar Nota Fiscal Eletrônica de Serviço (NFS-e)")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(this.sendingXML)?_c('v-progress-linear',{staticStyle:{"margin":"0"},attrs:{"color":"teal","value":this.progressEnviando}}):_vm._e(),_vm._v(" "),(this.sendingXML)?_c('div',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"background":"-webkit-linear-gradient(bottom, teal, #8dffbf)","-webkit-background-clip":"text","font-weight":"800","-webkit-text-fill-color":"transparent","margin-top":"6px"}},[_vm._v(_vm._s(_vm.progressEnviando ? parseFloat(_vm.progressEnviando).toFixed(0) : _vm.progressEnviando)+" %")]),_vm._v(" "),_c('span',{staticClass:"animeDodgeLoading"},[_vm._v(".")])]):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(this.file != undefined && this.file.length > 0)?_c('transition',{attrs:{"name":"fade"}},[_c('article',[_c('h4',{staticStyle:{"display":"inline-block"}},[_vm._v("Arquivos prontos para envio:")]),_vm._v(" "),_c('h4',{staticStyle:{"display":"inline-block","position":"absolute","right":"65px","color":"grey"}},[_vm._v("Total: "+_vm._s(this.file.length))]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"}},[(_vm.errorSending)?_c('article',[_c('span',{staticClass:"red--text",staticStyle:{"font-size":"11px"}},[_vm._v("Arquivos sem sucesso no envio")]),_vm._v(" "),_c('v-icon',{staticClass:"custom_anime",staticStyle:{"font-size":"14px"},attrs:{"color":"black"}},[_vm._v("arrow_downward")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"20px!important"},style:(_vm.errorSending ? 'position: absolute; right: 0; margin-top: -20px;' : ''),attrs:{"flat":"","small":"","color":"cyan darken-3"},nativeOn:{"click":function($event){return _vm.resetFiles()}}},[_vm._v("Limpar lista")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('ol',{staticStyle:{"padding":"0px","max-height":"149px","overflow-y":"scroll"}},_vm._l((_vm.file),function(item,i){return _c('li',{key:i,staticClass:"d-inline-block xml_envio",staticStyle:{"white-space":"nowrap","width":"40%","margin-right":"52px"}},[_c('div',{staticClass:"xml_envio_div",class:_vm.degradeColor,staticStyle:{"display":"inline-block","min-width":"50%","width":"100%","overflow":"hidden","text-overflow":"ellipsis","margin-right":"-10px","border-radius":"6px","padding":"3px 0"},attrs:{"title":item.name}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"margin-top":"-13px","margin-left":"-2px"},attrs:{"slot":"activator","color":"red darken-4","icon":"","flat":"","text-color":"white","dark":""},on:{"click":function($event){return _vm.removeColumn(item,i)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"font-size":"20px"},attrs:{"dark":"","color":"red darken-4"}},[_vm._v("delete_forever")])],1),_vm._v(" "),_c('span',[_vm._v("Remover este arquivo")])],1)],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.fileEnviado.length > 0)?_c('article',[_c('span',{staticClass:"green--text",staticStyle:{"font-size":"11px"}},[_vm._v("Arquivos enviados com successo")]),_vm._v(" "),_c('v-icon',{staticClass:"custom_anime",staticStyle:{"font-size":"14px"},attrs:{"color":"black"}},[_vm._v("arrow_downward")]),_vm._v(" "),_c('h4',{staticStyle:{"display":"inline-block","position":"absolute","right":"65px","color":"grey"},attrs:{"data-v-06e50aa7":""}},[_vm._v("Total: "+_vm._s(this.fileEnviado.length))]),_vm._v(" "),_c('ol',{staticStyle:{"padding":"0px","max-height":"149px","overflow-y":"scroll","margin-top":"10px"}},_vm._l((_vm.fileEnviado),function(item,i){return _c('li',{key:i,staticClass:"d-inline-block xml_envio",staticStyle:{"white-space":"nowrap","width":"40%","margin-right":"52px"}},[_c('div',{staticClass:"xml_envio_div successDegrade",staticStyle:{"display":"inline-block","min-width":"50%","width":"100%","overflow":"hidden","text-overflow":"ellipsis","margin-right":"-10px","border-radius":"6px","padding":"3px 0"},attrs:{"title":item.name}},[_vm._v(_vm._s(item.name))])])}),0)],1):_vm._e()],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('inputFile',{attrs:{"text":'Selecionar arquivo',"prevIcon":'description',"component":this.component.name == 'NFeRecebidas' || this.component.name === 'CTE' ? 'xml' : 'pdf'},on:{"emitResetInput":function($event){return _vm.emitResetInput(_vm.$emit)},"getFile":function($event){return _vm.getFile($event)}}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(this.component.name === 'NFeRecebidas' || this.component.name === 'CTE')?_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false, _vm.table.resetAlert()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.envXml()}}},[_vm._v("Enviar")])],1):_vm._e(),_vm._v(" "),(this.component.name == 'NFSE')?_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false, _vm.table.resetAlert()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.enviarPDF()}}},[_vm._v("Enviar")])],1):_vm._e()],1)],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownload_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_903538ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownload_vue__ = __webpack_require__(655);
function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_903538ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.component.enable.download)?_c('div',{staticClass:"d-inline"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"bg_white",attrs:{"slot":"activator"},nativeOn:{"click":function($event){_vm.component.name != 'NFSE'? _vm.setPositionMenu($event) : _vm.downloadMulti('xml')}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_header",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M12,19L8,15H10.5V12H13.5V15H16L12,19Z"}})]),_vm._v(" "),_c('small',[_vm._v("Download")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.component.name == 'NFSE' ? 'Baixar XML das notas selecionada':'Baixar PDF e/ou XML das notas selecionada'))])],1),_vm._v(" "),_c('v-menu',{attrs:{"nudge-top":"20","position-x":_vm.menuX,"position-y":_vm.menuY,"close-on-content-click":true,"bottom":"","offset-y":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-list',{attrs:{"id":"options"}},[_c('div',{attrs:{"id":"title"}},[_vm._v("Opções de download")]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('v-list-tile',{key:index,staticClass:"item"},[_c('v-list-tile-title',{on:{"click":function($event){return _vm.downloadMulti(item.evento)}}},[_c('v-tooltip',{attrs:{"right":""}},[_c('div',{staticClass:"text-xs-center",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n              "+_vm._s(item.title)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.tooltip))])])],1)],1)})],2)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnImportadorXml_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b17b4c1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnImportadorXml_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(657)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnImportadorXml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b17b4c1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnImportadorXml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.component.enable.download)?_c('div',{staticClass:"d-inline"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"bg_white",attrs:{"slot":"activator"},nativeOn:{"click":function($event){return _vm.alterarStatusErp('xml')}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_header",attrs:{"viewBox":"0 0 18 18"}},[_c('path',{attrs:{"d":"M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"}})]),_vm._v(" "),_c('small',[_vm._v("Validar XML")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s('Inserir na fila de processamento, para enviar ao ERP'))])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUploadPlanilha_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79302fce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUploadPlanilha_vue__ = __webpack_require__(698);
function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUploadPlanilha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79302fce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUploadPlanilha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 665 */,
/* 666 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"bg_white",staticStyle:{"min-width":"109px"},attrs:{"slot":"activator"},nativeOn:{"click":function($event){_vm.dialog = !_vm.dialog}},slot:"activator"},[_c('v-icon',{staticStyle:{"margin-right":"6px"},attrs:{"small":"","color":"teal"}},[_vm._v("cloud_upload")]),_vm._v(" "),(_vm.component.tipo === 'emitida')?_c('small',{staticStyle:{"color":"black"}},[_vm._v("Upload Planilha")]):_c('small',{staticStyle:{"color":"black"}},[_vm._v("Upload DES")])],1),_vm._v(" "),(_vm.component.tipo === 'emitida')?_c('span',[_vm._v("Upload Planilha")]):_c('span',[_vm._v("Upload DES")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[(_vm.component.tipo === 'emitida')?_c('strong',[_vm._v("Upload de planilha")]):_c('strong',[_vm._v("Upload DES")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.resetInfos(true)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('span',{staticClass:"inputFile"},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"file-upload"},on:{"click":function($event){return _vm.resetInfos(false)}}},[_c('v-icon',[_vm._v("mdi-file")]),_vm._v("\n              "+_vm._s(_vm.path ? _vm.path : 'Selecione um arquivo')+"\n            ")],1),_vm._v(" "),_c('small',[_vm._v("\n              "+_vm._s(_vm.fileText)+"\n              "),_c('span',{staticClass:"teal_bold"},[_vm._v(_vm._s(_vm.path))])]),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"file-upload","value":"file","id":"file-upload","accept":_vm.component.tipo === 'emitida' ? '.xlsx' : '.txt'},on:{"change":function($event){return _vm.setFile($event)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}}),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.resetInfos(true)}}},[_vm._v("Fechar")]),_vm._v(" "),(_vm.component.tipo === 'emitida')?_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.handleUpload($event)}}},[_vm._v("Upload")]):_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.handleUploadDes($event)}}},[_vm._v("Upload")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"90%","max-width":"90%","min-width":"90%"},model:{value:(_vm.dialogAviso),callback:function ($$v) {_vm.dialogAviso=$$v},expression:"dialogAviso"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Aviso")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('article',[_c('div',{staticStyle:{"margin-left":"50px"}},[_c('btnExpExcell',{attrs:{"component":this.component,"table":_vm.tableErros,"nfseErros":!_vm.isDes,"nfseDes":_vm.isDes}})],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[(_vm.isDes)?_c('h3',[_vm._v("Notas não localizadas.")]):_c('h3',[_vm._v("Foram encontrados erros nos campos da planilha.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"id":_vm.tableId,"rows-per-page-text":"Linhas por página:","rows-per-page-items":_vm.pagination.rowsPerPageItems,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([(_vm.isDes)?{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.cnpj != undefined ? (props.item.cnpj.length > 11 ? props.item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : props.item.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.razao))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.numeroNfse))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.vlEnviado))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.dtEmissao))])]}}:{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.cnpj != undefined ? (props.item.cnpj.length > 11 ? props.item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : props.item.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.razao))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.erro))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.vlEnviado))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.discriminacao))])]}},{key:"pageText",fn:function(props){return [_c('strong',[_vm._v("\n                    Exibindo "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" do total de "+_vm._s(_vm.quantity)+"\n                    "),(_vm.isDes)?_c('span',[_vm._v(_vm._s(_vm.quantity === 1 ? 'Nota' : 'Notas'))]):_c('span',[_vm._v(_vm._s(_vm.quantity === 1 ? 'Erro' : 'Erros'))])]),_vm._v(".\n                ")]}}],null,true)})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"50px"},attrs:{"id":"checkPlanilha"}},[(_vm.duplicidade)?_c('v-checkbox',{staticStyle:{"margin-top":"0!important"},attrs:{"label":"Deseja incluir as duplicidades?","color":"red"},model:{value:(_vm.checkboxDuplicidades),callback:function ($$v) {_vm.checkboxDuplicidades=$$v},expression:"checkboxDuplicidades"}}):_vm._e()],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px"},attrs:{"grid-list-md":"","text-xs-center":""}},[(_vm.duplicidade)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},on:{"click":function($event){_vm.dialogAviso=false}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"disabled":!_vm.checkboxDuplicidades,"block":"","depressed":"","small":"","color":"teal"},on:{"click":_vm.handleErros}},[_vm._v("Incluir")])],1)],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"blue"},on:{"click":function($event){_vm.dialogAviso=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUploadPlanilhaEscrituracao_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bcad20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUploadPlanilhaEscrituracao_vue__ = __webpack_require__(701);
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUploadPlanilhaEscrituracao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bcad20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUploadPlanilhaEscrituracao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"bg_white",staticStyle:{"min-width":"109px"},attrs:{"slot":"activator"},nativeOn:{"click":function($event){_vm.dialog = !_vm.dialog}},slot:"activator"},[_c('v-icon',{staticStyle:{"margin-right":"6px"},attrs:{"small":"","color":"teal"}},[_vm._v("cloud_upload")]),_vm._v(" "),(_vm.component.tipo === 'recebida')?_c('small',{staticStyle:{"color":"black"}},[_vm._v("Upload Planilha")]):_vm._e()],1),_vm._v(" "),(_vm.component.tipo === 'recebida')?_c('span',[_vm._v("Upload Planilha")]):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[(_vm.component.tipo === 'recebida')?_c('strong',[_vm._v("Upload de planilha")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.resetInfos(true)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('span',{staticClass:"inputFile"},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"file-upload"},on:{"click":function($event){return _vm.resetInfos(false)}}},[_c('v-icon',[_vm._v("mdi-file")]),_vm._v("\n              "+_vm._s(_vm.path ? _vm.path : 'Selecione um arquivo')+"\n            ")],1),_vm._v(" "),_c('small',[_vm._v("\n              "+_vm._s(_vm.fileText)+"\n              "),_c('span',{staticClass:"teal_bold"},[_vm._v(_vm._s(_vm.path))])]),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"file-upload","value":"file","id":"file-upload","accept":'.xlsx'},on:{"change":function($event){return _vm.setFile($event)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}}),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.resetInfos(true)}}},[_vm._v("Fechar")]),_vm._v(" "),(_vm.component.tipo === 'recebida')?_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.handleUpload($event)}}},[_vm._v("Upload")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"90%","max-width":"90%","min-width":"90%"},model:{value:(_vm.dialogAviso),callback:function ($$v) {_vm.dialogAviso=$$v},expression:"dialogAviso"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Aviso")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('article',[_c('div',{staticStyle:{"margin-left":"50px"}},[_c('btnExpExcell',{attrs:{"component":this.component,"table":_vm.tableErros,"nfseErros":true}})],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('h3',[_vm._v("Foram encontrados erros nos campos da planilha.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"id":_vm.tableId,"rows-per-page-text":"Linhas por página:","rows-per-page-items":_vm.pagination.rowsPerPageItems,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.cnpjCpfPrestador != undefined ? (props.item.cnpjCpfPrestador.length > 11 ? props.item.cnpjCpfPrestador.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : props.item.cnpjCpfPrestador.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.razaoPrestador))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.erro))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.numero))])]}},{key:"pageText",fn:function(props){return [_c('strong',[_vm._v("\n                    Exibindo "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" do total de "+_vm._s(_vm.quantity)+"\n                   \n                    "),_c('span',[_vm._v(_vm._s(_vm.quantity === 1 ? 'Erro' : 'Erros'))])]),_vm._v(".\n                ")]}}])})],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px"},attrs:{"grid-list-md":"","text-xs-center":""}},[(_vm.duplicidade)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},on:{"click":function($event){_vm.dialogAviso=false}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"disabled":!_vm.checkboxDuplicidades,"block":"","depressed":"","small":"","color":"teal"},on:{"click":_vm.handleErros}},[_vm._v("Incluir")])],1)],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"blue"},on:{"click":function($event){_vm.dialogAviso=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnEnviaFtp_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d99aa5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnEnviaFtp_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnEnviaFtp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d99aa5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnEnviaFtp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.component.enable.download)?_c('div',{staticClass:"d-inline"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"bg_white",attrs:{"slot":"activator"},nativeOn:{"click":function($event){return _vm.setPositionMenu($event)}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_header",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"}})]),_vm._v(" "),_c('small',[_vm._v("Enviar FTP")])]),_vm._v(" "),_c('span',[_vm._v("Enviar PDF e/ou XML das notas selecionada")])],1),_vm._v(" "),_c('v-menu',{attrs:{"nudge-top":"20","position-x":_vm.menuX,"position-y":_vm.menuY,"close-on-content-click":true,"bottom":"","offset-y":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-list',{attrs:{"id":"options"}},[_c('div',{attrs:{"id":"title"}},[_vm._v("Opções de envio")]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('v-list-tile',{key:index,staticClass:"item"},[_c('v-list-tile-title',{on:{"click":function($event){return _vm.downloadMulti(item.evento)}}},[_c('v-tooltip',{attrs:{"right":""}},[_c('div',{staticClass:"text-xs-center",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n              "+_vm._s(item.title)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.tooltip))])])],1)],1)})],2)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnEnviaFluig_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b0dadb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnEnviaFluig_vue__ = __webpack_require__(707);
function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnEnviaFluig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b0dadb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnEnviaFluig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.component.enable.download)?_c('div',{staticClass:"d-inline"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"bg_white",attrs:{"slot":"activator"},nativeOn:{"click":function($event){return _vm.setPositionMenu($event)}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_header",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"}})]),_vm._v(" "),_c('small',[_vm._v("Integra Fluig")])]),_vm._v(" "),_c('span',[_vm._v("Iniciar Solicitação no Fluig")])],1),_vm._v(" "),_c('v-menu',{attrs:{"nudge-top":"20","position-x":_vm.menuX,"position-y":_vm.menuY,"close-on-content-click":true,"bottom":"","offset-y":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-list',{attrs:{"id":"options"}},[_c('div',{attrs:{"id":"title"}},[_vm._v("Opções de integração")]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('v-list-tile',{key:index,staticClass:"item"},[_c('v-list-tile-title',{on:{"click":function($event){return _vm.downloadMulti(item.evento)}}},[_c('v-tooltip',{attrs:{"right":""}},[_c('div',{staticClass:"text-xs-center",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n              "+_vm._s(item.title)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.tooltip))])])],1)],1)})],2)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"actionHeader",attrs:{"fluid":""}},[(!(this.component.name != 'NFSE' &&this.component.name != 'CTE' && this.component.name != 'NFeRecebidas'))?_c('span',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"space_header",attrs:{"align-center":"","justify-space-between":"","row":"","fill-height":""}},[_c('div',{staticClass:"headerDiv",attrs:{"id":"c-margin-space-left"}},[_c('btnUpload',{attrs:{"component":_vm.component,"empresa":_vm.empresa,"table":_vm.table}}),_vm._v(" "),(_vm.component.enable.consultaSefaz  && _vm.component.name !== 'NFeRecebidas' && _vm.empresa.servicos && _vm.empresa.servicos.robotizacao && !_vm.empresa.servicos.robotizacao.find(function (item) { return item.nomeServico === 'NFSE_TOMADOS'; }))?_c('btnConsultaAvulsa',{attrs:{"conta":_vm.conta,"logQtd":this.logQtd,"logConsulta":this.logConsulta,"range":this.range,"empresa":_vm.empresa,"table":_vm.table,"component":_vm.component},on:{"getLogConsulta":function($event){return _vm.getLogConsulta($event)}}}):_vm._e(),_vm._v(" "),(_vm.component.name === 'NFSE' && _vm.component.tipo === 'emitida'  && _vm.empresa.servicos && _vm.empresa.servicos.robotizacao && _vm.empresa.servicos.robotizacao.find(function (item) { return item.nomeServico === 'NFSE_TOMADOS'; }))?_c('btnNovaNota',{attrs:{"conta":_vm.conta,"empresa":_vm.empresa,"table":_vm.table,"component":_vm.component,"edit":false}}):_vm._e(),_vm._v(" "),(_vm.component.name === 'NFSE' && _vm.empresa.servicos && _vm.empresa.servicos.robotizacao && _vm.empresa.servicos.robotizacao.find(function (item) { return item.nomeServico === 'NFSE_TOMADOS'; }))?_c('btnUploadPlanilha',{attrs:{"conta":_vm.conta,"empresa":_vm.empresa,"table":_vm.table,"component":_vm.component,"alert":_vm.alert}}):_vm._e(),_vm._v(" "),(_vm.component.name === 'NFeRecebidas' && _vm.empresa.servicos && _vm.empresa.servicos.ftp && _vm.empresa.servicos.ftp.botao_envio == true)?_c('BtnEnviaFtp',{attrs:{"component":_vm.component,"arraySelect":this.table.selected,"empresa":_vm.empresa,"table":_vm.table,"conta":_vm.conta}}):_vm._e(),_vm._v(" "),(_vm.component.enable.colunas)?_c('btnColumns',{attrs:{"conta":this.conta,"empresa":_vm.empresa,"component":this.component,"headers":_vm.headers,"table":_vm.table},on:{"getHeader":function($event){return _vm.getHeader($event)}}}):_vm._e(),_vm._v(" "),(_vm.component.enable.expExcel)?_c('btnExpExcell',{attrs:{"component":this.component,"table":this.table,"nfseErros":false,"nfseDes":false}}):_vm._e(),_vm._v(" "),(_vm.component.name === 'NFeRecebidas' && _vm.empresa.servicos && _vm.empresa.servicos.robotizacao && _vm.empresa.servicos.robotizacao.find(function (item) { return item.nomeServico === 'IMPORTADOR_XML_MANUAL'; }))?_c('btnImportadorXml',{attrs:{"component":_vm.component,"arraySelect":this.table.selected,"empresa":_vm.empresa,"table":_vm.table,"conta":_vm.conta},on:{"getSelected":function($event){return _vm.getSelected($event)}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"21px"}},[_c('btnDias',{attrs:{"buttons":this.table.rangeButtons,"component":_vm.component,"table":this.table,"empresa":this.empresa,"conta":this.conta,"openFiltro":this.openFiltro},on:{"getDataBusca":function($event){return _vm.getDataBusca($event)},"getOpenFiltro":function($event){return _vm.getOpenFiltro($event)}}})],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"space_header",attrs:{"align-center":"","justify-space-between":"","row":"","fill-height":""}},[_c('div',{staticClass:"headerDiv",attrs:{"id":"c-margin-space-left"}},[(_vm.component.name === 'NFSE' && _vm.empresa.servicos && _vm.empresa.servicos.escrituracaoNfse && _vm.empresa.servicos.escrituracaoNfse.uploadBotaoNfse === true)?_c('btnUploadPlanilhaEscrituracao',{attrs:{"conta":_vm.conta,"empresa":_vm.empresa,"table":_vm.table,"component":_vm.component,"alert":_vm.alert}}):_vm._e(),_vm._v(" "),(_vm.component.enable.selectAll)?_c('btnSelectAll',{attrs:{"selected":_vm.selected,"table":_vm.table},on:{"getSelected":function($event){return _vm.getSelected($event)}}}):_vm._e(),_vm._v(" "),((_vm.component.name === 'CTE' || _vm.component.name === 'NFeRecebidas' || _vm.component.name === 'NFSE') && _vm.empresa.servicos && _vm.empresa.servicos.fluig && _vm.empresa.servicos.fluig.botao_envio == true)?_c('BtnEnviaFluig',{attrs:{"component":_vm.component,"arraySelect":this.table.selected,"empresa":_vm.empresa,"table":_vm.table,"conta":_vm.conta}}):_vm._e(),_vm._v(" "),_c('btnDownload',{attrs:{"component":_vm.component,"arraySelect":this.table.selected,"empresa":_vm.empresa,"table":_vm.table,"conta":_vm.conta}}),_vm._v(" "),(this.component.enable.selectAll && this.component.enable.envEmail)?_c('btnEmail',{staticStyle:{"display":"inline-block"},attrs:{"id_nota":_vm.getIdSelecteds,"conta":this.conta,"table":this.table,"component":this.component,"zip":true,"empresa":this.empresa}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-flex',{staticClass:"searchBtn",attrs:{"flex":"","xs12":"","sm3":"","md3":"","lg4":"","text-xs-center":"","d-flex":"","id":"search"}},[(_vm.component.enable.search)?_c('v-select',{staticClass:"filtroForSearch",attrs:{"persistent-hint":"","items":_vm.filterItensSearch(),"return-object":"","item-disabled":"search","no-data-text":"Sem valores","menu-props":{nudgeBottom:20},"background-color":"teal","color":"teal","solo":"","change":_vm.getSearchTag},model:{value:(_vm.filtroForSearch),callback:function ($$v) {_vm.filtroForSearch=$$v},expression:"filtroForSearch"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{staticClass:"fieldSearch",attrs:{"append-icon":"search","label":("Pesquisar em " + (_vm.filtroForSearch.text)),"solo":"","hide-details":""},on:{"input":function($event){return _vm.emitFiltro($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)])],1)],1):_c('span',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"space_header",attrs:{"align-center":"","justify-space-between":"","row":"","fill-height":""}},[_c('div',{attrs:{"id":"c-margin-space-left"}},[(_vm.component.enable.colunas)?_c('btnColumns',{attrs:{"conta":this.conta,"empresa":_vm.empresa,"component":this.component,"headers":_vm.headers,"table":_vm.table},on:{"getHeader":function($event){return _vm.getHeader($event)}}}):_vm._e(),_vm._v(" "),(_vm.component.enable.expExcel)?_c('btnExpExcell',{attrs:{"component":this.component,"table":this.table,"nfseErros":false,"nfseDes":false}}):_vm._e(),_vm._v(" "),(_vm.component.enable.selectAll)?_c('btnSelectAll',{attrs:{"selected":_vm.selected,"table":_vm.table},on:{"getSelected":function($event){return _vm.getSelected($event)}}}):_vm._e(),_vm._v(" "),_c('btnDownload',{attrs:{"component":_vm.component,"arraySelect":this.table.selected,"empresa":_vm.empresa,"table":_vm.table,"conta":_vm.conta}}),_vm._v(" "),(this.component.enable.selectAll && this.component.enable.envEmail)?_c('btnEmail',{staticStyle:{"display":"inline-block"},attrs:{"id_nota":_vm.getIdSelecteds,"conta":this.conta,"table":this.table,"component":this.component,"zip":true,"empresa":this.empresa}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-flex',{staticClass:"searchNBtn",attrs:{"flex":"","xs12":"","sm3":"","md3":"","lg4":"","text-xs-center":"","d-flex":"","id":"search"}},[(_vm.component.enable.search)?_c('v-select',{staticClass:"filtroForSearch",attrs:{"persistent-hint":"","items":_vm.filterItensSearch(),"return-object":"","item-disabled":"search","no-data-text":"Sem valores","menu-props":{nudgeBottom:20},"background-color":"teal","color":"teal","solo":"","change":_vm.getSearchTag},model:{value:(_vm.filtroForSearch),callback:function ($$v) {_vm.filtroForSearch=$$v},expression:"filtroForSearch"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{staticClass:"fieldSearch",attrs:{"append-icon":"search","label":("Pesquisar em " + (_vm.filtroForSearch.text)),"solo":"","hide-details":""},on:{"input":function($event){return _vm.emitFiltro($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnFiltrar_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9067b4bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnFiltrar_vue__ = __webpack_require__(711);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9067b4bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnFiltrar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9067b4bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnFiltrar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PanelFiltro_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab81f06e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PanelFiltro_vue__ = __webpack_require__(714);
function injectStyle (ssrContext) {
  __webpack_require__(713)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab81f06e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PanelFiltro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab81f06e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PanelFiltro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.mostrar),expression:"mostrar"}],staticClass:"panelFiltro"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.table.filtros.items),function(item,i){return (item.type == 'T')?_c('v-flex',{key:i,staticClass:"inptFiltroRS",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-text-field',{attrs:{"prepend-icon":"R$","clearable":""},on:{"input":function($event){return _vm.mask(item)}},model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}},[_c('template',{slot:"label"},[_c('small',[_vm._v(_vm._s(item.text)+":")])])],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.table.filtros.items),function(item,i){return (item.type == 'S' && _vm.component.name != 'CTE' && _vm.component.name != 'NFSE' || (_vm.component.name == 'CTE' || _vm.component.name == 'NFSE') && item.type == 'S' 
      && (item.item_id != 'manifestacao' && item.item_id != 'protocolada' && item.item_id != 'cce' && item.item_id != 'tipoVencimento') )?_c('v-flex',{key:i,attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":item.options,"label":"Solo field","clearable":"","multiple":item.multiple,"persistent-hint":"","prepend-icon":item.icon,"change":_vm.getSelect(item.item_id == 'tipoVencimento' ? item : null)},model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}},[_c('template',{slot:"label"},[_c('small',[_vm._v(_vm._s(item.text)+":")])])],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.table.filtros.items),function(item,i){return (item.type == 'D' && _vm.component.name != 'CTE' && _vm.component.name != 'NFSE' || item.type == 'D' && item.item_id != 'vencimentoIni' && item.item_id != 'vencimentoFim' && item.item_id != 'tipoVencimento')?_c('v-flex',{key:i,attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{ref:item.index,refInFor:true,class:[item.item_id == 'vencimentoFim' || item.item_id == 'vencimentoIni'  ? 'fDtVencimento' : ''],attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(item.index),callback:function ($$v) {_vm.$set(item, "index", $$v)},expression:"item.index"}},[_c('v-text-field',{attrs:{"slot":"activator","close-on-content-click":true,"persistent-hint":"","prepend-icon":"event","clearable":"","mask":_vm.maskData},on:{"click:prepend-inner":function($event){return _vm.openMenu($event)},"blur":function($event){return _vm.validateDate($event,item)}},slot:"activator",model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}},[_c('template',{slot:"label"},[_c('small',[_vm._v(_vm._s(item.text))])])],2),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","no-title":"","scrollable":""},on:{"input":function($event){item.valor = _vm.formatDate($event), item.index = false}},model:{value:(item.data),callback:function ($$v) {_vm.$set(item, "data", $$v)},expression:"item.data"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.table.filtros.items),function(item,i){return (_vm.component.name === 'NFSE' && _vm.component.tipo !== 'emitida' && _vm.empresa.servicos && _vm.empresa.servicos.robotizacao && _vm.empresa.servicos.robotizacao.find(function (item) { return item.nomeServico === 'NFSE_TOMADOS'; }) && item.type === 'L')?_c('v-flex',{key:i,attrs:{"xs12":"","sm6":"","md4":"","empresa":_vm.empresa,"component":_vm.component}},[_c('v-select',{attrs:{"label":item.label,"clearable":"","multiple":item.multiple,"persistent-hint":"","items":item.options,"prepend-icon":item.icon},model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}},[_c('template',{slot:"label"},[_c('small',[_vm._v(_vm._s(item.text)+":")])])],2)],1):_vm._e()})],2),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-btn',{attrs:{"outline":"","flat":"","color":"teal"},on:{"click":function($event){return _vm.fecharPanelFiltro()}}},[_c('small',{staticStyle:{"color":"#009688"}},[_vm._v("Fechar")])]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","flat":"","color":"teal"},on:{"click":function($event){return _vm.returnFiltro(false)}}},[_c('small',{staticStyle:{"color":"#009688"}},[_vm._v("Limpar Filtro")])]),_vm._v(" "),_c('v-btn',{attrs:{"color":"teal"},on:{"click":function($event){return _vm.returnFiltro(true)}}},[_c('small',{staticStyle:{"color":"white"}},[_vm._v("Filtrar")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_Vinculo_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3966cc13_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_Vinculo_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_Vinculo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3966cc13_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_Vinculo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCTeVinculadas_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff3672d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCTeVinculadas_vue__ = __webpack_require__(719);
function injectStyle (ssrContext) {
  __webpack_require__(718)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCTeVinculadas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff3672d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCTeVinculadas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-chip',{staticClass:"vinculoChip",attrs:{"slot":"activator","small":"","color":"primary","text-color":"white"},on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}},slot:"activator"},[_vm._v("\n                CT-e\n      ")]),_vm._v(" "),_c('span',[_vm._v("Visualizar Controle de transporte vinculado a esta nota")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue text-xs-center",staticStyle:{"color":"white"},attrs:{"text-color":"white","primary-title":""}},[_vm._v("\n                        CT-e Vinculadas\n                        "),_c('v-spacer'),_vm._v(" "),_c('div',{attrs:{"id":"listaNfe"}},[_c('span',[_vm._v("CT-e Vinculadas")]),_vm._v(" "),(_vm.nota.item.cte.length > 0)?_c('ol',_vm._l((_vm.nota.item.cte),function(item){return _c('li',{key:item._id,on:{"click":function($event){return _vm.getNFeVinculada(item._id)}}},[_c('h6',[_vm._v("\n                                "+_vm._s(item.chave)+"\n                              ")])])}),0):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"bodyNFeVinculada"}},[(_vm.nota.item.cte && _vm.nota.item.cte.length> 0)?_c('h2',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.text_info))]):_c('h2',{staticClass:"text-xs-center red--text"},[_vm._v("Nenhuma CT-e vinculada")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                            Fechar\n                        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCCeVinculadas_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d36f632_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCCeVinculadas_vue__ = __webpack_require__(722);
function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCCeVinculadas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d36f632_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCCeVinculadas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-chip',{staticClass:"vinculoChip",attrs:{"slot":"activator","small":"","color":"blue","text-color":"white"},on:{"click":function($event){_vm.dialog = !_vm.dialog}},slot:"activator"},[_vm._v("\n                      CC-e\n            ")]),_vm._v(" "),_c('span',[_vm._v("Visualizar Carta de Correção vinculada a esta nota")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue text-xs-center",staticStyle:{"color":"white"},attrs:{"text-color":"white","primary-title":""}},[_vm._v("\n                            Cc-e Vinculadas\n                            "),_c('v-spacer'),_vm._v(" "),(_vm.nota.item.xmlCce.length > 0)?_c('div',{attrs:{"id":"listaNfe"}},[_c('span',[_vm._v("Cc-e Vinculadas")]),_vm._v(" "),_c('ol',_vm._l((_vm.nota.item.xmlCce),function(chave,i){return _c('li',{key:i,on:{"click":function($event){return _vm.getCce(_vm.nota.item._id,i)}}},[_c('h6',[_vm._v("\n                                    Cce\n                                  ")])])}),0)]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"bodyNFeVinculada"}},[(_vm.nota.item.xmlCce.length > 0)?_c('h2',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.text_info))]):_vm._e()]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                                Fechar\n                            ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNFeVinculadas_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4057f646_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNFeVinculadas_vue__ = __webpack_require__(725);
function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnNFeVinculadas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4057f646_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnNFeVinculadas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tst"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-chip',{staticClass:"vinculoChip",attrs:{"slot":"activator","small":"","color":"primary","text-color":"white"},on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}},slot:"activator"},[_vm._v("\n                NF-e\n      ")]),_vm._v(" "),_c('span',[_vm._v("Visualizar Nota Fiscal Eletrônica vinculada a esta nota")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue text-xs-center",staticStyle:{"color":"white"},attrs:{"text-color":"white","primary-title":""}},[_vm._v("\n                        Nf-e Vinculadas\n                        "),_c('v-spacer'),_vm._v(" "),_c('div',{attrs:{"id":"listaNfe"}},[_c('span',[_vm._v("NF-e Vinculadas")]),_vm._v(" "),(_vm.nota.item.nfe.length > 0)?_c('ol',_vm._l((_vm.nota.item.nfe),function(chave){return _c('li',{key:chave,on:{"click":function($event){return _vm.getNFeVinculada(chave)}}},[_c('h6',[_vm._v("\n                                "+_vm._s(chave)+"\n                              ")])])}),0):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"bodyNFeVinculada"}},[(_vm.nota.item.nfe.length > 0)?_c('h2',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.text_info))]):_c('h2',{staticClass:"text-xs-center red--text"},[_vm._v("Nenhuma nota vinculada")]),_vm._v(" "),(this.danfeB64 != '' && this.text_info != '')?_c('object',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"type":"text/html","data":"https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&tipoConteudo=XbSeqxE8pl8="}}):_vm._e()]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                            Fechar\n                        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(this.component.name != 'CTE')?_c('div',{staticStyle:{"width":"inherit"}},[(_vm.nota.item.cte && _vm.nota.item.cte.length > 0)?_c('btnCTeVinculadas',{staticStyle:{"width":"inherit"},attrs:{"nota":this.nota}}):_vm._e(),_vm._v(" "),(_vm.nota.item.xmlCce && _vm.nota.item.xmlCce.length > 0)?_c('btnCCeVinculadas',{staticStyle:{"width":"inherit"},attrs:{"nota":this.nota}}):_vm._e()],1):_c('div',{staticStyle:{"width":"inherit"}},[_c('btnNFeVinculadas',{attrs:{"nota":this.nota}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColunaManifestoBtn_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18bc53c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColunaManifestoBtn_vue__ = __webpack_require__(730);
function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColunaManifestoBtn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18bc53c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColunaManifestoBtn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDocumentoManifesto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var producao = window.location.href.indexOf("app.motorfiscal") != -1 ? true : false;
var url = producao ? "https://apiv2.motorfiscal.com.br" : "https://apiv2homolog.motorfiscal.com.br";

var getDocumentoManifesto = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(empresaId, json, token) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url + "/manifestacao/pdf/" + empresaId, json, {
              headers: {
                Authorization: "" + token
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function getDocumentoManifesto(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item != undefined)?_c('div',{attrs:{"id":"colunaManifestoBtnDiv"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-chip',{staticClass:"colunaManifestoBtnChip",attrs:{"slot":"activator","small":"","color":_vm.item.toLowerCase() == 'ciente'
            ? 'primary'
            : _vm.item.toLowerCase() == 'confirmada'
            ? '#1EA2F5'
            : 'red',"text-color":"white"},on:{"click":function($event){$event.stopPropagation();return _vm.getNotaManifestada()}},slot:"activator"},[_vm._v(_vm._s(_vm.item))]),_vm._v(" "),_c('span',[_vm._v("Visualizar Manifestação")])],1)],1):_c('span'),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue text-xs-center",staticStyle:{"color":"white"},attrs:{"text-color":"white","primary-title":""}},[_vm._v("\n        Manifestação\n\n        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"bodyColunaManifesto"}},[(!_vm.showError)?_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"src":'data:application/pdf;base64,'+encodeURIComponent(this.danfeB64),"frameborder":"0"}}):_vm._e(),_vm._v(" "),(!_vm.showError)?_c('h2',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.text_info))]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_vencimento_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77033160_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_vencimento_vue__ = __webpack_require__(733);
function injectStyle (ssrContext) {
  __webpack_require__(732)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_vencimento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77033160_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_vencimento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.item.length == 0)?_c('span',{staticClass:"duplicata_sem_dt_venc"},[_vm._v("Não Informada")]):_vm._e(),_vm._v(" "),(_vm.item.length === 1)?_c('span',{staticClass:"duplicata_dt_venc"},[_vm._v(_vm._s(_vm.item[0].dVenc.substring(0, _vm.item[0].dVenc.indexOf("T")).split('-').reverse().join('/')))]):_vm._e(),_vm._v(" "),(_vm.item.length > 1)?_c('span',{staticClass:"duplicata_parcelada"},[_c('v-tooltip',{attrs:{"top":"","close-delay":500,"allow-overflow":""}},[_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaParcela(_vm.item)}},slot:"activator"},[_vm._v("\n                    Parcelado\n                ")]),_vm._v(" "),_c('span',[_vm._v("Visualizar tabela de parcelas")])],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Parcelas")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('table',{staticClass:"table_vencimento",attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"3"}},[_vm._v("Condição de Pagamento")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"1"}},[_vm._v("Parcela")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Vencimento")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Valor")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.item),function(duplicata,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(duplicata.nDup))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(duplicata.dVenc.substring(0, duplicata.dVenc.indexOf("T")).split('-').reverse().join('/')))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right valorReais"},[_vm._v(_vm._s(duplicata.vDup.toLocaleString("pt-BR", {minimumFractionDigits: 2,maximumFractionDigits: 2})))])])}),0)])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_produtos_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42910dd1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_produtos_vue__ = __webpack_require__(736);
function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_produtos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42910dd1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_produtos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.item.length == 0)?_c('span',{staticClass:"duplicata_sem_dt_venc"},[_vm._v("Não Informada")]):_vm._e(),_vm._v(" "),(_vm.item.length)?_c('span',{staticClass:"duplicata_parcelada"},[_c('v-tooltip',{attrs:{"top":"","close-delay":500,"allow-overflow":""}},[_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaParcela(_vm.item)}},slot:"activator"},[_vm._v("\n                    Produtos\n                ")]),_vm._v(" "),_c('span',[_vm._v("Visualizar tabela de produtos")])],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","max-width":"750px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Produtos")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('table',{staticClass:"table_vencimento",attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"8"}},[_vm._v("Informações dos produtos")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"1"}},[_vm._v("Código")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Descrição")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("NCM/SH")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("CFOP")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("UN")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Quantidade")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Valor Unitario")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Valor Total")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.item),function(duplicata,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(duplicata.cProd))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(duplicata.xProd))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(duplicata.NCM))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(duplicata.CFOP))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(duplicata.uCom))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(duplicata.qCom))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center valorReais"},[_vm._v(_vm._s(duplicata.vUnCom.toLocaleString("pt-BR", {minimumFractionDigits: 2,maximumFractionDigits: 2})))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right valorReais"},[_vm._v(_vm._s(duplicata.vProd.toLocaleString("pt-BR", {minimumFractionDigits: 2,maximumFractionDigits: 2})))])])}),0)])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_lote_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262f5258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_lote_vue__ = __webpack_require__(739);
function injectStyle (ssrContext) {
  __webpack_require__(738)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_lote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262f5258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_lote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.item != undefined && _vm.item.length > 0)?_c('span',{staticClass:"lote_btn"},[_c('v-tooltip',{attrs:{"top":"","close-delay":500,"allow-overflow":""}},[_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaParcela(_vm.item)}},slot:"activator"},[_vm._v("\n                    Visualizar\n                ")]),_vm._v(" "),_c('span',[_vm._v("Visualizar tabela de lotes")])],1)],1):_c('span',{staticClass:"lote_btn"},[_vm._v("Sem informações")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Lotes")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('table',{staticClass:"table_vencimento",attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"3"}},[_vm._v("Tabela de inf. do Lote")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"1"}},[_vm._v("Número do Lote")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_vm._v("Vencimento")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.item),function(lote,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(lote.nLote))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(lote.dVal.substring(0, lote.dVal.indexOf("T")).split('-').reverse().join('/')))])])}),0)])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_simples_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c139590a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_simples_vue__ = __webpack_require__(742);
function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_simples_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c139590a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_simples_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('span',[_c('v-tooltip',{attrs:{"top":"","close-delay":500,"allow-overflow":""}},[_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaParcela()}},slot:"activator"},[_vm._v(_vm._s(_vm.item))]),_vm._v(" "),_c('span',[_vm._v("Visualizar tabela de descrição")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Parcelas")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('table',{staticClass:"table_vencimento",attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"3"}},[_vm._v("Opções do simples")])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"padding":"5px"},attrs:{"colspan":"1"}},[_vm._v("Númeração")]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Descrição")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.desc),function(opcao,i){return _c('tr',{key:i,class:[_vm.item == opcao.tipo ? 'destaque_fundo' : '']},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(opcao.tipo))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(opcao.desc))])])}),0)])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_tributacao_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de77ac0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_tributacao_vue__ = __webpack_require__(745);
function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_tributacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de77ac0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_tributacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('span',[_c('v-tooltip',{attrs:{"top":"","close-delay":500,"allow-overflow":""}},[_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaParcela()}},slot:"activator"},[_vm._v(_vm._s(_vm.item.item.tribNfe))]),_vm._v(" "),_c('span',[_vm._v("Visualizar tabela de descrição")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Parcelas")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('table',{staticClass:"table_vencimento",attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"3"}},[_vm._v("Opções de Tributação")])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"padding":"5px"},attrs:{"colspan":"1"}},[_vm._v("Tipos")]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Descrição")])])]),_vm._v(" "),_c('tbody',_vm._l((this.descAtt),function(opcao,i){return _c('tr',{key:i,class:[_vm.item.item.tribNfe == opcao.tipo ? 'destaque_fundo' : '']},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(opcao.tipo))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(opcao.desc))])])}),0)])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_lei_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ee2a18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_lei_vue__ = __webpack_require__(748);
function injectStyle (ssrContext) {
  __webpack_require__(747)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_lei_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ee2a18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_lei_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('span',[_c('v-tooltip',{attrs:{"top":"","close-delay":500,"allow-overflow":""}},[(_vm.item.item && _vm.item.item.lei && _vm.item.item.lei.descricao && _vm.item.item.lei.descricao.length >= 15)?_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaLei()}},slot:"activator"},[_vm._v("\n        "+_vm._s(_vm.item.item.lei.descricao.substr(0,15) + "...")+"\n        ")]):_c('v-chip',{attrs:{"slot":"activator","small":"","color":"grey darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaLei()}},slot:"activator"},[_vm._v("\n        "+_vm._s(_vm.item.item.lei.descricao)+"\n        ")]),_vm._v(" "),_c('span',[_vm._v("Visualizar descrição da lei")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("LEI 116")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('table',{staticClass:"table_lei",attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"padding":"5px"},attrs:{"colspan":"1"}},[_vm._v("Código")]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Descrição")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.item.item.lei.codigo))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.item.item.lei.descricao))])])])])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_infAd_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8b524b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_infAd_vue__ = __webpack_require__(751);
function injectStyle (ssrContext) {
  __webpack_require__(750)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coluna_infAd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8b524b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coluna_infAd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('div',[_c('v-tooltip',{attrs:{"bottom":"","close-delay":500,"allow-overflow":""}},[_c('v-chip',{staticClass:"infAdChip",attrs:{"slot":"activator","small":"","color":"indigo darken-1","text-color":"white"},nativeOn:{"click":function($event){return _vm.openTabelaInfAd()}},slot:"activator"},[_vm._v("\n          Visualizar\n      ")]),_vm._v(" "),_c('span',[_vm._v("Visualizar informações adicionais")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Informações adicionais")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n            "+_vm._s(this.item.item.inf_ad)+"\n          ")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnMoverTable_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d56a98c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnMoverTable_vue__ = __webpack_require__(754);
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d56a98c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnMoverTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d56a98c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnMoverTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-end":"","row":"","fill-height":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"ma-0",staticStyle:{"height":"23px","width":"23px","margin-right":"5px!important"},attrs:{"slot":"activator","color":"blue","icon":"","small":"","dark":""},on:{"click":_vm.handleRefresh},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"17px"}},[_vm._v("refresh")])],1),_vm._v(" "),_c('span',[_vm._v("Atualizar")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-0",staticStyle:{"height":"23px","width":"23px"},attrs:{"slot":"activator","color":"teal","icon":"","small":"","dark":""},on:{"mousedown":function($event){return _vm.scroll('left')},"mouseleave":_vm.stop,"mouseup":_vm.stop},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"17px"}},[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",staticStyle:{"height":"23px","width":"23px"},attrs:{"slot":"activator","color":"teal","icon":"","small":"","dark":""},on:{"mouseleave":_vm.stop,"mouseup":_vm.stop},nativeOn:{"mousedown":function($event){return _vm.scroll('rigth')}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"17px"}},[_vm._v("chevron_right")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SnackBar_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1e5b4b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SnackBar_vue__ = __webpack_require__(757);
function injectStyle (ssrContext) {
  __webpack_require__(756)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a1e5b4b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SnackBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1e5b4b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SnackBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"article_btnConsulta"},[_c('v-snackbar',{class:this.table.snack.multiple ? 'snack_multiple' : '',attrs:{"bottom":null === 'bottom',"left":'right' === 'left',"multi-line":'' === 'multi-line',"right":'right' === 'right',"timeout":_vm.table.snack.time,"top":null === 'top',"vertical":'' === 'vertical',"id":"snack","color":_vm.table.snack.color},model:{value:(_vm.table.snack.show),callback:function ($$v) {_vm.$set(_vm.table.snack, "show", $$v)},expression:"table.snack.show"}},[_c('strong',[_vm._v(_vm._s(this.table.snack.text))]),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.table.snack.btnFColor,"flat":""},on:{"click":function($event){_vm.table.snack.show = false}}},[_vm._v("\n            Fechar\n            ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.failureDialog),callback:function ($$v) {_vm.failureDialog=$$v},expression:"failureDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_vm._v("Erros")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',[_c('v-alert',{staticStyle:{"padding":"5px"},attrs:{"value":true,"type":"error"}},[_vm._v("\n          "+_vm._s(_vm.errors)+"\n        ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.failureDialog = false}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.infoDialog),callback:function ($$v) {_vm.infoDialog=$$v},expression:"infoDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_vm._v("Informação")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',[_c('v-alert',{staticStyle:{"padding":"5px"},attrs:{"value":true,"type":"info","color":"info","icon":"info"}},[_vm._v("\n          "+_vm._s(_vm.infos)+"\n        ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.infoDialog = false}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-header"},[_c('v-card-title',[_c('h1',{staticClass:"titleTable"},[_vm._v("\n        "+_vm._s(_vm.component.text.length > 0 ? _vm.component.text : "")+"\n      ")]),_vm._v(" "),(
          this.logConsulta &&
            ((this.component.tipo != 'emitida' &&
              (_vm.component.name.indexOf('NFe') != -1 ||
                _vm.component.name == 'CTE')) ||
              _vm.component.name == 'NFSE')
        )?_c('div',{attrs:{"id":"infoConsulta"}},[_c('small',[_vm._v("Última consulta completa em:")]),_vm._v(" "),_c('div',{attrs:{"id":"consultaData"}},[_c('v-icon',[_vm._v("calendar_today")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.logConsulta.toLocaleString()))])],1)]):_vm._e()]),_vm._v(" "),_c('v-card-title',[_c('actionsHeader',{attrs:{"alert":_vm.alert,"logQtd":_vm.logQtd,"logConsulta":this.logConsulta,"component":_vm.component,"range":this.range,"empresa":_vm.empresa,"headers":this.table.headers,"selected":this.selected,"table":this.table,"conta":_vm.conta},on:{"getHeader":function($event){return _vm.getHeader($event)},"getLogConsulta":function($event){return _vm.getLogConsulta($event)},"getSearch":function($event){return _vm.getSearch($event)},"tagForSearch":function($event){return _vm.tagForSearch($event)},"updatedSelected":function($event){return _vm.updatedSelected($event)},"getDataBusca":function($event){return _vm.getDataBusca($event)},"getOpenFiltro":function($event){return _vm.getOpenFiltro($event)}}}),_vm._v(" "),_c('panelFiltro',{attrs:{"mostrar":_vm.filtro,"table":this.table,"component":_vm.component,"empresa":_vm.empresa},on:{"getFiltro":function($event){return _vm.getFiltro($event)}}}),_vm._v(" "),(_vm.table.urlFiltros != '')?_c('v-container',{staticClass:"filtros"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',[_c('div',{attrs:{"id":"showFiltrosTitle"}},[_vm._v("Filtrando por")]),_vm._v(" "),_vm._l((_vm.table.filtros.items),function(item,i){return (
                item.valor != null &&
                  item.valor.length > 0 &&
                  _vm.table.urlFiltros != ''
              )?_c('div',{key:i,attrs:{"id":"showFiltrosContent"}},[_c('strong',[_vm._v(_vm._s(item.text)+":")]),_vm._v(" "),(
                  item.item_id != 'status' && item.item_id != 'manifestacao' && item.item_id != 'statusDes'
                )?_c('v-chip',{attrs:{"text-color":"white","id":"chipFiltros","color":"indigo darken-4"},nativeOn:{"click":function($event){return _vm.rmvThisFilter(item, undefined, $event)}}},[_c('small',[(item.item_id.indexOf('vlr') != -1)?_c('span',[_vm._v("R$")]):_vm._e(),_vm._v(" "),(item.text.toLowerCase().indexOf('data') != -1)?_c('span',[_vm._v(_vm._s(item.data
                      .split("-")
                      .reverse()
                      .join("/")))]):_c('span',[_vm._v(_vm._s(item.valor))])]),_vm._v(" "),_c('div',{staticClass:"v-chip__close"},[_c('i',{staticClass:"v-icon material-icons",attrs:{"id":"chipFiltrosClose","aria-hidden":"true"}},[_vm._v("cancel")])])]):_vm._e(),_vm._v(" "),_vm._l((item.valor),function(a,j){return (
                  item.item_id == 'status' || item.item_id == 'manifestacao' || item.item_id == 'statusDes'
                )?_c('v-chip',{key:j,attrs:{"text-color":"white","id":"chipFiltros","color":"indigo darken-4"},nativeOn:{"click":function($event){return _vm.rmvThisFilter(item, a, $event)}}},[_c('small',[_vm._v(_vm._s(a))]),_vm._v(" "),_c('div',{staticClass:"v-chip__close"},[_c('i',{staticClass:"v-icon material-icons",attrs:{"id":"chipFiltrosClose","aria-hidden":"true"}},[_vm._v("cancel")])])]):_vm._e()})],2):_vm._e()}),_vm._v(" "),_c('div',{attrs:{"id":"showFiltrosTitle"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{class:'d-inline-block',staticStyle:{"height":"22px!important","width":"100px"},attrs:{"slot":"activator","outline":"","color":"teal","text-color":"white","dark":"","round":"","id":"btn_clsFiltros"},nativeOn:{"click":function($event){_vm.table.resetFiltro(),
                      (_vm.table.filtros.fechar = true),
                      _vm.getFiltro(),
                      (_vm.range = 'mesAtual')}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"font-size":"15px"},attrs:{"dark":"","color":"orange"}},[_vm._v("delete_forever")]),_vm._v(" "),_c('small',{staticStyle:{"padding":"2px"}},[_vm._v("Limpar Filtro")])],1),_vm._v(" "),_c('span',[_vm._v("Limpar todo filtro avançado")])],1)],1)],2)])],1):_vm._e()],1),_vm._v(" "),(_vm.component.enable.arrowMovTable)?_c('btnMoverTable',{attrs:{"table":_vm.table,"component":this.component}}):_vm._e()],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",class:'table_' + _vm.component.name,attrs:{"headers":_vm.table.headers,"search":_vm.search,"custom-filter":_vm.customFilter,"items":_vm.table.arrayNotas,"pagination":_vm.pagination,"select-all":"","item-key":"chave","rows-per-page-text":((_vm.component.textPlural) + " por página: "),"rows-per-page-items":_vm.table.rows_per_page_items,"loading":_vm.table.loading,"next":_vm.$vuetify.icons.next,"prev-icon":"","next-icon":"","id":"table"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[(_vm.component.enable.selectAll || _vm.component.enable.acoes)?_c('th',{style:((_vm.component.enable.acoes == false
              ? 'min-width: 30px;max-width: 30px;width: 30px;'
              : '',
            _vm.component.enable.selectAll == false &&
            _vm.component.enable.acoes == true
              ? 'min-width: 0px;'
              : '')),attrs:{"id":"auxFix"}}):_vm._e(),_vm._v(" "),(_vm.component.enable.selectAll)?_c('th',{staticClass:"headcol",attrs:{"id":"slctBox"}},[_c('v-checkbox',{attrs:{"input-value":props.all,"indeterminate":props.indeterminate,"primary":"","hide-details":""},on:{"click":function($event){_vm.selected = _vm.table.selecionarTodosItens('primeiro_check')}},nativeOn:{"click":function($event){_vm.selected = _vm.table.selecionarTodosItens('parse').slice()}}})],1):_vm._e(),_vm._v(" "),_vm._l((props.headers),function(header){return _c('th',{directives:[{name:"show",rawName:"v-show",value:(header.show == true),expression:"header.show == true"}],key:header.text,class:[
            'column sortable',
            _vm.pagination.descending ? 'desc' : 'asc',
            header.value === _vm.pagination.sortBy ? 'active' : '',
            header.value == 'acoes' ? 'headcol' : '' ],staticStyle:{"color":"#25476a","font-weight":"900","font-size":"0.9em"},style:(header.value == 'acoes' &&
            _vm.component.enable.selectAll == false &&
            _vm.component.enable.acoes == true
              ? 'left: 0px'
              : ''),attrs:{"id":'h_' + header.value},on:{"click":function($event){return _vm.changeSort(header.value)}}},[(header.value != 'acoes')?_c('v-icon',{staticStyle:{"color":"white"},attrs:{"small":""}},[_vm._v("arrow_upward")]):_vm._e(),_vm._v("\n          "+_vm._s(header.text)+"\n          "),(header.value == 'CRT')?_c('v-tooltip',{staticStyle:{"cursor":"help"},attrs:{"top":""}},[_c('span',{staticStyle:{"font-size":"13px"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_c('v-icon',{staticClass:"dont_rotate",staticStyle:{"font-size":"13px","opacity":"1"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_vm._v("help")])],1),_vm._v(" "),_c('span',[_vm._v("\n              1 - Simples Nacional.\n              "),_c('br'),_vm._v("2 - Simples Nacional - excesso de sublimite de receita\n              bruta. "),_c('br'),_vm._v("3 - Regime Normal.\n              "),_c('br')])]):_vm._e(),_vm._v(" "),(header.value == 'statusIn')?_c('v-tooltip',{staticStyle:{"cursor":"help"},attrs:{"top":""}},[_c('span',{staticStyle:{"font-size":"13px"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_c('v-icon',{staticClass:"dont_rotate",staticStyle:{"font-size":"13px","opacity":"1"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_vm._v("help")])],1),_vm._v(" "),_c('span',[_vm._v("\n              Ativo - Colaborador ativo no Motor Fiscal.\n              "),_c('br'),_vm._v("Pendente - Acesso Pendente do colaborador no Motor Fiscal.\n              "),_c('br'),_vm._v("Inativo - Colaborador desativado no Motor Fiscal.\n              "),_c('br')])]):_vm._e(),_vm._v(" "),(header.value == 'statusErp')?_c('v-tooltip',{staticStyle:{"cursor":"help"},attrs:{"top":""}},[_c('span',{staticStyle:{"font-size":"13px"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_c('v-icon',{staticClass:"dont_rotate",staticStyle:{"font-size":"13px","opacity":"1"},attrs:{"slot":"activator","tag":"div","color":"black"},slot:"activator"},[_vm._v("help")])],1),_vm._v(" "),_c('span',[_vm._v("\n              Espaço reservado para\n              "),_c('strong',[_vm._v("informativo")]),_vm._v(" "),_c('br'),_vm._v("de integração com\n              "),_c('strong',[_vm._v("sistemas ERP.")])])]):_vm._e(),_vm._v(" "),(header.value == 'statusErpDois')?_c('v-tooltip',{staticStyle:{"cursor":"help"},attrs:{"top":""}},[_c('span',{staticStyle:{"font-size":"13px"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_c('v-icon',{staticClass:"dont_rotate",staticStyle:{"font-size":"13px","opacity":"1"},attrs:{"slot":"activator","tag":"div","color":"black"},slot:"activator"},[_vm._v("help")])],1),_vm._v(" "),_c('span',[_vm._v("\n            Espaço reservado para\n            "),_c('strong',[_vm._v("informativo")]),_vm._v(" "),_c('br'),_vm._v("de integração com\n            "),_c('strong',[_vm._v("sistemas ERP Dois.")])])]):_vm._e(),_vm._v(" "),(header.value == 'posFechamento')?_c('v-tooltip',{staticStyle:{"cursor":"help"},attrs:{"top":""}},[_c('span',{staticStyle:{"font-size":"13px"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_c('v-icon',{staticClass:"dont_rotate",staticStyle:{"font-size":"13px","opacity":"1"},attrs:{"slot":"activator","tag":"div","color":"black"},slot:"activator"},[_vm._v("help")])],1),_vm._v(" "),_c('span',[_vm._v("\n            Espaço reservado para\n            "),_c('strong',[_vm._v("informativo")]),_vm._v(" "),_c('br'),_vm._v("de notas emitidas pós o fechamento\n            "),_c('strong',[_vm._v(".")])])]):_vm._e(),_vm._v(" "),(header.value == 'discriminacao')?_c('v-tooltip',{staticStyle:{"cursor":"help"},attrs:{"top":""}},[_c('span',{staticStyle:{"font-size":"13px"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_c('v-icon',{staticClass:"dont_rotate",staticStyle:{"font-size":"13px","opacity":"1"},attrs:{"slot":"activator","color":"black"},slot:"activator"},[_vm._v("help")])],1),_vm._v(" "),_c('span',[_vm._v("\n              Discriminação completa no\n              "),_c('strong',[_vm._v("1º botão da coluna")]),_vm._v(" Ações\n            ")])]):_vm._e(),_vm._v(" "),(header.value.indexOf('custom_') != -1)?_c('v-tooltip',{staticStyle:{"cursor":"help"},attrs:{"top":""}},[_c('span',{staticStyle:{"font-size":"15px"},attrs:{"slot":"activator","color":"white"},slot:"activator"},[_c('v-icon',{staticClass:"dont_rotate",staticStyle:{"font-size":"13px","opacity":"1"},attrs:{"slot":"activator","color":"white"},slot:"activator"},[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("\n              Linhas desta coluna são\n              "),_c('strong',[_vm._v("Editáveis")])])]):_vm._e()],1)})],2)]}},{key:"items",fn:function(props){return [_c('tr',{class:[
          props.item.status != undefined &&
          props.item.status.toLowerCase() == 'cancelada'
            ? 'cancelada'
            : '',
          props.item.statusNFe != undefined &&
          props.item.statusNFe.toLowerCase() == 'cancelada'
            ? 'cancelada'
            : '',
          props.item.manifestacao != undefined &&
          props.item.manifestacao.toLowerCase() == 'desacordo'
            ? 'cancelada'
            : '',
          props.item.statusEmissao != undefined &&
          props.item.statusEmissao.toLowerCase() == 'cancelada'
            ? 'cancelada'
            : '' ],attrs:{"active":props.selected}},[(_vm.component.enable.selectAll)?_c('td',{staticClass:"headcol",attrs:{"id":"slctBox"},on:{"click":function($event){return _vm.selectRow(props)}}},[_c('v-checkbox',{attrs:{"input-value":props.selected,"primary":""},on:{"click":function($event){_vm.selected = _vm.table.selecionarTodosItens('primeiro_check')}}})],1):_vm._e(),_vm._v(" "),(_vm.component.enable.acoes)?_c('td',{staticClass:"text-xs-center headcol",class:[_vm.component.name == 'fornecedores' ? 'forn' : ''],style:((_vm.component.name == 'CTE'
              ? ' width: 134px;'
              : 'width: max-content;',
            _vm.component.enable.selectAll == false &&
            _vm.component.enable.acoes == true
              ? 'left: 0px;'
              : '')),attrs:{"id":"acoes"}},[_c('columnActions',{attrs:{"attTableEmp":this && this.attTableEmp,"alert":_vm.alert,"conta":_vm.conta,"table":_vm.table,"component":_vm.component,"nota":props,"empresa":_vm.empresa,"IBGE":_vm.IBGE},on:{"attTableEmp":function($event){return _vm.attTableEmp($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)}}})],1):_vm._e(),_vm._v(" "),(_vm.component.enable.selectAll || _vm.component.enable.acoes)?_c('td',{style:(_vm.component.enable.acoes == false ? 'min-width: unset;' : ''),attrs:{"id":"auxFix"}}):_vm._e(),_vm._v(" "),_vm._l((props.item),function(item,index){return _c('td',{key:index,class:[
            index.indexOf('valor') != -1 ||
            index.toLowerCase().indexOf('vlr') != -1 ||
            index.toLowerCase().indexOf('vlr') != -1 ||
            index.toLowerCase().indexOf('pis') != -1 ||
            index.toLowerCase().indexOf('cofins') != -1 ||
            index.toLowerCase().indexOf('csll') != -1 ||
            index.toLowerCase().indexOf('inss') != -1 ||
            index.toLowerCase().indexOf('ir') != -1
              ? 'text-xs-right'
              : index.toLowerCase().indexOf('xprod') != -1 ||
                index.toLowerCase().indexOf('cprod') != -1 ||
                index.toLowerCase().indexOf('fornrazao') != -1 ||
                index.toLowerCase().indexOf('xnome') != -1 ||
                index.toLowerCase().indexOf('xfant') != -1
              ? 'text-xs-left'
              : 'text-xs-center',
            index.indexOf('custom_') != -1 ? 'customCc' : '' ],attrs:{"id":index}},[(index == 'protocolada')?_c('span',[(item != undefined && item.toLowerCase() == 'sim')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):(item != undefined && item.toLowerCase() == 'nao')?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v(_vm._s(item))]):_vm._e()],1):(index == 'ISSRetido')?_c('span',[(item != undefined && item.toLowerCase() == 'true')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v("Sim")]):(item != undefined && item.toLowerCase() == 'false')?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v("Não")]):_vm._e()],1):(index == 'statusEmissao')?_c('span',[(item != undefined && item.toLowerCase() == 'processando')?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"green","text-color":"white"}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Processando")])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.erroEmissao ? props.item.erroEmissao : "Processando"))])]):(item != undefined && item.toLowerCase() == 'falha')?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"orange","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'EMISSAO')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Falha")])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.erroEmissao ? props.item.erroEmissao : "Falha"))])]):(item != undefined && item.toLowerCase() == 'emitido')?_c('v-chip',{attrs:{"small":"","color":"blue","text-color":"white"}},[_vm._v("Emitido")]):(
                item != undefined && item.toLowerCase() == 'inclusao'
              )?_c('v-chip',{attrs:{"small":"","color":"grey darken-3","text-color":"white"}},[_vm._v("Pendente")]):_vm._e(),_vm._v(" "),(item != undefined && item.toLowerCase() == 'cancelada')?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v("Cancelada")]):_vm._e()],1):(
              index != undefined && index.toLowerCase() == 'opcaosimples'
            )?_c('span',[_c('colunaSimples',{attrs:{"component":_vm.component,"table":_vm.table,"item":item}})],1):(index != undefined && index.toLowerCase() == 'tribnfe')?_c('span',[_c('colunatributacao',{attrs:{"component":_vm.component,"table":_vm.table,"item":props}})],1):(index != undefined && index.toLowerCase() == 'lei')?_c('span',[(props.item.lei != undefined)?_c('colunalei',{attrs:{"item":props}}):_vm._e()],1):(index != undefined && index.toLowerCase() == 'inf_ad')?_c('span',[(props.item.inf_ad)?_c('colunaInfAd',{attrs:{"item":props}}):_vm._e()],1):(index != undefined && index.toLowerCase() == 'produtos')?_c('span',[_c('colunaProdutos',{attrs:{"component":_vm.component,"item":item,"empresa":_vm.empresa}})],1):(index != undefined && index.toLowerCase() == 'sistem')?_c('span',[(props.item.sistem)?_c('colunaSistema',{attrs:{"item":props}}):_vm._e()],1):(index == 'status')?_c('span',[(item != undefined && item.toLowerCase() == 'cancelada')?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v(_vm._s(item))]):(
                item != undefined && item.toLowerCase() == 'autorizada'
              )?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):_vm._e()],1):(index == 'modal')?_c('span',[(item != undefined && item.toLowerCase() == '01')?_c('v-chip',{attrs:{"small":"","color":"indigo darken-4","text-color":"white"}},[_vm._v("Rodoviario")]):(item != undefined && item.toLowerCase() == '02')?_c('v-chip',{attrs:{"small":"","color":"indigo darken-3","text-color":"white"}},[_vm._v("Aereo")]):(item != undefined && item.toLowerCase() == '03')?_c('v-chip',{attrs:{"small":"","color":"indigo darken-2","text-color":"white"}},[_vm._v("Aquaviario")]):(item != undefined && item.toLowerCase() == '04')?_c('v-chip',{attrs:{"small":"","color":"deep-purple darken-2","text-color":"white"}},[_vm._v("Ferroviario")]):(item != undefined && item.toLowerCase() == '05')?_c('v-chip',{attrs:{"small":"","color":"deep-purple darken-3","text-color":"white"}},[_vm._v("Dutoviario")]):(item != undefined && item.toLowerCase() == '06')?_c('v-chip',{attrs:{"small":"","color":"deep-purple darken-4","text-color":"white"}},[_vm._v("Multimodal")]):_vm._e()],1):(index == 'trans_modFrete' && item != undefined && item.toLowerCase() == '0' )?_c('span',[_vm._v("\n          Por conta do emitente")]):(index == 'trans_modFrete' && item != undefined && item.toLowerCase() == '1' )?_c('span',[_vm._v("\n            Por conta do destinatário/remetente")]):(index == 'trans_modFrete' && item != undefined && item.toLowerCase() == '2' )?_c('span',[_vm._v("\n            Por conta de terceiros")]):(index == 'trans_modFrete' && item != undefined && item.toLowerCase() == '9' )?_c('span',[_vm._v("\n            Sem frete")]):(index == 'statusNFe')?_c('span',[(item != undefined && item.toLowerCase() == 'cancelada')?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v(_vm._s(item))]):(item != undefined && item.toLowerCase() == 'normal')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):_vm._e()],1):(index == 'status_escrituracao')?_c('span',[(item != undefined && item.toLowerCase() == 'escriturada')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):(item != undefined && item.toLowerCase() == 'desconsiderada')?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"orange","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'ESCRITURACAO')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Desconsiderada")])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_escrituracao ? props.item.log_escrituracao : 'Desconsiderada'))])]):(item != undefined && item.toLowerCase() == 'erro')?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"red","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'ESCRITURACAO')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Erro")])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_escrituracao ? props.item.log_escrituracao : 'Erro'))])]):(!item || item.toLowerCase() == 'pendente')?_c('v-chip',{attrs:{"small":"","color":"#fcf738","text-color":"black"}},[_vm._v("Pendente")]):_vm._e()],1):(index == 'ftpPython')?_c('span',[(item != undefined && item.toLowerCase() == 'sucesso')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):(props.item.logErroFtpXml != undefined && props.item.logErroFtpXml != '')?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"red","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'XML')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Falha")])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.logErroFtpXml ? props.item.logErroFtpXml : 'Falha'))])]):(!item || item.toLowerCase() == 'pendente')?_c('v-chip',{attrs:{"small":"","color":"#fcf738","text-color":"black"}},[_vm._v("Pendente")]):_vm._e()],1):(index == 'ftpPythonPdf')?_c('span',[(item != undefined && item.toLowerCase() == 'sucesso')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):(props.item.logErroFtpPdf != undefined && props.item.logErroFtpPdf != '')?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"red","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'PDF')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Falha")])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.logErroFtpPdf ? props.item.logErroFtpPdf : 'Falha'))])]):(!item || item.toLowerCase() == 'pendente')?_c('v-chip',{attrs:{"small":"","color":"#fcf738","text-color":"black"}},[_vm._v("Pendente")]):_vm._e()],1):(index == 'statusOcr')?_c('span',[(item != undefined && item.toLowerCase() == 'sucesso')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):(item != undefined && item.toLowerCase() == 'falha')?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"red","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'OCR')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Falha")])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_ocr ? props.item.log_ocr : 'Falha'))])]):(item != undefined && item.toLowerCase() == 'inativo')?_c('v-chip',{attrs:{"small":"","color":"orange","text-color":"black"}},[_vm._v(_vm._s(item))]):_c('v-chip',{attrs:{"small":"","color":"#fcf738","text-color":"black"}},[_vm._v(_vm._s(item))])],1):(index == 'statusIntegracao')?_c('span',[(item != undefined && item.toLowerCase() == 'sucesso')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):(item != undefined && item.toLowerCase() == 'falha')?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"red","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'INTEGRACAO')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Falha")])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_integracao ? props.item.log_integracao : 'Falha'))])]):(!item || item.toLowerCase() == 'pendente')?_c('v-chip',{attrs:{"small":"","color":"#fcf738","text-color":"black"}},[_vm._v(_vm._s(item))]):_vm._e()],1):(index === 'vencimento')?_c('span',[_vm._v(_vm._s(item != undefined && item instanceof Date && !isNaN(item)
              ? item.toLocaleDateString("pt-BR")
              : item))]):(index === 'createdAt')?_c('span',[_vm._v(_vm._s(item != undefined && item instanceof Date && !isNaN(item)
              ? item.toLocaleDateString("pt-BR")
              : item))]):(index == 'trabFiliado')?_c('span',[(item != undefined && item.indexOf('nfse') != -1)?_c('v-chip',{attrs:{"small":"","color":"primary","text-color":"white"}},[_vm._v("Serviço")]):_vm._e(),_vm._v(" "),(item != undefined && item.indexOf('nfe') != -1)?_c('v-chip',{attrs:{"small":"","color":"teal","text-color":"white"}},[_vm._v("Mercadoria")]):_vm._e()],1):(index == 'manifestacao')?_c('span',[_c('colunaManifestoBtn',{attrs:{"nota":props,"item":item,"empresa":_vm.empresa}})],1):(index.toLowerCase().indexOf('rela_qntlogins') != -1)?_c('span',[_c('colunaLogins',{attrs:{"component":_vm.component,"item":props.item}})],1):(index.toLowerCase() === 'statuserp')?_c('span',[(item != undefined && item.toLowerCase().indexOf('integrado') != -1)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"primary","text-color":"white"},on:{"click":function($event){return _vm.handleInfo(props.item,'STATUSERP')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_statusErp ? props.item.log_statusErp : _vm.capitalizeFirstLetter(item)))])]):(item != undefined && item.toLowerCase().indexOf('cancelada') != -1)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"primary","text-color":"white"},on:{"click":function($event){return _vm.handleInfo(props.item,'STATUSERP')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_statusErp ? props.item.log_statusErp : _vm.capitalizeFirstLetter(item)))])]):(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('validada') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"orange","text-color":"white"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))]):(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('pre') != -1 &&
                  item.toLowerCase().indexOf('nota') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"yellow lighten-2","text-color":"black"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))]):(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('nota') != -1 &&
                  item.toLowerCase().indexOf('classificada') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))]):(item != undefined && item.toLowerCase().indexOf('falha') != -1)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"red","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'STATUSERP')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(item))])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_statusErp ? props.item.log_statusErp : 'Falha'))])]):(item != undefined && item != '')?_c('v-chip',{attrs:{"small":"","color":"grey","text-color":"white"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))]):_vm._e()],1):(index.toLowerCase() === 'statuserpdois')?_c('span',[(item != undefined && item.toLowerCase().indexOf('integrado') != -1)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"primary","text-color":"white"},on:{"click":function($event){return _vm.handleInfo(props.item,'STATUSERPDOIS')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_statusErpDois ? props.item.log_statusErpDois : _vm.capitalizeFirstLetter(item)))])]):(item != undefined && item.toLowerCase().indexOf('cancelada') != -1)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"primary","text-color":"white"},on:{"click":function($event){return _vm.handleInfo(props.item,'STATUSERPDOIS')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_statusErpDois ? props.item.log_statusErpDois : _vm.capitalizeFirstLetter(item)))])]):(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('validada') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"orange","text-color":"white"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))]):(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('pre') != -1 &&
                  item.toLowerCase().indexOf('nota') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"yellow lighten-2","text-color":"black"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))]):(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('nota') != -1 &&
                  item.toLowerCase().indexOf('classificada') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))]):(item != undefined && item.toLowerCase().indexOf('falha') != -1)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"red","text-color":"white"},on:{"click":function($event){return _vm.handleFailure(props.item,'STATUSERPDOIS')}}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(item))])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.log_statusErpDois ? props.item.log_statusErpDois : 'Falha'))])]):(item != undefined && item != '')?_c('v-chip',{attrs:{"small":"","color":"grey","text-color":"white"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))]):_vm._e()],1):(index === 'posFechamento')?_c('span',[(item != undefined)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"red","text-color":"white"}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item)))])])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Nota emitida após o fechamento entre as datas 26 - 31")])]):_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"green","text-color":"white"}},on),[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("Não")])])]}}],null,true)})],1):(index.toLowerCase().indexOf('pagtoiptu') != -1)?_c('span',[(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('avista') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v("A Vista")]):_vm._e(),_vm._v(" "),(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('parcelado') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"blue","text-color":"white"}},[_vm._v("Parcelado")]):_vm._e(),_vm._v(" "),(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('ambos') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"orange","text-color":"white"}},[_vm._v("Ambos")]):_vm._e()],1):(index == 'statusDES')?_c('span',[(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('pendente') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"grey darken-3","text-color":"white"}},[_vm._v("Pendente")]):_vm._e(),_vm._v(" "),(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('validado') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"blue","text-color":"white"}},[_vm._v("Validado")]):_vm._e(),_vm._v(" "),(
                item &&
                  item != undefined &&
                  item.toLowerCase().indexOf('inconsistente') != -1
              )?_c('v-chip',{attrs:{"small":"","color":"orange","text-color":"white"}},[_vm._v("Inconsistente")]):_vm._e()],1):(index.toLowerCase().indexOf('statusin') != -1)?_c('span',[(
                (item != undefined &&
                  item &&
                  props.item.preCadastro != undefined &&
                  props.item.preCadastro.length == 0) ||
                  (props.item.preCadastro == undefined && props.item.statusIn)
              )?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v("Ativo")]):(
                item != undefined &&
                  item &&
                  props.item.preCadastro != undefined &&
                  props.item.preCadastro.length > 0
              )?_c('v-chip',{attrs:{"small":"","color":"yellow darken-2","text-color":"white"}},[_vm._v("Pendente")]):(item != undefined && !item)?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v("Inativo")]):_vm._e()],1):(index.toLowerCase().indexOf('plano') != -1)?_c('span',[(item == 'micro')?_c('v-chip',{attrs:{"small":"","color":"cyan darken-2","text-color":"white"}},[_vm._v(_vm._s(_vm.getTextPlano(item)))]):(item == 'gestao')?_c('v-chip',{attrs:{"small":"","color":"indigo darken-2","text-color":"white"}},[_vm._v(_vm._s(_vm.getTextPlano(item)))]):(item == 'performance')?_c('v-chip',{attrs:{"small":"","color":"orange darken-2","text-color":"white"}},[_vm._v(_vm._s(_vm.getTextPlano(item)))]):(item == 'super')?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v(_vm._s(_vm.getTextPlano(item)))]):_c('v-chip',{attrs:{"small":"","color":"blue-grey darken-4","text-color":"white"}},[_vm._v(_vm._s(_vm.getTextPlano(item)))])],1):(index.toLowerCase().indexOf('bloqueada') != -1)?_c('span',[(item)?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v("Sim")]):_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v("Não")])],1):(index === 'dataServico')?_c('span',[_vm._v(_vm._s(item != undefined && item instanceof Date && !isNaN(item)
              ? item.toLocaleDateString("pt-BR")
              : item))]):(index === 'dtEmissaoNfe')?_c('span',[_vm._v(_vm._s(item != undefined && item instanceof Date && !isNaN(item)
              ? item.toLocaleDateString("pt-BR")
              : item))]):(index.toLowerCase().indexOf('rela_totalemp') != -1)?_c('span',[_c('colunaListEmprConta',{attrs:{"component":_vm.component,"item":props.item}})],1):(index.toLowerCase().indexOf('rela_plano') != -1)?_c('span',[_vm._v(_vm._s(_vm.getTextPlano(item)))]):(index.toLowerCase().indexOf('vinculo') != -1)?_c('span',[_c('colunaVinculo',{attrs:{"component":_vm.component,"nota":props}})],1):(index.toLowerCase().indexOf('cnpj') != -1)?_c('span',[_vm._v(_vm._s(item != undefined
              ? item.length > 11
                ? item.replace(
                    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    "$1.$2.$3/$4-$5"
                  )
                : item.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")
              : ""))]):(index.toLowerCase().indexOf('rela_dtlastlogin') != -1)?_c('span',[_vm._v(_vm._s(item != undefined && item instanceof Date && !isNaN(item)
                ? ((item.toLocaleDateString("pt-BR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })) + " " + (item.toLocaleTimeString()))
                : item))]):(
              index.toLowerCase().indexOf('dt') != -1 ||
                index.toLowerCase().indexOf('emissao') != -1
            )?_c('span',[_vm._v(_vm._s(item != undefined && item instanceof Date && !isNaN(item)
                ? item.toLocaleDateString("pt-BR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })
                : item))]):(index.toLowerCase().indexOf('certificado') != -1)?_c('span',{style:(item == undefined || item.validade.venc ? 'color: red' : '')},[_vm._v(_vm._s(item != undefined
                ? item.validade.data.toLocaleDateString("pt-BR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })
                : "Pendente"))]):(index.toLowerCase().indexOf('validade') != -1)?_c('span',{style:(props.item.bvenc ? 'color: red' : '')},[_vm._v(_vm._s(item != undefined ? item : ""))]):(index.toLowerCase().indexOf('colaboradores') != -1)?_c('span',[_vm._v(_vm._s(item == undefined ? 0 : item.length))]):(
              index.toLowerCase().indexOf('uf') != -1 &&
                _vm.component.name == 'empresa'
            )?_c('span',{attrs:{"id":'uf_' + item}},[_vm._v(_vm._s(item != undefined ? _vm.getUfById(item) : ""))]):(index.toLowerCase().indexOf('duplicata') != -1)?_c('span',[_c('colunaVencimento',{attrs:{"component":_vm.component,"item":item,"empresa":_vm.empresa}})],1):(index.toLowerCase().indexOf('produtos') != -1)?_c('span',[_c('colunaProdutos',{attrs:{"component":_vm.component,"item":item,"empresa":_vm.empresa}})],1):(index.toLowerCase() == 'produto')?_c('span',[_vm._v(_vm._s(item == undefined ? 0 : item.length))]):(
              index.toLowerCase().indexOf('valor') != -1 ||
                index.toLowerCase().indexOf('vlr') != -1 ||
                index.toLowerCase().indexOf('pis') != -1 ||
                index.toLowerCase().indexOf('cofins') != -1 ||
                index.toLowerCase().indexOf('csll') != -1 ||
                index.toLowerCase().indexOf('inss') != -1 ||
                index.toLowerCase().indexOf('ir') != -1 ||
                index.toLowerCase().indexOf('acrescimos') != -1||
                index.toLowerCase().indexOf('deducoes') != -1||
                index.toLowerCase().indexOf('desconto') != -1||
                index.toLowerCase().indexOf('multa') != -1
            )?_c('span',[_vm._v(_vm._s(item != undefined
                ? item.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                : ""))]):(index.toLowerCase().indexOf('prodrastro') != -1)?_c('span',[_c('colunaLote',{attrs:{"component":_vm.component,"item":item}})],1):(index.indexOf('faturamento') != -1)?_c('v-edit-dialog',{staticClass:"text-xs-center",attrs:{"id":index,"return-value":props.item.faturamento,"large":"","lazy":"","persistent-hint":false,"cancel-text":"Cancelar","save-text":"Salvar","transition":'slide-y-transition'},on:{"update:returnValue":function($event){return _vm.$set(props.item, "faturamento", $event)},"update:return-value":function($event){return _vm.$set(props.item, "faturamento", $event)},"save":function($event){return _vm.save(props.item, index)},"cancel":_vm.cancel}},[(item != undefined && item.toLowerCase() == 'sim')?_c('v-chip',{attrs:{"small":"","color":"green","text-color":"white"}},[_vm._v(_vm._s(item))]):(item != undefined && item.toLowerCase() == 'não')?_c('v-chip',{attrs:{"small":"","color":"red","text-color":"white"}},[_vm._v(_vm._s(item))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v("Atualizar informação")]),_vm._v(" "),_c('v-select',{attrs:{"slot":"input","persistent-hint":false,"items":['Sim', 'Não'],"color":"teal","prepend-icon":item.prepIcon,"no-data-text":"Erro na consulta de dados","return-object":"","multiple":false,"single-line":"","autofocus":""},slot:"input",model:{value:(props.item.faturamento),callback:function ($$v) {_vm.$set(props.item, "faturamento", $$v)},expression:"props.item.faturamento"}})],1):(index.indexOf('custom_') != -1)?_c('v-edit-dialog',{staticClass:"text-xs-center",attrs:{"id":index,"return-value":item.value,"large":"","lazy":"","persistent":"","cancel-text":"Cancelar","save-text":"Salvar"},on:{"update:returnValue":function($event){return _vm.$set(item, "value", $event)},"update:return-value":function($event){return _vm.$set(item, "value", $event)},"save":function($event){return _vm.save(props.item, index)},"cancel":_vm.cancel}},[_c('div',[_vm._v(_vm._s(item.value))]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v("Atualizar informação")]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","label":"Editar","single-line":"","counter":"","autofocus":"","clearable":""},slot:"input",model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}})],1):_c('span',[_vm._v(_vm._s(item))])],1)})],2)]}},{key:"pageText",fn:function(props){return [(
          _vm.component.name != 'rela_usuario' &&
            _vm.component.name != 'conta' &&
            _vm.component.name != 'fornecedores' &&
            _vm.component.name != 'certificado' &&
            _vm.component.name != 'usuario' &&
            _vm.component.name != 'clientes' &&
            _vm.component.name != 'empresa' &&
            _vm.component.name != 'produtos' &&
            _vm.component.name != 'Iptu'
        )?_c('v-tooltip',{attrs:{"bottom":""}},[_c('div',{staticClass:"d-block",staticStyle:{"color":"black","font-size":"18px"},attrs:{"slot":"activator"},slot:"activator"},[_c('strong',{staticStyle:{"color":"#25476a"}},[_vm._v("Total")]),_vm._v(":\n          "),_c('span',[_vm._v(_vm._s(_vm.table.valor_total_notas.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })))])]),_vm._v(" "),(
            _vm.component.name != 'fornecedores' && _vm.component.name != 'clientes'
          )?_c('span',[_vm._v("Valor total das "+_vm._s(_vm.component.abrev)+" exibidas")]):_vm._e()]):(_vm.component.name == 'conta')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('div',{staticClass:"d-block",staticStyle:{"color":"black","font-size":"18px"},attrs:{"slot":"activator"},slot:"activator"},[_c('small',[_c('strong',{staticStyle:{"color":"#25476a"}},[_vm._v("Total")]),_vm._v(":\n            "),_vm._v(" "),_c('div',{staticClass:"conta_totalizar"},[_c('strong',[_vm._v("Empresa:")]),_vm._v("\n              "+_vm._s(_vm.table.valor_total_conta_empr)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"conta_totalizar"},[_c('strong',[_vm._v("Colaborador:")]),_vm._v("\n              "+_vm._s(_vm.table.valor_total_conta_colab)+"\n            ")])])]),_vm._v(" "),(
            _vm.component.name != 'fornecedores' && _vm.component.name != 'clientes'
          )?_c('span',[_vm._v("Valor total das "+_vm._s(_vm.component.abrev)+" exibidas")]):_vm._e()]):_vm._e(),_vm._v("\n      "+_vm._s(_vm.table.getPosNFeExibidas(props.pageStart, props.pageStop))+"\n      "),_c('strong',[_vm._v("\n        Exibindo "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" do total de\n        "+_vm._s(_vm.table.qnt_total_notas)+"\n        "),_c('span',[_vm._v(_vm._s(_vm.table.qnt_total_notas > 1 ? _vm.component.textPlural : _vm.component.text))])]),_vm._v(".\n    ")]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{staticStyle:{"z-index":"3"},attrs:{"slot":"progress","color":"teal","height":"20","indeterminate":""},slot:"progress"}),_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"color":"indigo darken-4","icon":"info","outline":""}},[(_vm.table.loading)?_c('article',[_vm._v("\n          Motor Fiscal está buscando as informações\n        ")]):_vm._e(),_vm._v(" "),(!_vm.table.loading)?_c('article',[_c('strong',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.empresa != undefined ? _vm.empresa.razao : ""))]),_vm._v("\n          Não possui\n          "),_c('strong',[_vm._v(_vm._s(_vm.component.text))]),_vm._v("\n          disponível para consulta\n          "),(this.component.enable.rangeDate)?_c('article',{staticStyle:{"display":"inline-block"}},[(
                this.component.enable.filtrar && this.table.urlFiltros != ''
              )?_c('span',[_vm._v("\n              com estes\n              "),_c('b',{staticStyle:{"text-transform":"uppercase"}},[_vm._v("filtros")])]):_c('span',[_c('b',[_vm._v(_vm._s(_vm.setTextRange))])])]):_vm._e(),_vm._v("\n          .\n        ")]):_vm._e()])],1),_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("Sua pesquisa por \""+_vm._s(_vm.search)+"\" não tem resultados.")])],2),_vm._v(" "),[_c('div',{staticClass:"text-xs-center pt-2 btn_pages",attrs:{"id":"pagination_button"}},[_c('v-pagination',{attrs:{"total-visible":6,"color":"teal","length":_vm.table.qnt_total_paginas},nativeOn:{"click":function($event){_vm.selected = _vm.table.selecionarTodosItens('clear')}},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}})],1)],_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":3000,"color":_vm.snackColor},model:{value:(_vm.snack),callback:function ($$v) {_vm.snack=$$v},expression:"snack"}},[_vm._v("\n    "+_vm._s(_vm.snackText)+"\n    "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.snack = false}}},[_vm._v("Fechar")])],1),_vm._v(" "),_c('SnackComp',{attrs:{"table":this.table}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Component = function Component(name, text, abrev, enable, textPlural, tipo) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component);

    this.name = name;
    this.text = text;
    this.abrev = abrev;
    this.enable = enable;
    this.textPlural = textPlural;
    this.tipo = tipo;
};

/* harmony default export */ __webpack_exports__["a"] = (Component);

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeBrowser_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77ee29b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeBrowser_vue__ = __webpack_require__(765);
function injectStyle (ssrContext) {
  __webpack_require__(762)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77ee29b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeBrowser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77ee29b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeBrowser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('v-container',{staticClass:"pa-0",attrs:{"id":"form-login","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticStyle:{"z-index":"2"},attrs:{"xs12":"","sm12":""}},[_c('div',{staticClass:"newLogin"},[_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('span',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Motor Fiscal"},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{staticStyle:{"margin-left":"9px"},attrs:{"src":__webpack_require__(258),"alt":"Logo motor","height":"100"}}),_vm._v(" "),_c('h1',{staticClass:"white--text mb-4 display-1 text-xs-center",staticStyle:{"font-weight":"500"}},[_c('span',{staticStyle:{"color":"#00a3a3","font-weight":"800","letter-spacing":"2px!important"}},[_vm._v("M")]),_vm._v("otor Fiscal\n            ")])])]),_vm._v(" "),(!_vm.forgotMenu)?_c('v-slide-x-transition',[_c('article',{staticClass:"login",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.logar()}}},[_c('v-form',{ref:"form",staticStyle:{"width":"60%","margin":"0 auto"},attrs:{"id":"formLogin"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"email",staticStyle:{"padding":"20px 0","color":"white!important"},attrs:{"validate-on-blur":"","rules":_vm.emailRules,"label":"E-mail: (Login)","type":"text","dark":"","clearable":"","required":"","placeholder":" ","color":"white"},model:{value:(_vm.conta.email),callback:function ($$v) {_vm.$set(_vm.conta, "email", $$v)},expression:"conta.email"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"20px 0","color":"white!important"},attrs:{"rules":_vm.passRules,"validate-on-blur":"","label":"Senha:","append-icon":_vm.showPass ? 'visibility_off' : 'visibility',"type":_vm.showPass ? 'text' : 'password',"dark":"","placeholder":" ","clearable":"","required":"","color":"white"},on:{"click:append":function($event){_vm.showPass = !_vm.showPass}},model:{value:(_vm.conta.password),callback:function ($$v) {_vm.$set(_vm.conta, "password", $$v)},expression:"conta.password"}})],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"-25px"}},[_c('a',{staticStyle:{"text-transform":"none !important","color":"white","text-decoration":"underline"},attrs:{"color":"white"},on:{"click":function($event){_vm.forgotMenu = !_vm.forgotMenu}}},[_vm._v("Esqueceu a senha?")])]),_vm._v(" "),_c('v-btn',{staticClass:"btnLogar",attrs:{"color":"success_custom","block":""},on:{"click":function($event){return _vm.logar()}}},[_vm._v("Entrar")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","white-space":"nowrap"}},[_c('span',{staticStyle:{"color":"white"}},[_vm._v("Ainda não possui uma conta? "),_c('a',{staticClass:"btnCadastrar",staticStyle:{"color":"white!important","font-weight":"bold","text-decoration":"underline"},attrs:{"block":""},on:{"click":function($event){return _vm.$router.push('/cadastrar')}}},[_vm._v("Cadastrar")])])])],1)]):_c('v-slide-x-transition',[_c('article',{staticClass:"forgot",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.recover()}}},[_c('v-layout',{staticClass:"white--text",staticStyle:{"padding-top":"0!important","padding-left":"0","padding-right":"0"},attrs:{"column":"","align-center":"","justify-center":""}},[_c('h3',[_vm._v("Recuperação de senha:")]),_vm._v(" "),_c('v-form',{ref:"form",staticStyle:{"width":"60%","margin":"0 auto"},attrs:{"id":"formLogin"},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.forgotForm),callback:function ($$v) {_vm.forgotForm=$$v},expression:"forgotForm"}},[_c('v-text-field',{staticClass:"email",staticStyle:{"padding":"20px 0","color":"white!important"},attrs:{"validate-on-blur":"","rules":_vm.emailRules,"label":"E-mail da conta:","type":"text","dark":"","color":"white","clearable":"","placeholder":" ","required":""},model:{value:(_vm.forgotEmail.email),callback:function ($$v) {_vm.$set(_vm.forgotEmail, "email", $$v)},expression:"forgotEmail.email"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"panel_btn_actions",attrs:{"row":"","justify-center":""}},[_c('v-btn',{on:{"click":function($event){_vm.forgotMenu = !_vm.forgotMenu}}},[_vm._v("\n                Voltar\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"btnCadastrar",attrs:{"color":"warning_custom"},nativeOn:{"click":function($event){return _vm.recover()}}},[_vm._v("Recuperar senha")])],1)],1)])],1)])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"id":"acesso-bloqueado-contato","max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.openDialog = false}},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Acesso bloqueado")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openDialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('small',[_vm._v("\n              Sua conta está com o acesso bloqueado, entre em\n              "),_c('strong',[_vm._v("contato")]),_vm._v("\n              para mais informações:\n              "),_c('div',[_c('strong',[_vm._v("E-mail:")]),_vm._v("contato@motorfiscal.com.br\n                "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Tel.:")]),_vm._v(" 11 4306 3036\n              ")]),_vm._v(" "),_c('div',[_vm._v("Agradecemos a compreensão!")])])])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folders"},[(!_vm.node.file)?_c('v-icon',[_vm._v("\n    "+_vm._s(this.open ? 'mdi-folder-open' : 'mdi-folder')+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFile_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec18682a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFile_vue__ = __webpack_require__(768);
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec18682a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec18682a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v("Upload de arquivo - "+_vm._s(_vm.component.text))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('span',{staticClass:"inputFile"},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"file-upload"},on:{"click":function($event){return _vm.resetInfos()}}},[_c('v-icon',[_vm._v("mdi-file")]),_vm._v("\n                            "+_vm._s(_vm.path ? _vm.path : 'Selecione um arquivo')+"\n                        ")],1),_vm._v(" "),_c('small',[_vm._v("\n                            "+_vm._s(_vm.fileText)+"\n                            "),_c('span',{staticClass:"teal_bold"},[_vm._v(_vm._s(_vm.path))])]),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"file-upload","value":"file","id":"file-upload"},on:{"change":function($event){return _vm.setFile($event)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}}),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.handleUpload($event)}}},[_vm._v("Upload")])],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"uploadBtn",on:{"click":_vm.resetInfos}},[_vm._v("\n        Upload Arquivo\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-header"},[_c('v-card',{staticClass:"cardDocs"},[_c('v-card-title',[_c('h1',{staticClass:"titleTable"},[_vm._v(_vm._s(_vm.component.text.length > 0 ? _vm.component.text : ''))])]),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialogPDF = false}},model:{value:(_vm.dialogPDF),callback:function ($$v) {_vm.dialogPDF=$$v},expression:"dialogPDF"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue",staticStyle:{"color":"white"},attrs:{"text-color":"white"}},[_vm._v("\n              "+_vm._s(_vm.iptuName)+"\n              "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogPDF = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"tst"}},[_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"src":'data:application/pdf;base64,'+encodeURIComponent(this.danfe),"frameborder":"0"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialogPDF = false}}},[_vm._v("\n                  Fechar\n              ")])],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"fileManager"}},[_c('div',{staticClass:"treeFolders",attrs:{"id":"treeview"}},[_c('v-treeview',{attrs:{"open":_vm.open,"activatable":"","active":_vm.active,"items":this.root,"item-text":"nome","item-key":"idPasta","open-on-click":"","transition":"","id":"treeview-id"},on:{"update:open":function($event){_vm.open=$event}},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
var open = ref.open;
return [(!item.file)?_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("\n                    "+_vm._s(open ? 'mdi-folder-open' : 'mdi-folder')+"\n                  ")]):_vm._e()]}},{key:"append",fn:function(ref){
var item = ref.item;
var open = ref.open;
return [_vm._v("\n                "+_vm._s(open || item.root ? _vm.handleOpenFolder(item, open) : _vm.handleCloseFolder(item, open))+"\n              ")]}}]),model:{value:(_vm.selectedPasta),callback:function ($$v) {_vm.selectedPasta=$$v},expression:"selectedPasta"}})],1),_vm._v(" "),_c('div',{staticClass:"treeFiles"},[(this.lastExpandedFolder.name)?_c('v-card',[_c('v-card',{staticClass:"filesMenu"},[_c('div',{staticClass:"breadcrumbs"},_vm._l((this.bread),function(folder){return _c('div',{key:folder.id},[_c('span',{class:[ _vm.bread[_vm.bread.length -1] !== folder ? ' notCurrentFolder breadcrumbsItem' : 'breadcrumbsItem' ],attrs:{"id":folder.id},on:{"click":function($event){return _vm.handleBreadcrumbs($event)}}},[_vm._v(" "+_vm._s(folder.text)+" ")]),_vm._v(" "),_c('span',{staticClass:"breadcrumbsSeparator"},[_vm._v(" / ")])])}),0)]),_vm._v(" "),_c('v-card-title',{staticClass:"documentsTableTitle"},[_c('v-text-field',{staticClass:"fileSearchField ",attrs:{"label":"Pesquisar","append-icon":"search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"docsFederalTable elevation-1",attrs:{"headers":_vm.headers,"items":_vm.fileItems,"search":_vm.search,"next":_vm.$vuetify.icons.next,"loading":false,"rows-per-page-items":_vm.pagination.rowsPerPageItems,"pagination":_vm.pagination,"id":"table","prev-icon":"","next-icon":"","item-key":"idDocumento","rows-per-page-text":"Arquivos por página:"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_c('v-icon',{attrs:{"color":"white","small":""}},[_vm._v("arrow_upward")]),_vm._v("\n                "+_vm._s(header.text)+"\n              ")],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',{staticClass:"tdCheckbox",attrs:{"active":props.selected},on:{"click":function($event){props.selected = !props.selected}}},[_c('td',{staticStyle:{"padding":"0 4px"}},[_c('div',{staticClass:"actionsDisplay"},[_c('div',{staticStyle:{"display":"inline-block"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({class:[_vm.disableButton(props.item.nome) ? '' : 'btnDisabled'],staticStyle:{"margin":"0","color":"grey"},attrs:{"icon":"","disabled":!_vm.disableButton(props.item.nome)}},on),[_c('v-icon',{class:[_vm.disableButton(props.item.path) ? 'editIcon' : 'editIcon c_disabled'],staticStyle:{"font-size":"16px"},attrs:{"small":"","aria-hidden":"true"},on:{"click":function($event){return _vm.getDanfe(props.item.idImovel, props.item.idDocumento, props.item.nome)}}},[_vm._v("remove_red_eye")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Visualizar documento")])])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('a',{attrs:{"id":"dLinkPdf"}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"margin-left":"-5px"},attrs:{"slot":"activator","color":"light-blue darken-4","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.setDanfe(props.item.idImovel, props.item.idDocumento, props.item.nome)}},slot:"activator"},[_c('svg',{staticClass:"customIcon i_action",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M14,9H19.5L14,3.5V9M7,2H15L21,8V20A2,2 0 0,1 19,22H7C5.89,22 5,21.1 5,20V4A2,2 0 0,1 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n                            Baixar documento\n                          ")])],1)],1)])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.dataIni))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.dataMod))])])]}},{key:"pageText",fn:function(props){return [_c('strong',[_vm._v("\n                  Exibindo "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" do total de "+_vm._s(_vm.quantity)+"\n                  "),_c('span',[_vm._v(_vm._s(_vm.quantity === 1 ? 'Arquivo' : 'Arquivos'))])]),_vm._v(".\n              ")]}}],null,false,882245468)},[_c('template',{slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"color":"indigo darken-4","icon":"info","outline":""}},[_c('article',[_c('strong',[_vm._v("O diretório não possui arquivos.")])])])],1),_vm._v(" "),_c('v-progress-linear',{staticStyle:{"z-index":"3"},attrs:{"slot":"progress","color":"teal","height":"20","indeterminate":""},slot:"progress"}),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("Sua pesquisa por \""+_vm._s(_vm.search)+"\" não tem resultados.")])],2),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-2 btn_pages",attrs:{"id":"pagination_button"}},[_c('v-pagination',{attrs:{"color":"teal","length":this.fileList ? _vm.paginationNumber : 1},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}})],1)],1):(this.root.length == 0)?_c('v-card',[_c('span',{staticStyle:{"color":"red"}},[_vm._v("Não foi encontrado nenhum diretório")])]):_c('v-card',[_c('span',[_vm._v("Por favor selecione um diretório")])])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.component.name != '')?_c('div',{attrs:{"id":'dataTable_'+_vm.component.name}},[(_vm.component.name !== 'automacaoFiscal')?_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}})],1)],1):_vm._e(),_vm._v(" "),(_vm.component.name !== 'automacaoFiscal')?_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}})],1)],1):_vm._e(),_vm._v(" "),(_vm.component.name.indexOf('NFe') != -1)?_c('div',{staticClass:"v-card__text"},[(_vm.component.name.indexOf('NFe') != -1)?_c('v-tabs',{attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItem),callback:function ($$v) {_vm.currentItem=$$v},expression:"currentItem"}},[_vm._l((_vm.tabs),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItem ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('v-tab-item',[(this.currentItem == 0)?_c('div',{attrs:{"flat":""}},[_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}})],1):_vm._e()]),_vm._v(" "),_c('v-tab-item',[(this.currentItem == 1)?_c('div',[_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}})],1):_vm._e()]),_vm._v(" "),_c('v-tab-item',[(this.currentItem == 2)?_c('div',[_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}})],1):_vm._e()])],2):_vm._e()],1):_vm._e(),_vm._v(" "),(this.component.name == 'clientes')?_c('div',{staticClass:"v-card__text",staticStyle:{"width":"90%","margin":"auto"}},[(this.component.name == 'clientes')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.component.name == 'fornecedores'),expression:"this.component.name == 'fornecedores'"}],staticClass:"v-card__text",staticStyle:{"width":"90%","margin":"auto"}},[(this.component.name == 'fornecedores')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1),_vm._v(" "),(this.component.name == 'produtos')?_c('div',{staticClass:"v-card__text"},[_c('v-tabs',{attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItemProduto),callback:function ($$v) {_vm.currentItemProduto=$$v},expression:"currentItemProduto"}},[_vm._l((_vm.tabsProduto),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItemProduto ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('v-tab-item',[(this.currentItemProduto == 0)?_c('div',[(this.component.name == 'produtos')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('v-tab-item',[(this.currentItemProduto == 1)?_c('div',[(this.component.name == 'produtos')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e()])],2)],1):_vm._e(),_vm._v(" "),(this.component.name == 'Iptu')?_c('div',{staticClass:"v-card__text"},[_c('v-tabs',{attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItemIptu),callback:function ($$v) {_vm.currentItemIptu=$$v},expression:"currentItemIptu"}},[_vm._l((_vm.tabsIptu),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItemIptu ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('v-tab-item',[(this.currentItemIptu == 0)?_c('div',[(this.component.name == 'Iptu')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('v-tab-item',[(this.currentItemProduto == 1)?_c('div',[(this.component.name == 'Iptu')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e()])],2)],1):_vm._e(),_vm._v(" "),(this.component.name == 'NFSE')?_c('div',{staticClass:"v-card__text"},[_c('v-tabs',{attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItemNFSE),callback:function ($$v) {_vm.currentItemNFSE=$$v},expression:"currentItemNFSE"}},_vm._l((_vm.tabsNFSE),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItemNFSE ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.currentItemNFSE),callback:function ($$v) {_vm.currentItemNFSE=$$v},expression:"currentItemNFSE"}},[_c('v-tab-item',[(this.currentItemNFSE == 0)?_c('div',{attrs:{"flat":""}},[(this.component.name == 'NFSE')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('v-tab-item',[(this.currentItemNFSE == 1)?_c('div',{attrs:{"flat":""}},[(this.component.name == 'NFSE')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e()])],1)],1):_vm._e(),_vm._v(" "),(this.component.name == 'CTE')?_c('div',{staticClass:"v-card__text"},[_c('v-tabs',{attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItemCTE),callback:function ($$v) {_vm.currentItemCTE=$$v},expression:"currentItemCTE"}},_vm._l((_vm.tabsCTE),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItemCTE? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.currentItemCTE),callback:function ($$v) {_vm.currentItemCTE=$$v},expression:"currentItemCTE"}},[_c('v-tab-item',[(_vm.currentItemCTE == 0)?_c('div',[(this.component.name == 'CTE')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('v-tab-item',[(_vm.currentItemCTE == 1)?_c('div',[(this.component.name == 'CTE')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)}}}):_vm._e()],1):_vm._e()])],1)],1):_vm._e(),_vm._v(" "),(this.component.name == 'docsMunicipal')?_c('div',{staticClass:"v-card__text"},[_c('v-tabs',{staticStyle:{"font-size":"0.9em"},attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItemDM),callback:function ($$v) {_vm.currentItemDM=$$v},expression:"currentItemDM"}},[_vm._l((_vm.tabsDocsMunicipal),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItem ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('v-tab-item',[(this.currentItemDM == 0)?_c('v-card',[_c('DocsFederal',{attrs:{"conta":this.conta,"empresa":this.empresa,"alert":this.alert,"IBGE":this.IBGE,"component":this.component}})],1):_vm._e()],1)],2)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"background":"red"},attrs:{"id":"tableEmpresa"}},[(this.component.name == 'empresa')?_c('div',[(this.component.name == 'empresa')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"attTable":this.attTable,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"emitEditEmp":function($event){return _vm.emitEditEmp($event)},"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)},"emitAttTable":function($event){return _vm.emitAttTable($event)}}}):_vm._e()],1):_vm._e()]),_vm._v(" "),(this.component.name == 'automacaoFiscal')?_c('CommonTable',{attrs:{"conta":this.conta,"alert":this.alert,"attTable":this.attTable,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"emitEditEmp":function($event){return _vm.emitEditEmp($event)},"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)},"emitAttTable":function($event){return _vm.emitAttTable($event)}}}):_vm._e(),_vm._v(" "),(this.component.name == 'certificado')?_c('CommonTable',{attrs:{"conta":this.conta,"attTable":this.attTable,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"attTableEmp":function($event){return _vm.attTableEmp($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)},"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)},"emitAttTable":function($event){return _vm.emitAttTable($event)}}}):_vm._e(),_vm._v(" "),(this.component.name == 'usuario')?_c('CommonTable',{attrs:{"conta":this.conta,"attTableEmp":this.attTableEmp,"alert":this.alert,"arrayItems":this.arrayItems,"attTable":this.attTable,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"attTableEmp":function($event){return _vm.attTableEmp($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)},"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)},"emitAttTable":function($event){return _vm.emitAttTable($event)}}}):_vm._e(),_vm._v(" "),(this.component.name == 'conta')?_c('CommonTable',{attrs:{"conta":this.conta,"attTable":this.attTable,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"attTableEmp":function($event){return _vm.attTableEmp($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)},"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)},"emitAttTable":function($event){return _vm.emitAttTable($event)}}}):_vm._e(),_vm._v(" "),(this.component.name == 'rela_usuario')?_c('CommonTable',{attrs:{"conta":this.conta,"attTable":this.attTable,"alert":this.alert,"logConsulta":this.logConsulta,"logQtd":this.logQtd,"component":this.component,"empresa":this.empresa,"IBGE":this.IBGE},on:{"attTableEmp":function($event){return _vm.attTableEmp($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)},"getNewEmp":function($event){return _vm.getNewEmp($event)},"attLogConsulta":function($event){return _vm.attLogConsulta($event)},"emitAttTable":function($event){return _vm.emitAttTable($event)}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"consultaNotas"}},[(this.$router.history.current.path == '/docsFederal' || this.$router.history.current.path == '/docsMunicipal')?_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('v-icon',{staticStyle:{"margin-left":"87px"},attrs:{"color":"white"}},[_vm._v("mdi-folder-open")]),_vm._v(" "),_vm._v("\n            "+_vm._s(this.$router.history.current.path == '/docsFederal' ? 'Documentos Federais' : 'Documentos Municipais')+"\n            "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.empresa._id)?_c('v-icon',{staticClass:"mr-2 ml-2 loading fechamento_loop"},[_vm._v("loop")]):_vm._e()],1)],1)])],1)],1):_vm._e(),_vm._v(" "),(this.empresa == '' || this.empresa == undefined)?_c('article',{staticClass:"text-xs-center",staticStyle:{"margin":"38px 2px 20px -100px"}},[_c('svg',{staticClass:"custom_anime",staticStyle:{"width":"55px","height":"45px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill":"white"},attrs:{"d":"M14,3V13L17.2,11.31L17.42,11.28C17.71,11.28 17.97,11.4 18.16,11.6L18.9,12.37L14,16.57C13.74,16.84 13.39,17 13,17H6.5C5.73,17 5,16.3 5,15.5V11.14C5,10.53 5.35,10 5.85,9.8L10.79,7.6L12,7.47V3A1,1 0 0,1 13,2A1,1 0 0,1 14,3M5,19H13V22H5V19Z"}})])]):_c('RenderTableNFe',{attrs:{"empresa":this.empresa,"conta":this.conta,"alert":this.alert,"IBGE":this.IBGE},on:{"getNewEmp":function($event){return _vm.getNewEmp($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashBoard_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9be2ce82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashBoard_vue__ = __webpack_require__(784);
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9be2ce82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9be2ce82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapBrasil_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b68b932_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapBrasil_vue__ = __webpack_require__(776);
function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b68b932"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapBrasil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b68b932_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapBrasil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{attrs:{"version":"1.1","id":"svg-map","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"450px","height":"460px","viewBox":"0 0 450 460","enable-background":"new 0 0 450 460","xml:space":"preserve"}},[_c('g',[_c('a',{staticClass:"estado",attrs:{"xlink:href":"#tocantins","name":"Tocantins","code":"17"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M289.558,235.641\n        c16.104,0.575,44.973-31.647,44.835-45.259c-0.136-13.612-17.227-58.446-22.349-66.088c-5.122-7.628-37.905,2.506-37.905,2.506\n        S234.852,233.695,289.558,235.641z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 287.0137 188.3208)","fill":"#FFFFFF"}},[_vm._v("TO")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#bahia","name":"Bahia","code":"29"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M313.276,197.775\n        c2.084-2.739,3.506-7.012,6.464-8.764c1.641-0.973,3.232-4.684,4.271-5.163c2.304-1.014,12.161-25.143,20.706-22.513\n        c1.095,0.342,29.881,3.478,32.153,7.532c2.246-0.506,17.582-8.804,25.829-4.999c9.172,4.246,11.225,20.679,11.2,20.843\n        c0.107,0.328-0.823,5.765-0.985,5.929c-1.15,1-5.258-0.807-4.22,2.138c1.317,3.751,5.094,10.583,9.97,6.613\n        c-3.669,6.574-6.846,16.022-13.966,17.747c-5.808,1.411-4.605,13.421-5.178,18.037c-0.465,3.75,0.192,8.448,1.014,12.117\n        c1.148,4.959-0.821,8.6-1.808,13.42c-0.822,4.162-0.219,8.299-0.987,12.297c-0.271,1.286-4.407,5.723-5.559,7.148\n        c-1.616-1.426-63.952-37.248-73.1-36.265c1.149-3.738,2.438-9.559-0.741-12.723c-8.625-8.572-0.135-19.335-0.162-19.432\n        c-0.546-1.725-5.396-6.079-0.026-7.175c-3.175,0.959-1.944-4.027,0.875-3.012C316.726,200.733,314.044,200.527,313.276,197.775z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 359.7324 210.1221)","fill":"#FFFFFF"}},[_vm._v("BA")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#sergipe","name":"Sergipe","code":"28"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M408.561,191.735\n        c0.521-1.505,2.465-0.725,3.533-0.794c2.273-0.164,0.494-2.738,1.095-3.778c2.026-3.793-2.738-5.999-1.998-10.408\n        c4.024,1.931,9.448,3.397,12.408,6.89c1.343,1.533,5.504,2.656,5.832,4.847c-6.822,0.384-6.901,8.819-11.942,11.572\n        C413.545,202.212,407.055,193.721,408.561,191.735z"}}),_vm._v(" "),_c('path',{staticClass:"circle",attrs:{"d":"M417.324,182.854c6.214,0,11.266,5.035,11.266,11.262c0,6.208-5.052,11.261-11.266,11.261\n        c-6.238,0-11.258-5.053-11.258-11.261C406.063,187.89,411.084,182.854,417.324,182.854z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 408.9121 198.6689)","fill":"#FFFFFF"}},[_vm._v("SE")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#pernambuco","name":"Pernambuco","code":"26"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M373.011,167.238\n        c2.709-0.795,6.218-14.106,8.325-15.106c4.136-1.986,17.255-1.437,17.8,4.903c-0.437-0.068,8.189-2.273,7.479-1.466\n        c1.7-0.711,10.518-4.723,12.599-4.82c0.274-0.013,4.603,0.905,3.068,2.315c-0.464,0.439,4.219,3.698,10.789,3.45\n        c4.66-0.176,5.179-3.436,8.627-4.409c5.89-1.67,4.737,3.698,5.589,6.943c-1.182,2.684-1.646,5.586-2.74,8.285\n        c-1.533,3.792-9.804,9.791-13.39,12.119c-7.287,4.778-21.802-4.067-22.762-5.67c-0.602-0.985-2.55-5.121-3.178-5.107\n        c-0.629,0.356-1.04,0.861-1.287,1.519c-0.904-0.013-7.256-3.533-7.502-4.655c-4.769-1.151-5.425,6.108-8.957,6.19\n        c0.219,0.108-8.244,6.681-7.506,3.314C383.556,170.4,374.241,168.566,373.011,167.238z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 401.3984 165.8003)","fill":"#FFFFFF"}},[_vm._v("PE")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#alagoas","name":"Alagoas","code":"27"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M413.953,169.018\n        c3.78,3.313,9.424,5.505,12.547,5.491c3.229-0.013,5.009-3.328,7.421-4.794c1.177-0.712,10.297-1.93,9.174,1.042\n        c-1.807,4.848-7.122,8.585-10.024,12.789c-2.792,2-3.423,7.093-6.354,1.864c-3.259,0.424-3.722-4.424-6.957-4.477\n        c-3.668-2.261-7.998-3.769-11.201-6.342C410.615,172.646,412.751,171.359,413.953,169.018z"}}),_vm._v(" "),_c('path',{staticClass:"circle",attrs:{"d":"M436.423,168.763c6.236,0,11.258,5.054,11.258,11.278c0,6.207-5.02,11.259-11.258,11.259\n        c-6.241,0-11.263-5.052-11.263-11.259C425.16,173.816,430.182,168.763,436.423,168.763z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 429.7891 183.895)","fill":"#FFFFFF"}},[_vm._v("AL")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#riograndedonorte","name":"Rio Grande do Norte","code":"24"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M404.698,138.795\n        c2.383-4.027,6.574-6.123,8.49-11.149c1.973-5.107,3.834-5.818,8.764-4.642c5.041,1.207,9.339,0.837,14.57,1.671\n        c7.534,1.193,6.848,10.968,9.206,16.516c-1.919,1.096-13.972,0.521-15.064-1.657c-1.041-2.067-2.904,7.107-5.094,7.3\n        c1.532-5.847-12.654,1.78-5.424-8.683c2.545-3.67-6.302-0.808-6.711,0.725C410.121,144.013,407.217,139.151,404.698,138.795z"}}),_vm._v(" "),_c('path',{staticClass:"circle",attrs:{"d":"M430.827,107.798c6.241,0,11.261,5.039,11.261,11.261c0,6.224-5.02,11.261-11.261,11.261\n        c-6.209,0-11.26-5.037-11.26-11.261C419.567,112.837,424.618,107.798,430.827,107.798z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 422.541 123.9009)","fill":"#FFFFFF"}},[_vm._v("RN")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#ceara","name":"Ceará","code":"23"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M372.379,104.409\n        c0.437-1.368,2.961-3.627,1.043-5.025c12.106-1.328,17.581-0.849,27.66,6.723c4.026,3.054,6.822,5.574,10.571,9.147\n        c1.317,1.273,7.614,4.313,7.914,6.164c-0.054-0.316-5.396,3.696-5.997,5.217c-1.066,2.684-2.659,6.093-4.3,8.298\n        c0.025-0.055-6.903,3.957-3.532,4.217c-4.41,3.821-1.015,8.135-0.797,11.517c0.196,2.767-4.38,7.587-6.765,5.422\n        c-2.244-1.999-3.998-5.711-7.779-5.094c-1.998,0.329-5.476,2.189-7.612,0.479c-2.52-2.054,3.669-5.162-0.545-7.354\n        c-6.987-3.615-1.264-15.393-6.684-20.239c-3.504-3.136,1.753-7.313,0.109-10.749C374.952,111.68,373.694,105.244,372.379,104.409\n        C373.035,102.314,374.815,105.971,372.379,104.409z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 386.8379 129.0347)","fill":"#FFFFFF"}},[_vm._v("CE")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#piaui","name":"Piauí","code":"22"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M320.781,185.478\n        c2.465-5.149-7.505-20.801-7.505-20.801s47.354-65.868,54.285-66.841c0.299-0.042,6.243,1.768,6.463,2.219\n        c0.438,0.863-0.821,5.244-0.685,6.587c0.275,2.629,2.879,6.587,2.328,8.684c-1.15,4.736-1.863,6.134,1.369,9.901\n        c2.794,3.245,0.325,10.16,2.544,14.269c-1.778,4.23,4.768,3.656,3.943,7.613c-0.655,3.163-5.424,7.655-1.176,10.312\n        c0.274,4.642-4.685,4.983-6.79,7.818c-2.631,2.835-5.535,5.013-7.999,7.888c-0.55,0.671-8.821,4.096-9.998,4.082\n        c0.302-0.301-17.665-6.449-11.967,2.354c2.463,3.808-1.505,5.56-3.177,8.778c-0.633,2.164-5.836,0.958-7.836,3.205\n        C328.176,198.748,327.409,180.727,320.781,185.478z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 355.127 158.1045)","fill":"#FFFFFF"}},[_vm._v("PI")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#maranhao","name":"Maranhão","code":"21"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M288.845,127.827\n        c4.108-2.726,31.195-48.985,31.386-50.395c1.235,0.397,6.084,7.435,7.562,5.025c0.493,0.013-0.328,2.15-0.547,2.396\n        c-0.054-0.135,2.189-2.286,2.52-2.436c0.521-0.233,1.948,1.903,3.451-0.726c5.642,1.575,1.314,14.31,9.121,11.694\n        c-1.147,0.384,1.452,0.74,0.848,1.905c5.095-6.587,8.488-0.027,15.337,1.491c2.025,0.466,6.243,0.575,8.162,0.207\n        c3.808-0.823-2.082,6.847-2.082,6.887c-1.369,2.986-5.041,1.713-6.818,5.683c-0.684,1.549-3.506,4.327-3.042,6.148\n        c0.494,1.781,2.081,2.863,0.274,4.629c0.603,2.793,3.066,7.109-0.385,9.12c-4.601,4.383,2.304,7.52,1.316,11.598\n        c-0.9,3.726-6.244,5.725-9.147,2.78c-4.847-0.11-6.872,3.821-10.406,6.45c-2.74,2.041-8.793,2.493-10.327,5.642\n        c-1.918,3.929-3.699,8.763-5.341,12.79c-1.699,4.204,6.383,18.762-4.328,15.611c-0.932-0.273-3.396-4.725-3.396-5.738\n        c-0.081-3.739-2.738-4.176-4.821-7.477c0.356-3.025,2.466-6.929,4.766-8.052c3.342-1.63,1.919-6.629-2.466-4.465\n        c-3.505,1.726-4.709-2.794-6.958-5.287c0.548,0.59-3.064-4.696-3.146-3.697c0.19-1.89,2.876-5.833,3.341-8.448\n        c0.575-3.259,0.52-6.764-0.521-10.105c-0.63-2.068-4.656-4.521-6.518-4.437c-1.289,0.287-2.443,0-3.427-0.878\n        C290.983,125.675,290.983,128.044,288.845,127.827z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 318.2754 126.7036)","fill":"#FFFFFF"}},[_vm._v("MA")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#amapa","name":"Amapá","code":"16"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M225.198,39.089\n        c3.274,1.165,3.985-1.315,6.572-1.74c3.616-0.603,5.683,2.725,9.037,2.067c4.055-0.78,7.093-8.025,7.314-11.598\n        c4.492-3.534,5.503-11.258,9.42-14.68c6.055,4.258,6.11,15.788,7.589,22.485c-0.164,0.083,6.57,7.998,7.944,8.682\n        c3.396,1.657,3.366,6.203,0.078,9.34c-3.777,3.587-7.449,34.275-7.449,34.275h-46.489c0,0,0.932-50.366,0-51.449\n        C221.814,36.458,223.334,38.417,225.198,39.089z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 245.9023 52.6099)","fill":"#FFFFFF"}},[_vm._v("AP")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#para","name":"Pará","code":"15"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M173.378,50.619\n        c2.259,2.63,5.629-4.478,7.901-3.82c3.19,0.918,1.478-1.108,5.026-1.752c1.931,0.806,3.096,0.273,3.519-1.631\n        c0.535-1.26,1.453-1.726,2.725-1.384c1.768-1.684,13.558,3.603,14.68,0.384c0.629-1.821-4.287-5.709-0.302-6.997\n        c1.643-0.533,6.012,0.808,8.75-0.068c3.986-1.288,4.876,2.684,4.382,6.066c0.631,3.587,13.145,5.766,12.982,7.97\n        c3.589-1.518,5.354,12.763,7.105,14.447c0.357,4.26,6.304,8.585,7.07,12.544c0.628,3.396,7.065,3.616,8.213,0.095\n        c2.578-8.133,9.696-10.022,13.475-16.651c4.603-8.038,3.725,3.752,8.955,1.067c2.11,0.411,2.876,3.629,4.574,4.724\n        c3.18,2.027,7.779,0.974,10.572,3.013c-4.192,4.382,8.188,3.752,9.231,3.875c4.682,0.575,8.104,2.383,11.855,3.629\n        c-0.164-0.069,4.792,0.52,5.178,1.245c2.026,3.767-4.904,19.214-6.382,21.486c-1.121,1.713-2.932,4.985-3.727,6.834\n        c-0.902,2.026-4.764,7.313-4.655,9.229c-1.888,0.972-2.248,4.835-5.012,4.328c-3.096,3.026-8.187,4.999-10.27,8.956\n        c2.057,0.781,8.325,1.041,5.311,4.272c-0.821,0.877-1.094,5.533-1.615,6.833c-0.575,1.384-4.464,4.779-6.108,5.34\n        c-4.107,1.426-2.736,4.135-4.271,7.655c-0.933,2.054-0.546,3.491,1.756,4.339c-0.083,2.835-0.988,5.575-2.385,7.998\n        c-3.041,5.245-9.009,9.818-10.079,16.27c-3.261,3.408-87.066-1.22-87.464-2.644c-1.423-5.012,1.508-24.006-2.808-27.88\n        c-0.19-2.082-29.893-6.299-30.714-8.081C150.016,140.479,173.173,58.561,173.378,50.619z M319.139,77.664\n        C319.302,76.912,319.74,78.76,319.139,77.664z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 232.7725 122.5137)","fill":"#FFFFFF"}},[_vm._v("PA")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#roraima","name":"Roraima","code":"14"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M113.18,24.107\n        c-0.972-2.753-7.861-5.889-6.999-8.984c0.068-0.232,13.229,6.053,12.79,2.808c0.398,1.329,1.219,1.889,2.439,1.685\n        c1.889-1.301,7.148,4.204,8.216,1.889c0.438-0.959-1.657-3.753,0.74-3.848c1.026,0.438,1.534,0.164,1.52-0.822\n        c0.835-1.752,3.575,0.219,4.793,0.083c0.767-1.056,10.625-3.026,9.037-5.094c1.37,0.438,4.574,0.808,4.63-1.547\n        c4.546-2.054,1.15-4.409,2.644-6.354c2.177-2.82,9.791,0.809,7.327,5.738c-1.972,3.93,7.121,4.027,5.724,9.366\n        c-0.452,1.686-2.479,2.724-3.423,3.971c-1.179,1.546-1.836,9.243-1.356,11.53c1.041,4.889,3.231,8.695,6.134,12.16\n        c1.712,2.027,5.614,2.261,5.724,4.369c0.164,2.945,1.165,6.177,0.329,9.092c-1.547,5.424-36.618,30.471-36.618,30.471\n        s-12.517-52.736-20.335-54.063C115.261,36.417,111.523,25.682,113.18,24.107z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 136.2939 42.3862)","fill":"#FFFFFF"}},[_vm._v("RR")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"slot":"activator","xlink:href":"#amazonas","id":"AM","name":"Amazonas","code":"13"},slot:"activator"},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M10.078,136.412\n        c1.15-4.972,4.258-10.394,8.215-13.105c4.41-3.027,7.656-5.71,13.105-6.082c2.165-0.149,10.216-5.75,11.983-2.984\n        c3.711,5.765,4.998-3.739,5.574-7.025c1.726-9.667,3.697-19.322,4.86-29.086c-0.342-1.356-2.013-6.231-2.833-7.163\n        c-1.453-1.616-4.287-2.122-4.768-4.544c-0.272-1.452-0.574-7.258,1.109-8.121c3.494-1.768,6.547-0.042,9.737-0.89\n        c-2.561-4.053,0.302-4.327-5.532-5.135c-3.438-0.466-3.971-2.466-2.738-6.368c1.053-3.3,15.898-1,19.088-1.396\n        c-1.534,0.178-1.11-2.479-0.042-2.616c1.274-0.165,1.576,2.684,3.165,0.998c1.286-1.395,3.189-2.915,4.6-3.751\n        c2.438-1.45,4.533,8.217,4.465,9.833c-0.041,0.78-0.137,2.438,1.177,2.246c3.012-0.466,4.219,2.849,7.273,4.231\n        c3.778,1.713,3.929-1.355,7.023-2.068c4.301-0.985,0.711,3.396,2.383,3.793c1.589,0.385,3.806-4.969,4.821-5.572\n        c0.93-0.533,3.725-0.753,4.846-1.602c3.013-2.245,1.933-1.686,3.492-1.206c3.478,1.041,2.233-8.367,6.491-7.066\n        c1.822-0.466,3.643-2.34,5.533-2.423c1.041-0.043,6.066,2.287,6.544,3.147c0.589,1.465,0.316,2.795-0.793,3.986\n        c1.575,1.425,2.698,3.149,3.355,5.162c0.904,2.862-1.286,6.807,0.588,9.299c-0.22,6.655,4.808,7.887-0.396,12.597\n        c0.192-0.178,6.711,7.067,7.121,8.039c0.971-0.711,4.066,0.849,4.381,1.535c-1.658-3.629,0.547-17.09,6.628-10.915\n        c7.203,7.327,5.491-3.615,9.148-8.627c2.834-3.875,14.597-3.136,14.077,3.246c-1.082,3.273,6.271,14.256,9.667,11.436\n        c2.26,5.737,6.889,4.285,10.407,8.051c5.094,5.464,4.37,3.396,11.313,2.848c-2.259,3.602-3.425,4.808-5.272,8.86\n        c-3.149,6.862-6.15,13.776-9.204,20.678c-2.437,5.505-14.843,23.471-11.105,28.442c4.806,6.395,9.339,30.183,11.324,29.934\n        c-6.162-0.26-48.079-10.625-51.652-8.105c-1.453,1.013-53.626,10.503-55.9,10.819c-6.369,0.875-18.09-7.272-23.719-10.136\n        c-8.601-4.381-16.61-8.981-26.088-11.05c-10.282-2.259-20.635-4.793-29.878-10.011C4.121,145.766,12.433,144.779,10.078,136.412z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 98.1406 119.0591)","fill":"#FFFFFF"}},[_vm._v("AM")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"tag":"a","activator":'#AM',"top":""}},[_c('span',[_vm._v("eee")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#acre","name":"Acre","code":"12"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M3.656,148.545\n        c12.557,7.544,27.524,8.367,41.082,13.2c12.802,8.065,27.278,12.845,40.616,19.872c-2.834,1.205-7.587,4.382-9.983,6.395\n        c-2.93,2.45-1.3,2.04-4.628,1.957c-2.93-0.069-3.957,4.615-7.203,5.259c-2.999,0.603-7.161-1.958-10.995-1.697\n        c-1.905,0.136-11.969-0.056-12.64,0.603c0.313-3.642-0.385-7.299-0.165-10.941c0.096-1.439,1.998-6.533,1.245-7.451\n        c-6.82,3.149-8.339,7.19-16.733,7.013c-2.136-0.042-2.562-2.492-3.081-4.001c-1.247-3.572-7.218-3.422-10.559-3.778\n        c6.299-3.41-3.107-11.9-5.216-15.679c-0.52-0.918-3.588-4.655-3.629-5.957C1.642,150.174,6.612,151.968,3.656,148.545z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 47.7017 184.9355)","fill":"#FFFFFF"}},[_vm._v("AC")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#rondonia","name":"Rondônia","code":"11"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M83.34,180.232\n        c0.931-1.574,5.341-4.668,6.312-4.656c1.355-0.067,2.671,0.138,3.958,0.603c3.012,1.44,2.039-1.135,5.341-0.123\n        c-1.274-2.287,3.793-2.943,2.86-0.315c3.068,0.247,2.725-4.683,6.668-5.12c4.438-0.508,5.054-0.646,7.122-4.534\n        c0.135-0.246,2.628-5.519,2.752-5.025c2.191-6.491,14.585-0.878,15.638,3.355c0.397,1.615,1.834,3.137,3.642,4.369\n        c1.246,0.862,6.327-3.999,6.134,1.314c-0.78,1.274,26.663,7.656,30.005,19.282c3.82,13.338-16.421,32.167-18.173,34.043\n        c-4.464,1.191-2.039,1.726-6.6,0.15c-2.574-0.875-6.422,0.986-9.08,0.289c-2.409-0.645-3.041-3.957-5.86-4.683\n        c-3.055-0.78-5.423-1.795-7.654-3.93c-4.041-3.876-8.983-2.645-14.475-3.808c-1.835-0.083-6.053-6.779-7.874-5.327\n        c-1.821-0.438-5.381-9.094-3.397-11.204c0.124-1.67-0.26-3.204-1.163-4.627c-0.986-2.644,1.041-5.026,0.863-7.806\n        c-0.384-6.081-1.028-1.986-3.382-1.903C94.336,180.686,85.957,181.671,83.34,180.232z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 118.1299 195.3193)","fill":"#FFFFFF"}},[_vm._v("RO")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#matogrosso","name":"Mato Grosso","code":"51"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M142.237,173.962\n        c4-0.316-1.888-6.452,5-5.738c7.914,0.808,16.295,0.328,24.279,0.218c1.629-0.013,8.902,1.288,7.395-1.833\n        c-1.192-2.453,1.821-6.425,0.425-9.725c2.027-0.864,1.289-3.807,2.629-5.107c1.151-1.123,4.176,7.244,4.436,7.819\n        c1.097,2.451,0.398,5.478,1.932,7.654c1.41,1.987,4.574,2.136,5.889,4.259c3.136,5.136,10.845,4.137,17.13,4.657\n        c20.159,1.656,40.356,2.669,60.486,4.752c-3.48,7.763-3.999,14.912-5.122,22.552c-0.437,2.972,1.863,7.163-0.056,10.065\n        c1.945,1.287,1.346,2.753,1.424,4.409c1.151,25.129-20.429,60.186-33.548,58.569c-10.914-1.369-45.3,0.058-46.928-3.396\n        c-1.165-3.944-6.136-2.658-8.395-6.603c-2.301-4.051,0.684-6.299,0.737-10.242c-6.997,0.603-14.09-0.384-21.102-0.324\n        c0.793-5.016-3.725-9.288-2.929-13.809c0.519-3.025,2.726-2.916,0.932-6.79c-1.206-2.589-0.261-4.247-0.699-6.382\n        c-0.289-1.385-1.042-1.876-2.124-2.424c-2.931-1.493,1.246-2.48,2.056-3.644c1.726-2.465,3.299-11.394,6.545-11.612\n        c1.219-1.999-1.781-3.643-1.465-5.56c-3.902-3.588,0.506-4.643,0.369-7.984c-0.151-3.627-9.654-3.944-12.256-3.751\n        c-1.821,0.137-4.109,0.562-5.888-0.094c0.493-3.521-0.521-6.054-0.535-9.217c-0.014-2.286,1.288-5.177,0.835-7.45\n        C143.581,176.618,141.937,174.714,142.237,173.962z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 200.0244 218.4175)","fill":"#FFFFFF"}},[_vm._v("MT")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#mattogrossodosul","name":"Mato Grosso do Sul","code":"50"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M183.198,294.536\n        c2.136-4.464,3.177-9.394,5.312-13.61c1.712-3.344-4.067-7.587-2.423-9.807c0.027-0.026,2.738,3.641,3.917,3.725\n        c3.204-1.534,4.807-2.272,6.984-5.228c2.615-3.59,10.832-3.014,14.051-0.305c1.259,1.041,3.068,2.107,4.668,2.574\n        c3.163,0.934,5.889-3.013,8.559-0.873c3.724,2.982,4.626-1.862,7.86-3.509c1.945-1.012-1.768,8.465-2.244,7.781\n        c2.463,0.959,4.285,0.901,6.82,0.959c3.504,0.081,1.805,1.205,2.436,3.339c0.466,1.564,28.948-5.997,29.416,0.578\n        c0.302,3.837-0.987,61.813-0.987,61.813s-39.532,5.533-41.602,5.286c-3.889-0.492-3.587-3.231-8.063-0.933\n        c-2.028,0.329-6.012,1.205-5.177-2.409c-2.013-4.354-0.111-14.625-4.849-17.088c-1.206-0.659-7.092-2.36-7.504-1.945\n        c-1.699,1.777-3.739,1.562-6.121,1.121c-2.904,0.027-5.629-1.614-8.243-1.203c-4.178,0.656-0.603-2.986-1.645-3.535\n        c0.932-2.847,1.411-9.912,0.453-11.856c-0.165-0.331-3.52-7.232-2.547-8.108C186.306,297.688,182.334,299.415,183.198,294.536z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 213.2939 306.7236)","fill":"#FFFFFF"}},[_vm._v("MS")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#goias","name":"Goiás","code":"52"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M237.768,270.519\n        c0.628-2.904,1.835-7.396,4.709-8.766c1.015-1.644,1.754-5.147,2.275-5.586c2.408-2.247,3.889-3.783,6.63-4.656\n        c3.723-1.205,3.338-5.342,4.846-8.165c1.504-2.845,4.736-1.15,5.942-3.382c1.479-2.834,0.741-6.161,2.189-8.874\n        c2.902-5.531,1.862-17.363,8.656-20.567c-4.878,7.641,3.698,4.971,7.201,9.449c2.273,1.738,2.164-1.822,2.71-3.055\n        c1.618-3.533,2.878,2.247,4.52-1.533c0.413,0.37,4.136,5.765,3.427,5.601c-0.029-0.931,0.326-1.408,1.037-1.438\n        c0.108,0.534,0.274,1.013,0.602,1.452c-0.602-0.261,9.697-0.095,8.82,1.534c0.36-0.657-0.602-3.11,0.221-3.438\n        c1.039-0.411,3.971,1.368,6.351,0.438c1.045-0.397,7.889-2.807,7.671-3.683c0.767,0.905,1.262,2.67,2.85,1.286\n        c-2.632,2.274-2.576,4.466,1.258,3.821c-1.861,1.438-2.846,4.341-2.382,6.547c0.357,1.643,3.752,5.973,3.478,6.751\n        c-1.78,0.315,0.602,5.438-2.325,6.078c-3.181,0.701-3.973-5.53-4.3,0.688c-0.164,1.48-1.097,1.67-2.768,0.576\n        c-3.288,0.327-0.549,2.19-1.121,3.888c-0.988,2.902,2.792,6.437-2.411,6.764c-3.586,0.219-2.682,1.341-2.682-2.739\n        c-0.028-4.573-12.054-3.643-10.218,0.521c-4.901,6.355,12.05-0.326,9.668,6.355c-1.313,3.752,15.83,28.211,10.406,25.416\n        c-1.944-0.986-50.804,10.271-49.982,12.105c-5.012-2.136-11.804-7.941-17.391-8.162c-0.438-2.189-3.618-1.284-5.095-1.533\n        c-3.724-0.604,1.04-3.231,0.22-4.109c-1.89-1.916-4.382,1.756-3.588-3.012C239.602,274.627,237.055,273.038,237.768,270.519z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 266.9111 254.2139)","fill":"#FFFFFF"}},[_vm._v("GO")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#parana","name":"Paraná","code":"41"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M222.225,363.694\n        c1.807-2.138,1.889-4.881,2.424-7.479c0.301-1.453,0.465-7.86,1.369-8.736c2.3-0.684,2.3-3.315,2.726-5.204\n        c0.616-2.738,2.821-2.958,3.984-5.616c4.369-9.91,38.947-9.529,46.476-9.227c4.658,0.193,15.775,34.563,17.916,33.794\n        c-1.728,2.19-5.754,8.929-8.41,8.984c-4.054,0.057-14.215,14.68-14.215,14.68s-37.329-12.05-40.287-11.285\n        c-3.875-1.449-2.698-6.491-6.054-8.216C226.663,364.623,222.498,367.8,222.225,363.694z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 248.4453 356.1045)","fill":"#FFFFFF"}},[_vm._v("PR")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#santacatarina","name":"Santa Catarina","code":"42"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M231.029,383.959\n        c1.669-3.338-0.284-10.516,4.573-10.569c6.631-0.109,13.639,3.559,20.402,3.888c1.317,0.055,5.231,2.163,4.357-1.15\n        c-1.095-4.164,3.945-1.863,5.67-3.179c2.274-1.724,8.187-4.106,11.311-1.367c1.423,1.809,20.05-5.395,13.284,3.946\n        c-1.368,1.395,0.713,10.789,0.466,10.734c-3.449,4.438,1.726,11.666-5.096,15.334c-2.901,1.536-7.284,7.779-9.64,9.995\n        C276.085,411.866,233.534,382.918,231.029,383.959z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 266.9111 387.7646)","fill":"#FFFFFF"}},[_vm._v("SC")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#riograndedosul","name":"Rio Grande do Sul","code":"43"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M191.236,416.881\n        c0.52-2.684,7.38-8.409,9.477-10.351c0.37-0.359,8.599-10.08,9.174-8.329c-1.301-3.89,2.781-1.589,3.917-4.819\n        c0.26-0.521,7.04-4.821,7.109-4.795c1.436-0.191,6.721-3.695,7.421-3.257c1.204-2.028,8.927-1.479,8.653-0.824\n        c1.165-0.38,2.284-0.877,3.326-1.479c0.221-0.821,22.459,7.533,24.319,11.531c2.523,5.34,12.217,2.822,13.15,5.563\n        c0.106,0.275-5.809,9.339-3.89,9.173c-0.985,0.08,3.204-2.875,3.834,0.409c-2.793,3.619-4.6,7.834-6.571,11.944\n        c-3.696,7.614-8.872,12.765-15.886,17.42c-7.394,4.902-7.339,11.941-13.257,17.693c-8.091,7.942-10.159-0.574-4.08-5.752\n        c3.806-3.231-22.527-19.746-25.578-22.732c-1.918-1.862-2.384,0.274-4.219,1.15c-2.547,1.205-1.917-2.822-3.588-4.273\n        c-2.3-1.999-4.793-5.479-7.737-6.68c-3.478-1.367-5.615,5.145-9.052,0.821C189.168,418.854,190.332,418.032,191.236,416.881z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 231.0313 414.4658)","fill":"#FFFFFF"}},[_vm._v("RS")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#saopaulo","name":"São Paulo","saida":11,"entrada":22,"code":"35"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M239.3,330.554\n        c3.26-4.356,9.56-5.039,11.531-10.792c1.369-3.942,3.889-8.818,6.135-13.036c1.561-2.957,7.749-7.121,10.517-8.65\n        c0.383-0.196,32.974-6.138,42.234-1.701c20.265,9.724,26.017,33.879,27.854,33.304c4.408-1.425,5.34,3.778,2.106,4.49\n        c-1.754,0.413-6.519,1.479-6.49,3.399c0.027,3.448,0.521,1.615-2.931,3.639c-2.189-1.42-3.34,4.111-4.763,3.426\n        c-4.271-2.244-6.958,2.96-9.258,1.918c-4.271-1.918-16.98,13.092-19.638,15.336c0.245-0.218-1.148-1.479-1.587-2.685\n        c-0.466-1.369-2.658,0.385-4.025,0.082c-0.986-0.192,1.751-4.079-2.303-4.52c-1.369-0.164-3.753,0.303-4.929,0.084\n        c-2.903-0.547,0.108-2.41-0.439-3.862c-1.067-2.986-3.013-4.931-3.751-7.779c-0.52-1.945,0.165-7.531-3.615-7.395\n        c-0.848-2.956-6.628-1.451-9.066-1.862c-0.162,0.163-8.846-2.684-10.079-2.684c-1.616-0.029-6.791-3.396-7.121-0.274\n        C247.982,330.386,239.876,331.21,239.3,330.554z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 280.6816 327.3193)","fill":"#FFFFFF"}},[_vm._v("SP")]),_vm._v(" "),_c('circle',{attrs:{"cx":"309.6816","cy":"338.3193","r":"8","stroke":"black","stroke-width":"1","fill":"red"}}),_vm._v(" "),_c('text',{staticClass:"saida",attrs:{"transform":"matrix(1 0 0 1 302.6816 342.3193)","fill":"#FFFFFF"}},[_vm._v("11")]),_vm._v(" "),_c('circle',{attrs:{"cx":"291.6816","cy":"342.3193","r":"8","stroke":"black","stroke-width":"1","fill":"green"}}),_vm._v(" "),_c('text',{staticClass:"entrada",attrs:{"transform":"matrix(1 0 0 1 284.6816 347.3193)","fill":"#FFFFFF"}},[_vm._v("22")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#minasgerais","name":"Minas Gerais","code":"31"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M262.881,297.305\n        c-1.696-5.094,15.531-19.882,18.844-13.421c5.531-7.367,15.886,1.588,19.773-3.944c0.988-1.367,3.015-1.453,3.725-2.957\n        c0.326-0.711-0.493-2.793-0.056-3.888c1.369-3.398-4.873-2.355-0.109-6.603c4.547-4.053-1.917-4.739-1.204-8.186\n        c0.957-4.604,1.807-4.713,5.613-6.027c1.943-0.688,0.906-8.272,0.083-8.52c-0.108-2.699,1.974-2.546,3.782-1.617\n        c2.188-0.135-0.276-3.695,0.957-4.243c-0.357,0.151,5.559,1.999,5.724,2.055c0.986,0.358-0.52,3.534-0.931,3.943\n        c8.217-2.355,14.514-11.789,23.279-11.242c4.983,0.316-0.327,4.339,5.367,5.544c0.684,1.234,3.34-1.054,4.054-1.189\n        c2.876-0.536,5.53,3.284,8.106,3.886c2.302221,3.578,7.503,0.537,10.298,3.001c1.755,1.589,2.188,3.397,3.396,5.313\n        c1.314,2.052,3.86-0.465,5.726-0.109c3.257,0.656,6.326,2.026,9.338,3.723c2.19,1.205,0.768,3.179-0.548,4.573\n        c-0.765,0.796-3.259,6.165-2.627,5.643c-2.138,1.781-2.628-1.669-3.397,2.764c-0.628,3.674,0.164,4.714,3.149,7.015\n        c4.901,3.229-6.765,3.12-6.71,3.504c0.22,0.601-2.846,41.96-3.835,42.179c-6.737,1.562-14.513,5.311-21.744,7.012\n        c-12.736,2.985-24.295,3.778-29.471,4.656c0,1.452-5.367,6.872-8.518,1.259c0,0-3.041-7.285-2.821-7.229\n        c0.105-0.027,2.138-5.506,2.244-6.137c0.768-3.504-5.042-0.765-5.749-2.188c-0.878-1.81-2.358-4.576-2.166-6.628\n        c1.699-1.205,1.672-2.383-0.08-3.562c-1.04-1.095-1.205-2.303-0.521-3.672c-2.329-1.424-3.065-2.683-5.698-2.462\n        c-1.479,0.138-4.055,3.668-5.506,0.629c0.878,2.108-4.188,0.769-5.094,1.56c-2.354-1.202-1.779,2.028-2.384,3.069\n        c-0.137,0.22-1.014-2.904-1.065-2.961c-1.149-1.175-2.767,4.165-3.505-0.055c0.766-4.105-4.657-2.709-7.67-2.93\n        c-4.708-0.353-5.53-1.613-9.858,0.631C262.993,300.562,262.336,299.274,262.881,297.305z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 328.4063 286.4561)","fill":"#FFFFFF"}},[_vm._v("MG")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#riodejaneiro","name":"Rio de Janeiro","code":"33"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M332.886,337.429\n        c-1.26-2.768,8.409-4.795,7.89-6.71c-3.177-1.864-4.602,1.148-6.63-2.959c4.274-0.686,9.533-4.49,13.831-3.562\n        c0.548-0.219,4.902-1.753,4.96,0.167c2.546-1.566,5.479-2.412,8.105-3.837c2.246-1.206,0.932-8.218,3.725-9.643\n        c6.054-3.123,1.398,1.836,7.066,2.959c5.888,1.205,5.395,1.48,5.641,7.067c0.247,5.642-8.763,4.381-11.063,8.764\n        c-1.039,1.999,1.698,5.368-3.368,4.903c-4.188-0.413-10.628,2.355-9.285-3.18c-1.039-0.08-1.861,0.301-2.464,1.124\n        c0,0,0.105,2.767-0.74,2.741c-0.766-0.056-7.643,1.094-7.449,0.463c1.398-0.359,2.708-0.684,4.135-0.794\n        c-1.667-0.713-2.957-1.839-4.901-0.142c0.465,0.195-4.227-0.086-3.379-0.113c-0.521,1.727-3.814,0.699-3.879,3.045\n        C336.717,337.908,333.927,342.41,332.886,337.429z"}}),_vm._v(" "),_c('path',{staticClass:"circle",attrs:{"d":"M355.094,318.613c6.209,0,11.263,5.021,11.263,11.259c0,6.208-5.056,11.264-11.263,11.264\n        c-6.211,0-11.263-5.054-11.263-11.264C343.831,323.634,348.883,318.613,355.094,318.613z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 347.4648 334.6807)","fill":"#FFFFFF"}},[_vm._v("RJ")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#espiritosanto","name":"Espírito Santo","code":"32"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M367.119,308.834\n        c1.044-1.999-0.298-5.451,1.841-6.326c3.697-1.453,3.858-0.467,5.941-4.49c0.767-1.563,3.999-5.807,2.848-7.835\n        c-0.439-0.765-3.204-3.613-3.286-4.05c1.04-0.249,2.079-0.219,3.123,0.054c1.366-0.654-6.465-10.519,2.137-8.054\n        c-1.204-0.655-1.535-1.365-0.932-2.135c4.358-0.138,13.856,0.027,12.845,6.738c-0.577,3.835,0.933,8.079-0.577,11.804\n        c-0.218,0.576-5.861,8.954-5.831,8.954c0.985,3.289-5.18,5.808-6.054,8.165c-1.313,3.56-2.135,3.013-5.614,2.573\n        c-1.64-0.274-3.202-0.768-4.736-1.451C368.819,311.297,369.424,309.055,367.119,308.834z"}}),_vm._v(" "),_c('path',{staticClass:"circle",attrs:{"d":"M381.917,284.723c6.21,0,11.261,5.055,11.261,11.262c0,6.212-5.051,11.261-11.261,11.261\n        c-6.212,0-11.263-5.049-11.263-11.261C370.654,289.777,375.705,284.723,381.917,284.723z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 373.3047 300.4971)","fill":"#FFFFFF"}},[_vm._v("ES")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#distritofederal","name":"Distrito Federal","code":"53"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M292.461,246.197\n        c0,0,12.929-2.903,14.188,0c1.233,2.903,0.659,10.683-1.424,11.504c-2.08,0.849-14.296-1.806-14.023-3.313\n        C291.503,252.853,292.461,246.197,292.461,246.197z"}}),_vm._v(" "),_c('path',{staticClass:"circle",attrs:{"d":"M300.735,238.34c6.212,0,11.26,5.035,11.26,11.258c0,6.21-5.048,11.263-11.26,11.263\n        c-6.209,0-11.261-5.053-11.261-11.263C289.475,243.377,294.523,238.34,300.735,238.34z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 292.4141 254.2139)","fill":"#FFFFFF"}},[_vm._v("DF")])]),_vm._v(" "),_c('a',{staticClass:"estado",attrs:{"xlink:href":"#paraiba","name":"Paraíba","code":"25"}},[_c('path',{attrs:{"stroke":"#FFFFFF","stroke-width":"1.0404","stroke-linecap":"round","stroke-linejoin":"round","d":"M401.575,141.096\n        c2.081-3.081,16.791-6.82,19.117-4.616c0,1.918,7.259,1.686,10.133,2.712c-0.492,3.038,12.652,1.533,14.408,2.259\n        c1.421,0.589,3.833,11.983,1.421,12.202c-0.874-1.124-2.083-1.739-3.586-1.835c-2.957-0.027-2.546,1.863-4.383,3.108\n        c-2.626,1.767-6.571,1.917-9.558,2.109c-0.162,1.232-3.943,4.438-5.259,4.916c-3.122,1.149-2.657-2.727-5.095-3.602\n        c0.713-1.124,4.082-5.203,3.725-6.205c-1.423-3.846-12.051,5.52-14.981,3.506c-1.396-0.973-6.218,1.493-3.476-2.588\n        C405.574,150.776,400.398,142.889,401.575,141.096z"}}),_vm._v(" "),_c('path',{staticClass:"circle",attrs:{"d":"M433.797,133.597c6.237,0,11.26,5.051,11.26,11.261c0,6.226-5.022,11.262-11.26,11.262\n        c-6.208,0-11.257-5.036-11.257-11.262C422.54,138.647,427.589,133.597,433.797,133.597z"}}),_vm._v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 425.2129 148.9893)","fill":"#FFFFFF"}},[_vm._v("PB")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPie_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bcc9ad8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPie_vue__ = __webpack_require__(779);
function injectStyle (ssrContext) {
  __webpack_require__(778)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bcc9ad8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pie_card"},[_c('v-card-title',{staticClass:"title white--text",attrs:{"primary":""}},[_c('h3',{staticClass:"headline mb-0"},[_c('v-icon',{staticClass:"mb-1",attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")],1)]),_vm._v(" "),_c('v-card-text',{staticStyle:{"position":"relative"},attrs:{"primary-text":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm7":"","md7":""}},[_c('canvas',{staticStyle:{"margin-left":"-22px","margin-top":"-8px","position":"relative","z-index":"1"},attrs:{"id":this.customId,"width":"200","height":"150"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm5":"","md5":""}},[_c('ul',{staticClass:"menu_pie"},_vm._l((_vm.pieChart.data.labels),function(pieInfo,i){return _c('li',{key:pieInfo},[_c('span',{staticClass:"circle",style:({backgroundColor: _vm.pieChart.data.datasets[0].backgroundColor[i], border: ("1px solid " + (_vm.pieChart.data.datasets[0].borderColor[i]))})}),_vm._v(" "),_c('span',{staticClass:"label",attrs:{"title":pieInfo}},[_vm._v(_vm._s(pieInfo))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.pieChart.data.datasets[0].data[i]))])])}),0)])],1),_vm._v(" "),(_vm.showMsgNoData)?_c('h4',{staticStyle:{"color":"wheat"}},[_vm._v("\n      Sem Dados para "),_c('strong',[_vm._v("Análise")])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatBar_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b471c10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatBar_vue__ = __webpack_require__(782);
function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b471c10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:[this.showMsgNoData ? 'noData' : ''],staticStyle:{"background":"#3C454D!important","min-height":"200px"}},[_c('v-card-title',{staticClass:"title white--text",attrs:{"primary":""}},[_c('h3',{staticClass:"headline mb-0"},[_c('v-icon',{staticClass:"mb-1",attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")],1)]),_vm._v(" "),_c('v-card-text',{staticClass:"card_c",staticStyle:{"position":"relative"},attrs:{"primary-text":""}},[(!_vm.showMsgNoData)?_c('div',[_c('canvas',{staticStyle:{"width":"100%","heigth":"100%"},attrs:{"id":this.customId}})]):_vm._e(),_vm._v(" "),(_vm.showMsgNoData)?_c('h4',{staticStyle:{"color":"wheat"}},[_vm._v("\n      Sem Dados para "),_c('strong',[_vm._v("Análise")])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__ = __webpack_require__(12);







var NotificacoesServices = function (_CommonService) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NotificacoesServices, _CommonService);

    function NotificacoesServices(http) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NotificacoesServices);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotificacoesServices.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(NotificacoesServices)).call(this, http));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NotificacoesServices, [{
        key: "verificaTipo",
        value: function verificaTipo(tipo) {
            var urlTipo = "";
            switch (tipo) {
                case 'Entrada':
                    urlTipo = "_entrada=true";
                    break;
                case 'Saida':
                    urlTipo = "_saida=true";
                    break;
                default:
                    throw new Error("Necess\xE1rio informar um tipo [entrada,saida]: tipo informado inv\xE1lido ou nulo: " + tipo);
            }
            return urlTipo;
        }
    }, {
        key: "buscaPeriodo",
        value: function buscaPeriodo(cnpj, tipo, range) {
            var url = "dashboards/nfe/periodo/" + cnpj + "?" + this.verificaTipo(tipo) + "&_range=" + range;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "buscaTop5",
        value: function buscaTop5(cnpj, tipo, range) {
            var url = "dashboards/nfe/regiao/" + cnpj + "?" + this.verificaTipo(tipo) + "&_range=" + range;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "buscaVlrTotal",
        value: function buscaVlrTotal(cnpj, tipo, range) {
            var url = "dashboards/nfe/valor/" + cnpj + "?" + this.verificaTipo(tipo) + "&_range=" + range;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "buscaQntdCancelada",
        value: function buscaQntdCancelada(cnpj, tipo, range) {
            var url = "dashboards/nfe/cancelada/" + cnpj + "?" + this.verificaTipo(tipo) + "&_range=" + range;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }, {
        key: "qntNfeEmpresa",
        value: function qntNfeEmpresa(id, range) {
            var url = "nfes/qnts/" + id + "?_range=" + range;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }]);

    return NotificacoesServices;
}(__WEBPACK_IMPORTED_MODULE_5__domain_dataTable_commonService_CommonService_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NotificacoesServices);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.empresa == '' || this.empresa == undefined)?_c('article',{staticClass:"text-xs-center",staticStyle:{"margin":"38px 2px 20px -100px"}},[_c('svg',{staticClass:"custom_anime",staticStyle:{"width":"55px","height":"45px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill":"white"},attrs:{"d":"M14,3V13L17.2,11.31L17.42,11.28C17.71,11.28 17.97,11.4 18.16,11.6L18.9,12.37L14,16.57C13.74,16.84 13.39,17 13,17H6.5C5.73,17 5,16.3 5,15.5V11.14C5,10.53 5.35,10 5.85,9.8L10.79,7.6L12,7.47V3A1,1 0 0,1 13,2A1,1 0 0,1 14,3M5,19H13V22H5V19Z"}})])]):_c('article',{staticStyle:{"padding":"40px"}},[_c('fieldset',{staticClass:"c_before loading",staticStyle:{"padding":"0.35em 0.75em 0.625em","border":"4px solid #ffffffa6"}},[_c('legend',{staticStyle:{"padding":"0px 90px"},attrs:{"align":"center"}},[_c('div',{staticClass:"periodoBusca"},[_vm._v("Período de busca:")]),_vm._v(" "),_c('v-layout',{staticClass:"align-center justify-end row",attrs:{"row":"","wrap":""}},_vm._l((_vm.rangeButtons),function(item,i){return _c('v-flex',{key:i,staticClass:"rangeDate",attrs:{"xs6":"","sm2":"","md2":"","d-flex":""}},[_c('v-btn',{class:['d-inline-block' + ' btn_'+item.value, item.selected ? 'teal white--text' : 'v-btn--outline'],attrs:{"slot":"activator","color":"white","text-color":"white","dark":"","round":"","disabled":_vm.consultando},nativeOn:{"click":function($event){_vm.changeSelected(item.value), _vm.buscarComRange(item.value)}},slot:"activator"},[_c('small',[_vm._v(_vm._s(item.text))])])],1)}),1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.consultando),expression:"!consultando"}],staticClass:"align-center justify-center row",staticStyle:{"margin-bottom":"-28px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"reload",attrs:{"xs6":"","sm2":"","md2":""}},[_c('v-btn',{staticStyle:{"height":"16px!important","margin-left":"-11px"},attrs:{"slot":"activator","outline":"","color":"white","text-color":"white","dark":"","round":"","small":""},nativeOn:{"click":function($event){return _vm.refresh()}},slot:"activator"},[_c('small',[_vm._v("Recarregar")])])],1)],1)],1),_vm._v(" "),(_vm.activeProgress)?_c('v-progress-linear',{staticClass:"loading_dash_progress",staticStyle:{"margin":"0"},attrs:{"color":"red","indeterminate":true}}):_vm._e(),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":"","id":"firstRow"}},[_c('v-layout',{staticClass:"infos",staticStyle:{"margin-bottom":"31px"},attrs:{"row":"","wrap":""}},_vm._l((_vm.cards),function(card,i){return _c('v-flex',{key:card.id,attrs:{"d-flex":"","xs12":"","sm3":"","md3":""}},[_c('v-card',{staticClass:"cardTipos",class:card.cor},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(!_vm.changingEmp)?_c('v-flex',[_c('div',{staticClass:"c_title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),(!_vm.changingEmp)?_c('div',{staticClass:"values fadeInUp",attrs:{"id":("value" + i)}},[_vm._v(_vm._s(card.valor))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"analise"},[_vm._v(_vm._s(card.analise))]),_vm._v(" "),_c('img',{staticClass:"imagem",attrs:{"src":card.path,"alt":""}})]):_vm._e()],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[(!_vm.changingEmp)?_c('pieChart',{attrs:{"labels":this.pieSaidaLabels,"data":this.pieSaida,"backgroundColor":this.colorsSaida,"borderColor":this.colorsSaida,"customId":("pieChart2_" + (this.empresa._id)),"title":'NF-e de saída por região',"icon":'place'}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[(!_vm.changingEmp)?_c('pieChart',{attrs:{"labels":this.pieEntradaLabels,"data":this.pieEntrada,"backgroundColor":this.colorsEntrada,"borderColor":this.colorsEntrada,"customId":("pieChart1_" + (this.empresa._id)),"title":'NF-e de entrada por região',"icon":'place'}}):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('fieldset',{staticClass:"c_before loading",staticStyle:{"padding":"0.35em 0.75em 0.625em","border":"4px solid #ffffffa6","margin-top":"11px"}},[_c('legend',{staticStyle:{"padding":"0px 90px"},attrs:{"align":"center"}},[_c('div',{staticClass:"periodoBusca"},[_vm._v("Período de busca:")]),_vm._v(" "),_c('v-layout',{staticClass:"align-center justify-end row",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"color":"wheat"},attrs:{"xs6":"","sm12":"","md12":"","d-flex":""}},[_vm._v("\n            "+_vm._s(new Date(new Date().getFullYear() - 1, new Date().getMonth(), 1).toLocaleDateString())+"\n            -\n            "+_vm._s(new Date().toLocaleDateString())+"\n          ")])],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.consultando),expression:"!consultando"}],staticClass:"align-center justify-center row",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"reload",attrs:{"xs6":"","sm2":"","md2":""}},[_c('v-btn',{staticStyle:{"height":"16px !important","margin-left":"-50%","transform":"translateX(-20%)"},attrs:{"slot":"activator","outline":"","color":"white","text-color":"white","dark":"","round":"","small":""},nativeOn:{"click":function($event){return _vm.refresh()}},slot:"activator"},[_c('small',[_vm._v("Recarregar")])])],1)],1)],1),_vm._v(" "),(_vm.activeProgress)?_c('v-progress-linear',{staticClass:"loading_dash_progress",staticStyle:{"margin":"0","margin-top":"15px!important"},attrs:{"color":"red","indeterminate":true}}):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"13px"},attrs:{"d-flex":"","xs12":"","sm12":"","md12":""}},[(!_vm.changingEmp)?_c('barChart',{attrs:{"customId":'barChart1',"labels":this.bar1Labels,"data":this.bar1Data,"title":'Nota Fiscal eletrônica - Quantidade por mês',"icon":'file_copy'}}):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editar_perfil"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('svg',{staticStyle:{"width":"24px","height":"24px","margin-left":"87px","margin-bottom":"-4px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#fff","d":"M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"}})]),_vm._v("\n          Minha conta\n          "),(this.cadastro)?_c('span',[_vm._v("- Concluindo cadastro")]):_c('span',[_vm._v("- Editar informações do perfil")])])])],1)],1),_vm._v(" "),(this.cadastro)?_c('div',{staticStyle:{"position":"relative","left":"50%","transform":"translateX(-19%)","margin-bottom":"19px"}},[_c('img',{staticStyle:{"width":"40%","cursor":"pointer"},attrs:{"title":"Motor Fiscal","id":"logo-image","src":__webpack_require__(101),"alt":"Logo da Empresa(Motor Fiscal)"},on:{"click":function($event){return _vm.$router.push('/')}}})]):_vm._e(),_vm._v(" "),_c('v-tabs',{staticClass:"tabPerfil",attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItem),callback:function ($$v) {_vm.currentItem=$$v},expression:"currentItem"}},[_vm._l((_vm.tabs),function(item,i){return (_vm.cadastro && i != 2 || _vm.cadastro != true)?_c('v-tab',{key:i,class:[i == _vm.currentItem ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))]):_vm._e()}),_vm._v(" "),_c('v-tab-item',{on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.salvarDados()}}},[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.currentItem == 0),expression:"this.currentItem == 0"}],attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"cardPerfil"},[_c('div',{staticClass:"cardPerfil-title"},[_vm._v("Avatar para o seu perfil na Plataforma")]),_vm._v(" "),_c('div',{staticClass:"cardPerfil-body"},[_c('div',{staticClass:"cardPerfil-img"},[(_vm.avatarProfile != '')?_c('img',{attrs:{"id":"userLogo_ePerfil","src":_vm.avatarProfile,"alt":"Avatar de Perfil(Motor Fiscal)"}}):_c('img',{attrs:{"id":"userLogo_ePerfil","src":__webpack_require__(153),"alt":"Avatar de Perfil(Motor Fiscal)"}})]),_vm._v(" "),_c('div',{staticClass:"cardPerfil-inputFile d-inline-block"},[_c('inputFile',{attrs:{"component":'imagem',"prevIcon":'image',"text":'Selecione uma imagem',"resetInput":_vm.resetInputImage},on:{"getFile":function($event){return _vm.getFile($event)},"emitResetInput":function($event){return _vm.emitResetInput($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"getImageGravatar"},[_c('div',{staticClass:"ou"},[_vm._v("Ou")]),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"teal","hide-details":""},on:{"change":function($event){return _vm.getGravatar()}},model:{value:(_vm.usarGravatar),callback:function ($$v) {_vm.usarGravatar=$$v},expression:"usarGravatar"}},[_c('template',{slot:"label"},[_c('v-tooltip',{attrs:{"bottom":"","close-delay":"1500"}},[_c('span',{staticStyle:{"font-size":"13px","margin-right":"10px"},attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                        Usar imagem do\n                        "),_c('span',{staticClass:"undeline_gravatar"},[_vm._v("Gravatar")]),_vm._v(" ?\n                        "),_c('v-icon',{staticStyle:{"position":"absolute","top":"-4px","right":"0","font-size":"11px!important"},attrs:{"color":"primary"}},[_vm._v("help")])],1),_vm._v(" "),_c('span',[_c('span',{staticClass:"undeline_gravatar"},[_vm._v("Gravatar")]),_vm._v(" é uma plataforma que agiliza o\n                        "),_c('br'),_vm._v("processo que envolvem imagens, não conhece ?\n                        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://br.gravatar.com/","target":"_blank"}},[_vm._v("https://br.gravatar.com/")])])]),_vm._v(" "),(_vm.buscaGravatar)?_c('v-progress-circular',{staticClass:"ml-2",attrs:{"indeterminate":_vm.buscaGravatar,"value":0,"size":"24"}}):_vm._e(),_vm._v(" "),(!_vm.buscaGravatar && _vm.gravatarSuccess)?_c('v-icon',{attrs:{"medium":"","color":"green"}},[_vm._v("done")]):(!_vm.buscaGravatar && _vm.gravatarError)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator","medium":"","size":"","color":"red"},slot:"activator"},[_vm._v("error")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.msgErrorGravatar))])],1):_vm._e()],1)],2)],1)])]),_vm._v(" "),_c('FormUsuario',{attrs:{"conta":this.conta,"displayFlex":'xs12 sm12 md12',"edit":true,"getDadosForm":_vm.getDadosForm},on:{"emitDadosForm":function($event){return _vm.emitDadosForm($event)}}}),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","color":"red"},nativeOn:{"click":function($event){_vm.cadastro == true ? _vm.$router.push('/') : _vm.$router.push('/DashBoard')}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","color":"success"},nativeOn:{"click":function($event){return _vm.salvarDados()}}},[_vm._v(_vm._s(this.cadastro == true ? 'Concluir Cadastro' : 'Salvar'))])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.salvarDados()}}},[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.currentItem == 1),expression:"this.currentItem == 1"}],attrs:{"flat":""}},[_c('v-card-text',[(this.cadastro != true)?_c('v-form',{ref:"formPass",attrs:{"lazy-validation":""},model:{value:(_vm.validPass),callback:function ($$v) {_vm.validPass=$$v},expression:"validPass"}},[_c('v-text-field',{ref:"pass1",staticClass:"input-required",attrs:{"color":"teal","label":"Senha atual:","append-icon":_vm.show1 ? 'visibility_off' : 'visibility',"type":_vm.show1 ? 'text' : 'password',"rules":_vm.passwordRules,"prepend-icon":"lock","validate-on-blur":"","clearable":"","required":""},on:{"click:append":function($event){_vm.show1 = !_vm.show1},"input":function($event){_vm.passwordRules.length > 1 ? _vm.passwordRules.pop() : ''}},model:{value:(_vm.pass1),callback:function ($$v) {_vm.pass1=$$v},expression:"pass1"}}),_vm._v(" "),_c('v-text-field',{ref:"pass2",staticClass:"input-required",attrs:{"color":"teal","label":"Senha:","append-icon":_vm.show2 ? 'visibility_off' : 'visibility',"type":_vm.show2 ? 'text' : 'password',"rules":this.pass1 != '' ? _vm.passwordRules : undefined,"validate-on-blur":"","prepend-icon":"lock","id":"usuario-email","clearable":"","required":""},on:{"click:append":function($event){_vm.show2 = !_vm.show2},"input":function($event){_vm.passwordRules.length > 1 ? _vm.passwordRules.pop() : ''}},model:{value:(_vm.pass2),callback:function ($$v) {_vm.pass2=$$v},expression:"pass2"}}),_vm._v(" "),_c('v-text-field',{ref:"pass3",staticClass:"input-required",attrs:{"color":"teal","rules":this.pass1 != '' ? _vm.passwordRules : undefined,"label":"Confirmação da senha:","append-icon":_vm.show3 ? 'visibility_off' : 'visibility',"type":_vm.show3 ? 'text' : 'password',"prepend-icon":"lock","validate-on-blur":"","id":"usuario-password","clearable":"","required":""},on:{"click:append":function($event){_vm.show3 = !_vm.show3},"input":function($event){_vm.passwordRules.length > 1 ? _vm.passwordRules.pop() : ''}},model:{value:(_vm.pass3),callback:function ($$v) {_vm.pass3=$$v},expression:"pass3"}})],1):_c('v-form',{ref:"formPass",attrs:{"lazy-validation":""},model:{value:(_vm.validPass),callback:function ($$v) {_vm.validPass=$$v},expression:"validPass"}},[_c('v-text-field',{ref:"pass2",staticClass:"input-required",attrs:{"color":"teal","label":"Senha:","append-icon":_vm.show2 ? 'visibility_off' : 'visibility',"type":_vm.show2 ? 'text' : 'password',"validate-on-blur":"","prepend-icon":"lock","id":"usuario-email","rules":_vm.passwordRules,"clearable":"","required":""},on:{"click:append":function($event){_vm.show2 = !_vm.show2},"input":function($event){_vm.passwordRules.length > 1 ? _vm.passwordRules.pop() : ''}},model:{value:(_vm.pass2),callback:function ($$v) {_vm.pass2=$$v},expression:"pass2"}}),_vm._v(" "),_c('v-text-field',{ref:"pass3",staticClass:"input-required",attrs:{"color":"teal","label":"Confirmação da senha:","validate-on-blur":"","append-icon":_vm.show3 ? 'visibility_off' : 'visibility',"type":_vm.show3 ? 'text' : 'password',"rules":_vm.passwordRules,"prepend-icon":"lock","id":"usuario-password","clearable":"","required":""},on:{"click:append":function($event){_vm.show3 = !_vm.show3},"input":function($event){_vm.passwordRules.length > 1 ? _vm.passwordRules.pop() : ''}},model:{value:(_vm.pass3),callback:function ($$v) {_vm.pass3=$$v},expression:"pass3"}})],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","color":"red"},nativeOn:{"click":function($event){_vm.cadastro == true ? _vm.$router.push('/') : _vm.$router.push('/DashBoard')}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","color":"success"},nativeOn:{"click":function($event){return _vm.salvarDados()}}},[_vm._v(_vm._s(this.cadastro == true ? 'Concluir Cadastro' : 'Salvar'))])],1)],1)],1)],1)],1)],1),_vm._v(" "),(this.cadastro != true)?_c('v-tab-item',{on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.salvarDados()}}},[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.currentItem == 2),expression:"this.currentItem == 2"}],attrs:{"flat":""}},[_c('v-card-text',[(_vm.empresa && _vm.empresa._id)?_c('v-container',{attrs:{"fluid":""}},[_c('article',{staticClass:"panel_notifi"},[_c('small',{staticClass:"title_emp_notifi"},[_vm._v("Notificações de: "+_vm._s(_vm.empresa.razao))]),_vm._v(" "),_c('article',{staticClass:"body_notifi"},[_c('v-layout',{staticClass:"dark--text",attrs:{"row":"","wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('h3',{staticClass:"text-xs-center"},[_vm._v("Envio das notificações:")])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Central de notificações do motor fiscal","color":"success","input-value":"true"},on:{"change":function($event){return _vm.resetOpcaoNotificacoes('geral')}},model:{value:(_vm.notificacoes.geral.ativo),callback:function ($$v) {_vm.$set(_vm.notificacoes.geral, "ativo", $$v)},expression:"notificacoes.geral.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Envio por E-mail","color":"success","input-value":"true"},on:{"change":function($event){return _vm.resetOpcaoNotificacoes('email')}},model:{value:(_vm.notificacoes.email.ativo),callback:function ($$v) {_vm.$set(_vm.notificacoes.email, "ativo", $$v)},expression:"notificacoes.email.ativo"}})],1)],1),_vm._v(" "),_c('article',{staticClass:"notifi_email"},[_c('v-layout',{staticClass:"dark--text",attrs:{"row":"","wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(this.notificacoes.email.ativo.indexOf(_vm.empresa._id) != -1),expression:"this.notificacoes.email.ativo.indexOf(empresa._id) != -1"}],attrs:{"xs12":""}},[_c('h3',{staticClass:"text-xs-center"},[_vm._v("Opções das notificações por e-mail:")])])],1)],1),_vm._v(" "),_c('v-fade-transition',{attrs:{"leave-absolute":""}},[(this.notificacoes.email.ativo.indexOf(_vm.empresa._id) != -1)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Novo Fornecedor","color":"success"},model:{value:(_vm.notificacoes.email.novoFornecedor),callback:function ($$v) {_vm.$set(_vm.notificacoes.email, "novoFornecedor", $$v)},expression:"notificacoes.email.novoFornecedor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Novo Cliente","color":"success"},model:{value:(_vm.notificacoes.email.novoCliente),callback:function ($$v) {_vm.$set(_vm.notificacoes.email, "novoCliente", $$v)},expression:"notificacoes.email.novoCliente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Notas Canceladas","color":"success"},model:{value:(_vm.notificacoes.email.notaCancelada),callback:function ($$v) {_vm.$set(_vm.notificacoes.email, "notaCancelada", $$v)},expression:"notificacoes.email.notaCancelada"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Nova NF-e","color":"success"},model:{value:(_vm.notificacoes.email.nvNotaNfe),callback:function ($$v) {_vm.$set(_vm.notificacoes.email, "nvNotaNfe", $$v)},expression:"notificacoes.email.nvNotaNfe"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Nova CT-e","color":"success"},model:{value:(_vm.notificacoes.email.nvNotaCte),callback:function ($$v) {_vm.$set(_vm.notificacoes.email, "nvNotaCte", $$v)},expression:"notificacoes.email.nvNotaCte"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Nova NFS-e","color":"success"},model:{value:(_vm.notificacoes.email.nvNotaNfse),callback:function ($$v) {_vm.$set(_vm.notificacoes.email, "nvNotaNfse", $$v)},expression:"notificacoes.email.nvNotaNfse"}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('article',{staticClass:"notifi_geral"},[_c('v-layout',{staticClass:"dark--text",attrs:{"row":"","wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(this.notificacoes.geral.ativo.indexOf(_vm.empresa._id) != -1),expression:"this.notificacoes.geral.ativo.indexOf(empresa._id) != -1"}],attrs:{"xs12":""}},[_c('h3',{staticClass:"text-xs-center"},[_vm._v("Opções das notificações Motor Fiscal:")])])],1)],1),_vm._v(" "),_c('v-fade-transition',{attrs:{"leave-absolute":""}},[(this.notificacoes.geral.ativo.indexOf(_vm.empresa._id) != -1)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Notas Canceladas","color":"success"},model:{value:(_vm.notificacoes.geral.notaCancelada),callback:function ($$v) {_vm.$set(_vm.notificacoes.geral, "notaCancelada", $$v)},expression:"notificacoes.geral.notaCancelada"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"value":_vm.empresa._id,"label":"Última consulta","color":"success"},model:{value:(_vm.notificacoes.geral.ultConsulta),callback:function ($$v) {_vm.$set(_vm.notificacoes.geral, "ultConsulta", $$v)},expression:"notificacoes.geral.ultConsulta"}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","color":"red"},nativeOn:{"click":function($event){_vm.cadastro == true ? _vm.$router.push('/') : _vm.$router.push('/DashBoard')}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","color":"success"},nativeOn:{"click":function($event){return _vm.salvarDados()}}},[_vm._v("Salvar")])],1)],1)],1)],1)])]):_c('v-container',[_vm._v("Necessário selecionar alguma empresa.")])],1)],1)],1):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configuracoes_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb9a6138_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configuracoes_vue__ = __webpack_require__(804);
function injectStyle (ssrContext) {
  __webpack_require__(788)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb9a6138"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configuracoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb9a6138_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configuracoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormEmpresa_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db1b7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormEmpresa_vue__ = __webpack_require__(803);
function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57db1b7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormEmpresa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db1b7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormEmpresa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FormEmpresa = function () {
    function FormEmpresa() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FormEmpresa);

        this.form = this.form();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FormEmpresa, [{
        key: 'form',
        value: function form() {
            return {
                fechar: false,
                items: [{ type: 'T', text: "CNPJ/CPF", item_id: 'cnpj', valor: null, prepIcon: 'location_city', class: "input-required", mask: '', maskCPF: { v: "###.###.###-##", b: false }, maskCNPJ: { v: "##.###.###/####-##", b: false } }, { type: 'T', text: "Razão Social", item_id: 'razao', valor: null, prepIcon: 'location_city', class: "input-required", mask: null }, { type: 'T', text: "Grupo", item_id: 'grupo', valor: null, prepIcon: 'location_city', class: null, mask: null }, { type: 'T', text: "Apelido", item_id: 'apelido', valor: null, prepIcon: 'location_city', class: null, mask: null }, { type: 'T', text: "CCM", item_id: 'ccm', valor: null, prepIcon: 'location_city', class: null, mask: null }, { type: 'T', text: "IE", item_id: 'ie', valor: null, prepIcon: 'location_city', class: null, mask: null }, { type: 'T', text: "CEP", item_id: 'cep', valor: null, prepIcon: 'place', class: null, mask: "#####-###" },
                // { type: 'S', text: "Faturamento", item_id: 'faturamento', prepIcon: 'attach_money', valor: null, options: ['Sim', 'Não'], multiple: false },
                { type: 'T', text: "Endereço", item_id: 'endereco', valor: null, prepIcon: 'place', class: null, mask: null }, { type: 'T', text: "Bairro", item_id: 'bairro', valor: null, prepIcon: 'place', class: null, mask: null }, { type: 'T', text: "Complemento", item_id: 'complemento', valor: null, prepIcon: 'place', class: null, mask: null }]
            };
        }
    }, {
        key: 'isValidCNPJ',
        value: function isValidCNPJ(v) {
            var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

            if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

            if (/0{14}/.test(v)) return "CNPJ inválido";

            for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]) {}
            if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

            for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]) {}
            if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

            return true;
        }
    }]);

    return FormEmpresa;
}();

/* harmony default export */ __webpack_exports__["a"] = (FormEmpresa);

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_usuario"},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[(_vm.create)?_c('div',[_c('v-flex',{class:[_vm.displayFlex]},[_c('InputFile',{attrs:{"component":'certificado',"resetInput":this.resetInput,"prevIcon":'description',"text":'Selecione um certificado'},on:{"emitResetInput":function($event){return _vm.emitResetInput(_vm.$emit)},"getFile":function($event){return _vm.getFile($event)}}})],1),_vm._v(" "),_c('v-flex',{class:[_vm.displayFlex]},[_c('v-text-field',{staticClass:"input-required",attrs:{"label":"Senha:","append-icon":_vm.showPassword ? 'visibility_off' : 'visibility',"type":_vm.showPassword ? 'text' : 'password',"validate-on-blur":"","rules":this.cert.file != undefined ? _vm.passRules : [function (v) { return true; }],"clearable":"","disabled":this.cert.file == undefined ? true : false,"required":""},on:{"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.cert.password),callback:function ($$v) {_vm.$set(_vm.cert, "password", $$v)},expression:"cert.password"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.create && !_vm.formEmp)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{class:_vm.displayFlex},[_c('v-combobox',{staticClass:"input-required",attrs:{"items":_vm.items,"chips":"","rules":this.cert.file != undefined  ? _vm.passRules : [function (v) { return true; }],"label":"Vincular a empresa: ","item-text":"empresa.razao","multiple":true,"item-value":"_id","disabled":this.cert.file == undefined ? true : false},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"v-chip--select-multi",attrs:{"selected":data.selected,"disabled":data.disabled,"close":""},on:{"input":function($event){return _vm.remove(data.item)}}},[_c('v-avatar',{staticClass:"teal white--text"},[_vm._v(_vm._s(data.item.empresa != undefined ? data.item.empresa.razao.slice(0, 1).toUpperCase() : ''))]),_vm._v("\n                "+_vm._s(data.item.empresa != undefined ? data.item.empresa.razao : '')+"\n              ")],1)]}}],null,false,2793543426),model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.vincular)?_c('v-layout',[_c('v-flex',{class:_vm.displayFlex},[_c('v-autocomplete',{attrs:{"item-text":"desc_venc","items":_vm.arrayCert,"label":"Certificados:","color":"teal","item-value":"_id","clearable":"","persistent-hint":"","return-object":"","prepend-icon":"description","no-data-text":"Nenhum certificado cadastrado"},on:{"change":function($event){return _vm.getSelected()}},model:{value:(_vm.certSelect),callback:function ($$v) {_vm.certSelect=$$v},expression:"certSelect"}})],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabNotificacoes_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e405312_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabNotificacoes_vue__ = __webpack_require__(802);
function injectStyle (ssrContext) {
  __webpack_require__(795)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e405312"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabNotificacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e405312_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabNotificacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAddEdit_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbd0f976_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAddEdit_vue__ = __webpack_require__(801);
function injectStyle (ssrContext) {
  __webpack_require__(797)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbd0f976"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAddEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbd0f976_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAddEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opcoes_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111f41d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Opcoes_vue__ = __webpack_require__(800);
function injectStyle (ssrContext) {
  __webpack_require__(799)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-111f41d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opcoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111f41d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Opcoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"opcoesNotificacoes"}},[_c('v-flex',[_c('article',{staticClass:"notifi_email"},[_c('v-layout',{staticClass:"dark--text",attrs:{"row":"","wrap":"","align-center":"","justify-center":"","fill-height":""}},[_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h3',{staticClass:"text-xs-center"},[_vm._v("Opções das notificações por e-mail:")])])],1)],1),_vm._v(" "),_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"label":"Novo Fornecedor","color":"success"},model:{value:(_vm.opcoes.novoFornecedor),callback:function ($$v) {_vm.$set(_vm.opcoes, "novoFornecedor", $$v)},expression:"opcoes.novoFornecedor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"label":"Novo Cliente","color":"success"},model:{value:(_vm.opcoes.novoCliente),callback:function ($$v) {_vm.$set(_vm.opcoes, "novoCliente", $$v)},expression:"opcoes.novoCliente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"label":"Notas Canceladas","color":"success"},model:{value:(_vm.opcoes.notaCancelada),callback:function ($$v) {_vm.$set(_vm.opcoes, "notaCancelada", $$v)},expression:"opcoes.notaCancelada"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"label":"Nova NF-e","color":"success"},model:{value:(_vm.opcoes.nvNotaNfe),callback:function ($$v) {_vm.$set(_vm.opcoes, "nvNotaNfe", $$v)},expression:"opcoes.nvNotaNfe"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"label":"Nova CT-e","color":"success"},model:{value:(_vm.opcoes.nvNotaCte),callback:function ($$v) {_vm.$set(_vm.opcoes, "nvNotaCte", $$v)},expression:"opcoes.nvNotaCte"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-switch',{attrs:{"label":"Nova NFS-e","color":"success"},model:{value:(_vm.opcoes.nvNotaNfse),callback:function ($$v) {_vm.$set(_vm.opcoes, "nvNotaNfse", $$v)},expression:"opcoes.nvNotaNfse"}})],1)],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.tipo == 'edit' ? _vm.editarItem() : _vm.tipo == 'create' ? _vm.salvarItem() : ''}]},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.titulo))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog=false}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[(this.showCampoEmail)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{ref:"email",attrs:{"label":"E-mail:","rules":_vm.emailRules,"validate-on-blur":"","box":"","color":"teal","cleareable":""},on:{"input":function($event){_vm.emailRules.length > 0 ? _vm.emailRules.pop() : ''}},model:{value:(_vm.obj.email),callback:function ($$v) {_vm.$set(_vm.obj, "email", $$v)},expression:"obj.email"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(this.showNotificacoes)?_c('Opcoes',{attrs:{"notificacoes":this.notificacoes,"opcoes":this.obj}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false, _vm.resetObj()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();_vm.tipo == 'edit' ? _vm.editarItem() : _vm.tipo == 'create' ? _vm.salvarItem() : ''}}},[_vm._v(_vm._s(_vm.btnFinishText))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tab_not"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box_lista_email"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[(_vm.notificacoes.objetos && _vm.notificacoes.objetos.length > 0 && (_vm.notificacoes.objetos.length != 1 || _vm.fakeDelete.length != 1))?_c('div',{staticClass:"total"},[_vm._v("Total: "+_vm._s(_vm.notificacoes.objetos ? _vm.notificacoes.objetos.length : ''))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":"","justify-end":""}},[_c('v-slide-x-reverse-transition',[(_vm.fakeDelete.length > 0)?_c('v-tooltip',{staticStyle:{"margin-top":"5.5px","display":"block"},attrs:{"left":""}},[_c('v-btn',{staticClass:"my-0",attrs:{"slot":"activator","icon":""},nativeOn:{"click":function($event){return _vm.activeItem()}},slot:"activator"},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),_c('span',[_vm._v("Desfazer deleção")])],1):_vm._e()],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"green darken-2","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){_vm.acao.create = true;}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"dark":"","color":"green"}},[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Cadastrar novo E-mail")])],1)],1)],1)],1),_vm._v(" "),_c('article',{staticClass:"list"},[(_vm.notificacoes.objetos && _vm.notificacoes.objetos.length > 0 && (_vm.notificacoes.objetos.length != 1 || _vm.fakeDelete.length != 1))?_c('div',{staticClass:"title"},[_c('v-layout',{staticStyle:{"margin-top":"-11px"},attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"icon_email"})]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"list_title email"},[_vm._v("E-mail:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"acoes"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"list_title acoes"},[_vm._v("Ações:")])])],1)])],1)],1):_vm._e(),_vm._v(" "),(_vm.notificacoes.objetos && _vm.notificacoes.objetos.length > 0 && (_vm.notificacoes.objetos.length != 1 || _vm.fakeDelete.length != 1))?[_c('ul',_vm._l((_vm.notificacoes.objetos),function(notif){return (!notif.delete)?_c('li',{key:notif.email},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"icon_email"})]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"email"},[_vm._v(_vm._s(notif.email))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"acoes"},[_c('v-layout',{attrs:{"row":"","justify-end":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"warning darken-2","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){_vm.acao.edit = true, _vm.editItem = notif}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"dark":"","color":"warning"}},[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Editar Notificações")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"red darken-2","icon":"","flat":"","text-color":"white","dark":""},nativeOn:{"click":function($event){notif['delete'] = true, _vm.fakeDelete.push(notif)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"dark":"","color":"red"}},[_vm._v("delete_forever")])],1),_vm._v(" "),_c('span',[_vm._v("Deletar E-mail")])],1)],1)],1)])],1)],1):_vm._e()}),0)]:_c('v-layout',{staticStyle:{"margin-top":"10%"},attrs:{"row":"","justify-center":""}},[_c('span',{staticClass:"msg_vazi"},[_vm._v("\n          Nenhum E-mail está sendo notificado,\n          "),_c('span',{staticClass:"link",on:{"click":function($event){_vm.acao.create = true;}}},[_vm._v("cadastre agora !")])])])],2)],1),_vm._v(" "),_c('ModalAddEdit',{attrs:{"notificacoes":this.notificacoes,"editItem":this.editItem,"acao":this.acao}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ctitle"},[_vm._v("\n    Configurar\n    "),_c('strong',[_vm._v("e-mails")]),_vm._v(" para receber notificações:\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_usuario"},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-layout',{staticStyle:{"display":"unset"}},[_c('v-tabs',{staticClass:"tabPerfil certificado panelEmpresa",attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItemModal),callback:function ($$v) {_vm.currentItemModal=$$v},expression:"currentItemModal"}},[_vm._l((_vm.tabsModal),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItemModal ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('v-tab-item',[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.currentItemModal == 0),expression:"this.currentItemModal == 0"}]},[_c('v-card-text',[_c('v-layout',{staticClass:"form_empresa_inputs",attrs:{"row":"","wrap":""}},[_vm._l((_vm.modelForm.form.items),function(item,i){return (item.type == 'T' && (_vm.prodRural && item.text != 'CNPJ' || !_vm.prodRural && item.text != 'CPF'))?_c('v-flex',{key:i,class:[_vm.displayFlex, item.class]},[_c('v-text-field',{ref:item.item_id,refInFor:true,attrs:{"maxLength":item.item_id == 'apelido' && 10,"color":"teal","prepend-icon":item.prepIcon,"mask":!_vm.edit ? item.mask : item.item_id == 'cnpj' ? item.valor && item.valor.length > 11 ? item.maskCNPJ.v : item.maskCPF.v : '',"validate-on-blur":"","clearable":_vm.edit && item.item_id != 'cnpj' && item.item_id != 'razao' || !_vm.edit,"rules":item.item_id == 'cnpj' ? item.valor && item.valor.length > 11 ? _vm.cnpjRules : item.valor && item.valor.length <= 11 && item.valor && item.valor.length > 0 ? _vm.cpfRules :  [ function (v) { return true}] 
                              : item.item_id == 'razao' ? _vm.razaoRules : [ function (v) { return true}],"disabled":_vm.edit && item.item_id == 'cnpj'},on:{"keyup":function($event){item.item_id == 'cnpj' ? _vm.trocaCampoCpfCnpj($event, item) : ''},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }item.item_id == 'cnpj' ? item.mask = '' : ''},"blur":function($event){item.item_id == 'cnpj' ? _vm.verificaCNPJ(item) : ''}},model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}},[_c('template',{slot:"label"},[_vm._v(_vm._s(item.text)+":")])],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.modelForm.form.items),function(item,i){return (item.type == 'S')?_c('v-flex',{key:i,class:[_vm.displayFlex, item.class]},[_c('v-autocomplete',{attrs:{"items":item.options,"persistent-hint":"","color":"teal","prepend-icon":item.prepIcon,"no-data-text":"Erro na consulta de dados","return-object":"","multiple":item.multiple},model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}},[_c('template',{slot:"label"},[_c('small',[_vm._v(_vm._s(item.text)+":")])])],2)],1):_vm._e()}),_vm._v(" "),_c('v-flex',{class:_vm.displayFlex},[_c('v-autocomplete',{staticClass:"input-required",attrs:{"item-text":"nome","items":_vm.arrayEstados,"label":"Estado:","persistent-hint":"","disabled":_vm.edit,"color":"teal","prepend-icon":"place","rules":this.razaoRules,"no-data-text":"Consulta de Estado indisponível","return-object":""},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}})],1),_vm._v(" "),_c('v-flex',{class:_vm.displayFlex},[_c('v-autocomplete',{staticClass:"input-required",attrs:{"item-text":"nome","items":_vm.arrayCidades,"label":"Cidade:","color":"teal","rules":this.razaoRules,"persistent-hint":"","return-object":"","prepend-icon":"place","no-data-text":"Selecione um Estado"},model:{value:(_vm.municipio),callback:function ($$v) {_vm.municipio=$$v},expression:"municipio"}})],1)],2)],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.currentItemModal == 1),expression:"this.currentItemModal == 1"}]},[_c('v-card-text',[_c('v-flex',{class:_vm.displayFlex},[_c('v-tabs',{staticClass:"tabPerfil certificado",attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItem),callback:function ($$v) {_vm.currentItem=$$v},expression:"currentItem"}},[_vm._l((_vm.tabs),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItem ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('v-tab-item',[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.currentItem == 0),expression:"this.currentItem == 0"}]},[_c('v-card-text',[_c('FormCertificado',{attrs:{"conta":this.conta,"formEmp":true,"displayFlex":'xs12 sm12 md12',"vincular":false,"create":true,"resetForm":this.resetFormCert,"getDadosForm":this.getDadosCert},on:{"changResetForm":function($event){return _vm.changResetForm($event)},"emitDadosForm":function($event){return _vm.emitDadosForm($event)}}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.currentItem == 1),expression:"this.currentItem == 1"}]},[_c('v-card-text',[_c('FormCertificado',{attrs:{"conta":this.conta,"displayFlex":'xs12 sm12 md12',"vincular":true,"create":false,"resetForm":this.resetFormCert,"getDadosForm":this.getDadosCert},on:{"changResetForm":function($event){return _vm.changResetForm($event)},"emitDadosForm":function($event){return _vm.emitDadosForm($event)}}})],1)],1)],1)],2)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',[(this.currentItemModal == 2)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticStyle:{"background-color":"#e9e9e9"}},[_c('TabNotificacoes',{attrs:{"notificacoes":this.notificacoes}})],1)],1):_vm._e()],1)],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editar_perfil configuracoes"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('svg',{staticStyle:{"width":"24px","height":"24px","margin-left":"87px","margin-bottom":"-4px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#FFF","d":"M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z"}})]),_vm._v("\n          Configurações da conta\n          "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.empresa._id)?_c('v-icon',{staticClass:"mr-2 ml-2 loading fechamento_loop"},[_vm._v("loop")]):_vm._e()],1)],1)])],1)],1),_vm._v(" "),(_vm.empresa._id)?_c('v-tabs',{staticClass:"tabPerfil",attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItem),callback:function ($$v) {_vm.currentItem=$$v},expression:"currentItem"}},[_vm._l((_vm.tabs),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItem ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('v-tab-item',[(this.currentItem == 0)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"d-inline-block",attrs:{"slot":"activator","outline":"","color":"black","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.showFormCadastrar('Empresa')}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px","font-size":"13px!important","position":"absolute","left":"-8%"},attrs:{"dark":"","color":"teal"}},[_vm._v("add")]),_vm._v(" "),_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px"},attrs:{"dark":"","color":"teal"}},[_vm._v("domain")]),_vm._v(" "),_c('small',[_vm._v("Adicionar empresa")])],1),_vm._v(" "),_c('span',[_vm._v("Adicionar uma nova empresa")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"d-inline-block",attrs:{"slot":"activator","outline":"","color":"black","text-color":"white","dark":""},nativeOn:{"click":function($event){_vm.dialog2 = !_vm.dialog2}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px"},attrs:{"dark":"","color":"teal"}},[_vm._v("person_add")]),_vm._v(" "),_c('small',[_vm._v("Adicionar Colaborador")])],1),_vm._v(" "),_c('span',[_vm._v("Adicionar um novo colaborador")])],1),_vm._v(" "),(_vm.dialog2)?_c('v-dialog',{attrs:{"max-width":"700px","transition":"dialog-bottom-transition"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog2 = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.salvarDados()}]},model:{value:(_vm.dialog2),callback:function ($$v) {_vm.dialog2=$$v},expression:"dialog2"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Configuração do Colaborador")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog2 = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',[_c('v-subheader',{staticClass:".container",attrs:{"subheader":""}},[_c('h2',[_vm._v("Adicionar Colaborador")])]),_vm._v(" "),_c('FormUsuario',{attrs:{"displayFlex":'xs6 sm6 md6',"conta":this.conta,"create":true,"resetForm":_vm.resetForm,"formEmp":true,"getDadosForm":_vm.getDadosForm},on:{"changResetForm":function($event){return _vm.changResetForm($event)},"emitDadosForm":function($event){return _vm.emitDadosForm($event)}}}),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},nativeOn:{"click":function($event){_vm.dialog2 = false}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","small":"","color":"teal"},nativeOn:{"click":function($event){return _vm.salvarDados()}}},[_vm._v("Cadastrar")])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('article',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[(_vm.dialog2 != true)?_c('v-dialog',{attrs:{"persistent":"","max-width":"700px","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Configuração da Empresa - "+_vm._s(_vm.formEmp.titulo))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',[_c('FormEmpresa',{attrs:{"conta":this.conta,"currentTab":this.currentTabInComp,"resetForm":_vm.resetForm,"getDadosForm":_vm.getDadosForm,"IBGE":this.IBGE,"edit":_vm.edit,"empEdit":_vm.empEdit,"notificacoes":this.notificacoes},on:{"changResetForm":function($event){return _vm.changResetForm($event)},"emitDadosForm":function($event){return _vm.emitDadosForm($event)}}}),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"2px"},attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","small":"","color":"teal"},nativeOn:{"click":function($event){return _vm.salvarDados()}}},[_vm._v(_vm._s(_vm.formEmp.btnSuccess))])],1)],1)],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"cardPerfil"},[_c('div',{staticClass:"cardPerfil-body"},[_c('RenderTableNFe',{attrs:{"conta":this.conta,"alert":this.alert,"IBGE":this.IBGE,"sendAttTable":this.sendAttTable,"table":'empresa'},on:{"attSendTable":function($event){return _vm.attSendTable($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)}}})],1)])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-tab-item',[(this.currentItem == 1)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"d-inline-block",attrs:{"slot":"activator","outline":"","color":"black","text-color":"white","dark":""},nativeOn:{"click":function($event){return _vm.showFormCadastrar('Certificado')}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",staticStyle:{"padding-right":"10px","font-size":"13px!important","position":"absolute","left":"-8%"},attrs:{"dark":"","color":"teal"}},[_vm._v("add")]),_vm._v(" "),_c('svg',{staticClass:"customIcon i_header",staticStyle:{"width":"15px","height":"17px","margin-top":"2px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"}})]),_vm._v(" "),_c('small',[_vm._v("Adicionar certificado")])],1),_vm._v(" "),_c('span',[_vm._v("Adicionar um novo certificado")])],1),_vm._v(" "),_c('article',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[(_vm.dialog2 != true)?_c('v-dialog',{attrs:{"persistent":"","max-width":"600px","transition":"dialog-bottom-transition"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.salvarDados()}]},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"headline darkBlue",attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Configuração do Certificado")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('article',[_c('v-subheader',{staticClass:".container",attrs:{"subheader":""}},[_c('h2',[_vm._v(_vm._s(_vm.formEmp.titulo))])]),_vm._v(" "),_c('FormCertificado',{attrs:{"displayFlex":'xs12 sm12 md12',"conta":this.conta,"create":true,"resetForm":_vm.resetForm,"getDadosForm":_vm.getDadosForm},on:{"changResetForm":function($event){return _vm.changResetForm($event)},"emitDadosForm":function($event){return _vm.emitDadosForm($event)}}}),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"block":"","outline":"","depressed":"","small":"","color":"red"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","small":"","color":"teal","text-color":"white"},nativeOn:{"click":function($event){return _vm.salvarDados()}}},[_vm._v(_vm._s(_vm.formEmp.btnSuccess))])],1)],1)],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.formEmp.show)?_c('v-container',{staticClass:"panelFiltro"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","margin-left":"1em"}},[_vm._v(_vm._s(_vm.formEmp.titulo))])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cardPerfil"},[_c('div',{staticClass:"cardPerfil-body"},[_c('RenderTableNFe',{attrs:{"conta":this.conta,"alert":this.alert,"IBGE":this.IBGE,"sendAttTable":this.sendAttTable,"table":'certificado'},on:{"attSendTable":function($event){return _vm.attSendTable($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)}}})],1)])],1)],1):_vm._e()],1)],2):_vm._e(),_vm._v(" "),_c('v-card-text')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfiguracoesAutomacao_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd5a0e3c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfiguracoesAutomacao_vue__ = __webpack_require__(807);
function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd5a0e3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfiguracoesAutomacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd5a0e3c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfiguracoesAutomacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editar_perfil configuracoes"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('svg',{staticStyle:{"width":"24px","height":"24px","margin-left":"87px","margin-bottom":"-4px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#FFF","d":"M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z"}})]),_vm._v("\n          Configurações Automação Fiscal\n          "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.empresa._id)?_c('v-icon',{staticClass:"mr-2 ml-2 loading fechamento_loop"},[_vm._v("loop")]):_vm._e()],1)],1)])],1)],1),_vm._v(" "),(_vm.empresa._id)?_c('v-tabs',{staticClass:"tabPerfil",attrs:{"slider-color":"indigo darken-4","left":"","id":"containerTab","color":"grey lighten-5"},model:{value:(_vm.currentItem),callback:function ($$v) {_vm.currentItem=$$v},expression:"currentItem"}},[_vm._l((_vm.tabs),function(item,i){return _c('v-tab',{key:i,class:[i == _vm.currentItem ? 'active' : ''],attrs:{"id":"tabOption"}},[_vm._v(_vm._s(item.title))])}),_vm._v(" "),_c('v-tab-item',[(this.currentItem == 0)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('BtnNovoImovel',{attrs:{"IBGE":_vm.IBGE,"empresa":_vm.empresa}}),_vm._v(" "),_c('div',{staticClass:"cardPerfil"},[_c('div',{staticClass:"cardPerfil-body"},[_c('RenderTableNFe',{attrs:{"conta":this.conta,"alert":this.alert,"IBGE":this.IBGE,"sendAttTable":this.sendAttTable,"table":'iptu',"empresa":_vm.empresa},on:{"attSendTable":function($event){return _vm.attSendTable($event)},"emitEditEmp":function($event){return _vm.emitEditEmp($event)}}})],1)])],1)],1):_vm._e()],1)],2):_vm._e(),_vm._v(" "),_c('v-card-text')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"alert_message"},[_c('v-snackbar',{class:this.alert.snack.multiple ? 'snack_multiple' : '',attrs:{"bottom":null === 'bottom',"left":'right' === 'left',"right":'right' === 'right',"timeout":_vm.alert.snack.time,"top":null === 'top',"vertical":'' === 'vertical',"id":"snack","color":_vm.alert.snack.color},model:{value:(_vm.alert.snack.show),callback:function ($$v) {_vm.$set(_vm.alert.snack, "show", $$v)},expression:"alert.snack.show"}},[_c('strong',[_vm._v(_vm._s(this.alert.snack.text))]),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.alert.snack.btnFColor,"flat":""},on:{"click":function($event){_vm.alert.snack.show = false}}},[_vm._v("\n            Fechar\n            ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstAccess_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c1ceb36_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstAccess_vue__ = __webpack_require__(812);
function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c1ceb36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstAccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c1ceb36_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstAccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('span',{staticStyle:{"position":"relative"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('h5',{staticStyle:{"color":"gainsboro","padding":"20px"}},[_vm._v("Notas importadas:")])]),_vm._v(" "),_c('v-layout',{staticClass:"infos",staticStyle:{"margin-bottom":"31px"},attrs:{"row":"","wrap":""}},_vm._l((_vm.cards),function(card,i){return _c('v-flex',{key:card.id,staticClass:"l_layout",attrs:{"d-flex":"","xs12":"","sm3":"","md3":""}},[_c('v-card',{staticClass:"cardTipos",class:card.cor},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('div',{staticClass:"c_title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('div',{staticClass:"c_title c_sub"},[_vm._v(_vm._s(card.subTitle))]),_vm._v(" "),_c('div',{staticClass:"values",attrs:{"id":("value" + i)}},[_vm._v(_vm._s(_vm.firstAccess[((card.id) + "Qtd")]))]),_vm._v(" "),_c('div',{staticClass:"analise"},[_vm._v(_vm._s(card.analise))])])],1)],1)],1)}),1)],1),_vm._v(" "),(_vm.firstAccess.buscando == false)?_c('div',{staticClass:"fadeInUp"},[_c('v-container',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"},attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{staticClass:"beginButton",attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('span',{staticStyle:{"text-align":"center","position":"relative"}},[_c('h1',{staticStyle:{"font-family":"monospace","color":"#fbfbfb"}},[_vm._v("\n              Bem vindo,\n              "),_c('strong',{staticClass:"nome_c"},[_vm._v(_vm._s(_vm.conta.nome))]),_vm._v(".\n          ")]),_vm._v(" "),_c('h2',{staticStyle:{"font-family":"monospace","color":"#fbfbfb"}},[_vm._v("Motor Fiscal está pronto para uso!")]),_vm._v(" "),_c('v-btn',{staticClass:"bg_white begin_custom",attrs:{"color":"white","small":"","outline":"","text-color":"white"},on:{"click":function($event){_vm.begin(), _vm.$router.push('/DashBoard')}}},[_vm._v("Começar")]),_vm._v(" "),_c('svg',{staticClass:"custom_anime c_hand_icon",staticStyle:{"width":"55px","height":"45px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill":"white"},attrs:{"d":"M14,3V13L17.2,11.31L17.42,11.28C17.71,11.28 17.97,11.4 18.16,11.6L18.9,12.37L14,16.57C13.74,16.84 13.39,17 13,17H6.5C5.73,17 5,16.3 5,15.5V11.14C5,10.53 5.35,10 5.85,9.8L10.79,7.6L12,7.47V3A1,1 0 0,1 13,2A1,1 0 0,1 14,3M5,19H13V22H5V19Z"}})])],1)])],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorio_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965e78b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Relatorio_vue__ = __webpack_require__(815);
function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-965e78b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965e78b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Relatorio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relatorio"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('svg',{staticStyle:{"width":"24px","height":"24px","margin-left":"87px","margin-bottom":"-4px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#fff","d":"M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"}})]),_vm._v("\n          Relátorio MF\n        ")])])],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"width":"80%","margin":"0 auto","padding":"41px 41px 0px 41px","background-color":"#efefef"},attrs:{"flat":"","id":"card_contas"}},[(!_vm.listaDisponivel)?_c('div',{staticClass:"txt-xs-center"},[_vm._v("Selecione um tipo:")]):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"c_line_title",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":""}},[_c('span',{staticClass:"title_click",on:{"click":function($event){return _vm.getUsuarios()}}},[_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.loadingUsers)?_c('v-icon',{staticClass:"mr-2 ml-2",attrs:{"small":""}},[_vm._v("person")]):_vm._e()],1),_vm._v(" "),(_vm.loadingUsers)?_c('v-icon',{staticClass:"mr-2 ml-2 loading",attrs:{"small":""}},[_vm._v("loop")]):_vm._e(),_vm._v("Usuários\n          ")],1)]),_vm._v(" "),(_vm.listaDisponivel)?_c('v-tooltip',{staticStyle:{"position":"absolute","right":"0","top":"0px","z-index":"10"},attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"white darken-2","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.resetUsuarios()}},slot:"activator"},[_c('v-icon',{staticClass:"mr-2 ml-2",attrs:{"small":""}},[_vm._v("remove_circle_outline")])],1),_vm._v(" "),_c('span',[_vm._v("Fechar tabela de usuários")])],1):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"translate-y-fade"}},[(_vm.listaDisponivel)?_c('RenderTableNFe',{attrs:{"conta":this.conta,"alert":this.alert,"table":'rela_usuario'}}):_vm._e()],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"width":"80%","margin":"0 auto","padding":"41px 41px 0px 41px","background-color":"#efefef"},attrs:{"flat":""}},[_c('v-layout',{staticClass:"c_line_title",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":""}},[_c('span',{staticClass:"title_click",on:{"click":function($event){return _vm.getCertificados()}}},[_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.loadingCertificados)?_c('span',{staticStyle:{"padding":"8px"}},[_c('svg',{staticStyle:{"width":"15px","height":"17px","margin-top":"2px","vertical-align":"middle"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill":"#214343"},attrs:{"d":"M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"}})])]):_vm._e()]),_vm._v(" "),(_vm.loadingCertificados)?_c('v-icon',{staticClass:"mr-2 ml-2 loading",attrs:{"small":""}},[_vm._v("loop")]):_vm._e(),_vm._v("Certificado próx. vencimento:\n          "),_c('v-chip',{attrs:{"small":"","color":"yellow darken-2 qntd_cert_venc","text-color":"white"}},[_vm._v(_vm._s(_vm.qntdCertVencendo))])],1)]),_vm._v(" "),(_vm.listaCertDisponivel)?_c('v-tooltip',{staticStyle:{"position":"absolute","right":"0","top":"0px","z-index":"10"},attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"white darken-2","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.resetCertificados()}},slot:"activator"},[_c('v-icon',{staticClass:"mr-2 ml-2",attrs:{"small":""}},[_vm._v("remove_circle_outline")])],1),_vm._v(" "),_c('span',[_vm._v("Fechar tabela de certificados")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_vm._v(_vm._s(_vm.listaCertDisponivel ? 'Detalhes do certificado' : ''))])],1),_vm._v(" "),_c('transition',{attrs:{"name":"translate-y-fade"}},[(_vm.listaCertDisponivel)?_c('v-layout',{staticClass:"body_lista layout justify-space-between"},[_c('v-flex',{staticStyle:{"min-height":"inherit","background-color":"#ebebeb"},attrs:{"xs5":""}},[_c('v-layout',{attrs:{"row":"","fill-heigh":""}},[_c('ul',_vm._l((_vm.certificados),function(certificado){return _c('li',{key:certificado.cert._id,on:{"click":function($event){return _vm.selectCert(certificado)}}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{staticClass:"title_click"},[_c('span',{staticStyle:{"padding":"8px"}},[_c('svg',{staticStyle:{"width":"15px","height":"17px","margin-top":"2px","vertical-align":"middle"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill":"#214343"},attrs:{"d":"M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"}})])]),_vm._v("\n                    "+_vm._s(certificado.cert.nome)+"\n                  ")])])],1)}),0)])],1),_vm._v(" "),_c('v-flex',{attrs:{"flex":"","d-flex":"","text-xs-center":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[(!_vm.certificadoSelecionado)?_c('div',[_vm._v(_vm._s(_vm.certificados && _vm.certificados.length > 0 ? 'Selecione um certificado' : 'Sem certificado para análise'))]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"translate-y-fade"}},[(_vm.certificadoSelecionado && _vm.informacoesCert && _vm.informacoesCert.hasOwnProperty('cert'))?_c('div',{staticStyle:{"align-self":"center"}},[_c('v-flex',{attrs:{"d-flex":"","text-xs-center":""}},[_c('v-card',{key:_vm.informacoesCert.cert._id,staticClass:"pt-4 mx-auto",attrs:{"flat":"","max-width":"400"}},[_c('v-card-text',[_c('span',{staticStyle:{"padding":"8px"}},[_c('svg',{staticStyle:{"width":"50px","height":"50px","margin-top":"2px","vertical-align":"middle"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill":"#214343"},attrs:{"d":"M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"}})])]),_vm._v(" "),_c('h3',{staticClass:"headline mb-2"},[_vm._v(_vm._s(_vm.informacoesCert.cert.nome))]),_vm._v(" "),_c('div',{staticClass:"blue--text mb-2"},[_c('small',[_vm._v("Dono:")]),_vm._v(" "),_c('br'),_vm._v("\n                        "+_vm._s(_vm.informacoesCert.mailConta)+"\n                        "),_c('v-tooltip',{attrs:{"right":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.envMail(_vm.informacoesCert.cert._id, _vm.informacoesCert.mailConta)}},slot:"activator"},[_c('v-icon',{staticClass:"material-icons",attrs:{"small":""}},[_vm._v("email")])],1),_vm._v(" "),_c('span',[_vm._v("Notificar vencimento por E-mail")])],1)],1),_vm._v(" "),_c('div',[_c('small',[_vm._v("Data vencimento:")])]),_vm._v(" "),_c('div',{staticClass:"blue--text subheading font-weight-bold"},[_vm._v(_vm._s(new Date(_vm.informacoesCert.cert.validade).toLocaleDateString()))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticStyle:{"padding-top":"10px"},attrs:{"tag":"v-card-text","text-xs-left":"","wrap":""}},[_c('v-flex',{staticStyle:{"font-size":"12px"},attrs:{"tag":"strong","xs5":"","text-xs-left":"","mr-3":"","mb-2":""}},[_vm._v("\n                        Vence em:\n                        "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.diffDays(new Date(_vm.informacoesCert.cert.validade), new Date()))+" dias")])]),_vm._v(" "),_c('v-flex',[_c('v-flex',{staticStyle:{"font-size":"12px"},attrs:{"tag":"strong","xs5":"","text-xs-left":"","mr-3":"","mb-2":""}},[_vm._v("Empresas que usam:")]),_vm._v(" "),_c('small',{staticStyle:{"color":"orangered"}},[_vm._v("Total: "+_vm._s(_vm.informacoesCert.empresas ? _vm.informacoesCert.empresas.length : 0))]),_vm._v(" "),_c('transition',{attrs:{"name":"translate-y-fade"}},[_c('v-layout',{staticClass:"body_lista_logins layout justify-space-between"},[_c('v-flex',{staticStyle:{"min-height":"inherit","background-color":"#ebebeb"},attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","fill-heigh":""}},[_c('ul',_vm._l((_vm.informacoesCert.empresas),function(empresa,i){return _c('li',{key:i},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('small',{staticClass:"title_click"},[_vm._v(_vm._s(empresa.cnpj != undefined ? (empresa.cnpj.length > 11 ? empresa.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : empresa.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''))]),_vm._v(" -\n                                      "),_c('small',{staticClass:"title_click"},[_vm._v(_vm._s(empresa.razao))]),_vm._v(" "),_c('hr')])],1)}),0)])],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"width":"80%","margin":"0 auto","padding":"41px 41px 41px 41px","background-color":"#efefef"},attrs:{"flat":"","id":"card_contas"}},[_c('v-layout',{staticClass:"c_line_title",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":""}},[_c('span',{staticClass:"title_click",on:{"click":function($event){return _vm.getContas()}}},[_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.loadingContas)?_c('span',{staticStyle:{"padding":"8px"}},[_c('svg',{staticStyle:{"width":"15px","height":"17px","margin-top":"2px","vertical-align":"middle"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill":"#214343"},attrs:{"d":"M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12M5,13.28L7.45,14.77L6.8,11.96L9,10.08L6.11,9.83L5,7.19L3.87,9.83L1,10.08L3.18,11.96L2.5,14.77L5,13.28Z"}})])]):_vm._e()]),_vm._v(" "),(_vm.loadingContas)?_c('v-icon',{staticClass:"mr-2 ml-2 loading",attrs:{"small":""}},[_vm._v("loop")]):_vm._e(),_vm._v("Contas:\n        ")],1),_vm._v(" "),(_vm.listaContaDisponivel)?_c('v-tooltip',{staticStyle:{"position":"absolute","right":"0","top":"0px","z-index":"10"},attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"white darken-2","icon":"","small":"","flat":""},on:{"click":function($event){return _vm.resetContas()}},slot:"activator"},[_c('v-icon',{staticClass:"mr-2 ml-2",attrs:{"small":""}},[_vm._v("remove_circle_outline")])],1),_vm._v(" "),_c('span',[_vm._v("Fechar tabela de contas")])],1):_vm._e()],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"translate-y-fade"}},[(_vm.listaContaDisponivel)?_c('RenderTableNFe',{attrs:{"conta":this.conta,"alert":this.alert,"table":'conta'}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FechamentoMes_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da29781_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FechamentoMes_vue__ = __webpack_require__(824);
function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0da29781"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FechamentoMes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da29781_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FechamentoMes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ribbon_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be1fb94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ribbon_vue__ = __webpack_require__(820);
function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6be1fb94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ribbon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be1fb94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ribbon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row ribon"},[_c('div',{staticClass:"block"},[_c('h1',[_c('a',{attrs:{"href":"#"}},[_c('v-icon',{staticClass:"mr-2 ml-2",attrs:{"color":"black","small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n        "+_vm._s(_vm.mainText)+"\n        "),(_vm.cnpjCpf)?_c('div',{staticClass:"snd_line"},[_c('small',[_vm._v(_vm._s(_vm.adptaTextCpfCnpj)+": "+_vm._s(_vm.maskCnpj))])]):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepperFechamentoMes_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c04761a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepperFechamentoMes_vue__ = __webpack_require__(823);
function injectStyle (ssrContext) {
  __webpack_require__(822)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c04761a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepperFechamentoMes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c04761a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepperFechamentoMes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper',{attrs:{"non-linear":"","id":"fechamento_stepper","vertical":""},model:{value:(_vm.e6),callback:function ($$v) {_vm.e6=$$v},expression:"e6"}},[_c('v-stepper-step',{attrs:{"color":"teal","edit-icon":"domain","editable":"","step":"1"}},[_vm._v("\n    Data de fechamento\n    "),_c('small',[_vm._v("\n      Selecione o mês e o ano para o fechamento:\n      "),_c('br'),_vm._v(" "),_c('strong',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.geraListaMeses[_vm.selectedMes])+" de "+_vm._s(_vm.selectedAno))])])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"cursor":"pointer"},attrs:{"color":"white lighten-1"}},[_c('v-tabs',{attrs:{"dark":"","color":"cyan","show-arrows":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tabs-slider',{attrs:{"color":"black"}}),_vm._v(" "),_vm._l((_vm.geraListaAno),function(i){return _c('v-tab',{key:i,attrs:{"href":'#tab-' + i,"ripple":""},nativeOn:{"click":function($event){_vm.selectedAno = i; _vm.listaMeses = _vm.geraListaMeses; _vm.selectedMes = 0; _vm.activeMes = "tab-Janeiro"}}},[_vm._v(_vm._s(i))])})],2),_vm._v(" "),_c('v-tabs',{attrs:{"dark":"","color":"cyan darken-2","show-arrows":""},model:{value:(_vm.activeMes),callback:function ($$v) {_vm.activeMes=$$v},expression:"activeMes"}},[_c('v-tabs-slider',{attrs:{"color":"black"}}),_vm._v(" "),_vm._l((_vm.geraListaMeses),function(i){return _c('v-tab',{key:i,attrs:{"href":'#tab-' + i,"ripple":""},nativeOn:{"click":function($event){_vm.selectedMes = _vm.geraListaMeses.indexOf(i)}}},[_vm._v(_vm._s(i))])})],2)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"teal","id":"custom_stepper_header","disabled":"","step":"2"}},[_vm._v("\n    NF-e\n    "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Especifique informações do documento")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.nfes_lista),function(i){return _c('v-switch',{key:i.id,attrs:{"return-object":"","small":"","label":i.text,"color":"success","value":i,"hide-details":""},model:{value:(_vm.nfes_selected),callback:function ($$v) {_vm.nfes_selected=$$v},expression:"nfes_selected"}})})],2),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"teal","id":"custom_stepper_header","step":"3"}},[_vm._v("\n    CT-e\n    "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Especifique informações do documento")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.ctes_lista),function(i){return _c('v-switch',{key:i.id,attrs:{"return-object":"","small":"","label":i.text,"color":"success","value":i,"hide-details":""},model:{value:(_vm.ctes_selected),callback:function ($$v) {_vm.ctes_selected=$$v},expression:"ctes_selected"}})})],2),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"teal","id":"custom_stepper_header","step":"4"}},[_vm._v("\n    NFs-e\n    "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Especifique informações do documento")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.nfses_lista),function(i){return _c('v-switch',{key:i.id,attrs:{"return-object":"","small":"","label":i.text,"color":"success","value":i,"hide-details":""},model:{value:(_vm.nfses_selected),callback:function ($$v) {_vm.nfses_selected=$$v},expression:"nfses_selected"}})})],2),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"teal","editable":"","step":"5"}},[_vm._v("Exportar")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":5}},[_c('v-card',{staticClass:"mb-5 card_fechamento"},[_c('v-layout',{attrs:{"xs6":"","align-center":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"align-center":"","justify-center":"","xs12":""}},[_c('div',{staticClass:"desc_exportacao"},[_vm._v("Enviar para E-mail:")]),_vm._v(" "),_c('v-combobox',{staticClass:"email_combo",attrs:{"filter":_vm.filter,"hide-no-data":!_vm.search,"items":_vm.items,"search-input":_vm.search,"hide-selected":"","label":"E-mail:","multiple":"","small-chips":"","regular":"","menu-props":{contentClass:'email_combo'}},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event},"change":_vm.handleEmails},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var parent = ref.parent;
var selected = ref.selected;
return (item === Object(item))?[_c('v-chip',{attrs:{"color":((item.color) + " lighten-3"),"selected":selected,"label":"","small":""}},[_c('span',{staticClass:"pr-2"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return parent.selectItem(item)}}},[_vm._v("close")])],1)]:undefined}},{key:"item",fn:function(ref){
var index = ref.index;
var item = ref.item;
return [_c('v-list-tile-content',[(_vm.editing === item)?_c('v-text-field',{attrs:{"autofocus":"","flat":"","background-color":"transparent","hide-details":"","solo":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.edit(index, item)}},model:{value:(_vm.editing.text),callback:function ($$v) {_vm.$set(_vm.editing, "text", $$v)},expression:"editing.text"}}):_c('v-chip',{attrs:{"color":((item.color) + " lighten-3"),"dark":"","label":"","small":""}},[_vm._v(_vm._s(item.text))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-list-tile-action',{on:{"click":function($event){$event.stopPropagation();}}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.edit(index, item)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.editing !== item ? 'edit' : 'check'))])],1)],1),_vm._v(" "),_c('v-list-tile-action',{on:{"click":function($event){$event.stopPropagation();}}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.middleDel(item)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}],null,true),model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('template',{staticStyle:{},slot:"no-data"},[_c('v-list-tile',{staticStyle:{"max-height":"110px"}},[_c('small',[_vm._v("\n                  Aperte\n                  "),_c('b',[_vm._v("enter")]),_vm._v(" para adicionar o e-mail\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-chip',{staticClass:"env_email",attrs:{"title":_vm.search,"color":((_vm.colors[_vm.nonce - 1]) + " lighten-3"),"label":"","small":""}},[_vm._v(_vm._s(_vm.search))])],1)],1)],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){_vm.downloadFechamento(_vm.model.map(function (item) { return item.text; }), _vm.empresa)}}},[_vm._v("Enviar")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"align-center":"","justify-center":"","xs12":""}},[_c('div',{staticClass:"desc_exportacao"},[_vm._v("Fazer download:")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"yellow darken-2"},on:{"click":function($event){return _vm.downloadFechamento([_vm.conta.email], _vm.empresa)}}},[_vm._v("Baixar")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialogDelete),callback:function ($$v) {_vm.dialogDelete=$$v},expression:"dialogDelete"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('small',[_vm._v("Confirmar remoção de e-mail")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Deseja remover \"\n        "),_c('strong',[_vm._v(_vm._s(_vm.mailDelete ? _vm.mailDelete.text : ''))]),_vm._v("\" da lista ?\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","small":"","flat":"flat"},on:{"click":function($event){return _vm.delMail(false)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"success"},on:{"click":function($event){return _vm.delMail(true)}}},[_vm._v("Remover")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fechamentoMes"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('svg',{staticStyle:{"width":"24px","height":"24px","margin-left":"87px","margin-bottom":"-4px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#fff","d":"M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M16.53,11.06L15.47,10L10.59,14.88L8.47,12.76L7.41,13.82L10.59,17L16.53,11.06Z"}})]),_vm._v("\n          Fechamento de Mês\n          "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.empresa._id)?_c('v-icon',{staticClass:"mr-2 ml-2 loading fechamento_loop"},[_vm._v("loop")]):_vm._e()],1)],1)])],1)],1),_vm._v(" "),(_vm.empresa._id)?_c('v-card',{staticClass:"card_fechamentoMes",attrs:{"flat":""}},[_c('small',{staticClass:"desc_ribbon"},[_vm._v("Fechamento de mês para:")]),_vm._v(" "),_c('v-combobox',{staticClass:"fechamento_listaEmpresas",attrs:{"items":_vm.conta.list_empresas,"chips":"","color":"teal","return-object":"","label":"Empresas: ","item-text":"razao","multiple":true,"item-value":"_id","menu-props":{contentClass:'email_combo'}},on:{"change":_vm.handleEmpresas},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"v-chip--select-multi",attrs:{"selected":data.selected,"disabled":data.disabled,"close":""},on:{"input":function($event){return _vm.remove(data.item)}}},[_c('v-avatar',{staticClass:"teal white--text"},[_vm._v(_vm._s(data.item != undefined && data.item.razao ? data.item.razao.slice(0, 1).toUpperCase() : ''))]),_vm._v(" "),_vm._v("\n          "+_vm._s(data.item.razao)+"\n        ")],1)]}}],null,false,12943596),model:{value:(_vm.emprSelecionadas),callback:function ($$v) {_vm.emprSelecionadas=$$v},expression:"emprSelecionadas"}}),_vm._v(" "),_c('Stepper',{attrs:{"empresa":_vm.emprSelecionadas,"conta":_vm.conta,"alert":_vm.alert}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loja_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_453c14a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loja_vue__ = __webpack_require__(841);
function injectStyle (ssrContext) {
  __webpack_require__(826)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-453c14a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_453c14a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LojaItem_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f73b7688_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LojaItem_vue__ = __webpack_require__(829);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LojaItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f73b7688_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LojaItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"shopItem"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(830)("./" + (this.item.image))}}),_vm._v(" "),_c('div',[_c('v-card-title',{staticStyle:{"margin-bottom":"25%"},attrs:{"primary-title":""}},[_c('h3',{staticClass:"mb-0",staticStyle:{"white-space":"nowrap"}},[_vm._v("+ "+_vm._s(this.item.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"font-size":"1em"}},[_vm._v(" "+_vm._s(this.item.description)+" ")]),_vm._v(" "),_c('span',{staticClass:"valor-span"},[_c('strong',[_vm._v("Valor mensal:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"green"}},[_vm._v(" R$ "+_vm._s(this.item.price)+" ")])]),_vm._v(" "),_c('span',{staticClass:"video-span"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-youtube")]),_c('a',{staticClass:"video-link",attrs:{"href":this.item.link,"target":"_blank"}},[_vm._v("Vídeo demonstração")])],1)]),_vm._v(" "),_c('div',[_c('v-card-actions',{staticStyle:{"margin-bottom":"0px","padding":"0px:height:15px","margin-top":"22px","position":"absolute","bottom":"0","width":"100%","left":"15px"}},[_c('v-btn',{class:[_vm.status === 'Em andamento' ? 'analise' : ( _vm.status === 'Adquirido' ? 'adquirido' : '' )],staticStyle:{"color":"white","background":"teal","width":"90%","margin-bottom":"10%"},on:{"click":_vm.handleClickButton}},[_c('v-icon',{staticStyle:{"margin-right":"3px"},attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.status))],1)],1),_vm._v(" "),(_vm.status === 'Em andamento')?_c('v-card-text',{staticStyle:{"padding":"0px","margin-top":"-20px","text-align":"center","position":"absolute","bottom":"6px","left":"0px"}},[_c('span',{staticStyle:{"color":"green","font-size":"0.8em"}},[_vm._v(" Aguarde que nossa equipe entrará em contato. ")])]):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cnd_federal.png": 831,
	"./cnd_municipal.png": 832,
	"./emails_caixa_postal.png": 833,
	"./extrato_dctf.png": 834,
	"./guias.png": 835,
	"./iptu.png": 836,
	"./processos.png": 837,
	"./relação_de_darfs_pagos.png": 838,
	"./relação_de_nfs.png": 839,
	"./situacao_fiscal.png": 840
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 830;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cnd_federal.3cde30b.png";

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cnd_municipal.075f2c2.png";

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/emails_caixa_postal.e617a4c.png";

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/extrato_dctf.56be8a1.png";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guias.0bdb28a.png";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iptu.caeacee.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/processos.c15b3a6.png";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/relação_de_darfs_pagos.5517e87.png";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/relação_de_nfs.0bb9890.png";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/situacao_fiscal.2683ce9.png";

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fechamentoMes"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('v-icon',{staticStyle:{"color":"white","margin-left":"87px"}},[_vm._v("mdi-store")]),_vm._v("\n          Loja\n          "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.empresa._id || !_vm.openStore)?_c('v-icon',{staticClass:"mr-2 ml-2 loading fechamento_loop"},[_vm._v("loop")]):_vm._e()],1)],1)])],1)],1),_vm._v(" "),(_vm.empresa._id && _vm.openStore)?_c('v-card',{staticClass:"card_loja",attrs:{"flat":""}},_vm._l((_vm.items),function(item){return _c('LojaItem',{key:item.id,attrs:{"item":item,"conta":_vm.conta,"empresa":_vm.empresa}})}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidaOcr_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f36eb3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidaOcr_vue__ = __webpack_require__(845);
function injectStyle (ssrContext) {
  __webpack_require__(843)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61f36eb3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidaOcr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f36eb3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidaOcr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNfseOcr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return saveOcr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return verifyOcr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return verifyDuplicate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return denyOcr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFileOcr; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var producao = window.location.href.indexOf("app.motorfiscal") != -1 ? true : false;
var url = producao ? "https://apiv2.motorfiscal.com.br:2024" : "https://apiv2homolog.motorfiscal.com.br";

var getNfseOcr = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var dataIni = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var dataFim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var cnpj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var verificado = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var status_ocr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + "/valida-ocr?dataIni=" + dataIni + "&dataFim=" + dataFim + "&cnpj=" + cnpj + "&verificadoOcr=" + verificado + "&statusOcr=" + status_ocr);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function getNfseOcr() {
    return _ref.apply(this, arguments);
  };
}();

var saveOcr = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(nfseOcr, id_usuario) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url + "/verificaNfse", {
              nfseOcr: nfseOcr,
              _id: nfseOcr._id,
              id_usuario: id_usuario
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", null);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 7]]);
  }));

  return function saveOcr(_x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

var verifyOcr = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id, id_usuario) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.log(id_usuario);
            _context3.prev = 1;
            _context3.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url + "/verificaNfse", {
              _id: id,
              id_usuario: id_usuario
            });

          case 4:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", null);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[1, 8]]);
  }));

  return function verifyOcr(_x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

var verifyDuplicate = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(numero_nota, cod_verificador, cnpj_prestador, codMun, _id, id_usuario) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url + "/verifica-duplicidade", {
              numero_nota: numero_nota,
              cod_verificador: cod_verificador,
              cnpj_prestador: cnpj_prestador,
              codMun: codMun,
              _id: _id,
              id_usuario: id_usuario
            });

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", null);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[0, 7]]);
  }));

  return function verifyDuplicate(_x10, _x11, _x12, _x13, _x14, _x15) {
    return _ref4.apply(this, arguments);
  };
}();

var denyOcr = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id, state, id_usuario) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url + "/alterar_status_processamento/" + state, { _id: id, id_usuario: id_usuario });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", null);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this, [[0, 7]]);
  }));

  return function denyOcr(_x16, _x17, _x18) {
    return _ref5.apply(this, arguments);
  };
}();

var getFileOcr = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + "/busca-pdf/" + id);

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", null);

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this, [[0, 7]]);
  }));

  return function getFileOcr(_x19) {
    return _ref6.apply(this, arguments);
  };
}();

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relatorio"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('svg',{staticStyle:{"width":"24px","height":"24px","margin-left":"87px","margin-bottom":"-4px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#fff","d":"M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"}})]),_vm._v("\n          Valida OCR\n        ")])])],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"width":"90%","margin":"0 auto 40px auto","padding":"41px 41px 0px 41px","background-color":"#efefef"},attrs:{"flat":"","id":""}},[(_vm.successMessage)?_c('div',[_c('v-alert',{staticStyle:{"padding":"5px"},attrs:{"value":true,"type":"success","dismissible":true}},[_vm._v("\n        "+_vm._s(_vm.successMessage)+"\n\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',[_c('v-alert',{staticStyle:{"padding":"5px"},attrs:{"value":true,"type":"error","dismissible":true}},[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('v-text-field',{attrs:{"return-masked-value":"","mask":"##/##/####","clearable":"","label":"Data Inicio"},model:{value:(_vm.dataIni),callback:function ($$v) {_vm.dataIni=$$v},expression:"dataIni"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"margin-left":"30px"},attrs:{"return-masked-value":"","mask":"##/##/####","clearable":"","label":"Data Fim"},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"margin-left":"30px"},attrs:{"return-masked-value":"","mask":"##.###.###/####-##","clearable":"","label":"CNPJ Empresa Upload"},model:{value:(_vm.cnpj),callback:function ($$v) {_vm.cnpj=$$v},expression:"cnpj"}}),_vm._v(" "),_c('v-select',{staticStyle:{"margin-left":"30px"},attrs:{"clearable":"","items":['Sim', 'Não'],"label":"Verificado"},model:{value:(_vm.verificado),callback:function ($$v) {_vm.verificado=$$v},expression:"verificado"}}),_vm._v(" "),_c('v-select',{staticStyle:{"margin-left":"30px","overflow-y":"hidden"},attrs:{"clearable":"","items":['Processada', 'pendente', 'Sucesso Manual', 'Desconsiderado', 'Boleto', 'Falha', 'Duplicada','Processada IA'],"label":"Status OCR"},model:{value:(_vm.status_ocr),callback:function ($$v) {_vm.status_ocr=$$v},expression:"status_ocr"}})],1),_vm._v(" "),_c('div',[_c('v-card',[_c('v-card-title',[_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.vOcrUpdate}},[_vm._v("Buscar")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.vOcrSevenDays}},[_vm._v("7 dias")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.vOcrCurrentMonth}},[_vm._v("Mês Atual")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.vOcrLastMonth}},[_vm._v("Mês Anterior")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.vOcrClear}},[_vm._v("Limpar filtros")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.body,"search":_vm.search,"hide-actions":"","pagination":_vm.pagination,"loading":_vm.isLoading,"id":"table"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([(!_vm.isLoading)?{key:"items",fn:function(props){return [_c('tr',{style:({ 'background': props.item.pathPdf ? '' : '#ffe5e3' })},[_c('td',{staticClass:"text-xs-center"},[_c('span',{staticClass:"ocrLink",on:{"click":function($event){return _vm.vOcrOpenFile(props.item)}}},[_vm._v("ACESSAR")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"small":"","color":props.item.verificadoOcr !== 'None' && props.item.verificadoOcr ? 'green' : 'red',"text-color":"white"}},[_c('span',[_vm._v(_vm._s(props.item.verificadoOcr !== 'None' && props.item.verificadoOcr ? 'Sim' : 'Não'))])])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"small":"","color":props.item.ocr_status ?
                  props.item.ocr_status === 'Processada' ?
                    'green' :
                    props.item.ocr_status === 'pendente' ?
                      'orange' :
                      props.item.ocr_status === 'Sucesso Manual' ?
                        'blue' :
                        props.item.ocr_status === 'Falha' ?
                          'red' : 
                          props.item.ocr_status === 'Processada IA' ?
                          'purple' :'grey darken-3'
                  : 'grey darken-3',"text-color":"white"}},[_c('span',[_vm._v(_vm._s(props.item.ocr_status ? props.item.ocr_status : 'Não possui'))])])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.empresa.razao + ' ' +
                props.item.empresa.cnpj))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(Number(props.item.numeroNfe)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.codVerificacao))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.cnpjCpfTomador != undefined ?
                (props.item.cnpjCpfTomador.length > 11 ?
                  props.item.cnpjCpfTomador.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") :
                  props.item.cnpjCpfTomador.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.razaoTomador))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.dtEmissaoNfe))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.ocr_log ? props.item.ocr_log : '')+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.cnpjCpfPrestador != undefined ?
                (props.item.cnpjCpfPrestador.length > 11 ?
                  props.item.cnpjCpfPrestador.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") :
                  props.item.cnpjCpfPrestador.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.razaoPrestador))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.createdAt))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.codServico))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.aliqServico))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.ISS))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.ISSRetido))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item._id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.nome_municipio))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.UFPrestador))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.dt_processamento != undefined ?
                props.item.dt_processamento.substring(0, 16) : ""))])])]}}:null,{key:"no-results",fn:function(){return [_c('v-alert',{attrs:{"value":true,"color":"error","icon":"warning"}},[_vm._v("\n              \""+_vm._s(_vm.search)+"\" não encontrado.\n            ")])]},proxy:true},{key:"pageText",fn:function(props){return [_c('strong',[_vm._v("\n              Exibindo "+_vm._s(props.pagination.page)+" - "+_vm._s(14)+" do total de "+_vm._s(props.pages)+"\n              "),_c('span',[_vm._v("Notas")])])]}}],null,true)},[_c('v-progress-linear',{staticStyle:{"z-index":"3"},attrs:{"slot":"progress","color":"teal","height":"20","indeterminate":""},slot:"progress"}),_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"color":"indigo darken-4","icon":"info","outline":""}},[(_vm.isLoading)?_c('article',[_vm._v("Motor Fiscal está buscando as informações")]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('article',[_vm._v("\n                Dados não encontrados\n              ")]):_vm._e()])],1)],2),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-2"},[_c('v-pagination',{attrs:{"length":_vm.pages},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}})],1)],1)],1)]),_vm._v(" "),(_vm.dialog)?_c('v-dialog',{attrs:{"persistent":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',{staticStyle:{"display":"flex","padding-top":"0","padding-bottom":"0"}},[_c('v-container',{staticStyle:{"margin-top":"0","overflow":"scroll","height":"90vh"},attrs:{"grid-list-md":""}},[_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end","flex-wrap":"wrap"}},[(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},attrs:{"disabled":!_vm.docPrestador || !_vm.docTomador || !_vm.cidade || !_vm.estado || !_vm.editedItem.vlrServico || !_vm.editedItem.numeroNfe || !_vm.editedItem.razaoTomador || !_vm.editedItem.razaoPrestador || !_vm.editedItem.codVerificacao || !_vm.editedItem.dtEmissaoNfe || !_vm.editedItem.descServico || !_vm.editedItem.codServico || !_vm.editedItem.discriminacao || !_vm.editedItem.aliqServico || (_vm.editedItem.cnpjCpfPrestador === _vm.editedItem.cnpjCpfTomador)},on:{"click":_vm.vOcrSave}},[_vm._v("Salvar")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},attrs:{"disabled":_vm.desabilita_campo},on:{"click":_vm.VeriricaDuplicidade}},[_vm._v("Verificar Duplicidade")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.vOcrVerify}},[_vm._v("Verificar")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":function($event){return _vm.vOcrAlterState('pendente')}}},[_vm._v("Pendente")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":function($event){return _vm.vOcrAlterState('duplicada')}}},[_vm._v("Duplicada")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"red","color":"white"},on:{"click":function($event){return _vm.vOcrAlterState('desconsiderado')}}},[_vm._v("Desconsiderar")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"red","color":"white"},on:{"click":function($event){return _vm.vOcrAlterState('boleto')}}},[_vm._v("Boleto")]):_vm._e(),_vm._v(" "),(_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"gray","color":"black"},attrs:{"disabled":""}},[_vm._v("Processando...")]):_vm._e(),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Fechar")])],1),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),(_vm.successMessageDuplicidade)?_c('div',[_c('v-alert',{staticStyle:{"padding":"5px"},attrs:{"value":true,"type":"success","dismissible":true}},[_vm._v("\n              "+_vm._s(_vm.successMessageDuplicidade)+"\n            ")])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":"","label":"ID"},model:{value:(_vm.editedItem._id),callback:function ($$v) {_vm.$set(_vm.editedItem, "_id", $$v)},expression:"editedItem._id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"rules":_vm.validationRules,"label":"Número da NFe"},on:{"blur":function($event){return _vm.regra_verifica_duplicidade()}},model:{value:(_vm.editedItem.numeroNfe),callback:function ($$v) {_vm.$set(_vm.editedItem, "numeroNfe", $$v)},expression:"editedItem.numeroNfe"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"rules":_vm.validationRules,"id":"codUpper","label":"Código Verificação"},on:{"blur":function($event){return _vm.regra_verifica_duplicidade()}},model:{value:(_vm.editedItem.codVerificacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "codVerificacao", $$v)},expression:"editedItem.codVerificacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"mask":_vm.mask.cnpjPrestador,"label":"CNPJ/CPF Prestador","clearable":"","rules":_vm.editedItem.cnpjCpfPrestador ? (_vm.editedItem.cnpjCpfPrestador.length > 11 ? _vm.cnpjRules : _vm.cpfRules) : _vm.cnpjRules},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }_vm.mask ? _vm.mask.cnpjPrestador = '' : ''},"keyup":function($event){return _vm.trocaCampoCpfCnpjPrestador($event, _vm.editedItem.cnpjCpfPrestador)},"blur":function($event){_vm.buscaReceitaPrestador(); _vm.regra_verifica_duplicidade()}},model:{value:(_vm.editedItem.cnpjCpfPrestador),callback:function ($$v) {_vm.$set(_vm.editedItem, "cnpjCpfPrestador", $$v)},expression:"editedItem.cnpjCpfPrestador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-autocomplete',{attrs:{"autocomplete":false,"validate-on-blur":"","item-text":"sigla","items":_vm.arrayEstados,"label":"Estado Prestador","clearable":"","persistent-hint":"","no-data-text":"Consulta de Estado indisponível","return-object":"","rules":_vm.validationRules},on:{"change":_vm.getMunicipiosPrestador,"blur":function($event){return _vm.regra_verifica_duplicidade()}},model:{value:(_vm.estado),callback:function ($$v) {_vm.estado=$$v},expression:"estado"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-autocomplete',{attrs:{"label":"Cidade Prestador","autocomplete":false,"validate-on-blur":"","item-text":"nome","items":_vm.arrayMunicipiosPrestador,"clearable":"","no-data-text":"Selecione um Estado","return-object":"","rules":_vm.validationRules},on:{"blur":function($event){return _vm.regra_verifica_duplicidade()}},model:{value:(_vm.cidade),callback:function ($$v) {_vm.cidade=$$v},expression:"cidade"}})],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Serie da NFe"},model:{value:(_vm.editedItem.serie),callback:function ($$v) {_vm.$set(_vm.editedItem, "serie", $$v)},expression:"editedItem.serie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"rules":_vm.validationRules,"return-masked-value":"","mask":"##/##/#### ##:##:##","label":"Data Emissão"},model:{value:(_vm.editedItem.dtEmissaoNfe),callback:function ($$v) {_vm.$set(_vm.editedItem, "dtEmissaoNfe", $$v)},expression:"editedItem.dtEmissaoNfe"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Número RPS"},model:{value:(_vm.editedItem.numRPS),callback:function ($$v) {_vm.$set(_vm.editedItem, "numRPS", $$v)},expression:"editedItem.numRPS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Serie RPS"},model:{value:(_vm.editedItem.serieRPS),callback:function ($$v) {_vm.$set(_vm.editedItem, "serieRPS", $$v)},expression:"editedItem.serieRPS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Tipo RPS"},model:{value:(_vm.editedItem.tipoRPS),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipoRPS", $$v)},expression:"editedItem.tipoRPS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"return-masked-value":"","mask":"##/##/#### ##:##:##","label":"Data de Emissão RPS"},model:{value:(_vm.editedItem.dtEmissaoRPS),callback:function ($$v) {_vm.$set(_vm.editedItem, "dtEmissaoRPS", $$v)},expression:"editedItem.dtEmissaoRPS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Número do Lote"},model:{value:(_vm.editedItem.numLote),callback:function ($$v) {_vm.$set(_vm.editedItem, "numLote", $$v)},expression:"editedItem.numLote"}})],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.desabilita_campo,"rules":_vm.validationRules,"rows":"1","auto-grow":"","label":"Razão Prestador"},model:{value:(_vm.editedItem.razaoPrestador),callback:function ($$v) {_vm.$set(_vm.editedItem, "razaoPrestador", $$v)},expression:"editedItem.razaoPrestador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"disabled":_vm.desabilita_campo,"items":[
                { text: 'Rua', value: 'Rua' },
                { text: 'Avenida', value: 'Avenida' },
                { text: 'Travessa', value: 'Travessa' },
                { text: 'Praça', value: 'Praça' },
                { text: 'Alameda', value: 'Alameda' },
                { text: 'Largo', value: 'Largo' }
              ],"label":"Tipo Logradouro Prestador"},model:{value:(_vm.editedItem.enderecoPrestadorTipoLogradouro),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoPrestadorTipoLogradouro", $$v)},expression:"editedItem.enderecoPrestadorTipoLogradouro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Número endereço Prestador"},model:{value:(_vm.editedItem.enderecoPrestadorNumeroEndereco),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoPrestadorNumeroEndereco", $$v)},expression:"editedItem.enderecoPrestadorNumeroEndereco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Bairro Prestador"},model:{value:(_vm.editedItem.enderecoPrestadorBairro),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoPrestadorBairro", $$v)},expression:"editedItem.enderecoPrestadorBairro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Complemento endereço Prestador"},model:{value:(_vm.editedItem.enderecoPrestadorComplementoEndereco),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoPrestadorComplementoEndereco", $$v)},expression:"editedItem.enderecoPrestadorComplementoEndereco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Endereço Prestador"},model:{value:(_vm.editedItem.enderecoPrestadorLogradouro),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoPrestadorLogradouro", $$v)},expression:"editedItem.enderecoPrestadorLogradouro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Inscrição Municipal Prestador"},model:{value:(_vm.editedItem.inscPrestador),callback:function ($$v) {_vm.$set(_vm.editedItem, "inscPrestador", $$v)},expression:"editedItem.inscPrestador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Inscrição Estadual Prestador"},model:{value:(_vm.editedItem.inscriEsPrestador),callback:function ($$v) {_vm.$set(_vm.editedItem, "inscriEsPrestador", $$v)},expression:"editedItem.inscriEsPrestador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"CEP Prestador"},model:{value:(_vm.editedItem.enderecoPrestadorCEP),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoPrestadorCEP", $$v)},expression:"editedItem.enderecoPrestadorCEP"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Telefone Prestador"},model:{value:(_vm.editedItem.telefonePrestador),callback:function ($$v) {_vm.$set(_vm.editedItem, "telefonePrestador", $$v)},expression:"editedItem.telefonePrestador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Email Prestador","rules":_vm.validaEmail,"validate-on-blur":""},model:{value:(_vm.editedItem.emailPrestador),callback:function ($$v) {_vm.$set(_vm.editedItem, "emailPrestador", $$v)},expression:"editedItem.emailPrestador"}})],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"mask":_vm.mask.cnpjTomador,"label":"CNPJ/CPF Tomador","clearable":"","rules":_vm.editedItem.cnpjCpfTomador ? (_vm.editedItem.cnpjCpfTomador.length > 11 ? _vm.cnpjRules : _vm.cpfRules) : _vm.cnpjRules},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }_vm.mask ? _vm.mask.cnpjTomador = '' : ''},"keyup":function($event){return _vm.trocaCampoCpfCnpjTomador($event, _vm.editedItem.cnpjCpfTomador)},"blur":function($event){return _vm.buscaReceitaTomador()}},model:{value:(_vm.editedItem.cnpjCpfTomador),callback:function ($$v) {_vm.$set(_vm.editedItem, "cnpjCpfTomador", $$v)},expression:"editedItem.cnpjCpfTomador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-autocomplete',{attrs:{"autocomplete":false,"validate-on-blur":"","item-text":"sigla","items":_vm.arrayEstados,"label":"Estado Tomador","clearable":"","persistent-hint":"","no-data-text":"Consulta de Estado indisponível","return-object":"","rules":_vm.validationRules,"disabled":_vm.desabilita_campo},on:{"change":_vm.getMunicipiosTomador},model:{value:(_vm.estadoTomador),callback:function ($$v) {_vm.estadoTomador=$$v},expression:"estadoTomador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-autocomplete',{attrs:{"label":"Cidade Tomador","autocomplete":false,"validate-on-blur":"","item-text":"nome","items":_vm.arrayMunicipiosTomador,"clearable":"","no-data-text":"Selecione um Estado","return-object":"","rules":_vm.validationRules,"disabled":_vm.desabilita_campo},model:{value:(_vm.cidadeTomador),callback:function ($$v) {_vm.cidadeTomador=$$v},expression:"cidadeTomador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.desabilita_campo,"rules":_vm.validationRules,"rows":"1","auto-grow":"","label":"Razão Tomador"},model:{value:(_vm.editedItem.razaoTomador),callback:function ($$v) {_vm.$set(_vm.editedItem, "razaoTomador", $$v)},expression:"editedItem.razaoTomador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"disabled":_vm.desabilita_campo,"items":[
                { text: 'Rua', value: 'Rua' },
                { text: 'Avenida', value: 'Avenida' },
                { text: 'Travessa', value: 'Travessa' },
                { text: 'Praça', value: 'Praça' },
                { text: 'Alameda', value: 'Alameda' },
                { text: 'Largo', value: 'Largo' }
              ],"label":"Tipo Logradouro Tomador"},model:{value:(_vm.editedItem.enderecoTomadorTipoLogradouro),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoTomadorTipoLogradouro", $$v)},expression:"editedItem.enderecoTomadorTipoLogradouro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Número endereço Tomador"},model:{value:(_vm.editedItem.enderecoTomadorNumeroEndereco),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoTomadorNumeroEndereco", $$v)},expression:"editedItem.enderecoTomadorNumeroEndereco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Bairro Tomador"},model:{value:(_vm.editedItem.enderecoTomadorBairro),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoTomadorBairro", $$v)},expression:"editedItem.enderecoTomadorBairro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Endereço Tomador"},model:{value:(_vm.editedItem.enderecoTomadorLogradouro),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoTomadorLogradouro", $$v)},expression:"editedItem.enderecoTomadorLogradouro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Complemento endereço Tomador"},model:{value:(_vm.editedItem.enderecoTomadorComplementoEndereco),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoTomadorComplementoEndereco", $$v)},expression:"editedItem.enderecoTomadorComplementoEndereco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"CEP Tomador"},model:{value:(_vm.editedItem.enderecoTomadorCEP),callback:function ($$v) {_vm.$set(_vm.editedItem, "enderecoTomadorCEP", $$v)},expression:"editedItem.enderecoTomadorCEP"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Email Tomador","rules":_vm.validaEmail,"validate-on-blur":""},model:{value:(_vm.editedItem.emailTomador),callback:function ($$v) {_vm.$set(_vm.editedItem, "emailTomador", $$v)},expression:"editedItem.emailTomador"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Inscrição Municipal Tomador"},model:{value:(_vm.editedItem.inscTomador),callback:function ($$v) {_vm.$set(_vm.editedItem, "inscTomador", $$v)},expression:"editedItem.inscTomador"}})],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{staticStyle:{"width":"100%","font-size":"0.8em"},attrs:{"disabled":_vm.desabilita_campo,"rules":_vm.validationRules,"rows":"2","auto-grow":"","label":"Discriminacao"},model:{value:(_vm.editedItem.discriminacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "discriminacao", $$v)},expression:"editedItem.discriminacao"}})],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"rules":_vm.validationRules,"label":"Cod Serviço / Atividade"},model:{value:(_vm.editedItem.codServico),callback:function ($$v) {_vm.$set(_vm.editedItem, "codServico", $$v)},expression:"editedItem.codServico"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{staticStyle:{"width":"100%","font-size":"0.8em"},attrs:{"disabled":_vm.desabilita_campo,"rules":_vm.validationRules,"rows":"1","auto-grow":"","label":"Desc Serviço / Atividade"},model:{value:(_vm.editedItem.descServico),callback:function ($$v) {_vm.$set(_vm.editedItem, "descServico", $$v)},expression:"editedItem.descServico"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Cod Lei"},model:{value:(_vm.editedItem.lei.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem.lei, "codigo", $$v)},expression:"editedItem.lei.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{staticStyle:{"width":"100%","font-size":"0.8em"},attrs:{"disabled":_vm.desabilita_campo,"rows":"1","auto-grow":"","label":"Desc Lei"},model:{value:(_vm.editedItem.lei.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem.lei, "descricao", $$v)},expression:"editedItem.lei.descricao"}})],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"PIS"},model:{value:(_vm.editedItem.PIS),callback:function ($$v) {_vm.$set(_vm.editedItem, "PIS", $$v)},expression:"editedItem.PIS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"COFINS"},model:{value:(_vm.editedItem.COFINS),callback:function ($$v) {_vm.$set(_vm.editedItem, "COFINS", $$v)},expression:"editedItem.COFINS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"IR"},model:{value:(_vm.editedItem.IR),callback:function ($$v) {_vm.$set(_vm.editedItem, "IR", $$v)},expression:"editedItem.IR"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"INSS"},model:{value:(_vm.editedItem.INSS),callback:function ($$v) {_vm.$set(_vm.editedItem, "INSS", $$v)},expression:"editedItem.INSS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"CSLL"},model:{value:(_vm.editedItem.CSLL),callback:function ($$v) {_vm.$set(_vm.editedItem, "CSLL", $$v)},expression:"editedItem.CSLL"}})],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm4":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"ISS"},model:{value:(_vm.editedItem.ISS),callback:function ($$v) {_vm.$set(_vm.editedItem, "ISS", $$v)},expression:"editedItem.ISS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md3":""}},[_c('v-select',{attrs:{"disabled":_vm.desabilita_campo,"items":[{ text: 'Sim', value: 'true' }, { text: 'Não', value: 'false' }],"label":"ISS Retido"},model:{value:(_vm.editedItem.ISSRetido),callback:function ($$v) {_vm.$set(_vm.editedItem, "ISSRetido", $$v)},expression:"editedItem.ISSRetido"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"rules":_vm.validationRules,"label":"Aliq Serviço"},model:{value:(_vm.editedItem.aliqServico),callback:function ($$v) {_vm.$set(_vm.editedItem, "aliqServico", $$v)},expression:"editedItem.aliqServico"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Deduções"},model:{value:(_vm.editedItem.deducoes),callback:function ($$v) {_vm.$set(_vm.editedItem, "deducoes", $$v)},expression:"editedItem.deducoes"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":"","md7":""}},[_c('v-select',{attrs:{"disabled":_vm.desabilita_campo,"items":[
                { text: 'Não optante pelo Simples Federal nem Municipal', value: '0' },
                { text: 'Optante pelo Simples Federal (Alíquota de 1,0%)', value: '1' },
                { text: 'Optante pelo Simples Federal (Alíquota de 0,5%)', value: '2' },
                { text: 'Optante pelo Simples Municipal.', value: '3' },
                { text: 'Optante pelo Simples Nacional.', value: '4' },
                { text: 'Não Contratado', value: '5' }
              ],"label":"Opção Simples"},model:{value:(_vm.editedItem.opcaoSimples),callback:function ($$v) {_vm.$set(_vm.editedItem, "opcaoSimples", $$v)},expression:"editedItem.opcaoSimples"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Outras Retenções"},model:{value:(_vm.editedItem.outrasRetencoes),callback:function ($$v) {_vm.$set(_vm.editedItem, "outrasRetencoes", $$v)},expression:"editedItem.outrasRetencoes"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"disabled":!_vm.docPrestador || !_vm.cidade || !_vm.editedItem.numeroNfe || !_vm.editedItem.codVerificacao,"items":[
                  { text: 'Tributado em São Paulo.', value: 'T' },
                  { text: 'Tributado Fora de São Paulo.', value: 'F' },
                  { text: 'Tributado em São Paulo, porém Isento.', value: 'A' },
                  { text: 'Tributado Fora de São Paulo, porém Isento.', value: 'B' },
                  { text: 'Tributado em São Paulo com isenção parcia.', value: 'D' },
                  { text: 'Tributado em São Paulo, porém com indicação de imunidade subjetiva.', value: 'M' },

                  { text: 'Tributado Fora de São Paulo, porém com indicação de imunidade subjetiva.', value: 'N' },
                  { text: 'Tributado em São Paulo, porém com indicação de imunidade objetiva.', value: 'R' },
                  { text: 'Tributado fora de São Paulo, porém com indicação de imunidade objetiva.', value: 'S' },
                  { text: 'Tributado em São Paulo, porém Exigibilidade Suspensa.', value: 'X' },
                  { text: 'Tributado Fora de São Paulo, porém Exigibilidade Suspensa.', value: 'V' },
                  { text: 'Exportação de Serviços.', value: 'P' },
                  { text: 'Upload, sem informação de tributação.', value: 'U0' } ],"label":"Trib NFe"},model:{value:(_vm.editedItem.tribNfe),callback:function ($$v) {_vm.$set(_vm.editedItem, "tribNfe", $$v)},expression:"editedItem.tribNfe"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"label":"Valor Crédito"},model:{value:(_vm.editedItem.vlrCredito),callback:function ($$v) {_vm.$set(_vm.editedItem, "vlrCredito", $$v)},expression:"editedItem.vlrCredito"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.desabilita_campo,"rules":_vm.validationRules,"label":"Valor Serviço"},model:{value:(_vm.editedItem.vlrServico),callback:function ($$v) {_vm.$set(_vm.editedItem, "vlrServico", $$v)},expression:"editedItem.vlrServico"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end","flex-wrap":"wrap"}},[(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},attrs:{"disabled":!_vm.docPrestador || !_vm.docTomador || !_vm.cidade || !_vm.estado || !_vm.editedItem.vlrServico || !_vm.editedItem.numeroNfe || !_vm.editedItem.razaoTomador || !_vm.editedItem.razaoPrestador || !_vm.editedItem.codVerificacao || !_vm.editedItem.dtEmissaoNfe || !_vm.editedItem.descServico || !_vm.editedItem.codServico || !_vm.editedItem.discriminacao || !_vm.editedItem.aliqServico || (_vm.editedItem.cnpjCpfPrestador === _vm.editedItem.cnpjCpfTomador)},on:{"click":_vm.vOcrSave}},[_vm._v("Salvar")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.vOcrVerify}},[_vm._v("Verificar")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":function($event){return _vm.vOcrAlterState('pendente')}}},[_vm._v("Pendente")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":function($event){return _vm.vOcrAlterState('duplicada')}}},[_vm._v("Duplicada")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"red","color":"white"},on:{"click":function($event){return _vm.vOcrAlterState('desconsiderar')}}},[_vm._v("Desconsiderar")]):_vm._e(),_vm._v(" "),(!_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"red","color":"white"},on:{"click":function($event){return _vm.vOcrAlterState('boleto')}}},[_vm._v("Boleto")]):_vm._e(),_vm._v(" "),(_vm.isBtnLoading)?_c('v-btn',{staticStyle:{"background":"gray","color":"black"},attrs:{"disabled":""}},[_vm._v("Processando...")]):_vm._e(),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Fechar")])],1)],1),_vm._v(" "),_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"src":'data:application/pdf;base64,' + encodeURIComponent(this.ocrFile),"frameborder":"0"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isFileLoading)?_c('div',{staticClass:"cont-ocr"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainMenu',{attrs:{"logado":true,"attEmpresas":this.attEmpresas,"conta":this.conta,"alert":this.alert,"firstAccess":this.firstAccess},on:{"emitAttEmpresas":function($event){return _vm.emitAttEmpresas($event)},"getNewEmp":function($event){return _vm.getNewEmp($event)}}}),_vm._v(" "),_c('AlertComponent',{attrs:{"alert":this.alert}}),_vm._v(" "),_c(_vm.component.name,{tag:"component",attrs:{"conta":this.conta,"alert":this.alert,"empresa":_vm.empresa,"IBGE":this.IBGE,"firstAccess":this.firstAccess},on:{"emitAttEmpresas":function($event){return _vm.emitAttEmpresas($event)},"getNewEmp":function($event){return _vm.getNewEmp($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestArea_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7523ea2b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestArea_vue__ = __webpack_require__(869);
function injectStyle (ssrContext) {
  __webpack_require__(848)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7523ea2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7523ea2b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestMenu_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b325ab24_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestMenu_vue__ = __webpack_require__(851);
function injectStyle (ssrContext) {
  __webpack_require__(850)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b325ab24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b325ab24_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"white",attrs:{"fixed":""}},[_c('v-toolbar-title',[_c('img',{staticStyle:{"width":"20%","cursor":"pointer"},attrs:{"title":"Motor Fiscal","id":"logo-image","src":__webpack_require__(101),"alt":"Logo da Empresa(Motor Fiscal)"},on:{"click":function($event){return _vm.$router.push('/')}}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},nativeOn:{"click":function($event){return _vm.$router.push('/login')}},slot:"activator"},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#fff","d":"M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"}})])]),_vm._v(" "),_c('span',[_vm._v("Logar no sistema")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8964e78c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(854);
function injectStyle (ssrContext) {
  __webpack_require__(853)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8964e78c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8964e78c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"light":""}},[_c('v-content',[_c('section',{attrs:{"id":"frs_parallax"}},[_c('v-parallax',{staticStyle:{"height":"100vh"},attrs:{"src":"/static/img/home_background.jpg"}},[_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('span',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Motor Fiscal"},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{staticStyle:{"margin-left":"16px"},attrs:{"src":__webpack_require__(152),"alt":"Logo motor","height":"100"}}),_vm._v(" "),_c('h1',{staticClass:"white--text mb-4 display-1 text-xs-center",staticStyle:{"color":"#00aea7!important","font-weight":"500","font-size":"44px!important"}},[_c('span',{staticStyle:{"color":"white","font-weight":"800","letter-spacing":"2px!important"}},[_vm._v("M")]),_vm._v("otor Fiscal")])]),_vm._v(" "),_c('v-btn',{staticClass:"teal",attrs:{"dark":"","large":"","href":"/cadastrar"}},[_vm._v("\n            Conhecer\n          ")])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("A melhor maneira de organização fiscal")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("\n              Tenha acesso a tudo em um único ambiente\n            ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("color_lens")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Fácil utilização")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                    Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. \n                    Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. \n                    Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. \n                  ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("flash_on")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Rápido acesso")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                    Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. \n                    Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. \n                    Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. \n                  ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("build")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Organização fiscal")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                    Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. \n                    Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. \n                    Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. \n                  ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"snd_parallax"}},[_c('v-parallax',{attrs:{"src":"/static/img/home_background_engrenagens.jpg","height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline white--text mb-3 text-xs-center"},[_vm._v("Começe agora e armazene seus documentos fiscais no "),_c('strong',[_vm._v("Motor Fiscal")])]),_vm._v(" "),_c('em',{staticStyle:{"color":"lightslategray"}},[_vm._v("Teste agora!")]),_vm._v(" "),_c('v-btn',{staticClass:"teal",attrs:{"dark":"","large":"","href":"/cadastrar"}},[_vm._v("\n            Conhecer\n          ")])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Compila")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                Com 10 anos de atuação no mercado visando oferecer tecnologia de ponta \n                com o objetivo de alavancar os negócios das empresas,\n                com o passar do tempo identificamos a necessidade de atender um nicho de empresas mais\n                robusto como grandes corporações e multinacionais e hoje atendemos empresas de todos os portes,\n                sempre com um atendimento personalizado e utilizando as melhores ferramentas do mercado.\n                "),_c('br'),_c('strong',[_c('a',{staticClass:"black--text",attrs:{"href":"http://www.compila.com.br","target":"_blank"}},[_vm._v("Visitar site")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm1":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Entre em contato")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                Estamos dispostos a sanar todas as dúvidas.\n              ")]),_vm._v(" "),_c('v-list',{staticClass:"transparent"},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("+55 (11) 4306-3036")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("place")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Av. Paulista, 2006 - 6 Andar")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("contato@compila.com.br")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-footer',{staticStyle:{"background-color":"#25476a!important"}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"white--text ml-3"},[_vm._v("\n            Mais um produto\n            "),_c('v-icon',{staticClass:"red--text"},[_vm._v("favorite")]),_vm._v(" "),_c('a',{staticClass:"white--text",staticStyle:{"text-decoration":"underline"},attrs:{"href":"http://www.compila.com.br","target":"_blank"}},[_vm._v("Compila")])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovaConta_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea4c3700_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovaConta_vue__ = __webpack_require__(864);
function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea4c3700"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovaConta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea4c3700_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovaConta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Empresa_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c3c152_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Empresa_vue__ = __webpack_require__(859);
function injectStyle (ssrContext) {
  __webpack_require__(858)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Empresa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c3c152_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Empresa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"id":"form"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{ref:"cnpj",staticClass:"input-required",attrs:{"mask":_vm.mask.cnpj,"rules":_vm.empresa.cnpj && _vm.empresa.cnpj.length > 11 ? _vm.cnpjRules : _vm.cpfRules,"label":"CNPJ/CPF da empresa:","color":"primary","type":"text","id":"empresa-cnpj","clearable":"","required":"","validate-on-blur":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }_vm.mask ? _vm.mask.cnpj = '' : ''},"keyup":function($event){return _vm.trocaCampoCpfCnpj($event, _vm.empresa.cnpj)},"blur":function($event){return _vm.verificaCNPJ($event)}},model:{value:(_vm.empresa.cnpj),callback:function ($$v) {_vm.$set(_vm.empresa, "cnpj", $$v)},expression:"empresa.cnpj"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-required",attrs:{"rules":_vm.razaoRules,"label":"Razão Social:","type":"text","id":"empresa-razao","clearable":"","validate-on-blur":"","browser-autocomplete":"background-color: red;","required":""},on:{"blur":function($event){return _vm.returnEmpresa($event)}},model:{value:(_vm.empresa.razao),callback:function ($$v) {_vm.$set(_vm.empresa, "razao", $$v)},expression:"empresa.razao"}}),_vm._v(" "),_c('v-autocomplete',{staticClass:"input-required",attrs:{"validate-on-blur":"","item-text":"nome","items":_vm.arrayEstados,"label":"UF:","id":"empresa-uf","persistent-hint":"","color":"teal","no-data-text":"Consulta de Estado indisponível","return-object":"","rules":_vm.razaoRules},on:{"change":function($event){_vm.setUfEmpresa(), _vm.returnEmpresa($event)}},model:{value:(_vm.auxEstado),callback:function ($$v) {_vm.auxEstado=$$v},expression:"auxEstado"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f7b2e48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_vue__ = __webpack_require__(862);
function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f7b2e48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"input-required",attrs:{"tabindex":"1","rules":_vm.nomeRules,"label":"Nome:","type":"text","id":"usuario-nome","validate-on-blur":"","mask":_vm.mask.nome,"clearable":"","required":""},on:{"input":function($event){return _vm.returnUsuario();}},model:{value:(_vm.usuario.nome),callback:function ($$v) {_vm.$set(_vm.usuario, "nome", $$v)},expression:"usuario.nome"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-required",attrs:{"tabindex":"2","rules":_vm.emailRules,"label":"E-mail: (Login)","type":"email","id":"usuario-email","validate-on-blur":"","clearable":"","required":""},on:{"blur":function($event){return _vm.verificaDispEmail();},"input":function($event){return _vm.returnUsuario();}},model:{value:(_vm.usuario.email),callback:function ($$v) {_vm.$set(_vm.usuario, "email", $$v)},expression:"usuario.email"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-required",attrs:{"tabindex":"3","label":"Telefone:","id":"usuario-telefone","validate-on-blur":"","type":'text',"mask":"(##) ##### - ####","clearable":"","required":""},on:{"input":function($event){return _vm.returnUsuario();}},model:{value:(_vm.usuario.telefone),callback:function ($$v) {_vm.$set(_vm.usuario, "telefone", $$v)},expression:"usuario.telefone"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-required",attrs:{"tabindex":"3","rules":_vm.passRules,"label":"Senha:","id":"usuario-password","validate-on-blur":"","append-icon":_vm.showPassword ? 'visibility_off' : 'visibility',"type":_vm.showPassword ? 'text' : 'password',"clearable":"","required":""},on:{"click:append":function($event){_vm.showPassword = !_vm.showPassword},"input":function($event){return _vm.returnUsuario();}},model:{value:(_vm.usuario.password),callback:function ($$v) {_vm.$set(_vm.usuario, "password", $$v)},expression:"usuario.password"}}),_vm._v(" "),_c('v-select',{attrs:{"hint":"Todos os planos possuem 7 dias gratuitos para teste","items":_vm.planos,"id":"usuario-planos","item-text":"text","item-value":"_ids","rules":_vm.passRules,"label":"Planos","persistent-hint":"","return-object":"","single-line":""},on:{"change":function($event){return _vm.returnUsuario()}},model:{value:(_vm.planoSelecionado),callback:function ($$v) {_vm.planoSelecionado=$$v},expression:"planoSelecionado"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var PreConta = function PreConta(Empresa, Usuario, Certificado) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PreConta);

    this.Empresa = Empresa;
    this.Usuario = Usuario;
    this.Certificado = Certificado;
};

/* harmony default export */ __webpack_exports__["a"] = (PreConta);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":""}},[_c('article',{staticClass:"panelLogar"},[_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('span',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Motor Fiscal"},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{staticClass:"logoMotor",staticStyle:{"margin-left":"-3px"},attrs:{"src":__webpack_require__(258),"alt":"Logo motor","height":"100"}}),_vm._v(" "),_c('h1',{staticClass:"white--text mb-4 display-1 text-xs-center",staticStyle:{"color":"white","font-weight":"500"}},[_c('span',{staticStyle:{"color":"#00a3a3","font-weight":"800","letter-spacing":"2px!important"}},[_vm._v("M")]),_vm._v("otor Fiscal\n            ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"130px"}},[_c('span',[_vm._v("Já tem cadastro ?")]),_vm._v(" "),_c('v-btn',{staticClass:"btnLogar",attrs:{"color":"primary_custom","block":""},on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("Logar")])],1)])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":""}},[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('h1',{staticStyle:{"color":"dimgrey"}},[_vm._v("Cadastrar")])]),_vm._v(" "),_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("Usuário")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v("Empresa")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),(!_vm.envCert)?_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 3,"step":"3"}},[_vm._v("Conta")]):_c('v-stepper-step',{attrs:{"complete":_vm.certCadastrado,"step":"3"}},[_vm._v("Certificado")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"},nativeOn:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.UserIsValid ? _vm.avançarStep($event) : ''}}},[_c('v-card',{staticClass:"mb-5",attrs:{"height":"300px"}},[_c('pre-cadastro-usuario',{on:{"getUsuario":function($event){return _vm.getUsuario($event)}}})],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('v-btn',{attrs:{"color":"indigo","tabindex":"5","outline":""}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('v-btn',{ref:"btn_avan_user",attrs:{"color":"primary","disabled":!_vm.UserIsValid,"tabindex":"4"},on:{"click":function($event){_vm.avançarStep($event)}}},[_vm._v("Continuar")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"},nativeOn:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.EmpIsValid ? _vm.avançarStep($event) : ''}}},[(_vm.loading)?_c('v-progress-linear',{staticStyle:{"z-index":"3","padding":"0","margin":"0"},attrs:{"color":"teal","height":"10","indeterminate":""}}):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"height":"200px"}},[_c('pre-cadastro-empresa',{on:{"getEmpresa":function($event){return _vm.getEmpresa($event)}}}),_vm._v(" "),_c('div',{attrs:{"id":"cadastroContaCheckbox"}},[_c('v-checkbox',{attrs:{"label":"Deseja vincular certificado agora ?","color":"success","value":"success","hide-details":""},model:{value:(_vm.envCert),callback:function ($$v) {_vm.envCert=$$v},expression:"envCert"}})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"indigo"},on:{"click":function($event){return _vm.retornarStep()}}},[_vm._v("Voltar")]),_vm._v(" "),_c('v-btn',{ref:"btn_avan_emp",staticClass:"btnCadastrar",attrs:{"id":"btn_avan_emp","color":"warning","disabled":!_vm.EmpIsValid},on:{"click":function($event){_vm.avançarStep($event)}}},[_vm._v("Cadastrar")])],1),_vm._v(" "),(!_vm.envCert)?_c('v-stepper-content',{attrs:{"step":"3"}},[(_vm.loading)?_c('v-progress-linear',{staticStyle:{"z-index":"3","padding":"0","margin":"0"},attrs:{"color":"teal","height":"10","indeterminate":""}}):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":"grey lighten-1","height":"200px"}},[_c('h2',{staticClass:"text-xs-center",class:_vm.colorOfMessage,staticStyle:{"background-color":"#f3f3f3!important","line-height":"187px"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":""}})],1),_vm._v(" "),_c('v-btn',{staticClass:"btnLogar",attrs:{"color":"primary_custom"},nativeOn:{"click":function($event){return _vm.finalizar()}}},[_vm._v("Finalizar")])],1):_c('v-stepper-content',{attrs:{"step":"3"}},[(_vm.loading)?_c('v-progress-linear',{staticStyle:{"z-index":"3","padding":"0","margin":"0"},attrs:{"color":"teal","height":"10","indeterminate":""}}):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"height":"150px"}},[_c('h2',{staticClass:"text-xs-center",class:_vm.colorOfMessage,staticStyle:{"background-color":"#f3f3f3!important"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-divider',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('InputFile',{attrs:{"id":"empresa-file","component":'certificado',"prevIcon":'description',"text":'Selecione um certificado'},on:{"getFile":function($event){return _vm.getFile($event)}}}),_vm._v(" "),_c('v-text-field',{ref:"passCert",class:this.cert.file != undefined ? 'input-required' : '',attrs:{"label":"Senha:","id":"empresa-password","disabled":this.cert.file == undefined || this.certCadastrado,"append-icon":_vm.showPassword ? 'visibility_off' : 'visibility',"type":_vm.showPassword ? 'text' : 'password',"rules":_vm.passRules,"validate-on-blur":"","clearable":"","required":""},on:{"click:append":function($event){_vm.showPassword = !_vm.showPassword},"input":function($event){return _vm.checkCertValid($event);}},model:{value:(_vm.cert.password),callback:function ($$v) {_vm.$set(_vm.cert, "password", $$v)},expression:"cert.password"}})],1),_vm._v(" "),(this.erroCadastro)?_c('v-btn',{attrs:{"outline":"","color":"indigo"},on:{"click":function($event){return _vm.retornarStep()}}},[_vm._v("Voltar")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btnLogar",attrs:{"outline":"","color":"yellow darken-3"},nativeOn:{"click":function($event){return _vm.finalizar()}}},[_vm._v("Finalizar sem vincular certificado")]),_vm._v(" "),_c('v-btn',{ref:"btn_avan_user",staticClass:"btnCadastrar",attrs:{"color":"warning","disabled":!_vm.certValido,"tabindex":"4"},on:{"click":function($event){return _vm.vincular()}}},[_vm._v("Vincular certificado")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Download_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c052f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Download_vue__ = __webpack_require__(868);
function injectStyle (ssrContext) {
  __webpack_require__(866)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03c052f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Download_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c052f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Download_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FechamentoMensal = function () {
    function FechamentoMensal(http) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FechamentoMensal);

        this._resource = http;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FechamentoMensal, [{
        key: "fechamentoMensal",
        value: function fechamentoMensal(tkn) {
            var url = "integracoes/zip/fechamentoMensal?_link=" + tkn;
            return this._resource.get(url).then(function (success) {
                return success;
            }, function (failed) {
                return failed;
            });
        }
    }]);

    return FechamentoMensal;
}();

/* harmony default export */ __webpack_exports__["a"] = (FechamentoMensal);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100vh","background-color":"#363636"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AlertComponent',{attrs:{"alert":this.alert}}),_vm._v(" "),_c(_vm.component.name,{tag:"component",attrs:{"alert":this.alert}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovoUsuario_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc344136_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovoUsuario_vue__ = __webpack_require__(872);
function injectStyle (ssrContext) {
  __webpack_require__(871)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc344136"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovoUsuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc344136_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovoUsuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AlertComponent',{attrs:{"alert":this.alert}}),_vm._v(" "),(this.render)?_c('editarPerfil',{attrs:{"alert":this.alert,"cadastro":true,"conta":this.usuario}}):_vm._e(),_vm._v(" "),(this.loading)?_c('v-icon',{staticClass:"custom-loader"},[_vm._v("cached")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformeRendimentos_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b53251a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformeRendimentos_vue__ = __webpack_require__(876);
function injectStyle (ssrContext) {
  __webpack_require__(874)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b53251a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformeRendimentos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b53251a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformeRendimentos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInformeRendimentosApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return informeRendimentosUploadFileApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return informeRendimentosBuscaArquivoApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var producao = window.location.href.indexOf("app.motorfiscal") != -1 ? true : false;
var url = producao ? "https://apiv2.motorfiscal.com.br" : "https://apiv2homolog.motorfiscal.com.br";

var getInformeRendimentosApi = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dataIni, dataFim, tipo, statusArquivo, statusEmail, token) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + "/informe-rendimento-pdf?dataIni=" + dataIni + "&dataFim=" + dataFim + "&tipo=" + tipo + "&statusArquivo=" + statusArquivo + "&statusEmail=" + statusEmail, {
              headers: {
                Authorization: "" + token
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function getInformeRendimentosApi(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

var informeRendimentosUploadFileApi = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(json, token) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url + "/informe-rendimento-pdf", json, {
              headers: {
                Authorization: "" + token
              }
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", null);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 7]]);
  }));

  return function informeRendimentosUploadFileApi(_x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

var informeRendimentosBuscaArquivoApi = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id, token) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + "/informe-rendimento-baixa-pdf/" + id, {
              headers: {
                Authorization: "" + token
              }
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", null);

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 7]]);
  }));

  return function informeRendimentosBuscaArquivoApi(_x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relatorio"},[_c('div',{staticClass:"descTable"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"color":"white","box-shadow":"1px 1px 8px black"}},[_c('svg',{staticStyle:{"width":"24px","height":"24px","margin-left":"87px","margin-bottom":"-4px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#fff","d":"M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"}})]),_vm._v("\n            Informe de Rendimentos\n          ")])])],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"width":"90%","margin":"0 auto 40px auto","padding":"41px 41px 0px 41px","background-color":"#efefef"},attrs:{"flat":"","id":""}},[(_vm.successMessage)?_c('div',[_c('v-alert',{staticStyle:{"padding":"5px"},attrs:{"value":true,"type":"success","dismissible":true}},[_vm._v("\n              "+_vm._s(_vm.successMessage)+"    \n            ")])],1):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',[_c('v-alert',{staticStyle:{"padding":"5px"},attrs:{"value":true,"type":"error","dismissible":true}},[_vm._v("\n              "+_vm._s(_vm.errorMessage)+"    \n            ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"informe-rendimentos-div-file"},[_c('span',{staticClass:"inputFile"},[_c('label',{staticClass:"custom-file-upload",attrs:{"for":"file-upload"},on:{"click":function($event){return _vm.resetInfos()}}},[_c('v-icon',[_vm._v("mdi-file")]),_vm._v("\n                    "+_vm._s(_vm.path ? _vm.path : 'Selecione um arquivo')+"\n                ")],1),_vm._v(" "),_c('small',[_vm._v("\n                    "+_vm._s(_vm.fileText)+"\n                    "),_c('span',{staticClass:"teal_bold"},[_vm._v(_vm._s(_vm.path))])]),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"file-upload","value":"file","id":"file-upload"},on:{"change":function($event){return _vm.setFile($event)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}})]),_vm._v(" "),(_vm.file && _vm.file.name)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},attrs:{"disabled":_vm.isFileUploading ? true : false},on:{"click":_vm.handleUploadFile}},[_vm._v(_vm._s(_vm.isFileUploading ? 'Enviando...' : 'Enviar arquivo'))]):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('v-select',{attrs:{"clearable":"","items":['pdf_beneficiario', 'pdf_completo'],"label":"Tipo"},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}}),_vm._v(" "),_c('v-select',{staticStyle:{"margin-left":"30px"},attrs:{"clearable":"","items":['pendente', 'processando', 'finalizado', 'falha'],"label":"Status do Arquivo"},model:{value:(_vm.status_arquivo),callback:function ($$v) {_vm.status_arquivo=$$v},expression:"status_arquivo"}}),_vm._v(" "),_c('v-select',{staticStyle:{"margin-left":"30px"},attrs:{"clearable":"","items":['pendente', 'processando', 'enviado'],"label":"Status do E-mail"},model:{value:(_vm.status_email),callback:function ($$v) {_vm.status_email=$$v},expression:"status_email"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"margin-left":"30px"},attrs:{"return-masked-value":"","mask":"##/##/####","clearable":"","label":"Data Inicio"},model:{value:(_vm.dataIni),callback:function ($$v) {_vm.dataIni=$$v},expression:"dataIni"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"margin-left":"30px"},attrs:{"return-masked-value":"","mask":"##/##/####","clearable":"","label":"Data Fim"},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1),_vm._v(" "),_c('div',[_c('v-card',[_c('v-card-title',[_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.buscaInformeRendimentos}},[_vm._v("Buscar / Atualizar")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.vOcrClear}},[_vm._v("Limpar filtros")]),_vm._v(" "),(_vm.body && _vm.body.length > 0)?_c('v-btn',{staticStyle:{"background":"teal","color":"white"},on:{"click":_vm.exportatExcel}},[_vm._v("Exportar")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.body,"search":_vm.search,"hide-actions":"","pagination":_vm.pagination,"loading":_vm.isLoading,"id":"table"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([(!_vm.isLoading)?{key:"items",fn:function(props){return [_c('tr',{style:({ 'background': props.item.pathPdf ? '' : '#ffe5e3' })},[_c('td',{staticClass:"text-xs-center"},[_c('span',{staticClass:"ocrLink",on:{"click":function($event){return _vm.handleOpenFile(props.item)}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.data_registro ? ((new Date(props.item.data_registro).toLocaleDateString('pt-BR')) + " " + (new Date(props.item.data_registro).toLocaleTimeString('pt-BR'))) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[(props.item.tipo_arquivo)?_c('v-chip',{attrs:{"small":"","color":props.item.tipo_arquivo ? 
                                    props.item.tipo_arquivo === 'pdf_beneficiario' ? 
                                    'brown darken-2' : 
                                    props.item.tipo_arquivo === 'pdf_completo' ? 
                                    'brown darken-4' : '' : '',"text-color":"white"}},[_c('span',[_vm._v(_vm._s(props.item.tipo_arquivo ? props.item.tipo_arquivo : ''))])]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[(props.item.status_ocr)?_c('v-chip',{attrs:{"small":"","color":props.item.status_ocr ? 
                                    props.item.status_ocr === 'finalizado' ? 
                                    'green' : 
                                    props.item.status_ocr === 'pendente' ? 
                                    'orange' : 
                                    props.item.status_ocr === 'processando' ? 
                                    'blue' :
                                    props.item.status_ocr === 'falha' ? 
                                    'red' : 'grey darken-3'
                                    : 'grey darken-3',"text-color":"white"}},[_c('span',[_vm._v(_vm._s(props.item.status_ocr ? props.item.status_ocr : 'Não possui'))])]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[(props.item.status_envio_email)?_c('v-chip',{attrs:{"small":"","color":props.item.status_envio_email ? 
                                    props.item.status_envio_email === 'enviado' ? 
                                    'green' : 
                                    props.item.status_envio_email === 'processando' ? 
                                    'blue' :
                                    props.item.status_envio_email === 'pendente' ? 
                                    'orange' : '' : '',"text-color":"white"}},[_c('span',[_vm._v(_vm._s(props.item.status_envio_email ? props.item.status_envio_email : ''))])]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.cnpj_beneficiario != undefined ? (props.item.cnpj_beneficiario.length > 11 ? props.item.cnpj_beneficiario.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : props.item.cnpj_beneficiario.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.razao_beneficiario))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.email_beneficiario))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.data_email && props.item.data_email !== 'None' ? ((new Date(props.item.data_email).toLocaleDateString('pt-BR')) + " " + (new Date(props.item.data_email).toLocaleTimeString('pt-BR'))) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(props.item.ano_calendario))])])]}}:null,{key:"no-results",fn:function(){return [_c('v-alert',{attrs:{"value":true,"color":"error","icon":"warning"}},[_vm._v("\n                        \""+_vm._s(_vm.search)+"\" não encontrado.\n                        ")])]},proxy:true},{key:"pageText",fn:function(props){return [_c('strong',[_vm._v("\n                        Exibindo "+_vm._s(props.pagination.page)+" - "+_vm._s(14)+" do total de "+_vm._s(props.pages)+"\n                        "),_c('span',[_vm._v("Notas")])])]}}],null,true)},[_c('v-progress-linear',{staticStyle:{"z-index":"3"},attrs:{"slot":"progress","color":"teal","height":"20","indeterminate":""},slot:"progress"}),_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"color":"indigo darken-4","icon":"info","outline":""}},[(_vm.isLoading)?_c('article',[_vm._v("Motor Fiscal está buscando as informações")]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('article',[_vm._v("\n                            Dados não encontrados\n                        ")]):_vm._e()])],1)],2),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-2"},[_c('v-pagination',{attrs:{"length":_vm.pages},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}})],1)],1)],1)]),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","lazy":true},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.dialog = false}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline darkBlue",staticStyle:{"color":"white"},attrs:{"text-color":"white"}},[_vm._v("\n                Informe de rendimentos\n                "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"tst"}},[_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"src":'data:application/pdf;base64,'+encodeURIComponent(this.pdf),"frameborder":"0"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                    Fechar\n                ")])],1)],1)],1),_vm._v(" "),(_vm.isFileLoading)?_c('div',{staticClass:"cont-ocr"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 877 */,
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */,
/* 880 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 303,
	"./af.js": 303,
	"./ar": 304,
	"./ar-dz": 305,
	"./ar-dz.js": 305,
	"./ar-kw": 306,
	"./ar-kw.js": 306,
	"./ar-ly": 307,
	"./ar-ly.js": 307,
	"./ar-ma": 308,
	"./ar-ma.js": 308,
	"./ar-sa": 309,
	"./ar-sa.js": 309,
	"./ar-tn": 310,
	"./ar-tn.js": 310,
	"./ar.js": 304,
	"./az": 311,
	"./az.js": 311,
	"./be": 312,
	"./be.js": 312,
	"./bg": 313,
	"./bg.js": 313,
	"./bm": 314,
	"./bm.js": 314,
	"./bn": 315,
	"./bn.js": 315,
	"./bo": 316,
	"./bo.js": 316,
	"./br": 317,
	"./br.js": 317,
	"./bs": 318,
	"./bs.js": 318,
	"./ca": 319,
	"./ca.js": 319,
	"./cs": 320,
	"./cs.js": 320,
	"./cv": 321,
	"./cv.js": 321,
	"./cy": 322,
	"./cy.js": 322,
	"./da": 323,
	"./da.js": 323,
	"./de": 324,
	"./de-at": 325,
	"./de-at.js": 325,
	"./de-ch": 326,
	"./de-ch.js": 326,
	"./de.js": 324,
	"./dv": 327,
	"./dv.js": 327,
	"./el": 328,
	"./el.js": 328,
	"./en-au": 329,
	"./en-au.js": 329,
	"./en-ca": 330,
	"./en-ca.js": 330,
	"./en-gb": 331,
	"./en-gb.js": 331,
	"./en-ie": 332,
	"./en-ie.js": 332,
	"./en-il": 333,
	"./en-il.js": 333,
	"./en-nz": 334,
	"./en-nz.js": 334,
	"./eo": 335,
	"./eo.js": 335,
	"./es": 336,
	"./es-do": 337,
	"./es-do.js": 337,
	"./es-us": 338,
	"./es-us.js": 338,
	"./es.js": 336,
	"./et": 339,
	"./et.js": 339,
	"./eu": 340,
	"./eu.js": 340,
	"./fa": 341,
	"./fa.js": 341,
	"./fi": 342,
	"./fi.js": 342,
	"./fo": 343,
	"./fo.js": 343,
	"./fr": 344,
	"./fr-ca": 345,
	"./fr-ca.js": 345,
	"./fr-ch": 346,
	"./fr-ch.js": 346,
	"./fr.js": 344,
	"./fy": 347,
	"./fy.js": 347,
	"./gd": 348,
	"./gd.js": 348,
	"./gl": 349,
	"./gl.js": 349,
	"./gom-latn": 350,
	"./gom-latn.js": 350,
	"./gu": 351,
	"./gu.js": 351,
	"./he": 352,
	"./he.js": 352,
	"./hi": 353,
	"./hi.js": 353,
	"./hr": 354,
	"./hr.js": 354,
	"./hu": 355,
	"./hu.js": 355,
	"./hy-am": 356,
	"./hy-am.js": 356,
	"./id": 357,
	"./id.js": 357,
	"./is": 358,
	"./is.js": 358,
	"./it": 359,
	"./it.js": 359,
	"./ja": 360,
	"./ja.js": 360,
	"./jv": 361,
	"./jv.js": 361,
	"./ka": 362,
	"./ka.js": 362,
	"./kk": 363,
	"./kk.js": 363,
	"./km": 364,
	"./km.js": 364,
	"./kn": 365,
	"./kn.js": 365,
	"./ko": 366,
	"./ko.js": 366,
	"./ky": 367,
	"./ky.js": 367,
	"./lb": 368,
	"./lb.js": 368,
	"./lo": 369,
	"./lo.js": 369,
	"./lt": 370,
	"./lt.js": 370,
	"./lv": 371,
	"./lv.js": 371,
	"./me": 372,
	"./me.js": 372,
	"./mi": 373,
	"./mi.js": 373,
	"./mk": 374,
	"./mk.js": 374,
	"./ml": 375,
	"./ml.js": 375,
	"./mn": 376,
	"./mn.js": 376,
	"./mr": 377,
	"./mr.js": 377,
	"./ms": 378,
	"./ms-my": 379,
	"./ms-my.js": 379,
	"./ms.js": 378,
	"./mt": 380,
	"./mt.js": 380,
	"./my": 381,
	"./my.js": 381,
	"./nb": 382,
	"./nb.js": 382,
	"./ne": 383,
	"./ne.js": 383,
	"./nl": 384,
	"./nl-be": 385,
	"./nl-be.js": 385,
	"./nl.js": 384,
	"./nn": 386,
	"./nn.js": 386,
	"./pa-in": 387,
	"./pa-in.js": 387,
	"./pl": 388,
	"./pl.js": 388,
	"./pt": 389,
	"./pt-br": 390,
	"./pt-br.js": 390,
	"./pt.js": 389,
	"./ro": 391,
	"./ro.js": 391,
	"./ru": 392,
	"./ru.js": 392,
	"./sd": 393,
	"./sd.js": 393,
	"./se": 394,
	"./se.js": 394,
	"./si": 395,
	"./si.js": 395,
	"./sk": 396,
	"./sk.js": 396,
	"./sl": 397,
	"./sl.js": 397,
	"./sq": 398,
	"./sq.js": 398,
	"./sr": 399,
	"./sr-cyrl": 400,
	"./sr-cyrl.js": 400,
	"./sr.js": 399,
	"./ss": 401,
	"./ss.js": 401,
	"./sv": 402,
	"./sv.js": 402,
	"./sw": 403,
	"./sw.js": 403,
	"./ta": 404,
	"./ta.js": 404,
	"./te": 405,
	"./te.js": 405,
	"./tet": 406,
	"./tet.js": 406,
	"./tg": 407,
	"./tg.js": 407,
	"./th": 408,
	"./th.js": 408,
	"./tl-ph": 409,
	"./tl-ph.js": 409,
	"./tlh": 410,
	"./tlh.js": 410,
	"./tr": 411,
	"./tr.js": 411,
	"./tzl": 412,
	"./tzl.js": 412,
	"./tzm": 413,
	"./tzm-latn": 414,
	"./tzm-latn.js": 414,
	"./tzm.js": 413,
	"./ug-cn": 415,
	"./ug-cn.js": 415,
	"./uk": 416,
	"./uk.js": 416,
	"./ur": 417,
	"./ur.js": 417,
	"./uz": 418,
	"./uz-latn": 419,
	"./uz-latn.js": 419,
	"./uz.js": 418,
	"./vi": 420,
	"./vi.js": 420,
	"./x-pseudo": 421,
	"./x-pseudo.js": 421,
	"./yo": 422,
	"./yo.js": 422,
	"./zh-cn": 423,
	"./zh-cn.js": 423,
	"./zh-hk": 424,
	"./zh-hk.js": 424,
	"./zh-tw": 425,
	"./zh-tw.js": 425
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;

/***/ }),
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(931);


var _mutations;




// import modules from './modules';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    // modules
    state: {
        certificate: {},

        progressBar: 0,
        dashboard: {},

        tableNfeRecebidas: {},
        tableNfeEmitidas: {},
        tableNfeTransportados: {},

        tableCteTodos: {},
        tableCteTomados: {},

        tableNfseRecebidas: {},
        tableNfseEmitidas: {},

        tableClientes: {},
        tableFornecedores: {},

        tableProdutos: {},
        tableProdutosEmitidas: {},

        tableEmpresas: {},
        tableCertificados: {},

        buscaCTE: false,

        files: [],
        expanded: true,
        lastExpandedFolder: { name: '', id: '', parentId: '', origin: '', children: [] },
        breadcrumbs: [{ text: '', id: '', parentId: '' }],

        mongoFolderReturn: [],
        copyNode: {},
        empresasMenu: {},
        openStore: true,
        updateTable: false,
        ufArray: [],

        dialogWidthRC: 1000
    },
    getters: {
        certificate: function certificate(state) {
            return state.certificate;
        },
        progressBar: function progressBar(state) {
            return state.progressBar;
        },
        ufArray: function ufArray(state) {
            return state.ufArray;
        },
        updateTable: function updateTable(state) {
            return state.updateTable;
        },
        dashboard: function dashboard(state) {
            return state.dashboard;
        },
        tableNfseRecebidas: function tableNfseRecebidas(state) {
            return state.tableNfseRecebidas;
        },
        tableNfseEmitidas: function tableNfseEmitidas(state) {
            return state.tableNfseEmitidas;
        },
        tableNfeRecebidas: function tableNfeRecebidas(state) {
            return state.tableNfeRecebidas;
        },
        tableNfeEmitidas: function tableNfeEmitidas(state) {
            return state.tableNfeEmitidas;
        },
        tableNfeTransportados: function tableNfeTransportados(state) {
            return state.tableNfeTransportados;
        },
        tableCteTodos: function tableCteTodos(state) {
            return state.tableCteTodos;
        },
        tableCteTomados: function tableCteTomados(state) {
            return state.tableCteTomados;
        },
        tableClientes: function tableClientes(state) {
            return state.tableClientes;
        },
        tableFornecedores: function tableFornecedores(state) {
            return state.tableFornecedores;
        },
        tableProdutos: function tableProdutos(state) {
            return state.tableProdutos;
        },
        tableProdutosEmitidas: function tableProdutosEmitidas(state) {
            return state.tableProdutosEmitidas;
        },
        tableEmpresas: function tableEmpresas(state) {
            return state.tableEmpresas;
        },
        tableCertificados: function tableCertificados(state) {
            return state.tableCertificados;
        },
        empresasMenu: function empresasMenu(state) {
            return state.empresasMenu;
        },
        files: function files(state) {
            return state.files;
        },
        openStore: function openStore(state) {
            return state.openStore;
        },
        dialogWidthRC: function dialogWidthRC(state) {
            return state.dialogWidthRC;
        }
    },
    mutations: (_mutations = {
        addCertificate: function addCertificate(state, payload) {
            state.certificate = payload;
        },
        addProgressBar: function addProgressBar(state, payload) {
            state.progressBar = payload;
        },
        addUfArray: function addUfArray(state, payload) {
            state.ufArray = payload;
        },
        addUpdateTable: function addUpdateTable(state, payload) {
            state.updateTable = payload;
        },
        addOpenStore: function addOpenStore(state, payload) {
            state.openStore = payload;
        },
        addEmpresasMenu: function addEmpresasMenu(state, payload) {
            state.empresasMenu = payload;
        },
        addCopyNode: function addCopyNode(state, payload) {
            state.copyNode = payload;
        },
        addDashboard: function addDashboard(state, payload) {
            state.dashboard = payload;
        },
        addTableNfeRecebidas: function addTableNfeRecebidas(state, payload) {
            state.tableNfeRecebidas = payload;
        },
        addTableNfeEmitidas: function addTableNfeEmitidas(state, payload) {
            state.tableNfeEmitidas = payload;
        },
        addTableNfeTransportados: function addTableNfeTransportados(state, payload) {
            state.tableNfeTransportados = payload;
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableNfeTransportados', function addTableNfeTransportados(state, payload) {
        state.tableNfeTransportados = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableCteTodos', function addTableCteTodos(state, payload) {
        state.tableCteTodos = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableCteTomados', function addTableCteTomados(state, payload) {
        state.tableCteTomados = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableNfseRecebidas', function addTableNfseRecebidas(state, payload) {
        state.tableNfseRecebidas = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableNfseEmitidas', function addTableNfseEmitidas(state, payload) {
        state.tableNfseEmitidas = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableClientes', function addTableClientes(state, payload) {
        state.tableClientes = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableFornecedores', function addTableFornecedores(state, payload) {
        state.tableFornecedores = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableProdutos', function addTableProdutos(state, payload) {
        state.tableProdutos = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableProdutosEmitidas', function addTableProdutosEmitidas(state, payload) {
        state.tableProdutosEmitidas = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableEmpresas', function addTableEmpresas(state, payload) {
        state.tableEmpresas = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addTableCertificados', function addTableCertificados(state, payload) {
        state.tableCertificados = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addFiles', function addFiles(state, payload) {
        state.files.push(payload);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'newFile', function newFile(state, payload) {
        state.files[0].push(payload);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'resetFiles', function resetFiles(state) {
        state.files.length = [];
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'resetBreadcrumbs', function resetBreadcrumbs(state) {
        state.breadcrumbs.length = 0;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'updateBreadcrumbs', function updateBreadcrumbs(state, position) {
        state.breadcrumbs.length = position + 1;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addLastExpandedFolder', function addLastExpandedFolder(state, payload) {
        var name = payload.name,
            id = payload.id,
            parentId = payload.parentId,
            origin = payload.origin,
            children = payload.children;

        state.lastExpandedFolder.name = name;
        state.lastExpandedFolder.id = id;
        state.lastExpandedFolder.parentId = parentId;
        state.lastExpandedFolder.origin = origin;
        state.lastExpandedFolder.children = children;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addBreadcrumbs', function addBreadcrumbs(state, payload) {
        var text = payload.text,
            id = payload.id,
            parentId = payload.parentId;

        state.breadcrumbs.push({
            text: text,
            id: id,
            parentId: parentId
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'removeBreadcrumbsLastPosition', function removeBreadcrumbsLastPosition(state) {
        state.breadcrumbs.splice(state.breadcrumbs.length - 1, 1);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addExpanded', function addExpanded(state, payload) {
        state.expanded = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'resetLastExpandedFolder', function resetLastExpandedFolder(state) {
        state.lastExpandedFolder = {};
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'ressetAllStates', function ressetAllStates(state) {
        state.dashboard = {};
        state.tableNfeRecebidas = {};
        state.tableNfeEmitidas = {};
        state.tableNfeTransportados = {};
        state.tableCteTodos = {};
        state.tableCteTomados = {};
        state.tableNfseRecebidas = {};
        state.tableNfseEmitidas = {};
        state.tableClientes = {};
        state.tableFornecedores = {};
        state.tableProdutos = {};
        state.tableProdutosEmitidas = {};
        state.tableEmpresas = {};
        state.tableCertificados = {};
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addBuscaCTE', function addBuscaCTE(state, payload) {
        state.buscaCTE = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addMongoFolderReturn', function addMongoFolderReturn(state, payload) {
        state.mongoFolderReturn.push(payload);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'resetMongoFolderReturn', function resetMongoFolderReturn(state) {
        state.mongoFolderReturn.length = 0;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addDialogWidthRC', function addDialogWidthRC(state, payload) {
        state.dialogWidthRC = payload;
    }), _mutations)
}));

/***/ })
],[426]);


// WEBPACK FOOTER //
// static/js/app.ebcf0e86a895f20d227e.js